/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/gba-villas-y-asentamientos/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(627);
	module.exports = __webpack_require__(328);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _isPlaceholder = __webpack_require__(62);
	
	
	/**
	 * Optimized internal two-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry2(fn) {
	  return function f2(a, b) {
	    switch (arguments.length) {
	      case 0:
	        return f2;
	      case 1:
	        return _isPlaceholder(a) ? f2
	             : _curry1(function(_b) { return fn(a, _b); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f2
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b); })
	             : fn(a, b);
	    }
	  };
	};


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(365)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(650)(module)))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var _isPlaceholder = __webpack_require__(62);
	
	
	/**
	 * Optimized internal one-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry1(fn) {
	  return function f1(a) {
	    if (arguments.length === 0 || _isPlaceholder(a)) {
	      return f1;
	    } else {
	      return fn.apply(this, arguments);
	    }
	  };
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _curry2 = __webpack_require__(1);
	var _isPlaceholder = __webpack_require__(62);
	
	
	/**
	 * Optimized internal three-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry3(fn) {
	  return function f3(a, b, c) {
	    switch (arguments.length) {
	      case 0:
	        return f3;
	      case 1:
	        return _isPlaceholder(a) ? f3
	             : _curry2(function(_b, _c) { return fn(a, _b, _c); });
	      case 2:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
	             : _isPlaceholder(a) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _curry1(function(_c) { return fn(a, b, _c); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
	             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) { return fn(_a, _b, c); })
	             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b, c); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b, c); })
	             : _isPlaceholder(c) ? _curry1(function(_c) { return fn(a, b, _c); })
	             : fn(a, b, c);
	    }
	  };
	};


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(18);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 7 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 8 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(28);
	var _isTransformer = __webpack_require__(85);
	
	
	/**
	 * Returns a function that dispatches with different strategies based on the
	 * object in list position (last argument). If it is an array, executes [fn].
	 * Otherwise, if it has a function with one of the given method names, it will
	 * execute that function (functor case). Otherwise, if it is a transformer,
	 * uses transducer [xf] to return a new transformer (transducer case).
	 * Otherwise, it will default to executing [fn].
	 *
	 * @private
	 * @param {Array} methodNames properties to check for a custom implementation
	 * @param {Function} xf transducer to initialize if object is transformer
	 * @param {Function} fn default ramda implementation
	 * @return {Function} A function that dispatches on object in list position
	 */
	module.exports = function _dispatchable(methodNames, xf, fn) {
	  return function() {
	    if (arguments.length === 0) {
	      return fn();
	    }
	    var args = Array.prototype.slice.call(arguments, 0);
	    var obj = args.pop();
	    if (!_isArray(obj)) {
	      var idx = 0;
	      while (idx < methodNames.length) {
	        if (typeof obj[methodNames[idx]] === 'function') {
	          return obj[methodNames[idx]].apply(obj, args);
	        }
	        idx += 1;
	      }
	      if (_isTransformer(obj)) {
	        var transducer = xf.apply(null, args);
	        return transducer(obj);
	      }
	    }
	    return fn.apply(this, arguments);
	  };
	};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var DOMProperty = __webpack_require__(38);
	var ReactDOMComponentFlags = __webpack_require__(299);
	
	var invariant = __webpack_require__(5);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = {
	  init: function() {
	    return this.xf['@@transducer/init']();
	  },
	  result: function(result) {
	    return this.xf['@@transducer/result'](result);
	  }
	};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(40);


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(22);
	var _curry1 = __webpack_require__(3);
	var _curry2 = __webpack_require__(1);
	var _curryN = __webpack_require__(60);
	
	
	/**
	 * Returns a curried equivalent of the provided function, with the specified
	 * arity. The curried function has two unusual capabilities. First, its
	 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value `R.__` may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is `R.__`, the
	 * following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curry
	 * @example
	 *
	 *      var sumArgs = (...args) => R.sum(args);
	 *
	 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry2(function curryN(length, fn) {
	  if (length === 1) {
	    return _curry1(fn);
	  }
	  return _arity(length, _curryN(length, [], fn));
	});


/***/ },
/* 14 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = function _has(prop, obj) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	};


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _map = __webpack_require__(64);
	var _reduce = __webpack_require__(17);
	var _xmap = __webpack_require__(456);
	var curryN = __webpack_require__(13);
	var keys = __webpack_require__(23);
	
	
	/**
	 * Takes a function and
	 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
	 * applies the function to each of the functor's values, and returns
	 * a functor of the same shape.
	 *
	 * Ramda provides suitable `map` implementations for `Array` and `Object`,
	 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
	 *
	 * Dispatches to the `map` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * Also treats functions as functors and will compose them together.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => (a -> b) -> f a -> f b
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {Array} list The list to be iterated over.
	 * @return {Array} The new list.
	 * @see R.transduce, R.addIndex
	 * @example
	 *
	 *      var double = x => x * 2;
	 *
	 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
	 *
	 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
	 * @symb R.map(f, [a, b]) = [f(a), f(b)]
	 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
	 * @symb R.map(f, functor_o) = functor_o.map(f)
	 */
	module.exports = _curry2(_dispatchable(['map'], _xmap, function map(fn, functor) {
	  switch (Object.prototype.toString.call(functor)) {
	    case '[object Function]':
	      return curryN(functor.length, function() {
	        return fn.call(this, functor.apply(this, arguments));
	      });
	    case '[object Object]':
	      return _reduce(function(acc, key) {
	        acc[key] = fn(functor[key]);
	        return acc;
	      }, {}, keys(functor));
	    default:
	      return _map(fn, functor);
	  }
	}));


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var _xwrap = __webpack_require__(268);
	var bind = __webpack_require__(243);
	var isArrayLike = __webpack_require__(47);
	
	
	module.exports = (function() {
	  function _arrayReduce(xf, acc, list) {
	    var idx = 0;
	    var len = list.length;
	    while (idx < len) {
	      acc = xf['@@transducer/step'](acc, list[idx]);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      idx += 1;
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _iterableReduce(xf, acc, iter) {
	    var step = iter.next();
	    while (!step.done) {
	      acc = xf['@@transducer/step'](acc, step.value);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      step = iter.next();
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _methodReduce(xf, acc, obj) {
	    return xf['@@transducer/result'](obj.reduce(bind(xf['@@transducer/step'], xf), acc));
	  }
	
	  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
	  return function _reduce(fn, acc, list) {
	    if (typeof fn === 'function') {
	      fn = _xwrap(fn);
	    }
	    if (isArrayLike(list)) {
	      return _arrayReduce(fn, acc, list);
	    }
	    if (typeof list.reduce === 'function') {
	      return _methodReduce(fn, acc, list);
	    }
	    if (list[symIterator] != null) {
	      return _iterableReduce(fn, acc, list[symIterator]());
	    }
	    if (typeof list.next === 'function') {
	      return _iterableReduce(fn, acc, list);
	    }
	    throw new TypeError('reduce: list must be array or iterable');
	  };
	}());


/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 19 */
/***/ function(module, exports) {

	/**
	 * Private `concat` function to merge two array-like objects.
	 *
	 * @private
	 * @param {Array|Arguments} [set1=[]] An array-like object.
	 * @param {Array|Arguments} [set2=[]] An array-like object.
	 * @return {Array} A new, merged array.
	 * @example
	 *
	 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 */
	module.exports = function _concat(set1, set2) {
	  set1 = set1 || [];
	  set2 = set2 || [];
	  var idx;
	  var len1 = set1.length;
	  var len2 = set2.length;
	  var result = [];
	
	  idx = 0;
	  while (idx < len1) {
	    result[result.length] = set1[idx];
	    idx += 1;
	  }
	  idx = 0;
	  while (idx < len2) {
	    result[result.length] = set2[idx];
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _equals = __webpack_require__(431);
	
	
	/**
	 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
	 * cyclical data structures.
	 *
	 * Dispatches symmetrically to the `equals` methods of both arguments, if
	 * present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> b -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      R.equals(1, 1); //=> true
	 *      R.equals(1, '1'); //=> false
	 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
	 *
	 *      var a = {}; a.v = a;
	 *      var b = {}; b.v = b;
	 *      R.equals(a, b); //=> true
	 */
	module.exports = _curry2(function equals(a, b) {
	  return _equals(a, b, [], []);
	});


/***/ },
/* 22 */
/***/ function(module, exports) {

	module.exports = function _arity(n, fn) {
	  /* eslint-disable no-unused-vars */
	  switch (n) {
	    case 0: return function() { return fn.apply(this, arguments); };
	    case 1: return function(a0) { return fn.apply(this, arguments); };
	    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
	    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
	    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
	    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
	    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
	    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	  }
	};


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _has = __webpack_require__(15);
	var _isArguments = __webpack_require__(261);
	
	
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	module.exports = (function() {
	  // cover IE < 9 keys issues
	  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
	                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	  // Safari bug
	  var hasArgsEnumBug = (function() {
	    'use strict';
	    return arguments.propertyIsEnumerable('length');
	  }());
	
	  var contains = function contains(list, item) {
	    var idx = 0;
	    while (idx < list.length) {
	      if (list[idx] === item) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  };
	
	  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
	    _curry1(function keys(obj) {
	      return Object(obj) !== obj ? [] : Object.keys(obj);
	    }) :
	    _curry1(function keys(obj) {
	      if (Object(obj) !== obj) {
	        return [];
	      }
	      var prop, nIdx;
	      var ks = [];
	      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	      for (prop in obj) {
	        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	          ks[ks.length] = prop;
	        }
	      }
	      if (hasEnumBug) {
	        nIdx = nonEnumerableProps.length - 1;
	        while (nIdx >= 0) {
	          prop = nonEnumerableProps[nIdx];
	          if (_has(prop, obj) && !contains(ks, prop)) {
	            ks[ks.length] = prop;
	          }
	          nIdx -= 1;
	        }
	      }
	      return ks;
	    });
	}());


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var _reduce = __webpack_require__(17);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * `R.reduced` to shortcut the iteration.
	 *
	 * The arguments' order of `reduceRight`'s iterator function is *(value, acc)*.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex, R.reduceRight
	 * @example
	 *
	 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
	 *                -               -10
	 *               / \              / \
	 *              -   4           -6   4
	 *             / \              / \
	 *            -   3   ==>     -3   3
	 *           / \              / \
	 *          -   2           -1   2
	 *         / \              / \
	 *        0   1            0   1
	 *
	 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
	 */
	module.exports = _curry3(_reduce);


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7),
	    _assign = __webpack_require__(8);
	
	var CallbackQueue = __webpack_require__(297);
	var PooledClass = __webpack_require__(32);
	var ReactFeatureFlags = __webpack_require__(302);
	var ReactReconciler = __webpack_require__(39);
	var Transaction = __webpack_require__(73);
	
	var invariant = __webpack_require__(5);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var PooledClass = __webpack_require__(32);
	
	var emptyFunction = __webpack_require__(18);
	var warning = __webpack_require__(6);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 27 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 28 */
/***/ function(module, exports) {

	/**
	 * Tests whether or not an object is an array.
	 *
	 * @private
	 * @param {*} val The object to test.
	 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	 * @example
	 *
	 *      _isArray([]); //=> true
	 *      _isArray(null); //=> false
	 *      _isArray({}); //=> false
	 */
	module.exports = Array.isArray || function _isArray(val) {
	  return (val != null &&
	          val.length >= 0 &&
	          Object.prototype.toString.call(val) === '[object Array]');
	};


/***/ },
/* 29 */
/***/ function(module, exports) {

	module.exports = function _reduced(x) {
	  return x && x['@@transducer/reduced'] ? x :
	    {
	      '@@transducer/value': x,
	      '@@transducer/reduced': true
	    };
	};


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var _indexOf = __webpack_require__(260);
	
	
	module.exports = function _contains(a, list) {
	  return _indexOf(list, a, 0) >= 0;
	};


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(45);
	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Returns the elements of the given list or string (or object with a `slice`
	 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
	 *
	 * Dispatches to the `slice` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @sig Number -> Number -> String -> String
	 * @param {Number} fromIndex The start index (inclusive).
	 * @param {Number} toIndex The end index (exclusive).
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
	 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
	 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
	 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
	 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
	 */
	module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
	  return Array.prototype.slice.call(list, fromIndex, toIndex);
	}));


/***/ },
/* 32 */
[652, 7],
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var createHelper = function createHelper(func, helperName) {
	  var setDisplayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var noArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (false) {
	    var _ret = function () {
	      /* eslint-disable global-require */
	      var wrapDisplayName = require('./wrapDisplayName').default;
	      /* eslint-enable global-require */
	
	      if (noArgs) {
	        return {
	          v: function v(BaseComponent) {
	            var Component = func(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          }
	        };
	      }
	
	      return {
	        v: function v() {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          return function (BaseComponent) {
	            var Component = func.apply(undefined, args)(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          };
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	
	  return func;
	};
	
	exports.default = createHelper;

/***/ },
/* 34 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Returns a function that always returns the given value. Note that for
	 * non-primitives the value returned is a reference to the original value.
	 *
	 * This function is known as `const`, `constant`, or `K` (for K combinator) in
	 * other languages and libraries.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> (* -> a)
	 * @param {*} val The value to wrap in a function
	 * @return {Function} A Function :: * -> val.
	 * @example
	 *
	 *      var t = R.always('Tee');
	 *      t(); //=> 'Tee'
	 */
	module.exports = _curry1(function always(val) {
	  return function() {
	    return val;
	  };
	});


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns the larger of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.maxBy, R.min
	 * @example
	 *
	 *      R.max(789, 123); //=> 789
	 *      R.max('a', 'b'); //=> 'b'
	 */
	module.exports = _curry2(function max(a, b) { return b > a ? b : a; });


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(92);
	var setInnerHTML = __webpack_require__(75);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(100);
	var setTextContent = __webpack_require__(314);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var invariant = __webpack_require__(5);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(599);
	var ReactInstrumentation = __webpack_require__(20);
	
	var warning = __webpack_require__(6);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var ReactChildren = __webpack_require__(630);
	var ReactComponent = __webpack_require__(107);
	var ReactPureComponent = __webpack_require__(635);
	var ReactClass = __webpack_require__(631);
	var ReactDOMFactories = __webpack_require__(632);
	var ReactElement = __webpack_require__(41);
	var ReactPropTypes = __webpack_require__(633);
	var ReactVersion = __webpack_require__(636);
	
	var onlyChild = __webpack_require__(637);
	var warning = __webpack_require__(6);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var ReactCurrentOwner = __webpack_require__(27);
	
	var warning = __webpack_require__(6);
	var canDefineProperty = __webpack_require__(319);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(317);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 42 */
7,
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(645);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(641);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFactory = function createFactory(type) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  return function (p, c) {
	    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
	  };
	};
	
	exports.default = createFactory;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(28);
	
	
	/**
	 * This checks whether a function has a [methodname] function. If it isn't an
	 * array it will execute that function otherwise it will default to the ramda
	 * implementation.
	 *
	 * @private
	 * @param {Function} fn ramda implemtation
	 * @param {String} methodname property to check for a custom implementation
	 * @return {Object} Whatever the return value of the method is.
	 */
	module.exports = function _checkForMethod(methodname, fn) {
	  return function() {
	    var length = arguments.length;
	    if (length === 0) {
	      return fn();
	    }
	    var obj = arguments[length - 1];
	    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
	      fn.apply(this, arguments) :
	      obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
	  };
	};


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isFunction = __webpack_require__(61);
	var curryN = __webpack_require__(13);
	var toString = __webpack_require__(51);
	
	
	/**
	 * Turns a named method with a specified arity into a function that can be
	 * called directly supplied with arguments and a target object.
	 *
	 * The returned function is curried and accepts `arity + 1` parameters where
	 * the final parameter is the target object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
	 * @param {Number} arity Number of arguments the returned function should take
	 *        before the target object.
	 * @param {String} method Name of the method to call.
	 * @return {Function} A new curried function.
	 * @example
	 *
	 *      var sliceFrom = R.invoker(1, 'slice');
	 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
	 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
	 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
	 * @symb R.invoker(0, 'method')(o) = o['method']()
	 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
	 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
	 */
	module.exports = _curry2(function invoker(arity, method) {
	  return curryN(arity + 1, function() {
	    var target = arguments[arity];
	    if (target != null && _isFunction(target[method])) {
	      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
	    }
	    throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
	  });
	});


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _isArray = __webpack_require__(28);
	var _isString = __webpack_require__(63);
	
	
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @deprecated since v0.23.0
	 * @example
	 *
	 *      R.isArrayLike([]); //=> true
	 *      R.isArrayLike(true); //=> false
	 *      R.isArrayLike({}); //=> false
	 *      R.isArrayLike({length: 10}); //=> false
	 *      R.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	module.exports = _curry1(function isArrayLike(x) {
	  if (_isArray(x)) { return true; }
	  if (!x) { return false; }
	  if (typeof x !== 'object') { return false; }
	  if (_isString(x)) { return false; }
	  if (x.nodeType === 1) { return !!x.length; }
	  if (x.length === 0) { return true; }
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	  return false;
	});


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isString = __webpack_require__(63);
	
	
	/**
	 * Returns the nth element of the given list or string. If n is negative the
	 * element at index length + n is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> a | Undefined
	 * @sig Number -> String -> String
	 * @param {Number} offset
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      var list = ['foo', 'bar', 'baz', 'quux'];
	 *      R.nth(1, list); //=> 'bar'
	 *      R.nth(-1, list); //=> 'quux'
	 *      R.nth(-99, list); //=> undefined
	 *
	 *      R.nth(2, 'abc'); //=> 'c'
	 *      R.nth(3, 'abc'); //=> ''
	 * @symb R.nth(-1, [a, b, c]) = c
	 * @symb R.nth(0, [a, b, c]) = a
	 * @symb R.nth(1, [a, b, c]) = b
	 */
	module.exports = _curry2(function nth(offset, list) {
	  var idx = offset < 0 ? list.length + offset : offset;
	  return _isString(list) ? list.charAt(idx) : list[idx];
	});


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Retrieve the value at a given path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {a} -> a | Undefined
	 * @param {Array} path The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path`.
	 * @see R.prop
	 * @example
	 *
	 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
	 */
	module.exports = _curry2(function path(paths, obj) {
	  var val = obj;
	  var idx = 0;
	  while (idx < paths.length) {
	    if (val == null) {
	      return;
	    }
	    val = val[paths[idx]];
	    idx += 1;
	  }
	  return val;
	});


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var map = __webpack_require__(16);
	var prop = __webpack_require__(86);
	
	
	/**
	 * Returns a new list by plucking the same named property off all objects in
	 * the list supplied.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig k -> [{k: v}] -> [v]
	 * @param {Number|String} key The key name to pluck off of each object.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of values for the given key.
	 * @see R.props
	 * @example
	 *
	 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
	 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
	 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
	 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
	 */
	module.exports = _curry2(function pluck(p, list) {
	  return map(prop(p), list);
	});


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _toString = __webpack_require__(443);
	
	
	/**
	 * Returns the string representation of the given value. `eval`'ing the output
	 * should result in a value equivalent to the input value. Many of the built-in
	 * `toString` methods do not satisfy this requirement.
	 *
	 * If the given value is an `[object Object]` with a `toString` method other
	 * than `Object.prototype.toString`, this method is invoked with no arguments
	 * to produce the return value. This means user-defined constructor functions
	 * can provide a suitable `toString` method. For example:
	 *
	 *     function Point(x, y) {
	 *       this.x = x;
	 *       this.y = y;
	 *     }
	 *
	 *     Point.prototype.toString = function() {
	 *       return 'new Point(' + this.x + ', ' + this.y + ')';
	 *     };
	 *
	 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category String
	 * @sig * -> String
	 * @param {*} val
	 * @return {String}
	 * @example
	 *
	 *      R.toString(42); //=> '42'
	 *      R.toString('abc'); //=> '"abc"'
	 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
	 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
	 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
	 */
	module.exports = _curry1(function toString(val) { return _toString(val, []); });


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var EventPluginRegistry = __webpack_require__(93);
	var EventPluginUtils = __webpack_require__(94);
	var ReactErrorUtils = __webpack_require__(98);
	
	var accumulateInto = __webpack_require__(308);
	var forEachAccumulated = __webpack_require__(309);
	var invariant = __webpack_require__(5);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(52);
	var EventPluginUtils = __webpack_require__(94);
	
	var accumulateInto = __webpack_require__(308);
	var forEachAccumulated = __webpack_require__(309);
	var warning = __webpack_require__(6);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 54 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(26);
	
	var getEventTarget = __webpack_require__(103);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Adds two values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Number}
	 * @see R.subtract
	 * @example
	 *
	 *      R.add(2, 3);       //=>  5
	 *      R.add(7)(10);      //=> 17
	 */
	module.exports = _curry2(function add(a, b) {
	  return Number(a) + Number(b);
	});


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the specified
	 * property with the given value. Note that this copies and flattens prototype
	 * properties onto the new object as well. All non-primitive properties are
	 * copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig String -> a -> {k: v} -> {k: v}
	 * @param {String} prop The property name to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except for the changed property.
	 * @see R.dissoc
	 * @example
	 *
	 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry3(function assoc(prop, val, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  result[prop] = val;
	  return result;
	});


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var curryN = __webpack_require__(13);
	
	
	/**
	 * Returns a curried equivalent of the provided function. The curried function
	 * has two unusual capabilities. First, its arguments needn't be provided one
	 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value `R.__` may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is `R.__`, the
	 * following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> a) -> (* -> a)
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curryN
	 * @example
	 *
	 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
	 *
	 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry1(function curry(fn) {
	  return curryN(fn.length, fn);
	});


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var curry = __webpack_require__(58);
	
	
	/**
	 * Returns a new function much like the supplied one, except that the first two
	 * arguments' order is reversed.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> b -> c -> ... -> z) -> (b -> a -> c -> ... -> z)
	 * @param {Function} fn The function to invoke with its first two parameters reversed.
	 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
	 * @example
	 *
	 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
	 *
	 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
	 * @symb R.flip(f)(a, b, c) = f(b, a, c)
	 */
	module.exports = _curry1(function flip(fn) {
	  return curry(function(a, b) {
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = b;
	    args[1] = a;
	    return fn.apply(this, args);
	  });
	});


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(22);
	var _isPlaceholder = __webpack_require__(62);
	
	
	/**
	 * Internal curryN function.
	 *
	 * @private
	 * @category Function
	 * @param {Number} length The arity of the curried function.
	 * @param {Array} received An array of arguments received thus far.
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curryN(length, received, fn) {
	  return function() {
	    var combined = [];
	    var argsIdx = 0;
	    var left = length;
	    var combinedIdx = 0;
	    while (combinedIdx < received.length || argsIdx < arguments.length) {
	      var result;
	      if (combinedIdx < received.length &&
	          (!_isPlaceholder(received[combinedIdx]) ||
	           argsIdx >= arguments.length)) {
	        result = received[combinedIdx];
	      } else {
	        result = arguments[argsIdx];
	        argsIdx += 1;
	      }
	      combined[combinedIdx] = result;
	      if (!_isPlaceholder(result)) {
	        left -= 1;
	      }
	      combinedIdx += 1;
	    }
	    return left <= 0 ? fn.apply(this, combined)
	                     : _arity(left, _curryN(length, combined, fn));
	  };
	};


/***/ },
/* 61 */
/***/ function(module, exports) {

	module.exports = function _isFunction(x) {
	  return Object.prototype.toString.call(x) === '[object Function]';
	};


/***/ },
/* 62 */
/***/ function(module, exports) {

	module.exports = function _isPlaceholder(a) {
	  return a != null &&
	         typeof a === 'object' &&
	         a['@@functional/placeholder'] === true;
	};


/***/ },
/* 63 */
/***/ function(module, exports) {

	module.exports = function _isString(x) {
	  return Object.prototype.toString.call(x) === '[object String]';
	};


/***/ },
/* 64 */
/***/ function(module, exports) {

	module.exports = function _map(fn, functor) {
	  var idx = 0;
	  var len = functor.length;
	  var result = Array(len);
	  while (idx < len) {
	    result[idx] = fn(functor[idx]);
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var map = __webpack_require__(16);
	
	
	/**
	 * Returns a lens for the given getter and setter functions. The getter "gets"
	 * the value of the focus; the setter "sets" the value of the focus. The setter
	 * should not mutate the data structure.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
	 * @param {Function} getter
	 * @param {Function} setter
	 * @return {Lens}
	 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	module.exports = _curry2(function lens(getter, setter) {
	  return function(toFunctorFn) {
	    return function(target) {
	      return map(
	        function(focus) {
	          return setter(focus, target);
	        },
	        toFunctorFn(getter(target))
	      );
	    };
	  };
	});


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var liftN = __webpack_require__(273);
	
	
	/**
	 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
	 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.liftN
	 * @example
	 *
	 *      var madd3 = R.lift((a, b, c) => a + b + c);
	 *
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 *
	 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
	 *
	 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
	 */
	module.exports = _curry1(function lift(fn) {
	  return liftN(fn.length, fn);
	});


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly `n` parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} n The desired arity of the new function.
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity `n`.
	 * @example
	 *
	 *      var takesTwoArgs = (a, b) => [a, b];
	 *
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.nAry(1, takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only `n` arguments are passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.nAry(0, f)(a, b) = f()
	 * @symb R.nAry(1, f)(a, b) = f(a)
	 * @symb R.nAry(2, f)(a, b) = f(a, b)
	 */
	module.exports = _curry2(function nAry(n, fn) {
	  switch (n) {
	    case 0: return function() {return fn.call(this);};
	    case 1: return function(a0) {return fn.call(this, a0);};
	    case 2: return function(a0, a1) {return fn.call(this, a0, a1);};
	    case 3: return function(a0, a1, a2) {return fn.call(this, a0, a1, a2);};
	    case 4: return function(a0, a1, a2, a3) {return fn.call(this, a0, a1, a2, a3);};
	    case 5: return function(a0, a1, a2, a3, a4) {return fn.call(this, a0, a1, a2, a3, a4);};
	    case 6: return function(a0, a1, a2, a3, a4, a5) {return fn.call(this, a0, a1, a2, a3, a4, a5);};
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6);};
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);};
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);};
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);};
	    default: throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
	  }
	});


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(60);
	var _dispatchable = __webpack_require__(9);
	var _has = __webpack_require__(15);
	var _reduce = __webpack_require__(17);
	var _xreduceBy = __webpack_require__(457);
	
	
	/**
	 * Groups the elements of the list according to the result of calling
	 * the String-returning function `keyFn` on each element and reduces the elements
	 * of each group to a single value via the reducer function `valueFn`.
	 *
	 * This function is basically a more general `groupBy` function.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
	 * @param {Function} valueFn The function that reduces the elements of each group to a single
	 *        value. Receives two values, accumulator for a particular group and the current element.
	 * @param {*} acc The (initial) accumulator value for each group.
	 * @param {Function} keyFn The function that maps the list's element into a key.
	 * @param {Array} list The array to group.
	 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
	 *         `valueFn` for elements which produced that key when passed to `keyFn`.
	 * @see R.groupBy, R.reduce
	 * @example
	 *
	 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
	 *      var namesByGrade = reduceToNamesBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Lucy', score: 92},
	 *                      {name: 'Drew', score: 85},
	 *                      // ...
	 *                      {name: 'Bart', score: 62}];
	 *      namesByGrade(students);
	 *      // {
	 *      //   'A': ['Lucy'],
	 *      //   'B': ['Drew']
	 *      //   // ...,
	 *      //   'F': ['Bart']
	 *      // }
	 */
	module.exports = _curryN(4, [], _dispatchable([], _xreduceBy,
	  function reduceBy(valueFn, valueAcc, keyFn, list) {
	    return _reduce(function(acc, elt) {
	      var key = keyFn(elt);
	      acc[key] = valueFn(_has(key, acc) ? acc[key] : valueAcc, elt);
	      return acc;
	    }, {}, list);
	  }));


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(257);
	var _curry2 = __webpack_require__(1);
	var filter = __webpack_require__(80);
	
	
	/**
	 * The complement of `filter`.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.filter, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isOdd = (n) => n % 2 === 1;
	 *
	 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(function reject(pred, filterable) {
	  return filter(_complement(pred), filterable);
	});


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _isString = __webpack_require__(63);
	
	
	/**
	 * Returns a new list or string with the elements or characters in reverse
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {Array|String}
	 * @example
	 *
	 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
	 *      R.reverse([1, 2]);     //=> [2, 1]
	 *      R.reverse([1]);        //=> [1]
	 *      R.reverse([]);         //=> []
	 *
	 *      R.reverse('abc');      //=> 'cba'
	 *      R.reverse('ab');       //=> 'ba'
	 *      R.reverse('a');        //=> 'a'
	 *      R.reverse('');         //=> ''
	 */
	module.exports = _curry1(function reverse(list) {
	  return _isString(list) ? list.split('').reverse().join('') :
	                           Array.prototype.slice.call(list, 0).reverse();
	});


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var EventPluginRegistry = __webpack_require__(93);
	var ReactEventEmitterMixin = __webpack_require__(591);
	var ViewportMetrics = __webpack_require__(307);
	
	var getVendorPrefixedEventName = __webpack_require__(624);
	var isEventSupported = __webpack_require__(104);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(55);
	var ViewportMetrics = __webpack_require__(307);
	
	var getEventModifierState = __webpack_require__(102);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var invariant = __webpack_require__(5);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	var DOMNamespaces = __webpack_require__(92);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(100);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(19);
	var _curry2 = __webpack_require__(1);
	var _reduce = __webpack_require__(17);
	var map = __webpack_require__(16);
	
	
	/**
	 * ap applies a list of functions to a list of values.
	 *
	 * Dispatches to the `ap` method of the second argument, if present. Also
	 * treats curried functions as applicatives.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig [a -> b] -> [a] -> [b]
	 * @sig Apply f => f (a -> b) -> f a -> f b
	 * @param {Array} fns An array of functions
	 * @param {Array} vs An array of values
	 * @return {Array} An array of results of applying each of `fns` to all of `vs` in turn.
	 * @example
	 *
	 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
	 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
	 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
	 */
	module.exports = _curry2(function ap(applicative, fn) {
	  return (
	    typeof applicative.ap === 'function' ?
	      applicative.ap(fn) :
	    typeof applicative === 'function' ?
	      function(x) { return applicative(x)(fn(x)); } :
	    // else
	      _reduce(function(acc, f) { return _concat(acc, map(f, fn)); }, [], applicative)
	  );
	});


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _makeFlat = __webpack_require__(265);
	var _xchain = __webpack_require__(446);
	var map = __webpack_require__(16);
	
	
	/**
	 * `chain` maps a function over a list and concatenates the results. `chain`
	 * is also known as `flatMap` in some libraries
	 *
	 * Dispatches to the `chain` method of the second argument, if present,
	 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain m => (a -> m b) -> m a -> m b
	 * @param {Function} fn The function to map with
	 * @param {Array} list The list to map over
	 * @return {Array} The result of flat-mapping `list` with `fn`
	 * @example
	 *
	 *      var duplicate = n => [n, n];
	 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
	 *
	 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
	 */
	module.exports = _curry2(_dispatchable(['chain'], _xchain, function chain(fn, monad) {
	  if (typeof monad === 'function') {
	    return function(x) { return fn(monad(x))(x); };
	  }
	  return _makeFlat(false)(map(fn, monad));
	}));


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var pipe = __webpack_require__(282);
	var reverse = __webpack_require__(70);
	
	
	/**
	 * Performs right-to-left function composition. The rightmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * **Note:** The result of compose is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipe
	 * @example
	 *
	 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
	 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
	 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
	 *
	 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
	 */
	module.exports = function compose() {
	  if (arguments.length === 0) {
	    throw new Error('compose requires at least one argument');
	  }
	  return pipe.apply(this, reverse(arguments));
	};


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isArray = __webpack_require__(28);
	var _isFunction = __webpack_require__(61);
	var toString = __webpack_require__(51);
	
	
	/**
	 * Returns the result of concatenating the given lists or strings.
	 *
	 * Note: `R.concat` expects both arguments to be of the same type,
	 * unlike the native `Array.prototype.concat` method. It will throw
	 * an error if you `concat` an Array with a non-Array value.
	 *
	 * Dispatches to the `concat` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @sig String -> String -> String
	 * @param {Array|String} firstList The first list
	 * @param {Array|String} secondList The second list
	 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
	 * `secondList`.
	 *
	 * @example
	 *
	 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
	 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 *      R.concat([], []); //=> []
	 */
	module.exports = _curry2(function concat(a, b) {
	  if (a == null || !_isFunction(a.concat)) {
	    throw new TypeError(toString(a) + ' does not have a method named "concat"');
	  }
	  if (_isArray(a) && !_isArray(b)) {
	    throw new TypeError(toString(b) + ' is not an array');
	  }
	  return a.concat(b);
	});


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _filter = __webpack_require__(259);
	var _isObject = __webpack_require__(264);
	var _reduce = __webpack_require__(17);
	var _xfilter = __webpack_require__(451);
	var keys = __webpack_require__(23);
	
	
	/**
	 * Takes a predicate and a "filterable", and returns a new filterable of the
	 * same type containing the members of the given filterable which satisfy the
	 * given predicate.
	 *
	 * Dispatches to the `filter` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.reject, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(_dispatchable(['filter'], _xfilter, function(pred, filterable) {
	  return (
	    _isObject(filterable) ?
	      _reduce(function(acc, key) {
	        if (pred(filterable[key])) {
	          acc[key] = filterable[key];
	        }
	        return acc;
	      }, {}, keys(filterable)) :
	    // else
	      _filter(pred, filterable)
	  );
	}));


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _identity = __webpack_require__(84);
	
	
	/**
	 * A function that does nothing but return the parameter supplied to it. Good
	 * as a default or placeholder function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x The value to return.
	 * @return {*} The input value, `x`.
	 * @example
	 *
	 *      R.identity(1); //=> 1
	 *
	 *      var obj = {};
	 *      R.identity(obj) === obj; //=> true
	 * @symb R.identity(a) = a
	 */
	module.exports = _curry1(_identity);


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var _objectAssign = __webpack_require__(436);
	
	module.exports =
	  typeof Object.assign === 'function' ? Object.assign : _objectAssign;


/***/ },
/* 83 */
/***/ function(module, exports) {

	module.exports = function _containsWith(pred, x, list) {
	  var idx = 0;
	  var len = list.length;
	
	  while (idx < len) {
	    if (pred(x, list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	};


/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = function _identity(x) { return x; };


/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = function _isTransformer(obj) {
	  return typeof obj['@@transducer/step'] === 'function';
	};


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a function that when supplied an object returns the indicated
	 * property of that object, if it exists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig s -> {s: a} -> a | Undefined
	 * @param {String} p The property name
	 * @param {Object} obj The object to query
	 * @return {*} The value at `obj.p`.
	 * @see R.path
	 * @example
	 *
	 *      R.prop('x', {x: 100}); //=> 100
	 *      R.prop('x', {}); //=> undefined
	 */
	module.exports = _curry2(function prop(p, obj) { return obj[p]; });


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(45);
	var _curry1 = __webpack_require__(3);
	var slice = __webpack_require__(31);
	
	
	/**
	 * Returns all but the first element of the given list or string (or object
	 * with a `tail` method).
	 *
	 * Dispatches to the `slice` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.head, R.init, R.last
	 * @example
	 *
	 *      R.tail([1, 2, 3]);  //=> [2, 3]
	 *      R.tail([1, 2]);     //=> [2]
	 *      R.tail([1]);        //=> []
	 *      R.tail([]);         //=> []
	 *
	 *      R.tail('abc');  //=> 'bc'
	 *      R.tail('ab');   //=> 'b'
	 *      R.tail('a');    //=> ''
	 *      R.tail('');     //=> ''
	 */
	module.exports = _curry1(_checkForMethod('tail', slice(1, Infinity)));


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Gives a single-word string description of the (native) type of a value,
	 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
	 * attempt to distinguish user Object types any further, reporting them all as
	 * 'Object'.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Type
	 * @sig (* -> {*}) -> String
	 * @param {*} val The value to test
	 * @return {String}
	 * @example
	 *
	 *      R.type({}); //=> "Object"
	 *      R.type(1); //=> "Number"
	 *      R.type(false); //=> "Boolean"
	 *      R.type('s'); //=> "String"
	 *      R.type(null); //=> "Null"
	 *      R.type([]); //=> "Array"
	 *      R.type(/[A-z]/); //=> "RegExp"
	 */
	module.exports = _curry1(function type(val) {
	  return val === null      ? 'Null'      :
	         val === undefined ? 'Undefined' :
	         Object.prototype.toString.call(val).slice(8, -1);
	});


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(81);
	var uniqBy = __webpack_require__(290);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list. `R.equals` is used to determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
	 *      R.uniq([1, '1']);     //=> [1, '1']
	 *      R.uniq([[42], [42]]); //=> [[42]]
	 */
	module.exports = uniqBy(identity);


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(83);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied predicate to
	 * two list elements. Prefers the first item if two items compare equal based
	 * on the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      var strEq = R.eqBy(String);
	 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
	 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
	 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
	 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
	 */
	module.exports = _curry2(function uniqWith(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var item;
	  while (idx < len) {
	    item = list[idx];
	    if (!_containsWith(pred, item, result)) {
	      result[result.length] = item;
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(37);
	var Danger = __webpack_require__(568);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactInstrumentation = __webpack_require__(20);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(100);
	var setInnerHTML = __webpack_require__(75);
	var setTextContent = __webpack_require__(314);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 92 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var ReactErrorUtils = __webpack_require__(98);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(6);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 95 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var React = __webpack_require__(40);
	var ReactPropTypesSecret = __webpack_require__(597);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(6);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var invariant = __webpack_require__(5);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var ReactCurrentOwner = __webpack_require__(27);
	var ReactInstanceMap = __webpack_require__(54);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(25);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(6);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 100 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 101 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 102 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 103 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 105 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var emptyFunction = __webpack_require__(18);
	var warning = __webpack_require__(6);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(42);
	
	var ReactNoopUpdateQueue = __webpack_require__(108);
	
	var canDefineProperty = __webpack_require__(319);
	var emptyObject = __webpack_require__(44);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(6);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(6);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 109 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(12);
	
	var _createHelper = __webpack_require__(33);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(43);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class2, _Component);
	
	      function _class2() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class2);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        }, _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _class2.prototype.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
	      };
	
	      return _class2;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(withState, 'withState');

/***/ },
/* 111 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GUID = exports.GUID = 'VILLA-Y-ASENT-PRECA';
	var API_KEY = exports.API_KEY = '259d111f7b8978f963c12001c8f85018d43b1b2b';
	var RESOURCE_URL = exports.RESOURCE_URL = 'http://api.datos.gba.gob.ar/api/v2/datastreams/' + GUID + '/data.ajson/?auth_key=' + API_KEY;
	var DEFAULT_ZOOM = exports.DEFAULT_ZOOM = 10;
	var GET_MAP_OPTIONS = exports.GET_MAP_OPTIONS = function GET_MAP_OPTIONS(maps) {
	  return {
	    mapTypeId: maps.MapTypeId.SATELLITE
	  };
	};
	var DEFAULT_STYLE = exports.DEFAULT_STYLE = {
	  position: 'relative',
	  margin: 0,
	  padding: 0,
	  flex: 1
	};
	var MAP_CENTER = exports.MAP_CENTER = {
	  lat: -34.8804504,
	  lng: -58.5923888
	};

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.centerPolygon = exports.filterItemsByName = exports.shapeResponse = undefined;
	
	var _ramda = __webpack_require__(368);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _fuzzy = __webpack_require__(347);
	
	var _fuzzy2 = _interopRequireDefault(_fuzzy);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_moment2.default.locale('es');
	
	var shapeResponse = exports.shapeResponse = function shapeResponse(response) {
	  return {
	    category: response.category_name,
	    created: response.created_at,
	    last_modified: response.modified_at,
	    title: response.title,
	    user: response.user,
	    items: response.result.slice(1, response.result.length).map(function (item) {
	      return {
	        coordinates: _ramda2.default.pipe(_ramda2.default.view(_ramda2.default.lensIndex(2)), _ramda2.default.replace(/,0.0 /g, ','), _ramda2.default.split(','), _ramda2.default.splitEvery(2), _ramda2.default.dropLast(1), _ramda2.default.map(function (item) {
	          return {
	            lat: parseFloat(_ramda2.default.view(_ramda2.default.lensIndex(1), item)),
	            lng: parseFloat(_ramda2.default.view(_ramda2.default.lensIndex(0), item))
	          };
	        }), _ramda2.default.filter(function (item) {
	          return item.lat && item.lng;
	        }))(item),
	        coordinates_type: item[3],
	        id: item[4],
	        region: item[6],
	        city: item[7],
	        created: item[9],
	        name: item[10],
	        type: item[11],
	        stabilished: (0, _moment2.default)(item[12], "YYYY").fromNow(),
	        integrants: item[13],
	        surface: parseFloat(item[14]) * 100,
	        direction: item[15],
	        electricity: item[16],
	        street_electricity: item[17],
	        water: item[18],
	        sewer: item[19],
	        gas: item[20],
	        streets: item[21]
	      };
	    })
	  };
	};
	
	var filterItemsByName = exports.filterItemsByName = function filterItemsByName(criteria, list) {
	  return _fuzzy2.default.filter(criteria, list, { extract: function extract(item) {
	      return item.name + item.city + item.region;
	    } });
	};
	
	var centerPolygon = exports.centerPolygon = function centerPolygon(library, map, item) {
	  if (!item) return;
	  var bounds = new library.LatLngBounds();
	  item.coordinates.map(function (bound) {
	    bounds.extend(bound);
	  });
	  map.fitBounds(bounds);
	};

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(18);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 114 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 115 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shallowEqual = __webpack_require__(34);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _omit = __webpack_require__(119);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mainStyle = {
	  width: '100%',
	  height: '100%',
	  left: 0,
	  top: 0,
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	};
	
	var style = {
	  width: 0,
	  height: 0,
	  left: 0,
	  top: 0,
	  backgroundColor: 'transparent',
	  position: 'absolute'
	};
	
	var GoogleMapMarkers = function (_Component) {
	  _inherits(GoogleMapMarkers, _Component);
	
	  function GoogleMapMarkers(props) {
	    _classCallCheck(this, GoogleMapMarkers);
	
	    var _this = _possibleConstructorReturn(this, (GoogleMapMarkers.__proto__ || Object.getPrototypeOf(GoogleMapMarkers)).call(this, props));
	
	    _this._getState = function () {
	      return {
	        children: _this.props.dispatcher.getChildren(),
	        updateCounter: _this.props.dispatcher.getUpdateCounter()
	      };
	    };
	
	    _this._onChangeHandler = function () {
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      var prevChildCount = (_this.state.children || []).length;
	      var state = _this._getState();
	
	      _this.setState(state, function () {
	        return (state.children || []).length !== prevChildCount && _this._onMouseChangeHandler();
	      });
	    };
	
	    _this._onChildClick = function () {
	      if (_this.props.onChildClick) {
	        if (_this.hoverChildProps_) {
	          var hoverKey = _this.hoverKey_;
	          var childProps = _this.hoverChildProps_;
	          // click works only on hovered item
	          _this.props.onChildClick(hoverKey, childProps);
	        }
	      }
	    };
	
	    _this._onChildMouseDown = function () {
	      if (_this.props.onChildMouseDown) {
	        if (_this.hoverChildProps_) {
	          var hoverKey = _this.hoverKey_;
	          var childProps = _this.hoverChildProps_;
	          // works only on hovered item
	          _this.props.onChildMouseDown(hoverKey, childProps);
	        }
	      }
	    };
	
	    _this._onChildMouseEnter = function (hoverKey, childProps) {
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      if (_this.props.onChildMouseEnter) {
	        _this.props.onChildMouseEnter(hoverKey, childProps);
	      }
	
	      _this.hoverChildProps_ = childProps;
	      _this.hoverKey_ = hoverKey;
	      _this.setState({ hoverKey: hoverKey });
	    };
	
	    _this._onChildMouseLeave = function () {
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      var hoverKey = _this.hoverKey_;
	      var childProps = _this.hoverChildProps_;
	
	      if (hoverKey !== undefined && hoverKey !== null) {
	        if (_this.props.onChildMouseLeave) {
	          _this.props.onChildMouseLeave(hoverKey, childProps);
	        }
	
	        _this.hoverKey_ = null;
	        _this.hoverChildProps_ = null;
	        _this.setState({ hoverKey: null });
	      }
	    };
	
	    _this._onMouseAllow = function (value) {
	      if (!value) {
	        _this._onChildMouseLeave();
	      }
	
	      _this.allowMouse_ = value;
	    };
	
	    _this._onMouseChangeHandler = function () {
	      if (_this.allowMouse_) {
	        _this._onMouseChangeHandler_raf();
	      }
	    };
	
	    _this._onMouseChangeHandler_raf = function () {
	      // eslint-disable-line
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      var mp = _this.props.dispatcher.getMousePosition();
	
	      if (mp) {
	        var distances = [];
	        var hoverDistance = _this.props.getHoverDistance();
	
	        _react2.default.Children.forEach(_this.state.children, function (child, childIndex) {
	          if (!child) return;
	          // layers
	          if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
	            return;
	          }
	
	          var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;
	          var dist = _this.props.distanceToMouse(_this.dimesionsCache_[childKey], mp, child.props);
	          if (dist < hoverDistance) {
	            distances.push({
	              key: childKey,
	              dist: dist,
	              props: child.props
	            });
	          }
	        });
	
	        if (distances.length) {
	          distances.sort(function (a, b) {
	            return a.dist - b.dist;
	          });
	          var hoverKey = distances[0].key;
	          var childProps = distances[0].props;
	
	          if (_this.hoverKey_ !== hoverKey) {
	            _this._onChildMouseLeave();
	
	            _this._onChildMouseEnter(hoverKey, childProps);
	          }
	        } else {
	          _this._onChildMouseLeave();
	        }
	      } else {
	        _this._onChildMouseLeave();
	      }
	    };
	
	    _this._getDimensions = function (key) {
	      var childKey = key;
	      return _this.dimesionsCache_[childKey];
	    };
	
	    _this.props.dispatcher.on('kON_CHANGE', _this._onChangeHandler);
	    _this.props.dispatcher.on('kON_MOUSE_POSITION_CHANGE', _this._onMouseChangeHandler);
	    _this.props.dispatcher.on('kON_CLICK', _this._onChildClick);
	    _this.props.dispatcher.on('kON_MDOWN', _this._onChildMouseDown);
	
	    _this.dimesionsCache_ = {};
	    _this.hoverKey_ = null;
	    _this.hoverChildProps_ = null;
	    _this.allowMouse_ = true;
	
	    _this.state = _extends({}, _this._getState(), { hoverKey: null });
	    return _this;
	  }
	
	  _createClass(GoogleMapMarkers, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (this.props.experimental === true) {
	        return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)((0, _omit2.default)(this.state, ['hoverKey']), (0, _omit2.default)(nextState, ['hoverKey']));
	      }
	
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.dispatcher.removeListener('kON_CHANGE', this._onChangeHandler);
	      this.props.dispatcher.removeListener('kON_MOUSE_POSITION_CHANGE', this._onMouseChangeHandler);
	      this.props.dispatcher.removeListener('kON_CLICK', this._onChildClick);
	      this.props.dispatcher.removeListener('kON_MDOWN', this._onChildMouseDown);
	
	      this.dimesionsCache_ = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var mainElementStyle = this.props.style || mainStyle;
	      this.dimesionsCache_ = {};
	
	      var markers = _react2.default.Children.map(this.state.children, function (child, childIndex) {
	        if (!child) return undefined;
	        if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
	          return _react2.default.cloneElement(child, {
	            $geoService: _this2.props.geoService,
	            $onMouseAllow: _this2._onMouseAllow,
	            $prerender: _this2.props.prerender
	          });
	        }
	
	        var latLng = child.props.latLng !== undefined ? child.props.latLng : { lat: child.props.lat, lng: child.props.lng };
	
	        var pt = _this2.props.geoService.project(latLng, _this2.props.projectFromLeftTop);
	
	        var stylePtPos = {
	          left: pt.x,
	          top: pt.y
	        };
	
	        var dx = 0;
	        var dy = 0;
	
	        if (!_this2.props.projectFromLeftTop) {
	          // center projection
	          if (_this2.props.geoService.hasSize()) {
	            dx = _this2.props.geoService.getWidth() / 2;
	            dy = _this2.props.geoService.getHeight() / 2;
	          }
	        }
	
	        // to prevent rerender on child element i need to pass
	        // const params $getDimensions and $dimensionKey instead of dimension object
	        var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;
	
	        _this2.dimesionsCache_[childKey] = _extends({
	          x: pt.x + dx,
	          y: pt.y + dy
	        }, latLng);
	
	        return _react2.default.createElement(
	          'div',
	          {
	            key: childKey,
	            style: _extends({}, style, stylePtPos),
	            className: child.props.$markerHolderClassName
	          },
	          _react2.default.cloneElement(child, {
	            $hover: childKey === _this2.state.hoverKey,
	            $getDimensions: _this2._getDimensions,
	            $dimensionKey: childKey,
	            $geoService: _this2.props.geoService,
	            $onMouseAllow: _this2._onMouseAllow,
	            $prerender: _this2.props.prerender
	          })
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: mainElementStyle },
	        markers
	      );
	    }
	  }]);
	
	  return GoogleMapMarkers;
	}(_react.Component);
	
	GoogleMapMarkers.propTypes = {
	  geoService: _react.PropTypes.any,
	  style: _react.PropTypes.any,
	  distanceToMouse: _react.PropTypes.func,
	  dispatcher: _react.PropTypes.any,
	  onChildClick: _react.PropTypes.func,
	  onChildMouseDown: _react.PropTypes.func,
	  onChildMouseLeave: _react.PropTypes.func,
	  onChildMouseEnter: _react.PropTypes.func,
	  getHoverDistance: _react.PropTypes.func,
	  projectFromLeftTop: _react.PropTypes.bool,
	  prerender: _react.PropTypes.bool
	};
	GoogleMapMarkers.defaultProps = {
	  projectFromLeftTop: false,
	  prerender: false
	};
	exports.default = GoogleMapMarkers;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _wrap2 = __webpack_require__(118);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LatLng = function () {
	  function LatLng(lat, lng) {
	    _classCallCheck(this, LatLng);
	
	    if (isNaN(lat) || isNaN(lng)) {
	      throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
	    }
	    this.lat = +lat;
	    this.lng = +lng;
	  }
	
	  _createClass(LatLng, [{
	    key: 'wrap',
	    value: function wrap() {
	      return new LatLng(this.lat, (0, _wrap2.wrap)(this.lng, -180, 180));
	    }
	  }]);
	
	  return LatLng;
	}();
	
	LatLng.convert = function (a) {
	  if (a instanceof LatLng) {
	    return a;
	  }
	
	  if (Array.isArray(a)) {
	    return new LatLng(a[0], a[1]);
	  }
	
	  if ('lng' in a && 'lat' in a) {
	    return new LatLng(a.lat, a.lng);
	  }
	
	  return a;
	};
	
	exports.default = LatLng;

/***/ },
/* 118 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.wrap = wrap;
	function wrap(n, min, max) {
	  var d = max - min;
	  return n === max ? n : ((n - min) % d + d) % d + min;
	}

/***/ },
/* 119 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// https://github.com/acdlite/recompose/blob/master/src/packages/recompose/utils/omit.js
	var omit = function omit(obj, keys) {
	  var rest = _objectWithoutProperties(obj, []);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (rest.hasOwnProperty(key)) {
	      delete rest[key];
	    }
	  }
	  return rest;
	};
	
	exports.default = omit;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 235 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = Point;
	
	function Point(x, y) {
	    this.x = x;
	    this.y = y;
	}
	
	Point.prototype = {
	    clone: function() { return new Point(this.x, this.y); },
	
	    add:     function(p) { return this.clone()._add(p);     },
	    sub:     function(p) { return this.clone()._sub(p);     },
	    mult:    function(k) { return this.clone()._mult(k);    },
	    div:     function(k) { return this.clone()._div(k);     },
	    rotate:  function(a) { return this.clone()._rotate(a);  },
	    matMult: function(m) { return this.clone()._matMult(m); },
	    unit:    function() { return this.clone()._unit(); },
	    perp:    function() { return this.clone()._perp(); },
	    round:   function() { return this.clone()._round(); },
	
	    mag: function() {
	        return Math.sqrt(this.x * this.x + this.y * this.y);
	    },
	
	    equals: function(p) {
	        return this.x === p.x &&
	               this.y === p.y;
	    },
	
	    dist: function(p) {
	        return Math.sqrt(this.distSqr(p));
	    },
	
	    distSqr: function(p) {
	        var dx = p.x - this.x,
	            dy = p.y - this.y;
	        return dx * dx + dy * dy;
	    },
	
	    angle: function() {
	        return Math.atan2(this.y, this.x);
	    },
	
	    angleTo: function(b) {
	        return Math.atan2(this.y - b.y, this.x - b.x);
	    },
	
	    angleWith: function(b) {
	        return this.angleWithSep(b.x, b.y);
	    },
	
	    // Find the angle of the two vectors, solving the formula for the cross product a x b = |a||b|sin(θ) for θ.
	    angleWithSep: function(x, y) {
	        return Math.atan2(
	            this.x * y - this.y * x,
	            this.x * x + this.y * y);
	    },
	
	    _matMult: function(m) {
	        var x = m[0] * this.x + m[1] * this.y,
	            y = m[2] * this.x + m[3] * this.y;
	        this.x = x;
	        this.y = y;
	        return this;
	    },
	
	    _add: function(p) {
	        this.x += p.x;
	        this.y += p.y;
	        return this;
	    },
	
	    _sub: function(p) {
	        this.x -= p.x;
	        this.y -= p.y;
	        return this;
	    },
	
	    _mult: function(k) {
	        this.x *= k;
	        this.y *= k;
	        return this;
	    },
	
	    _div: function(k) {
	        this.x /= k;
	        this.y /= k;
	        return this;
	    },
	
	    _unit: function() {
	        this._div(this.mag());
	        return this;
	    },
	
	    _perp: function() {
	        var y = this.y;
	        this.y = this.x;
	        this.x = -y;
	        return this;
	    },
	
	    _rotate: function(angle) {
	        var cos = Math.cos(angle),
	            sin = Math.sin(angle),
	            x = cos * this.x - sin * this.y,
	            y = sin * this.x + cos * this.y;
	        this.x = x;
	        this.y = y;
	        return this;
	    },
	
	    _round: function() {
	        this.x = Math.round(this.x);
	        this.y = Math.round(this.y);
	        return this;
	    }
	};
	
	// constructs Point from an array if necessary
	Point.convert = function (a) {
	    if (a instanceof Point) {
	        return a;
	    }
	    if (Array.isArray(a)) {
	        return new Point(a[0], a[1]);
	    }
	    return a;
	};


/***/ },
/* 236 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(322);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(19);
	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Applies a function to the value at the given index of an array, returning a
	 * new copy of the array with the element at the given index replaced with the
	 * result of the function application.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a -> a) -> Number -> [a] -> [a]
	 * @param {Function} fn The function to apply.
	 * @param {Number} idx The index.
	 * @param {Array|Arguments} list An array-like object whose value
	 *        at the supplied index will be replaced.
	 * @return {Array} A copy of the supplied array-like object with
	 *         the element at index `idx` replaced with the value
	 *         returned by applying `fn` to the existing element.
	 * @see R.update
	 * @example
	 *
	 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
	 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
	 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
	 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
	 */
	module.exports = _curry3(function adjust(fn, idx, list) {
	  if (idx >= list.length || idx < -list.length) {
	    return list;
	  }
	  var start = idx < 0 ? list.length : 0;
	  var _idx = start + idx;
	  var _list = _concat(list);
	  _list[_idx] = fn(list[_idx]);
	  return _list;
	});


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if both arguments are `true`; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if it is falsy, otherwise the second argument.
	 * @see R.both
	 * @example
	 *
	 *      R.and(true, true); //=> true
	 *      R.and(true, false); //=> false
	 *      R.and(false, true); //=> false
	 *      R.and(false, false); //=> false
	 */
	module.exports = _curry2(function and(a, b) {
	  return a && b;
	});


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _xany = __webpack_require__(266);
	
	
	/**
	 * Returns `true` if at least one of elements of the list match the predicate,
	 * `false` otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
	 *         otherwise.
	 * @see R.all, R.none, R.transduce
	 * @example
	 *
	 *      var lessThan0 = R.flip(R.lt)(0);
	 *      var lessThan2 = R.flip(R.lt)(2);
	 *      R.any(lessThan0)([1, 2]); //=> false
	 *      R.any(lessThan2)([1, 2]); //=> true
	 */
	module.exports = _curry2(_dispatchable(['any'], _xany, function any(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (fn(list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	}));


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Applies function `fn` to the argument list `args`. This is useful for
	 * creating a fixed-arity function from a variadic function. `fn` should be a
	 * bound function if context is significant.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> a) -> [*] -> a
	 * @param {Function} fn The function which will be called with `args`
	 * @param {Array} args The arguments to call `fn` with
	 * @return {*} result The result, equivalent to `fn(...args)`
	 * @see R.call, R.unapply
	 * @example
	 *
	 *      var nums = [1, 2, 3, -99, 42, 6, 7];
	 *      R.apply(Math.max, nums); //=> 42
	 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
	 */
	module.exports = _curry2(function apply(fn, args) {
	  return fn.apply(this, args);
	});


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var _has = __webpack_require__(15);
	var _isArray = __webpack_require__(28);
	var _isInteger = __webpack_require__(262);
	var assoc = __webpack_require__(57);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the nodes required
	 * to create the given path, and placing the specific value at the tail end of
	 * that path. Note that this copies and flattens prototype properties onto the
	 * new object as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> {a}
	 * @param {Array} path the path to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except along the specified path.
	 * @see R.dissocPath
	 * @example
	 *
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
	 *
	 *      // Any missing or non-object keys in path will be overridden
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
	 */
	module.exports = _curry3(function assocPath(path, val, obj) {
	  if (path.length === 0) {
	    return val;
	  }
	  var idx = path[0];
	  if (path.length > 1) {
	    var nextObj = _has(idx, obj) ? obj[idx] : _isInteger(path[1]) ? [] : {};
	    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
	  }
	  if (_isInteger(idx) && _isArray(obj)) {
	    var arr = [].concat(obj);
	    arr[idx] = val;
	    return arr;
	  } else {
	    return assoc(idx, val, obj);
	  }
	});


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(22);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates a function that is bound to a context.
	 * Note: `R.bind` does not provide the additional argument-binding capabilities of
	 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @category Object
	 * @sig (* -> *) -> {*} -> (* -> *)
	 * @param {Function} fn The function to bind to context
	 * @param {Object} thisObj The context to bind `fn` to
	 * @return {Function} A function that will execute in the context of `thisObj`.
	 * @see R.partial
	 * @example
	 *
	 *      var log = R.bind(console.log, console);
	 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
	 *      // logs {a: 2}
	 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
	 */
	module.exports = _curry2(function bind(fn, thisObj) {
	  return _arity(fn.length, function() {
	    return fn.apply(thisObj, arguments);
	  });
	});


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	var chain = __webpack_require__(77);
	var compose = __webpack_require__(78);
	var map = __webpack_require__(16);
	
	
	/**
	 * Returns the right-to-left Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), R.chain(f))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (a -> m z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipeK
	 * @example
	 *
	 *       //  get :: String -> Object -> Maybe *
	 *       var get = R.curry((propName, obj) => Maybe(obj[propName]))
	 *
	 *       //  getStateCode :: Maybe String -> Maybe String
	 *       var getStateCode = R.composeK(
	 *         R.compose(Maybe.of, R.toUpper),
	 *         get('state'),
	 *         get('address'),
	 *         get('user'),
	 *       );
	 *       getStateCode({"user":{"address":{"state":"ny"}}}); //=> Maybe.Just("NY")
	 *       getStateCode({}); //=> Maybe.Nothing()
	 * @symb R.composeK(f, g, h)(a) = R.chain(f, R.chain(g, h(a)))
	 */
	module.exports = function composeK() {
	  if (arguments.length === 0) {
	    throw new Error('composeK requires at least one argument');
	  }
	  var init = Array.prototype.slice.call(arguments);
	  var last = init.pop();
	  return compose(compose.apply(this, map(chain, init)), last);
	};


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var curry = __webpack_require__(58);
	var nAry = __webpack_require__(67);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type. The arity of the function
	 * returned is specified to allow using variadic constructor functions.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Function
	 * @sig Number -> (* -> {*}) -> (* -> {*})
	 * @param {Number} n The arity of the constructor function.
	 * @param {Function} Fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Variadic Constructor function
	 *      function Salad() {
	 *        this.ingredients = arguments;
	 *      };
	 *      Salad.prototype.recipe = function() {
	 *        var instructions = R.map((ingredient) => (
	 *          'Add a whollop of ' + ingredient, this.ingredients)
	 *        )
	 *        return R.join('\n', instructions)
	 *      }
	 *
	 *      var ThreeLayerSalad = R.constructN(3, Salad)
	 *
	 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
	 *      var salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup')
	 *      console.log(salad.recipe());
	 *      // Add a whollop of Mayonnaise
	 *      // Add a whollop of Potato Chips
	 *      // Add a whollop of Potato Ketchup
	 */
	module.exports = _curry2(function constructN(n, Fn) {
	  if (n > 10) {
	    throw new Error('Constructor with greater than ten arguments');
	  }
	  if (n === 0) {
	    return function() { return new Fn(); };
	  }
	  return curry(nAry(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
	    switch (arguments.length) {
	      case  1: return new Fn($0);
	      case  2: return new Fn($0, $1);
	      case  3: return new Fn($0, $1, $2);
	      case  4: return new Fn($0, $1, $2, $3);
	      case  5: return new Fn($0, $1, $2, $3, $4);
	      case  6: return new Fn($0, $1, $2, $3, $4, $5);
	      case  7: return new Fn($0, $1, $2, $3, $4, $5, $6);
	      case  8: return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
	      case  9: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
	      case 10: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
	    }
	  }));
	});


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _map = __webpack_require__(64);
	var curryN = __webpack_require__(13);
	var max = __webpack_require__(36);
	var pluck = __webpack_require__(50);
	var reduce = __webpack_require__(24);
	
	
	/**
	 * Accepts a converging function and a list of branching functions and returns
	 * a new function. When invoked, this new function is applied to some
	 * arguments, each branching function is applied to those same arguments. The
	 * results of each branching function are passed as arguments to the converging
	 * function to produce the return value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.2
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> b -> ... -> x1), (a -> b -> ... -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} after A function. `after` will be invoked with the return values of
	 *        `fn1` and `fn2` as its arguments.
	 * @param {Array} functions A list of functions.
	 * @return {Function} A new function.
	 * @see R.useWith
	 * @example
	 *
	 *      var average = R.converge(R.divide, [R.sum, R.length])
	 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
	 *
	 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
	 *      strangeConcat("Yodel") //=> "YODELyodel"
	 *
	 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
	 */
	module.exports = _curry2(function converge(after, fns) {
	  return curryN(reduce(max, 0, pluck('length', fns)), function() {
	    var args = arguments;
	    var context = this;
	    return after.apply(context, _map(function(fn) {
	      return fn.apply(context, args);
	    }, fns));
	  });
	});


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns the second argument if it is not `null`, `undefined` or `NaN`
	 * otherwise the first argument is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {a} default The default value.
	 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
	 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
	 * @example
	 *
	 *      var defaultTo42 = R.defaultTo(42);
	 *
	 *      defaultTo42(null);  //=> 42
	 *      defaultTo42(undefined);  //=> 42
	 *      defaultTo42('Ramda');  //=> 'Ramda'
	 *      // parseInt('string') results in NaN
	 *      defaultTo42(parseInt('string')); //=> 42
	 */
	module.exports = _curry2(function defaultTo(d, v) {
	  return v == null || v !== v ? d : v;
	});


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(30);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Objects and Arrays are compared are compared
	 * in terms of value equality, not reference equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith
	 * @example
	 *
	 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
	 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
	 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
	 */
	module.exports = _curry2(function difference(first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_contains(first[idx], second) && !_contains(first[idx], out)) {
	      out[out.length] = first[idx];
	    }
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(83);
	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
	 * @example
	 *
	 *      var cmp = (x, y) => x.a === y.a;
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}];
	 *      var l2 = [{a: 3}, {a: 4}];
	 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
	 */
	module.exports = _curry3(function differenceWith(pred, first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_containsWith(pred, first[idx], second) &&
	        !_containsWith(pred, first[idx], out)) {
	      out.push(first[idx]);
	    }
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a new object that does not contain a `prop` property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Object
	 * @sig String -> {k: v} -> {k: v}
	 * @param {String} prop The name of the property to dissociate
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original but without the specified property
	 * @see R.assoc
	 * @example
	 *
	 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
	 */
	module.exports = _curry2(function dissoc(prop, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  delete result[prop];
	  return result;
	});


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _xdrop = __webpack_require__(447);
	var slice = __webpack_require__(31);
	
	
	/**
	 * Returns all but the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `drop` method).
	 *
	 * Dispatches to the `drop` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {[a]} list
	 * @return {[a]} A copy of list without the first `n` elements
	 * @see R.take, R.transduce, R.dropLast, R.dropWhile
	 * @example
	 *
	 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(3, 'ramda');               //=> 'da'
	 */
	module.exports = _curry2(_dispatchable(['drop'], _xdrop, function drop(n, xs) {
	  return slice(Math.max(0, n), Infinity, xs);
	}));


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _xdropRepeatsWith = __webpack_require__(267);
	var last = __webpack_require__(271);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements. Equality is
	 * determined by applying the supplied predicate to each pair of consecutive elements. The
	 * first element in a series of equal elements will be preserved.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
	 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
	 */
	module.exports = _curry2(_dispatchable([], _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
	  var result = [];
	  var idx = 1;
	  var len = list.length;
	  if (len !== 0) {
	    result[0] = list[0];
	    while (idx < len) {
	      if (!pred(last(result), list[idx])) {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	  }
	  return result;
	}));
	


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _isArguments = __webpack_require__(261);
	var _isArray = __webpack_require__(28);
	var _isObject = __webpack_require__(264);
	var _isString = __webpack_require__(63);
	
	
	/**
	 * Returns the empty value of its argument's type. Ramda defines the empty
	 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
	 * types are supported if they define `<Type>.empty` and/or
	 * `<Type>.prototype.empty`.
	 *
	 * Dispatches to the `empty` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x
	 * @return {*}
	 * @example
	 *
	 *      R.empty(Just(42));      //=> Nothing()
	 *      R.empty([1, 2, 3]);     //=> []
	 *      R.empty('unicorns');    //=> ''
	 *      R.empty({x: 1, y: 2});  //=> {}
	 */
	module.exports = _curry1(function empty(x) {
	  return (
	    (x != null && typeof x.empty === 'function') ?
	      x.empty() :
	    (x != null && x.constructor != null && typeof x.constructor.empty === 'function') ?
	      x.constructor.empty() :
	    _isArray(x) ?
	      [] :
	    _isString(x) ?
	      '' :
	    _isObject(x) ?
	      {} :
	    _isArguments(x) ?
	      (function() { return arguments; }()) :
	    // else
	      void 0
	  );
	});


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns true if its arguments are identical, false otherwise. Values are
	 * identical if they reference the same memory. `NaN` is identical to `NaN`;
	 * `0` and `-0` are not identical.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      var o = {};
	 *      R.identical(o, o); //=> true
	 *      R.identical(1, 1); //=> true
	 *      R.identical(1, '1'); //=> false
	 *      R.identical([], []); //=> false
	 *      R.identical(0, -0); //=> false
	 *      R.identical(NaN, NaN); //=> true
	 */
	module.exports = _curry2(function identical(a, b) {
	  // SameValue algorithm
	  if (a === b) { // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return a !== 0 || 1 / a === 1 / b;
	  } else {
	    // Step 6.a: NaN == NaN
	    return a !== a && b !== b;
	  }
	});


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var _cloneRegExp = __webpack_require__(256);
	var type = __webpack_require__(88);
	
	
	/**
	 * Copies an object.
	 *
	 * @private
	 * @param {*} value The value to be copied
	 * @param {Array} refFrom Array containing the source references
	 * @param {Array} refTo Array containing the copied source references
	 * @param {Boolean} deep Whether or not to perform deep cloning.
	 * @return {*} The copied value.
	 */
	module.exports = function _clone(value, refFrom, refTo, deep) {
	  var copy = function copy(copiedValue) {
	    var len = refFrom.length;
	    var idx = 0;
	    while (idx < len) {
	      if (value === refFrom[idx]) {
	        return refTo[idx];
	      }
	      idx += 1;
	    }
	    refFrom[idx + 1] = value;
	    refTo[idx + 1] = copiedValue;
	    for (var key in value) {
	      copiedValue[key] = deep ?
	        _clone(value[key], refFrom, refTo, true) : value[key];
	    }
	    return copiedValue;
	  };
	  switch (type(value)) {
	    case 'Object':  return copy({});
	    case 'Array':   return copy([]);
	    case 'Date':    return new Date(value.valueOf());
	    case 'RegExp':  return _cloneRegExp(value);
	    default:        return value;
	  }
	};


/***/ },
/* 256 */
/***/ function(module, exports) {

	module.exports = function _cloneRegExp(pattern) {
	  return new RegExp(pattern.source, (pattern.global     ? 'g' : '') +
	                                    (pattern.ignoreCase ? 'i' : '') +
	                                    (pattern.multiline  ? 'm' : '') +
	                                    (pattern.sticky     ? 'y' : '') +
	                                    (pattern.unicode    ? 'u' : ''));
	};


/***/ },
/* 257 */
/***/ function(module, exports) {

	module.exports = function _complement(f) {
	  return function() {
	    return !f.apply(this, arguments);
	  };
	};


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(22);
	var _curry2 = __webpack_require__(1);
	
	
	module.exports = function _createPartialApplicator(concat) {
	  return _curry2(function(fn, args) {
	    return _arity(Math.max(0, fn.length - args.length), function() {
	      return fn.apply(this, concat(args, arguments));
	    });
	  });
	};


/***/ },
/* 259 */
/***/ function(module, exports) {

	module.exports = function _filter(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	
	  while (idx < len) {
	    if (fn(list[idx])) {
	      result[result.length] = list[idx];
	    }
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	var equals = __webpack_require__(21);
	
	
	module.exports = function _indexOf(list, a, idx) {
	  var inf, item;
	  // Array.prototype.indexOf doesn't exist below IE9
	  if (typeof list.indexOf === 'function') {
	    switch (typeof a) {
	      case 'number':
	        if (a === 0) {
	          // manually crawl the list to distinguish between +0 and -0
	          inf = 1 / a;
	          while (idx < list.length) {
	            item = list[idx];
	            if (item === 0 && 1 / item === inf) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        } else if (a !== a) {
	          // NaN
	          while (idx < list.length) {
	            item = list[idx];
	            if (typeof item === 'number' && item !== item) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        }
	        // non-zero numbers can utilise Set
	        return list.indexOf(a, idx);
	
	      // all these types can utilise Set
	      case 'string':
	      case 'boolean':
	      case 'function':
	      case 'undefined':
	        return list.indexOf(a, idx);
	
	      case 'object':
	        if (a === null) {
	          // null can utilise Set
	          return list.indexOf(a, idx);
	        }
	    }
	  }
	  // anything else not covered above, defer to R.equals
	  while (idx < list.length) {
	    if (equals(list[idx], a)) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	};


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(15);
	
	
	module.exports = (function() {
	  var toString = Object.prototype.toString;
	  return toString.call(arguments) === '[object Arguments]' ?
	    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
	    function _isArguments(x) { return _has('callee', x); };
	}());


/***/ },
/* 262 */
/***/ function(module, exports) {

	/**
	 * Determine if the passed argument is an integer.
	 *
	 * @private
	 * @param {*} n
	 * @category Type
	 * @return {Boolean}
	 */
	module.exports = Number.isInteger || function _isInteger(n) {
	  return (n << 0) === n;
	};


/***/ },
/* 263 */
/***/ function(module, exports) {

	module.exports = function _isNumber(x) {
	  return Object.prototype.toString.call(x) === '[object Number]';
	};


/***/ },
/* 264 */
/***/ function(module, exports) {

	module.exports = function _isObject(x) {
	  return Object.prototype.toString.call(x) === '[object Object]';
	};


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(47);
	
	
	/**
	 * `_makeFlat` is a helper function that returns a one-level or fully recursive
	 * function based on the flag passed in.
	 *
	 * @private
	 */
	module.exports = function _makeFlat(recursive) {
	  return function flatt(list) {
	    var value, jlen, j;
	    var result = [];
	    var idx = 0;
	    var ilen = list.length;
	
	    while (idx < ilen) {
	      if (isArrayLike(list[idx])) {
	        value = recursive ? flatt(list[idx]) : list[idx];
	        j = 0;
	        jlen = value.length;
	        while (j < jlen) {
	          result[result.length] = value[j];
	          j += 1;
	        }
	      } else {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	    return result;
	  };
	};


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduced = __webpack_require__(29);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XAny(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.any = false;
	  }
	  XAny.prototype['@@transducer/init'] = _xfBase.init;
	  XAny.prototype['@@transducer/result'] = function(result) {
	    if (!this.any) {
	      result = this.xf['@@transducer/step'](result, false);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAny.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.any = true;
	      result = _reduced(this.xf['@@transducer/step'](result, true));
	    }
	    return result;
	  };
	
	  return _curry2(function _xany(f, xf) { return new XAny(f, xf); });
	}());


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XDropRepeatsWith(pred, xf) {
	    this.xf = xf;
	    this.pred = pred;
	    this.lastValue = undefined;
	    this.seenFirstValue = false;
	  }
	
	  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase.init;
	  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase.result;
	  XDropRepeatsWith.prototype['@@transducer/step'] = function(result, input) {
	    var sameAsLast = false;
	    if (!this.seenFirstValue) {
	      this.seenFirstValue = true;
	    } else if (this.pred(this.lastValue, input)) {
	      sameAsLast = true;
	    }
	    this.lastValue = input;
	    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropRepeatsWith(pred, xf) { return new XDropRepeatsWith(pred, xf); });
	}());


/***/ },
/* 268 */
/***/ function(module, exports) {

	module.exports = (function() {
	  function XWrap(fn) {
	    this.f = fn;
	  }
	  XWrap.prototype['@@transducer/init'] = function() {
	    throw new Error('init not implemented on XWrap');
	  };
	  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
	  XWrap.prototype['@@transducer/step'] = function(acc, x) {
	    return this.f(acc, x);
	  };
	
	  return function _xwrap(fn) { return new XWrap(fn); };
	}());


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * See if an object (`val`) is an instance of the supplied constructor. This
	 * function will check up the inheritance chain, if any.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Type
	 * @sig (* -> {*}) -> a -> Boolean
	 * @param {Object} ctor A constructor
	 * @param {*} val The value to test
	 * @return {Boolean}
	 * @example
	 *
	 *      R.is(Object, {}); //=> true
	 *      R.is(Number, 1); //=> true
	 *      R.is(Object, 1); //=> false
	 *      R.is(String, 's'); //=> true
	 *      R.is(String, new String('')); //=> true
	 *      R.is(Object, new String('')); //=> true
	 *      R.is(Object, 's'); //=> false
	 *      R.is(Number, {}); //=> false
	 */
	module.exports = _curry2(function is(Ctor, val) {
	  return val != null && val.constructor === Ctor || val instanceof Ctor;
	});


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var converge = __webpack_require__(246);
	
	
	/**
	 * juxt applies a list of functions to a list of values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Function
	 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
	 * @param {Array} fns An array of functions
	 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
	 * @see R.applySpec
	 * @example
	 *
	 *      var getRange = R.juxt([Math.min, Math.max]);
	 *      getRange(3, 4, 9, -3); //=> [-3, 9]
	 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
	 */
	module.exports = _curry1(function juxt(fns) {
	  return converge(function() { return Array.prototype.slice.call(arguments, 0); }, fns);
	});


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(48);
	
	
	/**
	 * Returns the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.init, R.head, R.tail
	 * @example
	 *
	 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
	 *      R.last([]); //=> undefined
	 *
	 *      R.last('abc'); //=> 'c'
	 *      R.last(''); //=> ''
	 */
	module.exports = nth(-1);


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _isNumber = __webpack_require__(263);
	
	
	/**
	 * Returns the number of elements in the array by returning `list.length`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [a] -> Number
	 * @param {Array} list The array to inspect.
	 * @return {Number} The length of the array.
	 * @example
	 *
	 *      R.length([]); //=> 0
	 *      R.length([1, 2, 3]); //=> 3
	 */
	module.exports = _curry1(function length(list) {
	  return list != null && _isNumber(list.length) ? list.length : NaN;
	});


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduce = __webpack_require__(17);
	var ap = __webpack_require__(76);
	var curryN = __webpack_require__(13);
	var map = __webpack_require__(16);
	
	
	/**
	 * "lifts" a function to be the specified arity, so that it may "map over" that
	 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig Number -> (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.lift, R.ap
	 * @example
	 *
	 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 */
	module.exports = _curry2(function liftN(arity, fn) {
	  var lifted = curryN(arity, fn);
	  return curryN(arity, function() {
	    return _reduce(ap, map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
	  });
	});


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var sum = __webpack_require__(287);
	
	
	/**
	 * Returns the mean of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @example
	 *
	 *      R.mean([2, 7, 9]); //=> 6
	 *      R.mean([]); //=> NaN
	 */
	module.exports = _curry1(function mean(list) {
	  return sum(list) / list.length;
	});


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var _has = __webpack_require__(15);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the key
	 * and the values associated with the key in each object, with the result being
	 * used as the value associated with the key in the returned object. The key
	 * will be excluded from the returned object if the resulting value is
	 * `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.merge, R.mergeWith
	 * @example
	 *
	 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
	 *      R.mergeWithKey(concatValues,
	 *                     { a: true, thing: 'foo', values: [10, 20] },
	 *                     { b: true, thing: 'bar', values: [15, 35] });
	 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
	 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
	 */
	module.exports = _curry3(function mergeWithKey(fn, l, r) {
	  var result = {};
	  var k;
	
	  for (k in l) {
	    if (_has(k, l)) {
	      result[k] = _has(k, r) ? fn(k, l[k], r[k]) : l[k];
	    }
	  }
	
	  for (k in r) {
	    if (_has(k, r) && !(_has(k, result))) {
	      result[k] = r[k];
	    }
	  }
	
	  return result;
	});


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Multiplies two numbers. Equivalent to `a * b` but curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a * b`.
	 * @see R.divide
	 * @example
	 *
	 *      var double = R.multiply(2);
	 *      var triple = R.multiply(3);
	 *      double(3);       //=>  6
	 *      triple(4);       //=> 12
	 *      R.multiply(2, 5);  //=> 10
	 */
	module.exports = _curry2(function multiply(a, b) { return a * b; });


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * A function that returns the `!` of its argument. It will return `true` when
	 * passed false-y value, and `false` when passed a truth-y one.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig * -> Boolean
	 * @param {*} a any value
	 * @return {Boolean} the logical inverse of passed argument.
	 * @see R.complement
	 * @example
	 *
	 *      R.not(true); //=> false
	 *      R.not(false); //=> true
	 *      R.not(0); //=> true
	 *      R.not(1); //=> false
	 */
	module.exports = _curry1(function not(a) {
	  return !a;
	});


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates an object containing a single key:value pair.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @sig String -> a -> {String:a}
	 * @param {String} key
	 * @param {*} val
	 * @return {Object}
	 * @see R.pair
	 * @example
	 *
	 *      var matchPhrases = R.compose(
	 *        R.objOf('must'),
	 *        R.map(R.objOf('match_phrase'))
	 *      );
	 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
	 */
	module.exports = _curry2(function objOf(key, val) {
	  var obj = {};
	  obj[key] = val;
	  return obj;
	});


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if one or both of its arguments are `true`. Returns `false`
	 * if both arguments are `false`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if truthy, otherwise the second argument.
	 * @see R.either
	 * @example
	 *
	 *      R.or(true, true); //=> true
	 *      R.or(true, false); //=> true
	 *      R.or(false, true); //=> true
	 *      R.or(false, false); //=> false
	 */
	module.exports = _curry2(function or(a, b) {
	  return a || b;
	});


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the result of applying the given function to
	 * the focused value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> (a -> a) -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
	 */
	module.exports = (function() {
	  // `Identity` is a functor that holds a single value, where `map` simply
	  // transforms the held value with the provided function.
	  var Identity = function(x) {
	    return {value: x, map: function(f) { return Identity(f(x)); }};
	  };
	
	  return _curry3(function over(lens, f, x) {
	    // The value returned by the getter function is first transformed with `f`,
	    // then set as the value of an `Identity`. This is then mapped over with the
	    // setter function of the lens.
	    return lens(function(y) { return Identity(f(y)); })(x).value;
	  });
	}());


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Similar to `pick` except that this one includes a `key: undefined` pair for
	 * properties that don't exist.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
	 */
	module.exports = _curry2(function pickAll(names, obj) {
	  var result = {};
	  var idx = 0;
	  var len = names.length;
	  while (idx < len) {
	    var name = names[idx];
	    result[name] = obj[name];
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(22);
	var _pipe = __webpack_require__(438);
	var reduce = __webpack_require__(24);
	var tail = __webpack_require__(87);
	
	
	/**
	 * Performs left-to-right function composition. The leftmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * In some libraries this function is named `sequence`.
	 *
	 * **Note:** The result of pipe is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.compose
	 * @example
	 *
	 *      var f = R.pipe(Math.pow, R.negate, R.inc);
	 *
	 *      f(3, 4); // -(3^4) + 1
	 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
	 */
	module.exports = function pipe() {
	  if (arguments.length === 0) {
	    throw new Error('pipe requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipe, arguments[0], tail(arguments)));
	};


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(22);
	var _pipeP = __webpack_require__(439);
	var reduce = __webpack_require__(24);
	var tail = __webpack_require__(87);
	
	
	/**
	 * Performs left-to-right composition of one or more Promise-returning
	 * functions. The leftmost function may have any arity; the remaining functions
	 * must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.composeP
	 * @example
	 *
	 *      //  followersForUser :: String -> Promise [User]
	 *      var followersForUser = R.pipeP(db.getUserById, db.getFollowers);
	 */
	module.exports = function pipeP() {
	  if (arguments.length === 0) {
	    throw new Error('pipeP requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipeP, arguments[0], tail(arguments)));
	};


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(19);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a new list with the given element at the front, followed by the
	 * contents of the list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The item to add to the head of the output list.
	 * @param {Array} list The array to add to the tail of the output list.
	 * @return {Array} A new array.
	 * @see R.append
	 * @example
	 *
	 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
	 */
	module.exports = _curry2(function prepend(el, list) {
	  return _concat([el], list);
	});


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * Similar to `reduce`, except moves through the input list from the right to
	 * the left.
	 *
	 * The iterator function receives two values: *(value, acc)*, while the arguments'
	 * order of `reduce`'s iterator function is *(acc, value)*.
	 *
	 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a, b -> b) -> b -> [a] -> b
	 * @param {Function} fn The iterator function. Receives two values, the current element from the array
	 *        and the accumulator.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.addIndex
	 * @example
	 *
	 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
	 *          -               -2
	 *         / \              / \
	 *        1   -            1   3
	 *           / \              / \
	 *          2   -     ==>    2  -1
	 *             / \              / \
	 *            3   -            3   4
	 *               / \              / \
	 *              4   0            4   0
	 *
	 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
	 */
	module.exports = _curry3(function reduceRight(fn, acc, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    acc = fn(list[idx], acc);
	    idx -= 1;
	  }
	  return acc;
	});


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var ap = __webpack_require__(76);
	var map = __webpack_require__(16);
	var prepend = __webpack_require__(284);
	var reduceRight = __webpack_require__(285);
	
	
	/**
	 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
	 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
	 * Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
	 * @param {Function} of
	 * @param {*} traversable
	 * @return {*}
	 * @see R.traverse
	 * @example
	 *
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
	 *
	 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
	 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
	 */
	module.exports = _curry2(function sequence(of, traversable) {
	  return typeof traversable.sequence === 'function' ?
	    traversable.sequence(of) :
	    reduceRight(function(x, acc) { return ap(map(prepend, x), acc); },
	                of([]),
	                traversable);
	});


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var add = __webpack_require__(56);
	var reduce = __webpack_require__(24);
	
	
	/**
	 * Adds together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The sum of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.sum([2,4,6,8,100,1]); //=> 121
	 */
	module.exports = reduce(add, 0);


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _xtake = __webpack_require__(458);
	var slice = __webpack_require__(31);
	
	
	/**
	 * Returns the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `take` method).
	 *
	 * Dispatches to the `take` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {*} list
	 * @return {*}
	 * @see R.drop
	 * @example
	 *
	 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(3, 'ramda');               //=> 'ram'
	 *
	 *      var personnel = [
	 *        'Dave Brubeck',
	 *        'Paul Desmond',
	 *        'Eugene Wright',
	 *        'Joe Morello',
	 *        'Gerry Mulligan',
	 *        'Bob Bates',
	 *        'Joe Dodge',
	 *        'Ron Crotty'
	 *      ];
	 *
	 *      var takeFive = R.take(5);
	 *      takeFive(personnel);
	 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
	 * @symb R.take(-1, [a, b]) = [a, b]
	 * @symb R.take(0, [a, b]) = []
	 * @symb R.take(1, [a, b]) = [a]
	 * @symb R.take(2, [a, b]) = [a, b]
	 */
	module.exports = _curry2(_dispatchable(['take'], _xtake, function take(n, xs) {
	  return slice(0, n < 0 ? Infinity : n, xs);
	}));


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Calls an input function `n` times, returning an array containing the results
	 * of those function calls.
	 *
	 * `fn` is passed one argument: The current value of `n`, which begins at `0`
	 * and is gradually incremented to `n - 1`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.3
	 * @category List
	 * @sig (Number -> a) -> Number -> [a]
	 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
	 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
	 * @return {Array} An array containing the return values of all calls to `fn`.
	 * @example
	 *
	 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
	 * @symb R.times(f, 0) = []
	 * @symb R.times(f, 1) = [f(0)]
	 * @symb R.times(f, 2) = [f(0), f(1)]
	 */
	module.exports = _curry2(function times(fn, n) {
	  var len = Number(n);
	  var idx = 0;
	  var list;
	
	  if (len < 0 || isNaN(len)) {
	    throw new RangeError('n must be a non-negative number');
	  }
	  list = new Array(len);
	  while (idx < len) {
	    list[idx] = fn(idx);
	    idx += 1;
	  }
	  return list;
	});


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var _Set = __webpack_require__(426);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied function to
	 * each list element. Prefers the first item if the supplied function produces
	 * the same value on two items. `R.equals` is used for comparison.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> b) -> [a] -> [a]
	 * @param {Function} fn A function used to produce a value to use during comparisons.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
	 */
	module.exports = _curry2(function uniqBy(fn, list) {
	  var set = new _Set();
	  var result = [];
	  var idx = 0;
	  var appliedItem, item;
	
	  while (idx < list.length) {
	    item = list[idx];
	    appliedItem = fn(item);
	    if (set.add(appliedItem)) {
	      result.push(item);
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var adjust = __webpack_require__(238);
	var always = __webpack_require__(35);
	
	
	/**
	 * Returns a new copy of the array with the element at the provided index
	 * replaced with the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} idx The index to update.
	 * @param {*} x The value to exist at the given index of the returned array.
	 * @param {Array|Arguments} list The source array-like object to be updated.
	 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
	 * @see R.adjust
	 * @example
	 *
	 *      R.update(1, 11, [0, 1, 2]);     //=> [0, 11, 2]
	 *      R.update(1)(11)([0, 1, 2]);     //=> [0, 11, 2]
	 * @symb R.update(-1, a, [b, c]) = [b, a]
	 * @symb R.update(0, a, [b, c]) = [a, c]
	 * @symb R.update(1, a, [b, c]) = [b, a]
	 */
	module.exports = _curry3(function update(idx, x, list) {
	  return adjust(always(x), idx, list);
	});


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var curryN = __webpack_require__(13);
	
	
	/**
	 * Accepts a function `fn` and a list of transformer functions and returns a
	 * new curried function. When the new function is invoked, it calls the
	 * function `fn` with parameters consisting of the result of calling each
	 * supplied handler on successive arguments to the new function.
	 *
	 * If more arguments are passed to the returned function than transformer
	 * functions, those arguments are passed directly to `fn` as additional
	 * parameters. If you expect additional arguments that don't need to be
	 * transformed, although you can ignore them, it's best to pass an identity
	 * function so that the new function reports the correct arity.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} fn The function to wrap.
	 * @param {Array} transformers A list of transformer functions
	 * @return {Function} The wrapped function.
	 * @see R.converge
	 * @example
	 *
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
	 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
	 */
	module.exports = _curry2(function useWith(fn, transformers) {
	  return curryN(transformers.length, function() {
	    var args = [];
	    var idx = 0;
	    while (idx < transformers.length) {
	      args.push(transformers[idx].call(this, arguments[idx]));
	      idx += 1;
	    }
	    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
	  });
	});


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var keys = __webpack_require__(23);
	
	
	/**
	 * Returns a list of all the enumerable own properties of the supplied object.
	 * Note that the order of the output array is not guaranteed across different
	 * JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own properties.
	 * @example
	 *
	 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
	 */
	module.exports = _curry1(function values(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var vals = [];
	  var idx = 0;
	  while (idx < len) {
	    vals[idx] = obj[props[idx]];
	    idx += 1;
	  }
	  return vals;
	});


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _has = __webpack_require__(15);
	
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec. Each of the spec's own properties must be a predicate function.
	 * Each predicate is applied to the value of the corresponding property of the
	 * test object. `where` returns true if all the predicates return true, false
	 * otherwise.
	 *
	 * `where` is well suited to declaratively expressing constraints for other
	 * functions such as `filter` and `find`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Object
	 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.where({
	 *        a: R.equals('foo'),
	 *        b: R.complement(R.equals('bar')),
	 *        x: R.gt(__, 10),
	 *        y: R.lt(__, 20)
	 *      });
	 *
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
	 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
	 */
	module.exports = _curry2(function where(spec, testObj) {
	  for (var prop in spec) {
	    if (_has(prop, spec) && !spec[prop](testObj[prop])) {
	      return false;
	    }
	  }
	  return true;
	});


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(576);


/***/ },
/* 296 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(32);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(38);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactInstrumentation = __webpack_require__(20);
	
	var quoteAttributeValueForBrowser = __webpack_require__(625);
	var warning = __webpack_require__(6);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 299 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var LinkedValueUtils = __webpack_require__(96);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(25);
	
	var warning = __webpack_require__(6);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 301 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 302 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var invariant = __webpack_require__(5);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(584);
	
	var containsNode = __webpack_require__(337);
	var focusNode = __webpack_require__(114);
	var getActiveElement = __webpack_require__(115);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var DOMLazyTree = __webpack_require__(37);
	var DOMProperty = __webpack_require__(38);
	var React = __webpack_require__(40);
	var ReactBrowserEventEmitter = __webpack_require__(71);
	var ReactCurrentOwner = __webpack_require__(27);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDOMContainerInfo = __webpack_require__(578);
	var ReactDOMFeatureFlags = __webpack_require__(580);
	var ReactFeatureFlags = __webpack_require__(302);
	var ReactInstanceMap = __webpack_require__(54);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactMarkupChecksum = __webpack_require__(594);
	var ReactReconciler = __webpack_require__(39);
	var ReactUpdateQueue = __webpack_require__(99);
	var ReactUpdates = __webpack_require__(25);
	
	var emptyObject = __webpack_require__(44);
	var instantiateReactComponent = __webpack_require__(312);
	var invariant = __webpack_require__(5);
	var setInnerHTML = __webpack_require__(75);
	var shouldUpdateReactComponent = __webpack_require__(105);
	var warning = __webpack_require__(6);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var React = __webpack_require__(40);
	
	var invariant = __webpack_require__(5);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 307 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 309 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(306);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7),
	    _assign = __webpack_require__(8);
	
	var ReactCompositeComponent = __webpack_require__(575);
	var ReactEmptyComponent = __webpack_require__(301);
	var ReactHostComponent = __webpack_require__(303);
	
	var getNextDebugID = __webpack_require__(622);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(6);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 313 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	var escapeTextContentForBrowser = __webpack_require__(74);
	var setInnerHTML = __webpack_require__(75);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var ReactCurrentOwner = __webpack_require__(27);
	var REACT_ELEMENT_TYPE = __webpack_require__(590);
	
	var getIteratorFn = __webpack_require__(621);
	var invariant = __webpack_require__(5);
	var KeyEscapeUtils = __webpack_require__(95);
	var warning = __webpack_require__(6);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(42);
	
	var ReactCurrentOwner = __webpack_require__(27);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(6);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 317 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 320 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(34);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ },
/* 322 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppHOC = exports.App = undefined;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compose = __webpack_require__(109);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withState = __webpack_require__(110);
	
	var _withState2 = _interopRequireDefault(_withState);
	
	var _lifecycle = __webpack_require__(642);
	
	var _lifecycle2 = _interopRequireDefault(_lifecycle);
	
	var _AppMap = __webpack_require__(324);
	
	var _AppMap2 = _interopRequireDefault(_AppMap);
	
	var _Sidebar = __webpack_require__(326);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Spinner = __webpack_require__(327);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _ErrorBox = __webpack_require__(325);
	
	var _ErrorBox2 = _interopRequireDefault(_ErrorBox);
	
	var _constants = __webpack_require__(111);
	
	var _selectors = __webpack_require__(112);
	
	var _mockedData = __webpack_require__(364);
	
	var _mockedData2 = _interopRequireDefault(_mockedData);
	
	__webpack_require__(330);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var App = exports.App = function App(_ref) {
	  var data = _ref.data,
	      selected = _ref.selected,
	      setSelected = _ref.setSelected,
	      status = _ref.status,
	      showAll = _ref.showAll,
	      setShowAll = _ref.setShowAll;
	  return _react2.default.createElement(
	    'div',
	    { className: 'App' },
	    ['init', 'pending'].includes(status) && _react2.default.createElement(_Spinner2.default, null),
	    status === 'success' && data && _react2.default.createElement(
	      'div',
	      { className: 'layout' },
	      _react2.default.createElement(_Sidebar2.default, {
	        selected: selected,
	        setSelected: setSelected,
	        showAll: showAll,
	        setShowAll: setShowAll,
	        data: data
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'mapContainer' },
	        _react2.default.createElement(_AppMap2.default, {
	          selected: selected,
	          setSelected: setSelected,
	          showAll: showAll,
	          setShowAll: setShowAll,
	          data: data
	        }),
	        selected && _react2.default.createElement(
	          'div',
	          { className: 'info' },
	          _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            selected.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'subtitle' },
	            selected.region
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'subtitle' },
	            'Establecida ',
	            _react2.default.createElement(
	              'b',
	              null,
	              selected.stabilished
	            ),
	            ', es un ',
	            _react2.default.createElement(
	              'b',
	              null,
	              selected.type
	            ),
	            ', con ',
	            _react2.default.createElement(
	              'b',
	              null,
	              selected.integrants,
	              ' integrantes'
	            ),
	            '. Con una superficie aproximada de ',
	            _react2.default.createElement(
	              'b',
	              null,
	              selected.surface,
	              ' mts'
	            ),
	            '. La cobertura de electricidad es ',
	            _react2.default.createElement(
	              'b',
	              null,
	              selected.electricity
	            ),
	            ', la de iluminacion publica es ',
	            _react2.default.createElement(
	              'b',
	              null,
	              selected.street_electricity
	            ),
	            ', la de agua ',
	            _react2.default.createElement(
	              'b',
	              null,
	              selected.water
	            ),
	            ', la de cloacas ',
	            _react2.default.createElement(
	              'b',
	              null,
	              selected.sewer
	            ),
	            ' y la de gas ',
	            _react2.default.createElement(
	              'b',
	              null,
	              selected.gas
	            ),
	            '.'
	          )
	        )
	      )
	    ),
	    status === 'failure' && _react2.default.createElement(_ErrorBox2.default, { error: 'Hubo un error obteniendo los datos, por favor, recargue la pagina o intente nuevamente mas tarde' })
	  );
	};
	
	var AppHOC = exports.AppHOC = (0, _compose2.default)((0, _withState2.default)('selected', 'setSelected', null), (0, _withState2.default)('data', 'setData', (0, _selectors.shapeResponse)(_mockedData2.default)), (0, _withState2.default)('status', 'setStatus', 'success'), (0, _withState2.default)('showAll', 'setShowAll', false));
	
	exports.default = AppHOC(App);

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppMapHOC = exports.AppMap = undefined;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _googleMapReact = __webpack_require__(351);
	
	var _googleMapReact2 = _interopRequireDefault(_googleMapReact);
	
	var _compose = __webpack_require__(109);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps = __webpack_require__(639);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _withPropsOnChange = __webpack_require__(648);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _withState = __webpack_require__(110);
	
	var _withState2 = _interopRequireDefault(_withState);
	
	var _withHandlers = __webpack_require__(647);
	
	var _withHandlers2 = _interopRequireDefault(_withHandlers);
	
	var _pure = __webpack_require__(643);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _constants = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppMap = exports.AppMap = function AppMap(_ref) {
	  var center = _ref.center,
	      zoom = _ref.zoom,
	      style = _ref.style,
	      onGoogleApiLoaded = _ref.onGoogleApiLoaded;
	  return _react2.default.createElement(_googleMapReact2.default, {
	    center: center,
	    zoom: zoom,
	    style: style,
	    options: _constants.GET_MAP_OPTIONS,
	    yesIWantToUseGoogleMapApiInternals: true,
	    onGoogleApiLoaded: onGoogleApiLoaded
	  });
	};
	
	var AppMapHOC = exports.AppMapHOC = (0, _compose2.default)((0, _defaultProps2.default)({
	  center: _constants.MAP_CENTER,
	  style: _constants.DEFAULT_STYLE,
	  zoom: _constants.DEFAULT_ZOOM
	}), (0, _withState2.default)('library', 'setLibrary', null), (0, _withState2.default)('map', 'setMap', null), (0, _withState2.default)('polygon', 'setPolygon', null), (0, _withState2.default)('allPolygons', 'setAllPolygons', null), (0, _withHandlers2.default)({
	  onGoogleApiLoaded: function onGoogleApiLoaded(_ref2) {
	    var setLibrary = _ref2.setLibrary,
	        setMap = _ref2.setMap;
	    return function (_ref3) {
	      var map = _ref3.map,
	          maps = _ref3.maps;
	
	      setLibrary(maps);
	      setMap(map);
	    };
	  }
	}), (0, _withPropsOnChange2.default)(['selected'], function (_ref4) {
	  var map = _ref4.map,
	      library = _ref4.library,
	      selected = _ref4.selected,
	      setPolygon = _ref4.setPolygon,
	      polygon = _ref4.polygon;
	
	  if (library) {
	    if (polygon) {
	      polygon.setPath(selected.coordinates);
	    } else {
	      setPolygon(new library.Polygon({
	        paths: selected.coordinates,
	        fillColor: 'greenyellow',
	        strokeColor: 'yellow',
	        zIndex: 999,
	        map: map
	      }));
	    }
	  }
	}), (0, _withPropsOnChange2.default)(['selected'], function (_ref5) {
	  var map = _ref5.map,
	      library = _ref5.library,
	      selected = _ref5.selected;
	
	  if (library) {
	    centerPolygon(library, map, selected);
	  }
	}), (0, _withPropsOnChange2.default)(['showAll'], function (_ref6) {
	  var map = _ref6.map,
	      library = _ref6.library,
	      items = _ref6.data.items,
	      showAll = _ref6.showAll,
	      allPolygons = _ref6.allPolygons,
	      setAllPolygons = _ref6.setAllPolygons,
	      setSelected = _ref6.setSelected;
	
	  if (library) {
	    if (showAll) {
	      var polygons = [];
	      var bounds = new library.LatLngBounds();
	      items.map(function (item) {
	        var polygon = new library.Polygon({
	          paths: item.coordinates,
	          fillColor: 'palegreen',
	          strokeColor: 'green',
	          map: map
	        });
	        library.event.addListener(polygon, 'click', function () {
	          setSelected(item);
	        });
	        polygons.push(polygon);
	        centerPolygon(library, map, item, bounds);
	        setAllPolygons(polygons);
	      });
	    } else {
	      allPolygons.map(function (polygon) {
	        library.event.clearListeners(polygon, 'click');
	        polygon.setMap(null);
	      });
	    }
	  }
	}), (0, _withPropsOnChange2.default)(['showAll'], function (_ref7) {
	  var map = _ref7.map,
	      library = _ref7.library,
	      selected = _ref7.selected,
	      showAll = _ref7.showAll;
	
	  if (library) {
	    if (!showAll) {
	      centerPolygon(library, map, selected);
	    }
	  }
	}), _pure2.default);
	
	var centerPolygon = function centerPolygon(library, map, polygon, _bounds) {
	  if (!polygon) return;
	  var bounds = _bounds || new library.LatLngBounds();
	  polygon.coordinates.map(function (bound) {
	    bounds.extend(bound);
	  });
	  map.fitBounds(bounds);
	};
	
	exports.default = AppMapHOC(AppMap);

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorBox = function ErrorBox(_ref) {
	  var error = _ref.error;
	  return _react2.default.createElement(
	    'div',
	    { className: 'ErrorBox' },
	    _react2.default.createElement(
	      'p',
	      null,
	      error
	    )
	  );
	};
	
	exports.default = ErrorBox;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SidebarHOC = exports.Sidebar = undefined;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compose = __webpack_require__(109);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withState = __webpack_require__(110);
	
	var _withState2 = _interopRequireDefault(_withState);
	
	var _selectors = __webpack_require__(112);
	
	__webpack_require__(332);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sidebar = exports.Sidebar = function Sidebar(_ref) {
	  var items = _ref.data.items,
	      setSelected = _ref.setSelected,
	      selected = _ref.selected,
	      search = _ref.search,
	      setSearch = _ref.setSearch,
	      setShowAll = _ref.setShowAll,
	      showAll = _ref.showAll;
	  return _react2.default.createElement(
	    'div',
	    { className: 'Sidebar' },
	    _react2.default.createElement('input', {
	      className: 'search',
	      onChange: function onChange(_ref2) {
	        var value = _ref2.target.value;
	        return setSearch(value);
	      },
	      type: 'text'
	    }),
	    _react2.default.createElement(
	      'ul',
	      null,
	      !showAll ? _react2.default.createElement(
	        'li',
	        {
	          onClick: function onClick() {
	            return setShowAll(true);
	          },
	          className: 'all show'
	        },
	        _react2.default.createElement(
	          'span',
	          null,
	          'VER TODAS LAS VILLAS Y ASENTAMIENTOS'
	        )
	      ) : _react2.default.createElement(
	        'li',
	        {
	          onClick: function onClick() {
	            return setShowAll(false);
	          },
	          className: 'all hide'
	        },
	        _react2.default.createElement(
	          'span',
	          null,
	          'OCULTAR TODAS LAS VILLAS Y ASENTAMIENTOS'
	        )
	      ),
	      (0, _selectors.filterItemsByName)(search, items).map(function (_ref3, index) {
	        var result = _ref3.original;
	        return _react2.default.createElement(
	          'li',
	          {
	            key: index,
	            onClick: function onClick() {
	              return setSelected(result);
	            },
	            className: result === selected ? 'selected' : ''
	          },
	          _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            result.name
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { className: 'subtitle' },
	            result.region,
	            ' - ',
	            result.city
	          )
	        );
	      })
	    )
	  );
	};
	
	var SidebarHOC = exports.SidebarHOC = (0, _compose2.default)((0, _withState2.default)('search', 'setSearch', ''));
	
	exports.default = SidebarHOC(Sidebar);

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(333);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Spinner = function Spinner() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'Spinner' },
	    _react2.default.createElement('div', { className: 'squares' })
	  );
	};
	
	exports.default = Spinner;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(295);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(323);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(334);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	//
	// We store our EE objects in a plain object whose properties are event names.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// `~` to make sure that the built-in object properties are not overridden or
	// used as an attack vector.
	// We also assume that `Object.create(null)` is available when the event name
	// is an ES6 Symbol.
	//
	var prefix = typeof Object.create !== 'function' ? '~' : false;
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} [once=false] Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Hold the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var events = this._events
	    , names = []
	    , name;
	
	  if (!events) return names;
	
	  for (name in events) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @param {Boolean} exists We only need to know if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events && this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Mixed} context Only remove listeners matching this context.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return this;
	
	  var listeners = this._events[evt]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn) {
	      if (
	           listeners.fn !== fn
	        || (once && !listeners.once)
	        || (context && listeners.context !== context)
	      ) {
	        events.push(listeners);
	      }
	    } else {
	      for (var i = 0, length = listeners.length; i < length; i++) {
	        if (
	             listeners[i].fn !== fn
	          || (once && !listeners[i].once)
	          || (context && listeners[i].context !== context)
	        ) {
	          events.push(listeners[i]);
	        }
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[evt] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[prefix ? prefix + event : event];
	  else this._events = prefix ? {} : Object.create(null);
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ },
/* 330 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 331 */
330,
/* 332 */
330,
/* 333 */
330,
/* 334 */
330,
/* 335 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(335);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(345);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var createArrayFromMixed = __webpack_require__(338);
	var getMarkupWrap = __webpack_require__(340);
	var invariant = __webpack_require__(5);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 341 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 342 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(342);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 344 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(344);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 346 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Fuzzy
	 * https://github.com/myork/fuzzy
	 *
	 * Copyright (c) 2012 Matt York
	 * Licensed under the MIT license.
	 */
	
	(function() {
	
	var root = this;
	
	var fuzzy = {};
	
	// Use in node or in browser
	if (true) {
	  module.exports = fuzzy;
	} else {
	  root.fuzzy = fuzzy;
	}
	
	// Return all elements of `array` that have a fuzzy
	// match against `pattern`.
	fuzzy.simpleFilter = function(pattern, array) {
	  return array.filter(function(str) {
	    return fuzzy.test(pattern, str);
	  });
	};
	
	// Does `pattern` fuzzy match `str`?
	fuzzy.test = function(pattern, str) {
	  return fuzzy.match(pattern, str) !== null;
	};
	
	// If `pattern` matches `str`, wrap each matching character
	// in `opts.pre` and `opts.post`. If no match, return null
	fuzzy.match = function(pattern, str, opts) {
	  opts = opts || {};
	  var patternIdx = 0
	    , result = []
	    , len = str.length
	    , totalScore = 0
	    , currScore = 0
	    // prefix
	    , pre = opts.pre || ''
	    // suffix
	    , post = opts.post || ''
	    // String to compare against. This might be a lowercase version of the
	    // raw string
	    , compareString =  opts.caseSensitive && str || str.toLowerCase()
	    , ch;
	
	  pattern = opts.caseSensitive && pattern || pattern.toLowerCase();
	
	  // For each character in the string, either add it to the result
	  // or wrap in template if it's the next string in the pattern
	  for(var idx = 0; idx < len; idx++) {
	    ch = str[idx];
	    if(compareString[idx] === pattern[patternIdx]) {
	      ch = pre + ch + post;
	      patternIdx += 1;
	
	      // consecutive characters should increase the score more than linearly
	      currScore += 1 + currScore;
	    } else {
	      currScore = 0;
	    }
	    totalScore += currScore;
	    result[result.length] = ch;
	  }
	
	  // return rendered string if we have a match for every char
	  if(patternIdx === pattern.length) {
	    // if the string is an exact match with pattern, totalScore should be maxed
	    totalScore = (compareString === pattern) ? Infinity : totalScore;
	    return {rendered: result.join(''), score: totalScore};
	  }
	
	  return null;
	};
	
	// The normal entry point. Filters `arr` for matches against `pattern`.
	// It returns an array with matching values of the type:
	//
	//     [{
	//         string:   '<b>lah' // The rendered string
	//       , index:    2        // The index of the element in `arr`
	//       , original: 'blah'   // The original element in `arr`
	//     }]
	//
	// `opts` is an optional argument bag. Details:
	//
	//    opts = {
	//        // string to put before a matching character
	//        pre:     '<b>'
	//
	//        // string to put after matching character
	//      , post:    '</b>'
	//
	//        // Optional function. Input is an entry in the given arr`,
	//        // output should be the string to test `pattern` against.
	//        // In this example, if `arr = [{crying: 'koala'}]` we would return
	//        // 'koala'.
	//      , extract: function(arg) { return arg.crying; }
	//    }
	fuzzy.filter = function(pattern, arr, opts) {
	  if(!arr || arr.length === 0) {
	    return [];
	  }
	  if (typeof pattern !== 'string') {
	    return arr;
	  }
	  opts = opts || {};
	  return arr
	    .reduce(function(prev, element, idx, arr) {
	      var str = element;
	      if(opts.extract) {
	        str = opts.extract(element);
	      }
	      var rendered = fuzzy.match(pattern, str, opts);
	      if(rendered != null) {
	        prev[prev.length] = {
	            string: rendered.rendered
	          , score: rendered.score
	          , index: idx
	          , original: element
	        };
	      }
	      return prev;
	    }, [])
	
	    // Sort by score. Browsers are inconsistent wrt stable/unstable
	    // sorting, so force stable by using the index in the case of tie.
	    // See http://ofb.net/~sethml/is-sort-stable.html
	    .sort(function(a,b) {
	      var compare = b.score - a.score;
	      if(compare) return compare;
	      return a.index - b.index;
	    });
	};
	
	
	}());
	


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(295);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(34);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _marker_dispatcher = __webpack_require__(352);
	
	var _marker_dispatcher2 = _interopRequireDefault(_marker_dispatcher);
	
	var _google_map_map = __webpack_require__(349);
	
	var _google_map_map2 = _interopRequireDefault(_google_map_map);
	
	var _google_map_markers = __webpack_require__(116);
	
	var _google_map_markers2 = _interopRequireDefault(_google_map_markers);
	
	var _google_map_markers_prerender = __webpack_require__(350);
	
	var _google_map_markers_prerender2 = _interopRequireDefault(_google_map_markers_prerender);
	
	var _google_map_loader = __webpack_require__(360);
	
	var _google_map_loader2 = _interopRequireDefault(_google_map_loader);
	
	var _detect = __webpack_require__(354);
	
	var _detect2 = _interopRequireDefault(_detect);
	
	var _geo = __webpack_require__(356);
	
	var _geo2 = _interopRequireDefault(_geo);
	
	var _array_helper = __webpack_require__(353);
	
	var _array_helper2 = _interopRequireDefault(_array_helper);
	
	var _is_plain_object = __webpack_require__(358);
	
	var _is_plain_object2 = _interopRequireDefault(_is_plain_object);
	
	var _pick = __webpack_require__(362);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _raf = __webpack_require__(363);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _log = __webpack_require__(361);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _isNumber = __webpack_require__(357);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _omit = __webpack_require__(119);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _detectElementResize = __webpack_require__(355);
	
	var _detectElementResize2 = _interopRequireDefault(_detectElementResize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var kEPS = 0.00001;
	var K_GOOGLE_TILE_SIZE = 256;
	// real minZoom calculated here _getMinZoom
	var K_IDLE_TIMEOUT = 100;
	var K_IDLE_CLICK_TIMEOUT = 300;
	var DEFAULT_MIN_ZOOM = 3;
	
	function defaultOptions_() /* maps */{
	  return {
	    overviewMapControl: false,
	    streetViewControl: false,
	    rotateControl: true,
	    mapTypeControl: false,
	    // disable poi
	    styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }],
	    minZoom: DEFAULT_MIN_ZOOM };
	}
	
	var latLng2Obj = function latLng2Obj(latLng) {
	  return (0, _is_plain_object2.default)(latLng) ? latLng : { lat: latLng[0], lng: latLng[1] };
	};
	
	var GoogleMap = function (_Component) {
	  _inherits(GoogleMap, _Component);
	
	  // eslint-disable-line
	
	  function GoogleMap(props) {
	    _classCallCheck(this, GoogleMap);
	
	    var _this = _possibleConstructorReturn(this, (GoogleMap.__proto__ || Object.getPrototypeOf(GoogleMap)).call(this, props));
	
	    _this._getMinZoom = function () {
	      if (_this.geoService_.getWidth() > 0 || _this.geoService_.getHeight() > 0) {
	        var tilesPerWidth = Math.ceil(_this.geoService_.getWidth() / K_GOOGLE_TILE_SIZE) + 2;
	        var tilesPerHeight = Math.ceil(_this.geoService_.getHeight() / K_GOOGLE_TILE_SIZE) + 2;
	        var maxTilesPerDim = Math.max(tilesPerWidth, tilesPerHeight);
	        return Math.ceil((0, _log2.default)(maxTilesPerDim));
	      }
	      return DEFAULT_MIN_ZOOM;
	    };
	
	    _this._computeMinZoom = function (minZoomOverride, minZoom) {
	      if (minZoomOverride) {
	        return minZoom || DEFAULT_MIN_ZOOM;
	      }
	      return _this._getMinZoom();
	    };
	
	    _this._mapDomResizeCallback = function () {
	      _this.resetSizeOnIdle_ = true;
	      if (_this.maps_) {
	        var originalCenter = _this.map_.getCenter();
	        _this.maps_.event.trigger(_this.map_, 'resize');
	        _this.map_.setCenter(originalCenter);
	      }
	    };
	
	    _this._setLayers = function (layerTypes) {
	      layerTypes.forEach(function (layerType) {
	        _this.layers_[layerType] = new _this.maps_[layerType]();
	        _this.layers_[layerType].setMap(_this.map_);
	      });
	    };
	
	    _this._initMap = function () {
	      // only initialize the map once
	      if (_this.initialized_) {
	        return;
	      }
	      _this.initialized_ = true;
	
	      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
	      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);
	
	      _this._onBoundsChanged(); // now we can calculate map bounds center etc...
	
	      var bootstrapURLKeys = _extends({}, _this.props.apiKey && { key: _this.props.apiKey }, _this.props.bootstrapURLKeys);
	
	      _this.props.googleMapLoader(bootstrapURLKeys).then(function (maps) {
	        if (!_this.mounted_) {
	          return;
	        }
	
	        var centerLatLng = _this.geoService_.getCenter();
	
	        var propsOptions = {
	          zoom: _this.props.zoom || _this.props.defaultZoom,
	          center: new maps.LatLng(centerLatLng.lat, centerLatLng.lng)
	        };
	
	        // prevent to exapose full api
	        // next props must be exposed (console.log(Object.keys(pick(maps, isPlainObject))))
	        // "Animation", "ControlPosition", "MapTypeControlStyle", "MapTypeId",
	        // "NavigationControlStyle", "ScaleControlStyle", "StrokePosition",
	        // "SymbolPath", "ZoomControlStyle",
	        // "event", "DirectionsStatus", "DirectionsTravelMode", "DirectionsUnitSystem",
	        // "DistanceMatrixStatus",
	        // "DistanceMatrixElementStatus", "ElevationStatus", "GeocoderLocationType",
	        // "GeocoderStatus", "KmlLayerStatus",
	        // "MaxZoomStatus", "StreetViewStatus", "TransitMode", "TransitRoutePreference",
	        // "TravelMode", "UnitSystem"
	        var mapPlainObjects = (0, _pick2.default)(maps, _is_plain_object2.default);
	        var options = typeof _this.props.options === 'function' ? _this.props.options(mapPlainObjects) : _this.props.options;
	        var defaultOptions = defaultOptions_(mapPlainObjects);
	
	        var draggableOptions = _this.props.draggable !== undefined && { draggable: _this.props.draggable };
	
	        var minZoom = _this._computeMinZoom(options.minZoomOverride, options.minZoom);
	        _this.minZoom_ = minZoom;
	
	        var preMapOptions = _extends({}, defaultOptions, {
	          minZoom: minZoom
	        }, options, propsOptions);
	
	        _this.defaultDraggableOption_ = preMapOptions.draggable !== undefined ? preMapOptions.draggable : _this.defaultDraggableOption_;
	
	        var mapOptions = _extends({}, preMapOptions, draggableOptions);
	
	        mapOptions.minZoom = _this._checkMinZoom(mapOptions.minZoom, minZoom);
	
	        var map = new maps.Map(_reactDom2.default.findDOMNode(_this.refs.google_map_dom), mapOptions);
	
	        _this.map_ = map;
	        _this.maps_ = maps;
	
	        _this._setLayers(_this.props.layerTypes);
	
	        // render in overlay
	        var this_ = _this;
	        var overlay = _this.overlay_ = Object.assign(new maps.OverlayView(), {
	          onAdd: function onAdd() {
	            var K_MAX_WIDTH = typeof screen !== 'undefined' ? screen.width + 'px' : '2000px';
	            var K_MAX_HEIGHT = typeof screen !== 'undefined' ? screen.height + 'px' : '2000px';
	
	            var div = document.createElement('div');
	            this.div = div;
	            div.style.backgroundColor = 'transparent';
	            div.style.position = 'absolute';
	            div.style.left = '0px';
	            div.style.top = '0px';
	            div.style.width = K_MAX_WIDTH; // prevents some chrome draw defects
	            div.style.height = K_MAX_HEIGHT;
	
	            var panes = this.getPanes();
	            panes.overlayMouseTarget.appendChild(div);
	
	            _reactDom2.default.unstable_renderSubtreeIntoContainer(this_, _react2.default.createElement(_google_map_markers2.default, {
	              experimental: this_.props.experimental,
	              onChildClick: this_._onChildClick,
	              onChildMouseDown: this_._onChildMouseDown,
	              onChildMouseEnter: this_._onChildMouseEnter,
	              onChildMouseLeave: this_._onChildMouseLeave,
	              geoService: this_.geoService_,
	              projectFromLeftTop: true,
	              distanceToMouse: this_.props.distanceToMouse,
	              getHoverDistance: this_._getHoverDistance,
	              dispatcher: this_.markersDispatcher_
	            }), div,
	            // remove prerendered markers
	            function () {
	              return this_.setState({ overlayCreated: true });
	            });
	          },
	          onRemove: function onRemove() {
	            _reactDom2.default.unmountComponentAtNode(this.div);
	          },
	          draw: function draw() {
	            var div = overlay.div;
	            var overlayProjection = overlay.getProjection();
	            var bounds = map.getBounds();
	            var ne = bounds.getNorthEast();
	            var sw = bounds.getSouthWest();
	            var ptx = overlayProjection.fromLatLngToDivPixel(new maps.LatLng(ne.lat(), sw.lng()));
	
	            // need round for safari still can't find what need for firefox
	            var ptxRounded = (0, _detect2.default)().isSafari ? { x: Math.round(ptx.x), y: Math.round(ptx.y) } : { x: ptx.x, y: ptx.y };
	
	            this_.updateCounter_++;
	            this_._onBoundsChanged(map, maps, !this_.props.debounced);
	
	            if (!this_.googleApiLoadedCalled_) {
	              this_._onGoogleApiLoaded({ map: map, maps: maps });
	              this_.googleApiLoadedCalled_ = true;
	            }
	
	            div.style.left = ptxRounded.x + 'px';
	            div.style.top = ptxRounded.y + 'px';
	            if (this_.markersDispatcher_) {
	              this_.markersDispatcher_.emit('kON_CHANGE');
	            }
	          }
	        });
	
	        overlay.setMap(map);
	
	        maps.event.addListener(map, 'zoom_changed', function () {
	          // recalc position at zoom start
	          if (this_.geoService_.getZoom() !== map.getZoom()) {
	            if (!this_.zoomAnimationInProgress_) {
	              this_.zoomAnimationInProgress_ = true;
	              this_._onZoomAnimationStart();
	            }
	
	            var TIMEOUT_ZOOM = 300;
	
	            if (new Date().getTime() - _this.zoomControlClickTime_ < TIMEOUT_ZOOM) {
	              // there is strange Google Map Api behavior in chrome when zoom animation of map
	              // is started only on second raf call, if was click on zoom control
	              // or +- keys pressed, so i wait for two rafs before change state
	
	              // this does not fully prevent animation jump
	              // but reduce it's occurence probability
	              (0, _raf2.default)(function () {
	                return (0, _raf2.default)(function () {
	                  this_.updateCounter_++;
	                  this_._onBoundsChanged(map, maps);
	                });
	              });
	            } else {
	              this_.updateCounter_++;
	              this_._onBoundsChanged(map, maps);
	            }
	          }
	        });
	
	        maps.event.addListener(map, 'idle', function () {
	          if (_this.resetSizeOnIdle_) {
	            _this._setViewSize();
	            var currMinZoom = _this._computeMinZoom(_this.props.options.minZoomOverride, _this.props.options.minZoom);
	
	            if (currMinZoom !== _this.minZoom_) {
	              _this.minZoom_ = currMinZoom;
	              map.setOptions({ minZoom: currMinZoom });
	            }
	
	            _this.resetSizeOnIdle_ = false;
	          }
	
	          if (this_.zoomAnimationInProgress_) {
	            this_.zoomAnimationInProgress_ = false;
	            this_._onZoomAnimationEnd();
	          }
	
	          var div = overlay.div;
	          var overlayProjection = overlay.getProjection();
	          var bounds = map.getBounds();
	          var ne = bounds.getNorthEast();
	          var sw = bounds.getSouthWest();
	          var ptx = overlayProjection.fromLatLngToDivPixel(new maps.LatLng(ne.lat(), sw.lng()));
	          // need round for safari still can't find what need for firefox
	          var ptxRounded = (0, _detect2.default)().isSafari ? { x: Math.round(ptx.x), y: Math.round(ptx.y) } : { x: ptx.x, y: ptx.y };
	
	          this_.updateCounter_++;
	          this_._onBoundsChanged(map, maps);
	
	          if (_this.mouse_) {
	            var latLng = _this.geoService_.unproject(_this.mouse_, true);
	            _this.mouse_.lat = latLng.lat;
	            _this.mouse_.lng = latLng.lng;
	          }
	
	          _this._onChildMouseMove();
	
	          this_.dragTime_ = 0;
	          div.style.left = ptxRounded.x + 'px';
	          div.style.top = ptxRounded.y + 'px';
	          if (this_.markersDispatcher_) {
	            this_.markersDispatcher_.emit('kON_CHANGE');
	            if (this_.fireMouseEventOnIdle_) {
	              this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	            }
	          }
	        });
	
	        maps.event.addListener(map, 'mouseover', function () {
	          // has advantage over div MouseLeave
	          this_.mouseInMap_ = true;
	        });
	
	        // an alternative way to know the mouse is back within the map
	        // This would not fire when clicking/interacting with google maps
	        // own on-map countrols+markers. This handles an edge case for touch devices
	        // + 'draggable:false' custom option. See #332 for more details.
	        maps.event.addListener(map, 'click', function () {
	          this_.mouseInMap_ = true;
	        });
	
	        maps.event.addListener(map, 'mouseout', function () {
	          // has advantage over div MouseLeave
	          this_.mouseInMap_ = false;
	          this_.mouse_ = null;
	          this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	        });
	
	        maps.event.addListener(map, 'drag', function () {
	          this_.dragTime_ = new Date().getTime();
	          this_._onDrag();
	        });
	        // user choosing satellite vs roads, etc
	        maps.event.addListener(map, 'maptypeid_changed', function () {
	          this_._onMapTypeIdChange(map.getMapTypeId());
	        });
	      }).catch(function (e) {
	        console.error(e); // eslint-disable-line no-console
	        throw e;
	      });
	    };
	
	    _this._onGoogleApiLoaded = function () {
	      if (_this.props.onGoogleApiLoaded) {
	        var _this$props;
	
	        if (false) {
	          console.warn('GoogleMap: ' + // eslint-disable-line
	          'Usage of internal api objects is dangerous ' + 'and can cause a lot of issues.\n' + 'To hide this warning add yesIWantToUseGoogleMapApiInternals={true} ' + 'to <GoogleMap instance');
	        }
	
	        (_this$props = _this.props).onGoogleApiLoaded.apply(_this$props, arguments);
	      }
	    };
	
	    _this._getHoverDistance = function () {
	      return _this.props.hoverDistance;
	    };
	
	    _this._onDrag = function () {
	      var _this$props2;
	
	      return _this.props.onDrag && (_this$props2 = _this.props).onDrag.apply(_this$props2, arguments);
	    };
	
	    _this._onMapTypeIdChange = function () {
	      var _this$props3;
	
	      return _this.props.onMapTypeIdChange && (_this$props3 = _this.props).onMapTypeIdChange.apply(_this$props3, arguments);
	    };
	
	    _this._onZoomAnimationStart = function () {
	      var _this$props4;
	
	      return _this.props.onZoomAnimationStart && (_this$props4 = _this.props).onZoomAnimationStart.apply(_this$props4, arguments);
	    };
	
	    _this._onZoomAnimationEnd = function () {
	      var _this$props5;
	
	      return _this.props.onZoomAnimationEnd && (_this$props5 = _this.props).onZoomAnimationEnd.apply(_this$props5, arguments);
	    };
	
	    _this._onChildClick = function () {
	      if (_this.props.onChildClick) {
	        var _this$props6;
	
	        return (_this$props6 = _this.props).onChildClick.apply(_this$props6, arguments);
	      }
	      return undefined;
	    };
	
	    _this._onChildMouseDown = function (hoverKey, childProps) {
	      _this.childMouseDownArgs_ = [hoverKey, childProps];
	      if (_this.props.onChildMouseDown) {
	        _this.props.onChildMouseDown(hoverKey, childProps, _extends({}, _this.mouse_));
	      }
	    };
	
	    _this._onChildMouseUp = function () {
	      if (_this.childMouseDownArgs_) {
	        if (_this.props.onChildMouseUp) {
	          var _this$props7;
	
	          (_this$props7 = _this.props).onChildMouseUp.apply(_this$props7, _toConsumableArray(_this.childMouseDownArgs_).concat([_extends({}, _this.mouse_)]));
	        }
	        _this.childMouseDownArgs_ = null;
	        _this.childMouseUpTime_ = new Date().getTime();
	      }
	    };
	
	    _this._onChildMouseMove = function () {
	      if (_this.childMouseDownArgs_) {
	        if (_this.props.onChildMouseMove) {
	          var _this$props8;
	
	          (_this$props8 = _this.props).onChildMouseMove.apply(_this$props8, _toConsumableArray(_this.childMouseDownArgs_).concat([_extends({}, _this.mouse_)]));
	        }
	      }
	    };
	
	    _this._onChildMouseEnter = function () {
	      if (_this.props.onChildMouseEnter) {
	        var _this$props9;
	
	        return (_this$props9 = _this.props).onChildMouseEnter.apply(_this$props9, arguments);
	      }
	      return undefined;
	    };
	
	    _this._onChildMouseLeave = function () {
	      if (_this.props.onChildMouseLeave) {
	        var _this$props10;
	
	        return (_this$props10 = _this.props).onChildMouseLeave.apply(_this$props10, arguments);
	      }
	      return undefined;
	    };
	
	    _this._setViewSize = function () {
	      if (!_this.mounted_) return;
	
	      var mapDom = _reactDom2.default.findDOMNode(_this.refs.google_map_dom);
	      _this.geoService_.setViewSize(mapDom.clientWidth, mapDom.clientHeight);
	      _this._onBoundsChanged();
	    };
	
	    _this._onWindowResize = function () {
	      _this.resetSizeOnIdle_ = true;
	    };
	
	    _this._onMapMouseMove = function (e) {
	      if (!_this.mouseInMap_) return;
	
	      var currTime = new Date().getTime();
	      var K_RECALC_CLIENT_RECT_MS = 50;
	
	      if (currTime - _this.mouseMoveTime_ > K_RECALC_CLIENT_RECT_MS) {
	        _this.boundingRect_ = e.currentTarget.getBoundingClientRect();
	      }
	      _this.mouseMoveTime_ = currTime;
	
	      var mousePosX = e.clientX - _this.boundingRect_.left;
	      var mousePosY = e.clientY - _this.boundingRect_.top;
	
	      if (!_this.mouse_) {
	        _this.mouse_ = { x: 0, y: 0, lat: 0, lng: 0 };
	      }
	
	      _this.mouse_.x = mousePosX;
	      _this.mouse_.y = mousePosY;
	
	      var latLng = _this.geoService_.unproject(_this.mouse_, true);
	      _this.mouse_.lat = latLng.lat;
	      _this.mouse_.lng = latLng.lng;
	
	      _this._onChildMouseMove();
	
	      if (currTime - _this.dragTime_ < K_IDLE_TIMEOUT) {
	        _this.fireMouseEventOnIdle_ = true;
	      } else {
	        _this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	        _this.fireMouseEventOnIdle_ = false;
	      }
	    };
	
	    _this._onClick = function () {
	      var _this$props11;
	
	      return _this.props.onClick && !_this.childMouseDownArgs_ && new Date().getTime() - _this.childMouseUpTime_ > K_IDLE_CLICK_TIMEOUT && _this.dragTime_ === 0 && (_this$props11 = _this.props).onClick.apply(_this$props11, arguments);
	    };
	
	    _this._onMapClick = function (event) {
	      if (_this.markersDispatcher_) {
	        // support touch events and recalculate mouse position on click
	        _this._onMapMouseMove(event);
	        var currTime = new Date().getTime();
	        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
	          if (_this.mouse_) {
	            _this._onClick(_extends({}, _this.mouse_, {
	              event: event
	            }));
	          }
	
	          _this.markersDispatcher_.emit('kON_CLICK', event);
	        }
	      }
	    };
	
	    _this._onMapMouseDownNative = function (event) {
	      if (!_this.mouseInMap_) return;
	
	      _this._onMapMouseDown(event);
	    };
	
	    _this._onMapMouseDown = function (event) {
	      if (_this.markersDispatcher_) {
	        var currTime = new Date().getTime();
	        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
	          // Hovered marker detected at mouse move could be deleted at mouse down time
	          // so it will be good to force hovered marker recalculation
	          _this._onMapMouseMove(event);
	          _this.markersDispatcher_.emit('kON_MDOWN', event);
	        }
	      }
	    };
	
	    _this._onMapMouseDownCapture = function () {
	      if ((0, _detect2.default)().isChrome) {
	        // to fix strange zoom in chrome
	        if (!_this.mouse_) {
	          _this.zoomControlClickTime_ = new Date().getTime();
	        }
	      }
	    };
	
	    _this._onKeyDownCapture = function () {
	      if ((0, _detect2.default)().isChrome) {
	        _this.zoomControlClickTime_ = new Date().getTime();
	      }
	    };
	
	    _this._isCenterDefined = function (center) {
	      return center && ((0, _is_plain_object2.default)(center) && (0, _isNumber2.default)(center.lat) && (0, _isNumber2.default)(center.lng) || center.length === 2 && (0, _isNumber2.default)(center[0]) && (0, _isNumber2.default)(center[1]));
	    };
	
	    _this._onBoundsChanged = function (map, maps, callExtBoundsChange) {
	      if (map) {
	        var gmC = map.getCenter();
	        _this.geoService_.setView([gmC.lat(), gmC.lng()], map.getZoom(), 0);
	      }
	
	      if ((_this.props.onChange || _this.props.onBoundsChange) && _this.geoService_.canProject()) {
	        var zoom = _this.geoService_.getZoom();
	        var bounds = _this.geoService_.getBounds();
	        var centerLatLng = _this.geoService_.getCenter();
	
	        if (!(0, _array_helper2.default)(bounds, _this.prevBounds_, kEPS)) {
	          if (callExtBoundsChange !== false) {
	            var marginBounds = _this.geoService_.getBounds(_this.props.margin);
	            if (_this.props.onBoundsChange) {
	              _this.props.onBoundsChange(_this.centerIsObject_ ? _extends({}, centerLatLng) : [centerLatLng.lat, centerLatLng.lng], zoom, bounds, marginBounds);
	            }
	
	            if (_this.props.onChange) {
	              _this.props.onChange({
	                center: _extends({}, centerLatLng),
	                zoom: zoom,
	                bounds: {
	                  nw: {
	                    lat: bounds[0],
	                    lng: bounds[1]
	                  },
	                  se: {
	                    lat: bounds[2],
	                    lng: bounds[3]
	                  },
	                  sw: {
	                    lat: bounds[4],
	                    lng: bounds[5]
	                  },
	                  ne: {
	                    lat: bounds[6],
	                    lng: bounds[7]
	                  }
	                },
	                marginBounds: {
	                  nw: {
	                    lat: marginBounds[0],
	                    lng: marginBounds[1]
	                  },
	                  se: {
	                    lat: marginBounds[2],
	                    lng: marginBounds[3]
	                  },
	                  sw: {
	                    lat: marginBounds[4],
	                    lng: marginBounds[5]
	                  },
	                  ne: {
	                    lat: marginBounds[6],
	                    lng: marginBounds[7]
	                  }
	                },
	
	                size: _this.geoService_.hasSize() ? {
	                  width: _this.geoService_.getWidth(),
	                  height: _this.geoService_.getHeight()
	                } : {
	                  width: 0,
	                  height: 0
	                }
	              });
	            }
	
	            _this.prevBounds_ = bounds;
	          }
	        }
	      }
	    };
	
	    _this.mounted_ = false;
	    _this.initialized_ = false;
	    _this.googleApiLoadedCalled_ = false;
	
	    _this.map_ = null;
	    _this.maps_ = null;
	    _this.prevBounds_ = null;
	
	    _this.layers_ = {};
	
	    _this.mouse_ = null;
	    _this.mouseMoveTime_ = 0;
	    _this.boundingRect_ = null;
	    _this.mouseInMap_ = true;
	
	    _this.dragTime_ = 0;
	    _this.fireMouseEventOnIdle_ = false;
	    _this.updateCounter_ = 0;
	
	    _this.markersDispatcher_ = new _marker_dispatcher2.default(_this);
	    _this.geoService_ = new _geo2.default(K_GOOGLE_TILE_SIZE);
	    _this.centerIsObject_ = (0, _is_plain_object2.default)(_this.props.center);
	
	    _this.minZoom_ = DEFAULT_MIN_ZOOM;
	    _this.defaultDraggableOption_ = true;
	
	    _this.zoomControlClickTime_ = 0;
	
	    _this.childMouseDownArgs_ = null;
	    _this.childMouseUpTime_ = 0;
	
	    if (false) {
	      if (_this.props.apiKey) {
	        console.warn('GoogleMap: ' + // eslint-disable-line no-console
	        'apiKey is deprecated, use ' + 'bootstrapURLKeys={{key: YOUR_API_KEY}} instead.');
	      }
	
	      if (_this.props.onBoundsChange) {
	        console.warn('GoogleMap: ' + // eslint-disable-line no-console
	        'onBoundsChange is deprecated, use ' + 'onChange({center, zoom, bounds, ...other}) instead.');
	      }
	
	      if (_this.props.center === undefined && _this.props.defaultCenter === undefined) {
	        console.warn('GoogleMap: center or defaultCenter' + // eslint-disable-line no-console
	        'property must be defined');
	      }
	
	      if (_this.props.zoom === undefined && _this.props.defaultZoom === undefined) {
	        console.warn('GoogleMap: zoom or defaultZoom' + // eslint-disable-line no-console
	        'property must be defined');
	      }
	    }
	
	    if (_this._isCenterDefined(_this.props.center || _this.props.defaultCenter)) {
	      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
	      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);
	    }
	
	    _this.zoomAnimationInProgress_ = false;
	
	    _this.state = {
	      overlayCreated: false
	    };
	    return _this;
	  }
	
	  _createClass(GoogleMap, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.mounted_ = true;
	      window.addEventListener('resize', this._onWindowResize);
	      window.addEventListener('keydown', this._onKeyDownCapture, true);
	      var mapDom = _reactDom2.default.findDOMNode(this.refs.google_map_dom);
	      // gmap can't prevent map drag if mousedown event already occured
	      // the only workaround I find is prevent mousedown native browser event
	      _reactDom2.default.findDOMNode(this.refs.google_map_dom).addEventListener('mousedown', this._onMapMouseDownNative, true);
	
	      window.addEventListener('mouseup', this._onChildMouseUp, false);
	
	      var bootstrapURLKeys = _extends({}, this.props.apiKey && { key: this.props.apiKey }, this.props.bootstrapURLKeys);
	
	      this.props.googleMapLoader(bootstrapURLKeys); // we can start load immediatly
	
	      setTimeout(function () {
	        // to detect size
	        _this2._setViewSize();
	        if (_this2._isCenterDefined(_this2.props.center || _this2.props.defaultCenter)) {
	          _this2._initMap();
	        }
	      }, 0, this);
	      if (this.props.resetBoundsOnResize) {
	        var that = this;
	        _detectElementResize2.default.addResizeListener(mapDom, that._mapDomResizeCallback);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      if (false) {
	        if (this.props.defaultCenter !== nextProps.defaultCenter) {
	          console.warn('GoogleMap: defaultCenter prop changed. ' + // eslint-disable-line
	          'You can\'t change default props.');
	        }
	
	        if (this.props.defaultZoom !== nextProps.defaultZoom) {
	          console.warn('GoogleMap: defaultZoom prop changed. ' + // eslint-disable-line
	          'You can\'t change default props.');
	        }
	      }
	
	      if (!this._isCenterDefined(this.props.center) && this._isCenterDefined(nextProps.center)) {
	        setTimeout(function () {
	          return _this3._initMap();
	        }, 0);
	      }
	
	      if (this.map_) {
	        var centerLatLng = this.geoService_.getCenter();
	        if (this._isCenterDefined(nextProps.center)) {
	          var nextPropsCenter = latLng2Obj(nextProps.center);
	          var currCenter = this._isCenterDefined(this.props.center) ? latLng2Obj(this.props.center) : null;
	
	          if (!currCenter || Math.abs(nextPropsCenter.lat - currCenter.lat) + Math.abs(nextPropsCenter.lng - currCenter.lng) > kEPS) {
	            if (Math.abs(nextPropsCenter.lat - centerLatLng.lat) + Math.abs(nextPropsCenter.lng - centerLatLng.lng) > kEPS) {
	              this.map_.panTo({ lat: nextPropsCenter.lat, lng: nextPropsCenter.lng });
	            }
	          }
	        }
	
	        if (nextProps.zoom !== undefined) {
	          // if zoom chaged by user
	          if (Math.abs(nextProps.zoom - this.props.zoom) > 0) {
	            this.map_.setZoom(nextProps.zoom);
	          }
	        }
	
	        if (this.props.draggable !== undefined && nextProps.draggable === undefined) {
	          // reset to default
	          this.map_.setOptions({ draggable: this.defaultDraggableOption_ });
	        } else if (this.props.draggable !== nextProps.draggable) {
	          // also prevent this on window 'mousedown' event to prevent map move
	          this.map_.setOptions({ draggable: nextProps.draggable });
	        }
	
	        // use shallowEqual to try avoid calling map._setOptions if only the ref changes
	        if (nextProps.options !== undefined && !(0, _shallowEqual2.default)(this.props.options, nextProps.options)) {
	          var mapPlainObjects = (0, _pick2.default)(this.maps_, _is_plain_object2.default);
	          var options = typeof nextProps.options === 'function' ? nextProps.options(mapPlainObjects) : nextProps.options;
	          // remove zoom, center and draggable options as these are managed by google-maps-react
	          options = (0, _omit2.default)(options, ['zoom', 'center', 'draggable']);
	
	          if (options.hasOwnProperty('minZoom')) {
	            var minZoom = this._computeMinZoom(options.minZoomOverride, options.minZoom);
	            options.minZoom = this._checkMinZoom(options.minZoom, minZoom);
	          }
	
	          this.map_.setOptions(options);
	        }
	
	        if (nextProps.layerTypes !== this.props.layerTypes) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = Object.keys(this.layers_)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var layerKey = _step.value;
	
	              this.layers_[layerKey].setMap(null);
	              delete this.layers_[layerKey];
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          this._setLayers(nextProps.layerTypes);
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      // draggable does not affect inner components
	      return !(0, _shallowEqual2.default)((0, _omit2.default)(this.props, ['draggable']), (0, _omit2.default)(nextProps, ['draggable'])) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.markersDispatcher_.emit('kON_CHANGE');
	
	      if (this.props.hoverDistance !== prevProps.hoverDistance) {
	        this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted_ = false;
	      var mapDom = _reactDom2.default.findDOMNode(this.refs.google_map_dom);
	      window.removeEventListener('resize', this._onWindowResize);
	      window.removeEventListener('keydown', this._onKeyDownCapture);
	      mapDom.removeEventListener('mousedown', this._onMapMouseDownNative, true);
	      window.removeEventListener('mouseup', this._onChildMouseUp, false);
	      if (this.props.resetBoundsOnResize) {
	        _detectElementResize2.default.removeResizeListener(mapDom, this._mapDomResizeCallback);
	      }
	
	      if (this.overlay_) {
	        // this triggers overlay_.onRemove(), which will unmount the <GoogleMapMarkers/>
	        this.overlay_.setMap(null);
	      }
	
	      if (this.maps_ && this.map_) {
	        // fix google, as otherwise listeners works even without map
	        this.map_.setOptions({ scrollwheel: false });
	        this.maps_.event.clearInstanceListeners(this.map_);
	      }
	
	      this.map_ = null;
	      this.maps_ = null;
	      this.markersDispatcher_.dispose();
	
	      this.resetSizeOnIdle_ = false;
	
	      delete this.map_;
	      delete this.markersDispatcher_;
	    }
	    // calc minZoom if map size available
	    // it's better to not set minZoom less than this calculation gives
	    // otherwise there is no homeomorphism between screen coordinates and map
	    // (one map coordinate can have different screen coordinates)
	
	  }, {
	    key: '_checkMinZoom',
	    value: function _checkMinZoom(zoom, minZoom) {
	      if (false) {
	        if (zoom < minZoom) {
	          console.warn('GoogleMap: ' + // eslint-disable-line
	          'minZoom option is less than recommended ' + 'minZoom option for your map sizes.\n' + 'overrided to value ' + minZoom);
	        }
	      }
	
	      if (minZoom < zoom) {
	        return zoom;
	      }
	      return minZoom;
	    }
	
	    // this method works only if this.props.onChildMouseDown was called
	
	
	    // this method works only if this.props.onChildMouseDown was called
	
	
	    // K_IDLE_CLICK_TIMEOUT - looks like 300 is enough
	
	
	    // gmap can't prevent map drag if mousedown event already occured
	    // the only workaround I find is prevent mousedown native browser event
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var mapMarkerPrerender = !this.state.overlayCreated ? _react2.default.createElement(_google_map_markers_prerender2.default, {
	        experimental: this.props.experimental,
	        onChildClick: this._onChildClick,
	        onChildMouseDown: this._onChildMouseDown,
	        onChildMouseEnter: this._onChildMouseEnter,
	        onChildMouseLeave: this._onChildMouseLeave,
	        geoService: this.geoService_,
	        projectFromLeftTop: false,
	        distanceToMouse: this.props.distanceToMouse,
	        getHoverDistance: this._getHoverDistance,
	        dispatcher: this.markersDispatcher_
	      }) : null;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: this.props.style,
	          onMouseMove: this._onMapMouseMove,
	          onMouseDownCapture: this._onMapMouseDownCapture,
	          onClick: this._onMapClick
	        },
	        _react2.default.createElement(_google_map_map2.default, { ref: 'google_map_dom' }),
	        mapMarkerPrerender
	      );
	    }
	  }]);
	
	  return GoogleMap;
	}(_react.Component);
	
	GoogleMap.propTypes = {
	  apiKey: _react.PropTypes.string,
	  bootstrapURLKeys: _react.PropTypes.any,
	
	  defaultCenter: _react2.default.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.shape({
	    lat: _react.PropTypes.number,
	    lng: _react.PropTypes.number
	  })]),
	  center: _react2.default.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.shape({
	    lat: _react.PropTypes.number,
	    lng: _react.PropTypes.number
	  })]),
	  defaultZoom: _react.PropTypes.number,
	  zoom: _react.PropTypes.number,
	  onBoundsChange: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	  onChildClick: _react.PropTypes.func,
	  onChildMouseDown: _react.PropTypes.func,
	  onChildMouseUp: _react.PropTypes.func,
	  onChildMouseMove: _react.PropTypes.func,
	  onChildMouseEnter: _react.PropTypes.func,
	  onChildMouseLeave: _react.PropTypes.func,
	  onZoomAnimationStart: _react.PropTypes.func,
	  onZoomAnimationEnd: _react.PropTypes.func,
	  onDrag: _react.PropTypes.func,
	  onMapTypeIdChange: _react.PropTypes.func,
	  options: _react.PropTypes.any,
	  distanceToMouse: _react.PropTypes.func,
	  hoverDistance: _react.PropTypes.number,
	  debounced: _react.PropTypes.bool,
	  margin: _react.PropTypes.array,
	  googleMapLoader: _react.PropTypes.any,
	  onGoogleApiLoaded: _react.PropTypes.func,
	  yesIWantToUseGoogleMapApiInternals: _react.PropTypes.bool,
	  draggable: _react.PropTypes.bool,
	  style: _react.PropTypes.any,
	  resetBoundsOnResize: _react.PropTypes.bool,
	  layerTypes: _react.PropTypes.arrayOf(_react.PropTypes.string) };
	GoogleMap.defaultProps = {
	  distanceToMouse: function distanceToMouse(pt, mousePos /* , markerProps */) {
	    return Math.sqrt((pt.x - mousePos.x) * (pt.x - mousePos.x) + (pt.y - mousePos.y) * (pt.y - mousePos.y));
	  },
	
	  hoverDistance: 30,
	  debounced: true,
	  options: defaultOptions_,
	  googleMapLoader: _google_map_loader2.default,
	  yesIWantToUseGoogleMapApiInternals: false,
	  style: {
	    width: '100%',
	    height: '100%',
	    margin: 0,
	    padding: 0,
	    position: 'relative'
	  },
	  layerTypes: []
	};
	GoogleMap.googleMapLoader = _google_map_loader2.default;
	exports.default = GoogleMap;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var style = {
	  width: '100%',
	  height: '100%',
	  left: 0,
	  top: 0,
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	};
	
	var GoogleMapMap = function (_Component) {
	  _inherits(GoogleMapMap, _Component);
	
	  function GoogleMapMap() {
	    _classCallCheck(this, GoogleMapMap);
	
	    return _possibleConstructorReturn(this, (GoogleMapMap.__proto__ || Object.getPrototypeOf(GoogleMapMap)).apply(this, arguments));
	  }
	
	  _createClass(GoogleMapMap, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false; // disable react on this div
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { style: style });
	    }
	  }]);
	
	  return GoogleMapMap;
	}(_react.Component);
	
	exports.default = GoogleMapMap;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { style: style },
	    _react2.default.createElement(_google_map_markers2.default, _extends({}, props, { prerender: true }))
	  );
	};
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _google_map_markers = __webpack_require__(116);
	
	var _google_map_markers2 = _interopRequireDefault(_google_map_markers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	  width: '50%',
	  height: '50%',
	  left: '50%',
	  top: '50%',
	  // backgroundColor: 'red',
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	};

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _google_map = __webpack_require__(348);
	
	var _google_map2 = _interopRequireDefault(_google_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _google_map2.default;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventemitter = __webpack_require__(329);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarkerDispatcher = function (_EventEmitter) {
	  _inherits(MarkerDispatcher, _EventEmitter);
	
	  function MarkerDispatcher(gmapInstance) {
	    _classCallCheck(this, MarkerDispatcher);
	
	    var _this = _possibleConstructorReturn(this, (MarkerDispatcher.__proto__ || Object.getPrototypeOf(MarkerDispatcher)).call(this));
	
	    _this.gmapInstance = gmapInstance;
	    return _this;
	  }
	
	  _createClass(MarkerDispatcher, [{
	    key: 'getChildren',
	    value: function getChildren() {
	      return this.gmapInstance.props.children;
	    }
	  }, {
	    key: 'getMousePosition',
	    value: function getMousePosition() {
	      return this.gmapInstance.mouse_;
	    }
	  }, {
	    key: 'getUpdateCounter',
	    value: function getUpdateCounter() {
	      return this.gmapInstance.updateCounter_;
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      this.gmapInstance = null;
	      this.removeAllListeners();
	    }
	  }]);
	
	  return MarkerDispatcher;
	}(_eventemitter2.default);
	
	exports.default = MarkerDispatcher;

/***/ },
/* 353 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isArraysEqualEps;
	function isArraysEqualEps(arrayA, arrayB, eps) {
	  if (arrayA && arrayB) {
	    for (var i = 0; i !== arrayA.length; ++i) {
	      if (Math.abs(arrayA[i] - arrayB[i]) > eps) {
	        return false;
	      }
	    }
	    return true;
	  }
	  return false;
	}

/***/ },
/* 354 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = detectBrowser;
	// http://stackoverflow.com/questions/5899783/detect-safari-chrome-ie-firefox-opera-with-user-agent
	var detectBrowserResult_ = null;
	
	function detectBrowser() {
	  if (detectBrowserResult_) {
	    return detectBrowserResult_;
	  }
	
	  if (typeof navigator !== 'undefined') {
	    var isExplorer = navigator.userAgent.indexOf('MSIE') > -1;
	    var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
	    var isOpera = navigator.userAgent.toLowerCase().indexOf('op') > -1;
	
	    var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
	    var isSafari = navigator.userAgent.indexOf('Safari') > -1;
	
	    if (isChrome && isSafari) {
	      isSafari = false;
	    }
	
	    if (isChrome && isOpera) {
	      isChrome = false;
	    }
	
	    detectBrowserResult_ = { isExplorer: isExplorer, isFirefox: isFirefox, isOpera: isOpera, isChrome: isChrome, isSafari: isSafari };
	    return detectBrowserResult_;
	  }
	
	  detectBrowserResult_ = {
	    isChrome: true,
	    isExplorer: false,
	    isFirefox: false,
	    isOpera: false,
	    isSafari: false
	  };
	
	  return detectBrowserResult_;
	}

/***/ },
/* 355 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	/**
	* Detect Element Resize.
	* Forked in order to guard against unsafe 'window' and 'document' references.
	*
	* https://github.com/sdecima/javascript-detect-element-resize
	* Sebastian Decima
	*
	* version: 0.5.3
	**/
	
	// Reliable `window` and `document` detection
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// Check `document` and `window` in case of server-side rendering
	var _window;
	if (canUseDOM) {
	  _window = window;
	} else if (typeof self !== 'undefined') {
	  _window = self;
	} else {
	  _window = undefined;
	}
	
	var attachEvent = typeof document !== 'undefined' && document.attachEvent;
	var stylesCreated = false;
	
	if (canUseDOM && !attachEvent) {
	  var requestFrame = function () {
	    var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
	      return _window.setTimeout(fn, 20);
	    };
	    return function (fn) {
	      return raf(fn);
	    };
	  }();
	
	  var cancelFrame = function () {
	    var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
	    return function (id) {
	      return cancel(id);
	    };
	  }();
	
	  var resetTriggers = function resetTriggers(element) {
	    var triggers = element.__resizeTriggers__,
	        expand = triggers.firstElementChild,
	        contract = triggers.lastElementChild,
	        expandChild = expand.firstElementChild;
	    contract.scrollLeft = contract.scrollWidth;
	    contract.scrollTop = contract.scrollHeight;
	    expandChild.style.width = expand.offsetWidth + 1 + 'px';
	    expandChild.style.height = expand.offsetHeight + 1 + 'px';
	    expand.scrollLeft = expand.scrollWidth;
	    expand.scrollTop = expand.scrollHeight;
	  };
	
	  var checkTriggers = function checkTriggers(element) {
	    return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
	  };
	
	  var scrollListener = function scrollListener(e) {
	    var element = this;
	    resetTriggers(this);
	    if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
	    this.__resizeRAF__ = requestFrame(function () {
	      if (checkTriggers(element)) {
	        element.__resizeLast__.width = element.offsetWidth;
	        element.__resizeLast__.height = element.offsetHeight;
	        element.__resizeListeners__.forEach(function (fn) {
	          fn.call(element, e);
	        });
	      }
	    });
	  };
	
	  /* Detect CSS Animations support to detect element display/re-attach */
	  var animation = false,
	      animationstring = 'animation',
	      keyframeprefix = '',
	      animationstartevent = 'animationstart',
	      domPrefixes = 'Webkit Moz O ms'.split(' '),
	      startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
	      pfx = '';
	
	  if (canUseDOM) {
	    var elm = document.createElement('fakeelement');
	    if (elm.style.animationName !== undefined) {
	      animation = true;
	    }
	
	    if (animation === false) {
	      for (var i = 0; i < domPrefixes.length; i++) {
	        if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	          pfx = domPrefixes[i];
	          animationstring = pfx + 'Animation';
	          keyframeprefix = '-' + pfx.toLowerCase() + '-';
	          animationstartevent = startEvents[i];
	          animation = true;
	          break;
	        }
	      }
	    }
	  }
	
	  var animationName = 'resizeanim';
	  var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
	  var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	}
	
	var createStyles = function createStyles() {
	  if (!stylesCreated) {
	    //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	    var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
	        head = document.head || document.getElementsByTagName('head')[0],
	        style = document.createElement('style');
	
	    style.type = 'text/css';
	    if (style.styleSheet) {
	      style.styleSheet.cssText = css;
	    } else {
	      style.appendChild(document.createTextNode(css));
	    }
	
	    head.appendChild(style);
	    stylesCreated = true;
	  }
	};
	
	var addResizeListener = function addResizeListener(element, fn) {
	  if (element.parentNode === undefined) {
	    var tempParentDiv = document.createElement('div');
	    element.parentNode = tempParentDiv;
	  }
	  element = element.parentNode;
	  if (attachEvent) element.attachEvent('onresize', fn);else {
	    if (!element.__resizeTriggers__) {
	      if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
	      createStyles();
	      element.__resizeLast__ = {};
	      element.__resizeListeners__ = [];
	      (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
	      element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
	      element.appendChild(element.__resizeTriggers__);
	      resetTriggers(element);
	      element.addEventListener('scroll', scrollListener, true);
	
	      /* Listen for a css animation to detect element display/re-attach */
	      animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function (e) {
	        if (e.animationName == animationName) resetTriggers(element);
	      });
	    }
	    element.__resizeListeners__.push(fn);
	  }
	};
	
	var removeResizeListener = function removeResizeListener(element, fn) {
	  element = element.parentNode;
	  if (attachEvent) element.detachEvent('onresize', fn);else {
	    element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	    if (!element.__resizeListeners__.length) {
	      element.removeEventListener('scroll', scrollListener);
	      element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	    }
	  }
	};
	
	module.exports = {
	  addResizeListener: addResizeListener,
	  removeResizeListener: removeResizeListener
	};

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lat_lng = __webpack_require__(117);
	
	var _lat_lng2 = _interopRequireDefault(_lat_lng);
	
	var _pointGeometry = __webpack_require__(235);
	
	var _pointGeometry2 = _interopRequireDefault(_pointGeometry);
	
	var _transform = __webpack_require__(359);
	
	var _transform2 = _interopRequireDefault(_transform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Geo = function () {
	  function Geo(tileSize) {
	    _classCallCheck(this, Geo);
	
	    // left_top view пользует гугл
	    // super();
	    this.hasSize_ = false;
	    this.hasView_ = false;
	    this.transform_ = new _transform2.default(tileSize || 512);
	  }
	
	  _createClass(Geo, [{
	    key: 'setView',
	    value: function setView(center, zoom, bearing) {
	      this.transform_.center = _lat_lng2.default.convert(center);
	      this.transform_.zoom = +zoom;
	      this.transform_.bearing = +bearing;
	      this.hasView_ = true;
	    }
	  }, {
	    key: 'setViewSize',
	    value: function setViewSize(width, height) {
	      this.transform_.width = width;
	      this.transform_.height = height;
	      this.hasSize_ = true;
	    }
	  }, {
	    key: 'canProject',
	    value: function canProject() {
	      return this.hasSize_ && this.hasView_;
	    }
	  }, {
	    key: 'hasSize',
	    value: function hasSize() {
	      return this.hasSize_;
	    }
	  }, {
	    key: 'unproject',
	    value: function unproject(ptXY, viewFromLeftTop) {
	      var ptRes = void 0;
	      if (viewFromLeftTop) {
	        var ptxy = _extends({}, ptXY);
	        ptxy.x -= this.transform_.width / 2;
	        ptxy.y -= this.transform_.height / 2;
	        ptRes = this.transform_.pointLocation(_pointGeometry2.default.convert(ptxy));
	      } else {
	        ptRes = this.transform_.pointLocation(_pointGeometry2.default.convert(ptXY));
	      }
	
	      ptRes.lng -= 360 * Math.round(ptRes.lng / 360); // convert 2 google format
	      return ptRes;
	    }
	  }, {
	    key: 'project',
	    value: function project(ptLatLng, viewFromLeftTop) {
	      if (viewFromLeftTop) {
	        var pt = this.transform_.locationPoint(_lat_lng2.default.convert(ptLatLng));
	        pt.x -= this.transform_.worldSize * Math.round(pt.x / this.transform_.worldSize);
	
	        pt.x += this.transform_.width / 2;
	        pt.y += this.transform_.height / 2;
	
	        return pt;
	      }
	
	      return this.transform_.locationPoint(_lat_lng2.default.convert(ptLatLng));
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.transform_.width;
	    }
	  }, {
	    key: 'getHeight',
	    value: function getHeight() {
	      return this.transform_.height;
	    }
	  }, {
	    key: 'getZoom',
	    value: function getZoom() {
	      return this.transform_.zoom;
	    }
	  }, {
	    key: 'getCenter',
	    value: function getCenter() {
	      var ptRes = this.transform_.pointLocation({ x: 0, y: 0 });
	
	      return ptRes;
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(margins, roundFactor) {
	      var bndT = margins && margins[0] || 0;
	      var bndR = margins && margins[1] || 0;
	      var bndB = margins && margins[2] || 0;
	      var bndL = margins && margins[3] || 0;
	
	      if (this.getWidth() - bndR - bndL > 0 && this.getHeight() - bndT - bndB > 0) {
	        var topLeftCorner = this.unproject({
	          x: bndL - this.getWidth() / 2,
	          y: bndT - this.getHeight() / 2
	        });
	        var bottomRightCorner = this.unproject({
	          x: this.getWidth() / 2 - bndR,
	          y: this.getHeight() / 2 - bndB
	        });
	
	        var res = [topLeftCorner.lat, topLeftCorner.lng, // NW
	        bottomRightCorner.lat, bottomRightCorner.lng, // SE
	        bottomRightCorner.lat, topLeftCorner.lng, // SW
	        topLeftCorner.lat, bottomRightCorner.lng];
	
	        if (roundFactor) {
	          res = res.map(function (r) {
	            return Math.round(r * roundFactor) / roundFactor;
	          });
	        }
	        return res;
	      }
	
	      return [0, 0, 0, 0];
	    }
	  }]);
	
	  return Geo;
	}();
	
	exports.default = Geo;

/***/ },
/* 357 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isNumber;
	
	function isObjectLike(value) {
	  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
	}
	
	var objectToString = Object.prototype.toString;
	
	function isNumber(value) {
	  var numberTag = '[object Number]';
	  return typeof value === 'number' || isObjectLike(value) && objectToString.call(value) === numberTag;
	}

/***/ },
/* 358 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isPlainObject;
	// source taken from https://github.com/rackt/redux/blob/master/src/utils/isPlainObject.js
	var fnToString = function fnToString(fn) {
	  return Function.prototype.toString.call(fn);
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
	    return false;
	  }
	
	  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;
	
	  if (proto === null) {
	    return true;
	  }
	
	  var constructor = proto.constructor;
	
	  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === fnToString(Object);
	}

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lat_lng = __webpack_require__(117);
	
	var _lat_lng2 = _interopRequireDefault(_lat_lng);
	
	var _pointGeometry = __webpack_require__(235);
	
	var _pointGeometry2 = _interopRequireDefault(_pointGeometry);
	
	var _wrap = __webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// A single transform, generally used for a single tile to be scaled, rotated, and zoomed.
	var Transform = function () {
	  function Transform(tileSize, minZoom, maxZoom) {
	    _classCallCheck(this, Transform);
	
	    this.tileSize = tileSize || 512; // constant
	
	    this._minZoom = minZoom || 0;
	    this._maxZoom = maxZoom || 52;
	
	    this.latRange = [-85.05113, 85.05113];
	
	    this.width = 0;
	    this.height = 0;
	    this.zoom = 0;
	    this.center = new _lat_lng2.default(0, 0);
	    this.angle = 0;
	  }
	
	  _createClass(Transform, [{
	    key: 'zoomScale',
	    value: function zoomScale(zoom) {
	      return Math.pow(2, zoom);
	    }
	  }, {
	    key: 'scaleZoom',
	    value: function scaleZoom(scale) {
	      return Math.log(scale) / Math.LN2;
	    }
	  }, {
	    key: 'project',
	    value: function project(latlng, worldSize) {
	      return new _pointGeometry2.default(this.lngX(latlng.lng, worldSize), this.latY(latlng.lat, worldSize));
	    }
	  }, {
	    key: 'unproject',
	    value: function unproject(point, worldSize) {
	      return new _lat_lng2.default(this.yLat(point.y, worldSize), this.xLng(point.x, worldSize));
	    }
	  }, {
	    key: 'lngX',
	
	
	    // lat/lon <-> absolute pixel coords convertion
	    value: function lngX(lon, worldSize) {
	      return (180 + lon) * (worldSize || this.worldSize) / 360;
	    }
	
	    // latitude to absolute y coord
	
	  }, {
	    key: 'latY',
	    value: function latY(lat, worldSize) {
	      var y = 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360));
	      return (180 - y) * (worldSize || this.worldSize) / 360;
	    }
	  }, {
	    key: 'xLng',
	    value: function xLng(x, worldSize) {
	      return x * 360 / (worldSize || this.worldSize) - 180;
	    }
	  }, {
	    key: 'yLat',
	    value: function yLat(y, worldSize) {
	      var y2 = 180 - y * 360 / (worldSize || this.worldSize);
	      return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
	    }
	  }, {
	    key: 'locationPoint',
	    value: function locationPoint(latlng) {
	      var p = this.project(latlng);
	      return this.centerPoint._sub(this.point._sub(p)._rotate(this.angle));
	    }
	  }, {
	    key: 'pointLocation',
	    value: function pointLocation(p) {
	      var p2 = this.centerPoint._sub(p)._rotate(-this.angle);
	      return this.unproject(this.point.sub(p2));
	    }
	  }, {
	    key: 'minZoom',
	    get: function get() {
	      return this._minZoom;
	    },
	    set: function set(zoom) {
	      this._minZoom = zoom;
	      this.zoom = Math.max(this.zoom, zoom);
	    }
	  }, {
	    key: 'maxZoom',
	    get: function get() {
	      return this._maxZoom;
	    },
	    set: function set(zoom) {
	      this._maxZoom = zoom;
	      this.zoom = Math.min(this.zoom, zoom);
	    }
	  }, {
	    key: 'worldSize',
	    get: function get() {
	      return this.tileSize * this.scale;
	    }
	  }, {
	    key: 'centerPoint',
	    get: function get() {
	      return new _pointGeometry2.default(0, 0); // this.size._div(2);
	    }
	  }, {
	    key: 'size',
	    get: function get() {
	      return new _pointGeometry2.default(this.width, this.height);
	    }
	  }, {
	    key: 'bearing',
	    get: function get() {
	      return -this.angle / Math.PI * 180;
	    },
	    set: function set(bearing) {
	      this.angle = -(0, _wrap.wrap)(bearing, -180, 180) * Math.PI / 180;
	    }
	  }, {
	    key: 'zoom',
	    get: function get() {
	      return this._zoom;
	    },
	    set: function set(zoom) {
	      var zoomV = Math.min(Math.max(zoom, this.minZoom), this.maxZoom);
	      this._zoom = zoomV;
	      this.scale = this.zoomScale(zoomV);
	      this.tileZoom = Math.floor(zoomV);
	      this.zoomFraction = zoomV - this.tileZoom;
	    }
	  }, {
	    key: 'x',
	    get: function get() {
	      return this.lngX(this.center.lng);
	    }
	  }, {
	    key: 'y',
	    get: function get() {
	      return this.latY(this.center.lat);
	    }
	  }, {
	    key: 'point',
	    get: function get() {
	      return new _pointGeometry2.default(this.x, this.y);
	    }
	  }]);
	
	  return Transform;
	}();
	
	exports.default = Transform;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = googleMapLoader;
	var $script_ = null;
	
	var loadPromise_ = void 0;
	
	var resolveCustomPromise_ = void 0;
	var _customPromise = new Promise(function (resolve) {
	  resolveCustomPromise_ = resolve;
	});
	
	// TODO add libraries language and other map options
	function googleMapLoader(bootstrapURLKeys) {
	  if (!$script_) {
	    $script_ = __webpack_require__(649); // eslint-disable-line
	  }
	
	  // call from outside google-map-react
	  // will be as soon as loadPromise_ resolved
	  if (!bootstrapURLKeys) {
	    return _customPromise;
	  }
	
	  if (loadPromise_) {
	    return loadPromise_;
	  }
	
	  loadPromise_ = new Promise(function (resolve, reject) {
	    if (typeof window === 'undefined') {
	      reject(new Error('google map cannot be loaded outside browser env'));
	      return;
	    }
	
	    if (window.google && window.google.maps) {
	      resolve(window.google.maps);
	      return;
	    }
	
	    if (typeof window._$_google_map_initialize_$_ !== 'undefined') {
	      reject(new Error('google map initialization error'));
	    }
	
	    window._$_google_map_initialize_$_ = function () {
	      delete window._$_google_map_initialize_$_;
	      resolve(window.google.maps);
	    };
	
	    if (false) {
	      if (Object.keys(bootstrapURLKeys).indexOf('callback') > -1) {
	        console.error('"callback" key in bootstrapURLKeys is not allowed, ' + // eslint-disable-line
	        'use onGoogleApiLoaded property instead');
	        throw new Error('"callback" key in bootstrapURLKeys is not allowed, ' + 'use onGoogleApiLoaded property instead');
	      }
	    }
	
	    var queryString = Object.keys(bootstrapURLKeys).reduce(function (r, key) {
	      return r + '&' + key + '=' + bootstrapURLKeys[key];
	    }, '');
	
	    $script_('https://maps.googleapis.com/maps/api/js?callback=_$_google_map_initialize_$_' + queryString, function () {
	      return typeof window.google === 'undefined' && reject(new Error('google map initialization error (not loaded)'));
	    });
	  });
	
	  resolveCustomPromise_(loadPromise_);
	
	  return loadPromise_;
	}

/***/ },
/* 361 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var log2 = Math.log2 ? Math.log2 : function (x) {
	  return Math.log(x) / Math.LN2;
	};
	
	exports.default = log2;

/***/ },
/* 362 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = pick;
	// source taken from https://github.com/rackt/redux/blob/master/src/utils/pick.js
	
	function pick(obj, fn) {
	  return Object.keys(obj).reduce(function (result, key) {
	    if (fn(obj[key])) {
	      result[key] = obj[key]; // eslint-disable-line
	    }
	    return result;
	  }, {});
	}

/***/ },
/* 363 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = raf;
	function raf(callback) {
	  if (window.requestAnimationFrame) {
	    return window.requestAnimationFrame(callback);
	  }
	
	  var nativeRaf = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
	
	  return nativeRaf ? nativeRaf(callback) : window.setTimeout(callback, 1e3 / 60);
	}

/***/ },
/* 364 */
/***/ function(module, exports) {

	module.exports = {
		"result": [
			[
				"-",
				"-",
				"coordenadas",
				"referencia_espacial",
				"id",
				"cod_folio",
				"partido",
				"localidad",
				"matricula",
				"fecha de carga",
				"nombre oficial",
				"tipo",
				"año de origen",
				"cantidad de familias",
				"superficie",
				"direccion",
				"energia electrica",
				"alumbrado publico",
				"agua corriente",
				"red cloacal",
				"red de gas",
				"pavimento"
			],
			[
				"",
				"",
				"-58.83350908756257,-34.4813022747595,0.0 -58.83380723185837,-34.480891032516375,0.0 -58.83336734957993,-34.48062571386432,0.0 -58.833437087014325,-34.48054169611525,0.0 -58.83315813727677,-34.480382504358694,0.0 -58.832782628014684,-34.48092640827289,0.0 -58.83350908756257,-34.4813022747595,0.0 ",
				"Polygon Outer Boundary",
				"2037",
				"0840017",
				"Pilar",
				"Presidente Derqui",
				"0017",
				"2015/08/04",
				"Monterrey I",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"0.4799999999999999800000000000000",
				"Chacabuco, Peru, Ecuador",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.0120114765685,-34.9473701263458,0.0 -58.0091085689959,-34.9446674749424,0.0 -58.0079654804835,-34.9454637365368,0.0 -58.0089293758069,-34.9462763305947,0.0 -58.0078375307954,-34.9470744609038,0.0 -58.009850319128,-34.948985035498,0.0 -58.0099701019628,-34.9489594210589,0.0 -58.0120114765685,-34.9473701263458,0.0 ",
				"Polygon Outer Boundary",
				"353",
				"0550080",
				"La Plata",
				"Melchor Romero",
				"0080",
				"2014/10/10",
				"Malvinas II",
				"Asentamiento Precario",
				"2002",
				"273",
				"9.0999999999999996000000000000000",
				"36, 38, 150, 153",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0802807830337,-35.0351557609995,0.0 -58.0795370956319,-35.0355591813555,0.0 -58.0913535004487,-35.0464274882283,0.0 -58.0915086984651,-35.0456750339882,0.0 -58.0802807830337,-35.0351557609995,0.0 ",
				"Polygon Outer Boundary",
				"379",
				"0550105",
				"La Plata",
				"Etcheverry",
				"0105",
				"2014/10/24",
				"Ferroviario",
				"Villa",
				"2010",
				"133",
				"11.6000000000000000000000000000000",
				"52 e/238 y Ruta 2",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9799010229449,-34.9083324151729,0.0 -57.9800909259621,-34.9082748317217,0.0 -57.9808238380236,-34.9077364707294,0.0 -57.9794327462123,-34.9064598599956,0.0 -57.9778151919679,-34.9076433511348,0.0 -57.9787273740662,-34.9084943058888,0.0 -57.9792753854051,-34.9080866163914,0.0 -57.9793938343168,-34.9081636566601,0.0 -57.979728028796,-34.9084633670068,0.0 -57.9799010229449,-34.9083324151729,0.0 ",
				"Polygon Outer Boundary",
				"341",
				"0550069",
				"La Plata",
				"Tolosa",
				"0069",
				"2014/10/07",
				"La Favelita",
				"Villa",
				"1983",
				"122",
				"3.2999999999999998000000000000000",
				"15, 17, 530, 532",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.0630394306824,-34.9013685074865,0.0 -58.0634154154553,-34.9019317244197,0.0 -58.0633980819441,-34.9021807252676,0.0 -58.0632422931864,-34.9025167398078,0.0 -58.0632457228867,-34.9027526434161,0.0 -58.0631240794056,-34.9029156273241,0.0 -58.0631614262233,-34.9031699157292,0.0 -58.064750594691,-34.9027914924795,0.0 -58.0647801752025,-34.9027336547668,0.0 -58.0641796975649,-34.9011269487371,0.0 -58.06412724355,-34.9011107021619,0.0 -58.0630394306824,-34.9013685074865,0.0 ",
				"Polygon Outer Boundary",
				"311",
				"0550040",
				"La Plata",
				"City Bell",
				"0040",
				"2014/09/25",
				"Casaca",
				"Villa",
				"2002",
				"20",
				"3.4199999999999999000000000000000",
				"139, 141, Arroyo, 471",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.04667234420777,-34.88788029085788,0.0 -58.0468225479126,-34.887959495979274,0.0 -58.04694592952728,-34.888390722522956,0.0 -58.04718196392059,-34.88835112017966,0.0 -58.04733216762542,-34.88830711755359,0.0 -58.04726779460907,-34.88804750158016,0.0 -58.046929836273186,-34.887660276231216,0.0 -58.046613335609436,-34.88758107082139,0.0 -58.04643630981445,-34.887721880386074,0.0 -58.0465167760849,-34.88792869399669,0.0 -58.04667234420777,-34.88788029085788,0.0 ",
				"Polygon Outer Boundary",
				"330",
				"0550058",
				"La Plata",
				"Gonnet",
				"0058",
				"2014/10/06",
				"La Güemes",
				"Villa",
				"1980",
				"20",
				"0.3400000000000000200000000000000",
				"480, 26bis, 26",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.0193162668309,-34.869868358855,0.0 -58.0190586232077,-34.8694681664041,0.0 -58.0181050633943,-34.8698945141072,0.0 -58.0183510690252,-34.8702915182119,0.0 -58.0193162668309,-34.869868358855,0.0 ",
				"Polygon Outer Boundary",
				"332",
				"0550060",
				"La Plata",
				"Gonnet",
				"0060",
				"2014/10/06",
				"8 & 489",
				"Villa",
				"1980",
				"33",
				"0.5100000000000000100000000000000",
				"8 e/ 489 y 490",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0495262145996,-34.900767719578226,0.0 -58.04775595664977,-34.90113728484302,0.0 -58.0480062486706,-34.9018962073842,0.0 -58.0477640854401,-34.9020862037261,0.0 -58.0470186604974,-34.9027649703858,0.0 -58.0472700744731,-34.9034704275388,0.0 -58.0502553060612,-34.9027481905324,0.0 -58.0495262145996,-34.900767719578226,0.0 ",
				"Polygon Outer Boundary",
				"331",
				"0550059",
				"La Plata",
				"Gorina",
				"0059",
				"2014/10/06",
				"La Fábrica",
				"Villa",
				"1994",
				"182",
				"5.2699999999999996000000000000000",
				"481, 138, 136",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.071233332157135,-34.879783364552246,0.0 -58.0711367726326,-34.87957653044241,0.0 -58.0702196670059,-34.8795055212563,0.0 -58.0699609394803,-34.8797799815328,0.0 -58.0700625739205,-34.8800591314816,0.0 -58.071233332157135,-34.879783364552246,0.0 ",
				"Polygon Outer Boundary",
				"326",
				"0550054",
				"La Plata",
				"City Bell",
				"0054",
				"2014/09/25",
				"457 & 24",
				"Villa",
				"2005",
				"6",
				"0.4500000000000000100000000000000",
				"457, Arroyo, 24",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0163363376866,-34.9475763938675,0.0 -58.0174109978365,-34.9467385402323,0.0 -58.0155247374812,-34.9449624923532,0.0 -58.014459587432,-34.9457389513305,0.0 -58.0163363376866,-34.9475763938675,0.0 ",
				"Polygon Outer Boundary",
				"354",
				"0550081",
				"La Plata",
				"Melchor Romero",
				"0081",
				"2014/10/10",
				"Hijos de Malvinas",
				"Asentamiento Precario",
				"2009",
				"110",
				"3.7700000000000000000000000000000",
				"33, 34, 153, 155",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0257915796819,-34.9120158229171,0.0 -58.0234285390273,-34.9125004807483,0.0 -58.0229345146032,-34.9127403646039,0.0 -58.0214728227202,-34.9130021607827,0.0 -58.0201844658104,-34.9133075889758,0.0 -58.0203071760437,-34.9134141290351,0.0 -58.0208752543929,-34.9139204056882,0.0 -58.0216379110749,-34.9146205377447,0.0 -58.0216379110749,-34.9146205377447,0.0 -58.0233621586208,-34.9133296853897,0.0 -58.0230583311577,-34.9129069336871,0.0 -58.0258620321863,-34.912242908693,0.0 -58.0257915796819,-34.9120158229171,0.0 ",
				"Polygon Outer Boundary",
				"356",
				"0550083",
				"La Plata",
				"Hernandez",
				"0083",
				"2014/10/07",
				"514 & 138",
				"Villa",
				"2001",
				"59",
				"3.8999999999999999000000000000000",
				"510, 514, 137, 138, vias",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0865589038359,-34.8663957423217,0.0 -58.0880811245015,-34.8677495461879,0.0 -58.0884271506346,-34.8675110258702,0.0 -58.0882357583239,-34.8672670275411,0.0 -58.0880808739167,-34.8670283796555,0.0 -58.0880298461496,-34.8662892182084,0.0 -58.0881114753113,-34.8660325533613,0.0 -58.0876796470029,-34.8655616282435,0.0 -58.0870457023661,-34.8660371450668,0.0 -58.0864578970533,-34.8655451957154,0.0 -58.0859662318033,-34.8658881296827,0.0 -58.0854500561358,-34.866239493747,0.0 -58.086086793439,-34.8667903475389,0.0 -58.0865589038359,-34.8663957423217,0.0 ",
				"Polygon Outer Boundary",
				"317",
				"0550045",
				"La Plata",
				"Villa Elisa",
				"0045",
				"2014/10/01",
				"Villa Rica",
				"Asentamiento Precario",
				"2000",
				"54",
				"2.7999999999999998000000000000000",
				"Arroyo, 21A, 17, 423",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0804516332714,-34.8614212922913,0.0 -58.0807578355348,-34.8611763451618,0.0 -58.079825558176,-34.8608525537146,0.0 -58.0796921215302,-34.8606946228793,0.0 -58.0794211373468,-34.8604648718452,0.0 -58.0792542505703,-34.8604591940292,0.0 -58.0790816960522,-34.860411735892,0.0 -58.0788017284175,-34.8603172734157,0.0 -58.0786642917209,-34.8604252012517,0.0 -58.0783446466482,-34.8606762131099,0.0 -58.0791478056072,-34.861396731105,0.0 -58.0797976761843,-34.8619248431598,0.0 -58.0804516332714,-34.8614212922913,0.0 ",
				"Polygon Outer Boundary",
				"318",
				"0550046",
				"La Plata",
				"Villa Elisa",
				"0046",
				"2014/10/01",
				"El Progreso",
				"Asentamiento Precario",
				"2013",
				"58",
				"1.6000000000000001000000000000000",
				"423, 423bis, 13, 11 (borde de arroyo)",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.1011129990169,-34.8890472647337,0.0 -58.1009586802665,-34.8890706283885,0.0 -58.100688359838,-34.8891490463237,0.0 -58.1000922012913,-34.8893086173045,0.0 -58.1000731449645,-34.8893477030013,0.0 -58.1003378703424,-34.8908661735444,0.0 -58.1009866423929,-34.890787723127,0.0 -58.1011322039696,-34.8906317422536,0.0 -58.1017725199042,-34.8905499110365,0.0 -58.1019539717407,-34.890369435641,0.0 -58.1022238222703,-34.8903353480016,0.0 -58.1026405377707,-34.8902358707266,0.0 -58.1025674371067,-34.8900424975117,0.0 -58.1024118666198,-34.8898824436333,0.0 -58.1011129990169,-34.8890472647337,0.0 ",
				"Polygon Outer Boundary",
				"319",
				"0550047",
				"La Plata",
				"Arturo Segui",
				"0047",
				"2014/10/01",
				"El Rincon I",
				"Asentamiento Precario",
				"2011",
				"58",
				"2.8999999999999999000000000000000",
				"431, 435, 137, 138",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0805900732755,-34.8614910693976,0.0 -58.0798939973677,-34.862028564637,0.0 -58.0812785357123,-34.8632246338147,0.0 -58.0826217704168,-34.8643530789117,0.0 -58.0836895564919,-34.8652666348041,0.0 -58.0844271017496,-34.8647705079686,0.0 -58.0852808637335,-34.8641755399249,0.0 -58.0857242559731,-34.863855169283,0.0 -58.0857150422353,-34.8638744683117,0.0 -58.0852838318077,-34.8635663546064,0.0 -58.0850082528453,-34.8635610047236,0.0 -58.0843074414945,-34.8635230618936,0.0 -58.0840889522435,-34.8634148495789,0.0 -58.0834102438598,-34.863954370001,0.0 -58.0834102438598,-34.863954370001,0.0 -58.0833224581361,-34.8637982451287,0.0 -58.0805900732755,-34.8614910693976,0.0 ",
				"Polygon Outer Boundary",
				"323",
				"0550051",
				"La Plata",
				"Villa Elisa",
				"0051",
				"2014/10/01",
				"La Fortaleza",
				"Asentamiento Precario",
				"2000",
				"146",
				"5.7999999999999998000000000000000",
				"423bis, 13, 16, 423, Arroyo",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.0700499950776,-34.8514194730696,0.0 -58.0677479365679,-34.8529581922922,0.0 -58.067792709717,-34.8530849412457,0.0 -58.0704996906883,-34.851742383592,0.0 -58.0700499950776,-34.8514194730696,0.0 ",
				"Polygon Outer Boundary",
				"324",
				"0550052",
				"La Plata",
				"Villa Elisa",
				"0052",
				"2014/10/01",
				"YPF",
				"Asentamiento Precario",
				"1974",
				"38",
				"0.9000000000000000200000000000000",
				"sobre vías, 423, 425",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0554557317531,-34.9491445330378,0.0 -58.0535471987939,-34.9473611549826,0.0 -58.0530700655541,-34.9476935858511,0.0 -58.0526432009756,-34.9480182648561,0.0 -58.0536226066714,-34.9489199078903,0.0 -58.0545175988062,-34.9497075796027,0.0 -58.0545682639271,-34.9497233403837,0.0 -58.0546684619075,-34.9496724993616,0.0 -58.0554557317531,-34.9491445330378,0.0 ",
				"Polygon Outer Boundary",
				"367",
				"0550093",
				"La Plata",
				"Melchor Romero",
				"0093",
				"2014/10/15",
				"Vieja Estacion",
				"Villa",
				"2012",
				"30",
				"2.7999999999999998000000000000000",
				"516, 517, 171, 173",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0344796621577,-34.9944708685204,0.0 -58.0341610666187,-34.994184896782,0.0 -58.0338239277682,-34.9938655476531,0.0 -58.0339241521041,-34.9935250344478,0.0 -58.0316145867115,-34.9914050825257,0.0 -58.025686740875244,-34.98596125183214,0.0 -58.023937940597534,-34.984308704711175,0.0 -58.02360534667968,-34.98452846024056,0.0 -58.0313537091931,-34.9915937177967,0.0 -58.0329325718345,-34.9930841769754,0.0 -58.0335036873403,-34.9950600858187,0.0 -58.0335682322538,-34.9951460629914,0.0 -58.0344796621577,-34.9944708685204,0.0 ",
				"Polygon Outer Boundary",
				"386",
				"0550112",
				"La Plata",
				"Lisandro Olmos",
				"0112",
				"2014/10/24",
				"El Triángulo",
				"Villa",
				"2007",
				"62",
				"5.9100000000000001000000000000000",
				"187, 190, 52",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.5013922096231,-34.7031648184579,0.0 -58.500767131261,-34.7036348145906,0.0 -58.5013525923042,-34.7041512501278,0.0 -58.5015626379238,-34.7039704199484,0.0 -58.5016794229662,-34.7039110437135,0.0 -58.5019722160146,-34.7036811839624,0.0 -58.5013922096231,-34.7031648184579,0.0 ",
				"Polygon Outer Boundary",
				"1075",
				"0700055",
				"La Matanza",
				"Tapiales",
				"0055",
				"2014/10/01",
				"Arozanera",
				"Villa",
				"90_o_anterior",
				"110",
				"1.1100000000000001000000000000000",
				"Arozarena, Curapaligue, Humaitá",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.50249767303467,-34.70512737680128,0.0 -58.503066301345825,-34.70468196045012,0.0 -58.5026478767395,-34.704311513341366,0.0 -58.5020899772644,-34.70475252161611,0.0 -58.50249767303467,-34.70512737680128,0.0 ",
				"Polygon Outer Boundary",
				"1075",
				"0700055",
				"La Matanza",
				"Tapiales",
				"0055",
				"2014/10/01",
				"Arozanera",
				"Villa",
				"90_o_anterior",
				"110",
				"1.1100000000000001000000000000000",
				"Arozarena, Curapaligue, Humaitá",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.502320647239685,-34.70402044659226,0.0 -58.50206851959228,-34.7037823003086,0.0 -58.501816391944885,-34.70398075559259,0.0 -58.502079248428345,-34.70420126090537,0.0 -58.502320647239685,-34.70402044659226,0.0 ",
				"Polygon Outer Boundary",
				"1075",
				"0700055",
				"La Matanza",
				"Tapiales",
				"0055",
				"2014/10/01",
				"Arozanera",
				"Villa",
				"90_o_anterior",
				"110",
				"1.1100000000000001000000000000000",
				"Arozarena, Curapaligue, Humaitá",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.26569080352784,-34.74529318469309,0.0 -58.26614677906036,-34.74468048309467,0.0 -58.26519727706909,-34.74416916029642,0.0 -58.26426923274994,-34.7436754663157,0.0 -58.26326072216034,-34.74315532125142,0.0 -58.262853026390076,-34.74372836224046,0.0 -58.26318025588989,-34.74392672165671,0.0 -58.262665271759026,-34.744574692430575,0.0 -58.26297640800476,-34.744742194252844,0.0 -58.263083696365356,-34.74474660219094,0.0 -58.26358258724213,-34.74413389653849,0.0 -58.263866901397705,-34.74430139925456,0.0 -58.26569080352784,-34.74529318469309,0.0 ",
				"Polygon Outer Boundary",
				"911",
				"0860037",
				"Quilmes",
				"Quilmes",
				"0037",
				"2014/10/01",
				"Laprida",
				"Asentamiento Precario",
				"decada_2000",
				"217",
				"2.8199999999999998000000000000000",
				"Rodriguez y Laprida",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.094405484857,-34.8952486794008,0.0 -58.0942043888238,-34.8936466417654,0.0 -58.0936185260188,-34.8937551611556,0.0 -58.0936916354937,-34.8941977177379,0.0 -58.0939095972246,-34.8945542646096,0.0 -58.0941033055263,-34.8949300489025,0.0 -58.0942788767135,-34.895060320888,0.0 -58.094405484857,-34.8952486794008,0.0 ",
				"Polygon Outer Boundary",
				"322",
				"0550050",
				"La Plata",
				"Arturo Segui",
				"0050",
				"2014/10/01",
				"El Rincon II",
				"Asentamiento Precario",
				"2010",
				"57",
				"2.5000000000000000000000000000000",
				"vias (141) e/438 y 443; 443 e/139 y 141 sobre terraplen",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0984858110342,-34.8948289462336,0.0 -58.0948423267535,-34.8956938092887,0.0 -58.0949080596897,-34.8960982699175,0.0 -58.0986147577529,-34.8953618236429,0.0 -58.0984858110342,-34.8948289462336,0.0 ",
				"Polygon Outer Boundary",
				"322",
				"0550050",
				"La Plata",
				"Arturo Segui",
				"0050",
				"2014/10/01",
				"El Rincon II",
				"Asentamiento Precario",
				"2010",
				"57",
				"2.5000000000000000000000000000000",
				"vias (141) e/438 y 443; 443 e/139 y 141 sobre terraplen",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0548385989611,-34.9033190357461,0.0 -58.0547948629996,-34.9032995902205,0.0 -58.0541144768351,-34.9034695694805,0.0 -58.0530622056894,-34.903720643716,0.0 -58.0518621074402,-34.9040146696626,0.0 -58.0520971584368,-34.9047386003836,0.0 -58.05239081382751,-34.90566872370664,0.0 -58.0532760165375,-34.9054393620642,0.0 -58.0532945644886,-34.9054347859352,0.0 -58.0545342952139,-34.9051351063431,0.0 -58.0542842166722,-34.9043504482329,0.0 -58.0551833447953,-34.9041452464077,0.0 -58.0548385989611,-34.9033190357461,0.0 ",
				"Polygon Outer Boundary",
				"329",
				"0550057",
				"La Plata",
				"Gorina",
				"0057",
				"2014/10/06",
				"Colinas del Sol",
				"Asentamiento Precario",
				"2000",
				"137",
				"4.6799999999999997000000000000000",
				"476bis, 480, 139, 141",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.008635135906,-34.9498864298664,0.0 -58.0095864696183,-34.9491904452938,0.0 -58.0086453172639,-34.9483385181017,0.0 -58.0065331371591,-34.9498881738338,0.0 -58.0074718858083,-34.950781282024,0.0 -58.008635135906,-34.9498864298664,0.0 ",
				"Polygon Outer Boundary",
				"347",
				"0550076",
				"La Plata",
				"San Carlos",
				"0076",
				"2014/10/10",
				"153 & 40",
				"Asentamiento Precario",
				"2010",
				"80",
				"3.2999999999999998000000000000000",
				"38, 40, 152, 153",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9952504484303,-34.9581809988382,0.0 -57.9957160172668,-34.9578501681818,0.0 -57.9926348271668,-34.9552484660037,0.0 -57.9922694146717,-34.9555094235257,0.0 -57.9941505098109,-34.9572140298458,0.0 -57.9952504484303,-34.9581809988382,0.0 ",
				"Polygon Outer Boundary",
				"345",
				"0550074",
				"La Plata",
				"San Carlos",
				"0074",
				"2014/10/07",
				"La Banda",
				"Asentamiento Precario",
				"2013",
				"51",
				"2.0000000000000000000000000000000",
				"50bis, 52, 149, 152",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.4215248233289,-34.8041920955607,0.0 -58.4218036059062,-34.803918100604,0.0 -58.421786867521,-34.8036699616872,0.0 -58.4217085415595,-34.8034966982829,0.0 -58.4216714343912,-34.8034771996542,0.0 -58.4215236190621,-34.8036822188195,0.0 -58.4207404458831,-34.8032837790738,0.0 -58.4208949147633,-34.8030737098522,0.0 -58.420639462573,-34.8029469171273,0.0 -58.420212048792,-34.8034944913697,0.0 -58.4215248233289,-34.8041920955607,0.0 ",
				"Polygon Outer Boundary",
				"951",
				"0630060",
				"Lomas de Zamora",
				"Lavallol",
				"0060",
				"2014/10/01",
				"Barrio Obrero II",
				"Villa",
				"90_o_anterior",
				"50",
				"0.8000000000000000400000000000000",
				"Rauch, Charlone, 1 de Mayo, Santos Vega",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.5034472777683,-34.4664620148524,0.0 -58.5020475121261,-34.4656048243118,0.0 -58.5017789856297,-34.4658224563952,0.0 -58.500956593823,-34.4664748482277,0.0 -58.4999796117166,-34.4672515228275,0.0 -58.5003727782404,-34.4675144551127,0.0 -58.5023777815599,-34.4661597852644,0.0 -58.5044940267774,-34.4673519174393,0.0 -58.5046875212124,-34.4672362153757,0.0 -58.5034472777683,-34.4664620148524,0.0 ",
				"Polygon Outer Boundary",
				"883",
				"0970001",
				"San Isidro",
				"San Isidro",
				"0001",
				"2014/10/01",
				"Bajo San Isidro",
				"Villa",
				"90_o_anterior",
				"90",
				"2.1299999999999999000000000000000",
				"Pedro de Mendoza, Martín y Omar, La Ribera",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.830242156982415,-34.485485333353274,0.0 -58.829560875892646,-34.48510064222003,0.0 -58.829201459884644,-34.48560471989595,0.0 -58.82984519004822,-34.48594076998752,0.0 -58.830242156982415,-34.485485333353274,0.0 ",
				"Polygon Outer Boundary",
				"2039",
				"0840019",
				"Pilar",
				"Presidente Derqui",
				"0019",
				"2015/08/04",
				"Monterrey II",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"0.4600000000000000200000000000000",
				"Perú y Salta",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.09255421161651,-34.88199249640598,0.0 -58.09254616498947,-34.88174826263643,0.0 -58.092240393161774,-34.88146002184856,0.0 -58.0922108888626,-34.88128179612282,0.0 -58.09204459190369,-34.8810375602413,0.0 -58.091923892498016,-34.88109476871108,0.0 -58.09194803237914,-34.88134560537768,0.0 -58.09209287166595,-34.881592040655505,0.0 -58.09214651584625,-34.88202990151381,0.0 -58.09255421161651,-34.88199249640598,0.0 ",
				"Polygon Outer Boundary",
				"320",
				"0550048",
				"La Plata",
				"Arturo Segui",
				"0048",
				"2014/10/01",
				"El Rincon III",
				"Asentamiento Precario",
				"2013",
				"10",
				"0.2999999999999999900000000000000",
				"30, 441, Arroyo",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Sin dato"
			],
			[
				"",
				"",
				"-58.40478479862213,-34.81643701647602,0.0 -58.405675292015076,-34.81520826086174,0.0 -58.40277314186096,-34.813794508612816,0.0 -58.401925563812256,-34.81497924345238,0.0 -58.401153087615974,-34.81610670762802,0.0 -58.404012322425835,-34.81752042020207,0.0 -58.40478479862213,-34.81643701647602,0.0 ",
				"Polygon Outer Boundary",
				"1241",
				"0030038",
				"Almirante Brown",
				"Burzaco",
				"0038",
				"2014/10/01",
				"Bétharram I",
				"Asentamiento Precario",
				"1987",
				"124",
				"9.1500000000000004000000000000000",
				"Soler, Cornet, Ituzaigo y Diomede",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.31224858760834,-34.730939786860965,0.0 -58.31030666828155,-34.72993019421386,0.0 -58.30819845199585,-34.73294130088879,0.0 -58.31102013587952,-34.73427708614381,0.0 -58.31224858760834,-34.730939786860965,0.0 ",
				"Polygon Outer Boundary",
				"1409",
				"0860065",
				"Quilmes",
				"Quilmes",
				"0065",
				"2015/02/18",
				"Cañada",
				"Asentamiento Precario",
				"90_o_anterior",
				"343",
				"9.6899999999999995000000000000000",
				"Zapiola, Maurino y Lamadrid",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0430149670395,-34.8911730085827,0.0 -58.0430149670395,-34.8911730085827,0.0 -58.0434109475099,-34.8923105018477,0.0 -58.0440696387439,-34.8921621314813,0.0 -58.0437153828135,-34.891045138688,0.0 -58.0435656782662,-34.8906794481085,0.0 -58.0432361629531,-34.8907564235248,0.0 -58.0433522879232,-34.8911114268784,0.0 -58.0430149670395,-34.8911730085827,0.0 ",
				"Polygon Outer Boundary",
				"357",
				"0550084",
				"La Plata",
				"Gorina",
				"0084",
				"2014/10/06",
				"28b & 482",
				"Asentamiento Precario",
				"1987",
				"24",
				"1.0000000000000000000000000000000",
				"28b, 30, 482, 483",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.5843552319801,-34.5609278372877,0.0 -58.5845762958731,-34.5607413879003,0.0 -58.584763301859,-34.5605908676155,0.0 -58.5847882241589,-34.560611797484,0.0 -58.5849031733948,-34.5605214628971,0.0 -58.5848790120782,-34.5605006320092,0.0 -58.58501774783,-34.560376051374,0.0 -58.5851106280905,-34.5603021357224,0.0 -58.5849961615411,-34.5602031926298,0.0 -58.5849881144513,-34.5602022881291,0.0 -58.5848354665429,-34.5600740590669,0.0 -58.5847466913577,-34.5599956939745,0.0 -58.584666800785,-34.5599331153256,0.0 -58.5843593583402,-34.5596620294602,0.0 -58.5842519505907,-34.5595195422117,0.0 -58.5835397573641,-34.5588888075822,0.0 -58.5833691854594,-34.5587834432818,0.0 -58.58430504798889,-34.55809382371254,0.0 -58.58351111412049,-34.55736928916348,0.0 -58.5825683460382,-34.5580741581743,0.0 -58.5825357859763,-34.5580732392716,0.0 -58.5817781059054,-34.5586667203984,0.0 -58.5814017347034,-34.5589615133961,0.0 -58.5822186043772,-34.5596814952103,0.0 -58.5824380587191,-34.5595051603755,0.0 -58.5825036663565,-34.559401275583,0.0 -58.5826106085838,-34.5594040497256,0.0 -58.5827486216364,-34.5595084061068,0.0 -58.5830186314277,-34.5597475732848,0.0 -58.5834608138384,-34.5601391452741,0.0 -58.5836716129638,-34.5602239747891,0.0 -58.5836773210174,-34.5602343164083,0.0 -58.5836875751081,-34.5602464233404,0.0 -58.5837666619184,-34.5603178265236,0.0 -58.5838231622306,-34.5603719320978,0.0 -58.5839193212643,-34.560451735539,0.0 -58.5840602775457,-34.5606204809794,0.0 -58.5841190382404,-34.5606955239538,0.0 -58.5842811783245,-34.560861540414,0.0 -58.5843552319801,-34.5609278372877,0.0 ",
				"Polygon Outer Boundary",
				"806",
				"0470061",
				"General San Martin",
				"General San Martin",
				"0061",
				"2014/10/01",
				"El Zanjón",
				"Asentamiento Precario",
				"2000",
				"240",
				"5.1100000000000003000000000000000",
				"Colón, España, Pueyrredón y Eva Perón",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.0366677133183,-34.9358634893148,0.0 -58.0384213440138,-34.9345600499436,0.0 -58.0398702705358,-34.9334830439823,0.0 -58.0401680285382,-34.9332498474931,0.0 -58.04038066237,-34.9330423449106,0.0 -58.0402692712568,-34.9329475514484,0.0 -58.0393769852425,-34.932188207757,0.0 -58.0385223342769,-34.9314086688888,0.0 -58.0384071934439,-34.931438718022,0.0 -58.0356634030669,-34.9334415610345,0.0 -58.0358671329163,-34.9335168381178,0.0 -58.0360943798796,-34.9337619705584,0.0 -58.0363575079423,-34.9339580759836,0.0 -58.03536415100098,-34.93461123721678,0.0 -58.0365704379314,-34.9357746986859,0.0 -58.0366677133183,-34.9358634893148,0.0 ",
				"Polygon Outer Boundary",
				"372",
				"0550098",
				"La Plata",
				"Melchor Romero",
				"0098",
				"2014/10/15",
				"Las Rosas II",
				"Asentamiento Precario",
				"2013",
				"13",
				"10.9100000000000000000000000000000",
				"515, arroyo, 155, 157",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.486938173949,-34.7335798840324,0.0 -58.4869083105808,-34.733630977904,0.0 -58.490492787549,-34.7368378947271,0.0 -58.4919367317297,-34.7349321139724,0.0 -58.4905569329209,-34.7337372746682,0.0 -58.486938173949,-34.7335798840324,0.0 ",
				"Polygon Outer Boundary",
				"1001",
				"0630010",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0010",
				"2014/10/01",
				"Juan Domingo Perón",
				"Asentamiento Precario",
				"90_o_anterior",
				"240",
				"8.0800000000000001000000000000000",
				"A. Dr. Gilberlto Elizalde, Diag. 64, Calle 19, Río Matanza",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.0366923463621,-34.9511292765403,0.0 -58.0337439535075,-34.9484641686765,0.0 -58.0325951959434,-34.9492149457276,0.0 -58.0315562061802,-34.9500138793768,0.0 -58.0345813438974,-34.9527306355676,0.0 -58.0366923463621,-34.9511292765403,0.0 ",
				"Polygon Outer Boundary",
				"358",
				"0550085",
				"La Plata",
				"Melchor Romero",
				"0085",
				"2014/10/15",
				"San Cayetano",
				"Asentamiento Precario",
				"2011",
				"220",
				"10.6999999999999990000000000000000",
				"163, 166, 526, 528",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0398648023586,-34.9482750921921,0.0 -58.0388215167885,-34.9490636359582,0.0 -58.03917550882,-34.9493861480179,0.0 -58.0390685287019,-34.949452044313,0.0 -58.0385746054011,-34.9498269901374,0.0 -58.0395255133853,-34.9506968721637,0.0 -58.0401198549408,-34.9502463999675,0.0 -58.0411738930827,-34.9494649375752,0.0 -58.0398648023586,-34.9482750921921,0.0 ",
				"Polygon Outer Boundary",
				"365",
				"0550091",
				"La Plata",
				"Melchor Romero",
				"0091",
				"2014/10/15",
				"166 & 523",
				"Asentamiento Precario",
				"2011",
				"41",
				"3.2999999999999998000000000000000",
				"166, 167, 523, 524",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0417820432777,-34.9354092996106,0.0 -58.0425060905253,-34.934864924978,0.0 -58.0405423264738,-34.9331935953561,0.0 -58.0402419597348,-34.9334624661836,0.0 -58.0417820432777,-34.9354092996106,0.0 ",
				"Polygon Outer Boundary",
				"370",
				"0550096",
				"La Plata",
				"Melchor Romero",
				"0096",
				"2014/10/15",
				"Las Rosas C.P.A.",
				"Asentamiento Precario",
				"2012",
				"22",
				"1.7000000000000000000000000000000",
				"159, 157, 515, vias",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0394376274757,-34.9799366157406,0.0 -58.0383883859947,-34.9790398180621,0.0 -58.0383499278869,-34.9790409088307,0.0 -58.0372481411247,-34.9798505830821,0.0 -58.0368761751645,-34.9801977685646,0.0 -58.0378626600334,-34.9810695293557,0.0 -58.03793951961,-34.9810632598376,0.0 -58.0383547228859,-34.9814330518262,0.0 -58.0381423147083,-34.9815898534471,0.0 -58.0386080255497,-34.9819776873338,0.0 -58.0402079405719,-34.9807856435129,0.0 -58.0402919631833,-34.9806875071813,0.0 -58.0394376274757,-34.9799366157406,0.0 ",
				"Polygon Outer Boundary",
				"375",
				"0550101",
				"La Plata",
				"Lisandro Olmos",
				"0101",
				"2014/10/24",
				"Las Casuarinas",
				"Asentamiento Precario",
				"1999",
				"124",
				"5.0000000000000000000000000000000",
				"40, 41bis, 183, 185",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.0912721157074,-35.023222602758416,0.0 -58.09044599533081,-35.02247578483704,0.0 -58.08923363685607,-35.02337196552408,0.0 -58.0871917621481,-35.0249558927398,0.0 -58.0871898032108,-35.025007050407,0.0 -58.0878778700843,-35.0256254012393,0.0 -58.0879285718854,-35.0256263806315,0.0 -58.0900123973163,-35.0240839865522,0.0 -58.0900313383324,-35.024044721093,0.0 -58.0912721157074,-35.023222602758416,0.0 ",
				"Polygon Outer Boundary",
				"376",
				"0550102",
				"La Plata",
				"Etcheverry",
				"0102",
				"2014/10/24",
				"236 & 41",
				"Asentamiento Precario",
				"2005",
				"50",
				"4.2999999999999998000000000000000",
				"235, 236, 39, 41",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0421638944721,-34.9395004607523,0.0 -58.0413581412051,-34.9401100237656,0.0 -58.041837054884,-34.9405392949733,0.0 -58.042641467289,-34.9399285261242,0.0 -58.0421638944721,-34.9395004607523,0.0 ",
				"Polygon Outer Boundary",
				"373",
				"0550099",
				"La Plata",
				"Melchor Romero",
				"0099",
				"2014/10/15",
				"518 & 162",
				"Asentamiento Precario",
				"2011",
				"32",
				"0.5999999999999999800000000000000",
				"517, 518, 161, 162",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0543938726592,-35.0034164738722,0.0 -58.0514307409171,-35.0056197725279,0.0 -58.0537171581651,-35.0077092284852,0.0 -58.0558514711631,-35.0061853869277,0.0 -58.0553026502082,-35.0056836094391,0.0 -58.0552332360862,-35.0053384084836,0.0 -58.0559385581375,-35.0048171894015,0.0 -58.0543938726592,-35.0034164738722,0.0 ",
				"Polygon Outer Boundary",
				"377",
				"0550103",
				"La Plata",
				"Lisandro Olmos",
				"0103",
				"2014/10/24",
				"Los Rosales",
				"Asentamiento Precario",
				"1985",
				"188",
				"10.4000000000000000000000000000000",
				"45, 49, 204b, 207",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9676906292808,-34.9636467823026,0.0 -57.9644141487917,-34.966023304033,0.0 -57.9643903076985,-34.9661860199656,0.0 -57.9655140018322,-34.9672375321636,0.0 -57.9658308254026,-34.9670028547275,0.0 -57.9670454022056,-34.968094541647,0.0 -57.9679119986437,-34.9689137292122,0.0 -57.9695878217968,-34.9703723651587,0.0 -57.9705104619716,-34.9697274407606,0.0 -57.969687363995,-34.9689747887538,0.0 -57.9692462315047,-34.9685351910567,0.0 -57.9698350833067,-34.9681835732331,0.0 -57.9707733938901,-34.9674870923771,0.0 -57.9703324795884,-34.9671669674695,0.0 -57.9700088678938,-34.9667565756913,0.0 -57.9706660925333,-34.9663234075077,0.0 -57.9676906292808,-34.9636467823026,0.0 ",
				"Polygon Outer Boundary",
				"389",
				"0550115",
				"La Plata",
				"Los Hornos",
				"0115",
				"2014/10/24",
				"Las Palmeras",
				"Asentamiento Precario",
				"2009",
				"450",
				"20.8000000000000010000000000000000",
				"143, 148, 70, 73",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.00094604492187,-34.96342044752481,0.0 -57.9983748079244,-34.9610770284057,0.0 -57.9972543079323,-34.9600701170164,0.0 -57.9970206996602,-34.9602405011406,0.0 -57.998074445497,-34.9612421810588,0.0 -57.9981227482747,-34.9614225532814,0.0 -58.000667095184326,-34.96365784400583,0.0 -58.00094604492187,-34.96342044752481,0.0 ",
				"Polygon Outer Boundary",
				"381",
				"0550107",
				"La Plata",
				"Los Hornos",
				"0107",
				"2014/10/24",
				"52 & 155",
				"Asentamiento Precario",
				"2011",
				"29",
				"1.8600000000000001000000000000000",
				"154, 159, 52",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0020129213793,-34.9686929343047,0.0 -58.0009167589918,-34.9695109297949,0.0 -58.0014133740858,-34.9699610045955,0.0 -58.0008815047673,-34.9703586709461,0.0 -58.0012934298465,-34.9706933761083,0.0 -58.0008805515073,-34.9710001942386,0.0 -58.0006307358253,-34.9711394606312,0.0 -57.9998249577327,-34.9703872942658,0.0 -57.9997280240694,-34.9704041178893,0.0 -57.9977468841932,-34.9718857928114,0.0 -57.9977474266761,-34.9719399637204,0.0 -57.9995036855502,-34.9735433273288,0.0 -58.000099481527,-34.9740705934916,0.0 -58.0021739789572,-34.9725236953851,0.0 -58.0016449224114,-34.9720428493524,0.0 -58.0038262958666,-34.9703542230242,0.0 -58.0020129213793,-34.9686929343047,0.0 ",
				"Polygon Outer Boundary",
				"383",
				"0550109",
				"La Plata",
				"Los Hornos",
				"0109",
				"2014/10/24",
				"El Triunfo",
				"Asentamiento Precario",
				"1998",
				"242",
				"13.8000000000000010000000000000000",
				"55, 60, 161, 163",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.447877168655396,-34.6994161636251,0.0 -58.44776451587676,-34.69934118754874,0.0 -58.448118567466736,-34.69889574004724,0.0 -58.44801127910614,-34.69853408783678,0.0 -58.44790399074554,-34.698132740240716,0.0 -58.44750786200166,-34.69794309179833,0.0 -58.444320559501655,-34.7021020264934,0.0 -58.443360328674316,-34.703336876715724,0.0 -58.44293653964996,-34.703852862241895,0.0 -58.44048500061035,-34.702565097486556,0.0 -58.440114855766296,-34.70311195894083,0.0 -58.43937993049621,-34.70410864874558,0.0 -58.440506458282464,-34.70468637052477,0.0 -58.44102680683136,-34.704902463894,0.0 -58.4414130449295,-34.70515824715261,0.0 -58.44273805618286,-34.7059344121999,0.0 -58.443354964256294,-34.70511855669879,0.0 -58.44431519508361,-34.70387932295135,0.0 -58.44527542591095,-34.70265771137418,0.0 -58.44633758068085,-34.703169290980725,0.0 -58.44677830114961,-34.70258273823503,0.0 -58.44676757231355,-34.70172715760072,0.0 -58.4468855895102,-34.70163895290855,0.0 -58.44694996252655,-34.70135669726174,0.0 -58.44764733687043,-34.701100902250104,0.0 -58.44809794798493,-34.700642233352475,0.0 -58.447877168655396,-34.6994161636251,0.0 ",
				"Polygon Outer Boundary",
				"1470",
				"0630071",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0071",
				"2015/03/19",
				"Nueva Fiorito",
				"Asentamiento Precario",
				"90_o_anterior",
				"350",
				"18.9100000000000000000000000000000",
				"El Plumerillo, Azamor, Baradero, Esquel",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9945687699627,-34.9637148943568,0.0 -57.9945706426292,-34.9636695049208,0.0 -57.9929663798097,-34.9622182002939,0.0 -57.9926375323431,-34.9624650086313,0.0 -57.9932229004654,-34.9629888192971,0.0 -57.9933815312598,-34.963136624279,0.0 -57.9927520201984,-34.963605474582,0.0 -57.9927469279064,-34.9636436912799,0.0 -57.994668746076,-34.965357536759,0.0 -57.9947395757217,-34.965357535174,0.0 -57.9950912420098,-34.9650955074614,0.0 -57.9950993397728,-34.9650372435807,0.0 -57.9940687070982,-34.9640858155682,0.0 -57.9945687699627,-34.9637148943568,0.0 ",
				"Polygon Outer Boundary",
				"387",
				"0550113",
				"La Plata",
				"Los Hornos",
				"0113",
				"2014/10/24",
				"57 & 155",
				"Asentamiento Precario",
				"2000",
				"66",
				"2.6000000000000001000000000000000",
				"153, 156, 57, 58",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0011973330467,-34.9564710523298,0.0 -58.0002134502633,-34.9572068120517,0.0 -58.0015617855493,-34.9584296816339,0.0 -58.0016122286684,-34.958430511924,0.0 -58.0025375145874,-34.9577413603685,0.0 -58.0025385708859,-34.9577068617822,0.0 -58.0011973330467,-34.9564710523298,0.0 ",
				"Polygon Outer Boundary",
				"388",
				"0550114",
				"La Plata",
				"Los Hornos",
				"0114",
				"2014/10/24",
				"155 & 46",
				"Asentamiento Precario",
				"2005",
				"39",
				"2.2999999999999998000000000000000",
				"45, 46, 154, 155",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.008855819702156,-34.16068181711787,0.0 -59.01014328002929,-34.15982954899694,0.0 -59.00904131121933,-34.158955077452084,0.0 -59.00788796134293,-34.158022889690564,0.0 -59.00639665313065,-34.156806591137915,0.0 -59.00585484690964,-34.15630497385872,0.0 -59.006890179589384,-34.15543046581301,0.0 -59.00699746794999,-34.15557695763993,0.0 -59.007507087662816,-34.15515967722152,0.0 -59.00950265116989,-34.15659795422443,0.0 -59.010806204751134,-34.15549261389183,0.0 -59.011841537430875,-34.15457814468885,0.0 -59.01212048716843,-34.15436506306376,0.0 -59.00972259230912,-34.152842401637194,0.0 -59.00489151477814,-34.1498236331015,0.0 -58.99958610534667,-34.15301109434278,0.0 -59.008855819702156,-34.16068181711787,0.0 ",
				"Polygon Outer Boundary",
				"1848",
				"0140007",
				"Campana",
				"Campana",
				"0007",
				"2015/07/01",
				"21 de Septiembre",
				"Asentamiento Precario",
				"2009",
				"360",
				"56.1899999999999980000000000000000",
				"Ahumada, Benigno Ibarra, Iturriaga,",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9582910676793,-34.9625730047601,0.0 -57.9568010436999,-34.9637426452382,0.0 -57.9593191119395,-34.9660632995228,0.0 -57.9608433180652,-34.9649370994686,0.0 -57.9582910676793,-34.9625730047601,0.0 ",
				"Polygon Outer Boundary",
				"396",
				"0550121",
				"La Plata",
				"Los Hornos",
				"0121",
				"2014/10/31",
				"74 & 140",
				"Asentamiento Precario",
				"2013",
				"51",
				"6.5000000000000000000000000000000",
				"138,141,74,76",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.81050730124116,-34.50409872643757,0.0 -58.80975628271698,-34.50330298943661,0.0 -58.80726719275117,-34.503983787117924,0.0 -58.80580807104706,-34.50550450990755,0.0 -58.810593131929636,-34.50422250706609,0.0 -58.81050730124116,-34.50409872643757,0.0 ",
				"Polygon Outer Boundary",
				"1888",
				"1320050",
				"Jose C. Paz",
				"Jose C. Paz",
				"0050",
				"2015/07/13",
				"Urquiza",
				"Asentamiento Precario",
				"2011",
				"80",
				"4.2300000000000004000000000000000",
				"Trinidad, Caracas, Crucero La Argentina",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9512882438953,-34.9689566552368,0.0 -57.9510795562362,-34.9691119661222,0.0 -57.9506830327667,-34.9693991124499,0.0 -57.9529361044537,-34.9714486714795,0.0 -57.953850268692,-34.9707622382616,0.0 -57.9536699082641,-34.9705968938113,0.0 -57.9535987765394,-34.9705912788595,0.0 -57.9533190945513,-34.9707975468127,0.0 -57.9532251044669,-34.970650575133,0.0 -57.9523288512845,-34.9698598853301,0.0 -57.9521837126601,-34.9697500063647,0.0 -57.9512882438953,-34.9689566552368,0.0 ",
				"Polygon Outer Boundary",
				"399",
				"0550124",
				"La Plata",
				"Los Hornos",
				"0124",
				"2014/10/31",
				"Santa Isabel",
				"Asentamiento Precario",
				"2007",
				"67",
				"2.3999999999999999000000000000000",
				"81, 82bis, 139, 141",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.5767026419669,-34.5645596102015,0.0 -58.5765764347374,-34.5641780399004,0.0 -58.5761103737401,-34.5642834695882,0.0 -58.5759780466668,-34.5638839806058,0.0 -58.5755177171532,-34.5639919986888,0.0 -58.5756483591285,-34.5643879532156,0.0 -58.575417023837,-34.5644402356061,0.0 -58.5754480031996,-34.5645339768331,0.0 -58.5749121563456,-34.5649680300198,0.0 -58.5750606669013,-34.565095682211,0.0 -58.5751044315053,-34.5650978155656,0.0 -58.5753252151871,-34.5649168784258,0.0 -58.5766878540282,-34.5645834136177,0.0 -58.5767026419669,-34.5645596102015,0.0 ",
				"Polygon Outer Boundary",
				"798",
				"0470069",
				"General San Martin",
				"Billinghurst",
				"0069",
				"2014/10/01",
				"18 de Julio",
				"Villa",
				"90_o_anterior",
				"180",
				"1.4199999999999999000000000000000",
				"Diag. 122, M. Ocampo, Maipú",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.575565908104174,-34.56510911233796,0.0 -58.5756249167025,-34.56515770484296,0.0 -58.57592582702637,-34.56547134669211,0.0 -58.57649445533752,-34.565064937308776,0.0 -58.5768860578537,-34.56479546912268,0.0 -58.57686946168542,-34.56471153623064,0.0 -58.576772902160876,-34.56463643830806,0.0 -58.57566783204674,-34.56491032452189,0.0 -58.575442526489496,-34.5649942572133,0.0 -58.575565908104174,-34.56510911233796,0.0 ",
				"Polygon Outer Boundary",
				"798",
				"0470069",
				"General San Martin",
				"Billinghurst",
				"0069",
				"2014/10/01",
				"18 de Julio",
				"Villa",
				"90_o_anterior",
				"180",
				"1.4199999999999999000000000000000",
				"Diag. 122, M. Ocampo, Maipú",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.28700363636017,-34.79098614437813,0.0 -58.28708913177252,-34.79090684589414,0.0 -58.28698754310608,-34.790836358288786,0.0 -58.28745424747467,-34.79030329382269,0.0 -58.28923523426055,-34.79125487756238,0.0 -58.28874170780182,-34.79191128772382,0.0 -58.28911721706391,-34.792127153011066,0.0 -58.29118251800537,-34.7914795554541,0.0 -58.29124689102172,-34.79139144654991,0.0 -58.2905226945877,-34.79102579359153,0.0 -58.28995943069457,-34.79072622128482,0.0 -58.29014718532562,-34.79047951386217,0.0 -58.29024374485015,-34.790334132356776,0.0 -58.29005599021911,-34.790210778151206,0.0 -58.28954637050629,-34.79073943773306,0.0 -58.28745424747467,-34.78957638217954,0.0 -58.28651010990143,-34.79073943773306,0.0 -58.28700363636017,-34.79098614437813,0.0 ",
				"Polygon Outer Boundary",
				"1662",
				"0320048",
				"Florencio Varela",
				"Florencio Varela",
				"0048",
				"2015/05/05",
				"La Sirena",
				"Asentamiento Precario",
				"1996",
				"180",
				"3.9500000000000002000000000000000",
				"La Argentina, Guardia Nacional",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9291632496798,-34.9547994157591,0.0 -57.9266094641374,-34.9569990517453,0.0 -57.9266094641442,-34.9569990517492,0.0 -57.925790597551,-34.9576797089816,0.0 -57.9262717619335,-34.9581044709948,0.0 -57.9269619468992,-34.9587531110269,0.0 -57.9279627157141,-34.959668226565,0.0 -57.9293948063074,-34.958361175356,0.0 -57.9311419970985,-34.9568518074109,0.0 -57.930667867557,-34.9561182721237,0.0 -57.9291632496798,-34.9547994157591,0.0 ",
				"Polygon Outer Boundary",
				"403",
				"0550128",
				"La Plata",
				"Altos De San Lorenzo",
				"0128",
				"2014/10/31",
				"Puente de Fierro 2",
				"Asentamiento Precario",
				"2007",
				"220",
				"12.8000000000000010000000000000000",
				"85, 89, 23bis, 22",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0410493175333,-34.9547582538343,0.0 -58.0419723027679,-34.9540120948584,0.0 -58.0411034965845,-34.953191199069,0.0 -58.0400913974838,-34.9522736587009,0.0 -58.0391236744043,-34.9530045949881,0.0 -58.0401091748344,-34.9539205344624,0.0 -58.0410493175333,-34.9547582538343,0.0 ",
				"Polygon Outer Boundary",
				"369",
				"0550095",
				"La Plata",
				"Melchor Romero",
				"0095",
				"2014/10/15",
				"El Bajo",
				"Asentamiento Precario",
				"2009",
				"60",
				"3.1000000000000001000000000000000",
				"168, 170, 525, 526",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.61438870429992,-34.47462044270678,0.0 -58.61203925684094,-34.474788490045825,0.0 -58.611803222447634,-34.474788490045825,0.0 -58.61158864572644,-34.47480175692659,0.0 -58.61138479784131,-34.474823868389876,0.0 -58.61107366159559,-34.474899047321166,0.0 -58.61088590696453,-34.47496980390051,0.0 -58.610564041882746,-34.47504498270031,0.0 -58.610328007489436,-34.475102472325055,0.0 -58.608729243278496,-34.47548278730641,0.0 -58.60864341259002,-34.47556681014991,0.0 -58.60965192317962,-34.476124012128935,0.0 -58.60988259315491,-34.47582772265094,0.0 -58.61031711101531,-34.47523956280883,0.0 -58.61118078231811,-34.47521302918439,0.0 -58.61138463020324,-34.47521302918439,0.0 -58.61156165599823,-34.47518207327854,0.0 -58.61164212226868,-34.47512458370864,0.0 -58.61198008060455,-34.47531916363154,0.0 -58.6121517419815,-34.47504940498056,0.0 -58.61349284648895,-34.47579676697313,0.0 -58.61438870429992,-34.47462044270678,0.0 ",
				"Polygon Outer Boundary",
				"2259",
				"0570051",
				"Tigre",
				"Don Torcuato",
				"0051",
				"2015/09/24",
				"Gallardo & 9 de Julio",
				"Asentamiento Precario",
				"90_o_anterior",
				"135",
				"2.8700000000000001000000000000000",
				"9 de Julio, Ituzaingo, Gallardo, Don Bosco",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.8876009663626,-34.9353687044259,0.0 -57.8876009663626,-34.9353687044259,0.0 -57.8876009663686,-34.9353687037504,0.0 -57.8869179749333,-34.934670393035,0.0 -57.8860661481693,-34.9352339457762,0.0 -57.8860314993469,-34.9353645537392,0.0 -57.8856072347504,-34.9356415800797,0.0 -57.8861849508267,-34.9362417301212,0.0 -57.8866093284802,-34.9359646136539,0.0 -57.886748131297,-34.9359330547022,0.0 -57.886748131297,-34.9359330547022,0.0 -57.8876009663626,-34.9353687044259,0.0 ",
				"Polygon Outer Boundary",
				"405",
				"0550130",
				"La Plata",
				"Villa Elvira",
				"0130",
				"2014/10/31",
				"99 & 123",
				"Asentamiento Precario",
				"1999",
				"46",
				"1.5000000000000000000000000000000",
				"98, 99, 123, 124",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-57.9420031721465,-34.9628917791321,0.0 -57.9411124053588,-34.9621005727089,0.0 -57.9401357304354,-34.9628307290601,0.0 -57.941027048889,-34.9636216815496,0.0 -57.9420031721465,-34.9628917791321,0.0 ",
				"Polygon Outer Boundary",
				"402",
				"0550127",
				"La Plata",
				"Altos De San Lorenzo",
				"0127",
				"2014/10/31",
				"131 & 83",
				"Asentamiento Precario",
				"2007",
				"51",
				"1.3999999999999999000000000000000",
				"131, 132, 83, 84",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.8735102906515,-34.9470641060766,0.0 -57.8742643504501,-34.9464785455643,0.0 -57.8742947249675,-34.9464536479922,0.0 -57.8742849777782,-34.946445320149,0.0 -57.8772144863509,-34.9441788803323,0.0 -57.8746427540765,-34.9413784073166,0.0 -57.8731123866313,-34.9398164634138,0.0 -57.8675067590764,-34.9434940787061,0.0 -57.8719209647033,-34.9481796913174,0.0 -57.8734765634003,-34.9470411801609,0.0 -57.8735102906515,-34.9470641060766,0.0 ",
				"Polygon Outer Boundary",
				"409",
				"0550133",
				"La Plata",
				"Villa Elvira",
				"0133",
				"2014/10/31",
				"Villa Aburridita",
				"Asentamiento Precario",
				"2001",
				"732",
				"41.8999999999999990000000000000000",
				"122, 127, 611, 615",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9552979104361,-34.9659188944997,0.0 -57.9540242704794,-34.9669358373107,0.0 -57.9549067134564,-34.9677387069322,0.0 -57.9548029010394,-34.9678147306558,0.0 -57.9549798609124,-34.9679673964297,0.0 -57.9552338021964,-34.9681977856413,0.0 -57.9550707171079,-34.9683196730339,0.0 -57.9553632608971,-34.9685874777503,0.0 -57.9556324040838,-34.9683976388534,0.0 -57.9560388702954,-34.9687671073752,0.0 -57.9562613851135,-34.9685749803831,0.0 -57.9572657968958,-34.9677219001773,0.0 -57.9552979104361,-34.9659188944997,0.0 ",
				"Polygon Outer Boundary",
				"397",
				"0550122",
				"La Plata",
				"Los Hornos",
				"0122",
				"2014/10/31",
				"2 de Abril",
				"Otros",
				"2013",
				"32",
				"4.5999999999999996000000000000000",
				"139, 141, 78, 79",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9635358588194,-34.9598572175856,0.0 -57.9629878043933,-34.9593514663832,0.0 -57.9613054320765,-34.9606063444123,0.0 -57.9611644090283,-34.9604794314989,0.0 -57.9607506854417,-34.9607861877327,0.0 -57.9643974127947,-34.9641752506877,0.0 -57.9653795974002,-34.9649814488441,0.0 -57.9663272234541,-34.9642778558001,0.0 -57.9663143366055,-34.9642278941044,0.0 -57.9653853926915,-34.9633810692561,0.0 -57.9655363413651,-34.9632752756568,0.0 -57.9660370585238,-34.9629121941896,0.0 -57.9655290340491,-34.9624507424271,0.0 -57.9649525417205,-34.9619251475743,0.0 -57.9645083170127,-34.9615269433864,0.0 -57.9650001511424,-34.9611686736262,0.0 -57.9635358588194,-34.9598572175856,0.0 ",
				"Polygon Outer Boundary",
				"400",
				"0550125",
				"La Plata",
				"Los Hornos",
				"0125",
				"2014/10/31",
				"La Esperanza",
				"Asentamiento Precario",
				"2000",
				"200",
				"13.0000000000000000000000000000000",
				"138, 143, 70, 72",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.527746332068,-34.5564072740022,0.0 -58.5274288241676,-34.5561005029651,0.0 -58.527029139087,-34.5563766290228,0.0 -58.5273417570024,-34.5566888402742,0.0 -58.527746332068,-34.5564072740022,0.0 ",
				"Polygon Outer Boundary",
				"791",
				"0470076",
				"General San Martin",
				"General San Martin",
				"0076",
				"2014/10/01",
				"Colombia & Ecuador",
				"Villa",
				"90_o_anterior",
				"65",
				"0.2200000000000000000000000000000",
				"Colombia y Ecuador",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.0442371254219,-35.0033739581625,0.0 -58.0413328605724,-35.000708222089,0.0 -58.0412570511709,-35.0007299590123,0.0 -58.039363605103,-35.0021238399429,0.0 -58.0408378015246,-35.0025002903545,0.0 -58.0441642126939,-35.0034278464077,0.0 -58.0442371254219,-35.0033739581625,0.0 ",
				"Polygon Outer Boundary",
				"380",
				"0550106",
				"La Plata",
				"Lisandro Olmos",
				"0106",
				"2014/10/24",
				"La Palangana",
				"Otros",
				"1997",
				"141",
				"4.9000000000000004000000000000000",
				"197, 200, 52, 55",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.0704306081144,-34.8725446254934,0.0 -58.0703507040426,-34.8724730615093,0.0 -58.0701662316382,-34.8725090122618,0.0 -58.0699209604898,-34.8725568112484,0.0 -58.0689462541716,-34.8727973673293,0.0 -58.0689223037653,-34.8728442109389,0.0 -58.0692382620206,-34.8737496429276,0.0 -58.0692893903595,-34.8737657759012,0.0 -58.0697794735823,-34.8735857596002,0.0 -58.0700222565737,-34.8740474217285,0.0 -58.0704359997819,-34.8739513949545,0.0 -58.0705907131987,-34.8739154866822,0.0 -58.0707336359567,-34.8743643204877,0.0 -58.0708532869681,-34.8742934007609,0.0 -58.0709720573368,-34.8741604695448,0.0 -58.0710732433798,-34.8740387811799,0.0 -58.0711398313664,-34.8739315108031,0.0 -58.0711833244318,-34.8738298219682,0.0 -58.0712132016332,-34.8737258442311,0.0 -58.0712270810067,-34.873627921187,0.0 -58.0711826017386,-34.8732523061528,0.0 -58.0711237642248,-34.8731121333267,0.0 -58.0709629429049,-34.8728999563506,0.0 -58.0704306081144,-34.8725446254934,0.0 ",
				"Polygon Outer Boundary",
				"325",
				"0550053",
				"La Plata",
				"City Bell",
				"0053",
				"2014/09/25",
				"456 & 20",
				"Asentamiento Precario",
				"decada_1990",
				"86",
				"2.6299999999999999000000000000000",
				"Arroyo, 456, Parque Ecológico, 20, 21C",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.0685365899757,-34.9665611816326,0.0 -58.0709116742286,-34.9647351146089,0.0 -58.0713322383928,-34.9644160428858,0.0 -58.0702694643431,-34.9634964107722,0.0 -58.0692709976679,-34.9625850921221,0.0 -58.068043205837,-34.9613881763599,0.0 -58.067599112432,-34.9610353484571,0.0 -58.06624710559844,-34.95983303919871,0.0 -58.06780815124512,-34.95869875241767,0.0 -58.06679427623748,-34.957845828760725,0.0 -58.06528151035308,-34.95896254144217,0.0 -58.062552716429,-34.9565592723514,0.0 -58.0619071465961,-34.9570313876986,0.0 -58.064537132301,-34.9594295180477,0.0 -58.0655902233072,-34.9604199198618,0.0 -58.0650910334434,-34.9607835348356,0.0 -58.0655729122477,-34.9611618774829,0.0 -58.06437492370605,-34.962026828386534,0.0 -58.0641496181488,-34.96182459777259,0.0 -58.06365609169006,-34.96214992503761,0.0 -58.0655175447464,-34.96387325873599,0.0 -58.06647777557373,-34.96479206214397,0.0 -58.0676326674002,-34.9657384231928,0.0 -58.0685365899757,-34.9665611816326,0.0 ",
				"Polygon Outer Boundary",
				"360",
				"0550087",
				"La Plata",
				"Melchor Romero",
				"0087",
				"2014/10/15",
				"Barrio Nuevo",
				"Asentamiento Precario",
				"1980",
				"239",
				"29.6999999999999990000000000000000",
				"181, 189, vías, 519",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7443231921468,-35.0463729901607,0.0 -58.7435213247278,-35.0456829421897,0.0 -58.742614281975,-35.0448985140892,0.0 -58.7409385689983,-35.0461924376556,0.0 -58.7409393296944,-35.0462357080398,0.0 -58.7416843651742,-35.0468714657507,0.0 -58.7418124718649,-35.0470008695395,0.0 -58.7426080827231,-35.0476914045813,0.0 -58.7427047364857,-35.04779227066,0.0 -58.7435115569216,-35.048488954759,0.0 -58.7443140780184,-35.0478706796818,0.0 -58.7433979428268,-35.0470767897099,0.0 -58.7435368942251,-35.0469920645521,0.0 -58.7443231921468,-35.0463729901607,0.0 ",
				"Polygon Outer Boundary",
				"483",
				"0150001",
				"Cañuelas",
				"Cañuelas",
				"0001",
				"2014/09/09",
				"El Ombú",
				"Asentamiento Precario",
				"2004",
				"102",
				"11.0000000000000000000000000000000",
				"Tristan Suarez, Las Heras, San Juan, Mandela",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.77295863814652,-34.50924872944422,0.0 -58.77227735705673,-34.510119556865774,0.0 -58.77223980613052,-34.510172601896905,0.0 -58.77284062094986,-34.51049971217612,0.0 -58.77289426513016,-34.51050413257651,0.0 -58.77359163947404,-34.50962004783324,0.0 -58.773580910637975,-34.50957584334988,0.0 -58.77295863814652,-34.50924872944422,0.0 ",
				"Polygon Outer Boundary",
				"1890",
				"1320051",
				"Jose C. Paz",
				"Jose C. Paz",
				"0051",
				"2015/07/14",
				"11 de Septiembre & Bruguetti",
				"Asentamiento Precario",
				"2013",
				"46",
				"0.8700000000000000000000000000000",
				"11 de Septiembre & Bruguetti",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9970678961358,-34.8824430743665,0.0 -57.9973491203021,-34.8826888724808,0.0 -57.9978022715624,-34.8830832281286,0.0 -57.9979474900989,-34.8829712571465,0.0 -57.9981292688905,-34.8831333669758,0.0 -57.9984836279237,-34.8832158384405,0.0 -57.9988276170655,-34.8830091159168,0.0 -57.9981248053833,-34.8823746938576,0.0 -57.9980749554864,-34.8823738726929,0.0 -57.9978895983656,-34.882517536007,0.0 -57.9977742712838,-34.8824027145036,0.0 -57.9977295634476,-34.8823567372208,0.0 -57.9970678961358,-34.8824430743665,0.0 ",
				"Polygon Outer Boundary",
				"334",
				"0550062",
				"La Plata",
				"Gonnet",
				"0062",
				"2014/10/06",
				"508 & 9",
				"Villa",
				"decada_1990",
				"13",
				"1.1899999999999999000000000000000",
				"508, vias, 9, 10",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.35759401321411,-34.74690646356784,0.0 -58.35685908794404,-34.74654942915475,0.0 -58.35626916959882,-34.74735606026315,0.0 -58.35579710081219,-34.748224392051135,0.0 -58.35667133331298,-34.7486519429278,0.0 -58.357025384902954,-34.74813182919876,0.0 -58.357395529747,-34.74761171219457,0.0 -58.35759401321411,-34.74690646356784,0.0 ",
				"Polygon Outer Boundary",
				"2302",
				"0630087",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0087",
				"2015/10/05",
				"Monroe & Dinamarca",
				"Otros",
				"90_o_anterior",
				"50",
				"2.0200000000000000000000000000000",
				"Monroe & Dinamarca",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.91220247745514,-34.95020429199023,0.0 -57.91150510311126,-34.94958432019371,0.0 -57.91227757930756,-34.949052283920956,0.0 -57.91187524795532,-34.94869172845099,0.0 -57.91108131408691,-34.949276531035395,0.0 -57.91062533855439,-34.948867609366154,0.0 -57.90999233722687,-34.9493600739212,0.0 -57.909852862358086,-34.94925014905375,0.0 -57.90955781936646,-34.94944801370901,0.0 -57.90972411632538,-34.94958432019371,0.0 -57.90914475917816,-34.949993238288,0.0 -57.909541726112366,-34.950362581910326,0.0 -57.909284234046936,-34.95054285616927,0.0 -57.909337878227234,-34.95060881006741,0.0 -57.9070794582367,-34.95229721179267,0.0 -57.909214496612556,-34.95424498620696,0.0 -57.913307547569275,-34.95117601140089,0.0 -57.912111282348626,-34.95027464310356,0.0 -57.91220247745514,-34.95020429199023,0.0 ",
				"Polygon Outer Boundary",
				"328",
				"0550056",
				"La Plata",
				"Villa Elvira",
				"0056",
				"2014/08/27",
				"Aeropuerto",
				"Asentamiento Precario",
				"1998",
				"900",
				"16.3099999999999990000000000000000",
				"93 a 98 y 1 a 13",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.635333068668835,-34.715618222877026,0.0 -58.63456964492797,-34.71505380601273,0.0 -58.633947372436516,-34.71467458626849,0.0 -58.632649183273315,-34.71557412794822,0.0 -58.6340456083417,-34.716553029834884,0.0 -58.635333068668835,-34.715618222877026,0.0 ",
				"Polygon Outer Boundary",
				"1031",
				"0700099",
				"La Matanza",
				"Rafael Castillo",
				"0099",
				"2014/10/01",
				"América",
				"Asentamiento Precario",
				"90_o_anterior",
				"120",
				"2.6000000000000001000000000000000",
				"Polledo y Merou",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.44921827316284,-34.705184707444566,0.0 -58.448467254638665,-34.70605789233147,0.0 -58.4512996673584,-34.707663117269654,0.0 -58.455119132995605,-34.709568178973086,0.0 -58.45525860786439,-34.70940060586096,0.0 -58.45083832740784,-34.70693988791123,0.0 -58.45153570175171,-34.706525351159954,0.0 -58.45000684261322,-34.7033853883125,0.0 -58.44966921955346,-34.702970833750264,0.0 -58.45112834125757,-34.70172715760072,0.0 -58.45137510448694,-34.70084510644771,0.0 -58.44801697880029,-34.703332466569144,0.0 -58.44729814678431,-34.70238868979476,0.0 -58.446815349161625,-34.7027591455131,0.0 -58.44743762165309,-34.70353533306816,0.0 -58.44729814678431,-34.703720558567596,0.0 -58.44921827316284,-34.705184707444566,0.0 ",
				"Polygon Outer Boundary",
				"2344",
				"0630092",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0092",
				"2015/10/14",
				"8 de Diciembre",
				"Villa",
				"2004",
				"1200",
				"13.0399999999999990000000000000000",
				"Figueredo y Presidente J.Domingo Perón",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.6888900771737,-34.40346624463656,0.0 -58.68842873722314,-34.40287314910511,0.0 -58.68819270282984,-34.40253676469645,0.0 -58.68745241314173,-34.4015984220929,0.0 -58.68693172931671,-34.40187284413173,0.0 -58.68656158447265,-34.401346130069584,0.0 -58.68599832057952,-34.401616126767735,0.0 -58.685601353645325,-34.401120394456534,0.0 -58.68515644222498,-34.40135940861609,0.0 -58.68596110492945,-34.40232431068891,0.0 -58.68551049381494,-34.40268725262539,0.0 -58.68441581726074,-34.40329362771414,0.0 -58.68355214595795,-34.40377606898868,0.0 -58.6839759349823,-34.40399737139491,0.0 -58.68471086025239,-34.40360345270546,0.0 -58.68487179279328,-34.4038070513608,0.0 -58.68537068367004,-34.40353263566575,0.0 -58.685628175735474,-34.40381147741302,0.0 -58.686153888702385,-34.4035768963226,0.0 -58.68694815784693,-34.40452849478159,0.0 -58.68732366710902,-34.40435145402732,0.0 -58.6888900771737,-34.40346624463656,0.0 ",
				"Polygon Outer Boundary",
				"2258",
				"0570050",
				"Tigre",
				"Benavidez",
				"0050",
				"2015/09/24",
				"IRSA",
				"Otros",
				"90_o_anterior",
				"160",
				"12.0600000000000000000000000000000",
				"Elcano, José León Suarez, Echeverria",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.691765405237675,-34.40190825336151,0.0 -58.68893299251794,-34.40348394891616,0.0 -58.68970546871424,-34.40446653056021,0.0 -58.692580796778195,-34.402899705711356,0.0 -58.691765405237675,-34.40190825336151,0.0 ",
				"Polygon Outer Boundary",
				"2258",
				"0570050",
				"Tigre",
				"Benavidez",
				"0050",
				"2015/09/24",
				"IRSA",
				"Otros",
				"90_o_anterior",
				"160",
				"12.0600000000000000000000000000000",
				"Elcano, José León Suarez, Echeverria",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.0376568944353,-34.952048732179,0.0 -58.0367692928141,-34.9512899442585,0.0 -58.0366880830166,-34.9512662027466,0.0 -58.0347791870648,-34.9527273724253,0.0 -58.0324544448154,-34.9544577772225,0.0 -58.0321166177715,-34.9544159756572,0.0 -58.0302785587542,-34.9527623868442,0.0 -58.0301842470585,-34.9525675569176,0.0 -58.0323049821876,-34.9509892252832,0.0 -58.0294399673433,-34.9483333206749,0.0 -58.0293010113876,-34.9484055421941,0.0 -58.023690484644,-34.9526311084416,0.0 -58.022815663084,-34.9533318937899,0.0 -58.0230327478543,-34.953549634112,0.0 -58.0240010831641,-34.9527811308046,0.0 -58.024837456523,-34.9534728043961,0.0 -58.0238136495595,-34.9542120976026,0.0 -58.024822683831,-34.9551228718538,0.0 -58.025717158995,-34.9559612680693,0.0 -58.0261856527808,-34.9555626549301,0.0 -58.026793479937,-34.9550975094327,0.0 -58.0299075636918,-34.9578307862355,0.0 -58.0322803482897,-34.9560487388079,0.0 -58.0333593067014,-34.9552613528268,0.0 -58.0376568944353,-34.952048732179,0.0 ",
				"Polygon Outer Boundary",
				"364",
				"0550090",
				"La Plata",
				"Melchor Romero",
				"0090",
				"2014/10/15",
				"El Futuro",
				"Asentamiento Precario",
				"decada_1990",
				"931",
				"54.6000000000000010000000000000000",
				"526, 34, 161, 167",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0402039285748,-34.9505171280586,0.0 -58.0381030637633,-34.9520915872378,0.0 -58.0385483902864,-34.9524889146106,0.0 -58.039673289539,-34.9516477793865,0.0 -58.0406520121642,-34.9509182773994,0.0 -58.0402039285748,-34.9505171280586,0.0 ",
				"Polygon Outer Boundary",
				"363",
				"0550089",
				"La Plata",
				"Melchor Romero",
				"0089",
				"2014/10/15",
				"167 & 524",
				"Asentamiento Precario",
				"decada_1990",
				"43",
				"1.6000000000000001000000000000000",
				"524, 526, 167",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.75835090875625,-38.548991917720784,0.0 -58.75688147731125,-38.550103684912145,0.0 -58.756886841729276,-38.550154028680005,0.0 -58.75771832652391,-38.550804299180086,0.0 -58.75776124186814,-38.550804299180086,0.0 -58.7594671268016,-38.549507947649225,0.0 -58.75947249121964,-38.549394673104125,0.0 -58.75894904136658,-38.548991917720784,0.0 -58.75862717628479,-38.54922685863522,0.0 -58.75835090875625,-38.548991917720784,0.0 ",
				"Polygon Outer Boundary",
				"1579",
				"0760007",
				"Necochea",
				"Necochea",
				"0007",
				"2015/04/21",
				"Plan Federal Nº13",
				"Otros",
				"2013",
				"28",
				"2.2400000000000002000000000000000",
				"calles 82 - 86 - 71 - 73",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0428814407853,-34.9379697320337,0.0 -58.0436164528438,-34.9374681971075,0.0 -58.0427497968619,-34.9364085101977,0.0 -58.0426686982996,-34.9365600191589,0.0 -58.0402206400029,-34.9334355168467,0.0 -58.0395286786363,-34.9338941401988,0.0 -58.0357744354786,-34.9367655749214,0.0 -58.0357733741017,-34.9368100774855,0.0 -58.0396440873677,-34.9403530008737,0.0 -58.0396924463025,-34.9403581974253,0.0 -58.0428814407853,-34.9379697320337,0.0 ",
				"Polygon Outer Boundary",
				"368",
				"0550094",
				"La Plata",
				"Melchor Romero",
				"0094",
				"2014/10/15",
				"Las Rosas",
				"Asentamiento Precario",
				"decada_1990",
				"666",
				"28.3999999999999990000000000000000",
				"515, 519, 155, 161",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.011631259457,-34.9546394067413,0.0 -58.0106194933845,-34.9537019063186,0.0 -58.009765148162835,-34.95434611092846,0.0 -58.00878882408142,-34.95347995166295,0.0 -58.00857961177825,-34.95364702878199,0.0 -58.0105633833675,-34.955409472135,0.0 -58.0095018440493,-34.9562590141375,0.0 -58.0104651888132,-34.9571148621404,0.0 -58.0115005288289,-34.9563654006042,0.0 -58.0114755164706,-34.9563572665143,0.0 -58.0126017050224,-34.955487983521,0.0 -58.011631259457,-34.9546394067413,0.0 ",
				"Polygon Outer Boundary",
				"384",
				"0550110",
				"La Plata",
				"Lisandro Olmos",
				"0110",
				"2014/10/24",
				"155 & 41",
				"Asentamiento Precario",
				"decada_1990",
				"129",
				"5.6699999999999999000000000000000",
				"41 e/155 y 158",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9642354402649,-34.9651758005245,0.0 -57.9637703738828,-34.9655173928354,0.0 -57.9634878067334,-34.9655224759488,0.0 -57.9630533882735,-34.9658507913056,0.0 -57.9635407842175,-34.966279013803,0.0 -57.9635956504905,-34.9662782219206,0.0 -57.9641778144984,-34.9658765020694,0.0 -57.964631969994,-34.9655378794585,0.0 -57.9642354402649,-34.9651758005245,0.0 ",
				"Polygon Outer Boundary",
				"393",
				"0550119",
				"La Plata",
				"Los Hornos",
				"0119",
				"2014/10/31",
				"75 & 142",
				"Asentamiento Precario",
				"decada_1990",
				"135",
				"9.8000000000000007000000000000000",
				"141, 144, 72, 76",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9622884687276,-34.9642165305341,0.0 -57.9621227870071,-34.9643511811417,0.0 -57.9611632142903,-34.9650512461865,0.0 -57.9609533280056,-34.9651229712623,0.0 -57.9601388296629,-34.9657242606925,0.0 -57.9594816872012,-34.9662086908029,0.0 -57.9594785201348,-34.9662348622196,0.0 -57.9605609383382,-34.9672221020781,0.0 -57.9613195424583,-34.9679357905573,0.0 -57.9613576981135,-34.9679334580784,0.0 -57.9625403384596,-34.9690266308739,0.0 -57.9640411538935,-34.9678817946346,0.0 -57.9631460382886,-34.9670531606088,0.0 -57.9628536679837,-34.9667940514496,0.0 -57.9614593723493,-34.9655402494954,0.0 -57.961531467219,-34.9653477941069,0.0 -57.9624378330241,-34.9646744096327,0.0 -57.9626590423306,-34.9645033811548,0.0 -57.9634063183642,-34.9639542068942,0.0 -57.9630711105648,-34.9636493873735,0.0 -57.9627853712547,-34.9638579949478,0.0 -57.9622884687276,-34.9642165305341,0.0 ",
				"Polygon Outer Boundary",
				"393",
				"0550119",
				"La Plata",
				"Los Hornos",
				"0119",
				"2014/10/31",
				"75 & 142",
				"Asentamiento Precario",
				"decada_1990",
				"135",
				"9.8000000000000007000000000000000",
				"141, 144, 72, 76",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.8742947249675,-34.9464536479922,0.0 -57.8742643504501,-34.9464785455643,0.0 -57.8735102906515,-34.9470641060766,0.0 -57.8750222606767,-34.9480918372319,0.0 -57.8771851733359,-34.9489230948622,0.0 -57.8742947249675,-34.9464536479922,0.0 ",
				"Polygon Outer Boundary",
				"406",
				"0550131",
				"La Plata",
				"Villa Elvira",
				"0131",
				"2014/10/31",
				"Alegre - Villa Alba",
				"Asentamiento Precario",
				"2011",
				"70",
				"2.3999999999999999000000000000000",
				"119, 122, 613, 614",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.8428370738265,-34.6607835009452,0.0 -58.843130043869,-34.6609824192169,0.0 -58.842759614814,-34.6613684404642,0.0 -58.8431859035184,-34.6616490604781,0.0 -58.8432395338837,-34.6616441611671,0.0 -58.8439432764108,-34.660936231922,0.0 -58.8447555047843,-34.6601135006145,0.0 -58.844750359423,-34.6600676623276,0.0 -58.8435969751897,-34.6592837134693,0.0 -58.84376049041747,-34.65843381980632,0.0 -58.84306311607361,-34.65665996029555,0.0 -58.84223699569702,-34.6569070673791,0.0 -58.8430094718933,-34.65880447222194,0.0 -58.842247724533074,-34.65915747298131,0.0 -58.8417021811992,-34.6596041894052,0.0 -58.8416929937816,-34.6596764819955,0.0 -58.8419459044276,-34.6603001077742,0.0 -58.841970387934616,-34.660304486638154,0.0 -58.841982629688125,-34.66030667607003,0.0 -58.841988750564866,-34.66030777078599,0.0 -58.8419948714416,-34.6603088655019,0.0 -58.842386793401,-34.6599185094078,0.0 -58.8428295946287,-34.6600660308382,0.0 -58.8432524742579,-34.6603519921195,0.0 -58.8428370738265,-34.6607835009452,0.0 ",
				"Polygon Outer Boundary",
				"71",
				"0740027",
				"Moreno",
				"La Reja",
				"0027",
				"2014/09/11",
				"Benito Juárez & Balaguer",
				"Asentamiento Precario",
				"2013",
				"65",
				"5.9199999999999999000000000000000",
				"Benito Juarez- Balaguer-del Valle Inclan- Garcilaso de la Vega",
				"Inexistente",
				"Sin dato",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.643646240234375,-34.80154097303929,0.0 -58.646886348724365,-34.80429839762429,0.0 -58.64941835403442,-34.80222813539893,0.0 -58.64808797836303,-34.80120619955819,0.0 -58.64705801010131,-34.80212241848569,0.0 -58.64505171775818,-34.80031640027573,0.0 -58.64431142807007,-34.80092428399328,0.0 -58.643646240234375,-34.80154097303929,0.0 ",
				"Polygon Outer Boundary",
				"1041",
				"0700089",
				"La Matanza",
				"Virrey Del Pino",
				"0089",
				"2014/10/01",
				"Las Camelias",
				"Asentamiento Precario",
				"decada_2000",
				"206",
				"10.1700000000000000000000000000000",
				"Chivilcoy, San Luis, Comercio",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9054747678765,-34.9397801611281,0.0 -57.9056353519148,-34.9396729392694,0.0 -57.9030062411494,-34.9370577657551,0.0 -57.902746016899,-34.9372632557237,0.0 -57.9054747678765,-34.9397801611281,0.0 ",
				"Polygon Outer Boundary",
				"289",
				"0550013",
				"La Plata",
				"Villa Elvira",
				"0013",
				"2014/06/30",
				"Villa Montoro  1",
				"Villa",
				"2001",
				"40",
				"2.5000000000000000000000000000000",
				"90 de 3 a 116 (sobre la 90)",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9240216320676,-34.9561876872395,0.0 -57.921080589294434,-34.953510729052574,0.0 -57.92067289352416,-34.95381850231318,0.0 -57.9236279573778,-34.9565845449326,0.0 -57.9243954189746,-34.9572704464974,0.0 -57.9258239870447,-34.9585354333111,0.0 -57.9261934705678,-34.9582035205259,0.0 -57.9255016438492,-34.9575403063662,0.0 -57.9240216320676,-34.9561876872395,0.0 ",
				"Polygon Outer Boundary",
				"291",
				"0550017",
				"La Plata",
				"Altos De San Lorenzo",
				"0017",
				"2014/08/05",
				"90 & 19",
				"Villa",
				"1984",
				"100",
				"3.7700000000000000000000000000000",
				"90 e/19 y 22",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9484897477813,-34.9520500893366,0.0 -57.9484858742195,-34.9515741605603,0.0 -57.9481698092742,-34.9517835876641,0.0 -57.9484897477813,-34.9520500893366,0.0 ",
				"Polygon Outer Boundary",
				"294",
				"0550019",
				"La Plata",
				"Altos De San Lorenzo",
				"0019",
				"2014/08/05",
				"Los Chaques",
				"Villa",
				"1994",
				"15",
				"0.0800000000000000020000000000000",
				"29, 73 y las vías",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9242881476428,-34.9434312428496,0.0 -57.9229734379902,-34.9445778723067,0.0 -57.923120633198,-34.9447170098536,0.0 -57.9245196110212,-34.9436372333995,0.0 -57.9242881476428,-34.9434312428496,0.0 ",
				"Polygon Outer Boundary",
				"295",
				"0550020",
				"La Plata",
				"Villa Elvira",
				"0020",
				"2014/08/05",
				"81 & 13",
				"Villa",
				"decada_1990",
				"30",
				"0.3200000000000000100000000000000",
				"81 a 83 e/ 12 bis y 13",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9209387819681,-34.9532394921587,0.0 -57.923602609133,-34.9556822301316,0.0 -57.9241627552057,-34.9552024725521,0.0 -57.9252334027232,-34.9544253771101,0.0 -57.9257083227849,-34.9539554129517,0.0 -57.9284702054702,-34.9514577084758,0.0 -57.9277660099341,-34.9508066544186,0.0 -57.9272185014827,-34.9503098634381,0.0 -57.9262554140704,-34.9494372914604,0.0 -57.9256887626081,-34.9499333580528,0.0 -57.9255294568423,-34.9498051912815,0.0 -57.9209387819681,-34.9532394921587,0.0 ",
				"Polygon Outer Boundary",
				"288",
				"0550022",
				"La Plata",
				"Altos De San Lorenzo",
				"0022",
				"2014/08/05",
				"La Cantera",
				"Villa",
				"2008",
				"295",
				"19.3099999999999990000000000000000",
				"17 a 19 - 84 a 89",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9151910313946,-34.9267977816112,0.0 -57.9156713940287,-34.9264281777444,0.0 -57.9151509147397,-34.9259658262187,0.0 -57.9147852413468,-34.9256207794898,0.0 -57.9145842247648,-34.9257984550595,0.0 -57.9148969749992,-34.9261237643838,0.0 -57.9146592162625,-34.926299967563,0.0 -57.9151910313946,-34.9267977816112,0.0 ",
				"Polygon Outer Boundary",
				"300",
				"0550026",
				"La Plata",
				"Villa Elvira",
				"0026",
				"2014/08/20",
				"116 & 77",
				"Asentamiento Precario",
				"decada_1990",
				"30",
				"0.5600000000000000500000000000000",
				"76-116-117 hacia 77",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-57.8832243116267,-34.9606636205197,0.0 -57.88745370067,-34.9574907202622,0.0 -57.8863257548665,-34.9565866647344,0.0 -57.8862501385569,-34.9566756058954,0.0 -57.8847883144804,-34.9552756312184,0.0 -57.8807113993634,-34.9583155391747,0.0 -57.8832243116267,-34.9606636205197,0.0 ",
				"Polygon Outer Boundary",
				"303",
				"0550029",
				"La Plata",
				"Villa Elvira",
				"0029",
				"2014/08/20",
				"Frison",
				"Villa",
				"2001",
				"100",
				"17.6000000000000010000000000000000",
				"613bis a 619 - 3 a 5",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9855959838913,-34.9686306120781,0.0 -57.9847759351192,-34.9678688297987,0.0 -57.9847295578078,-34.9678671587085,0.0 -57.9837996374131,-34.9685604168725,0.0 -57.9830560527016,-34.969123477544,0.0 -57.9835238106775,-34.9695450771423,0.0 -57.9836161970212,-34.9694786616505,0.0 -57.9840367880498,-34.9698728906062,0.0 -57.9846712990876,-34.9693558673681,0.0 -57.9855912249795,-34.9686684741135,0.0 -57.9855959838913,-34.9686306120781,0.0 ",
				"Polygon Outer Boundary",
				"382",
				"0550108",
				"La Plata",
				"Los Hornos",
				"0108",
				"2014/10/24",
				"65 & 153",
				"Otros",
				"decada_1990",
				"78",
				"2.3999999999999999000000000000000",
				"64, 65, 153, 154",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9598924717848,-34.8849824985876,0.0 -57.9598934426622,-34.8849388066197,0.0 -57.9586818332858,-34.8838307169145,0.0 -57.9577478231539,-34.8845332377226,0.0 -57.9577083801159,-34.8848254120546,0.0 -57.9576042322013,-34.8862980263115,0.0 -57.9578437634639,-34.8865183400894,0.0 -57.958727949421,-34.8858530593712,0.0 -57.9598924717848,-34.8849824985876,0.0 ",
				"Polygon Outer Boundary",
				"339",
				"0550067",
				"La Plata",
				"Tolosa",
				"0067",
				"2014/10/07",
				"La Bajada",
				"Asentamiento Precario",
				"decada_1980",
				"106",
				"3.3999999999999999000000000000000",
				"121, 122, 528, 530",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9200021944359,-34.9504274353887,0.0 -57.9182218760952,-34.9487864327143,0.0 -57.9171297011841,-34.9497463263674,0.0 -57.9178433395379,-34.9503944237236,0.0 -57.9188954054359,-34.9512459412571,0.0 -57.9189425206599,-34.9512482808193,0.0 -57.9199996111291,-34.950469025885,0.0 -57.9200021944359,-34.9504274353887,0.0 ",
				"Polygon Outer Boundary",
				"391",
				"0550117",
				"La Plata",
				"Altos De San Lorenzo",
				"0117",
				"2014/10/24",
				"26 de Julio",
				"Otros",
				"1992",
				"60",
				"3.3999999999999999000000000000000",
				"88, 90, 13, 15",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.18225968629122,-34.86111779140251,0.0 -58.18899739533662,-34.855905990588916,0.0 -58.188718445599086,-34.855677086361865,0.0 -58.187581188976765,-34.85665432688641,0.0 -58.18437326699495,-34.855589046104946,0.0 -58.18225968629122,-34.86111779140251,0.0 ",
				"Polygon Outer Boundary",
				"1578",
				"0320025",
				"Florencio Varela",
				"Ingeniero Allan",
				"0025",
				"2015/04/21",
				"El Parque",
				"Asentamiento Precario",
				"1992",
				"900",
				"11.6199999999999990000000000000000",
				"Diag. Fontana, diag. Perito Moreno, Ruta Provincial N 36",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.689810518175356,-33.66531806779736,0.0 -59.6894028224051,-33.6647822960639,0.0 -59.68723559752106,-33.66500553469169,0.0 -59.686538223177195,-33.66501446422475,0.0 -59.684826135635376,-33.66503232328808,0.0 -59.68319535255432,-33.665300208793326,0.0 -59.6807062625885,-33.66590741285007,0.0 -59.676704406738274,-33.66629137790918,0.0 -59.67514872550964,-33.66686285761409,0.0 -59.67278838157654,-33.668407619688956,0.0 -59.670363664627075,-33.66940768207639,0.0 -59.66959118843078,-33.66880050272788,0.0 -59.668593406677246,-33.66927374582386,0.0 -59.667386412620544,-33.67009075372004,0.0 -59.66897964477539,-33.671992610892794,0.0 -59.67204809188842,-33.670202366218085,0.0 -59.67270255088806,-33.67091668277579,0.0 -59.673700332641594,-33.67027379814083,0.0 -59.673110246658325,-33.66955947624379,0.0 -59.67749834060669,-33.66705930288579,0.0 -59.67787384986877,-33.667737928554324,0.0 -59.67977285385132,-33.66712180810543,0.0 -59.680405855178826,-33.66791651336671,0.0 -59.68346357345581,-33.66610386030373,0.0 -59.684364795684814,-33.667050373565,0.0 -59.68559408560395,-33.666541400747256,0.0 -59.686033967882395,-33.66596991890672,0.0 -59.686870817095034,-33.66561274082841,0.0 -59.6873858012259,-33.66577347114717,0.0 -59.68799734488129,-33.66550558711573,0.0 -59.688362125307314,-33.6655234460771,0.0 -59.68917751684785,-33.66540736276183,0.0 -59.689810518175356,-33.66531806779736,0.0 ",
				"Polygon Outer Boundary",
				"1919",
				"0990012",
				"San Pedro",
				"San Pedro",
				"0012",
				"2015/07/15",
				"La Barranca",
				"Villa",
				"90_o_anterior",
				"560",
				"33.9099999999999970000000000000000",
				"San Lorenzo, La Laguna, Gimenez",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.67263298109174,-33.67101043638356,0.0 -59.671946335583925,-33.671416700836254,0.0 -59.67114686965943,-33.67184528543146,0.0 -59.67154383659362,-33.672367620019195,0.0 -59.67233793810009,-33.6718899295373,0.0 -59.673046041280024,-33.67147473845855,0.0 -59.67263298109174,-33.67101043638356,0.0 ",
				"Polygon Outer Boundary",
				"1919",
				"0990012",
				"San Pedro",
				"San Pedro",
				"0012",
				"2015/07/15",
				"La Barranca",
				"Villa",
				"90_o_anterior",
				"560",
				"33.9099999999999970000000000000000",
				"San Lorenzo, La Laguna, Gimenez",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.7312346160803,-34.7030333774701,0.0 -58.7259215742375,-34.7065916050407,0.0 -58.7278079290333,-34.7073876794802,0.0 -58.7321345636974,-34.7044352070722,0.0 -58.7312346160803,-34.7030333774701,0.0 ",
				"Polygon Outer Boundary",
				"660",
				"0720002",
				"Merlo",
				"Parque San Martín",
				"0002",
				"2014/10/01",
				"Gral. Belgrano",
				"Otros",
				"90_o_anterior",
				"500",
				"10.0200000000000000000000000000000",
				"A. Brown, Pizarro, Aguado y Lafayette",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.48588490858674,-34.733615809013195,0.0 -58.4839859046042,-34.733536455401946,0.0 -58.48219418898225,-34.73626970256783,0.0 -58.483417276293046,-34.736754624074194,0.0 -58.48377585411071,-34.736895691614436,0.0 -58.48588490858674,-34.733615809013195,0.0 ",
				"Polygon Outer Boundary",
				"1440",
				"0630065",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0065",
				"2015/03/10",
				"Mariscal Sucre",
				"Asentamiento Precario",
				"90_o_anterior",
				"370",
				"6.0300000000000002000000000000000",
				"Av. Brig. Juan Manuel de Rosas; Av. la Noria, calle 4 , Av. 102",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9343343126298,-34.944956542187,0.0 -57.933376645575,-34.9456444927462,0.0 -57.932379421299,-34.9449642685895,0.0 -57.9317313797315,-34.9453353276191,0.0 -57.9325688266606,-34.9460957381013,0.0 -57.9332088270426,-34.9457250331754,0.0 -57.9342216351772,-34.9466378469643,0.0 -57.9352989205875,-34.9458435800387,0.0 -57.9343343126298,-34.944956542187,0.0 ",
				"Polygon Outer Boundary",
				"293",
				"0550018",
				"La Plata",
				"Altos De San Lorenzo",
				"0018",
				"2014/08/05",
				"19 & 77",
				"Asentamiento Precario",
				"decada_1990",
				"68",
				"2.6800000000000002000000000000000",
				"77 a 79 y 19 a 17",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.8889234935001,-34.9420048324,0.0 -57.8877779933033,-34.9428448180278,0.0 -57.8867598897158,-34.9435898623614,0.0 -57.8877778084049,-34.9445178709486,0.0 -57.8888430951209,-34.9438172392931,0.0 -57.8903951971771,-34.9452998903926,0.0 -57.8904450872823,-34.9453048124665,0.0 -57.8911412731171,-34.9447917878981,0.0 -57.8920254675075,-34.9455613385464,0.0 -57.8920197546805,-34.9457459812943,0.0 -57.8914323520167,-34.9461736656779,0.0 -57.8914249258765,-34.9462200376047,0.0 -57.8921241807726,-34.9468610218506,0.0 -57.8921850117806,-34.9468661331579,0.0 -57.8932471512791,-34.946093690686,0.0 -57.8932479387865,-34.9460500872225,0.0 -57.8907500055079,-34.943694219148,0.0 -57.8889234935001,-34.9420048324,0.0 ",
				"Polygon Outer Boundary",
				"305",
				"0550031",
				"La Plata",
				"Villa Elvira",
				"0031",
				"2014/08/20",
				"Villa Montoro 4",
				"Asentamiento Precario",
				"2000",
				"150",
				"10.6099999999999990000000000000000",
				"116 a 119bis - 602 a 604",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.043101722995,-34.9381818505021,0.0 -58.0438678251908,-34.9388190452066,0.0 -58.0445623107816,-34.9395062816121,0.0 -58.044778032409,-34.9393647002747,0.0 -58.0459687459034,-34.9408341409782,0.0 -58.0456539127118,-34.9410865421592,0.0 -58.0480758808165,-34.9434343704429,0.0 -58.0486406367475,-34.9439351583556,0.0 -58.0489031043254,-34.94383347528,0.0 -58.0482503361513,-34.9431340373014,0.0 -58.0473405437067,-34.9420107133987,0.0 -58.0437612580844,-34.937688011442,0.0 -58.043101722995,-34.9381818505021,0.0 ",
				"Polygon Outer Boundary",
				"366",
				"0550092",
				"La Plata",
				"Melchor Romero",
				"0092",
				"2014/10/15",
				"Las Margaritas",
				"Villa",
				"1998",
				"60",
				"3.8999999999999999000000000000000",
				"515, 516bis, 167, 161 sobre vias",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.5185683913919,-34.5607784200407,0.0 -58.51917028427123,-34.560073007876724,0.0 -58.518971800804145,-34.55996256357247,0.0 -58.51888060569763,-34.56001557685681,0.0 -58.51830124855041,-34.559715167798785,0.0 -58.518344163894646,-34.55966657211392,0.0 -58.518075942993164,-34.55950311369284,0.0 -58.51799547672272,-34.55961355860714,0.0 -58.518467545509345,-34.55986537246342,0.0 -58.51823687553406,-34.56015252768498,0.0 -58.51778090000152,-34.559913968032134,0.0 -58.51756945141,-34.5601871805026,0.0 -58.5175786437864,-34.5602155944333,0.0 -58.5180276224951,-34.560480001542,0.0 -58.5180822953809,-34.5605122023291,0.0 -58.5181813798497,-34.5605705601612,0.0 -58.5185332125537,-34.560777722464,0.0 -58.5185683913919,-34.5607784200407,0.0 ",
				"Polygon Outer Boundary",
				"788",
				"0470079",
				"General San Martin",
				"General San Martin",
				"0079",
				"2014/10/01",
				"La Segunda",
				"Villa",
				"90_o_anterior",
				"94",
				"0.8299999999999999600000000000000",
				"De los Constituyentes y Matheu",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.487794641405344,-34.73342183338451,0.0 -58.48813796415925,-34.73246958278547,0.0 -58.48540211096406,-34.73237259368284,0.0 -58.48392153158784,-34.732407862460605,0.0 -58.48353529348969,-34.73335129667937,0.0 -58.487794641405344,-34.73342183338451,0.0 ",
				"Polygon Outer Boundary",
				"1439",
				"0630064",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0064",
				"2015/03/10",
				"Av. la Noria & Av. 102",
				"Asentamiento Precario",
				"decada_1990",
				"70",
				"4.2400000000000002000000000000000",
				"Av. la Noria, Av. 102 y Río Matanza",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.699146676808596,-34.43152724901687,0.0 -58.69884610176086,-34.43140336053413,0.0 -58.69909286499024,-34.431089213915364,0.0 -58.69878189638257,-34.43089895552991,0.0 -58.69880335405469,-34.43072197059647,0.0 -58.69887309148907,-34.430562683835966,0.0 -58.698910642415285,-34.4303458763686,0.0 -58.69935588911175,-34.430589231650465,0.0 -58.69966166093945,-34.43017773957816,0.0 -58.7002839334309,-34.42934147525383,0.0 -58.69882481172681,-34.428562724232776,0.0 -58.698492217808955,-34.42896537481429,0.0 -58.69850294664502,-34.42942111983567,0.0 -58.698669243603945,-34.42986801302619,0.0 -58.69849758222699,-34.43020871217023,0.0 -58.698213268071406,-34.43058480701529,0.0 -58.69851887226105,-34.43077064149053,0.0 -58.698266744613655,-34.43111576156262,0.0 -58.69841175153851,-34.43119982905666,0.0 -58.69826154783368,-34.431407785125955,0.0 -58.69854049757123,-34.43158919318938,0.0 -58.69834737852216,-34.43177945000363,0.0 -58.698797821998596,-34.43202722567055,0.0 -58.699146676808596,-34.43152724901687,0.0 ",
				"Polygon Outer Boundary",
				"2248",
				"0570045",
				"Tigre",
				"Benavidez",
				"0045",
				"2015/09/24",
				"Arroyo El Claro III",
				"Villa",
				"90_o_anterior",
				"170",
				"3.1499999999999999000000000000000",
				"El Salvador, Ecuador",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.5961489757026,-34.5369854772045,0.0 -58.5936503986007,-34.5389909972277,0.0 -58.5937387592474,-34.5390779150435,0.0 -58.5938757868632,-34.5391555672758,0.0 -58.5939516700174,-34.5391448136912,0.0 -58.5951081971024,-34.5382001674461,0.0 -58.5960168777576,-34.537457988499,0.0 -58.5964089902416,-34.5371793809334,0.0 -58.5962705432737,-34.5370630468957,0.0 -58.5961489757026,-34.5369854772045,0.0 ",
				"Polygon Outer Boundary",
				"775",
				"0470092",
				"General San Martin",
				"General San Martin",
				"0092",
				"2014/10/01",
				"Plazoleta 9 de Julio",
				"Villa",
				"90_o_anterior",
				"110",
				"0.9799999999999999800000000000000",
				"9 de Julio entre 3 y 6",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.693535663187504,-34.72894263314316,0.0 -58.69261298328638,-34.72968330505237,0.0 -58.69068179279565,-34.72813141343675,0.0 -58.68845019489526,-34.72985083706379,0.0 -58.69118604809045,-34.73225797005119,0.0 -58.69445834308863,-34.72966567008405,0.0 -58.693535663187504,-34.72894263314316,0.0 ",
				"Polygon Outer Boundary",
				"2315",
				"0720071",
				"Merlo",
				"Pontevedra",
				"0071",
				"2015/10/08",
				"Circuito",
				"Asentamiento Precario",
				"90_o_anterior",
				"100",
				"11.8800000000000010000000000000000",
				"Montes de Oca, Ushuaia, Valdivia",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.8909486041551,-34.9404698954998,0.0 -57.8889930163958,-34.9419183562291,0.0 -57.8908450544065,-34.943683508463,0.0 -57.892749678036,-34.9454539618031,0.0 -57.8947838851441,-34.9439492191561,0.0 -57.8919221020479,-34.941323095062,0.0 -57.8909486041551,-34.9404698954998,0.0 ",
				"Polygon Outer Boundary",
				"306",
				"0550032",
				"La Plata",
				"Villa Elvira",
				"0032",
				"2014/08/20",
				"Barrio Alegre",
				"Asentamiento Precario",
				"2008",
				"200",
				"16.1000000000000010000000000000000",
				"116 a 119 - 600 a 602",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.898559367984,-34.9474040502145,0.0 -57.8980882228721,-34.9477544752182,0.0 -57.8974518184015,-34.9482302723284,0.0 -57.8969304899937,-34.9486194780477,0.0 -57.897151609973,-34.9488281461486,0.0 -57.8974618942522,-34.949119734508,0.0 -57.8981145197239,-34.9497426438658,0.0 -57.8983234101511,-34.9499242643806,0.0 -57.8987728270248,-34.9503397368962,0.0 -57.9004431973668,-34.9491070687081,0.0 -57.8988297757954,-34.9476691688998,0.0 -57.898559367984,-34.9474040502145,0.0 ",
				"Polygon Outer Boundary",
				"297",
				"0550023",
				"La Plata",
				"Villa Elvira",
				"0023",
				"2014/08/20",
				"Agosti, Carlos",
				"Asentamiento Precario",
				"2007",
				"250",
				"5.0000000000000000000000000000000",
				"4 a 6 - 99 a 602",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9006121110993,-34.947831212881,0.0 -57.8998056450157,-34.9470953299322,0.0 -57.8990408843644,-34.9476576283888,0.0 -57.8998390406353,-34.9483903645392,0.0 -57.9006121110993,-34.947831212881,0.0 ",
				"Polygon Outer Boundary",
				"297",
				"0550023",
				"La Plata",
				"Villa Elvira",
				"0023",
				"2014/08/20",
				"Agosti, Carlos",
				"Asentamiento Precario",
				"2007",
				"250",
				"5.0000000000000000000000000000000",
				"4 a 6 - 99 a 602",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.8758978496284,-34.9708403271481,0.0 -57.875649333000176,-34.97064754321314,0.0 -57.8754420353323,-34.9707823365703,0.0 -57.8749960810727,-34.9711243666068,0.0 -57.8743028640747,-34.97173770668633,0.0 -57.87445306777954,-34.971843205607335,0.0 -57.87485003471375,-34.97156627064993,0.0 -57.8753113746643,-34.972010245287684,0.0 -57.87545621395111,-34.97188276766768,0.0 -57.87754833698272,-34.97371139315884,0.0 -57.878326177597046,-34.973078412031775,0.0 -57.8758978496284,-34.9708403271481,0.0 ",
				"Polygon Outer Boundary",
				"302",
				"0550028",
				"La Plata",
				"Villa Elvira",
				"0028",
				"2014/08/20",
				"Padre Cajade",
				"Asentamiento Precario",
				"1994",
				"60",
				"4.0999999999999996000000000000000",
				"7 a 10 - 630 a 632",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.8844244577706,-34.9414320559121,0.0 -57.884362619161,-34.9414280046502,0.0 -57.8836314957502,-34.9419619150504,0.0 -57.8833748307771,-34.9421512895196,0.0 -57.8830529160025,-34.9423873739841,0.0 -57.882570729179,-34.9427402493004,0.0 -57.882562109072,-34.9427860590941,0.0 -57.883973972403,-34.9440692568201,0.0 -57.8858252791895,-34.9427065689757,0.0 -57.8844244577706,-34.9414320559121,0.0 ",
				"Polygon Outer Boundary",
				"304",
				"0550030",
				"La Plata",
				"Villa Elvira",
				"0030",
				"2014/08/20",
				"119 & 604",
				"Asentamiento Precario",
				"2000",
				"50",
				"4.9000000000000004000000000000000",
				"119 a 121B - 604 a 606B",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.884130477905266,-34.93797107434475,0.0 -57.88328826427459,-34.938525170388445,0.0 -57.8839323671043,-34.9391940545124,0.0 -57.8847150146518,-34.9385887535924,0.0 -57.884130477905266,-34.93797107434475,0.0 ",
				"Polygon Outer Boundary",
				"301",
				"0550027",
				"La Plata",
				"Villa Elvira",
				"0027",
				"2014/08/20",
				"Villa Alba",
				"Asentamiento Precario",
				"1998",
				"40",
				"0.8900000000000000100000000000000",
				"122 - 123 - 602 - 603",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.331941366195686,-34.74510364439632,0.0 -58.33084166049957,-34.744477717536114,0.0 -58.33049833774567,-34.74490528780608,0.0 -58.33158195018768,-34.745535619322524,0.0 -58.331941366195686,-34.74510364439632,0.0 ",
				"Polygon Outer Boundary",
				"1411",
				"0860067",
				"Quilmes",
				"Quilmes",
				"0067",
				"2015/02/18",
				"La Arboleda",
				"Villa",
				"2009",
				"48",
				"0.6999999999999999600000000000000",
				"Calle 192 y Andrade",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.332550060003996,-34.744270543516585,0.0 -58.33161128684879,-34.7437107302693,0.0 -58.33103192970157,-34.74443804595558,0.0 -58.33197606727481,-34.74501989389409,0.0 -58.332550060003996,-34.744270543516585,0.0 ",
				"Polygon Outer Boundary",
				"1410",
				"0860066",
				"Quilmes",
				"Quilmes",
				"0066",
				"2015/02/18",
				"Total Gas",
				"Villa",
				"2011",
				"120",
				"1.0400000000000000000000000000000",
				"Calle 192 y Braggio",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.513280153274536,-34.517174249608885,0.0 -58.5134825553268,-34.5168661775622,0.0 -58.5134584597464,-34.5168249631847,0.0 -58.51326942443847,-34.5167410839334,0.0 -58.513060212135315,-34.51706374837503,0.0 -58.513280153274536,-34.517174249608885,0.0 ",
				"Polygon Outer Boundary",
				"662",
				"1100017",
				"Vicente Lopez",
				"Olivos",
				"0017",
				"2014/10/01",
				"Borges & Rosetti",
				"Villa",
				"2003",
				"25",
				"0.1000000000000000100000000000000",
				"Borges, Rosetti",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-57.8860103226548,-34.9496437759403,0.0 -57.8852149980653,-34.9489086205211,0.0 -57.8839176529687,-34.9499922817813,0.0 -57.8840435184747,-34.9502767685743,0.0 -57.8830812219843,-34.9509561246179,0.0 -57.8819226725033,-34.9501471187763,0.0 -57.8844488875359,-34.9481664115812,0.0 -57.8830497754176,-34.9469071082289,0.0 -57.8788436791027,-34.9500332434822,0.0 -57.8803680535221,-34.951404825048,0.0 -57.8834215095128,-34.9538589442208,0.0 -57.8855381732569,-34.952309222104,0.0 -57.8872505175251,-34.9534870239373,0.0 -57.8889619138664,-34.9522669434261,0.0 -57.8860103226548,-34.9496437759403,0.0 ",
				"Polygon Outer Boundary",
				"290",
				"0550016",
				"La Plata",
				"Villa Elvira",
				"0016",
				"2014/06/30",
				"Joel",
				"Asentamiento Precario",
				"2004",
				"900",
				"30.9899999999999980000000000000000",
				"1 a 117 de 609 a 614",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.728726580739014,-34.725829975069104,0.0 -58.725379183888435,-34.728563477097424,0.0 -58.72673101723194,-34.72981556719488,0.0 -58.730056285858154,-34.72697629337646,0.0 -58.728726580739014,-34.725829975069104,0.0 ",
				"Polygon Outer Boundary",
				"2317",
				"0720073",
				"Merlo",
				"Pontevedra",
				"0073",
				"2015/10/08",
				"Isabel de Barnes & Albarino",
				"Asentamiento Precario",
				"90_o_anterior",
				"150",
				"7.8799999999999999000000000000000",
				"Isabel de Barnes, Albarino, Bella Vista",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.3498853445053,-34.69926621140444,0.0 -58.350309133529656,-34.69849439420523,0.0 -58.3492868805753,-34.6976033583377,0.0 -58.348793889008,-34.6980011066104,0.0 -58.3486753208418,-34.6978785282771,0.0 -58.3479147574269,-34.6972609244008,0.0 -58.3474669250639,-34.6976274464207,0.0 -58.3497394442972,-34.699542587965,0.0 -58.349992632865906,-34.699350008267125,0.0 -58.3498853445053,-34.69926621140444,0.0 ",
				"Polygon Outer Boundary",
				"533",
				"0040016",
				"Avellaneda",
				"Avellaneda",
				"0016",
				"2014/10/31",
				"La Tierrita",
				"Villa",
				"1970",
				"262",
				"2.6099999999999999000000000000000",
				"El Salvador y Cnel La Fuente (lateral Cementerio)",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.3587194528093,-34.7012240712927,0.0 -58.3587352837333,-34.7012348160323,0.0 -58.3608991187924,-34.7031639021325,0.0 -58.3619353686857,-34.7022878618167,0.0 -58.3598410162161,-34.7004218898748,0.0 -58.358952467622,-34.7010422334276,0.0 -58.3587198675362,-34.701221071848,0.0 -58.3587194528093,-34.7012240712927,0.0 ",
				"Polygon Outer Boundary",
				"517",
				"0040001",
				"Avellaneda",
				"Avellaneda",
				"0001",
				"2014/10/31",
				"7 de Enero",
				"Villa",
				"2000",
				"198",
				"3.9199999999999999000000000000000",
				"Camino Gral Belgrano, Predio/Parcela Privada, Barrio Honor y Dignidad",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.64268947020173,-33.68746037976837,0.0 -59.64204574003816,-33.68673727336508,0.0 -59.64073682203889,-33.689638589453956,0.0 -59.639106038957834,-33.69039737904347,0.0 -59.63779712095857,-33.691165088751305,0.0 -59.63678861036897,-33.692459467496974,0.0 -59.63606977835297,-33.69348602988089,0.0 -59.63423514738678,-33.695235620986445,0.0 -59.63446045294403,-33.69635141303647,0.0 -59.63473940268158,-33.69666383221399,0.0 -59.63501835241914,-33.69684235694826,0.0 -59.63517928496003,-33.69683343072036,0.0 -59.63521147146821,-33.69666383221399,0.0 -59.63491106405854,-33.69623537133836,0.0 -59.63467502966523,-33.695914024279524,0.0 -59.63469648733735,-33.6955748233025,0.0 -59.63694954290986,-33.69355744246007,0.0 -59.63762545958162,-33.693075406398904,0.0 -59.63773274794221,-33.69250410089909,0.0 -59.63804388418793,-33.691816743935966,0.0 -59.63831210508943,-33.69151323391678,0.0 -59.64010382071138,-33.69054913615744,0.0 -59.64089775457978,-33.69009386401158,0.0 -59.64197063818573,-33.68990639830934,0.0 -59.64283967390656,-33.689790347907795,0.0 -59.64197063818573,-33.688638762353904,0.0 -59.64268947020173,-33.68746037976837,0.0 ",
				"Polygon Outer Boundary",
				"1917",
				"0990011",
				"San Pedro",
				"San Pedro",
				"0011",
				"2015/07/15",
				"Depetri",
				"Villa",
				"90_o_anterior",
				"75",
				"9.7899999999999991000000000000000",
				"España, San Martín, Av 58, acceso al Puerto.",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.3602224482153,-34.691157678395,0.0 -58.3603804650579,-34.6901667543602,0.0 -58.3597143025158,-34.6907197477984,0.0 -58.3599502165964,-34.6909077797318,0.0 -58.3602224482153,-34.691157678395,0.0 ",
				"Polygon Outer Boundary",
				"527",
				"0040035",
				"Avellaneda",
				"Avellaneda",
				"0035",
				"2014/10/31",
				"Supisiche & Heredia",
				"Villa",
				"90_o_anterior",
				"32",
				"0.2899999999999999800000000000000",
				"Pitágoras, Heredia y Supiciche",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.3423059075893,-34.65895423711,0.0 -58.3415385034747,-34.6589828461515,0.0 -58.3415534228559,-34.6596076044109,0.0 -58.3409563443425,-34.6596285944934,0.0 -58.3409641858676,-34.6601112130377,0.0 -58.3423290091613,-34.6600999228982,0.0 -58.3423059075893,-34.65895423711,0.0 ",
				"Polygon Outer Boundary",
				"314",
				"0040030",
				"Avellaneda",
				"Avellaneda",
				"0030",
				"2014/10/31",
				"Diamante",
				"Villa",
				"90_o_anterior",
				"76",
				"1.1899999999999999000000000000000",
				"Ayolas, Predio Privado, Díaz de Solís y Campaña",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9711990682618,-34.87997479862,0.0 -57.9743821180012,-34.8777635813685,0.0 -57.9734004294695,-34.8769042957762,0.0 -57.9704559315852,-34.8792021108023,0.0 -57.9711990682618,-34.87997479862,0.0 ",
				"Polygon Outer Boundary",
				"307",
				"0550033",
				"La Plata",
				"Ringuelet",
				"0033",
				"2014/09/19",
				"El Mercadito",
				"Asentamiento Precario",
				"decada_1990",
				"150",
				"5.1299999999999999000000000000000",
				"520, 516, 119, 120",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9713457857714,-34.8800468427329,0.0 -57.9714435895798,-34.8801476422344,0.0 -57.9751882339757,-34.8773918170992,0.0 -57.9750514776042,-34.8773356959336,0.0 -57.9713457857714,-34.8800468427329,0.0 ",
				"Polygon Outer Boundary",
				"307",
				"0550033",
				"La Plata",
				"Ringuelet",
				"0033",
				"2014/09/19",
				"El Mercadito",
				"Asentamiento Precario",
				"decada_1990",
				"150",
				"5.1299999999999999000000000000000",
				"520, 516, 119, 120",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9714566356385,-34.8804718024694,0.0 -57.9712488496825,-34.8802894449472,0.0 -57.9712028264992,-34.8802931826745,0.0 -57.9708222200437,-34.8805791789146,0.0 -57.9708503764905,-34.8806038013092,0.0 -57.9711920637965,-34.880668715019,0.0 -57.9714566356385,-34.8804718024694,0.0 ",
				"Polygon Outer Boundary",
				"307",
				"0550033",
				"La Plata",
				"Ringuelet",
				"0033",
				"2014/09/19",
				"El Mercadito",
				"Asentamiento Precario",
				"decada_1990",
				"150",
				"5.1299999999999999000000000000000",
				"520, 516, 119, 120",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6608198654833,-34.463969869953,0.0 -58.6605180405145,-34.4637956622338,0.0 -58.6601310968399,-34.46359491343902,0.0 -58.65982532501221,-34.463997395193296,0.0 -58.6604999253118,-34.4643709907505,0.0 -58.6608198654833,-34.463969869953,0.0 ",
				"Polygon Outer Boundary",
				"686",
				"0570030",
				"Tigre",
				"Tigre",
				"0030",
				"2014/10/01",
				"Calle Gutierrez",
				"Villa",
				"90_o_anterior",
				"40",
				"0.4000000000000000200000000000000",
				"El Jazmin y Los Gladiolos",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.3352171093372,-34.6681874235573,0.0 -58.3356897207486,-34.668003819664,0.0 -58.3358360040737,-34.6677867174829,0.0 -58.3359542551316,-34.6675716078748,0.0 -58.3360332140013,-34.6673959972084,0.0 -58.3360322078664,-34.6671214575729,0.0 -58.336187624168,-34.6668796142197,0.0 -58.3362267480202,-34.6667351580761,0.0 -58.336168186023,-34.6665103170514,0.0 -58.3364147027428,-34.66640786108,0.0 -58.3364726813919,-34.6662386412831,0.0 -58.3365200910201,-34.6659967769995,0.0 -58.3364029241237,-34.6657237207516,0.0 -58.3363053227801,-34.6656112955284,0.0 -58.3363049210861,-34.6654987112104,0.0 -58.3364206349233,-34.6653697971361,0.0 -58.3366044037888,-34.6651688611495,0.0 -58.33677939763,-34.664912229399,0.0 -58.3372185800531,-34.6648161317111,0.0 -58.3379505619691,-34.6648002404817,0.0 -58.3385447538739,-34.6648804681326,0.0 -58.3389048358136,-34.6650328064472,0.0 -58.3389924092061,-34.6651851377559,0.0 -58.3390119051955,-34.6652252287523,0.0 -58.3390809728962,-34.6655060171264,0.0 -58.3393696983573,-34.6656000043945,0.0 -58.3393531483983,-34.6651506731736,0.0 -58.339337443117,-34.6642596157705,0.0 -58.3393663388372,-34.6638102446314,0.0 -58.3392289675792,-34.6638179422093,0.0 -58.3389353649492,-34.6638494635582,0.0 -58.3388891232721,-34.6642906432322,0.0 -58.3380991969382,-34.6642911008825,0.0 -58.3380578880024,-34.6641462908104,0.0 -58.3379959076692,-34.6626083781393,0.0 -58.3373974585078,-34.6625924661513,0.0 -58.3365113625876,-34.6625678680422,0.0 -58.3364529318307,-34.6613853374734,0.0 -58.336156653106,-34.6613915844521,0.0 -58.3356158198022,-34.6614029859541,0.0 -58.3350335384811,-34.6614152585474,0.0 -58.3350391088245,-34.6606063463199,0.0 -58.3350454973733,-34.6601850595669,0.0 -58.3362743171947,-34.6601711939058,0.0 -58.3364725272416,-34.6601355281931,0.0 -58.3367973013796,-34.6601242531274,0.0 -58.3367900373954,-34.6601765079262,0.0 -58.3370811684401,-34.6601750783846,0.0 -58.3370748922336,-34.6601193880157,0.0 -58.3376952151626,-34.6601085614113,0.0 -58.3376852351578,-34.6597180727702,0.0 -58.3377808201309,-34.6597164019808,0.0 -58.3377781416954,-34.6595992867266,0.0 -58.3376822297151,-34.6596009530564,0.0 -58.337684105027,-34.659107091025,0.0 -58.3377397724687,-34.6590136402092,0.0 -58.3377397724687,-34.6590136402092,0.0 -58.3377320662188,-34.6586622087619,0.0 -58.3377246142966,-34.6583187585877,0.0 -58.3376368513906,-34.6583122878192,0.0 -58.3376275311088,-34.6579488470459,0.0 -58.3376247629393,-34.6578089276694,0.0 -58.3376168549333,-34.6574184671535,0.0 -58.3376120454217,-34.6571841538989,0.0 -58.3376595623024,-34.65641469737,0.0 -58.3376105330952,-34.6559496206265,0.0 -58.3375071880018,-34.6555329408935,0.0 -58.3362047882628,-34.655524679927,0.0 -58.3361863325422,-34.6553511983144,0.0 -58.3361672923931,-34.6548795589161,0.0 -58.3361611839694,-34.6547267954384,0.0 -58.3356811415238,-34.6546515633616,0.0 -58.3356913224015,-34.6549224526515,0.0 -58.3353497184187,-34.6549276124307,0.0 -58.33534123267,-34.6546156470339,0.0 -58.3351939788196,-34.6544852009456,0.0 -58.3348218213293,-34.6547637566712,0.0 -58.3346898641364,-34.6549427546491,0.0 -58.3343870527103,-34.6551732256394,0.0 -58.3345149557321,-34.6552841205084,0.0 -58.3345166886433,-34.6554373650092,0.0 -58.3352310766796,-34.6554116121911,0.0 -58.3352340073832,-34.6554504982053,0.0 -58.3356945801371,-34.6555941452738,0.0 -58.3356888754633,-34.6556776178161,0.0 -58.3362069032045,-34.6557735575039,0.0 -58.3362232459474,-34.6563137114076,0.0 -58.3365625273981,-34.6563550620861,0.0 -58.3369859872994,-34.6566315000631,0.0 -58.3369921066221,-34.656958484758,0.0 -58.3370049365622,-34.6578175978323,0.0 -58.3370738118848,-34.6598459192339,0.0 -58.3366485887141,-34.6598533664832,0.0 -58.3362685854958,-34.6598195190795,0.0 -58.3358417036527,-34.6597462746499,0.0 -58.3354614468505,-34.6595942610387,0.0 -58.3353644089798,-34.6594395348706,0.0 -58.3353598464794,-34.6591659284467,0.0 -58.3348730463257,-34.6591382792665,0.0 -58.3348691482651,-34.6589841940995,0.0 -58.3347809667739,-34.6575419031104,0.0 -58.3347659615835,-34.6569562144551,0.0 -58.33443524465,-34.6569619709174,0.0 -58.3344497922888,-34.6575476795166,0.0 -58.3327157918983,-34.6575935874779,0.0 -58.3327216475473,-34.6579773814448,0.0 -58.332048654556274,-34.657974914518775,0.0 -58.3320428386899,-34.6570650569574,0.0 -58.3310534502529,-34.657867972851,0.0 -58.330648135716,-34.658217761882,0.0 -58.330617913567,-34.6586952987725,0.0 -58.3306367157796,-34.6589741469536,0.0 -58.3308408250425,-34.6593017043057,0.0 -58.3309575564253,-34.6595497964106,0.0 -58.3310351247962,-34.6598857881686,0.0 -58.33114209305,-34.6602383255032,0.0 -58.3313762816991,-34.6605754192305,0.0 -58.3313272921025,-34.6608244174477,0.0 -58.3314249506749,-34.6610268640935,0.0 -58.33162046568,-34.6610829837191,0.0 -58.3319624843558,-34.6610039668759,0.0 -58.3323233413005,-34.6609827798773,0.0 -58.3325961001281,-34.6610167219811,0.0 -58.3330058541899,-34.6612496053648,0.0 -58.3330546308115,-34.6612977725377,0.0 -58.3330746136638,-34.6616099215297,0.0 -58.3331432049578,-34.6618824660611,0.0 -58.3331328309618,-34.6621722163214,0.0 -58.3327716580484,-34.6621722332964,0.0 -58.3314443625809,-34.6621726308953,0.0 -58.331317584055,-34.6623580880914,0.0 -58.3312981568201,-34.6625835837717,0.0 -58.3314638105284,-34.6626717709589,0.0 -58.3319702900317,-34.6626728367947,0.0 -58.3327589356011,-34.6626732416835,0.0 -58.3331498884667,-34.662741132694,0.0 -58.3331888669103,-34.6628379384149,0.0 -58.3333154470025,-34.6630393969482,0.0 -58.3333639839825,-34.6634171825712,0.0 -58.333305535529,-34.6636739812978,0.0 -58.3332958055603,-34.6636900455218,0.0 -58.3334610960348,-34.6639218775826,0.0 -58.333675324728,-34.6641610223998,0.0 -58.3337629983045,-34.6644890501311,0.0 -58.3339387342797,-34.6644885132141,0.0 -58.3342806195016,-34.6645199789781,0.0 -58.3347503077587,-34.664687854263,0.0 -58.3349849586688,-34.6648724927207,0.0 -58.3353564071849,-34.6650492052881,0.0 -58.3355615838027,-34.6653143407188,0.0 -58.335561546961,-34.6654910856536,0.0 -58.335571263125,-34.6656115913684,0.0 -58.3355712173066,-34.6658285038781,0.0 -58.3353958326163,-34.6658687733125,0.0 -58.3353080221564,-34.6659250511176,0.0 -58.3353562995177,-34.6660935997341,0.0 -58.335335489705,-34.666342008596,0.0 -58.3351784958495,-34.6665100969842,0.0 -58.3351193187232,-34.6666460790738,0.0 -58.3348465577027,-34.6665500540078,0.0 -58.3345834212279,-34.6663897484685,0.0 -58.33450486529,-34.6664695481649,0.0 -58.334416749506,-34.6665494353715,0.0 -58.3342896806545,-34.6666373007209,0.0 -58.3343284475644,-34.6667573024131,0.0 -58.3344159973647,-34.6668613192011,0.0 -58.3345719016615,-34.666949487293,0.0 -58.334757269721,-34.6670379324514,0.0 -58.335069902396,-34.6671830683015,0.0 -58.335343428979,-34.6672878572781,0.0 -58.3353630365608,-34.6672879553281,0.0 -58.3354217590626,-34.6673924782863,0.0 -58.3353827668218,-34.6675048678967,0.0 -58.3352361982664,-34.6676329956053,0.0 -58.3352068131235,-34.6676408696133,0.0 -58.3351089800586,-34.6677126983881,0.0 -58.3349818288013,-34.6678004124295,0.0 -58.3352171093372,-34.6681874235573,0.0 ",
				"Polygon Outer Boundary",
				"528",
				"0040011",
				"Avellaneda",
				"Dock Sud",
				"0011",
				"2014/10/31",
				"Inflamable",
				"Villa",
				"90_o_anterior",
				"1500",
				"40.9500000000000030000000000000000",
				"Sargento Ponce, Genova, Morse, Autopista, Canal Sarandí",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.4180154682793,-34.7202647318055,0.0 -58.4190471497936,-34.7188930038767,0.0 -58.4193348330849,-34.7184128241809,0.0 -58.4185634480351,-34.7185109654815,0.0 -58.4172601922792,-34.7185832589212,0.0 -58.4142817842178,-34.7186207755047,0.0 -58.4129790693764,-34.720345979811,0.0 -58.4137398614103,-34.7203555855086,0.0 -58.4142489395464,-34.7205896533313,0.0 -58.414516768918,-34.7202953214177,0.0 -58.4162143013863,-34.7203050263843,0.0 -58.4180154682793,-34.7202647318055,0.0 ",
				"Polygon Outer Boundary",
				"349",
				"0250013",
				"Lanus",
				"Remedios De Escalada",
				"0013",
				"2014/10/01",
				"Esperanza",
				"Villa",
				"90_o_anterior",
				"1200",
				"8.9100000000000001000000000000000",
				"Colón, Juan Ruíz de Ocaña, Don Orione, 1 de Mayo",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.847328666597605,-34.488279817983276,0.0 -58.853047136217356,-34.491056523259736,0.0 -58.8537230528891,-34.490136860413784,0.0 -58.852483034133904,-34.489522272377855,0.0 -58.851212505251176,-34.48893420908181,0.0 -58.85097647085786,-34.489234873540696,0.0 -58.84841227903963,-34.487943777315756,0.0 -58.847328666597605,-34.488279817983276,0.0 ",
				"Polygon Outer Boundary",
				"2041",
				"0840020",
				"Pilar",
				"Presidente Derqui",
				"0020",
				"2015/08/05",
				"Henry Martín & México",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"5.7000000000000002000000000000000",
				"Caseros, Humahuaca",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.33516001701354,-34.72530089971969,0.0 -58.3337116241455,-34.72515540340496,0.0 -58.3321988582611,-34.72497463489965,0.0 -58.3317154053192,-34.7251361842639,0.0 -58.332552909851074,-34.72595783443719,0.0 -58.334135413169854,-34.72617828115909,0.0 -58.33516001701354,-34.72530089971969,0.0 ",
				"Polygon Outer Boundary",
				"536",
				"0040019",
				"Avellaneda",
				"Avellaneda",
				"0019",
				"2014/10/31",
				"Lynch",
				"Villa",
				"90_o_anterior",
				"132",
				"2.5000000000000000000000000000000",
				"Camino Gral Belgrano, Cnel Lynch, Calle 177",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.3626154774732,-34.6873989069337,0.0 -58.3626451274338,-34.6873893009355,0.0 -58.3621611742687,-34.6855686618674,0.0 -58.3621346823407,-34.6855619966895,0.0 -58.3612816623808,-34.6862920268198,0.0 -58.3612812120328,-34.6863204116844,0.0 -58.3626154774732,-34.6873989069337,0.0 ",
				"Polygon Outer Boundary",
				"553",
				"0040044",
				"Avellaneda",
				"Avellaneda",
				"0044",
				"2014/10/31",
				"Larralde & Martín Garcia",
				"Villa",
				"90_o_anterior",
				"44",
				"1.5700000000000001000000000000000",
				"Martín Garcia, Larralde, Pitágoras y O´Higgins",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.3617849595676,-34.6843059314487,0.0 -58.3616440863217,-34.6841681215239,0.0 -58.3612327998738,-34.6844999935296,0.0 -58.3615190025727,-34.6848561533075,0.0 -58.3617849595676,-34.6843059314487,0.0 ",
				"Polygon Outer Boundary",
				"553",
				"0040044",
				"Avellaneda",
				"Avellaneda",
				"0044",
				"2014/10/31",
				"Larralde & Martín Garcia",
				"Villa",
				"90_o_anterior",
				"44",
				"1.5700000000000001000000000000000",
				"Martín Garcia, Larralde, Pitágoras y O´Higgins",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.3611991387452,-34.6855575298857,0.0 -58.3610459579096,-34.6858613705895,0.0 -58.3606791503314,-34.6866402961101,0.0 -58.361703913509,-34.6857611612904,0.0 -58.3611991387452,-34.6855575298857,0.0 ",
				"Polygon Outer Boundary",
				"553",
				"0040044",
				"Avellaneda",
				"Avellaneda",
				"0044",
				"2014/10/31",
				"Larralde & Martín Garcia",
				"Villa",
				"90_o_anterior",
				"44",
				"1.5700000000000001000000000000000",
				"Martín Garcia, Larralde, Pitágoras y O´Higgins",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.343201279640205,-34.70846571805796,0.0 -58.34238588809967,-34.709113966855874,0.0 -58.3421560817117,-34.7090950991384,0.0 -58.3415196249305,-34.7095950351335,0.0 -58.34214448928833,-34.71010617456483,0.0 -58.34277749061584,-34.70962550653877,0.0 -58.3425237255519,-34.7094096961603,0.0 -58.3426487072783,-34.7092941384502,0.0 -58.3426995466359,-34.7092951906509,0.0 -58.343422599732,-34.7087267560195,0.0 -58.3434237446213,-34.7086857627495,0.0 -58.343201279640205,-34.70846571805796,0.0 ",
				"Polygon Outer Boundary",
				"546",
				"0040037",
				"Avellaneda",
				"Avellaneda",
				"0037",
				"2014/10/31",
				"Matanza & José Martín de la Serna",
				"Otros",
				"90_o_anterior",
				"66",
				"1.0600000000000001000000000000000",
				"Chascomús, Casacuberta, De los Italianos, De la Serna",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.3435192294183,-34.7041596837146,0.0 -58.3440207435286,-34.7030955845039,0.0 -58.3437189956514,-34.7028638711177,0.0 -58.3437549544087,-34.7027657498994,0.0 -58.3434153621102,-34.7025067957993,0.0 -58.3434498135029,-34.7024137339716,0.0 -58.3431731372399,-34.7021960150056,0.0 -58.3421934781946,-34.702971319858,0.0 -58.3435192294183,-34.7041596837146,0.0 ",
				"Polygon Outer Boundary",
				"551",
				"0040042",
				"Avellaneda",
				"Avellaneda",
				"0042",
				"2014/10/31",
				"Lucena & Gral. Pico",
				"Villa",
				"90_o_anterior",
				"139",
				"1.8000000000000000000000000000000",
				"Predio Privado, Lucena, Pico y Celedonio Flores",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.3580875220281,-34.7033004204011,0.0 -58.3583575818454,-34.7012633241762,0.0 -58.3585075992306,-34.7004045007316,0.0 -58.3581951659358,-34.7000890306079,0.0 -58.3579609169151,-34.7003170398832,0.0 -58.3574560596957,-34.700710579365,0.0 -58.3573043126021,-34.7005753217397,0.0 -58.356977917979,-34.7008910341043,0.0 -58.3566548229073,-34.7011566847665,0.0 -58.3564638396277,-34.701616697587,0.0 -58.355787403285,-34.7021341123966,0.0 -58.3580875220281,-34.7033004204011,0.0 ",
				"Polygon Outer Boundary",
				"557",
				"0040047",
				"Avellaneda",
				"Sarandi",
				"0047",
				"2014/10/31",
				"Unidad y Lucha",
				"Villa",
				"1988",
				"150",
				"4.4900000000000002000000000000000",
				"Villa de Luján, Cangallo, Suipacha y Pitágoras",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.7480956921354,-38.53877963692554,0.0 -58.74794817063957,-38.538899222145325,0.0 -58.74811714980752,-38.53901880716629,0.0 -58.748034001328044,-38.53907964859189,0.0 -58.748118281364434,-38.53914888187566,0.0 -58.748034001328044,-38.539213919142135,0.0 -58.74811714980752,-38.53927476040269,0.0 -58.74802976846695,-38.53934609147023,0.0 -58.748184205032885,-38.53946777371629,0.0 -58.74826198909432,-38.5394048346492,0.0 -58.74834626913071,-38.53946777371629,0.0 -58.748425603844225,-38.5394048346492,0.0 -58.74851411674171,-38.539465675748275,0.0 -58.748589218594134,-38.53940273667935,0.0 -58.74876892659813,-38.5395433005241,0.0 -58.748903037048876,-38.53944469606475,0.0 -58.748908401466906,-38.539398540739455,0.0 -58.7481520185247,-38.53878173491356,0.0 -58.7480956921354,-38.53877963692554,0.0 ",
				"Polygon Outer Boundary",
				"1582",
				"0760008",
				"Necochea",
				"Necochea",
				"0008",
				"2015/04/21",
				"88 entre 47 y 49",
				"Otros",
				"decada_1990",
				"7",
				"0.3300000000000000200000000000000",
				"Calle 88 entre 47 y 49",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.358168005943305,-34.70554633058651,0.0 -58.35819482803345,-34.70517588734818,0.0 -58.357776403427124,-34.70510532654329,0.0 -58.35778176784515,-34.7047833921073,0.0 -58.3570226754587,-34.7041006394202,0.0 -58.3573322453064,-34.7032251788662,0.0 -58.35682492065,-34.7029084912014,0.0 -58.3564822268952,-34.7038879633471,0.0 -58.3562658698839,-34.7047053220314,0.0 -58.3576374893302,-34.7059335505623,0.0 -58.3577149890803,-34.7058871663931,0.0 -58.358168005943305,-34.70554633058651,0.0 ",
				"Polygon Outer Boundary",
				"550",
				"0040041",
				"Avellaneda",
				"Avellaneda",
				"0041",
				"2014/10/31",
				"Suipacha & Pinto",
				"Villa",
				"90_o_anterior",
				"120",
				"2.5200000000000000000000000000000",
				"Suipacha, Predio Privado, San Lorenzo y Pinto",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.58633366664435,-34.51262469219067,0.0 -58.58659652312781,-34.512465561678624,0.0 -58.587197337947146,-34.51191302281895,0.0 -58.58809319575811,-34.51124555099031,0.0 -58.589015875659236,-34.510502927043454,0.0 -58.58934846957709,-34.51022444135719,0.0 -58.589187537036196,-34.510052044989784,0.0 -58.58878520568396,-34.509729353394825,0.0 -58.58831850131538,-34.50934477410859,0.0 -58.588184390864626,-34.50915027356393,0.0 -58.58823803504493,-34.50903534121052,0.0 -58.588795934520014,-34.50852256416424,0.0 -58.58910170634771,-34.50808935351125,0.0 -58.58930555423286,-34.50788158841953,0.0 -58.58934846957709,-34.507598673419245,0.0 -58.58941284259345,-34.50710799043832,0.0 -58.58935383399512,-34.506511209946545,0.0 -58.58906415542152,-34.506396273953676,0.0 -58.588554535708674,-34.506405115189516,0.0 -58.58738509257818,-34.506405115189516,0.0 -58.58685937961127,-34.50650678933437,0.0 -58.58689156611945,-34.50658193970952,0.0 -58.586977396807924,-34.50669687544636,0.0 -58.58616200526739,-34.50740416879943,0.0 -58.586430226168886,-34.50772686939774,0.0 -58.58687547286536,-34.50804514821597,0.0 -58.58684328635717,-34.50808493298278,0.0 -58.58570066531684,-34.50899113641702,0.0 -58.58687010844733,-34.509945954740274,0.0 -58.58677891334082,-34.510113930906286,0.0 -58.58653215011145,-34.51041893939481,0.0 -58.586188827357546,-34.51085213793801,0.0 -58.58602789481665,-34.51113062152662,0.0 -58.58534661372687,-34.51165222320441,0.0 -58.58633366664435,-34.51262469219067,0.0 ",
				"Polygon Outer Boundary",
				"1730",
				"0470136",
				"General San Martin",
				"General San Martin",
				"0136",
				"2015/05/21",
				"Hidalgo II",
				"Villa",
				"90_o_anterior",
				"1500",
				"14.3900000000000010000000000000000",
				"Camino del Buen Ayre y Lebenson",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.606504620052874,-37.956073483441976,0.0 -57.606078148819506,-37.95628285576269,0.0 -57.60614520404488,-37.95636110587075,0.0 -57.60576164815575,-37.95654509903963,0.0 -57.60595208499581,-37.956775618566276,0.0 -57.605995000340044,-37.95679042254785,0.0 -57.606740654446185,-37.95641820724835,0.0 -57.60674870107323,-37.956365335603955,0.0 -57.606504620052874,-37.956073483441976,0.0 ",
				"Polygon Outer Boundary",
				"1290",
				"0450014",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Libertad",
				"0014",
				"2015/01/29",
				"Republica Arabe Siria & Ituzaingo",
				"Asentamiento Precario",
				"90_o_anterior",
				"60",
				"0.8599999999999999900000000000000",
				"Republica Arabe Siria entre Ituzaingo y Brandsen",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.60451173875481,-37.95594024619989,0.0 -57.60487383697182,-37.95575625151585,0.0 -57.60467535350471,-37.955496120314066,0.0 -57.604624391533434,-37.955487660747316,0.0 -57.60429716203361,-37.955656851897096,0.0 -57.60451173875481,-37.95594024619989,0.0 ",
				"Polygon Outer Boundary",
				"1290",
				"0450014",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Libertad",
				"0014",
				"2015/01/29",
				"Republica Arabe Siria & Ituzaingo",
				"Asentamiento Precario",
				"90_o_anterior",
				"60",
				"0.8599999999999999900000000000000",
				"Republica Arabe Siria entre Ituzaingo y Brandsen",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.605732143856585,-37.95584507659328,0.0 -57.60616666171699,-37.95564204768705,0.0 -57.60616666171699,-37.955612439258,0.0 -57.60567581746727,-37.95499277439713,0.0 -57.605632902123034,-37.95498854458489,0.0 -57.60520106647163,-37.95518523059618,0.0 -57.605732143856585,-37.95584507659328,0.0 ",
				"Polygon Outer Boundary",
				"1290",
				"0450014",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Libertad",
				"0014",
				"2015/01/29",
				"Republica Arabe Siria & Ituzaingo",
				"Asentamiento Precario",
				"90_o_anterior",
				"60",
				"0.8599999999999999900000000000000",
				"Republica Arabe Siria entre Ituzaingo y Brandsen",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.565492033958435,-34.44401692018976,0.0 -58.56530964374542,-34.44385765877034,0.0 -58.56512725353241,-34.44369839704729,0.0 -58.56511116027832,-34.443729364628325,0.0 -58.565057516098015,-34.443755908260094,0.0 -58.565009236335754,-34.44379129975596,0.0 -58.56490731239319,-34.44385765877034,0.0 -58.564832210540764,-34.44393286558956,0.0 -58.5647742435729,-34.4439853837706,0.0 -58.56512725353241,-34.44431332257868,0.0 -58.565492033958435,-34.44401692018976,0.0 ",
				"Polygon Outer Boundary",
				"563",
				"0960009",
				"San Fernando",
				"San Fernando",
				"0009",
				"2014/10/01",
				"San Rafael II",
				"Villa",
				"90_o_anterior",
				"38",
				"0.2300000000000000100000000000000",
				"Av. Sobremonte, Quirno Costa, Callao, 25 de Mayo",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Total",
				"Sin dato"
			],
			[
				"",
				"",
				"-58.31438597291708,-34.80016663113535,0.0 -58.30995261669159,-34.79777469299107,0.0 -58.3089280128479,-34.799219555270675,0.0 -58.31347402185201,-34.80155859265853,0.0 -58.31438597291708,-34.80016663113535,0.0 ",
				"Polygon Outer Boundary",
				"1586",
				"0320026",
				"Florencio Varela",
				"Gobernador Julio A. Costa",
				"0026",
				"2015/04/22",
				"Don José II",
				"Asentamiento Precario",
				"90_o_anterior",
				"200",
				"8.8100000000000005000000000000000",
				"El paraíso, La cautiva, La aguada, El Malambo",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6271184682846,-34.72840916890645,0.0 -58.6273169517517,-34.72821958987746,0.0 -58.623443841934204,-34.72493936295009,0.0 -58.615592010319226,-34.731155811633535,0.0 -58.61954022198915,-34.7344357918678,0.0 -58.62251579761505,-34.732041948159406,0.0 -58.6205792427063,-34.730401926810956,0.0 -58.6220920085907,-34.72919834205246,0.0 -58.62403392791747,-34.730816343880264,0.0 -58.6271184682846,-34.72840916890645,0.0 ",
				"Polygon Outer Boundary",
				"1588",
				"0700137",
				"La Matanza",
				"Rafael Castillo",
				"0137",
				"2015/04/22",
				"El Porvenir II",
				"Asentamiento Precario",
				"decada_1990",
				"800",
				"45.8999999999999990000000000000000",
				"Lavallol, Mèrou, Río Cuarto y de la Fuente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.487118724733584,-34.84880966339274,0.0 -58.48692560568452,-34.84867759194897,0.0 -58.48665738478302,-34.84911782927053,0.0 -58.48637843504549,-34.84943479868367,0.0 -58.48466182127594,-34.85196170561528,0.0 -58.486500978469856,-34.852824534111285,0.0 -58.488056659698486,-34.85064983678972,0.0 -58.48811650648713,-34.84926750942333,0.0 -58.487118724733584,-34.84880966339274,0.0 ",
				"Polygon Outer Boundary",
				"1891",
				"0300042",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0042",
				"2015/07/14",
				"Costa Azul",
				"Asentamiento Precario",
				"90_o_anterior",
				"105",
				"7.7300000000000004000000000000000",
				"Las Calandrias y Olavarria",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.44308137893677,-34.727840430515066,0.0 -58.44209432601929,-34.72912780174269,0.0 -58.446999080479145,-34.731614311320676,0.0 -58.45045376569032,-34.72706447104938,0.0 -58.444390296936035,-34.7239429241572,0.0 -58.44327449798585,-34.725459622680056,0.0 -58.442587852478034,-34.72620032579894,0.0 -58.44183683395385,-34.72711737760797,0.0 -58.44308137893677,-34.727840430515066,0.0 ",
				"Polygon Outer Boundary",
				"1446",
				"0630066",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0066",
				"2015/03/13",
				"General Paz",
				"Otros",
				"decada_1970",
				"700",
				"37.1199999999999970000000000000000",
				"Cno. Negro, Saladillo, Ginebra y Amberes",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.68407282978296,-34.73983160513056,0.0 -58.68605766445398,-34.74148907179347,0.0 -58.689544536173344,-34.738738364239744,0.0 -58.68869695812464,-34.73793605728628,0.0 -58.68818197399378,-34.73756575914179,0.0 -58.685274459421635,-34.73981397232774,0.0 -58.68478093296289,-34.739373151034215,0.0 -58.68407282978296,-34.73983160513056,0.0 ",
				"Polygon Outer Boundary",
				"2314",
				"0720070",
				"Merlo",
				"Pontevedra",
				"0070",
				"2015/10/08",
				"Las Delicias",
				"Otros",
				"90_o_anterior",
				"320",
				"8.7200000000000006000000000000000",
				"De la Union, Maximiliano Aberastury",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.3362586656825,-34.683257884056,0.0 -58.3357188457362,-34.6827594867703,0.0 -58.3340585116576,-34.6840525097053,0.0 -58.3340585116576,-34.6840525097053,0.0 -58.3345641943832,-34.6844738375903,0.0 -58.3346104369757,-34.684474830119,0.0 -58.3362586656825,-34.683257884056,0.0 ",
				"Polygon Outer Boundary",
				"541",
				"0040024",
				"Avellaneda",
				"Avellaneda",
				"0024",
				"2014/10/31",
				"San Nicolas",
				"Otros",
				"1989",
				"30",
				"2.4300000000000002000000000000000",
				"Salto, La Blanqueada, Zárate y Baradero",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.3342373878978,-34.6826576067772,0.0 -58.3333713578341,-34.683360191679,0.0 -58.3340186137172,-34.6839128596977,0.0 -58.3348846444575,-34.6832102702638,0.0 -58.3342373878978,-34.6826576067772,0.0 ",
				"Polygon Outer Boundary",
				"541",
				"0040024",
				"Avellaneda",
				"Avellaneda",
				"0024",
				"2014/10/31",
				"San Nicolas",
				"Otros",
				"1989",
				"30",
				"2.4300000000000002000000000000000",
				"Salto, La Blanqueada, Zárate y Baradero",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.37281935931287,-34.73116783528978,0.0 -58.37206721305848,-34.73171570994648,0.0 -58.371224999427795,-34.73239463667071,0.0 -58.37083876132966,-34.73218302374454,0.0 -58.370313048362725,-34.73255775459816,0.0 -58.370414972305305,-34.732716463623966,0.0 -58.36993753910065,-34.73308237493873,0.0 -58.371011550436826,-34.734043836281295,0.0 -58.37154262782179,-34.73447426596738,0.0 -58.37231510401807,-34.733795356327406,0.0 -58.37335580111585,-34.73296935545547,0.0 -58.374187285910466,-34.732325702265314,0.0 -58.37281935931287,-34.73116783528978,0.0 ",
				"Polygon Outer Boundary",
				"585",
				"0250019",
				"Lanus",
				"Monte Chingolo",
				"0019",
				"2014/10/01",
				"Los Ceibos",
				"Otros",
				"90_o_anterior",
				"850",
				"6.6699999999999999000000000000000",
				"Centenario Uruguayo, Gral. C de Alvear, Matanza",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.627166748046875,-34.68300801504436,0.0 -58.62672686576843,-34.682659527157405,0.0 -58.62660348415375,-34.682760985807484,0.0 -58.62704873085022,-34.68311388449169,0.0 -58.627166748046875,-34.68300801504436,0.0 ",
				"Polygon Outer Boundary",
				"158",
				"1010024",
				"Moron",
				"Moron",
				"0024",
				"2014/10/31",
				"Cucha Cucha I",
				"Villa",
				"1970",
				"10",
				"0.0899999999999999970000000000000",
				"Cucha Cucha, Azul y Avellaneda",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-60.87714046239852,-35.43312276635488,0.0 -60.87736576795577,-35.432832101707795,0.0 -60.87723433971405,-35.43276435265432,0.0 -60.87744891643524,-35.43245401755179,0.0 -60.87712168693542,-35.43226825300975,0.0 -60.87666051462293,-35.43287581074431,0.0 -60.87714046239852,-35.43312276635488,0.0 ",
				"Polygon Outer Boundary",
				"2297",
				"0770001",
				"Nueve de Julio",
				"Nueve de Julio",
				"0001",
				"2015/10/01",
				"La Freyre",
				"Asentamiento Precario",
				"2008",
				"15",
				"0.3499999999999999800000000000000",
				"Freyre y Av. P.Perón",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.3228793922653,-34.7122965756945,0.0 -58.3219576501307,-34.7115305136908,0.0 -58.3213779522129,-34.7110188860535,0.0 -58.3207911309558,-34.7114484639579,0.0 -58.3188736323464,-34.7129713306591,0.0 -58.3194085062567,-34.7135458023325,0.0 -58.3202508158567,-34.7143976022067,0.0 -58.3204146856808,-34.7145468621026,0.0 -58.3206002492583,-34.71473526643,0.0 -58.3207806637737,-34.7145953501601,0.0 -58.3208579526577,-34.7145353983984,0.0 -58.3211176480886,-34.7143341151911,0.0 -58.3207439799539,-34.7140236076307,0.0 -58.322885206623,-34.7123608476443,0.0 -58.3228793922653,-34.7122965756945,0.0 ",
				"Polygon Outer Boundary",
				"524",
				"0040008",
				"Avellaneda",
				"Avellaneda",
				"0008",
				"2014/10/31",
				"San Juan",
				"Otros",
				"1985",
				"600",
				"6.9500000000000002000000000000000",
				"Salcedo, Varela, Lynch y Mansilla",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.343130482424,-34.6640650292321,0.0 -58.3434785544013,-34.6637178645685,0.0 -58.3425489943738,-34.6637212708721,0.0 -58.3425886123618,-34.6649912268798,0.0 -58.3423235046768,-34.6649969849647,0.0 -58.3421954781023,-34.665162441695,0.0 -58.3414601867924,-34.6651735418348,0.0 -58.3414708757878,-34.6650024342327,0.0 -58.3411102119053,-34.6650169647594,0.0 -58.3411350586333,-34.6658994020326,0.0 -58.3410667307375,-34.6671707450417,0.0 -58.3410454557185,-34.6676319378445,0.0 -58.3415774674578,-34.6673467889232,0.0 -58.3425910114577,-34.6656151109375,0.0 -58.343267976871,-34.6648708285773,0.0 -58.3434739863602,-34.6646322606814,0.0 -58.3436563377645,-34.6642450170629,0.0 -58.343130482424,-34.6640650292321,0.0 ",
				"Polygon Outer Boundary",
				"501",
				"0040029",
				"Avellaneda",
				"Dock Sud",
				"0029",
				"2014/10/31",
				"Santa Catalina",
				"Villa",
				"1986",
				"130",
				"3.8500000000000001000000000000000",
				"Debendetti, Sande, Díaz de Solís y Autopista Bs. As. - La Plata",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.882298804819584,-34.63858384461575,0.0 -58.88285636901855,-34.63804538424717,0.0 -58.88556003570557,-34.63994322081218,0.0 -58.88605356216431,-34.639395942165876,0.0 -58.88465881347656,-34.63850439986318,0.0 -58.88527035713195,-34.63794828446439,0.0 -58.883854150772095,-34.63696845302226,0.0 -58.882582783699036,-34.6361607454269,0.0 -58.881601095199585,-34.635533994222854,0.0 -58.88191256672144,-34.637692293583065,0.0 -58.88218078762293,-34.63864563492624,0.0 -58.882298804819584,-34.63858384461575,0.0 ",
				"Polygon Outer Boundary",
				"2170",
				"0460001",
				"General Rodriguez",
				"General Rodriguez",
				"0001",
				"2015/09/09",
				"Guemes",
				"Otros",
				"2013",
				"60",
				"7.0300000000000002000000000000000",
				"Tierra del Fuego,Chilecito, el Quijote",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.3382102200877,-34.6765343456202,0.0 -58.3381849346783,-34.6755447374992,0.0 -58.3381528137114,-34.6755142863042,0.0 -58.3369683584292,-34.6755350819848,0.0 -58.3369367461286,-34.6755610585859,0.0 -58.3369715130587,-34.6765613412984,0.0 -58.3382102200877,-34.6765343456202,0.0 ",
				"Polygon Outer Boundary",
				"532",
				"0040015",
				"Avellaneda",
				"Sarandí",
				"0015",
				"2014/10/31",
				"La Saladita",
				"Asentamiento Precario",
				"decada_1990",
				"48",
				"1.3000000000000000000000000000000",
				"Cucha Cucha, Edison, Agrelo y Génova",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.3217809527065,-34.7100665546265,0.0 -58.3223919013944,-34.7095701151482,0.0 -58.321529030799866,-34.7088581958281,0.0 -58.32091748714446,-34.709316819177594,0.0 -58.3217809527065,-34.7100665546265,0.0 ",
				"Polygon Outer Boundary",
				"520",
				"0040004",
				"Avellaneda",
				"Avellaneda",
				"0004",
				"2014/10/31",
				"4 de Febrero",
				"Villa",
				"2004",
				"71",
				"0.8700000000000000000000000000000",
				"San Carlos, Almirante Solier, Echeverría y Varela",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.3232130782082,-34.6843287127821,0.0 -58.3222168786735,-34.6834651712965,0.0 -58.3217188285371,-34.68386380432,0.0 -58.3220229011838,-34.6841347746271,0.0 -58.3220702905302,-34.684095139389,0.0 -58.322766901709,-34.6846925531015,0.0 -58.3232130782082,-34.6843287127821,0.0 ",
				"Polygon Outer Boundary",
				"531",
				"0040014",
				"Avellaneda",
				"Avellaneda",
				"0014",
				"2014/10/31",
				"La Esperanza",
				"Asentamiento Precario",
				"1988",
				"16",
				"0.7900000000000000400000000000000",
				"Chivilcoy, Tres de Arroyo, Darwin y San Nicolás",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.355763848870986,-34.640208031763834,0.0 -59.351740535348654,-34.63677425082139,0.0 -59.351858552545316,-34.63925470838056,0.0 -59.352071285247796,-34.64188514815452,0.0 -59.35359477996826,-34.6407729589679,0.0 -59.35432618483901,-34.641390843690886,0.0 -59.355763848870986,-34.640208031763834,0.0 ",
				"Polygon Outer Boundary",
				"1732",
				"0710003",
				"Mercedes",
				"Gowland",
				"0003",
				"2015/05/22",
				"Geo",
				"Asentamiento Precario",
				"2013",
				"30",
				"10.1199999999999990000000000000000",
				"Estación Gowland",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.597717703320086,-37.95903636347232,0.0 -57.597672105766826,-37.9590173303632,0.0 -57.596899629570544,-37.95940433594573,0.0 -57.596894265152514,-37.95944874629196,0.0 -57.59713298175484,-37.959742699811386,0.0 -57.59795641992241,-37.959338777766476,0.0 -57.597717703320086,-37.95903636347232,0.0 ",
				"Polygon Outer Boundary",
				"1293",
				"0450017",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Libertad",
				"0017",
				"2015/01/29",
				"Brandsen & Tandil",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"0.3700000000000000000000000000000",
				"Brandsen e/ Tandil y Pigue",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.3273165821241,-34.6878423829997,0.0 -58.327679509289,-34.6875541736029,0.0 -58.3276803886687,-34.6875158806986,0.0 -58.3267491354586,-34.6867228464191,0.0 -58.3267027755001,-34.686722209793,0.0 -58.326344171972,-34.6870070505848,0.0 -58.3263432938088,-34.687045253566,0.0 -58.3272703324221,-34.6878416577593,0.0 -58.3273165821241,-34.6878423829997,0.0 ",
				"Polygon Outer Boundary",
				"530",
				"0040013",
				"Avellaneda",
				"Avellaneda",
				"0013",
				"2014/10/31",
				"Jardín de América",
				"Otros",
				"1989",
				"34",
				"0.6700000000000000400000000000000",
				"Otero, Bolivar, Chivilcoy y Soreda",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.32614243030548,-34.687886691450814,0.0 -58.3257275927522,-34.6874938406674,0.0 -58.3256867774881,-34.687494181334,0.0 -58.3248057704508,-34.6881994111885,0.0 -58.3248043461219,-34.6882376064266,0.0 -58.325257301330566,-34.68864096385973,0.0 -58.32551479339599,-34.688442471786864,0.0 -58.325809836387634,-34.68868507314463,0.0 -58.3261799812317,-34.68842041708273,0.0 -58.325831294059746,-34.68812929443735,0.0 -58.32614243030548,-34.687886691450814,0.0 ",
				"Polygon Outer Boundary",
				"549",
				"0040040",
				"Avellaneda",
				"Avellaneda",
				"0040",
				"2014/10/31",
				"Bolivar & Darwin",
				"Asentamiento Precario",
				"90_o_anterior",
				"95",
				"0.9200000000000000400000000000000",
				"Bolivar, Darwin, Juán B. Justo",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.63505244255065,-34.67637325963865,0.0 -58.63537430763244,-34.676262969984165,0.0 -58.63506853580475,-34.67517771195087,0.0 -58.634183406829834,-34.675451233608605,0.0 -58.634446263313286,-34.67594533495862,0.0 -58.63480567932129,-34.675843867957624,0.0 -58.63505244255065,-34.67637325963865,0.0 ",
				"Polygon Outer Boundary",
				"136",
				"1010003",
				"Moron",
				"Moron",
				"0003",
				"2014/10/31",
				"20 de Junio",
				"Otros",
				"1960",
				"30",
				"0.7199999999999999700000000000000",
				"A. Palacios, Cucha Cucha, Sta. Catalina, Arana",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.112804889678955,-34.99793682647188,0.0 -58.11233282089233,-34.99832353141964,0.0 -58.111581802368164,-34.99887282507902,0.0 -58.1121289730072,-34.99940893213508,0.0 -58.11296582221985,-34.99889040241523,0.0 -58.114998936653144,-35.00074918440874,0.0 -58.11568369230372,-35.000221475301714,0.0 -58.112804889678955,-34.99793682647188,0.0 ",
				"Polygon Outer Boundary",
				"2043",
				"0550140",
				"La Plata",
				"Abasto",
				"0140",
				"2015/08/05",
				"Villa San Martín",
				"Asentamiento Precario",
				"decada_2000",
				"35",
				"3.4199999999999999000000000000000",
				"515 entre 231 y 233",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.3342073046502,-34.6843555278605,0.0 -58.3331414075839,-34.683483148032,0.0 -58.3323535798975,-34.6841012489597,0.0 -58.3331179119251,-34.6847732786528,0.0 -58.3332319774155,-34.6848624812204,0.0 -58.3333534917622,-34.6849672820305,0.0 -58.3342073046502,-34.6843555278605,0.0 ",
				"Polygon Outer Boundary",
				"544",
				"0040027",
				"Avellaneda",
				"Avellaneda",
				"0027",
				"2014/10/31",
				"San Jorge",
				"Asentamiento Precario",
				"1985",
				"70",
				"1.3799999999999999000000000000000",
				"Zarate, Colonia, Obarrio y Baradero",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.5548872262056,-34.4326111278713,0.0 -58.5554673574107,-34.4331118672704,0.0 -58.55581194162368,-34.432854614093564,0.0 -58.5551981818616,-34.4323517475768,0.0 -58.5548872262056,-34.4326111278713,0.0 ",
				"Polygon Outer Boundary",
				"566",
				"0960013",
				"San Fernando",
				"San Fernando",
				"0013",
				"2014/10/01",
				"San Jose II",
				"Asentamiento Precario",
				"90_o_anterior",
				"24",
				"0.3300000000000000200000000000000",
				"De Marzi, Ituzaingo, Gral Pinto, Servetto",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.326455410569906,-34.81108585009777,0.0 -58.327828701585524,-34.80934609563759,0.0 -58.32653587684035,-34.80865018356934,0.0 -58.32514649257064,-34.81037233498986,0.0 -58.326455410569906,-34.81108585009777,0.0 ",
				"Polygon Outer Boundary",
				"1592",
				"0320030",
				"Florencio Varela",
				"Gobernador Julio  A. Costa",
				"0030",
				"2015/04/22",
				"Santa Inés",
				"Asentamiento Precario",
				"2013",
				"90",
				"3.2799999999999998000000000000000",
				"Las Casuarinas, El Hornero, Las Acacias. Frente al Instituto Don Orione",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.32631140947342,-34.68883724999709,0.0 -58.325920158333,-34.6891366596598,0.0 -58.32592546352,-34.6891820675864,0.0 -58.3263999223709,-34.68957387022693,0.0 -58.32659035921097,-34.68941728384045,0.0 -58.32679957151412,-34.68925408081254,0.0 -58.32631140947342,-34.68883724999709,0.0 ",
				"Polygon Outer Boundary",
				"552",
				"0040043",
				"Avellaneda",
				"Avellaneda",
				"0043",
				"2014/10/31",
				"Juan B. Justo & Colonia",
				"Asentamiento Precario",
				"90_o_anterior",
				"36",
				"0.3300000000000000200000000000000",
				"Darwin, Juan B. Justo, Baradero, Colonia",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.5990553329372,-34.6599913775772,0.0 -58.5994125856688,-34.6596885527932,0.0 -58.5999658667982,-34.6592571527064,0.0 -58.5996053688127,-34.6589385350675,0.0 -58.5995901078078,-34.6589508885607,0.0 -58.5993874595398,-34.6587874013589,0.0 -58.5992599667298,-34.6588897702248,0.0 -58.5989791768794,-34.6586509339162,0.0 -58.5987536051791,-34.65883843328,0.0 -58.5987040440139,-34.658879595744,0.0 -58.5985454816638,-34.6589872853349,0.0 -58.5981961966766,-34.6592921580751,0.0 -58.5990553329372,-34.6599913775772,0.0 ",
				"Polygon Outer Boundary",
				"147",
				"1010013",
				"Moron",
				"Moron",
				"0013",
				"2014/10/31",
				"Santa Laura",
				"Otros",
				"1985",
				"23",
				"1.2400000000000000000000000000000",
				"Maza, Avellaneda, ,Paso, Castelli",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.6507186275312,-34.6668482355683,0.0 -58.6506798353034,-34.6668320326394,0.0 -58.6497912983145,-34.6670258973336,0.0 -58.6492496968844,-34.6671442822758,0.0 -58.6486560969925,-34.6672736255283,0.0 -58.6486276291584,-34.6673135999824,0.0 -58.6486412504104,-34.6673682822836,0.0 -58.6488721144431,-34.6683006675698,0.0 -58.6489137312011,-34.6683176234575,0.0 -58.6497982720342,-34.6681170096355,0.0 -58.650058554079,-34.6680963188608,0.0 -58.6509372877893,-34.6679089236922,0.0 -58.6509720820439,-34.6678554985502,0.0 -58.6507186275312,-34.6668482355683,0.0 ",
				"Polygon Outer Boundary",
				"141",
				"1010008",
				"Moron",
				"Castelar",
				"0008",
				"2014/10/31",
				"Fuerza Aérea",
				"Otros",
				"1985",
				"44",
				"2.3700000000000001000000000000000",
				"J. Fernández, N. Granada, O. Andrade, Montevideo",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.931517004966736,-34.62632197074192,0.0 -58.93148481845855,-34.625509745190996,0.0 -58.93058896064758,-34.626542682833026,0.0 -58.93161356449127,-34.627165087767665,0.0 -58.930894732475274,-34.62811855010224,0.0 -58.93129706382751,-34.628405469493394,0.0 -58.93047094345093,-34.62955313713558,0.0 -58.931554555892944,-34.63014020713791,0.0 -58.931624293327324,-34.629036688661216,0.0 -58.93176913261414,-34.628740943215476,0.0 -58.93150627613068,-34.62861293366577,0.0 -58.93184959888459,-34.6279640546345,0.0 -58.93219828605652,-34.62746966720446,0.0 -58.93165647983551,-34.62714301675054,0.0 -58.931517004966736,-34.62632197074192,0.0 ",
				"Polygon Outer Boundary",
				"2172",
				"0460003",
				"General Rodriguez",
				"General Rodriguez",
				"0003",
				"2015/09/09",
				"Medrano & Donato Alvares",
				"Asentamiento Precario",
				"90_o_anterior",
				"20",
				"2.8900000000000001000000000000000",
				"Medrano, Donato Alvares, Corrientes, Martinez",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.570201992988586,-34.70842161931573,0.0 -58.5687698400757,-34.7071355587596,0.0 -58.56770217418671,-34.707275043765925,0.0 -58.56633424758911,-34.70745144103876,0.0 -58.56679558753967,-34.70791007218778,0.0 -58.56864094734191,-34.70960786729202,0.0 -58.56918811798095,-34.70918893407619,0.0 -58.570201992988586,-34.70842161931573,0.0 ",
				"Polygon Outer Boundary",
				"1111",
				"0700019",
				"La Matanza",
				"San Justo",
				"0019",
				"2014/10/01",
				"17 de Marzo Bis",
				"Asentamiento Precario",
				"90_o_anterior",
				"310",
				"4.9600000000000000000000000000000",
				"Rucci, Berro, Peribebuy y Colonia",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.6164727807045,-34.675918865318174,0.0 -58.6159508947165,-34.675482084178,0.0 -58.6155551644537,-34.6758041444243,0.0 -58.6160673567761,-34.6762398095793,0.0 -58.6164727807045,-34.675918865318174,0.0 ",
				"Polygon Outer Boundary",
				"149",
				"1010015",
				"Moron",
				"Moron",
				"0015",
				"2014/10/31",
				"Santa Teresa I",
				"Otros",
				"1980",
				"12",
				"0.3499999999999999800000000000000",
				"Santa Teresa, Ramella, Ríos Gallardo, Pres. Alessandri",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.65582346916198,-34.694957174148996,0.0 -58.655767142772675,-34.69472561768828,0.0 -58.6557177696921,-34.6947005176311,0.0 -58.6549597978592,-34.69483147215071,0.0 -58.6550161242485,-34.695104928885314,0.0 -58.65511804819106,-34.69508508124951,0.0 -58.65516632795334,-34.69526370980044,0.0 -58.655372858047485,-34.695226219889626,0.0 -58.655351400375366,-34.695045385963596,0.0 -58.65582346916198,-34.694957174148996,0.0 ",
				"Polygon Outer Boundary",
				"144",
				"1010011",
				"Moron",
				"Castelar",
				"0011",
				"2014/10/31",
				"San Juan II",
				"Otros",
				"1990",
				"15",
				"0.2700000000000000200000000000000",
				"G. Pavón, Zorrilla, D. Betbeder.",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.322523185415776,-34.81893611038538,0.0 -58.32247403701331,-34.818884463716294,0.0 -58.3211222036698,-34.81816220810739,0.0 -58.32097199996496,-34.81806531967816,0.0 -58.31825224002386,-34.81665161645449,0.0 -58.31518915732885,-34.815048509305,0.0 -58.31376222213293,-34.814339432731614,0.0 -58.312908411026,-34.81540644849065,0.0 -58.321611234350705,-34.819957826376665,0.0 -58.322523185415776,-34.81893611038538,0.0 ",
				"Polygon Outer Boundary",
				"1733",
				"0320068",
				"Florencio Varela",
				"Gobernador Julio A. Costa",
				"0068",
				"2015/05/22",
				"Portela & 539",
				"Asentamiento Precario",
				"2014",
				"460",
				"13.7400000000000000000000000000000",
				"Las Lengas entre Blas Parera y El Tero",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.4178348904529,-34.6700850114854,0.0 -58.4175250212043,-34.6698094295991,0.0 -58.4169603192622,-34.6702480843698,0.0 -58.4172215650239,-34.6705158792895,0.0 -58.4178348904529,-34.6700850114854,0.0 ",
				"Polygon Outer Boundary",
				"458",
				"0250005",
				"Lanus",
				"Valentín Alsina",
				"0005",
				"2014/10/01",
				"Campomar",
				"Villa",
				"decada_2000",
				"35",
				"0.2899999999999999800000000000000",
				"Dr. José Darregueyra, Remedios de Escalada",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.59331995248795,-34.62173985512478,0.0 -58.593572080135345,-34.62144629092405,0.0 -58.59340846538544,-34.62135579347982,0.0 -58.59316170215607,-34.62166039424062,0.0 -58.59331995248795,-34.62173985512478,0.0 ",
				"Polygon Outer Boundary",
				"151",
				"1010017",
				"Moron",
				"El Palomar",
				"0017",
				"2014/10/31",
				"Bulnes",
				"Villa",
				"1960",
				"11",
				"0.0700000000000000070000000000000",
				"Dinamarca, Bulnes, Gdor. D'Amico, M. Escalada",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.2054091617465,-34.827490588788706,0.0 -58.20635329931975,-34.827164727798554,0.0 -58.20476543158293,-34.826178329915656,0.0 -58.2042182609439,-34.82397650630969,0.0 -58.20422898977995,-34.82278749708739,0.0 -58.20322047919035,-34.8204182349441,0.0 -58.202329985797405,-34.81952864308533,0.0 -58.201825730502605,-34.8198809578417,0.0 -58.20276986807585,-34.82107881674248,0.0 -58.2029951736331,-34.821924353714394,0.0 -58.20334922522306,-34.82291080254518,0.0 -58.20366036146879,-34.82396769889707,0.0 -58.203735463321216,-34.824381646272165,0.0 -58.20404659956694,-34.82558824696305,0.0 -58.20420753210783,-34.826319244622255,0.0 -58.20478688925505,-34.82676840864042,0.0 -58.205162398517125,-34.82696216491157,0.0 -58.2054091617465,-34.827490588788706,0.0 ",
				"Polygon Outer Boundary",
				"1594",
				"0320032",
				"Florencio Varela",
				"Bosques",
				"0032",
				"2015/04/22",
				"San Rudecindo",
				"Asentamiento Precario",
				"2005",
				"200",
				"5.9299999999999997000000000000000",
				"Laguna de Iberá, Luis Agote, Martínez de Irala",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.462704420089715,-34.73190528095668,0.0 -58.461384773254395,-34.73127925410721,0.0 -58.45888495445252,-34.7345592294424,0.0 -58.45905661582947,-34.734647399025654,0.0 -58.45950722694396,-34.73409192908061,0.0 -58.46187829971313,-34.7353174847842,0.0 -58.46401333808898,-34.73254893742112,0.0 -58.462704420089715,-34.73190528095668,0.0 ",
				"Polygon Outer Boundary",
				"993",
				"0630018",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0018",
				"2014/10/01",
				"La Chanchería",
				"Asentamiento Precario",
				"2008",
				"350",
				"10.1800000000000000000000000000000",
				"Falucho (Arroyo del Rey, canalizado), Ostende o García de Loyola, Homero y Escobar",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.721280097961426,-34.721764825863055,0.0 -58.720378875732415,-34.72259374452802,0.0 -58.720819093286984,-34.72294647335413,0.0 -58.720207549631596,-34.723413836730714,0.0 -58.721054792404175,-34.72409283164576,0.0 -58.72199892997742,-34.72342265488224,0.0 -58.72140917927027,-34.72297292795542,0.0 -58.72208509594201,-34.72247028908335,0.0 -58.721280097961426,-34.721764825863055,0.0 ",
				"Polygon Outer Boundary",
				"2318",
				"0720074",
				"Merlo",
				"Pontevedra",
				"0074",
				"2015/10/08",
				"La Estrella",
				"Asentamiento Precario",
				"90_o_anterior",
				"60",
				"2.3300000000000001000000000000000",
				"Carrasco, Muñiz, Pedro Nolasco Flores",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.56629133224487,-34.707513179995395,0.0 -58.56607608497142,-34.70745585096576,0.0 -58.564944192767136,-34.707993860296064,0.0 -58.56761097908019,-34.71039721990179,0.0 -58.56860876083374,-34.709621096727446,0.0 -58.56629133224487,-34.707513179995395,0.0 ",
				"Polygon Outer Boundary",
				"1447",
				"0700122",
				"La Matanza",
				"San Justo",
				"0122",
				"2015/03/16",
				"San Petersburgo",
				"Otros",
				"90_o_anterior",
				"420",
				"4.3799999999999999000000000000000",
				"Gaboto, Colonia, Rucci",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.64173001144081,-34.69002818961548,0.0 -58.64217907190323,-34.68994658874396,0.0 -58.64213615655899,-34.68979441393085,0.0 -58.64191085100174,-34.68983411173515,0.0 -58.64169090986252,-34.68987822038429,0.0 -58.64173001144081,-34.69002818961548,0.0 ",
				"Polygon Outer Boundary",
				"156",
				"1010022",
				"Moron",
				"Moron",
				"0022",
				"2014/10/31",
				"Achaga",
				"Villa",
				"1970",
				"10",
				"0.0700000000000000070000000000000",
				"R.Spini, Achaga, Itapirú",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.222349407151334,-34.759027086638,0.0 -58.22299313731491,-34.75819412620157,0.0 -58.222483517602086,-34.757947321495486,0.0 -58.221839787438505,-34.7587846916107,0.0 -58.222327949479215,-34.75906234403723,0.0 -58.222349407151334,-34.759027086638,0.0 ",
				"Polygon Outer Boundary",
				"1179",
				"1200015",
				"Berazategui",
				"Berazategui",
				"0015",
				"2014/10/01",
				"El Sol",
				"Otros",
				"90_o_anterior",
				"20",
				"0.6099999999999999900000000000000",
				"Calle 7 y 141",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.175216266317875,-34.92239088817354,0.0 -58.17582780997327,-34.92191585552323,0.0 -58.17442233244946,-34.92062269715511,0.0 -58.17381978034973,-34.921020963252744,0.0 -58.173310160636895,-34.92055471974542,0.0 -58.17295074462891,-34.920818631489986,0.0 -58.17286491394042,-34.92089340632999,0.0 -58.172564506530755,-34.92090660188292,0.0 -58.17160427570343,-34.92089780484786,0.0 -58.17159354686736,-34.92209419295804,0.0 -58.172628879547126,-34.92218656043244,0.0 -58.17341382185986,-34.92224134115426,0.0 -58.175216266317875,-34.92239088817354,0.0 ",
				"Polygon Outer Boundary",
				"2044",
				"0550141",
				"La Plata",
				"El Peligro",
				"0141",
				"2015/08/05",
				"Martín Fierro",
				"Otros",
				"decada_2000",
				"60",
				"5.3799999999999999000000000000000",
				"Ruta 2 y 415",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.31118106842041,-34.814591674078635,0.0 -58.31166386604309,-34.8131867198162,0.0 -58.31186771392822,-34.812715460199755,0.0 -58.31194818019867,-34.81202398093054,0.0 -58.31181943416596,-34.811720080562694,0.0 -58.31163704395295,-34.811565927773735,0.0 -58.31120252609253,-34.81118274673472,0.0 -58.310848474502556,-34.81064100498407,0.0 -58.3109986782074,-34.810257819644114,0.0 -58.311041593551636,-34.810094855223895,0.0 -58.31092357635498,-34.809702858406645,0.0 -58.31045687198639,-34.80905980340963,0.0 -58.310290575027466,-34.80839912524152,0.0 -58.310027718544006,-34.80775606007132,0.0 -58.309502005577095,-34.80787057889352,0.0 -58.30962538719177,-34.80820972985653,0.0 -58.30926597118378,-34.808350675300744,0.0 -58.30938398838043,-34.80867220619317,0.0 -58.308321833610535,-34.80896730878494,0.0 -58.30877780914307,-34.810491254603555,0.0 -58.31025302410126,-34.811297260795136,0.0 -58.30823600292206,-34.814067571685044,0.0 -58.308911919593804,-34.81438027183364,0.0 -58.309416174888604,-34.81368880653546,0.0 -58.31118106842041,-34.814591674078635,0.0 ",
				"Polygon Outer Boundary",
				"1597",
				"0320034",
				"Florencio Varela",
				"Gobernador Julio A. Costa",
				"0034",
				"2015/04/22",
				"Villa Argenta",
				"Asentamiento Precario",
				"2012",
				"300",
				"13.1099999999999990000000000000000",
				"Calle 531, Dr. Irineo Portela, Diagonal los Tilos, El Canario, Diagonal Los Pinos.",
				"Inexistente",
				"Sin dato",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6511009952281,-34.5705542588874,0.0 -58.6505881915099,-34.5703803300839,0.0 -58.6494717332462,-34.5702993147071,0.0 -58.6492548738385,-34.5703628672576,0.0 -58.6503315373992,-34.5713088986822,0.0 -58.65050196647643,-34.57145240289991,0.0 -58.65126907825469,-34.57074123633023,0.0 -58.6511009952281,-34.5705542588874,0.0 ",
				"Polygon Outer Boundary",
				"99",
				"1350006",
				"Hurlingham",
				"William Morris",
				"0006",
				"2014/07/23",
				"CEAMSE",
				"Villa",
				"decada_1980",
				"100",
				"1.2000000000000000000000000000000",
				"Av. Roca y Cellini",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.76547284424304,-34.53678368708011,0.0 -58.76654036343097,-34.53536959321251,0.0 -58.76590736210346,-34.53509560974802,0.0 -58.76548290252685,-34.53562148044082,0.0 -58.76475401222706,-34.53639481366091,0.0 -58.76547284424304,-34.53678368708011,0.0 ",
				"Polygon Outer Boundary",
				"1734",
				"1320042",
				"Jose C. Paz",
				"Jose C. Paz",
				"0042",
				"2015/05/26",
				"Concejal Alfonzo II",
				"Asentamiento Precario",
				"2011",
				"35",
				"1.2800000000000000000000000000000",
				"Alvarado, Gallardo, Pichincha",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.5235469790243,-34.5517858477224,0.0 -58.5239899310413,-34.5511256530683,0.0 -58.5239786975211,-34.5510893734098,0.0 -58.523789048194885,-34.55100725143244,0.0 -58.52346450090409,-34.55084156686701,0.0 -58.52296829223633,-34.551559530934476,0.0 -58.5235070176367,-34.5517970818425,0.0 -58.5235070176367,-34.5517970818425,0.0 -58.5235469790243,-34.5517858477224,0.0 ",
				"Polygon Outer Boundary",
				"665",
				"1100014",
				"Vicente Lopez",
				"Villa Martelli",
				"0014",
				"2014/10/01",
				"Prodal",
				"Villa",
				"2005",
				"241",
				"0.5200000000000000200000000000000",
				"Av.de los Constituyentes, Las Heras, Gral. Güemes",
				"Inexistente",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.5245578302607,-34.5501716154606,0.0 -58.524974584579475,-34.54908087183757,0.0 -58.522539138793945,-34.54792325530843,0.0 -58.5224269296569,-34.5478151460561,0.0 -58.5227994594082,-34.5472383057009,0.0 -58.5214956500831,-34.5466246292868,0.0 -58.5208176597201,-34.5468148512729,0.0 -58.5212721119831,-34.547790585514,0.0 -58.52148234844207,-34.54821045175088,0.0 -58.52120339870452,-34.54863461699138,0.0 -58.5217265679523,-34.5488460837456,0.0 -58.5245578302607,-34.5501716154606,0.0 ",
				"Polygon Outer Boundary",
				"666",
				"1100013",
				"Vicente Lopez",
				"Florida Oeste",
				"0013",
				"2014/10/01",
				"Las Flores",
				"Villa",
				"90_o_anterior",
				"1423",
				"5.9000000000000004000000000000000",
				"Av. de los Constituyentes, Melo, Los Pozos",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.42365145683288,-34.69247838371753,0.0 -58.423946499824524,-34.69215198941071,0.0 -58.423662185668945,-34.69196232726277,0.0 -58.42199385166168,-34.69366927094849,0.0 -58.422696590423584,-34.69412797849586,0.0 -58.42331349849701,-34.69352812965322,0.0 -58.42367065139115,-34.69322379291626,0.0 -58.42409133911132,-34.69273861609402,0.0 -58.42365145683288,-34.69247838371753,0.0 ",
				"Polygon Outer Boundary",
				"211",
				"0250010",
				"Lanus",
				"Lanus",
				"0010",
				"2014/10/01",
				"Rivadavia",
				"Otros",
				"90_o_anterior",
				"150",
				"1.8500000000000001000000000000000",
				"Humahuaca, Aristóbulo del Valle, Av. Pres. B. Rivadavia, Cnel. Murature",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.33842602558434,-34.783483289035665,0.0 -58.337310226634145,-34.78156671332348,0.0 -58.33711174316704,-34.78184428911516,0.0 -58.33665576763451,-34.78201612128006,0.0 -58.33640900440514,-34.7823509726756,0.0 -58.33735314197838,-34.78388862807927,0.0 -58.33842602558434,-34.783483289035665,0.0 ",
				"Polygon Outer Boundary",
				"2127",
				"0030091",
				"Almirante Brown",
				"Rafael Calzada",
				"0091",
				"2015/08/26",
				"San Jerónimo & Albeniz (B. San Jerónimo)",
				"Villa",
				"1987",
				"100",
				"2.3700000000000001000000000000000",
				"Isaac Albéniz, San Jerónimo Norte, San Carlos y San Jerónimo Sur",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.32154322043061,-34.295311826617116,0.0 -59.31977296248078,-34.294948419549335,0.0 -59.31925797834992,-34.29422160069764,0.0 -59.31696200743317,-34.29407091795363,0.0 -59.31667232885957,-34.2941595548946,0.0 -59.31809926405549,-34.295453643582974,0.0 -59.31832456961274,-34.29546250713538,0.0 -59.321446660906076,-34.29560432384687,0.0 -59.32154322043061,-34.295311826617116,0.0 ",
				"Polygon Outer Boundary",
				"1600",
				"0940002",
				"San Andres de Giles",
				"Solis",
				"0002",
				"2015/04/22",
				"Estación Solis",
				"Asentamiento Precario",
				"2006",
				"35",
				"3.8300000000000001000000000000000",
				"Ruta 193 y vías FFRR",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.611301900818944,-34.554020443834354,0.0 -58.61082446761429,-34.55358305170786,0.0 -58.61059379763901,-34.553388654469096,0.0 -58.610534789040685,-34.55337981822018,0.0 -58.60968947410583,-34.55399393528608,0.0 -58.61028802581131,-34.55457270333569,0.0 -58.61108732409775,-34.55528400817182,0.0 -58.61114096827805,-34.55530168026423,0.0 -58.61199617385864,-34.55466548257225,0.0 -58.611301900818944,-34.554020443834354,0.0 ",
				"Polygon Outer Boundary",
				"1393",
				"1170007",
				"Tres de Febrero",
				"El Libertador",
				"0007",
				"2015/02/18",
				"Del Gaucho",
				"Villa",
				"1965",
				"190",
				"2.1400000000000001000000000000000",
				"Lavalle, Salgueiro, Uspallata y Río cuarto",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.24662934988737,-34.82555301799633,0.0 -58.24714433401824,-34.824769169588876,0.0 -58.24355017393827,-34.821633701359254,0.0 -58.24307810515165,-34.82246161748895,0.0 -58.24662934988737,-34.82555301799633,0.0 ",
				"Polygon Outer Boundary",
				"1598",
				"0320035",
				"Florencio Varela",
				"Zeballos",
				"0035",
				"2015/04/22",
				"La Casona de López",
				"Asentamiento Precario",
				"2000",
				"200",
				"4.4900000000000002000000000000000",
				"Av. Guillermo Hudson, Av. Bosques, calle 838, Calle 811",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.323068618774414,-34.72171632504551,0.0 -58.32393765449523,-34.72080362253731,0.0 -58.32472085952759,-34.72023483182044,0.0 -58.32310616970062,-34.718837089173626,0.0 -58.32125544548035,-34.72024365031103,0.0 -58.323068618774414,-34.72171632504551,0.0 ",
				"Polygon Outer Boundary",
				"1426",
				"0860072",
				"Quilmes",
				"Quilmes",
				"0072",
				"2015/03/03",
				"Esperanza Chica",
				"Asentamiento Precario",
				"1987",
				"260",
				"4.9699999999999998000000000000000",
				"168,171,Pilcomayo, Bermejo",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.4051564418583,-34.6609401377838,0.0 -58.4049956705311,-34.6606606927438,0.0 -58.4051615112272,-34.6604482563811,0.0 -58.4045424550238,-34.6602567865844,0.0 -58.4042460468572,-34.6601914903394,0.0 -58.4041329644961,-34.6603648532324,0.0 -58.4041492276867,-34.6606295187836,0.0 -58.404226583709,-34.6609294077364,0.0 -58.4039502353536,-34.6611266412298,0.0 -58.404982613396,-34.6621061328852,0.0 -58.4055313960408,-34.6616944952814,0.0 -58.4053537905968,-34.6614264122557,0.0 -58.4053498438834,-34.6613703554186,0.0 -58.4053422997447,-34.6612631851995,0.0 -58.4051564418583,-34.6609401377838,0.0 ",
				"Polygon Outer Boundary",
				"292",
				"0250011",
				"Lanus",
				"Valentín Alsina",
				"0011",
				"2014/10/01",
				"San Francisco de Asís",
				"Villa",
				"90_o_anterior",
				"75",
				"1.6799999999999999000000000000000",
				"Valparaíso, Entre Ríos,",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-59.426160100847476,-34.457411488313916,0.0 -59.42508721724152,-34.45627913768161,0.0 -59.42441130056977,-34.45650914764659,0.0 -59.42339206114411,-34.45560679722823,0.0 -59.42347789183258,-34.45522639167906,0.0 -59.4237675704062,-34.454757517338805,0.0 -59.42384267225861,-34.45452750254899,0.0 -59.423456434160464,-34.45407631785184,0.0 -59.421965125948184,-34.45516446503029,0.0 -59.42354226484894,-34.456517994171044,0.0 -59.42390704527498,-34.456880700867,0.0 -59.42417526617646,-34.45693377976353,0.0 -59.42546272650361,-34.458092660593906,0.0 -59.42611718550324,-34.45753533823269,0.0 -59.426160100847476,-34.457411488313916,0.0 ",
				"Polygon Outer Boundary",
				"1599",
				"0940001",
				"San Andres de Giles",
				"San Andrés De Giles",
				"0001",
				"2015/04/22",
				"Scully",
				"Asentamiento Precario",
				"2011",
				"45",
				"4.5800000000000001000000000000000",
				"Av. Scully y 59",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9101564526689,-34.9002634467458,0.0 -57.9071274024979,-34.9018443326649,0.0 -57.9071274024979,-34.9018443326649,0.0 -57.905813455581665,-34.902694720187235,0.0 -57.904826402664185,-34.903240255526356,0.0 -57.90520191192626,-34.90351302183692,0.0 -57.906081676483154,-34.9030818746722,0.0 -57.9075837135315,-34.90478005346521,0.0 -57.90899991989136,-34.90387377588842,0.0 -57.910083532333374,-34.903134668324185,0.0 -57.910592452315,-34.9028041414125,0.0 -57.9116709777546,-34.9021642701607,0.0 -57.9101564526689,-34.9002634467458,0.0 ",
				"Polygon Outer Boundary",
				"446",
				"1140005",
				"Berisso",
				"Berisso",
				"0005",
				"2014/08/28",
				"Villa Argüello",
				"Asentamiento Precario",
				"2010",
				"208",
				"13.4600000000000010000000000000000",
				"133 a 135 y 9 a 13",
				"Inexistente",
				"Sin dato",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.6094992714648,-34.6333061473768,0.0 -58.6094282709625,-34.6333198493901,0.0 -58.6094749281957,-34.6336408990288,0.0 -58.6095204949379,-34.63396268165214,0.0 -58.60954999923705,-34.634152476604996,0.0 -58.609941601753235,-34.63394502628562,0.0 -58.60985845327378,-34.63380599014289,0.0 -58.6096680890217,-34.6335864069777,0.0 -58.6096503697135,-34.6335594708059,0.0 -58.6096840626387,-34.6335440457008,0.0 -58.6096575480549,-34.6334927273814,0.0 -58.6096440624808,-34.6334900412259,0.0 -58.6094992714648,-34.6333061473768,0.0 ",
				"Polygon Outer Boundary",
				"139",
				"1010006",
				"Moron",
				"El Palomar",
				"0006",
				"2014/10/31",
				"Angela Dorrego",
				"Asentamiento Precario",
				"decada_2000",
				"16",
				"0.2099999999999999900000000000000",
				"A. Dorrego, Ferrocarril G.F.S. y Boedo, Newton",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.4617920748037,-34.8576155868423,0.0 -58.4625184706893,-34.8566216446695,0.0 -58.4589877890026,-34.854872283828,0.0 -58.4576881507654,-34.8542277063484,0.0 -58.4569848476854,-34.8551849670884,0.0 -58.4586641000249,-34.8560221076019,0.0 -58.4617920748037,-34.8576155868423,0.0 ",
				"Polygon Outer Boundary",
				"1203",
				"0300023",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0023",
				"2014/10/01",
				"Las Chacritas",
				"Asentamiento Precario",
				"2002",
				"1000",
				"6.5000000000000000000000000000000",
				"Chiriguano, Maipú, Gral. Villegas",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.4429274132652,-34.7279125591307,0.0 -58.4429258108139,-34.72787129238865,0.0 -58.44278633594512,-34.727769889046456,0.0 -58.44271928071976,-34.72771698290549,0.0 -58.44185292720795,-34.727227599496295,0.0 -58.44089269638061,-34.7285105714644,0.0 -58.4420104661953,-34.7290837965147,0.0 -58.4420567194839,-34.7290740231925,0.0 -58.4429274132652,-34.7279125591307,0.0 ",
				"Polygon Outer Boundary",
				"992",
				"0630019",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0019",
				"2014/10/01",
				"Malvinas",
				"Otros",
				"90_o_anterior",
				"40",
				"2.0299999999999998000000000000000",
				"Bolonia, Amberes, Cosquín, Colectora Cno. Pres. Juan Domingo Perón",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.805147744715214,-34.56099189880243,0.0 -58.80230460315943,-34.55911876424793,0.0 -58.80024466663598,-34.557784571933034,0.0 -58.7980130687356,-34.56010835002311,0.0 -58.802873231470585,-34.563350928059045,0.0 -58.805147744715214,-34.56099189880243,0.0 ",
				"Polygon Outer Boundary",
				"2223",
				"0740059",
				"Moreno",
				"Moreno",
				"0059",
				"2015/09/22",
				"Los Hornos III",
				"Asentamiento Precario",
				"2009",
				"280",
				"19.1099999999999990000000000000000",
				"Miguel Lillo, Oyuela, Pablo Ricchieri",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.1740146366792,-34.94071273384879,0.0 -58.17267353217175,-34.94177691117332,0.0 -58.17211563269666,-34.942234239334624,0.0 -58.17148263136914,-34.9417241423752,0.0 -58.170967647238285,-34.94226941831831,0.0 -58.16993767897657,-34.943025762817314,0.0 -58.17110712210706,-34.943993170031604,0.0 -58.172201463385136,-34.94492538800337,0.0 -58.17315459251404,-34.944145075851765,0.0 -58.174250671072514,-34.94503971589293,0.0 -58.172512599630856,-34.946332489397456,0.0 -58.17373568694165,-34.94738779959593,0.0 -58.17441160361341,-34.94684255768942,0.0 -58.17491585890821,-34.94734382860885,0.0 -58.17712599913647,-34.94554979222727,0.0 -58.17439014594129,-34.9432104505306,0.0 -58.175740242004395,-34.94216627983059,0.0 -58.1745725361543,-34.94116127308244,0.0 -58.1740146366792,-34.94071273384879,0.0 ",
				"Polygon Outer Boundary",
				"2046",
				"0550142",
				"La Plata",
				"El Peligro",
				"0142",
				"2015/08/05",
				"Ruta del Sol",
				"Otros",
				"decada_2000",
				"200",
				"21.1999999999999990000000000000000",
				"424 y Ruta 2",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9309001578477,-34.8942821582679,0.0 -57.9305837590049,-34.8938852213925,0.0 -57.9308886510251,-34.8936558696098,0.0 -57.9311315235869,-34.8934731698001,0.0 -57.9309739663283,-34.8933482164619,0.0 -57.9311473569821,-34.8932189229159,0.0 -57.9306338512209,-34.8927459372947,0.0 -57.9298983003998,-34.8933249542923,0.0 -57.9304052095123,-34.8937824181093,0.0 -57.9302848086432,-34.893820766527,0.0 -57.9301782944118,-34.8942037297494,0.0 -57.9301864853807,-34.8944223434939,0.0 -57.9309001578477,-34.8942821582679,0.0 ",
				"Polygon Outer Boundary",
				"490",
				"1150002",
				"Ensenada",
				"El Dique",
				"0002",
				"2014/11/20",
				"48 & 130",
				"Villa",
				"decada_1990",
				"10",
				"1.0700000000000001000000000000000",
				"48. 47, 130, 131",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9266767535033,-34.8551254849624,0.0 -57.9285702445954,-34.856732251452,0.0 -57.9292682763902,-34.8561734567324,0.0 -57.930600289137,-34.8551071772544,0.0 -57.9311818664525,-34.8546415705263,0.0 -57.9305771234079,-34.8541379032844,0.0 -57.9299642712637,-34.8541179989777,0.0 -57.9296978904842,-34.8538890392647,0.0 -57.9292460306037,-34.8535149762617,0.0 -57.9290886360778,-34.8536377141649,0.0 -57.9289606562339,-34.8537153321035,0.0 -57.9287207276363,-34.8535117239558,0.0 -57.9279625531375,-34.8528680977281,0.0 -57.9259325140429,-34.8544932186104,0.0 -57.9266767535033,-34.8551254849624,0.0 ",
				"Polygon Outer Boundary",
				"504",
				"1150005",
				"Ensenada",
				"Ensenada",
				"0005",
				"2014/11/20",
				"Tranquila",
				"Asentamiento Precario",
				"2005",
				"145",
				"10.1300000000000010000000000000000",
				"Quintana, Ayacucho, F. Cestino, Antonio Silva",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.380253314971924,-34.87484120719293,0.0 -58.37956666946411,-34.87583582373998,0.0 -58.38187336921691,-34.87698885971934,0.0 -58.38258147239686,-34.87602066265725,0.0 -58.380253314971924,-34.87484120719293,0.0 ",
				"Polygon Outer Boundary",
				"1246",
				"0030033",
				"Almirante Brown",
				"Glew",
				"0033",
				"2014/10/01",
				"Scalabrini Ortiz & Yapeyú (B. Villa París)",
				"Asentamiento Precario",
				"2008",
				"80",
				"3.1400000000000001000000000000000",
				"Yapeyú, Pcia. de Mendoza, Dr. Kellertas y Garay",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9006627535527,-34.8588860745184,0.0 -57.9010725823012,-34.8590085043002,0.0 -57.9014150498471,-34.8587313523265,0.0 -57.9006720437682,-34.8581291426704,0.0 -57.9002638029856,-34.8582893507792,0.0 -57.9002195679833,-34.8585583316941,0.0 -57.8999208226199,-34.8588680810395,0.0 -57.9002803020931,-34.859127477256,0.0 -57.9006627535527,-34.8588860745184,0.0 ",
				"Polygon Outer Boundary",
				"511",
				"1150012",
				"Ensenada",
				"Ensenada",
				"0012",
				"2014/11/20",
				"Arenero",
				"Asentamiento Precario",
				"2009",
				"10",
				"0.8100000000000000500000000000000",
				"Hipolito Yrigoyen, Marques de Aviles, Rotonda de acceso a zona franca",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.67541432380676,-34.50958026379927,0.0 -58.67563158273697,-34.50937913311457,0.0 -58.675400456267,-34.5091759289762,0.0 -58.6753558285583,-34.5091680537875,0.0 -58.6753558285583,-34.5091680537875,0.0 -58.67454528808594,-34.50943438884554,0.0 -58.67521584033965,-34.509730558939076,0.0 -58.67541432380676,-34.50958026379927,0.0 ",
				"Polygon Outer Boundary",
				"171",
				"1330011",
				"Malvinas Argentinas",
				"Villa De Mayo",
				"0011",
				"2014/07/25",
				"La Gótica",
				"Villa",
				"1950",
				"60",
				"0.3200000000000000100000000000000",
				"Marquez- Tres Arroyos- Marañon",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9334882734358,-34.9024401229491,0.0 -57.9332749456563,-34.9023667145021,0.0 -57.9323484558273,-34.902327551664,0.0 -57.9314279340413,-34.9021406196287,0.0 -57.9304303957255,-34.9018389865856,0.0 -57.9295338672766,-34.9012010884937,0.0 -57.9294762340063,-34.9012445709393,0.0 -57.9303132527564,-34.9020288088292,0.0 -57.9311083454079,-34.9027555932346,0.0 -57.9319698601587,-34.9035792761252,0.0 -57.9334882734358,-34.9024401229491,0.0 ",
				"Polygon Outer Boundary",
				"500",
				"1150001",
				"Ensenada",
				"El Dique",
				"0001",
				"2014/11/20",
				"Peruana",
				"Villa",
				"decada_1990",
				"110",
				"2.4500000000000002000000000000000",
				"122, 125 y vias (53)",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.2688235855813,-34.9950393922869,0.0 -59.2660303774197,-34.9940940470609,0.0 -59.2657873444565,-34.9945456905114,0.0 -59.2685584814103,-34.9955355256188,0.0 -59.2688235855813,-34.9950393922869,0.0 ",
				"Polygon Outer Boundary",
				"412",
				"0750002",
				"Navarro",
				"Navarro",
				"0002",
				"2014/07/07",
				"B. Emergencia",
				"Asentamiento Precario",
				"1980",
				"27",
				"0.7600000000000000100000000000000",
				"36 entre 27 y 31",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.987180948257446,-35.560640619263765,0.0 -57.98772811889648,-35.55682643050329,0.0 -57.98490643501281,-35.55657330857991,0.0 -57.98440217971801,-35.560431149076614,0.0 -57.987180948257446,-35.560640619263765,0.0 ",
				"Polygon Outer Boundary",
				"1896",
				"0270003",
				"Chascomus",
				"Chascomus",
				"0003",
				"2015/07/15",
				"La Esmeralda",
				"Otros",
				"90_o_anterior",
				"10",
				"10.9499999999999990000000000000000",
				"Balcarce y Colombia",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9338913400359,-34.9647331523656,0.0 -57.9326465634571,-34.9636075722013,0.0 -57.9321994867548,-34.9635382520637,0.0 -57.9294214582962,-34.9610644205538,0.0 -57.9288595684486,-34.9604841129997,0.0 -57.9286174908541,-34.9602628770621,0.0 -57.9280267956209,-34.9597230308612,0.0 -57.9269619468992,-34.958753111027,0.0 -57.9263741763931,-34.9582144721252,0.0 -57.926164792696,-34.9584637341779,0.0 -57.9277570595056,-34.959904361274,0.0 -57.9276225989829,-34.9600409473087,0.0 -57.9274382367979,-34.9600596702931,0.0 -57.9276121993017,-34.9606530137837,0.0 -57.9281277683557,-34.9604592071581,0.0 -57.9284374513457,-34.9605199016824,0.0 -57.9287310469646,-34.9607899938317,0.0 -57.9292729279125,-34.9612757174431,0.0 -57.9296410026607,-34.9616087160692,0.0 -57.9305498002988,-34.9624397387407,0.0 -57.931304536034,-34.9631136421086,0.0 -57.9334757788778,-34.9650778401441,0.0 -57.9338913400359,-34.9647331523656,0.0 ",
				"Polygon Outer Boundary",
				"392",
				"0550118",
				"La Plata",
				"Altos De San Lorenzo",
				"0118",
				"2014/10/31",
				"Puente de Fierro 3",
				"Villa",
				"2007",
				"98",
				"3.7000000000000002000000000000000",
				"23bis a 29 sobre traza vial (90)",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.28411405906081,-34.83930438054836,0.0 -58.28347032889724,-34.83895214888329,0.0 -58.282799776643515,-34.84021137014868,0.0 -58.28193610534072,-34.84003085359762,0.0 -58.28123336657882,-34.83980630806698,0.0 -58.28109389171004,-34.83999122796025,0.0 -58.28318601474166,-34.841074321849916,0.0 -58.28411405906081,-34.83930438054836,0.0 ",
				"Polygon Outer Boundary",
				"1593",
				"0320031",
				"Florencio Varela",
				"Santa Rosa",
				"0031",
				"2015/04/22",
				"Pico de Oro",
				"Asentamiento Precario",
				"2013",
				"60",
				"2.4500000000000002000000000000000",
				"Hungria, Berna, Lisboa",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.28430307097733,-34.8394584814279,0.0 -58.284249426797025,-34.839432064154764,0.0 -58.28370762057603,-34.84037427498909,0.0 -58.28405094332993,-34.840488748467855,0.0 -58.28440499491989,-34.83984593379338,0.0 -58.28440499491989,-34.839744668010255,0.0 -58.284227969124906,-34.83966101357372,0.0 -58.28430307097733,-34.8394584814279,0.0 ",
				"Polygon Outer Boundary",
				"1593",
				"0320031",
				"Florencio Varela",
				"Santa Rosa",
				"0031",
				"2015/04/22",
				"Pico de Oro",
				"Asentamiento Precario",
				"2013",
				"60",
				"2.4500000000000002000000000000000",
				"Hungria, Berna, Lisboa",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6619370898864,-34.5027251999597,0.0 -58.66231977939606,-34.502467457409985,0.0 -58.66203546524048,-34.50222431159624,0.0 -58.662153482437134,-34.50211821138252,0.0 -58.66214275360107,-34.502122632227454,0.0 -58.66181552410126,-34.5018662228337,0.0 -58.6617361428531,-34.5017349186216,0.0 -58.66157412528992,-34.50160981265125,0.0 -58.66123616695403,-34.50188390626549,0.0 -58.6609852029727,-34.5018654103343,0.0 -58.6607521735099,-34.5016769035305,0.0 -58.6601471486274,-34.5021938739224,0.0 -58.6601545247902,-34.5022500199292,0.0 -58.6601545247902,-34.5022500199292,0.0 -58.6601545247902,-34.5022500199292,0.0 -58.6606769191322,-34.5026582995398,0.0 -58.6619370898864,-34.5027251999597,0.0 -58.6622028426153,-34.5025627996296,0.0 -58.6623304161964,-34.5024625222993,0.0 -58.6619370898864,-34.5027251999597,0.0 ",
				"Polygon Outer Boundary",
				"210",
				"1330160",
				"Malvinas Argentinas",
				"Sordeaux",
				"0160",
				"2014/11/11",
				"La Canchita",
				"Villa",
				"1983",
				"28",
				"1.5800000000000001000000000000000",
				"Remedios de Escalada- Nicolas Repetto- Arroyo Basualdo- Rosario",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9093392752538,-34.8536048267873,0.0 -57.9093600639643,-34.8535190767409,0.0 -57.9098443360197,-34.8534022712517,0.0 -57.9093433130013,-34.8529679331657,0.0 -57.9091303697336,-34.8530618104982,0.0 -57.9085837219898,-34.853319967443,0.0 -57.9081917590557,-34.8536162275076,0.0 -57.9080843922665,-34.8539007524428,0.0 -57.908073766284,-34.8540916394652,0.0 -57.9071065113896,-34.8548619015516,0.0 -57.907192342968,-34.8549657295264,0.0 -57.9077121164843,-34.8554307647598,0.0 -57.9079473517124,-34.8552545807439,0.0 -57.9085315460006,-34.8547855575818,0.0 -57.9091819033819,-34.854246294736,0.0 -57.909452835442,-34.8540897206172,0.0 -57.9096815339089,-34.8539085573831,0.0 -57.9093392752538,-34.8536048267873,0.0 ",
				"Polygon Outer Boundary",
				"503",
				"1150004",
				"Ensenada",
				"Ensenada",
				"0004",
				"2014/11/20",
				"Zona Franca",
				"Villa",
				"decada_1990",
				"72",
				"2.6899999999999999000000000000000",
				"Bolivia, Dr. Illia, Aristobulo del Valle, H. Yrigoyen",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.912190041544,-34.8721903148986,0.0 -57.9115356483859,-34.8727068108228,0.0 -57.9110807485912,-34.8723268904457,0.0 -57.9103863337687,-34.8717198954897,0.0 -57.9089088590962,-34.8729016325271,0.0 -57.911618519979,-34.8751581287307,0.0 -57.9137177830871,-34.8734478500406,0.0 -57.9123689607848,-34.8723233403722,0.0 -57.9123591350164,-34.8723313724605,0.0 -57.912190041544,-34.8721903148986,0.0 ",
				"Polygon Outer Boundary",
				"510",
				"1150011",
				"Ensenada",
				"Ensenada",
				"0011",
				"2014/11/20",
				"Mosconi",
				"Asentamiento Precario",
				"decada_1990",
				"190",
				"8.2400000000000002000000000000000",
				"Remedios de Escalada, Olegario Andrade, N. Gonzalez, 12 bis",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.910008267647,-34.8718990406916,0.0 -57.9103034734726,-34.87167683822618,0.0 -57.9093637863895,-34.8708601162885,0.0 -57.9094881126375,-34.87075508787,0.0 -57.9089246788408,-34.8702838286351,0.0 -57.9091015023259,-34.8701430927539,0.0 -57.9086261465512,-34.8697614960222,0.0 -57.908027774729,-34.87024602153,0.0 -57.9087119784587,-34.8707799909413,0.0 -57.9080293545619,-34.871327073271,0.0 -57.9077833807391,-34.8711220535234,0.0 -57.9075400768045,-34.8713208136409,0.0 -57.907481789588935,-34.87126752986747,0.0 -57.9071475327814,-34.8715103860508,0.0 -57.9087440953524,-34.8728358943586,0.0 -57.9087893471975,-34.8728023597028,0.0 -57.910008267647,-34.8718990406916,0.0 ",
				"Polygon Outer Boundary",
				"509",
				"1150010",
				"Ensenada",
				"Ensenada",
				"0010",
				"2014/11/20",
				"El Porteño",
				"Villa",
				"decada_1990",
				"112",
				"4.2300000000000004000000000000000",
				"Perito Moreno, Remedios de Escalada, V. Calzetta, Mitre",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.7117520486465,-34.4826802882468,0.0 -58.7117419592613,-34.4826426845635,0.0 -58.7111325286786,-34.4823149167606,0.0 -58.7104679036524,-34.4831761114493,0.0 -58.7111151363476,-34.4835092388919,0.0 -58.7117520486465,-34.4826802882468,0.0 ",
				"Polygon Outer Boundary",
				"213",
				"1330162",
				"Malvinas Argentinas",
				"Pablo Nogues",
				"0162",
				"2014/11/11",
				"Padre Stoppler & Hiroshima",
				"Asentamiento Precario",
				"2001",
				"31",
				"0.7900000000000000400000000000000",
				"Padre Stoppler- Hiroshima- Conjunto Habitacional",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.265397672004,-35.0117345632461,0.0 -59.2643954709779,-35.0113780460382,0.0 -59.2641896138775,-35.0117697894966,0.0 -59.2638789176978,-35.0116592921148,0.0 -59.2637179759473,-35.0119654079092,0.0 -59.2648236836402,-35.0128270466843,0.0 -59.265397672004,-35.0117345632461,0.0 ",
				"Polygon Outer Boundary",
				"411",
				"0750001",
				"Navarro",
				"Navarro",
				"0001",
				"2014/07/07",
				"Los Carros",
				"Asentamiento Precario",
				"1990",
				"59",
				"1.2700000000000000000000000000000",
				"121, 123, 8, Av Circunvalación",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.5223319061384,-33.820452782185,0.0 -59.5221379251047,-33.8201007885658,0.0 -59.5219986775001,-33.819929135595,0.0 -59.521669545272,-33.819407667677,0.0 -59.5211163525479,-33.8194370750408,0.0 -59.5214330012636,-33.8205120449556,0.0 -59.5223319061384,-33.820452782185,0.0 ",
				"Polygon Outer Boundary",
				"440",
				"0090004",
				"Baradero",
				"Baradero",
				"0004",
				"2014/08/11",
				"Tobares",
				"Asentamiento Precario",
				"1985",
				"35",
				"0.8000000000000000400000000000000",
				"Libertad 2900 entre vías y calle sin nombre",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.005275130271905,-35.55846733944732,0.0 -58.00508201122284,-35.55937506187846,0.0 -58.004931807518,-35.5610290104538,0.0 -58.005694393068545,-35.56107701372862,0.0 -58.006932735443115,-35.56111192518317,0.0 -58.00694346427917,-35.56052715631369,0.0 -58.00705075263978,-35.559820191237066,0.0 -58.00673961639404,-35.559610718905674,0.0 -58.006691336631775,-35.55863753818621,0.0 -58.00589740276336,-35.5585022520386,0.0 -58.005275130271905,-35.55846733944732,0.0 ",
				"Polygon Outer Boundary",
				"1897",
				"0270004",
				"Chascomus",
				"Chascomus",
				"0004",
				"2015/07/15",
				"Algarrobo",
				"Otros",
				"90_o_anterior",
				"35",
				"4.6100000000000003000000000000000",
				"M. Rico, Colombia, Ameghino y Diag. 7 de Noviembre",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.4963944909129,-33.82120110574,0.0 -59.496439050066,-33.8212098523555,0.0 -59.4985432625592,-33.8201245823309,0.0 -59.4985538495061,-33.8200873014381,0.0 -59.4978220050046,-33.8190976734543,0.0 -59.4977774473238,-33.8190888371919,0.0 -59.4956732503376,-33.8201741846276,0.0 -59.495662662662,-33.8202113751089,0.0 -59.4963944909129,-33.82120110574,0.0 ",
				"Polygon Outer Boundary",
				"438",
				"0090002",
				"Baradero",
				"Baradero",
				"0002",
				"2014/08/11",
				"La Igualdad",
				"Asentamiento Precario",
				"2012",
				"64",
				"0.2000000000000000100000000000000",
				"Calle 1 Santos Vega, Calle 2 Emilio Genoud, calle 3 Pedro Alonso, calle 4 J. Newbery",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.5256656673364,-33.8208061628394,0.0 -59.5241623592054,-33.821655668139,0.0 -59.5247575738469,-33.822389567368,0.0 -59.5262640011342,-33.8215437632648,0.0 -59.5256656673364,-33.8208061628394,0.0 ",
				"Polygon Outer Boundary",
				"439",
				"0090003",
				"Baradero",
				"Baradero",
				"0003",
				"2014/08/11",
				"Las Campanillas",
				"Asentamiento Precario",
				"decada_1990",
				"50",
				"0.0200000000000000000000000000000",
				"Astigueta entre Libertad y Mitre",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.6013599096578,-37.9809252535186,0.0 -57.6007997755641,-37.9802444839813,0.0 -57.6007997755641,-37.9802444839813,0.0 -57.5999600465664,-37.9806778929097,0.0 -57.5999553237286,-37.9807130660076,0.0 -57.6005006148628,-37.9813443055371,0.0 -57.6013599096578,-37.9809252535186,0.0 ",
				"Polygon Outer Boundary",
				"471",
				"0450001",
				"General Pueyrredon",
				"Mar Del Plata",
				"0001",
				"2014/08/05",
				"A. Alio & Falucho",
				"Asentamiento Precario",
				"decada_1990",
				"70",
				"0.5000000000000000000000000000000",
				"A. Alio, Gascón, Falucho",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.6041219377109,-37.98063033294,0.0 -57.6049706456069,-37.98019739314,0.0 -57.6043459901526,-37.9794072368013,0.0 -57.6037891607742,-37.9786978149172,0.0 -57.602908393906,-37.9791414881141,0.0 -57.6027624286775,-37.9792522751354,0.0 -57.6019815079174,-37.9796312323832,0.0 -57.6019731529989,-37.9796711448598,0.0 -57.6024605488164,-37.9802850820392,0.0 -57.6025092576696,-37.9802967439987,0.0 -57.6034736942468,-37.9798317208503,0.0 -57.6041219377109,-37.98063033294,0.0 ",
				"Polygon Outer Boundary",
				"472",
				"0450002",
				"General Pueyrredon",
				"Mar Del Plata",
				"0002",
				"2014/08/05",
				"Termas de Río Hondo & Falucho",
				"Asentamiento Precario",
				"decada_1990",
				"200",
				"2.0000000000000000000000000000000",
				"Termas de Río Hondo, Gascón, Falucho, Cnel. Suárez",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.654885007036,-37.9607755233904,0.0 -57.654396560961,-37.9611484191401,0.0 -57.654928318703,-37.9615954393868,0.0 -57.6549704214284,-37.9615951981949,0.0 -57.6554049764001,-37.9612641012012,0.0 -57.6554122333825,-37.9612147947173,0.0 -57.654885007036,-37.9607755233904,0.0 ",
				"Polygon Outer Boundary",
				"473",
				"0450003",
				"General Pueyrredon",
				"Mar Del Plata",
				"0003",
				"2014/08/05",
				"Alazan & Firmamento",
				"Asentamiento Precario",
				"decada_1990",
				"10",
				"0.5000000000000000000000000000000",
				"Alazan entre Firmamento y Abolengo",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.79207968711853,-34.56980036686302,0.0 -58.79227817058563,-34.56948674134139,0.0 -58.79165053367614,-34.569062682416984,0.0 -58.79240155220032,-34.56820130606881,0.0 -58.79142522811889,-34.56756962440912,0.0 -58.79039525985717,-34.56870488101732,0.0 -58.78993391990661,-34.56918194920807,0.0 -58.789376020431526,-34.56885065214378,0.0 -58.7885689956778,-34.5696489012822,0.0 -58.7881693600745,-34.5700560476391,0.0 -58.7886452802555,-34.5703811620747,0.0 -58.7881588901422,-34.5708888554531,0.0 -58.7885138318372,-34.5711270971058,0.0 -58.7885138318372,-34.5711270971058,0.0 -58.7890645342049,-34.571497168248,0.0 -58.7891143953278,-34.5714928856515,0.0 -58.7899653838644,-34.5706097755266,0.0 -58.7901063473199,-34.570481919769,0.0 -58.7908276511643,-34.5709558860125,0.0 -58.79207968711853,-34.56980036686302,0.0 ",
				"Polygon Outer Boundary",
				"94",
				"0740049",
				"Moreno",
				"Moreno",
				"0049",
				"2014/11/28",
				"Bariloche & Oyuela",
				"Asentamiento Precario",
				"2012",
				"41",
				"8.1199999999999992000000000000000",
				"Lilli- Oyuela-Nazca- Brigada Aerea",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.863088488578796,-34.506008464246,0.0 -58.86425256729126,-34.50436397041644,0.0 -58.86143624782562,-34.50299353410697,0.0 -58.860100507736206,-34.504876773048906,0.0 -58.85728418827057,-34.503541711334535,0.0 -58.855165243148804,-34.50667155741734,0.0 -58.85658144950867,-34.507356748152155,0.0 -58.857960104942315,-34.508024251128454,0.0 -58.85737538337707,-34.508979080529514,0.0 -58.86032581329346,-34.51034941842349,0.0 -58.86333525180816,-34.51178161846203,0.0 -58.86503577232361,-34.50944765021553,0.0 -58.861892223358154,-34.50768386948404,0.0 -58.863088488578796,-34.506008464246,0.0 ",
				"Polygon Outer Boundary",
				"2048",
				"0840023",
				"Pilar",
				"Presidente Derqui",
				"0023",
				"2015/08/05",
				"La Escondida",
				"Otros",
				"2004",
				"400",
				"45.3800000000000030000000000000000",
				"2 de Abril, Cabo Segundo, Isla Soledad",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.401727080345154,-34.90043774918655,0.0 -58.40205338783562,-34.89997138877207,0.0 -58.4020319301635,-34.89989219523112,0.0 -58.40116918087005,-34.899452229724226,0.0 -58.40106189250946,-34.899465428723715,0.0 -58.400713205337524,-34.899949390573916,0.0 -58.401727080345154,-34.90043774918655,0.0 ",
				"Polygon Outer Boundary",
				"2128",
				"0030092",
				"Almirante Brown",
				"Glew",
				"0092",
				"2015/08/26",
				"San Martín & Franklin (Barrio Parque Roma)",
				"Asentamiento Precario",
				"2004",
				"50",
				"0.7199999999999999700000000000000",
				"Libertador San Martín, Franklin, Edison y San Mariano",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.2829115866251,-34.9988930924923,0.0 -59.28372859954833,-34.99925952560363,0.0 -59.284694194793694,-34.999558338393726,0.0 -59.2858099937439,-34.99892555707635,0.0 -59.2856967433931,-34.9986509130066,0.0 -59.2867657560851,-34.996564872305,0.0 -59.2869555780158,-34.9962633807717,0.0 -59.2871763636191,-34.9958363333778,0.0 -59.2874046847442,-34.9953763054933,0.0 -59.2853306198732,-34.9946496952141,0.0 -59.2852743827001,-34.994667661744,0.0 -59.2835569637257,-34.9978906255288,0.0 -59.2833915676692,-34.997990511401,0.0 -59.2829115866251,-34.9988930924923,0.0 ",
				"Polygon Outer Boundary",
				"413",
				"0750003",
				"Navarro",
				"Navarro",
				"0003",
				"2014/07/07",
				"Matadero",
				"Asentamiento Precario",
				"1970",
				"112",
				"11.1400000000000010000000000000000",
				"3, 7, 38, 46",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6876996987316,-34.4791843496896,0.0 -58.6871526456246,-34.4798572990388,0.0 -58.68680298328399,-34.48030290836649,0.0 -58.6879026889801,-34.48090429842682,0.0 -58.6880606972394,-34.4806891956905,0.0 -58.68824064731598,-34.48048863223015,0.0 -58.68850350379944,-34.48014371615428,0.0 -58.688803911209106,-34.479825330818564,0.0 -58.6876996987316,-34.4791843496896,0.0 ",
				"Polygon Outer Boundary",
				"176",
				"1330021",
				"Malvinas Argentinas",
				"Ingeniero Pablo Nogues",
				"0021",
				"2014/07/25",
				"La Olla",
				"Villa",
				"1996",
				"100",
				"1.7900000000000000000000000000000",
				"Cangallo- Lugones- Galilei- Stephenson",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.5201604600641,-34.558892118067,0.0 -58.5190479489208,-34.5582242519299,0.0 -58.51850509643554,-34.558902290790265,0.0 -58.51897716522217,-34.55916736025283,0.0 -58.51915955543518,-34.55895972257884,0.0 -58.519824743270874,-34.559335237142236,0.0 -58.5201663874194,-34.5589265310141,0.0 -58.5201604600641,-34.558892118067,0.0 ",
				"Polygon Outer Boundary",
				"789",
				"0470078",
				"General San Martin",
				"General San Martin",
				"0078",
				"2014/10/01",
				"De los Constituyentes & Rivadavia",
				"Villa",
				"90_o_anterior",
				"175",
				"0.9200000000000000400000000000000",
				"De los Constituyentes, Rivadavia",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.7075373330079,-34.5219203818135,0.0 -58.708445727825165,-34.52128258145605,0.0 -58.7082901597023,-34.52115440633242,0.0 -58.708115816116326,-34.52098424250153,0.0 -58.7072280049324,-34.521638376886266,0.0 -58.7075373330079,-34.5219203818135,0.0 ",
				"Polygon Outer Boundary",
				"174",
				"1330014",
				"Malvinas Argentinas",
				"Los Polvorines",
				"0014",
				"2014/07/25",
				"Solar del Norte",
				"Asentamiento Precario",
				"1996",
				"17",
				"0.4699999999999999700000000000000",
				"Alejandro Sirio- Acevedo- Mozart- Amenábar",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.6719327173343,-34.4837638811152,0.0 -58.6713243168883,-34.48341501586,0.0 -58.6709573444612,-34.4832178608107,0.0 -58.6706390390937,-34.483061345221,0.0 -58.6706158648392,-34.4830674928395,0.0 -58.6700690392088,-34.4836815962862,0.0 -58.6706879448826,-34.4841708355381,0.0 -58.6710460349481,-34.4844203546648,0.0 -58.6712961207526,-34.4845820764707,0.0 -58.6719414885561,-34.4838011129907,0.0 -58.6719327173343,-34.4837638811152,0.0 ",
				"Polygon Outer Boundary",
				"173",
				"1330013",
				"Malvinas Argentinas",
				"Villa De Mayo",
				"0013",
				"2014/07/25",
				"Alvear",
				"Villa",
				"1950",
				"90",
				"1.4800000000000000000000000000000",
				"Sánchez de Loria- Velez Sarfield- Perito Moreno- Estomba",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7127355604639,-34.4830043327291,0.0 -58.7132697038511,-34.4823095880195,0.0 -58.7139951982067,-34.4826857990235,0.0 -58.7145857402148,-34.4819326016504,0.0 -58.7131492794541,-34.481170690659,0.0 -58.7131234976106,-34.4811625771546,0.0 -58.7125123066543,-34.4819556612075,0.0 -58.7124328960828,-34.4820444214367,0.0 -58.7122909689023,-34.4822346489174,0.0 -58.712018464154,-34.4825706047779,0.0 -58.7120216625945,-34.4826245408809,0.0 -58.7127355604639,-34.4830043327291,0.0 ",
				"Polygon Outer Boundary",
				"181",
				"1330031",
				"Malvinas Argentinas",
				"Pablo Nogues",
				"0031",
				"2014/07/25",
				"El Chiri 2",
				"Villa",
				"1988",
				"110",
				"2.3300000000000001000000000000000",
				"Riobamba- Hiroshima- Padre Stoppler- Patricias Mendocinas",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7350413817844,-34.5040264212004,0.0 -58.7341243705186,-34.5035523520336,0.0 -58.7328580014491,-34.5051987485074,0.0 -58.7337747316331,-34.5056776917139,0.0 -58.7350413817844,-34.5040264212004,0.0 ",
				"Polygon Outer Boundary",
				"186",
				"1330046",
				"Malvinas Argentinas",
				"Grand Bourg S",
				"0046",
				"2014/07/25",
				"San Pascual",
				"Villa",
				"1996",
				"80",
				"2.1600000000000001000000000000000",
				"Cangallo- Jose Hernandez-Lugones- A. Brown.",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.745829392578,-34.4819540491158,0.0 -58.7452757201222,-34.4816593820315,0.0 -58.7447486808049,-34.4823410024803,0.0 -58.745295553926,-34.4826392076644,0.0 -58.745829392578,-34.4819540491158,0.0 ",
				"Polygon Outer Boundary",
				"196",
				"1330064",
				"Malvinas Argentinas",
				"Tierras Altas",
				"0064",
				"2014/07/25",
				"Ferroviario",
				"Villa",
				"1988",
				"60",
				"0.5400000000000000400000000000000",
				"Palacios- Ecuador- Uruguay- Mascardi",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.7468203849773,-34.4839407670244,0.0 -58.7463435041295,-34.4836780800329,0.0 -58.746299623267,-34.4836861929467,0.0 -58.746054775934,-34.4840157496231,0.0 -58.7465519565915,-34.484282251507,0.0 -58.7468203849773,-34.4839407670244,0.0 ",
				"Polygon Outer Boundary",
				"205",
				"1330143",
				"Malvinas Argentinas",
				"Tierras Altas",
				"0143",
				"2014/07/25",
				"Ecuador & Benito Lynch",
				"Asentamiento Precario",
				"90_o_anterior",
				"11",
				"0.2500000000000000000000000000000",
				"Benito Lynch - Ecuador",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.8105889166398,-34.5947988243737,0.0 -58.8105889166398,-34.5947988243737,0.0 -58.8095468584675,-34.5958542659091,0.0 -58.8094420151748,-34.5959066042509,0.0 -58.8084260568279,-34.5969490402038,0.0 -58.8073073004804,-34.5980969145634,0.0 -58.8062042219901,-34.599228706811,0.0 -58.8132387749586,-34.6039282304144,0.0 -58.8157290785108,-34.6013539501333,0.0 -58.8157290785105,-34.6013539501331,0.0 -58.8164531609887,-34.6006054450064,0.0 -58.8164964906992,-34.6005248318203,0.0 -58.8175345816714,-34.5994782165135,0.0 -58.8176290931002,-34.5993703366001,0.0 -58.8182269288271,-34.5987207395175,0.0 -58.8159750676696,-34.5972249800812,0.0 -58.8133948414535,-34.5955010035862,0.0 -58.8122292761593,-34.5934247035689,0.0 -58.8116561182546,-34.5934990755086,0.0 -58.8112916889511,-34.5934829555297,0.0 -58.810871564467,-34.5936205354807,0.0 -58.8107871250871,-34.5939012586059,0.0 -58.8106941800752,-34.5942102567675,0.0 -58.8102669923901,-34.5944104387432,0.0 -58.810568687488,-34.5946274562499,0.0 -58.8105889166398,-34.5947988243737,0.0 ",
				"Polygon Outer Boundary",
				"82",
				"0740038",
				"Moreno",
				"Cuartel V",
				"0038",
				"2014/09/11",
				"La Gloria",
				"Asentamiento Precario",
				"2005",
				"1100",
				"63.7000000000000030000000000000000",
				"Rivera Floutoso, Guiraldes Ricardo, Araucanos, S/N",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.5109382656252,-34.5131999662387,0.0 -58.5111509898274,-34.5128903333567,0.0 -58.51082056760788,-34.51275187579771,0.0 -58.51061403751373,-34.51305687463085,0.0 -58.5109382656252,-34.5131999662387,0.0 ",
				"Polygon Outer Boundary",
				"669",
				"1100010",
				"Vicente Lopez",
				"Olivos",
				"0010",
				"2014/10/01",
				"Las Lomas",
				"Villa",
				"90_o_anterior",
				"19",
				"0.1300000000000000000000000000000",
				"Acassuso y Warnes",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.749783377106,-34.4872840589096,0.0 -58.7494986866447,-34.4871325077388,0.0 -58.7494783747105,-34.4871368067661,0.0 -58.7489571302603,-34.4878093100054,0.0 -58.7493014059456,-34.4879802211129,0.0 -58.7496485711771,-34.4875273145161,0.0 -58.7496043921055,-34.487504237731,0.0 -58.749783377106,-34.4872840589096,0.0 ",
				"Polygon Outer Boundary",
				"204",
				"1330139",
				"Malvinas Argentinas",
				"Tierras Altas",
				"0139",
				"2014/07/25",
				"12 de Octubre & Buenos Aires",
				"Asentamiento Precario",
				"1988",
				"24",
				"0.5300000000000000300000000000000",
				"Buenos Aires- Quintana- Viena- Hernandez",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7484580090572,-34.4878529632713,0.0 -58.7483295815413,-34.4877855764486,0.0 -58.7484552691709,-34.4876283109058,0.0 -58.7481176210525,-34.4874657580556,0.0 -58.7478471180919,-34.4878072238718,0.0 -58.7478560243598,-34.4878449928912,0.0 -58.7482777062813,-34.4880808784578,0.0 -58.7484580090572,-34.4878529632713,0.0 ",
				"Polygon Outer Boundary",
				"204",
				"1330139",
				"Malvinas Argentinas",
				"Tierras Altas",
				"0139",
				"2014/07/25",
				"12 de Octubre & Buenos Aires",
				"Asentamiento Precario",
				"1988",
				"24",
				"0.5300000000000000300000000000000",
				"Buenos Aires- Quintana- Viena- Hernandez",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7431259753902,-34.4739467849233,0.0 -58.7433356245362,-34.473663045703,0.0 -58.7434520416128,-34.4735054857796,0.0 -58.7435822137516,-34.4733292596676,0.0 -58.7434069500969,-34.4732518466346,0.0 -58.7432784695197,-34.4734172618149,0.0 -58.7430960149283,-34.4733245225545,0.0 -58.7429415932726,-34.4735280628189,0.0 -58.7427604636275,-34.4737668048267,0.0 -58.7430464919099,-34.4739082193351,0.0 -58.7431259753902,-34.4739467849233,0.0 ",
				"Polygon Outer Boundary",
				"214",
				"1330060",
				"Malvinas Argentinas",
				"Tortuguitas",
				"0060",
				"2014/07/25",
				"Haiti & Paso de Los Andes",
				"Asentamiento Precario",
				"1988",
				"45",
				"0.2700000000000000200000000000000",
				"Maipu- Chacabuco- Canada- Colombia",
				"Cobertura Parcial",
				"Sin dato",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.3713804631996,-34.7065519924559,0.0 -58.3714438547724,-34.7065529300521,0.0 -58.37215840816498,-34.70604907232818,0.0 -58.37227642536163,-34.705965282250055,0.0 -58.371324241161346,-34.7052464480929,0.0 -58.371195495128624,-34.70517588734818,0.0 -58.37033987045288,-34.7045254026482,0.0 -58.37030500173569,-34.70450555727188,0.0 -58.37027013301849,-34.70449012197588,0.0 -58.36969614028931,-34.70407336789553,0.0 -58.36867690086364,-34.704884823640114,0.0 -58.36914896965027,-34.70531700877742,0.0 -58.3693435309252,-34.7053375543184,0.0 -58.3701685882113,-34.7058060941572,0.0 -58.3713804631996,-34.7065519924559,0.0 ",
				"Polygon Outer Boundary",
				"591",
				"0250025",
				"Lanus",
				"Gerli",
				"0025",
				"2014/10/01",
				"La Maquinita",
				"Villa",
				"90_o_anterior",
				"230",
				"3.7300000000000000000000000000000",
				"Bv. Gob. Martín Rodriguez y Gral. Madariaga",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.59358722846081,-34.55234797894339,0.0 -58.59290957450867,-34.55286289602524,0.0 -58.592394590377815,-34.552376897870076,0.0 -58.59182769934705,-34.55286048618532,0.0 -58.59234268347791,-34.55325811893954,0.0 -58.59317953269055,-34.55396501692144,0.0 -58.59433650970459,-34.5530131130625,0.0 -58.59358722846081,-34.55234797894339,0.0 ",
				"Polygon Outer Boundary",
				"1736",
				"0470100",
				"General San Martin",
				"Loma Hermosa",
				"0100",
				"2015/05/26",
				"COVIPRO",
				"Villa",
				"decada_1990",
				"90",
				"2.0699999999999998000000000000000",
				"Hortensias y El Pensamiento",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.51573169231415,-34.51726265049044,0.0 -58.5160082970994,-34.516813699552,0.0 -58.5152262775769,-34.5164546528355,0.0 -58.5151845727304,-34.5164668547897,0.0 -58.515034317970276,-34.51668362301134,0.0 -58.51547420024872,-34.51688694609602,0.0 -58.515334725379944,-34.5170814285823,0.0 -58.51573169231415,-34.51726265049044,0.0 ",
				"Polygon Outer Boundary",
				"674",
				"1100005",
				"Vicente Lopez",
				"Olivos",
				"0005",
				"2014/10/01",
				"Panamericano",
				"Villa",
				"90_o_anterior",
				"87",
				"0.3700000000000000000000000000000",
				"Ramón Castro, Bellaqc, Repetto",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.7341790521861,-34.4867174161238,0.0 -58.7339956168847,-34.4866243861271,0.0 -58.7339478300036,-34.4866386736178,0.0 -58.7335608677938,-34.4871408783854,0.0 -58.7339195224019,-34.4873304597988,0.0 -58.7340209614505,-34.48738268997,0.0 -58.7338690275651,-34.4875815116763,0.0 -58.7339884632187,-34.4876452148816,0.0 -58.7342604881172,-34.4872787378082,0.0 -58.73414363909,-34.4872167742886,0.0 -58.7341674717809,-34.4870608474282,0.0 -58.7341810519336,-34.4869577597289,0.0 -58.7341790521861,-34.4867174161238,0.0 ",
				"Polygon Outer Boundary",
				"190",
				"1330051",
				"Malvinas Argentinas",
				"Grand Bourg",
				"0051",
				"2014/07/25",
				"Areguati & Batalla de Maipu",
				"Asentamiento Precario",
				"decada_1990",
				"10",
				"0.3499999999999999800000000000000",
				"Batalla de Maipu- Areguati- Vernet- 9 de Marzo",
				"Cobertura Parcial",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.511279225349426,-34.51568468064854,0.0 -58.511662781238556,-34.51585927542082,0.0 -58.5116962174004,-34.5158585302063,0.0 -58.51221263408661,-34.51506586078769,0.0 -58.51189076900482,-34.51492220551982,0.0 -58.51170837879181,-34.515198465430494,0.0 -58.511617183685296,-34.51515868405981,0.0 -58.5115760045545,-34.5152093583003,0.0 -58.51146697998047,-34.51537748136352,0.0 -58.511279225349426,-34.51568468064854,0.0 ",
				"Polygon Outer Boundary",
				"671",
				"1100008",
				"Vicente Lopez",
				"Olivos",
				"0008",
				"2014/10/01",
				"7 de Mayo",
				"Villa",
				"90_o_anterior",
				"101",
				"0.4099999999999999800000000000000",
				"Leopoldo Lugones, Borges y Castro",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.5140428127458,-34.5158973788076,0.0 -58.51375490427018,-34.51573330201429,0.0 -58.51356714963912,-34.51599408885542,0.0 -58.51314067840576,-34.51583275471948,0.0 -58.5130666008489,-34.515902983572,0.0 -58.512929135189,-34.5161076278994,0.0 -58.5133405166939,-34.5162923645366,0.0 -58.5131717220322,-34.5165503479639,0.0 -58.5135796320072,-34.5167345007493,0.0 -58.5141272922217,-34.5159353618103,0.0 -58.5140428127458,-34.5158973788076,0.0 ",
				"Polygon Outer Boundary",
				"673",
				"1100006",
				"Vicente Lopez",
				"Olivos",
				"0006",
				"2014/10/01",
				"2 de Abril",
				"Villa",
				"90_o_anterior",
				"164",
				"0.5999999999999999800000000000000",
				"Ramón Castro, Francisco Borges, Rosetti",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.7383991454039,-34.4958180371546,0.0 -58.7373960156491,-34.4951970800257,0.0 -58.7372125416215,-34.4950835028802,0.0 -58.7362948526556,-34.494510748433,0.0 -58.736150760208,-34.4946710493765,0.0 -58.7360383690832,-34.4948178931181,0.0 -58.7360473645324,-34.4948566553439,0.0 -58.7368765122919,-34.4952609615016,0.0 -58.7371958889723,-34.4954586650382,0.0 -58.7380220160119,-34.4959699906229,0.0 -58.7379818288352,-34.4960214949397,0.0 -58.7381579077735,-34.496127513122,0.0 -58.7383991454039,-34.4958180371546,0.0 ",
				"Polygon Outer Boundary",
				"206",
				"1330152",
				"Malvinas Argentinas",
				"Grand Bourg S",
				"0152",
				"2014/07/25",
				"Santa Mónica",
				"Asentamiento Precario",
				"2006",
				"38",
				"0.8900000000000000100000000000000",
				"Bouchard- A. Brown- Palacios- Arroyo",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.51094126701355,-34.51509680188988,0.0 -58.5112293877783,-34.5146409813926,0.0 -58.5112178357881,-34.5146109159015,0.0 -58.510850071907036,-34.51445145652174,0.0 -58.51052820682525,-34.514915575270706,0.0 -58.51094126701355,-34.51509680188988,0.0 ",
				"Polygon Outer Boundary",
				"670",
				"1100009",
				"Vicente Lopez",
				"Olivos",
				"0009",
				"2014/10/01",
				"Valle Grande",
				"Villa",
				"90_o_anterior",
				"47",
				"0.2500000000000000000000000000000",
				"Valle Grande, Ramón Castro",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.7446470394751,-34.4916160728357,0.0 -58.7443677665145,-34.491480429705,0.0 -58.744002803831,-34.4912731467118,0.0 -58.7437287604589,-34.4911373756214,0.0 -58.7436867393632,-34.4911446052806,0.0 -58.7434724209416,-34.4914180435178,0.0 -58.7436850873688,-34.4915305594344,0.0 -58.7437686131188,-34.4915868531675,0.0 -58.7437787879694,-34.491576231356,0.0 -58.7437787879694,-34.491576231356,0.0 -58.7444408322627,-34.491929527273,0.0 -58.744658028963,-34.4916527818017,0.0 -58.7446470394751,-34.4916160728357,0.0 ",
				"Polygon Outer Boundary",
				"189",
				"1330050",
				"Malvinas Argentinas",
				"Grand Bourg N",
				"0050",
				"2014/07/25",
				"Palpa & Hernández",
				"Asentamiento Precario",
				"decada_1980",
				"30",
				"0.4099999999999999800000000000000",
				"Palpa- hernandez- 11 de Septiembre- Ambrosetti",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.661185529504,-34.5042965230274,0.0 -58.6606187212052,-34.5048805252835,0.0 -58.6609511550457,-34.5051038332225,0.0 -58.6608978158688,-34.5051711215141,0.0 -58.661097093037,-34.5052921062036,0.0 -58.6612088085563,-34.5052404695198,0.0 -58.6617200063405,-34.5047061024666,0.0 -58.661185529504,-34.5042965230274,0.0 ",
				"Polygon Outer Boundary",
				"167",
				"1330001",
				"Malvinas Argentinas",
				"Sourdeaux",
				"0001",
				"2014/07/25",
				"Km. 30",
				"Villa",
				"decada_1980",
				"76",
				"0.5600000000000000500000000000000",
				"Manuela Pedraza- José Martí- Gral. Pico-  Marcelo Fitte",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.67599630355834,-33.672273867890894,0.0 -59.67531502246856,-33.67267566200686,0.0 -59.67593193054199,-33.67346585162545,0.0 -59.67667758464813,-33.67304620380552,0.0 -59.6771764755249,-33.673662281816284,0.0 -59.67874322086573,-33.67278280678742,0.0 -59.67986941337586,-33.67398817637047,0.0 -59.68081355094909,-33.67344799431313,0.0 -59.68035221099854,-33.67289441579189,0.0 -59.68017518520355,-33.67276941369716,0.0 -59.67965517193078,-33.67213100730838,0.0 -59.67997703701258,-33.67194350243372,0.0 -59.679660201072686,-33.671541704897145,0.0 -59.6793869510293,-33.67169349529824,0.0 -59.67833518981933,-33.67229172544702,0.0 -59.67750906944274,-33.67137652092095,0.0 -59.67599630355834,-33.672273867890894,0.0 ",
				"Polygon Outer Boundary",
				"1923",
				"0990016",
				"San Pedro",
				"San Pedro",
				"0016",
				"2015/07/16",
				"Las Cañitas",
				"Asentamiento Precario",
				"decada_1990",
				"200",
				"6.9400000000000004000000000000000",
				"Benefactoras Sampedrinas y Moreno",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.7724164346958,-34.4690707392921,0.0 -58.7724010181602,-34.4690384049188,0.0 -58.7712359198743,-34.4684154659673,0.0 -58.771028426003,-34.4686567541838,0.0 -58.7707242773921,-34.4690395791799,0.0 -58.7705517028901,-34.4692669758369,0.0 -58.7711863873156,-34.4695894753074,0.0 -58.7717732189732,-34.4698876038659,0.0 -58.7724164346958,-34.4690707392921,0.0 ",
				"Polygon Outer Boundary",
				"193",
				"1330058",
				"Malvinas Argentinas",
				"Tortuguitas",
				"0058",
				"2014/07/25",
				"Carumbe",
				"Asentamiento Precario",
				"decada_1990",
				"45",
				"1.4700000000000000000000000000000",
				"Santa Teresa- Santa Elena- Los Aromos- Las Acacias",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7391308101647,-34.4999574218159,0.0 -58.7393148415089,-34.4997166699021,0.0 -58.739313715338724,-34.499718269171986,0.0 -58.73931315225364,-34.4997190688069,0.0 -58.73931258916854,-34.49971986844181,0.0 -58.73930722475052,-34.49971986844181,0.0 -58.73890221118927,-34.49931092750657,0.0 -58.7388652490015,-34.4993511174499,0.0 -58.7388450774596,-34.4993820067832,0.0 -58.7387667686804,-34.499477826158,0.0 -58.7386125889018,-34.4996666055054,0.0 -58.7389175160917,-34.4998277652633,0.0 -58.7391308101647,-34.4999574218159,0.0 ",
				"Polygon Outer Boundary",
				"203",
				"1330113",
				"Malvinas Argentinas",
				"Grand Bourg N",
				"0113",
				"2014/07/25",
				"Matheu & Jose Hernandez",
				"Asentamiento Precario",
				"decada_1990",
				"21",
				"0.2200000000000000000000000000000",
				"Matheu- Hernandez- Wilde- Quintana",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.62871186807752,-34.45118336981305,0.0 -58.62789111211895,-34.45219193188388,0.0 -58.62913565710186,-34.45282448872204,0.0 -58.62994031980634,-34.45182920482232,0.0 -58.62871186807752,-34.45118336981305,0.0 ",
				"Polygon Outer Boundary",
				"694",
				"0570022",
				"Tigre",
				"General Pacheco",
				"0022",
				"2014/10/01",
				"Bajo Pacheco",
				"Asentamiento Precario",
				"90_o_anterior",
				"45",
				"1.8000000000000000000000000000000",
				"Estrada, Jujuy, Córdoba",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.842801097780466,-34.50042943146673,0.0 -58.843406438827515,-34.499620396507055,0.0 -58.84262859821319,-34.49928440153879,0.0 -58.84104073047637,-34.49849746065537,0.0 -58.84059011936188,-34.49911640354684,0.0 -58.84143769741058,-34.49952313494497,0.0 -58.841153383255005,-34.49990333858791,0.0 -58.842676877975464,-34.50065931974957,0.0 -58.842801097780466,-34.50042943146673,0.0 ",
				"Polygon Outer Boundary",
				"2051",
				"0840026",
				"Pilar",
				"Presidente Derqui",
				"0026",
				"2015/08/05",
				"Toro IV",
				"Asentamiento Precario",
				"2009",
				"70",
				"2.7999999999999998000000000000000",
				"Charcas y Japón",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.006915724544335,-34.38222274850857,0.0 -59.00359836830375,-34.384524857668374,0.0 -59.00722042309553,-34.38646566357218,0.0 -59.009645140536115,-34.38481527298893,0.0 -59.006915724544335,-34.38222274850857,0.0 ",
				"Polygon Outer Boundary",
				"1899",
				"0310001",
				"Exaltacion de la Cruz",
				"Pavón",
				"0001",
				"2015/07/15",
				"Carlos Lemee",
				"Otros",
				"decada_1980",
				"150",
				"13.0700000000000000000000000000000",
				"Calles, Juan Maria Boineau, Modesto Jaime, Juan Sambucetti y Eduardo Tormey",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7211365274544,-34.4979343627813,0.0 -58.7209532165245,-34.4978254503084,0.0 -58.7208623922073,-34.4977771771033,0.0 -58.7206893820573,-34.4976853179744,0.0 -58.72052639722825,-34.497900618515324,0.0 -58.72099310159683,-34.49815040852348,0.0 -58.7210335874199,-34.498087690987,0.0 -58.7211365274544,-34.4979343627813,0.0 ",
				"Polygon Outer Boundary",
				"188",
				"1330048",
				"Malvinas Argentinas",
				"Grand Bourg Sur",
				"0048",
				"2014/07/25",
				"Nogues & Combate de San Lorenzo",
				"Otros",
				"decada_1980",
				"15",
				"0.4099999999999999800000000000000",
				"Combate de San Lorenzo- Nogues",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.7221877270349,-34.4983244814221,0.0 -58.72237175703048,-34.498097355840976,0.0 -58.72156172990799,-34.49766630154422,0.0 -58.7214467370308,-34.4978039355094,0.0 -58.7214343111987,-34.4978120079948,0.0 -58.7213686967499,-34.4978952394603,0.0 -58.7221877270349,-34.4983244814221,0.0 ",
				"Polygon Outer Boundary",
				"188",
				"1330048",
				"Malvinas Argentinas",
				"Grand Bourg Sur",
				"0048",
				"2014/07/25",
				"Nogues & Combate de San Lorenzo",
				"Otros",
				"decada_1980",
				"15",
				"0.4099999999999999800000000000000",
				"Combate de San Lorenzo- Nogues",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.5545221689839,-34.7165087496942,0.0 -58.5542598431628,-34.7170814150832,0.0 -58.5537489808819,-34.7174693623602,0.0 -58.5536293723694,-34.7176466272344,0.0 -58.5534631291304,-34.718802293872,0.0 -58.553445706905,-34.7193778561914,0.0 -58.5533232921185,-34.7206714887311,0.0 -58.5532950756529,-34.7209109296187,0.0 -58.5494666056897,-34.723864407643,0.0 -58.5568930937386,-34.7308229209737,0.0 -58.5640996244508,-34.7253936212152,0.0 -58.5545221689839,-34.7165087496942,0.0 ",
				"Polygon Outer Boundary",
				"1108",
				"0700022",
				"La Matanza",
				"Ciudad Evita",
				"0022",
				"2014/10/01",
				"22 de Enero",
				"Otros",
				"90_o_anterior",
				"3800",
				"99.3299999999999980000000000000000",
				"Av. Cristianía, Las Camelia, Las Orquideas, Las Gardenias",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.5288181900978,-34.57980705025113,0.0 -58.52891743183135,-34.579751841221956,0.0 -58.52860093116761,-34.57949567084671,0.0 -58.52815568447112,-34.579173248390155,0.0 -58.52795183658599,-34.57925716668419,0.0 -58.52832734584808,-34.57956633861529,0.0 -58.5280833791972,-34.5797597589907,0.0 -58.5284658240668,-34.5800970557329,0.0 -58.5288181900978,-34.57980705025113,0.0 ",
				"Polygon Outer Boundary",
				"805",
				"0470062",
				"General San Martin",
				"General San Martin",
				"0062",
				"2014/10/01",
				"Pilar",
				"Villa",
				"decada_1990",
				"25",
				"0.3800000000000000000000000000000",
				"Pilar y M. de Irigoyen",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.740801215171814,-34.50063279421082,0.0 -58.74069392681122,-34.50079194731668,0.0 -58.740865588188164,-34.500884786488115,0.0 -58.7412370739064,-34.5004091903757,0.0 -58.7412371128876,-34.500409140072,0.0 -58.7415128712885,-34.5000532829952,0.0 -58.7416901220024,-34.4998068690268,0.0 -58.7413230866474,-34.4995979341192,0.0 -58.741173661712,-34.4995214898988,0.0 -58.7410459961831,-34.4996778255283,0.0 -58.7409892683911,-34.4997577340631,0.0 -58.7408699332327,-34.4999030683841,0.0 -58.7408380719611,-34.49992942081,0.0 -58.7408237500205,-34.4999478415988,0.0 -58.7406784597417,-34.500117696115,0.0 -58.7408581032718,-34.5002191501883,0.0 -58.7406178546627,-34.5005277395763,0.0 -58.740801215171814,-34.50063279421082,0.0 ",
				"Polygon Outer Boundary",
				"185",
				"1330044",
				"Malvinas Argentinas",
				"Grand Bourg N",
				"0044",
				"2014/07/25",
				"Ventura Coll & Castelli",
				"Otros",
				"decada_1980",
				"45",
				"0.6800000000000000500000000000000",
				"Matheu- Ventura Coll- Wilde- Quintana- Castelli",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.6771148443222,-34.51622614425653,0.0 -58.67644697427749,-34.51577529317096,0.0 -58.676259219646454,-34.51592336708087,0.0 -58.676133155822754,-34.51609796135297,0.0 -58.67624849081039,-34.51613995232586,0.0 -58.676342368125916,-34.51618194327759,0.0 -58.676857352256775,-34.51636316714226,0.0 -58.67693781852722,-34.51638968767475,0.0 -58.6771148443222,-34.51622614425653,0.0 ",
				"Polygon Outer Boundary",
				"215",
				"1330097",
				"Malvinas Argentinas",
				"Los Polvorines",
				"0097",
				"2014/07/25",
				"Israel & Gral Savio",
				"Villa",
				"90_o_anterior",
				"20",
				"0.2899999999999999800000000000000",
				"sin dato",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.86031508445739,-34.49400998727341,0.0 -58.86045489460229,-34.49375355292816,0.0 -58.86318001896143,-34.495044559208935,0.0 -58.864778615534306,-34.49267475152826,0.0 -58.8621285930276,-34.491507508064586,0.0 -58.86324405670166,-34.48973008322775,0.0 -58.860143423080444,-34.49055247853286,0.0 -58.85574460029601,-34.49179932046222,0.0 -58.86031508445739,-34.49400998727341,0.0 ",
				"Polygon Outer Boundary",
				"2052",
				"0840027",
				"Pilar",
				"Presidente Derqui",
				"0027",
				"2015/08/05",
				"San Souci",
				"Otros",
				"decada_2000",
				"320",
				"21.9699999999999990000000000000000",
				"Portugal y Río Pilcomayo",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.86870050802827,-34.49019876111599,0.0 -58.86705899611115,-34.48944710662378,0.0 -58.86645818129181,-34.49030487649857,0.0 -58.86806750670075,-34.49104768039606,0.0 -58.86870050802827,-34.49019876111599,0.0 ",
				"Polygon Outer Boundary",
				"2053",
				"0840028",
				"Pilar",
				"Villa Astolfi",
				"0028",
				"2015/08/05",
				"Manzone II",
				"Asentamiento Precario",
				"2005",
				"20",
				"1.8899999999999999000000000000000",
				"Carlos Pellegrini, Manuel Quintana",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7439568174939,-34.4782644772436,0.0 -58.744126352637,-34.478042586719,0.0 -58.7435943128483,-34.4777664812886,0.0 -58.7431440917315,-34.4775386553187,0.0 -58.7428632633144,-34.4775801967223,0.0 -58.7421592832542,-34.4778706098482,0.0 -58.7416846590482,-34.478156262873,0.0 -58.7418357007107,-34.4783182123628,0.0 -58.7421473270596,-34.4784756272252,0.0 -58.7432973231032,-34.4790984160508,0.0 -58.7439568174939,-34.4782644772436,0.0 ",
				"Polygon Outer Boundary",
				"208",
				"1330154",
				"Malvinas Argentinas",
				"Tierras Altas",
				"0154",
				"2014/07/25",
				"Santa Elena",
				"Villa",
				"90_o_anterior",
				"110",
				"2.1000000000000001000000000000000",
				"Paso de los Patos- Siria - Guatemala- FCGMB",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7504663788965,-34.4841443204124,0.0 -58.7504562705311,-34.4841068096744,0.0 -58.7499744750807,-34.4838516580793,0.0 -58.7497415281101,-34.4841506069051,0.0 -58.749620561966,-34.4843056688047,0.0 -58.7501337096784,-34.4845826855333,0.0 -58.7504663788965,-34.4841443204124,0.0 ",
				"Polygon Outer Boundary",
				"197",
				"1330066",
				"Malvinas Argentinas",
				"Tierras Altas",
				"0066",
				"2014/07/25",
				"Uruguay & Hernandez",
				"Villa",
				"90_o_anterior",
				"18",
				"0.3400000000000000200000000000000",
				"Uruguya- Hernandez-  ·Ecuador- Ambrosetti",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.78513813018798,-34.51674992407174,0.0 -58.78541707992554,-34.5165200801701,0.0 -58.7856638431549,-34.5162637150702,0.0 -58.78652835264801,-34.5150526003118,0.0 -58.78426456823945,-34.51353205174775,0.0 -58.78273034468293,-34.51521172588316,0.0 -58.78513813018798,-34.51674992407174,0.0 ",
				"Polygon Outer Boundary",
				"1739",
				"1320043",
				"Jose C. Paz",
				"Jose C. Paz",
				"0043",
				"2015/05/28",
				"Nuestra Sra. de Caacupé",
				"Asentamiento Precario",
				"2009",
				"125",
				"6.4299999999999997000000000000000",
				"Manuel Gorriti, Luis Pasteur, 11 de Septiembre",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.82829487323761,-34.516391897718755,0.0 -58.82780134677886,-34.51533549000636,0.0 -58.82720589637756,-34.51429232949837,0.0 -58.826321605592966,-34.513753063436965,0.0 -58.826181292533875,-34.5139210319287,0.0 -58.82633686065673,-34.51416856382565,0.0 -58.82643878459931,-34.51441167479438,0.0 -58.82678210735322,-34.5148625332588,0.0 -58.82699131965637,-34.515048180152704,0.0 -58.8272649049759,-34.51526034752492,0.0 -58.8273400068283,-34.515600698222684,0.0 -58.827415946871035,-34.51573330201429,0.0 -58.827479481697075,-34.51590568662786,0.0 -58.827720880508416,-34.51616205282941,0.0 -58.827694058418274,-34.516661522646146,0.0 -58.827849626541145,-34.517019547840455,0.0 -58.82829487323761,-34.516391897718755,0.0 ",
				"Polygon Outer Boundary",
				"2054",
				"0840029",
				"Pilar",
				"Presidente Derqui",
				"0029",
				"2015/08/05",
				"Santa Ana II",
				"Asentamiento Precario",
				"2010",
				"40",
				"1.8300000000000001000000000000000",
				"Suipacha, Cerrito, Libertad",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.24311843428,-33.4049852318899,0.0 -60.2436127438952,-33.4046108134223,0.0 -60.2438000046749,-33.4044948585727,0.0 -60.2440999263709,-33.4042648076867,0.0 -60.2443944829902,-33.4040388242749,0.0 -60.244540744612,-33.4039468418497,0.0 -60.2448336908654,-33.4037223931247,0.0 -60.2449891200295,-33.4036032534627,0.0 -60.2450970301486,-33.4035206327304,0.0 -60.24509968531,-33.403470858327,0.0 -60.2439954513878,-33.4023850552172,0.0 -60.242969764118,-33.4013938482257,0.0 -60.2424624023631,-33.4008949851252,0.0 -60.2424067253843,-33.4008967168112,0.0 -60.2417365312238,-33.4013732658273,0.0 -60.2415706424463,-33.4014807909812,0.0 -60.2410404713887,-33.4018671722875,0.0 -60.2407975561558,-33.4020315578065,0.0 -60.2403465451298,-33.4023580053825,0.0 -60.2400460408739,-33.4025729012624,0.0 -60.2396481789159,-33.4028789572923,0.0 -60.2396403601229,-33.4029284710796,0.0 -60.240409687048,-33.4037783780956,0.0 -60.2405322636833,-33.4039061699108,0.0 -60.2412609593336,-33.4047120614333,0.0 -60.24138276656,-33.4048716810756,0.0 -60.2421067992065,-33.4056959694811,0.0 -60.2421722896918,-33.4057043166733,0.0 -60.2428752317421,-33.4051639574636,0.0 -60.24311843428,-33.4049852318899,0.0 ",
				"Polygon Outer Boundary",
				"417",
				"0980003",
				"San Nicolas",
				"San Nicolás",
				"0003",
				"2014/07/25",
				"Sandrina",
				"Asentamiento Precario",
				"1963",
				"198",
				"13.9000000000000000000000000000000",
				"Juarez Celman, C. Saenz, Av. Quintana, Sdo Sombra",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.1995270450425,-33.3736820778612,0.0 -60.1994650368946,-33.3736805545939,0.0 -60.1989073689277,-33.3740809573113,0.0 -60.1987042475347,-33.3741665761001,0.0 -60.1981573746986,-33.374591482229,0.0 -60.1981641389065,-33.3746362821549,0.0 -60.1989844404394,-33.375364831538,0.0 -60.1990383962778,-33.3753690728149,0.0 -60.1995821571823,-33.3749458809389,0.0 -60.1997564395645,-33.3748896999594,0.0 -60.2003152044537,-33.3744984882362,0.0 -60.2003172391741,-33.3744485351771,0.0 -60.1995270450425,-33.3736820778612,0.0 ",
				"Polygon Outer Boundary",
				"419",
				"0980004",
				"San Nicolas",
				"San Nicolás",
				"0004",
				"2014/07/25",
				"Avambaé",
				"Asentamiento Precario",
				"2003",
				"20",
				"0.0400000000000000010000000000000",
				"Bogado, La Plata, Los Robles, Colectora, Zona rural",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.49565267562866,-34.81244679696917,0.0 -58.49320650100707,-34.81586448029783,0.0 -58.4907603263855,-34.81911467132121,0.0 -58.49328696727752,-34.82041383104768,0.0 -58.49469780921935,-34.82112285534068,0.0 -58.49513232707977,-34.821175701627446,0.0 -58.495556116104126,-34.82140470181168,0.0 -58.49691867828369,-34.8221137175758,0.0 -58.49740147590637,-34.821457547917625,0.0 -58.49773406982421,-34.82029492575503,0.0 -58.49779844284057,-34.820021883322354,0.0 -58.498356342315674,-34.81888566477075,0.0 -58.49893569946289,-34.81778466285208,0.0 -58.499128818511956,-34.81698312420002,0.0 -58.49908590316772,-34.81654271502769,0.0 -58.49922537803649,-34.816040645699516,0.0 -58.49925756454468,-34.815653081318615,0.0 -58.49916100502014,-34.81503649786439,0.0 -58.49939703941345,-34.81488675547199,0.0 -58.49971890449524,-34.81445514352411,0.0 -58.49821686744689,-34.813776891609336,0.0 -58.49565267562866,-34.81244679696917,0.0 ",
				"Polygon Outer Boundary",
				"1223",
				"0300003",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0003",
				"2014/10/01",
				"San Ignacio",
				"Asentamiento Precario",
				"90_o_anterior",
				"1300",
				"48.1099999999999990000000000000000",
				"Av. V. Fair, Hipólito Bouchard, M. Cichero, La Rioja",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.208624124526985,-34.871883692213004,0.0 -58.21070719510316,-34.87373215154341,0.0 -58.21727324277162,-34.86857396597322,0.0 -58.218367584049695,-34.86769369720491,0.0 -58.21723032742739,-34.866707784997075,0.0 -58.21523476392031,-34.86705989785681,0.0 -58.211093433201306,-34.86353870141323,0.0 -58.20871163159609,-34.861531551980256,0.0 -58.206329829990864,-34.86338024402837,0.0 -58.210385330021374,-34.866883841615405,0.0 -58.20625305175781,-34.87000878386692,0.0 -58.20660710334777,-34.870360882591555,0.0 -58.20991158485412,-34.86801939774748,0.0 -58.210115432739265,-34.86822185959671,0.0 -58.21125268936157,-34.86764088077915,0.0 -58.212432861328125,-34.86868840022097,0.0 -58.208624124526985,-34.871883692213004,0.0 ",
				"Polygon Outer Boundary",
				"1862",
				"0325242",
				"Florencio Varela",
				"Ingeniero Allan",
				"5242",
				"2015/07/06",
				"Diagonal Las Tobas & 1120",
				"Asentamiento Precario",
				"2010",
				"140",
				"54.9799999999999970000000000000000",
				"Diagonal Las Tobas & 1120",
				"Inexistente",
				"Sin dato",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.680934669449925,-33.680764717505106,0.0 -59.67997443862259,-33.67962640305579,0.0 -59.679153682664044,-33.680121906491976,0.0 -59.678850173950195,-33.67977371518647,0.0 -59.678231002762914,-33.68012637047391,0.0 -59.67681705951691,-33.67863538761642,0.0 -59.67613577842712,-33.679072864308715,0.0 -59.67655420303345,-33.679679971132515,0.0 -59.67591047286987,-33.68009512259546,0.0 -59.676961898803704,-33.68138074021611,0.0 -59.67662394046783,-33.68160839966615,0.0 -59.677079916000366,-33.682148530459266,0.0 -59.67816889286041,-33.681514657612674,0.0 -59.67778801918029,-33.68112629658793,0.0 -59.678603410720825,-33.680666510578035,0.0 -59.67948627658188,-33.68162179137975,0.0 -59.680934669449925,-33.680764717505106,0.0 ",
				"Polygon Outer Boundary",
				"1879",
				"0990002",
				"San Pedro",
				"San Pedro",
				"0002",
				"2015/07/08",
				"Banfield",
				"Asentamiento Precario",
				"90_o_anterior",
				"310",
				"7.7500000000000000000000000000000",
				"Las Provincias, Iglesias, Auli, Bozzano",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.2557116691024,-33.308528232169,0.0 -60.2551962741262,-33.3080225765586,0.0 -60.25501429076,-33.3078467717212,0.0 -60.2544826166489,-33.3073529578196,0.0 -60.2544236492583,-33.3073473081439,0.0 -60.2532691018553,-33.3081980992867,0.0 -60.2532650089412,-33.3082309270996,0.0 -60.2536394328026,-33.3085983883916,0.0 -60.2537966815858,-33.3087247461486,0.0 -60.2543120729415,-33.3092304980529,0.0 -60.2546865057363,-33.3095980462517,0.0 -60.2550762407706,-33.3099461770496,0.0 -60.2562726195671,-33.3090407343605,0.0 -60.2560828818456,-33.3088585459226,0.0 -60.2558976462492,-33.3087101588082,0.0 -60.2557116691024,-33.308528232169,0.0 ",
				"Polygon Outer Boundary",
				"416",
				"0980002",
				"San Nicolas",
				"San Nicolás",
				"0002",
				"2014/07/25",
				"San Martín",
				"Villa",
				"2004",
				"55",
				"0.0599999999999999980000000000000",
				"Gil Medina, José Nuñez, Montenegro, Chacabuco",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.2487617848877,-33.3178615694046,0.0 -60.248761784887,-33.3178615695871,0.0 -60.2489349058114,-33.3177879201535,0.0 -60.2496725193848,-33.3172772909796,0.0 -60.2502917711438,-33.3168386654664,0.0 -60.2487761955624,-33.3155292507389,0.0 -60.2485269055831,-33.3157399383923,0.0 -60.2477670059556,-33.3149692268899,0.0 -60.2465977848688,-33.3158201800616,0.0 -60.2487617848877,-33.3178615694046,0.0 ",
				"Polygon Outer Boundary",
				"425",
				"0980010",
				"San Nicolas",
				"San Nicolás",
				"0010",
				"2014/07/25",
				"Don Miguel",
				"Asentamiento Precario",
				"2001",
				"30",
				"5.0999999999999996000000000000000",
				"12 de marzo entre Moreno y Chacabuco, Moreno (parte de atrás de la lonja)",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.2023438000391,-33.3609534127281,0.0 -60.2022374823223,-33.3607919440325,0.0 -60.1962173765837,-33.3648345688016,0.0 -60.1965744941631,-33.3651653696384,0.0 -60.2023922743753,-33.3610907293439,0.0 -60.2023438000391,-33.3609534127281,0.0 ",
				"Polygon Outer Boundary",
				"429",
				"0980013",
				"San Nicolas",
				"San Nicolás",
				"0013",
				"2014/07/25",
				"Los Pinos",
				"Asentamiento Precario",
				"2009",
				"22",
				"0.0599999999999999980000000000000",
				"Malvidoni e/ M. Benitez y Sdo Sombra",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.2415050253341,-33.3470278835507,0.0 -60.2429625590852,-33.3484524413205,0.0 -60.2440815376302,-33.3475850552098,0.0 -60.2425613955993,-33.3461929094661,0.0 -60.2415050253341,-33.3470278835507,0.0 ",
				"Polygon Outer Boundary",
				"430",
				"0980014",
				"San Nicolas",
				"San Nicolás",
				"0014",
				"2014/07/25",
				"Evita",
				"Asentamiento Precario",
				"2008",
				"25",
				"2.0000000000000000000000000000000",
				"Bergantín 25 de mayo, Alberdi, Goleta Invencible, león Guruciaga",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.90575444698334,-34.942161882452915,0.0 -57.90570080280304,-34.94220145884342,0.0 -57.90617823600769,-34.94267637403971,0.0 -57.906543016433716,-34.94239934050947,0.0 -57.9055083938523,-34.9413530456379,0.0 -57.9046036294227,-34.9404846877017,0.0 -57.9053235469815,-34.939941438379,0.0 -57.9037229690298,-34.9384903096016,0.0 -57.9027716569009,-34.9376217251286,0.0 -57.901892708247,-34.9368129606095,0.0 -57.9014957580435,-34.9364406720539,0.0 -57.9012941595342,-34.9360454983822,0.0 -57.9010362373783,-34.9358389112694,0.0 -57.9009504775168,-34.9356589302369,0.0 -57.9007708797272,-34.9354017341309,0.0 -57.9005605092005,-34.9351798831533,0.0 -57.9004973347304,-34.9351725728335,0.0 -57.8995735260115,-34.9358286104537,0.0 -57.8995797938797,-34.9358789147493,0.0 -57.8996884078633,-34.9360088984596,0.0 -57.8998934080282,-34.9359393588578,0.0 -57.9002373782075,-34.9360037891613,0.0 -57.9003619366741,-34.9361127400247,0.0 -57.9007426555402,-34.9367998891659,0.0 -57.9012972223236,-34.9373835152007,0.0 -57.9018530558126,-34.9378471081365,0.0 -57.9023528977193,-34.938419725233,0.0 -57.9023526220335,-34.938670098892,0.0 -57.9024255855872,-34.9389058182523,0.0 -57.9027341765576,-34.939208917416,0.0 -57.9025240307765,-34.9393565516047,0.0 -57.9021636822599,-34.9396260889649,0.0 -57.9023641611874,-34.9398112306425,0.0 -57.9029651887339,-34.9403657455062,0.0 -57.9037666047382,-34.9411052151359,0.0 -57.9043019097427,-34.9415466621115,0.0 -57.9049039657801,-34.9421004645008,0.0 -57.9053795895719,-34.9418377346834,0.0 -57.905385672234004,-34.94183648042793,0.0 -57.90538871356507,-34.94183585330017,0.0 -57.90539023423057,-34.941835539736296,0.0 -57.905390994563334,-34.94183538295439,0.0 -57.90539137472971,-34.94183530456341,0.0 -57.9053915648129,-34.94183526536793,0.0 -57.90539175489611,-34.94183522617243,0.0 -57.905394796227164,-34.94183459904468,0.0 -57.90539555655992,-34.94183444226274,0.0 -57.90538966655731,-34.94181888626839,0.0 -57.9053963168927,-34.941834285480816,0.0 -57.905397837558226,-34.941833971916935,0.0 -57.9054039202203,-34.9418327176614,0.0 -57.90575444698334,-34.942161882452915,0.0 ",
				"Polygon Outer Boundary",
				"299",
				"0550025",
				"La Plata",
				"Villa Elvira",
				"0025",
				"2014/08/20",
				"Villa Montoro 2",
				"Asentamiento Precario",
				"2002",
				"130",
				"10.4700000000000010000000000000000",
				"90, 177, 2 y 92",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.2615183707343,-33.4217407240187,0.0 -60.2600905570851,-33.4203852665579,0.0 -60.257645383548,-33.4222037818212,0.0 -60.2590850217532,-33.4235609554184,0.0 -60.2597455832475,-33.4230742361221,0.0 -60.2615183707343,-33.4217407240187,0.0 ",
				"Polygon Outer Boundary",
				"421",
				"0980006",
				"San Nicolas",
				"San Nicolás",
				"0006",
				"2014/07/25",
				"Villa Esperanza",
				"Villa",
				"decada_1980",
				"130",
				"6.0999999999999996000000000000000",
				"Calle 1 (entrada), calle 7 (camino rural), calle 6 (dispensario), calle 2 y 3 (costado de plaza), calle 4 (contra campo inundable) y calle 5 (frente al dispensario",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.1840857615691,-33.3475831817294,0.0 -60.183420622734,-33.3469045969122,0.0 -60.1830208561748,-33.3472208868284,0.0 -60.1825622890446,-33.3476880830288,0.0 -60.1827475447597,-33.348130175039,0.0 -60.1826911928028,-33.3483550773853,0.0 -60.1833241055051,-33.3482383286148,0.0 -60.1837704461447,-33.3481831672401,0.0 -60.1839403806742,-33.3479308453796,0.0 -60.1840857615691,-33.3475831817294,0.0 ",
				"Polygon Outer Boundary",
				"431",
				"0980015",
				"San Nicolas",
				"San Nicolás",
				"0015",
				"2014/07/25",
				"Los Pescadores",
				"Asentamiento Precario",
				"2007",
				"18",
				"1.0000000000000000000000000000000",
				"Colón, Pombo, Río Paraná, Camino muelle pesca",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.48779916763306,-34.73947013192059,0.0 -58.488389253616326,-34.739655276933014,0.0 -58.48876476287842,-34.73928498649328,0.0 -58.485996723175056,-34.73813883890029,0.0 -58.48453760147095,-34.73750404262303,0.0 -58.48399043083191,-34.738332803456714,0.0 -58.48320722579956,-34.73798895688574,0.0 -58.48372220993043,-34.7371337425425,0.0 -58.48075032234192,-34.73592584741171,0.0 -58.47934484481811,-34.737891974260855,0.0 -58.47737073898315,-34.74082785237726,0.0 -58.47991347312928,-34.7405016488493,0.0 -58.48219418898225,-34.74819794553246,0.0 -58.482842445373535,-34.747166524699765,0.0 -58.48415756598114,-34.74542982975354,0.0 -58.48467255011201,-34.744751010128816,0.0 -58.4850480593741,-34.74412508059666,0.0 -58.486056569963694,-34.742776230412574,0.0 -58.48672175779939,-34.74191224944265,0.0 -58.48592782393097,-34.74148025556939,0.0 -58.48473692312837,-34.74308479285498,0.0 -58.48390007391573,-34.74271451778579,0.0 -58.484511617571115,-34.74170947708956,0.0 -58.48429704084992,-34.74162131504169,0.0 -58.48403334617615,-34.74055454680621,0.0 -58.48525643348694,-34.74035177112085,0.0 -58.485428094863884,-34.74032532208173,0.0 -58.485342264175415,-34.73986687072492,0.0 -58.48779916763306,-34.73947013192059,0.0 ",
				"Polygon Outer Boundary",
				"1459",
				"0630069",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0069",
				"2015/03/17",
				"Santa Catalina I",
				"Otros",
				"90_o_anterior",
				"2350",
				"52.6899999999999980000000000000000",
				"Av. Brigadier Juan Manuel de Rosas, Av. Dr. Gilberto Elizalde, Arroyo Santa Catalina",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.32924842834473,-34.815027689495906,0.0 -58.33031058311463,-34.815573806561574,0.0 -58.331812620162964,-34.81366238099492,0.0 -58.330610990524285,-34.81302816547975,0.0 -58.329377174377434,-34.812437988323815,0.0 -58.32807898521423,-34.81190065917726,0.0 -58.32761764526367,-34.81261856536513,0.0 -58.3287763595581,-34.813261592591246,0.0 -58.32945764064788,-34.81359631710654,0.0 -58.330010175704956,-34.8139178275317,0.0 -58.32924842834473,-34.815027689495906,0.0 ",
				"Polygon Outer Boundary",
				"1253",
				"0030026",
				"Almirante Brown",
				"Don Orione",
				"0026",
				"2014/10/01",
				"Las Latitas",
				"Asentamiento Precario",
				"2008",
				"660",
				"5.8300000000000001000000000000000",
				"Araujo, Humahuaca, Portela y Blas Parera",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.2470002742428,-33.3289909775079,0.0 -60.2483230712437,-33.3280416329294,0.0 -60.2491192222054,-33.3274626375172,0.0 -60.2490977915598,-33.3274424840673,0.0 -60.2483848405697,-33.3267966342099,0.0 -60.2483297491773,-33.3267988180919,0.0 -60.2479147581448,-33.3271068310358,0.0 -60.2477585868439,-33.3272181327946,0.0 -60.2473212924884,-33.3275405240827,0.0 -60.2471629619216,-33.3276484032085,0.0 -60.2467318844939,-33.3279678948374,0.0 -60.2465701980435,-33.328105082718,0.0 -60.2463169112105,-33.328286180917,0.0 -60.2466163107788,-33.3285754596608,0.0 -60.2465851221631,-33.3285989638522,0.0 -60.2467945759196,-33.328794471233,0.0 -60.2470002742428,-33.3289909775079,0.0 ",
				"Polygon Outer Boundary",
				"415",
				"0980001",
				"San Nicolas",
				"San Nicolás",
				"0001",
				"2014/07/25",
				"Martínez",
				"Asentamiento Precario",
				"decada_1990",
				"90",
				"4.0000000000000000000000000000000",
				"Alvarez, Dámaso Valdez, Rondeaux, Crul Mellian",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.2676920144484,-33.3062210687531,0.0 -60.2687409372384,-33.305435560027,0.0 -60.2688093846819,-33.3053464210388,0.0 -60.2700049195974,-33.3044775443399,0.0 -60.270981118024,-33.3037298623205,0.0 -60.2693656795361,-33.3022307196075,0.0 -60.2692756945238,-33.3020887276959,0.0 -60.2676456812997,-33.3006142981023,0.0 -60.2658210068896,-33.3019883305792,0.0 -60.2655033342347,-33.3022410797984,0.0 -60.265338975098,-33.302365880958,0.0 -60.2643468105872,-33.3031353721216,0.0 -60.2654079912007,-33.3040947878543,0.0 -60.2660307605047,-33.3046944822606,0.0 -60.2676920144484,-33.3062210687531,0.0 ",
				"Polygon Outer Boundary",
				"422",
				"0980007",
				"San Nicolas",
				"San Nicolás",
				"0007",
				"2014/07/25",
				"Las Mellizas",
				"Asentamiento Precario",
				"decada_1990",
				"27",
				"19.1999999999999990000000000000000",
				"Chapin, Strauss, Nobel entre Chacabuco y Moreno",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.2233140825039,-33.3240370169437,0.0 -60.2221135856132,-33.3228569550973,0.0 -60.2219757216217,-33.3229554790847,0.0 -60.2224263058206,-33.3233995174918,0.0 -60.2220605549153,-33.3236553067819,0.0 -60.2215286907492,-33.3240432788513,0.0 -60.2222449104678,-33.3247519411074,0.0 -60.2223176299689,-33.3247556879884,0.0 -60.2228323162017,-33.3243853691762,0.0 -60.2233140825039,-33.3240370169437,0.0 ",
				"Polygon Outer Boundary",
				"420",
				"0980005",
				"San Nicolas",
				"San Nicolás",
				"0005",
				"2014/07/25",
				"Santuario",
				"Villa",
				"decada_1950",
				"36",
				"1.5000000000000000000000000000000",
				"Sarmiento, Bustamante, Santuario, Av Costanera, cortada Cafiero",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.2218637396547,-33.3483909891483,0.0 -60.2222013415637,-33.3487102814711,0.0 -60.2226493850731,-33.3483968862156,0.0 -60.2226794281749,-33.3484245120148,0.0 -60.2232681350269,-33.3480013149221,0.0 -60.2234050097715,-33.347921274875,0.0 -60.22444410954,-33.3471868320395,0.0 -60.2240895613019,-33.3468371012478,0.0 -60.225295139979,-33.3460067670296,0.0 -60.224367330107,-33.3450331380226,0.0 -60.2231346195129,-33.3458606487718,0.0 -60.2221265514829,-33.3465451654859,0.0 -60.221838662026,-33.3467628814932,0.0 -60.2209548129668,-33.3473831513859,0.0 -60.2209526756375,-33.3474301299798,0.0 -60.221173047953,-33.3476573073959,0.0 -60.2217389382785,-33.3481915021938,0.0 -60.2218637396547,-33.3483909891483,0.0 ",
				"Polygon Outer Boundary",
				"424",
				"0980009",
				"San Nicolas",
				"San Nicolás",
				"0009",
				"2014/07/25",
				"Mitre",
				"Otros",
				"decada_2000",
				"35",
				"2.0000000000000000000000000000000",
				"Morteo, Falcón. Güemes, Ameghino",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.0486356957936,-34.092264688719,0.0 -59.0485195494132,-34.0924187521129,0.0 -59.0491364826405,-34.0927420184491,0.0 -59.0502683243043,-34.0912416204811,0.0 -59.0512152520569,-34.0899863359783,0.0 -59.0496708998535,-34.0900816627188,0.0 -59.0482545262247,-34.0902199940952,0.0 -59.0489412018446,-34.0905934727129,0.0 -59.0479320425217,-34.0918871103366,0.0 -59.0486356957936,-34.092264688719,0.0 ",
				"Polygon Outer Boundary",
				"461",
				"0380011",
				"Zarate",
				"Zárate",
				"0011",
				"2014/09/18",
				"La Ponderosa",
				"Villa",
				"1998",
				"60",
				"4.7699999999999996000000000000000",
				"Guiraldes, J. J. Paso, vías ferrocarril Mitre",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.0455824985384,-34.1143252912616,0.0 -59.0449172504509,-34.1139777422443,0.0 -59.0438401038346,-34.1154743609056,0.0 -59.0445034141733,-34.1158310054888,0.0 -59.0455824985384,-34.1143252912616,0.0 ",
				"Polygon Outer Boundary",
				"454",
				"0380006",
				"Zarate",
				"Zárate",
				"0006",
				"2014/09/18",
				"6 de Agosto",
				"Asentamiento Precario",
				"2008",
				"50",
				"1.5700000000000001000000000000000",
				"Calle 14, Mitre, Pasaje Bs. As., Hipólito Yrigoyen, Psaje Libertad, Pinto",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.546668626368046,-34.72353729076642,0.0 -58.54685084894299,-34.72364751742824,0.0 -58.546936679631465,-34.72360783584692,0.0 -58.54720490053296,-34.72371365335479,0.0 -58.54850308969616,-34.72454696149619,0.0 -58.551689554005854,-34.72214401309217,0.0 -58.55107817798853,-34.72163255083911,0.0 -58.550026752054684,-34.720636072190054,0.0 -58.548009730875485,-34.71899582454362,0.0 -58.54731235653162,-34.71936620588856,0.0 -58.54789171367883,-34.7197718597437,0.0 -58.547784425318234,-34.71980713389792,0.0 -58.5462287440896,-34.720891806794235,0.0 -58.54479108005763,-34.72201173867489,0.0 -58.545005656778805,-34.722205741081154,0.0 -58.546668626368046,-34.72353729076642,0.0 ",
				"Polygon Outer Boundary",
				"2182",
				"0700157",
				"La Matanza",
				"La Matanza",
				"0157",
				"2015/09/10",
				"Un Techo para todos",
				"Asentamiento Precario",
				"2004",
				"500",
				"19.2899999999999990000000000000000",
				"Las Gardenias, Las Magnolias y las Camelias",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.0014914801246,-34.1074732205853,0.0 -59.0001554075683,-34.1069888125415,0.0 -58.9999937083878,-34.1063262721424,0.0 -58.999541818425,-34.1064073298352,0.0 -58.9956284009433,-34.1075072693851,0.0 -58.9952812301638,-34.1080982240292,0.0 -58.9937144501817,-34.1082550528876,0.0 -58.9934393346481,-34.1085072816563,0.0 -58.9919036604841,-34.1089188252336,0.0 -58.9935492814529,-34.1095183623252,0.0 -59.0014914801246,-34.1074732205853,0.0 ",
				"Polygon Outer Boundary",
				"456",
				"0380008",
				"Zarate",
				"Zárate",
				"0008",
				"2014/09/18",
				"Ferry",
				"Asentamiento Precario",
				"1994",
				"50",
				"5.8899999999999997000000000000000",
				"Río Paraná de Las Palmas, Arenera",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.0334773180744,-34.0817763562018,0.0 -59.0319561137702,-34.0807559736854,0.0 -59.0309504094341,-34.0816000013562,0.0 -59.031123960669,-34.0819022271458,0.0 -59.0313375621727,-34.0822597367417,0.0 -59.0310794614477,-34.0828052128439,0.0 -59.0311996121595,-34.0828862967068,0.0 -59.0314443635772,-34.0830226648135,0.0 -59.0317603156345,-34.0835091659144,0.0 -59.0326834476933,-34.0840028178444,0.0 -59.0332040342095,-34.0833170196611,0.0 -59.0331945951639,-34.0832705196364,0.0 -59.0333005056264,-34.0831032286431,0.0 -59.0338156484211,-34.0824760706092,0.0 -59.0331708767151,-34.0821163599852,0.0 -59.0334773180744,-34.0817763562018,0.0 ",
				"Polygon Outer Boundary",
				"464",
				"0380014",
				"Zarate",
				"Zárate",
				"0014",
				"2014/09/18",
				"Barrio H",
				"Asentamiento Precario",
				"1995",
				"130",
				"18.9100000000000000000000000000000",
				"Pavón, Maipú, 3 de Febrero, orillas del Río Paraná de Las Palmas",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.0143398281019,-34.1405865752821,0.0 -59.0149879821904,-34.1397438815035,0.0 -59.0124068559615,-34.1383804011386,0.0 -59.0123791601206,-34.1383940608463,0.0 -59.0123470237062,-34.1397020339549,0.0 -59.0122971118704,-34.1405175407104,0.0 -59.0129662577164,-34.1407371967098,0.0 -59.0140045154533,-34.1410460484962,0.0 -59.0143398281019,-34.1405865752821,0.0 ",
				"Polygon Outer Boundary",
				"467",
				"0380017",
				"Zarate",
				"Zárate",
				"0017",
				"2014/09/18",
				"Los Sauces",
				"Asentamiento Precario",
				"2004",
				"50",
				"12.8699999999999990000000000000000",
				"Saavedra, Camino viejo a Campana y terrenos baldíos",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.32548260688782,-34.76928194786794,0.0 -58.31216812133789,-34.76218697124826,0.0 -58.31076264381409,-34.76383517547488,0.0 -58.32424879074097,-34.77113271103535,0.0 -58.32548260688782,-34.76928194786794,0.0 ",
				"Polygon Outer Boundary",
				"926",
				"0860022",
				"Quilmes",
				"Quilmes",
				"0022",
				"2014/10/01",
				"Sayonara",
				"Asentamiento Precario",
				"1981",
				"700",
				"33.5300000000000010000000000000000",
				"894 y 27 de Noviembre",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.0091244734607,-34.1364032587969,0.0 -59.0098547969096,-34.135143160085,0.0 -59.0084264036916,-34.1343923376766,0.0 -59.0079070136757,-34.1352186572456,0.0 -59.0057846656217,-34.13412758089,0.0 -59.0055273066946,-34.1344553492857,0.0 -59.0091244734607,-34.1364032587969,0.0 ",
				"Polygon Outer Boundary",
				"465",
				"0380015",
				"Zarate",
				"Zárate",
				"0015",
				"2014/09/18",
				"Las Violetas",
				"Villa",
				"1996",
				"80",
				"7.4100000000000001000000000000000",
				"Colectora Ruta 6, Scholnik, Fábrica Monsanto",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.0319756243502,-34.1218588591856,0.0 -59.0291770944868,-34.1203608744877,0.0 -59.028608279429,-34.1211436380012,0.0 -59.027627033281,-34.1210144005646,0.0 -59.0274932285892,-34.1206636206499,0.0 -59.0272925195552,-34.1205528472162,0.0 -59.0269235017774,-34.1210985103888,0.0 -59.0233484635077,-34.1205475528631,0.0 -59.02327754141,-34.1208146008797,0.0 -59.0264004733115,-34.121328250569,0.0 -59.0266792363763,-34.1213744064094,0.0 -59.0269774145082,-34.1212214498128,0.0 -59.0319756243502,-34.1218588591856,0.0 ",
				"Polygon Outer Boundary",
				"469",
				"0380018",
				"Zarate",
				"Zárate",
				"0018",
				"2014/09/18",
				"Los Rosales",
				"Asentamiento Precario",
				"1992",
				"72",
				"13.1500000000000000000000000000000",
				"Almafuerte, Pacheco, Paredón que linda con el ferrocarril Urquiza",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.0104289885294,-34.1168460089218,0.0 -59.0107381935271,-34.1162923123164,0.0 -59.0097593550878,-34.115592919962,0.0 -59.010018778194,-34.1150917690074,0.0 -59.0094134577655,-34.1147624395659,0.0 -59.0093100587407,-34.1138866765665,0.0 -59.0080357299323,-34.1132142854371,0.0 -59.0078446396047,-34.1143850056584,0.0 -59.0084679072661,-34.1150756025127,0.0 -59.0091995259243,-34.1158031962271,0.0 -59.0104289885294,-34.1168460089218,0.0 ",
				"Polygon Outer Boundary",
				"466",
				"0380016",
				"Zarate",
				"Zárate",
				"0016",
				"2014/09/18",
				"Los Pomelos",
				"Villa",
				"2000",
				"80",
				"4.2400000000000002000000000000000",
				"Justa Lima, teodor Fels, ruta Nacional Nº 12",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.0508281392994,-34.1042030540502,0.0 -59.0505742998808,-34.1040705594568,0.0 -59.0504064585818,-34.1042915644234,0.0 -59.0502294293338,-34.1042000487454,0.0 -59.0500497207146,-34.1044355652533,0.0 -59.0504684262098,-34.1046522707174,0.0 -59.0505140184239,-34.1046454113989,0.0 -59.0508369301889,-34.1042407132655,0.0 -59.0508281392994,-34.1042030540502,0.0 ",
				"Polygon Outer Boundary",
				"460",
				"0380010",
				"Zarate",
				"Zárate",
				"0010",
				"2014/09/18",
				"Agua y energía",
				"Asentamiento Precario",
				"2008",
				"12",
				"0.2399999999999999900000000000000",
				"Calle 34, entre De La Torre y V. Alsina",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.645323518663645,-37.947632532608914,0.0 -57.64506602659821,-37.94737871801567,0.0 -57.64474416151642,-37.94738717851623,0.0 -57.63858580961823,-37.95198108643417,0.0 -57.63762021437288,-37.95330928988461,0.0 -57.63770604506135,-37.9533685085875,0.0 -57.639411929994814,-37.95209952593365,0.0 -57.63974452391267,-37.95278477928932,0.0 -57.64007711783052,-37.953529244826136,0.0 -57.64052772894502,-37.95403683063911,0.0 -57.64069092459976,-37.95421871470184,0.0 -57.64111471362411,-37.95451903391271,0.0 -57.64135074801742,-37.95460786048627,0.0 -57.64186573214829,-37.95481935189574,0.0 -57.642477275803685,-37.954967395520065,0.0 -57.64274549670517,-37.95498431477242,0.0 -57.643324853852384,-37.954967395520065,0.0 -57.64390957541763,-37.95485319046475,0.0 -57.64432800002396,-37.95463323948756,0.0 -57.64489126391709,-37.95432869089338,0.0 -57.645545722916715,-37.95381687721745,0.0 -57.64592123217881,-37.95344464684965,0.0 -57.646368741989136,-37.95317393267016,0.0 -57.64807236380875,-37.951964166490086,0.0 -57.6487107295543,-37.95149463648717,0.0 -57.64915597625077,-37.95115623462423,0.0 -57.6491613406688,-37.95083898146202,0.0 -57.645323518663645,-37.947632532608914,0.0 ",
				"Polygon Outer Boundary",
				"1301",
				"0450024",
				"General Pueyrredon",
				"Mar Del Plata",
				"0024",
				"2015/01/30",
				"La Herradura",
				"Asentamiento Precario",
				"90_o_anterior",
				"400",
				"43.5099999999999980000000000000000",
				"Av. de la Herradura, Av. Colon, Salvador Viva, Av Pedro Luro",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-61.29823923110961,-38.71297385102971,0.0 -61.29369020462036,-38.71206971351445,0.0 -61.29358291625976,-38.712337607303745,0.0 -61.298153400421135,-38.713224998310054,0.0 -61.29823923110961,-38.71297385102971,0.0 ",
				"Polygon Outer Boundary",
				"1614",
				"0220001",
				"Coronel Dorrego",
				"Coronel Dorrego",
				"0001",
				"2015/04/24",
				"Estación Dorrego",
				"Otros",
				"decada_1970",
				"17",
				"1.2300000000000000000000000000000",
				"Los Reseros, San Martín, Colón y Guillermo Aranda",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.56667843898321,-34.73674901345898,0.0 -58.5651281221726,-34.73672697163257,0.0 -58.565047655902156,-34.736815138902955,0.0 -58.56659260829474,-34.736859222502865,0.0 -58.56667843898321,-34.73674901345898,0.0 ",
				"Polygon Outer Boundary",
				"1612",
				"0700139",
				"La Matanza",
				"Isidro Casanova",
				"0139",
				"2015/04/23",
				"El Pasillo",
				"Asentamiento Precario",
				"90_o_anterior",
				"12",
				"0.1600000000000000000000000000000",
				"Canal Venecia y Elias Bedoya",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.53949069976806,-34.67812684541184,0.0 -58.5400727391243,-34.6775732015875,0.0 -58.540062010288246,-34.67753349790407,0.0 -58.539906442165375,-34.67743203284885,0.0 -58.5398581624031,-34.67743644437558,0.0 -58.53946655988693,-34.67812463966689,0.0 -58.53949069976806,-34.67812684541184,0.0 ",
				"Polygon Outer Boundary",
				"1078",
				"0700052",
				"La Matanza",
				"San Justo",
				"0052",
				"2014/10/01",
				"El Triangulo",
				"Villa",
				"90_o_anterior",
				"25",
				"0.1200000000000000000000000000000",
				"Matheu y José Martí",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-59.0537726773937,-34.0999763318869,0.0 -59.0510235298993,-34.0985148451877,0.0 -59.0480370970522,-34.1024302600717,0.0 -59.0507777813436,-34.1038603768659,0.0 -59.0537726773937,-34.0999763318869,0.0 ",
				"Polygon Outer Boundary",
				"453",
				"0380005",
				"Zarate",
				"Zárate",
				"0005",
				"2014/09/18",
				"La Ilusion",
				"Otros",
				"1997",
				"400",
				"14.2799999999999990000000000000000",
				"V. Alsina, J. B. Justo, Calle 24, calle 32",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.0409833489375,-34.111832063864,0.0 -59.0403823090859,-34.1114740840812,0.0 -59.0399839976986,-34.1112742710946,0.0 -59.0398535322,-34.1111955447369,0.0 -59.03916904085,-34.1108479947044,0.0 -59.0380614017059,-34.112400125108,0.0 -59.0398759028208,-34.1133784427002,0.0 -59.0409833489375,-34.111832063864,0.0 ",
				"Polygon Outer Boundary",
				"470",
				"0380019",
				"Zarate",
				"Zárate",
				"0019",
				"2014/09/18",
				"Los Olivos",
				"Asentamiento Precario",
				"2003",
				"122",
				"3.9700000000000002000000000000000",
				"Pividal, Mitre, calle 4, Pinto",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.563775420188904,-34.51188770637458,0.0 -58.563078045845025,-34.511352845106096,0.0 -58.56083035469056,-34.51338176346423,0.0 -58.56144726276397,-34.513898930830706,0.0 -58.563775420188904,-34.51188770637458,0.0 ",
				"Polygon Outer Boundary",
				"1433",
				"0970018",
				"San Isidro",
				"San Isidro",
				"0018",
				"2015/03/06",
				"Santa Rosa",
				"Asentamiento Precario",
				"90_o_anterior",
				"150",
				"2.5800000000000001000000000000000",
				"Guayaquil, Loria, Predio Ferrovías,  Eduardo Wilde",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.48600745201111,-34.737883157652945,0.0 -58.487445116043084,-34.73560844138222,0.0 -58.487992286682136,-34.73491190721101,0.0 -58.4864858928312,-34.7336555622304,0.0 -58.4859538078308,-34.73364226020002,0.0 -58.485556840896606,-34.734285903136474,0.0 -58.48512768745422,-34.73492072413594,0.0 -58.48390460014343,-34.73698385870479,0.0 -58.48600745201111,-34.737883157652945,0.0 ",
				"Polygon Outer Boundary",
				"1000",
				"0630011",
				"Lomas de Zamora",
				"Santa Catalina",
				"0011",
				"2014/10/01",
				"6 de Agosto - El Olimpo",
				"Asentamiento Precario",
				"2006",
				"500",
				"9.1500000000000004000000000000000",
				"Calle 4 (Comunidad Organizada); Avda. Juan Manuel de Rosas u Olimpo; Los Pinos o calle 2 (abierta recientemente y que lo separa del asentamiento irregular ubicado en la ex planta de Totalgaz); calle 19,  y Diag. 64 ó Avda. de La Noria",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.580208621284,-34.5019884089825,0.0 -58.5814374706713,-34.5029732670725,0.0 -58.5816499462517,-34.5027899645666,0.0 -58.5818208187062,-34.5026523281863,0.0 -58.582333148843,-34.502198312309,0.0 -58.5823353198059,-34.5021601199415,0.0 -58.581828893152,-34.5017514249421,0.0 -58.5811498877216,-34.5012152545409,0.0 -58.5811038321574,-34.5012153505516,0.0 -58.5805794835341,-34.5016718356164,0.0 -58.5803861226521,-34.5018322836868,0.0 -58.580208621284,-34.5019884089825,0.0 ",
				"Polygon Outer Boundary",
				"877",
				"0970007",
				"San Isidro",
				"San Isidro",
				"0007",
				"2014/10/01",
				"Binca",
				"Villa",
				"90_o_anterior",
				"48",
				"1.9199999999999999000000000000000",
				"Capitán Juan de San Martín, Junín, Olazabal",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.61240697093308,-34.55196600630611,0.0 -58.61233186908066,-34.55191298789199,0.0 -58.61147356219589,-34.55256687930505,0.0 -58.61185133457183,-34.55290707753495,0.0 -58.61272573471069,-34.55224435242599,0.0 -58.61240697093308,-34.55196600630611,0.0 ",
				"Polygon Outer Boundary",
				"1417",
				"1170022",
				"Tres de Febrero",
				"Tres de Febrero",
				"0022",
				"2015/02/23",
				"Lujan & Lavalle",
				"Otros",
				"2006",
				"39",
				"0.5600000000000000500000000000000",
				"Lavalle entre Lujan y Tucumán",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.89727592468261,-34.47198913102622,0.0 -58.89806533232332,-34.47175916371003,0.0 -58.89696026220918,-34.47118424264712,0.0 -58.896810058504336,-34.47138767670678,0.0 -58.89727592468261,-34.47198913102622,0.0 ",
				"Polygon Outer Boundary",
				"2058",
				"0840032",
				"Pilar",
				"Pilar",
				"0032",
				"2015/08/06",
				"Buenos Aires & FFCC San Martin",
				"Asentamiento Precario",
				"2012",
				"15",
				"0.4600000000000000200000000000000",
				"Buenos Aires, Tierra del Fuego",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.08415615558624,-35.19034655337075,0.0 -59.08419102430343,-35.18983142847664,0.0 -59.08300817012787,-35.18979854805335,0.0 -59.08298403024674,-35.190300521066284,0.0 -59.08415615558624,-35.19034655337075,0.0 ",
				"Polygon Outer Boundary",
				"1416",
				"0620004",
				"Lobos",
				"Lobos",
				"0004",
				"2015/02/23",
				"PYM",
				"Asentamiento Precario",
				"decada_2000",
				"25",
				"2.2000000000000002000000000000000",
				"Berro, Mar Chiquita y Lomas de Zamora",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.085631370544434,-35.1916003756343,0.0 -59.085626006126404,-35.190469306055164,0.0 -59.08425807952881,-35.19046053801243,0.0 -59.08421516418457,-35.191591607713626,0.0 -59.085631370544434,-35.1916003756343,0.0 ",
				"Polygon Outer Boundary",
				"1416",
				"0620004",
				"Lobos",
				"Lobos",
				"0004",
				"2015/02/23",
				"PYM",
				"Asentamiento Precario",
				"decada_2000",
				"25",
				"2.2000000000000002000000000000000",
				"Berro, Mar Chiquita y Lomas de Zamora",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.09289747476578,-35.15114828006909,0.0 -59.089665412902825,-35.15068773388366,0.0 -59.08961445093155,-35.15101888878504,0.0 -59.09040302038193,-35.15120091375287,0.0 -59.09134715795517,-35.15144215103461,0.0 -59.092385172843926,-35.15149039840512,0.0 -59.09291625022888,-35.15146188859873,0.0 -59.09290015697479,-35.15124258206171,0.0 -59.09289747476578,-35.15114828006909,0.0 ",
				"Polygon Outer Boundary",
				"1415",
				"0620003",
				"Lobos",
				"Lobos",
				"0003",
				"2015/02/23",
				"ASENTAMIENTO FERROVIARIO",
				"Villa",
				"90_o_anterior",
				"50",
				"3.1499999999999999000000000000000",
				"parte de la fracción de la Estación de Empalme Lobos, Calle 10 e Independencia",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.09097433090209,-35.152911489941964,0.0 -59.09170389175414,-35.15226235244273,0.0 -59.090896965935826,-35.151639526460414,0.0 -59.08989918418228,-35.151218458306566,0.0 -59.089464666321874,-35.15184128751194,0.0 -59.090210320428014,-35.15225796636094,0.0 -59.09066629596055,-35.15262201034562,0.0 -59.09097433090209,-35.152911489941964,0.0 ",
				"Polygon Outer Boundary",
				"1415",
				"0620003",
				"Lobos",
				"Lobos",
				"0003",
				"2015/02/23",
				"ASENTAMIENTO FERROVIARIO",
				"Villa",
				"90_o_anterior",
				"50",
				"3.1499999999999999000000000000000",
				"parte de la fracción de la Estación de Empalme Lobos, Calle 10 e Independencia",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.930253744125366,-34.94875328681423,0.0 -57.93046295642852,-34.94859499378684,0.0 -57.92993187904358,-34.948106921695064,0.0 -57.9302430152893,-34.947887068452275,0.0 -57.929803133010864,-34.94748253694514,0.0 -57.92965292930602,-34.947605655441215,0.0 -57.929132580757134,-34.947113180347564,0.0 -57.92863368988038,-34.947416580531886,0.0 -57.9262554140704,-34.9494372914605,0.0 -57.9269771599333,-34.9500989084062,0.0 -57.9277660099341,-34.9508066544186,0.0 -57.9284702054702,-34.9514577084758,0.0 -57.9303490351104,-34.9498667148947,0.0 -57.93089747428894,-34.9493600739212,0.0 -57.930253744125366,-34.94875328681423,0.0 ",
				"Polygon Outer Boundary",
				"286",
				"0550006",
				"La Plata",
				"San Lorenzo",
				"0006",
				"2014/06/30",
				"La Esperanza (extension)",
				"Villa",
				"2006",
				"235",
				"10.6300000000000010000000000000000",
				"81 a 83 bis - 17 a 19",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.0301767279945,-34.8653697854629,0.0 -58.0312476652415,-34.8649230983839,0.0 -58.0314591499364,-34.86480305661,0.0 -58.0327244583919,-34.8642609105176,0.0 -58.0327270957923,-34.8642190465613,0.0 -58.0323250429527,-34.8635998911268,0.0 -58.032483070748,-34.8635159320849,0.0 -58.0335534409126,-34.8630501990296,0.0 -58.0335578265712,-34.8630083633211,0.0 -58.0331588886347,-34.8623961101815,0.0 -58.0333301425704,-34.8623029912929,0.0 -58.0342511063626,-34.8618982801993,0.0 -58.034369269644,-34.8617066091638,0.0 -58.0340418443221,-34.8612180808726,0.0 -58.0339210530337,-34.8610654435643,0.0 -58.0335264729671,-34.8604770542295,0.0 -58.0334758960012,-34.860470558384,0.0 -58.0324109637149,-34.8609526915704,0.0 -58.0322327434756,-34.8610216339152,0.0 -58.0311254190781,-34.8614973015206,0.0 -58.0309699695315,-34.8615878795167,0.0 -58.0297317379618,-34.8621237778997,0.0 -58.0297132175867,-34.8621576338722,0.0 -58.0300858606781,-34.8627415741631,0.0 -58.0301788390138,-34.8628839010704,0.0 -58.0306691411649,-34.8636576099608,0.0 -58.0305025187826,-34.863721330199,0.0 -58.0299536670166,-34.8639536923859,0.0 -58.0294178405398,-34.8641807657588,0.0 -58.0294499618173,-34.8642917757328,0.0 -58.0298753798126,-34.8649665636315,0.0 -58.0301253967786,-34.8653535428083,0.0 -58.0301767279945,-34.8653697854629,0.0 ",
				"Polygon Outer Boundary",
				"313",
				"0550043",
				"La Plata",
				"City Bell",
				"0043",
				"2014/09/25",
				"Savoia",
				"Otros",
				"1984",
				"321",
				"7.7400000000000002000000000000000",
				"476, 480, 8, 5",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.17411256022751,-34.77968093560015,0.0 -58.173399092629545,-34.779081707485666,0.0 -58.17299139685929,-34.77846485046864,0.0 -58.17215454764665,-34.77751311916661,0.0 -58.17182731814682,-34.77776427154873,0.0 -58.17190241999924,-34.777980173862616,0.0 -58.171864869073026,-34.77821810637045,0.0 -58.17161810584366,-34.77828419861197,0.0 -58.17151081748307,-34.77825335557252,0.0 -58.17120504565536,-34.778425195216926,0.0 -58.171333791688085,-34.77858381610947,0.0 -58.17151081748307,-34.77871599995363,0.0 -58.171816589310765,-34.778667532568704,0.0 -58.17198288626969,-34.778874620287084,0.0 -58.17218673415481,-34.7790993319041,0.0 -58.17227482795715,-34.779209484433984,0.0 -58.17243886180222,-34.779398946441376,0.0 -58.17191004753113,-34.779742620600146,0.0 -58.17259669303894,-34.780526897293356,0.0 -58.174144746735685,-34.77969415381832,0.0 -58.17411256022751,-34.77968093560015,0.0 ",
				"Polygon Outer Boundary",
				"1188",
				"1200006",
				"Berazategui",
				"Platanos",
				"0006",
				"2014/10/01",
				"3 de Junio II",
				"Villa",
				"2009",
				"100",
				"3.5699999999999998000000000000000",
				"Arroyo Las Conchillas, Avenida Mitre",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.6005596873105,-38.0208633426472,0.0 -57.6000198389016,-38.0205817384264,0.0 -57.5986919623687,-38.0207501618531,0.0 -57.5982552790486,-38.0207893371661,0.0 -57.5976165046523,-38.0208350984301,0.0 -57.5964083996118,-38.020867681727,0.0 -57.5961322328375,-38.0208693288578,0.0 -57.5954332308558,-38.0208173776856,0.0 -57.5931940600657,-38.0204724062585,0.0 -57.5931469199565,-38.0204759444613,0.0 -57.5909142960504,-38.0198344526456,0.0 -57.5899210574223,-38.0193215667694,0.0 -57.58889979062,-38.0200495768956,0.0 -57.5885420572359,-38.0203200225289,0.0 -57.5888918040879,-38.0206022824541,0.0 -57.5892458388769,-38.0203300485018,0.0 -57.5895933364968,-38.0206115396329,0.0 -57.5896658503819,-38.0207544419191,0.0 -57.5890933317892,-38.0211859481095,0.0 -57.5898381752127,-38.0218124634651,0.0 -57.5913162048073,-38.0219033867972,0.0 -57.5928683039238,-38.0207264062307,0.0 -57.5929576865106,-38.0207541781507,0.0 -57.5938017020477,-38.020953590891,0.0 -57.5957708530554,-38.0225092868662,0.0 -57.5974046558161,-38.0212693345571,0.0 -57.5988830756249,-38.0211565146724,0.0 -57.6005596873105,-38.0208633426472,0.0 ",
				"Polygon Outer Boundary",
				"482",
				"0450025",
				"General Pueyrredon",
				"Mar Del Plata",
				"0025",
				"2014/09/03",
				"Evita",
				"Villa",
				"decada_1990",
				"150",
				"5.0000000000000000000000000000000",
				"Via del FFCC desde Vertiz hasta Namuncura y triangulo Cuba, via y Soler",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.02017641812563,-34.38413978999962,0.0 -59.019532687962055,-34.38353770325494,0.0 -59.01908040046692,-34.383103843946145,0.0 -59.018189907073975,-34.3837944760726,0.0 -59.01861000806093,-34.38421062344965,0.0 -59.01914644986391,-34.38467103941415,0.0 -59.01979018002749,-34.38444083174838,0.0 -59.02017641812563,-34.38413978999962,0.0 ",
				"Polygon Outer Boundary",
				"1907",
				"0310003",
				"Exaltacion de la Cruz",
				"Pavon",
				"0003",
				"2015/07/15",
				"Los Cardos",
				"Otros",
				"decada_1950",
				"40",
				"1.6499999999999999000000000000000",
				"Calles La Alameda, Ruta Prov. Nº 6, Carlos Lemee y La Felicidad",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9460164785358,-34.8398115092422,0.0 -57.9460567010727,-34.8398203896553,0.0 -57.9505302293489,-34.8370565411448,0.0 -57.9511907548096,-34.8377542965194,0.0 -57.9525780797773,-34.8368398531269,0.0 -57.9512744306544,-34.8354383850873,0.0 -57.9520300252382,-34.8349799302381,0.0 -57.9518902038845,-34.8348323438825,0.0 -57.9507364796281,-34.8336145218733,0.0 -57.949260246426,-34.8346002366167,0.0 -57.9486137192739,-34.8350319241958,0.0 -57.9481402922803,-34.8353553999173,0.0 -57.9442118903815,-34.8378888433593,0.0 -57.944203018422,-34.8379247415373,0.0 -57.9460164785358,-34.8398115092422,0.0 ",
				"Polygon Outer Boundary",
				"507",
				"1150008",
				"Ensenada",
				"Punta Lara",
				"0008",
				"2014/11/26",
				"Piria",
				"Asentamiento Precario",
				"decada_1990",
				"386",
				"22.2399999999999980000000000000000",
				"5, 13, 18, 26",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.60684633255005,-34.45535024483881,0.0 -58.5984387648924,-34.4506684107587,0.0 -58.59618186950684,-34.44942278052022,0.0 -58.595924377441406,-34.45140454674839,0.0 -58.59770536422729,-34.45485483109762,0.0 -58.598424196243286,-34.45527947162716,0.0 -58.598198890686035,-34.45539447806563,0.0 -58.59871387481689,-34.45627913768161,0.0 -58.59942197799682,-34.45602258735788,0.0 -58.603284358978264,-34.45800419697542,0.0 -58.604443073272705,-34.45848189940178,0.0 -58.60684633255005,-34.45535024483881,0.0 ",
				"Polygon Outer Boundary",
				"713",
				"0570003",
				"Tigre",
				"General Pacheco",
				"0003",
				"2014/10/01",
				"Los Troncos",
				"Otros",
				"90_o_anterior",
				"3000",
				"44.0700000000000000000000000000000",
				"Carrel, Escalada, Río de la Reconquista",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.68897020816803,-34.41754438978768,0.0 -58.68952274322509,-34.41688058832947,0.0 -58.68833720684052,-34.41635839414609,0.0 -58.68740916252137,-34.415871600021525,0.0 -58.686347007751465,-34.415322846883605,0.0 -58.6858596242922,-34.415888651192,0.0 -58.68566572666168,-34.4158671746074,0.0 -58.68421196937561,-34.41512370170922,0.0 -58.683922290801995,-34.415437908323774,0.0 -58.68460357189178,-34.41562377646964,0.0 -58.68531167507171,-34.415946832025895,0.0 -58.68589103221893,-34.41602206396259,0.0 -58.6868240372907,-34.4163972047974,0.0 -58.68789732456207,-34.41694254335518,0.0 -58.68897020816803,-34.41754438978768,0.0 ",
				"Polygon Outer Boundary",
				"697",
				"0570019",
				"Tigre",
				"Benavidez",
				"0019",
				"2014/10/01",
				"Arroyo El Claro",
				"Asentamiento Precario",
				"90_o_anterior",
				"90",
				"3.2500000000000000000000000000000",
				"Tucumán, Jujuy, B. Mitre y Arroyo El Claro",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6391688570986,-34.4055816307596,0.0 -58.63710165023804,-34.402669548177215,0.0 -58.635009527206414,-34.403253792989155,0.0 -58.6368493774779,-34.4062825667715,0.0 -58.6391688570986,-34.4055816307596,0.0 ",
				"Polygon Outer Boundary",
				"700",
				"0570016",
				"Tigre",
				"Tigre",
				"0016",
				"2014/10/01",
				"El Lucero",
				"Asentamiento Precario",
				"90_o_anterior",
				"220",
				"7.9800000000000004000000000000000",
				"A. M. García, Los Lirios, Las Orquídeas",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.7383529661807,-34.4743862417973,0.0 -58.7381498517446,-34.4746619506912,0.0 -58.7380826183914,-34.4747466173397,0.0 -58.7386358846732,-34.4750346421035,0.0 -58.7389144530259,-34.4746775951429,0.0 -58.7383529661807,-34.4743862417973,0.0 ",
				"Polygon Outer Boundary",
				"198",
				"1330067",
				"Malvinas Argentinas",
				"Tierras Altas",
				"0067",
				"2014/07/25",
				"Guatemala & Combate de San Lorenzo",
				"Asentamiento Precario",
				"decada_1990",
				"25",
				"0.5300000000000000300000000000000",
				"Guatemala- Uspallata_ Bolivia-Combate de San Lorenzo",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7397380008392,-34.475108929286,0.0 -58.7396153838887,-34.4750405117375,0.0 -58.7394085301431,-34.4753261895031,0.0 -58.7395281011446,-34.4753872746458,0.0 -58.7394634749742,-34.4754723294987,0.0 -58.7398278540919,-34.4756624933572,0.0 -58.7398474149163,-34.4756717990273,0.0 -58.7400040391659,-34.4754764619811,0.0 -58.7401271702738,-34.4753080011736,0.0 -58.7399353089072,-34.4752119187164,0.0 -58.7398107508019,-34.4751495206076,0.0 -58.7397380008392,-34.475108929286,0.0 ",
				"Polygon Outer Boundary",
				"198",
				"1330067",
				"Malvinas Argentinas",
				"Tierras Altas",
				"0067",
				"2014/07/25",
				"Guatemala & Combate de San Lorenzo",
				"Asentamiento Precario",
				"decada_1990",
				"25",
				"0.5300000000000000300000000000000",
				"Guatemala- Uspallata_ Bolivia-Combate de San Lorenzo",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.557563424110405,-34.619921064716834,0.0 -58.55752587318421,-34.61967826201074,0.0 -58.55734884738922,-34.61950167777832,0.0 -58.55727910995483,-34.61950609238871,0.0 -58.55690360069275,-34.61964294519431,0.0 -58.55645298957824,-34.61989016259369,0.0 -58.55604529380798,-34.62014620840958,0.0 -58.55646371841431,-34.620380180619584,0.0 -58.5569143295288,-34.62055676298281,0.0 -58.55711281299591,-34.620618566721184,0.0 -58.557563424110405,-34.619921064716834,0.0 ",
				"Polygon Outer Boundary",
				"1403",
				"1170016",
				"Tres de Febrero",
				"Tres de Febrero",
				"0016",
				"2015/02/18",
				"Mercado",
				"Villa",
				"1972",
				"80",
				"0.9499999999999999600000000000000",
				"Bolivia y Pedro Mendoza",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Sin dato",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-59.209692372112,-34.0474499705894,0.0 -59.2088788189884,-34.0446522755342,0.0 -59.2021778907535,-34.0461116676569,0.0 -59.2031116034919,-34.0488814262376,0.0 -59.209692372112,-34.0474499705894,0.0 ",
				"Polygon Outer Boundary",
				"450",
				"0380002",
				"Zarate",
				"Lima",
				"0002",
				"2014/09/15",
				"8 de Septiembre",
				"Asentamiento Precario",
				"2011",
				"150",
				"19.3799999999999990000000000000000",
				"14, 21, 20, 33",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.2058808478282,-34.0399184064515,0.0 -59.2069266796688,-34.0396881972966,0.0 -59.206632746279,-34.0387754862013,0.0 -59.2063532980522,-34.0378998928177,0.0 -59.205227345546,-34.0381394527494,0.0 -59.2040866090541,-34.0383739699398,0.0 -59.20435479833,-34.0391828504159,0.0 -59.2044038635994,-34.039326331187,0.0 -59.2046513508164,-34.0401301403075,0.0 -59.2046971332595,-34.0401489489616,0.0 -59.2056656893249,-34.0399392315076,0.0 -59.2058808478282,-34.0399184064515,0.0 ",
				"Polygon Outer Boundary",
				"452",
				"0380004",
				"Zarate",
				"Lima",
				"0004",
				"2014/09/15",
				"Los Pinos",
				"Asentamiento Precario",
				"2007",
				"100",
				"12.8599999999999990000000000000000",
				"4, 2, 29, 33",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.1925493837201,-34.0362842073837,0.0 -59.1923277665622,-34.0355334532439,0.0 -59.1920939890664,-34.0347414901999,0.0 -59.1918710065751,-34.0339860834512,0.0 -59.1892794484547,-34.0345713098734,0.0 -59.1890466904633,-34.0346229629511,0.0 -59.1864975142376,-34.035211024214,0.0 -59.1869340435161,-34.0367277868897,0.0 -59.1871630999389,-34.0375076493277,0.0 -59.1872446234091,-34.0374893941369,0.0 -59.1925493837201,-34.0362842073837,0.0 -59.1925493837201,-34.0362842073837,0.0 ",
				"Polygon Outer Boundary",
				"451",
				"0380003",
				"Zarate",
				"Lima",
				"0003",
				"2014/09/15",
				"San Sebastián",
				"Asentamiento Precario",
				"2011",
				"150",
				"43.0000000000000000000000000000000",
				"111, Héroes de Malvinas y Pasaje S/nombre",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.64181781187653,-34.70671938989788,0.0 -58.64175343886018,-34.70658709080776,0.0 -58.641603235155344,-34.70666647028722,0.0 -58.64103460684418,-34.70723976426621,0.0 -58.64028358832002,-34.70792771179658,0.0 -58.63900685682893,-34.70926831105895,0.0 -58.64133501425385,-34.710882293187616,0.0 -58.6429657973349,-34.70963873597136,0.0 -58.64181781187653,-34.70671938989788,0.0 ",
				"Polygon Outer Boundary",
				"1618",
				"0700140",
				"La Matanza",
				"Rafael Castillo",
				"0140",
				"2015/04/24",
				"San Antonio",
				"Asentamiento Precario",
				"90_o_anterior",
				"210",
				"8.9100000000000001000000000000000",
				"Rocamora, Merou y Andrade",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.955679181963205,-34.45830497289587,0.0 -58.95700955763459,-34.45643837541715,0.0 -58.95458484068512,-34.456668384943484,0.0 -58.95411277189851,-34.45643837541715,0.0 -58.95118379965425,-34.45690724031948,0.0 -58.950969222933054,-34.45598720104445,0.0 -58.94977832213044,-34.45618182558263,0.0 -58.9501323737204,-34.457544184648434,0.0 -58.955250028520815,-34.45680108245895,0.0 -58.955679181963205,-34.45830497289587,0.0 ",
				"Polygon Outer Boundary",
				"2062",
				"0840034",
				"Pilar",
				"Pilar",
				"0034",
				"2015/08/06",
				"Los Grillos",
				"Asentamiento Precario",
				"2006",
				"100",
				"5.1399999999999997000000000000000",
				"M. García, Los Sauces, Balcarce",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.360506892204285,-34.818068722755534,0.0 -58.36199283599853,-34.81891429062436,0.0 -58.36295306682587,-34.81814138908514,0.0 -58.36330711841583,-34.817771450739706,0.0 -58.36262047290803,-34.81738829855925,0.0 -58.36225569248199,-34.817797874962324,0.0 -58.362003564834595,-34.818136985066985,0.0 -58.36194187402725,-34.8181678131891,0.0 -58.36075097322464,-34.81748298575812,0.0 -58.36061418056488,-34.81787274354705,0.0 -58.360490798950195,-34.81801367246316,0.0 -58.360506892204285,-34.818068722755534,0.0 ",
				"Polygon Outer Boundary",
				"1984",
				"0030063",
				"Almirante Brown",
				"Claypole",
				"0063",
				"2015/07/26",
				"San Lucas",
				"Asentamiento Precario",
				"1991",
				"52",
				"1.9500000000000000000000000000000",
				"Aristóbulo del Valle, 2 de Abril, El Baqueano y Aparcero",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-61.882864236831665,-35.80927817738673,0.0 -61.88102960586548,-35.81078339362336,0.0 -61.8829071521759,-35.812349484277775,0.0 -61.884709596633904,-35.81081819597346,0.0 -61.88378691673279,-35.81004384007808,0.0 -61.882864236831665,-35.80927817738673,0.0 ",
				"Polygon Outer Boundary",
				"1619",
				"0800002",
				"Pehuajo",
				"Pehuajó",
				"0002",
				"2015/04/24",
				"Talleres",
				"Asentamiento Precario",
				"decada_1980",
				"104",
				"5.6799999999999997000000000000000",
				"Neuquén - Paraguay - Chubut y Antártida Argentina",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.11591334962168,-34.32890463194902,0.0 -59.11363116552366,-34.33071156939687,0.0 -59.117278969456486,-34.33391522322198,0.0 -59.115021622087625,-34.33576506481528,0.0 -59.11703864359424,-34.33756525457383,0.0 -59.12166491734296,-34.333780558579875,0.0 -59.11591334962168,-34.32890463194902,0.0 ",
				"Polygon Outer Boundary",
				"1908",
				"0310004",
				"Exaltacion de la Cruz",
				"Arroyo De La Cruz",
				"0004",
				"2015/07/15",
				"Arroyo de la Cruz",
				"Asentamiento Precario",
				"decada_1970",
				"50",
				"30.6099999999999990000000000000000",
				"Calles El Cardenal, La Calandria, El Hornero, La Golondrina, La Paloma y La Lechuza",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.043942724070796,-34.974620096179535,0.0 -58.04017761867726,-34.97106874470067,0.0 -58.03867210706812,-34.97216369783014,0.0 -58.03907980283839,-34.97344725212995,0.0 -58.0385433610354,-34.97510001845209,0.0 -58.04068912824732,-34.97708681041786,0.0 -58.043942724070796,-34.974620096179535,0.0 ",
				"Polygon Outer Boundary",
				"2007",
				"0550139",
				"La Plata",
				"La Plata",
				"0139",
				"2015/07/30",
				"Arroyo Doña Flora & Calle 38",
				"Asentamiento Precario",
				"2014",
				"160",
				"18.1000000000000010000000000000000",
				"Calle 179, calle 183, calle 38, calle 35",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6307653692463,-34.8077859477887,0.0 -58.6299001796319,-34.8068814846271,0.0 -58.6297604368941,-34.8070947462288,0.0 -58.6288172741574,-34.8071076150712,0.0 -58.6284657512442,-34.8071878367787,0.0 -58.6285028141733,-34.8082534555027,0.0 -58.6275390243203,-34.8090905366026,0.0 -58.6268284985358,-34.8097242769811,0.0 -58.6246825592149,-34.8085596160151,0.0 -58.6242852083402,-34.8089750951176,0.0 -58.6270293082063,-34.8108436403106,0.0 -58.6283256252543,-34.8098297092226,0.0 -58.629254002501,-34.8090470416424,0.0 -58.6299895770737,-34.8084564532496,0.0 -58.6299895770737,-34.8084564532496,0.0 -58.6309467389233,-34.8092677581822,0.0 -58.6315438890467,-34.8087286594304,0.0 -58.6307064205496,-34.8079967832809,0.0 -58.6307653692463,-34.8077859477887,0.0 ",
				"Polygon Outer Boundary",
				"1052",
				"0700078",
				"La Matanza",
				"Virrey Del Pino",
				"0078",
				"2014/10/01",
				"Los Alamos",
				"Asentamiento Precario",
				"90_o_anterior",
				"530",
				"8.8699999999999992000000000000000",
				"Jacinto Estivado, Arroyo Morales",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7790572610052,-34.615794651356,0.0 -58.7786716291465,-34.6160702146426,0.0 -58.7793156151415,-34.6177483364822,0.0 -58.7795543665052,-34.6179584906734,0.0 -58.7800506230047,-34.6183194048791,0.0 -58.7802276836021,-34.6181409022194,0.0 -58.7790572610052,-34.615794651356,0.0 ",
				"Polygon Outer Boundary",
				"56",
				"0740013",
				"Moreno",
				"Moreno",
				"0013",
				"2014/09/11",
				"Los Paraisos II",
				"Asentamiento Precario",
				"decada_1990",
				"56",
				"1.4099999999999999000000000000000",
				"Aguado Alejandro Maria de Marquez, Peru, Solon, Zanjón",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9932485188887,-34.93091156244,0.0 -57.99253463745117,-34.93143597669091,0.0 -57.99311935901642,-34.93196812726345,0.0 -57.99346804618835,-34.93198571895898,0.0 -57.993484139442444,-34.93179660803444,0.0 -57.99322664737701,-34.931589904897315,0.0 -57.9934794868368,-34.9313981680675,0.0 -57.9932881238761,-34.9312083674967,0.0 -57.9932792897621,-34.9312081387544,0.0 -57.9934517311777,-34.9310882280039,0.0 -57.9932485188887,-34.93091156244,0.0 ",
				"Polygon Outer Boundary",
				"355",
				"0550082",
				"La Plata",
				"San Carlos",
				"0082",
				"2014/10/10",
				"36bis & 135",
				"Asentamiento Precario",
				"1996",
				"30",
				"0.5600000000000000500000000000000",
				"36, 37, 135, 135bis",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.2514384343404,-35.163597934499,0.0 -58.250459817651,-35.1632147534666,0.0 -58.2502892874431,-35.1631475825799,0.0 -58.2486447502354,-35.1625139596263,0.0 -58.2484699235789,-35.1624425784882,0.0 -58.2481437649958,-35.1623147550138,0.0 -58.2469690439886,-35.1618765289934,0.0 -58.2464309562392,-35.1628397419036,0.0 -58.2464231956998,-35.1628421204896,0.0 -58.2459165260745,-35.1636538082657,0.0 -58.2459057757208,-35.1638119961618,0.0 -58.2454432291421,-35.1646280157064,0.0 -58.246436225542,-35.1650055874408,0.0 -58.2465839793482,-35.1650806350567,0.0 -58.2475912754305,-35.1654645202643,0.0 -58.2477532607439,-35.1655288801702,0.0 -58.2487588493277,-35.1659190520803,0.0 -58.2489313166831,-35.1659575043852,0.0 -58.2488308777878,-35.1660863679321,0.0 -58.2483775423991,-35.1669085699942,0.0 -58.2493618292982,-35.1672745467883,0.0 -58.250916874225,-35.1645586702399,0.0 -58.2514384343404,-35.163597934499,0.0 ",
				"Polygon Outer Boundary",
				"486",
				"0130001",
				"Brandsen",
				"Brandsen",
				"0001",
				"2014/10/01",
				"Santa Isabel",
				"Asentamiento Precario",
				"1990",
				"303",
				"21.9400000000000010000000000000000",
				"Aristobulo del valle, Belgrano, Moreno, Magdalena Fait",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.2492881870939,-35.1674281308556,0.0 -58.2463927936915,-35.1663280330625,0.0 -58.2448197570924,-35.1657261246496,0.0 -58.2438275138216,-35.1675079518248,0.0 -58.2482845569699,-35.1692070368837,0.0 -58.2492881870939,-35.1674281308556,0.0 ",
				"Polygon Outer Boundary",
				"487",
				"0130002",
				"Brandsen",
				"Brandsen",
				"0002",
				"2014/10/01",
				"Los Aromos",
				"Asentamiento Precario",
				"1990",
				"217",
				"10.5299999999999990000000000000000",
				"Aristobulo del valle, Berutti, Moreno, Belgrano",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.2001077099281,-34.040075708401,0.0 -59.1994479651804,-34.0379480390041,0.0 -59.1968348855966,-34.0396141728033,0.0 -59.1976725665909,-34.0405618818419,0.0 -59.1988573161389,-34.0403144855188,0.0 -59.2001077099281,-34.040075708401,0.0 ",
				"Polygon Outer Boundary",
				"449",
				"0380001",
				"Zarate",
				"Lima",
				"0001",
				"2014/09/15",
				"9 de Julio",
				"Asentamiento Precario",
				"2003",
				"150",
				"4.5099999999999998000000000000000",
				"21, 2, 17, 2 bis",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.940557329249,-34.8380001082474,0.0 -57.9409786987189,-34.8378361196757,0.0 -57.9398666668475,-34.8358546425973,0.0 -57.9391770329167,-34.8360221791723,0.0 -57.9381674919706,-34.8362513010218,0.0 -57.9370766682778,-34.8365694207037,0.0 -57.9378159107251,-34.8375737490428,0.0 -57.938514947891235,-34.83846342495163,0.0 -57.93715238571166,-34.83949370444558,0.0 -57.93734550476074,-34.83968743077338,0.0 -57.937517166137695,-34.83955534469024,0.0 -57.9387613822179,-34.8388395764118,0.0 -57.940557329249,-34.8380001082474,0.0 ",
				"Polygon Outer Boundary",
				"506",
				"1150007",
				"Ensenada",
				"Punta Lara",
				"0007",
				"2014/11/26",
				"Rubencito",
				"Asentamiento Precario",
				"decada_1970",
				"81",
				"7.2300000000000004000000000000000",
				"Av. Alte Brown, 10, 12",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.866136316210024,-34.41093711783083,0.0 -58.8645100593567,-34.4101847496774,0.0 -58.86506795883178,-34.4095031868024,0.0 -58.863458633422844,-34.40854721912713,0.0 -58.86195659637451,-34.410450292151346,0.0 -58.863357547670596,-34.4117071817562,0.0 -58.86463427916169,-34.41288439221442,0.0 -58.866136316210024,-34.41093711783083,0.0 ",
				"Polygon Outer Boundary",
				"2017",
				"0840003",
				"Pilar",
				"Villa Rosa",
				"0003",
				"2015/08/03",
				"Boliviano II",
				"Asentamiento Precario",
				"90_o_anterior",
				"350",
				"8.8300000000000001000000000000000",
				"Carcova, Sivori, Dublanc, Escobio",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.3414262499198,-35.3781169847504,0.0 -57.3414138151856,-35.3780802202647,0.0 -57.337616183382,-35.3763433810302,0.0 -57.3375712946194,-35.3763535637058,0.0 -57.3347892017599,-35.3803767951282,0.0 -57.3348016307615,-35.3804136502025,0.0 -57.3385995428215,-35.3821557219755,0.0 -57.3386444377048,-35.3821454490263,0.0 -57.3386444377048,-35.3821454490263,0.0 -57.3414262499198,-35.3781169847504,0.0 ",
				"Polygon Outer Boundary",
				"497",
				"1340002",
				"Punta Indio",
				"Veronica",
				"0002",
				"2014/10/01",
				"Latorre",
				"Otros",
				"2000",
				"200",
				"20.8799999999999990000000000000000",
				"Circunvalacion 14va, Circunvalacion 3ra, calle 19, calle 22",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.5765266418457,-34.760300750633036,0.0 -58.57619404792785,-34.75982478161245,0.0 -58.57708454132081,-34.75911963727889,0.0 -58.57639789581298,-34.75859077507648,0.0 -58.57545375823975,-34.75936643848068,0.0 -58.573533296585076,-34.75776221748178,0.0 -58.5694357987702,-34.7608768289159,0.0 -58.57027173042297,-34.76199306270519,0.0 -58.57114076614379,-34.76174626935527,0.0 -58.57272863388061,-34.76131437921765,0.0 -58.57309341430663,-34.76158761609788,0.0 -58.573297262191765,-34.761473033000144,0.0 -58.57371568679809,-34.76114691100536,0.0 -58.57438087463378,-34.760997070738,0.0 -58.57505679130554,-34.7615435456945,0.0 -58.5765266418457,-34.760300750633036,0.0 ",
				"Polygon Outer Boundary",
				"1096",
				"0700034",
				"La Matanza",
				"Gregorio De Laferrere",
				"0034",
				"2014/10/01",
				"Don Juan",
				"Asentamiento Precario",
				"2005",
				"300",
				"16.6700000000000020000000000000000",
				"Cnel. Garmendia, E. Echeverría, Tarija, Río Matanza",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9930937837205,-34.8058455898749,0.0 -57.9926588953764,-34.804585270615,0.0 -57.9920828628988,-34.8028292933356,0.0 -57.9915022657845,-34.8029463300784,0.0 -57.9917028785915,-34.8036526823836,0.0 -57.9917948731543,-34.8039094260405,0.0 -57.9920251544913,-34.8045343753817,0.0 -57.992072227476,-34.8046773360538,0.0 -57.9926338436432,-34.8063208736111,0.0 -57.9930937837205,-34.8058455898749,0.0 ",
				"Polygon Outer Boundary",
				"515",
				"1150016",
				"Ensenada",
				"Punta Lara",
				"0016",
				"2014/11/26",
				"Miguelin",
				"Villa",
				"2012",
				"20",
				"2.0400000000000000000000000000000",
				"5, 11, 120, 122, 126",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.4903132280195,-34.7370395455912,0.0 -58.48861455917358,-34.73559080767817,0.0 -58.48877549171447,-34.73540565355845,0.0 -58.488303422927856,-34.73505297789702,0.0 -58.48755240440369,-34.735678976160806,0.0 -58.4860718691907,-34.7379063185123,0.0 -58.4888030159108,-34.7390307386124,0.0 -58.4903132280195,-34.7370395455912,0.0 ",
				"Polygon Outer Boundary",
				"999",
				"0630012",
				"Lomas de Zamora",
				"Ingeniero Budge",
				"0012",
				"2014/10/01",
				"30 de Agosto",
				"Asentamiento Precario",
				"2006",
				"400",
				"9.0299999999999994000000000000000",
				"Av. Brig. Juan Manuel de Rosas, calle 19, Av. Dr. Gilberto Elizalde",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.3406058576292,-36.4686253685371,0.0 -57.3380156438542,-36.4707011241758,0.0 -57.3391501213345,-36.4708707618767,0.0 -57.3402908738765,-36.4710103494679,0.0 -57.3414366711158,-36.4711199494061,0.0 -57.3425862918924,-36.4711993541367,0.0 -57.343181714404,-36.4707220933161,0.0 -57.3406058576292,-36.4686253685371,0.0 ",
				"Polygon Outer Boundary",
				"414",
				"1050001",
				"Tordillo",
				"General Conesa",
				"0001",
				"2014/07/18",
				"Paraje Villa Roch",
				"Asentamiento Precario",
				"1979",
				"35",
				"6.7800000000000002000000000000000",
				"Ruta Prov. Km 245 - Canal Auxiliar nº 1",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.99289131164551,-34.461839008800936,0.0 -58.99403477087617,-34.46038383566247,0.0 -58.99462938308715,-34.459587681569715,0.0 -58.99397039785981,-34.45922498663262,0.0 -58.992607835680246,-34.45850843834533,0.0 -58.991743326187134,-34.45964075874543,0.0 -58.99239242076873,-34.460056528787796,0.0 -58.991507291793816,-34.46112248294805,0.0 -58.99289131164551,-34.461839008800936,0.0 ",
				"Polygon Outer Boundary",
				"2064",
				"0840035",
				"Pilar",
				"Manzanares",
				"0035",
				"2015/08/06",
				"Luchetti",
				"Asentamiento Precario",
				"2010",
				"65",
				"5.5499999999999998000000000000000",
				"Eufrates, Gimenez, Volga",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.36181891150772,-34.88106396415539,0.0 -58.36633801460266,-34.88323785731424,0.0 -58.36764693260193,-34.883889133948976,0.0 -58.36876273155213,-34.88443479418279,0.0 -58.370962142944336,-34.88560531117167,0.0 -58.371687890030444,-34.884659217904854,0.0 -58.364020586013794,-34.8808703352552,0.0 -58.36420297622681,-34.88060629511073,0.0 -58.362722396850586,-34.879831772460236,0.0 -58.36181891150772,-34.88106396415539,0.0 ",
				"Polygon Outer Boundary",
				"2063",
				"0030074",
				"Almirante Brown",
				"Glew",
				"0074",
				"2015/08/06",
				"8 de Diciembre",
				"Asentamiento Precario",
				"2007",
				"122",
				"12.1999999999999990000000000000000",
				"Presidente Castillo, Espoile, Gobernador Arias, Paredón del Barrio Santa Ana (Victorino de la Plaza)",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.87028217315674,-34.41461034751735,0.0 -58.86817932128906,-34.41241528025819,0.0 -58.86830806732178,-34.412132041576754,0.0 -58.87036800384521,-34.40945892928084,0.0 -58.86824369430542,-34.408414444974845,0.0 -58.86626422405243,-34.41105218530469,0.0 -58.865454196929925,-34.412074508602394,0.0 -58.86682748794556,-34.41278702957195,0.0 -58.865851163864136,-34.41410584118977,0.0 -58.86734247207641,-34.41554854417464,0.0 -58.8679164648056,-34.41484489766839,0.0 -58.86882841587067,-34.41567688157829,0.0 -58.87028217315674,-34.41461034751735,0.0 ",
				"Polygon Outer Boundary",
				"2019",
				"0840005",
				"Pilar",
				"Villa Rosa",
				"0005",
				"2015/08/03",
				"Boliviano",
				"Otros",
				"90_o_anterior",
				"750",
				"18.9100000000000000000000000000000",
				"Carcova, Schiaffino, I. Baz",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-56.690432550385594,-36.6816532739614,0.0 -56.6904701013118,-36.68166618021852,0.0 -56.69049692340195,-36.68141665886369,0.0 -56.69053983874619,-36.680573442778744,0.0 -56.6904991865158,-36.68036263731324,0.0 -56.69052064418793,-36.67988939844978,0.0 -56.68997347354889,-36.67985928315085,0.0 -56.689922930672765,-36.6805175148544,0.0 -56.68979418464005,-36.68161885726514,0.0 -56.690432550385594,-36.6816532739614,0.0 ",
				"Polygon Outer Boundary",
				"1910",
				"1230001",
				"La Costa",
				"San Bernardo",
				"0001",
				"2015/07/15",
				"Frías & Gaboto",
				"Asentamiento Precario",
				"90_o_anterior",
				"25",
				"1.0900000000000001000000000000000",
				"Frías y  Gaboto",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.940172981748,-34.8363859546712,0.0 -57.9409786987189,-34.8378361196757,0.0 -57.9411834224459,-34.8377627743493,0.0 -57.9416011937658,-34.8375795834682,0.0 -57.9419364944237,-34.8374070498718,0.0 -57.9409270872859,-34.8355507839188,0.0 -57.9408412728823,-34.8355688868817,0.0 -57.9407770969156,-34.8356349166753,0.0 -57.9402734821739,-34.8357617441707,0.0 -57.939877223572,-34.8358548214514,0.0 -57.9401237081818,-34.8363017586239,0.0 -57.940172981748,-34.8363859546712,0.0 ",
				"Polygon Outer Boundary",
				"514",
				"1150015",
				"Ensenada",
				"Punta Lara",
				"0015",
				"2014/11/26",
				"Tres Pasillos",
				"Asentamiento Precario",
				"decada_1970",
				"53",
				"2.3399999999999999000000000000000",
				"12, 14, Camino Alte Brown y canal",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.25657716020942,-34.75772695952736,0.0 -58.25778951868414,-34.75642240462959,0.0 -58.25381984934211,-34.75419227318721,0.0 -58.25346579775215,-34.754932718763975,0.0 -58.25306296348572,-34.75572604594286,0.0 -58.25657716020942,-34.75772695952736,0.0 ",
				"Polygon Outer Boundary",
				"1424",
				"0860071",
				"Quilmes",
				"Quilmes",
				"0071",
				"2015/03/03",
				"24 de Diciembre",
				"Asentamiento Precario",
				"90_o_anterior",
				"253",
				"7.5199999999999996000000000000000",
				"Av. La Plata y Namuncurá",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.34830904379486,-34.71904873626591,0.0 -58.346122624352574,-34.720913852843765,0.0 -58.347098948434,-34.72180891749067,0.0 -58.34685218520462,-34.722047011873514,0.0 -58.347731530666344,-34.72280097289572,0.0 -58.347174050286405,-34.72326392801095,0.0 -58.34791433997452,-34.72381506167274,0.0 -58.34940677974373,-34.719957048885476,0.0 -58.34840631578117,-34.719108261913,0.0 -58.34830904379486,-34.71904873626591,0.0 ",
				"Polygon Outer Boundary",
				"1435",
				"0250032",
				"Lanus",
				"Monte Chingolo",
				"0032",
				"2015/03/09",
				"Urquiza",
				"Villa",
				"90_o_anterior",
				"400",
				"7.4600000000000000000000000000000",
				"Bouchard, Condarco, Cnel Mendez.",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.6716403669212,-34.4446698692907,0.0 -58.671938180923455,-34.4443044747614,0.0 -58.67126762866973,-34.4439417134462,0.0 -58.6705746492038,-34.4436258468499,0.0 -58.6704426442145,-34.4435384198832,0.0 -58.6709807128836,-34.4428484967405,0.0 -58.6711093291519,-34.4429300273374,0.0 -58.6724396610986,-34.4436226773734,0.0 -58.67276430130004,-34.44318521831883,0.0 -58.67144465446472,-34.442521620461854,0.0 -58.67123544216157,-34.442357932180016,0.0 -58.67069363594055,-34.44206594688103,0.0 -58.66955637931823,-34.443543558969914,0.0 -58.6701177384784,-34.4438764180274,0.0 -58.6703216365529,-34.4440134819716,0.0 -58.671592752751,-34.444674129224,0.0 -58.6716403669212,-34.4446698692907,0.0 ",
				"Polygon Outer Boundary",
				"691",
				"0570025",
				"Tigre",
				"Tigre",
				"0025",
				"2014/10/01",
				"Las Quintas",
				"Otros",
				"90_o_anterior",
				"120",
				"3.0600000000000001000000000000000",
				"Donato Alvarez, Lamadrid, Cerviño, L. M. Campos",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.48303623497486,-34.727135013119984,0.0 -58.47490344196558,-34.73325430861151,0.0 -58.47509656101465,-34.73335129667937,0.0 -58.48325081169605,-34.727152648628234,0.0 -58.48303623497486,-34.727135013119984,0.0 ",
				"Polygon Outer Boundary",
				"2155",
				"0630076",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0076",
				"2015/09/04",
				"Padre Mujica III",
				"Asentamiento Precario",
				"2011",
				"80",
				"1.7500000000000000000000000000000",
				"Padre Mujica, Av. de la Noria, Vias FFCC, Rivera Sur",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.618159890174866,-34.47924604327183,0.0 -58.616899251937866,-34.47880825841159,0.0 -58.6164674817298,-34.47972947353,0.0 -58.61599266529083,-34.48064782378422,0.0 -58.6158800125122,-34.48087334463248,0.0 -58.615515232086175,-34.481678139552656,0.0 -58.616781234741204,-34.482098221729224,0.0 -58.618159890174866,-34.47924604327183,0.0 ",
				"Polygon Outer Boundary",
				"708",
				"0570008",
				"Tigre",
				"Tigre",
				"0008",
				"2014/10/01",
				"Baires",
				"Villa",
				"90_o_anterior",
				"320",
				"4.3099999999999996000000000000000",
				"Gallardo, Ombú, Triunvirato, Blandengues",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.33477545529603,-34.67973481784358,0.0 -58.332788944244385,-34.681217036379266,0.0 -58.33134055137634,-34.67995538775836,0.0 -58.330547455698245,-34.67935102479132,0.0 -58.33031058311463,-34.67937308191147,0.0 -58.32972049713134,-34.67879959487828,0.0 -58.32479763776064,-34.682611003411246,0.0 -58.32552719861268,-34.683210931366155,0.0 -58.32653570920228,-34.68238161804443,0.0 -58.32875490188598,-34.6843843073007,0.0 -58.329527378082275,-34.68505480036858,0.0 -58.330462463200085,-34.684322551087135,0.0 -58.331544399261475,-34.68348442649128,0.0 -58.33224177360534,-34.68411963748968,0.0 -58.33314467221499,-34.68336973509718,0.0 -58.33491325378418,-34.682072829047144,0.0 -58.33446264266968,-34.681675812929946,0.0 -58.334280252456665,-34.68140231183071,0.0 -58.335599899291985,-34.68037888034783,0.0 -58.33477545529603,-34.67973481784358,0.0 ",
				"Polygon Outer Boundary",
				"538",
				"0040021",
				"Avellaneda",
				"Avellaneda",
				"0021",
				"2014/10/31",
				"Nueva Ana",
				"Otros",
				"1988",
				"439",
				"31.8500000000000010000000000000000",
				"San Nicolás, Colonia, Casazza, Ciudadela",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.5717058702348,-34.5815372254746,0.0 -58.5711516370618,-34.581038602695,0.0 -58.57102274894715,-34.58115193087472,0.0 -58.57089936733245,-34.58108568110729,0.0 -58.570706248283386,-34.581227013880635,0.0 -58.57006251811981,-34.580723514778576,0.0 -58.569740653038025,-34.58097968136955,0.0 -58.5713203179378,-34.5823704221268,0.0 -58.5713480344567,-34.5823747125455,0.0 -58.5718868410236,-34.5819410730534,0.0 -58.5715478812901,-34.5816564268045,0.0 -58.5717058702348,-34.5815372254746,0.0 ",
				"Polygon Outer Boundary",
				"826",
				"0470041",
				"General San Martin",
				"General San Martin",
				"0041",
				"2014/10/01",
				"Guido Spano",
				"Villa",
				"90_o_anterior",
				"130",
				"1.4299999999999999000000000000000",
				"Guido Spano y Pringles",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-59.678850173950195,-33.66870674671116,0.0 -59.67908084392547,-33.66898801445471,0.0 -59.68050241470337,-33.668139743860785,0.0 -59.6802802104503,-33.66783168562705,0.0 -59.679754497483366,-33.667197707239644,0.0 -59.67888236045838,-33.66742986888151,0.0 -59.67803478240966,-33.66776025167614,0.0 -59.678850173950195,-33.66870674671116,0.0 ",
				"Polygon Outer Boundary",
				"1913",
				"0990008",
				"San Pedro",
				"San Pedro",
				"0008",
				"2015/07/15",
				"Don Juan",
				"Asentamiento Precario",
				"decada_2010",
				"65",
				"2.4600000000000000000000000000000",
				"Saavedra, Sbert y Dumrauf",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.4792878793584,-34.7331772469833,0.0 -58.48335742950439,-34.73334247958699,0.0 -58.48348617553711,-34.73283108661972,0.0 -58.48395824432372,-34.73226678725926,0.0 -58.4837922963115,-34.7315070395982,0.0 -58.4837906187368,-34.7309212113336,0.0 -58.4839965908463,-34.7299460925645,0.0 -58.483944789567,-34.7293011748797,0.0 -58.4835637319235,-34.7286634356686,0.0 -58.4837840472955,-34.72786335547,0.0 -58.483233326304,-34.7273006974415,0.0 -58.47550392150879,-34.73312205197188,0.0 -58.478786945343025,-34.733201405981056,0.0 -58.477864265441895,-34.732381410878695,0.0 -58.47884058952331,-34.73164076314809,0.0 -58.4799349308014,-34.73264592631679,0.0 -58.4792878793584,-34.7331772469833,0.0 ",
				"Polygon Outer Boundary",
				"958",
				"0630053",
				"Lomas de Zamora",
				"Villa Albertina",
				"0053",
				"2014/10/01",
				"Juan Manuel de Rosas III",
				"Asentamiento Precario",
				"90_o_anterior",
				"1360",
				"25.0500000000000010000000000000000",
				"R. Llovera, Av. de la Noria",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.03369062021375,-34.94842350932893,0.0 -58.03166823461651,-34.9466075108787,0.0 -58.03065972402691,-34.94739459504901,0.0 -58.03258555009961,-34.94918859106362,0.0 -58.03330974653363,-34.94870052250571,0.0 -58.03369062021375,-34.94842350932893,0.0 ",
				"Polygon Outer Boundary",
				"2368",
				"0550144",
				"La Plata",
				"Melchor Romero",
				"0144",
				"2015/10/26",
				"161 & 526",
				"Asentamiento Precario",
				"2015",
				"55",
				"3.5000000000000000000000000000000",
				"calle 161, calle 526",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.68574881553649,-33.692513027576744,0.0 -59.68709838576615,-33.69166052567761,0.0 -59.686363460496075,-33.69131684450966,0.0 -59.68613815493881,-33.69171854963528,0.0 -59.68609523959457,-33.691803353810656,0.0 -59.685923578217626,-33.69174086653166,0.0 -59.685773374512785,-33.69200866883604,0.0 -59.684941889718175,-33.692472857520045,0.0 -59.685231568291776,-33.69279868077173,0.0 -59.68574881553649,-33.692513027576744,0.0 ",
				"Polygon Outer Boundary",
				"1914",
				"0990009",
				"San Pedro",
				"San Pedro",
				"0009",
				"2015/07/15",
				"Estación San Pedro",
				"Villa",
				"decada_2000",
				"18",
				"1.0200000000000000000000000000000",
				"Molina y vías del FFCC",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7471753311287,-34.7143697715262,0.0 -58.7468164260415,-34.7150725963544,0.0 -58.748968105649,-34.7159828746085,0.0 -58.7471753311287,-34.7143697715262,0.0 ",
				"Polygon Outer Boundary",
				"659",
				"0720003",
				"Merlo",
				"Parque San Martín",
				"0003",
				"2014/10/01",
				"Martín Fierro",
				"Asentamiento Precario",
				"90_o_anterior",
				"45",
				"0.9399999999999999500000000000000",
				"Albarinos, Gabriela Mistral, Ancaste",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.69476304204909,-34.647396443351354,0.0 -58.69481132181135,-34.647396443351354,0.0 -58.695401407794634,-34.646955129555174,0.0 -58.695406772212664,-34.64689334543626,0.0 -58.69474158437697,-34.64627991490055,0.0 -58.69468257577864,-34.64628432808609,0.0 -58.69407639654128,-34.646765363900606,0.0 -58.69407639654128,-34.646822734958256,0.0 -58.69476304204909,-34.647396443351354,0.0 ",
				"Polygon Outer Boundary",
				"15",
				"1360014",
				"Ituzaingo",
				"Ituzaingo",
				"0014",
				"2014/09/01",
				"Evita II",
				"Villa",
				"1985",
				"29",
				"0.8199999999999999500000000000000",
				"Ombu, Int. Perez Quintana, Andalgala",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-59.45892009884119,-34.654533043865456,0.0 -59.4557547569275,-34.65399468706762,0.0 -59.455422163009644,-34.655080222601434,0.0 -59.45820126682519,-34.65575095289827,0.0 -59.45892009884119,-34.654533043865456,0.0 ",
				"Polygon Outer Boundary",
				"2190",
				"0710008",
				"Mercedes",
				"Mercedes",
				"0008",
				"2015/09/10",
				"Facundo Quiroga",
				"Asentamiento Precario",
				"2011",
				"120",
				"3.8100000000000001000000000000000",
				"12 y 67",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.47611714154481,-34.742211998966,0.0 -58.46998929977417,-34.739002859330114,0.0 -58.46574068069458,-34.744239687767106,0.0 -58.469551093876355,-34.7463025896459,0.0 -58.4700446203351,-34.74550917194298,0.0 -58.46931505948305,-34.745244697681834,0.0 -58.471525199711316,-34.74245885069804,0.0 -58.474700935184956,-34.74418679216974,0.0 -58.47611714154481,-34.742211998966,0.0 ",
				"Polygon Outer Boundary",
				"1745",
				"0630074",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0074",
				"2015/06/01",
				"2 de Abril",
				"Asentamiento Precario",
				"90_o_anterior",
				"400",
				"32.6499999999999990000000000000000",
				"Cabo Del Monte;Padre Mujica; Quiroga; Av. Cap. Giachino",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.5235771536827,-34.680081112346905,0.0 -58.52304607629776,-34.67970173230568,0.0 -58.52285027503967,-34.67987157125995,0.0 -58.522791266441345,-34.67993774218681,0.0 -58.522879779338844,-34.680001707365825,0.0 -58.52283954620362,-34.68003920417193,0.0 -58.52329552173614,-34.68034358938142,0.0 -58.5235771536827,-34.680081112346905,0.0 ",
				"Polygon Outer Boundary",
				"1121",
				"0700009",
				"La Matanza",
				"La Tablada",
				"0009",
				"2014/10/01",
				"El Cascote",
				"Villa",
				"90_o_anterior",
				"80",
				"0.2500000000000000000000000000000",
				"Alberti, Cerrito, Chiclana",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.2419416679245,-37.8447908887657,0.0 -58.2402159317503,-37.8434013127064,0.0 -58.2384592720794,-37.8447751383943,0.0 -58.2401816604764,-37.8461620774224,0.0 -58.2419416679245,-37.8447908887657,0.0 ",
				"Polygon Outer Boundary",
				"492",
				"0080004",
				"Balcarce",
				"Balcarce",
				"0004",
				"2014/10/10",
				"28 & 103",
				"Asentamiento Precario",
				"2000",
				"40",
				"4.0000000000000000000000000000000",
				"28, 30, 32, 103, 105",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.45088420063257,-34.646166054619215,0.0 -59.447558261454105,-34.64676624651909,0.0 -59.44769773632288,-34.64761356886342,0.0 -59.45105586200952,-34.64724286640332,0.0 -59.45088420063257,-34.646166054619215,0.0 ",
				"Polygon Outer Boundary",
				"2194",
				"0710012",
				"Mercedes",
				"Mercedes",
				"0012",
				"2015/09/10",
				"Marchetti",
				"Asentamiento Precario",
				"90_o_anterior",
				"115",
				"4.7800000000000002000000000000000",
				"calle 26,calle 61",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.44961819797754,-34.6445508107209,0.0 -59.44807324558496,-34.64484208653627,0.0 -59.44812688976526,-34.64575121356087,0.0 -59.44965038448572,-34.645451114480146,0.0 -59.44961819797754,-34.6445508107209,0.0 ",
				"Polygon Outer Boundary",
				"2194",
				"0710012",
				"Mercedes",
				"Mercedes",
				"0012",
				"2015/09/10",
				"Marchetti",
				"Asentamiento Precario",
				"90_o_anterior",
				"115",
				"4.7800000000000002000000000000000",
				"calle 26,calle 61",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.5235871001177,-34.556556324939,0.0 -58.5231690828724,-34.5563216965129,0.0 -58.5231690828724,-34.5563216965129,0.0 -58.522821299969,-34.5567423807473,0.0 -58.5228229373057,-34.5567791752957,0.0 -58.5231407154599,-34.5570698273527,0.0 -58.5234745753895,-34.5568204991231,0.0 -58.5234041384476,-34.5567806189949,0.0 -58.5235871001177,-34.556556324939,0.0 ",
				"Polygon Outer Boundary",
				"828",
				"0470039",
				"General San Martin",
				"Villa Granaderos De San Martín",
				"0039",
				"2014/10/01",
				"La California",
				"Otros",
				"90_o_anterior",
				"60",
				"0.3100000000000000000000000000000",
				"4 de Febrero & Saenz Peña",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-57.6276023028528,-37.9734489880791,0.0 -57.6264636389482,-37.9740136590654,0.0 -57.6266035885646,-37.974078944916,0.0 -57.6267576828432,-37.9739830468091,0.0 -57.6270658714003,-37.9742995100864,0.0 -57.6272524065796,-37.9744593395058,0.0 -57.627288902593,-37.9746063822643,0.0 -57.6274754377723,-37.9748173561425,0.0 -57.6277349649783,-37.9747981767241,0.0 -57.6279863819591,-37.9749228428542,0.0 -57.6280837046613,-37.9749100565942,0.0 -57.6283026807414,-37.9748429286926,0.0 -57.6285425286293,-37.974592181933,0.0 -57.6276023028528,-37.9734489880791,0.0 ",
				"Polygon Outer Boundary",
				"477",
				"0450007",
				"General Pueyrredon",
				"Mar Del Plata",
				"0007",
				"2014/09/03",
				"Alvarado & Errea",
				"Villa",
				"2004",
				"12",
				"0.5999999999999999800000000000000",
				"Alvarado entre Venezuela y Errea",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.33764910697937,-34.73077666574018,0.0 -58.339129686355584,-34.72965685259848,0.0 -58.33837866783142,-34.72900435605577,0.0 -58.3408668978716,-34.727271557631,0.0 -58.34293842315673,-34.72606805787162,0.0 -58.34431171417236,-34.72672939539192,0.0 -58.34538459777832,-34.72705565328631,0.0 -58.34609270095825,-34.72858992990123,0.0 -58.34640383720399,-34.72844884818307,0.0 -58.34674715995789,-34.72689693339042,0.0 -58.346908092498786,-34.72639431837621,0.0 -58.34640383720399,-34.726773484371805,0.0 -58.344537019729614,-34.72510690457649,0.0 -58.34380745887756,-34.72443673603361,0.0 -58.343598246574395,-34.72423392079846,0.0 -58.343201279640205,-34.72441028190071,0.0 -58.34248244762421,-34.724657186811804,0.0 -58.34214985370635,-34.72472332193063,0.0 -58.34133446216583,-34.724771820984145,0.0 -58.3406263589859,-34.72476300297654,0.0 -58.340095281600945,-34.72476300297654,0.0 -58.3388614654541,-34.72473213994247,0.0 -58.338603973388665,-34.72464836879197,0.0 -58.33786904811859,-34.724533734448435,0.0 -58.33720922470093,-34.72443232701204,0.0 -58.336780071258545,-34.72437060068551,0.0 -58.3367084887945,-34.7243649571098,0.0 -58.3356672974249,-34.7251560508386,0.0 -58.3336278228217,-34.7269375759981,0.0 -58.3336298898508,-34.7269759991968,0.0 -58.3340350459616,-34.7273927102634,0.0 -58.3359558347996,-34.7291728794406,0.0 -58.3368534408588,-34.7299890009143,0.0 -58.3369105622454,-34.7299986136282,0.0 -58.33764910697937,-34.73077666574018,0.0 ",
				"Polygon Outer Boundary",
				"588",
				"0250022",
				"Lanus",
				"Monte Chingolo",
				"0022",
				"2014/10/01",
				"Santa María",
				"Villa",
				"90_o_anterior",
				"2500",
				"38.6400000000000010000000000000000",
				"Coronel Lynch, Bolaños, Kloosterman, Camino Gral. Belgrano",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.5572581847702,-34.5878427803268,0.0 -58.5568185115362,-34.5875224715781,0.0 -58.5567723681695,-34.5875249002302,0.0 -58.5560675583252,-34.5881858982489,0.0 -58.5560698455198,-34.5882237816777,0.0 -58.5565074474711,-34.5885441587324,0.0 -58.5572581847702,-34.5878427803268,0.0 ",
				"Polygon Outer Boundary",
				"823",
				"0470044",
				"General San Martin",
				"General San Martin",
				"0044",
				"2014/10/01",
				"Corralón 2",
				"Villa",
				"90_o_anterior",
				"90",
				"0.5899999999999999700000000000000",
				"Posadas,  González y San Vicente",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.67457211017608,-34.67400420555509,0.0 -58.6743305695799,-34.6737837703678,0.0 -58.6743170749241,-34.6737816406308,0.0 -58.6740060654427,-34.6740392873079,0.0 -58.67428243160248,-34.674255672611054,0.0 -58.67457211017608,-34.67400420555509,0.0 ",
				"Polygon Outer Boundary",
				"38",
				"1360036",
				"Ituzaingo",
				"Ituzaingó Sur",
				"0036",
				"2014/09/01",
				"Iparraguirre",
				"Asentamiento Precario",
				"1988",
				"10",
				"0.1400000000000000100000000000000",
				"Gral. Villegas, Gral. M. Pintos, Cesario B. Quiros, Gral. Espejo",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.2598867525729,-37.8323627117587,0.0 -58.260283208995,-37.8320557046129,0.0 -58.2602858972126,-37.8320331329618,0.0 -58.2595126616241,-37.8314181350268,0.0 -58.2594813623896,-37.831416050824,0.0 -58.2590872927646,-37.8317230005043,0.0 -58.2598867525729,-37.8323627117587,0.0 ",
				"Polygon Outer Boundary",
				"488",
				"0080001",
				"Balcarce",
				"Balcarce",
				"0001",
				"2014/10/10",
				"Casero & Calle 1",
				"Asentamiento Precario",
				"2007",
				"30",
				"1.0000000000000000000000000000000",
				"Caseros, 1, 3, San Lorenzo",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.2597859260008,-37.8324386047317,0.0 -58.2596831835741,-37.8323591625325,0.0 -58.2593753053963,-37.8325990124238,0.0 -58.2594617964368,-37.8326643415429,0.0 -58.259501068214,-37.8326606880751,0.0 -58.2597859260008,-37.8324386047317,0.0 ",
				"Polygon Outer Boundary",
				"488",
				"0080001",
				"Balcarce",
				"Balcarce",
				"0001",
				"2014/10/10",
				"Casero & Calle 1",
				"Asentamiento Precario",
				"2007",
				"30",
				"1.0000000000000000000000000000000",
				"Caseros, 1, 3, San Lorenzo",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.60522252414375,-37.99027361902231,0.0 -57.60483896825462,-37.99045964109261,0.0 -57.60483092162758,-37.990487121585744,0.0 -57.60532713029534,-37.99110014529466,0.0 -57.60551488492638,-37.99128193754765,0.0 -57.605965496040874,-37.991854791584366,0.0 -57.60601109359413,-37.991863246961,0.0 -57.606121064163744,-37.99202389893188,0.0 -57.60611301753671,-37.99206617570786,0.0 -57.60628199670464,-37.99228390071822,0.0 -57.60632222983986,-37.99228812838193,0.0 -57.60699814651161,-37.991753326988736,0.0 -57.60700619313866,-37.9917300746658,0.0 -57.606794298626475,-37.99148698175749,0.0 -57.607059837318964,-37.99137917507942,0.0 -57.60748899076134,-37.99114453646777,0.0 -57.60730928275734,-37.990899327747314,0.0 -57.60723954532295,-37.99082534219655,0.0 -57.60675674770027,-37.99108534823098,0.0 -57.60657703969628,-37.99116567511219,0.0 -57.606341005302966,-37.99086761966326,0.0 -57.606190801598125,-37.990660459843575,0.0 -57.60666018817574,-37.9904575272081,0.0 -57.60684794280678,-37.99035606067985,0.0 -57.60660654399544,-37.990034749081204,0.0 -57.605568529106684,-37.99054419642318,0.0 -57.60531371925026,-37.990220771757215,0.0 -57.60522252414375,-37.99027361902231,0.0 ",
				"Polygon Outer Boundary",
				"1304",
				"0450028",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Regional",
				"0028",
				"2015/01/30",
				"La Palangana",
				"Asentamiento Precario",
				"90_o_anterior",
				"150",
				"2.4300000000000002000000000000000",
				"Paula Albarracín, Primera Junta, Grecia, Juan B. Justo",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.6207634904915,-37.9768496310752,0.0 -57.6197687810511,-37.9773476885645,0.0 -57.6202235751478,-37.977901764654,0.0 -57.6204055972375,-37.9777991728582,0.0 -57.620440686375,-37.9776435908952,0.0 -57.6207784193239,-37.9774810938261,0.0 -57.6210503601399,-37.9772909372247,0.0 -57.6210635185665,-37.9771872152344,0.0 -57.6207634904915,-37.9768496310752,0.0 ",
				"Polygon Outer Boundary",
				"476",
				"0450006",
				"General Pueyrredon",
				"Mar Del Plata",
				"0006",
				"2014/09/03",
				"Leguizamón & Alvarado",
				"Villa",
				"2001",
				"15",
				"0.2500000000000000000000000000000",
				"Leguizamón y Alvarado",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.6180582874163,-37.9738091560575,0.0 -57.6180111395346,-37.9738033367965,0.0 -57.6172261236649,-37.9741899708887,0.0 -57.6172151446572,-37.9742268589627,0.0 -57.6177199367529,-37.9748559891312,0.0 -57.617770814415,-37.9748590917921,0.0 -57.6185482628119,-37.9744743725676,0.0 -57.6185612526977,-37.974431580193,0.0 -57.6180582874163,-37.9738091560575,0.0 ",
				"Polygon Outer Boundary",
				"478",
				"0450008",
				"General Pueyrredon",
				"Mar Del Plata",
				"0008",
				"2014/09/03",
				"Wilde & Rawson",
				"Asentamiento Precario",
				"decada_1990",
				"30",
				"1.0000000000000000000000000000000",
				"Wilde, Alberti, Rawson, Leguizamon",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.6144478339859,-37.9743028779984,0.0 -57.6153274940825,-37.9738683714333,0.0 -57.6141128062389,-37.9723855151292,0.0 -57.6136685586528,-37.9726076292354,0.0 -57.613545994595,-37.9727064748974,0.0 -57.6140886492924,-37.9733738597065,0.0 -57.6141511933556,-37.9734412691233,0.0 -57.6138661220041,-37.9735833597975,0.0 -57.6144478339859,-37.9743028779984,0.0 ",
				"Polygon Outer Boundary",
				"480",
				"0450011",
				"General Pueyrredon",
				"Mar Del Plata",
				"0011",
				"2014/09/03",
				"Falucho & Bayley",
				"Asentamiento Precario",
				"decada_1980",
				"50",
				"1.0000000000000000000000000000000",
				"Falucho, Paraguay y Bayley",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.6153833517872,-37.9722446551875,0.0 -57.6145366503412,-37.9726669506598,0.0 -57.6148557096855,-37.9730992049499,0.0 -57.6151416863637,-37.9734498105734,0.0 -57.6157940263433,-37.974258667426,0.0 -57.6162357123787,-37.9740384750688,0.0 -57.6165296479998,-37.9744001377578,0.0 -57.6169650902009,-37.9741794557606,0.0 -57.6168325084189,-37.9740155642693,0.0 -57.6163775834837,-37.9734554185879,0.0 -57.6159392866277,-37.9736764909442,0.0 -57.6158709363305,-37.9735874626423,0.0 -57.6155755202644,-37.9732288115566,0.0 -57.6160118296172,-37.9730065485349,0.0 -57.6156222147351,-37.9725391786085,0.0 -57.6153833517872,-37.9722446551875,0.0 ",
				"Polygon Outer Boundary",
				"481",
				"0450012",
				"General Pueyrredon",
				"Mar Del Plata",
				"0012",
				"2014/09/03",
				"Falucho & Leguizamón",
				"Asentamiento Precario",
				"decada_1980",
				"15",
				"0.4000000000000000200000000000000",
				"Falucho esquina Leguizamón",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.6239336814879,-37.978917571706,0.0 -57.6228063059584,-37.9780785055406,0.0 -57.6226715457736,-37.9781735481934,0.0 -57.6227637501105,-37.9783524516767,0.0 -57.6231680306649,-37.978861206074,0.0 -57.6233172889493,-37.9793983740149,0.0 -57.6239336814879,-37.978917571706,0.0 ",
				"Polygon Outer Boundary",
				"475",
				"0450005",
				"General Pueyrredon",
				"Mar Del Plata",
				"0005",
				"2014/09/03",
				"Canadá & San Lorenzo",
				"Villa",
				"2001",
				"10",
				"0.5000000000000000000000000000000",
				"Canadá, Juan B. Justo, San Lorenzo",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.648483041673906,-33.68221102471215,0.0 -59.64843702502549,-33.6821708498405,0.0 -59.645062806084745,-33.684581308908236,0.0 -59.6456314343959,-33.68525086887644,0.0 -59.646400809288025,-33.68473307629145,0.0 -59.646813869476325,-33.68513481218893,0.0 -59.64706063270569,-33.68499643670288,0.0 -59.64729666709899,-33.68532228829855,0.0 -59.6475487947464,-33.68521069542541,0.0 -59.64732348918915,-33.68485806099408,0.0 -59.64754343032837,-33.68466612012601,0.0 -59.64700162410736,-33.684067976067375,0.0 -59.64770436286926,-33.683576959177294,0.0 -59.64828372001647,-33.68424652696841,0.0 -59.64900791645049,-33.68386710586042,0.0 -59.6484293974936,-33.68324663714597,0.0 -59.648118261247866,-33.68296095220339,0.0 -59.64877272024751,-33.68248778442889,0.0 -59.648483041673906,-33.68221102471215,0.0 ",
				"Polygon Outer Boundary",
				"1916",
				"0990010",
				"San Pedro",
				"San Pedro",
				"0010",
				"2015/07/15",
				"Bajo Puerto",
				"Villa",
				"90_o_anterior",
				"96",
				"4.6299999999999999000000000000000",
				"España y 24 de Febrero",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.7901726765064,-34.1759719868912,0.0 -59.7901295276153,-34.1758842496277,0.0 -59.7888475601347,-34.1762603829276,0.0 -59.7890711548763,-34.1768338387939,0.0 -59.78953325948,-34.176692019105,0.0 -59.7902264189296,-34.1760939016152,0.0 -59.7901726765064,-34.1759719868912,0.0 ",
				"Polygon Outer Boundary",
				"498",
				"1210001",
				"Capitan Sarmiento",
				"Capitan Sarmiento",
				"0001",
				"2014/10/30",
				"Centro",
				"Asentamiento Precario",
				"2007",
				"16",
				"0.6999999999999999600000000000000",
				"Belgrano, Pte Peron, Av. Alem, Rene Favaloro",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.6899193788812,-34.6018597588417,0.0 -58.6895268068536,-34.6015220400765,0.0 -58.6892524966218,-34.6012892469,0.0 -58.6891696931389,-34.6013559591066,0.0 -58.6891585110431,-34.6013738661228,0.0 -58.6889374177435,-34.6015697891428,0.0 -58.6890827822447,-34.6016840209737,0.0 -58.6890054276793,-34.6017507916086,0.0 -58.6890592140291,-34.6017964374853,0.0 -58.6889101664633,-34.6019165191413,0.0 -58.6891107691632,-34.6020819652188,0.0 -58.689586772291,-34.6017480175555,0.0 -58.689798499856,-34.6019215557996,0.0 -58.6898420955756,-34.6019220239859,0.0 -58.6899193788812,-34.6018597588417,0.0 ",
				"Polygon Outer Boundary",
				"7",
				"1360007",
				"Ituzaingo",
				"Villa Udaondo",
				"0007",
				"2014/10/30",
				"Nuevo",
				"Asentamiento Precario",
				"2009",
				"15",
				"0.3599999999999999900000000000000",
				"Chimbora, Santos Vega,  Del Pretal",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.0103504195918,-34.9156025963548,0.0 -60.010295922628,-34.9155998967961,0.0 -60.0096543876744,-34.916102477502,0.0 -60.0096525333724,-34.9161540377073,0.0 -60.0102548013641,-34.916679051486,0.0 -60.0104406361808,-34.9168258728348,0.0 -60.0110472912489,-34.9173495301562,0.0 -60.0110960988985,-34.9173525005259,0.0 -60.0117434334959,-34.9168413482816,0.0 -60.0117432083657,-34.9167973599763,0.0 -60.011132285051,-34.916273345914,0.0 -60.0103504195918,-34.9156025963548,0.0 ",
				"Polygon Outer Boundary",
				"432",
				"0280001",
				"Chivilcoy",
				"Chivilcoy",
				"0001",
				"2014/07/30",
				"Rojas",
				"Asentamiento Precario",
				"decada_2000",
				"50",
				"1.5000000000000000000000000000000",
				"22 de octubre entre Namuncura y Guzmán, Padre Zacarías",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.0023797721346,-34.9261673659705,0.0 -60.0023749549858,-34.9261129216292,0.0 -60.0019588362206,-34.9257283040228,0.0 -60.0017581115906,-34.9255611885475,0.0 -60.0013328049134,-34.9251576396082,0.0 -60.0012800529676,-34.9251511503448,0.0 -60.0006122313545,-34.9256302465453,0.0 -60.0006120127664,-34.9256707193712,0.0 -60.0010365524345,-34.9260731891325,0.0 -60.0012335556894,-34.926238593174,0.0 -60.0016578823083,-34.9266352014548,0.0 -60.0017170924565,-34.9266383557234,0.0 -60.0023797721346,-34.9261673659705,0.0 ",
				"Polygon Outer Boundary",
				"433",
				"0280002",
				"Chivilcoy",
				"Chivilcoy",
				"0002",
				"2014/07/30",
				"De los inmigrantes & M. Luis Conti",
				"Asentamiento Precario",
				"decada_1980",
				"32",
				"1.1000000000000001000000000000000",
				"Zacarías, De los Inmigrantes, M. Luis Conti, 112",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.48728820681572,-34.70908309798068,0.0 -58.489950299263,-34.70705013669751,0.0 -58.489306569099426,-34.70650771125212,0.0 -58.48890960216522,-34.706820819057015,0.0 -58.48735928535461,-34.70534346901861,0.0 -58.48693013191223,-34.705718321526156,0.0 -58.48762214183807,-34.706423921638546,0.0 -58.48621666431426,-34.70745144103876,0.0 -58.487074971199036,-34.70848776742026,0.0 -58.48703742027282,-34.7086994409993,0.0 -58.48728820681572,-34.70908309798068,0.0 ",
				"Polygon Outer Boundary",
				"1451",
				"0700126",
				"La Matanza",
				"Ciudad Madero",
				"0126",
				"2015/03/16",
				"Las Achiras",
				"Villa",
				"90_o_anterior",
				"800",
				"5.9699999999999998000000000000000",
				"Antofagasta y Bulong Sur Mer",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.35617780685425,-34.7382446378057,0.0 -58.35464132018387,-34.739351109907815,0.0 -58.357876064255834,-34.741008586209915,0.0 -58.35855198092758,-34.74041789368163,0.0 -58.358632447198026,-34.74044875085855,0.0 -58.35945546627044,-34.73980074772315,0.0 -58.358763456344604,-34.73917918891999,0.0 -58.35793733596802,-34.73974344107883,0.0 -58.357057571411126,-34.73894996037978,0.0 -58.35629892535507,-34.738147655480915,0.0 -58.35617780685425,-34.7382446378057,0.0 ",
				"Polygon Outer Boundary",
				"1437",
				"0250034",
				"Lanus",
				"Lanus",
				"0034",
				"2015/03/09",
				"SIAM",
				"Villa",
				"2002",
				"380",
				"5.8499999999999996000000000000000",
				"Purita, Cnel Lynch, Alzaga y Cazón",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-57.8945117033613,-34.8894605354683,0.0 -57.8918924571183,-34.8862561131049,0.0 -57.8866174002888,-34.8893708746042,0.0 -57.889943808884,-34.8935769120639,0.0 -57.8882808549828,-34.8945420773844,0.0 -57.8884023408955,-34.8949197179306,0.0 -57.8956849045909,-34.8908398312946,0.0 -57.8945117033613,-34.8894605354683,0.0 ",
				"Polygon Outer Boundary",
				"445",
				"1140004",
				"Berisso",
				"Berisso",
				"0004",
				"2014/08/28",
				"Santa Cruz",
				"Asentamiento Precario",
				"2000",
				"771",
				"37.2000000000000030000000000000000",
				"14 a 19 y 148 a 152",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.8701366629592,-34.8893321565538,0.0 -57.8693507139928,-34.8898422427392,0.0 -57.87677049636841,-34.89303286495012,0.0 -57.87840127944946,-34.89233766031896,0.0 -57.88013935089111,-34.89126404160946,0.0 -57.8752482188002,-34.8854469310826,0.0 -57.8746665364016,-34.8847131053789,0.0 -57.8725079279234,-34.8859086927563,0.0 -57.8707181015142,-34.8869070356289,0.0 -57.869367995564,-34.8876895687282,0.0 -57.869381100817,-34.8878065069544,0.0 -57.869845576841,-34.8884237329541,0.0 -57.8704652579446,-34.8891581609987,0.0 -57.8701366629592,-34.8893321565538,0.0 ",
				"Polygon Outer Boundary",
				"443",
				"1140002",
				"Berisso",
				"Berisso",
				"0002",
				"2014/08/28",
				"Villa Roca",
				"Asentamiento Precario",
				"2004",
				"632",
				"48.9900000000000020000000000000000",
				"153 a 159 y 25 y Av 66",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.52624595165253,-34.68523124501028,0.0 -58.52771580219269,-34.6862105059367,0.0 -58.528354167938225,-34.686669254818966,0.0 -58.5287994146347,-34.686245794402495,0.0 -58.52675020694733,-34.684843066302186,0.0 -58.52624595165253,-34.68523124501028,0.0 ",
				"Polygon Outer Boundary",
				"1120",
				"0700010",
				"La Matanza",
				"La Tablada",
				"0010",
				"2014/10/01",
				"Godoy Cruz",
				"Villa",
				"90_o_anterior",
				"280",
				"1.5200000000000000000000000000000",
				"Godoy Cruz, Avellaneda, Guayaquil",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.4694693217987,-34.7043943864427,0.0 -58.4693992137909,-34.70463785969082,0.0 -58.4770235246644,-34.7119884847864,0.0 -58.47850799560547,-34.711526113337015,0.0 -58.47952723503112,-34.711173335793625,0.0 -58.4800874068984,-34.7110438662865,0.0 -58.4805898905728,-34.7098720759593,0.0 -58.4776503082432,-34.7092093370734,0.0 -58.4778078248986,-34.7087205805167,0.0 -58.4756773757616,-34.70824002089,0.0 -58.47616910934448,-34.706728209829706,0.0 -58.47688794136047,-34.704523197606626,0.0 -58.47612619400024,-34.70415274978698,0.0 -58.47522497177124,-34.7069222480918,0.0 -58.47526788711548,-34.7073985218964,0.0 -58.475085496902466,-34.70813938680874,0.0 -58.47477436065673,-34.708042369162065,0.0 -58.47370147705078,-34.707777775001894,0.0 -58.4743914704224,-34.7059272364921,0.0 -58.47148060798645,-34.70527290835665,0.0 -58.4716827393524,-34.7047185038137,0.0 -58.4697874308083,-34.7042870813333,0.0 -58.4695396002733,-34.7042211054289,0.0 -58.4694693217987,-34.7043943864427,0.0 ",
				"Polygon Outer Boundary",
				"1070",
				"0700060",
				"La Matanza",
				"Ciudad Madero",
				"0060",
				"2014/10/01",
				"Hijos de Sarmiento",
				"Asentamiento Precario",
				"2000",
				"2000",
				"26.2100000000000010000000000000000",
				"Ramón Carrillo, Gral. Paz, Boulogne Sur Mer",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.5828271813153,-34.5534188052176,0.0 -58.5826009601939,-34.5532230193416,0.0 -58.58232581917,-34.5534449817184,0.0 -58.5825500307082,-34.5536436290847,0.0 -58.5828271813153,-34.5534188052176,0.0 ",
				"Polygon Outer Boundary",
				"855",
				"0470012",
				"General San Martin",
				"General San Martin",
				"0012",
				"2014/10/01",
				"Betinotti",
				"Asentamiento Precario",
				"90_o_anterior",
				"15",
				"0.1100000000000000000000000000000",
				"148 entre Urquiza y 1 de Agosto",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.47498960793019,-34.73348355295211,0.0 -58.471255972981446,-34.73614626754821,0.0 -58.4687239676714,-34.738650199021464,0.0 -58.46499033272266,-34.743763626171486,0.0 -58.46574135124683,-34.74413389653849,0.0 -58.46994705498218,-34.7389323273888,0.0 -58.47159929573535,-34.7370279422147,0.0 -58.47241468727589,-34.73593466422845,0.0 -58.47314357757568,-34.736256477395976,0.0 -58.475268557667725,-34.73357172368302,0.0 -58.47498960793019,-34.73348355295211,0.0 ",
				"Polygon Outer Boundary",
				"2156",
				"0630077",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0077",
				"2015/09/04",
				"Padre Mujica II",
				"Asentamiento Precario",
				"decada_2000",
				"500",
				"13.0299999999999990000000000000000",
				"Padre Mujica, Arroyo Santa Catalina y Vias del FFCC",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-61.88283205032348,-35.81248869084121,0.0 -61.8810510635376,-35.81390684379893,0.0 -61.881405115127556,-35.81420265165272,0.0 -61.883175373077385,-35.812758402863366,0.0 -61.88283205032348,-35.81248869084121,0.0 ",
				"Polygon Outer Boundary",
				"1746",
				"0800006",
				"Pehuajo",
				"Pehuajo",
				"0006",
				"2015/06/01",
				"Barrio Cumba",
				"Otros",
				"decada_1990",
				"10",
				"1.0100000000000000000000000000000",
				"Antártida Argentina entre Tierra del Fuego y Chubut",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.768413612051525,-34.36866768491036,0.0 -58.768982240362675,-34.368224892698215,0.0 -58.7708597866731,-34.36693192604477,0.0 -58.77402479331067,-34.364593908283624,0.0 -58.77599889914563,-34.363203465269955,0.0 -58.778015920324826,-34.36183071227228,0.0 -58.77771551291516,-34.36159158525668,0.0 -58.776996680899174,-34.36217611675678,0.0 -58.77567703406384,-34.363097188421655,0.0 -58.77441103140881,-34.36396511207157,0.0 -58.77407843749097,-34.36429279519341,0.0 -58.77132112662366,-34.36622344270376,0.0 -58.7708597866731,-34.36651569280787,0.0 -58.768327781363034,-34.36825146029693,0.0 -58.768241950674565,-34.3685259916571,0.0 -58.768413612051525,-34.36866768491036,0.0 ",
				"Polygon Outer Boundary",
				"2082",
				"1180015",
				"Escobar",
				"Escobar",
				"0015",
				"2015/08/06",
				"Gral Guemes & Ceferino Namuncura",
				"Asentamiento Precario",
				"90_o_anterior",
				"160",
				"5.3200000000000003000000000000000",
				"Gral Guemes, Ceferino Mamuncura, Río Negro",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.78671700636914,-34.35516146965594,0.0 -58.78583724181227,-34.35580804628816,0.0 -58.78539735953382,-34.3561180470141,0.0 -58.78408844153455,-34.35707461345516,0.0 -58.782961913748295,-34.357862886854086,0.0 -58.78198558966687,-34.35855372710762,0.0 -58.78082687537244,-34.35938627061578,0.0 -58.7797754494386,-34.36017452227238,0.0 -58.77994711081555,-34.36036051315519,0.0 -58.783991882010014,-34.35733146739945,0.0 -58.78684575240186,-34.355312042741836,0.0 -58.78671700636914,-34.35516146965594,0.0 ",
				"Polygon Outer Boundary",
				"2082",
				"1180015",
				"Escobar",
				"Escobar",
				"0015",
				"2015/08/06",
				"Gral Guemes & Ceferino Namuncura",
				"Asentamiento Precario",
				"90_o_anterior",
				"160",
				"5.3200000000000003000000000000000",
				"Gral Guemes, Ceferino Mamuncura, Río Negro",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.7705866698513,-34.5079997175975,0.0 -58.7692087550947,-34.5072562636604,0.0 -58.7684913638046,-34.50817772645,0.0 -58.7698707278773,-34.5089342730998,0.0 -58.7705866698513,-34.5079997175975,0.0 ",
				"Polygon Outer Boundary",
				"1155",
				"1320023",
				"Jose C. Paz",
				"Jose C. Paz",
				"0023",
				"2014/10/01",
				"Alberdi",
				"Asentamiento Precario",
				"90_o_anterior",
				"175",
				"3.6400000000000001000000000000000",
				"Agrelo, Mansilla, 11 de Septiembre y Quirós",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7712693267158,-34.5098212474483,0.0 -58.7706273061802,-34.5094662234172,0.0 -58.7705223392046,-34.5094142388998,0.0 -58.7699334072577,-34.5090777732298,0.0 -58.7692039020875,-34.5099264665552,0.0 -58.7692178335282,-34.5099639241049,0.0 -58.769799780345,-34.5102868922909,0.0 -58.7701469922665,-34.5104785200765,0.0 -58.7705972611588,-34.5107185704829,0.0 -58.7712693267158,-34.5098212474483,0.0 ",
				"Polygon Outer Boundary",
				"1155",
				"1320023",
				"Jose C. Paz",
				"Jose C. Paz",
				"0023",
				"2014/10/01",
				"Alberdi",
				"Asentamiento Precario",
				"90_o_anterior",
				"175",
				"3.6400000000000001000000000000000",
				"Agrelo, Mansilla, 11 de Septiembre y Quirós",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.75819039531052,-34.536399232687245,0.0 -58.758576633408666,-34.53590430028018,0.0 -58.75856590457261,-34.535838014466535,0.0 -58.757809521630406,-34.53545797478291,0.0 -58.75774514861405,-34.535462393858964,0.0 -58.757358910515904,-34.53596616699197,0.0 -58.75819039531052,-34.536399232687245,0.0 ",
				"Polygon Outer Boundary",
				"1747",
				"1320045",
				"Jose C. Paz",
				"Jose C. Paz",
				"0045",
				"2015/06/01",
				"Las Acacias",
				"Otros",
				"90_o_anterior",
				"35",
				"0.6400000000000000100000000000000",
				"Pueyrredón, Antartida Argentina, Martel",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.53882014751434,-34.551095616399095,0.0 -58.53906691074371,-34.551303273701365,0.0 -58.53993058204651,-34.55060518964923,0.0 -58.54111075401306,-34.549593399203275,0.0 -58.5406655073166,-34.54923109570283,0.0 -58.541674017906196,-34.54843137141676,0.0 -58.5416136785322,-34.5483622194251,0.0 -58.5413030679193,-34.5480334832804,0.0 -58.5405992970468,-34.547219179249,0.0 -58.5383333914426,-34.5490846317463,0.0 -58.5381833067203,-34.5492081874853,0.0 -58.5375945383716,-34.5496928796682,0.0 -58.5374218524405,-34.549835038384,0.0 -58.5372303493559,-34.5498991178452,0.0 -58.5365989128321,-34.549335060035,0.0 -58.5360022123859,-34.5498232845853,0.0 -58.5367247466863,-34.5503360693073,0.0 -58.53675108552,-34.5503872208417,0.0 -58.5377099798137,-34.5510022509865,0.0 -58.5380507891094,-34.5512423049104,0.0 -58.53842854499816,-34.55145791178129,0.0 -58.53882014751434,-34.551095616399095,0.0 ",
				"Polygon Outer Boundary",
				"739",
				"0470128",
				"General San Martin",
				"General San Martin",
				"0128",
				"2014/10/01",
				"La Rana",
				"Villa",
				"90_o_anterior",
				"550",
				"10.1800000000000000000000000000000",
				"Mendoza, Entre Ríos, A. Alvares",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.56941429217841,-34.580223224801614,0.0 -58.569038782916316,-34.579883138301895,0.0 -58.568743739924685,-34.58011280725945,0.0 -58.56912997802283,-34.58043522607138,0.0 -58.56918898662116,-34.58043964275875,0.0 -58.56941429217841,-34.580223224801614,0.0 ",
				"Polygon Outer Boundary",
				"1748",
				"0470137",
				"General San Martin",
				"General San Martin",
				"0137",
				"2015/06/02",
				"Rivadavia & Sarmiento",
				"Villa",
				"90_o_anterior",
				"35",
				"0.1900000000000000000000000000000",
				"Rivadavia, Sarmiento",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.7849769307211,-34.696327206831,0.0 -58.7843478889496,-34.6956854764131,0.0 -58.7836316223253,-34.6961650610376,0.0 -58.78393650054932,-34.69649645681937,0.0 -58.7842659428201,-34.6968113545353,0.0 -58.7849769307211,-34.696327206831,0.0 ",
				"Polygon Outer Boundary",
				"604",
				"0720058",
				"Merlo",
				"Mariano Acosta",
				"0058",
				"2014/10/01",
				"Carcavallo & Fregues",
				"Otros",
				"90_o_anterior",
				"23",
				"0.7900000000000000400000000000000",
				"Florencio Sanchez, Fray Mocho, Carcavallo",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.745098114013665,-34.434819075718806,0.0 -58.74345123767853,-34.43695603896591,0.0 -58.745752573013306,-34.43824792398912,0.0 -58.747522830963135,-34.436040204265744,0.0 -58.745098114013665,-34.434819075718806,0.0 ",
				"Polygon Outer Boundary",
				"2066",
				"1180003",
				"Escobar",
				"Garín",
				"0003",
				"2015/08/06",
				"El Campo del Ruso",
				"Asentamiento Precario",
				"2007",
				"90",
				"7.4400000000000004000000000000000",
				"Martín Fierro, Magallanes, Carranza",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.727656577430025,-34.429227438592044,0.0 -58.72765925963904,-34.42921637682348,0.0 -58.727331161499016,-34.429691025909754,0.0 -58.72703075408935,-34.43007154774678,0.0 -58.726140260696404,-34.429593682835986,0.0 -58.72571734031226,-34.430163258912515,0.0 -58.72838258743286,-34.431673260207226,0.0 -58.72847914695739,-34.43203607478792,0.0 -58.72852206230164,-34.43260241635119,0.0 -58.72874736785889,-34.432381189634796,0.0 -58.728704452514656,-34.4316555618947,0.0 -58.72852206230164,-34.43146088020966,0.0 -58.72898963531043,-34.43082695491698,0.0 -58.72950911521912,-34.430195438203604,0.0 -58.72765389522101,-34.429238500359155,0.0 -58.72765523632552,-34.42923296947579,0.0 -58.727656577430025,-34.429227438592044,0.0 ",
				"Polygon Outer Boundary",
				"2068",
				"1180004",
				"Escobar",
				"Escobar",
				"0004",
				"2015/08/06",
				"Cabot",
				"Asentamiento Precario",
				"90_o_anterior",
				"250",
				"4.7599999999999998000000000000000",
				"Bourdet, Calle 8, Cilento,",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.47208309918642,-34.74773072230653,0.0 -58.46564579755067,-34.744363110695915,0.0 -58.46240401268005,-34.74876213609401,0.0 -58.46817780286074,-34.75164473709485,0.0 -58.46824217587709,-34.75176814895905,0.0 -58.46804905682802,-34.75210312308938,0.0 -58.468616008758545,-34.752420465749026,0.0 -58.47208309918642,-34.74773072230653,0.0 ",
				"Polygon Outer Boundary",
				"1453",
				"0630067",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0067",
				"2015/03/16",
				"Barrio Obrero I",
				"Otros",
				"2004",
				"1200",
				"39.7599999999999980000000000000000",
				"Gral. J. F. Quiroga , Av. Capitán Giachino, Pepe Ratti",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.5704372625894,-34.4464938203299,0.0 -58.5703284086377,-34.446579799532,0.0 -58.5701810869041,-34.4466692943069,0.0 -58.570035373991,-34.4467856685533,0.0 -58.569929011739,-34.4468786170308,0.0 -58.5698639559421,-34.4469355432336,0.0 -58.569817097327,-34.4469589710988,0.0 -58.5696628688917,-34.4470833575277,0.0 -58.5696428769219,-34.4470944809907,0.0 -58.5694358991604,-34.447249527015,0.0 -58.569821070342,-34.4475939379887,0.0 -58.5699359864893,-34.4476311566393,0.0 -58.5699194429306,-34.4476506128275,0.0 -58.5699150170145,-34.4476740866355,0.0 -58.5699237707549,-34.4476967233284,0.0 -58.5699499789553,-34.4477166794423,0.0 -58.5700033162189,-34.4477217202678,0.0 -58.5700154756308,-34.4477169048054,0.0 -58.5700340292301,-34.4477008073636,0.0 -58.5700393186798,-34.447690503356,0.0 -58.570693348102,-34.4475497879141,0.0 -58.5709921817892,-34.44748261466,0.0 -58.5710528623482,-34.4474461878036,0.0 -58.5709823183328,-34.4473207045941,0.0 -58.5709603578403,-34.4473260363332,0.0 -58.5709929819848,-34.4472759411397,0.0 -58.57111620161,-34.4473941984025,0.0 -58.5712439184301,-34.4472995156782,0.0 -58.57121586799621,-34.447140152219525,0.0 -58.5710555356351,-34.4470592634475,0.0 -58.5709016695032,-34.4468814284702,0.0 -58.5708903203694,-34.4468514608593,0.0 -58.5708467046364,-34.4468122824632,0.0 -58.5708292914101,-34.446825328933,0.0 -58.5707715360292,-34.4467730955017,0.0 -58.5704372625894,-34.4464938203299,0.0 ",
				"Polygon Outer Boundary",
				"561",
				"0960006",
				"San Fernando",
				"San Fernando",
				"0006",
				"2014/10/01",
				"San Francisco",
				"Villa",
				"decada_1960",
				"90",
				"1.2400000000000000000000000000000",
				"Arroyo Cordero, General Pinto, Sarratea, French",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.605167269706726,-34.72515540340496,0.0 -58.60562324523925,-34.7255433930085,0.0 -58.606288433074944,-34.7250319517856,0.0 -58.60585391521454,-34.72463955077117,0.0 -58.605167269706726,-34.72515540340496,0.0 ",
				"Polygon Outer Boundary",
				"1625",
				"0700141",
				"La Matanza",
				"Rafael Castillo",
				"0141",
				"2015/04/27",
				"Del Cencerro",
				"Villa",
				"90_o_anterior",
				"50",
				"0.5000000000000000000000000000000",
				"Lope de Vega y Sequeira",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.40097069740295,-34.883625103502915,0.0 -58.402665853500366,-34.88439959040606,0.0 -58.40463903732598,-34.885341286239424,0.0 -58.40739727020263,-34.8867142066237,0.0 -58.408968122676015,-34.88749306472096,0.0 -58.40954211540521,-34.88777028361818,0.0 -58.41010001488029,-34.88811350571895,0.0 -58.410733016207814,-34.88834231965633,0.0 -58.41166106052697,-34.888870349387616,0.0 -58.41379165649414,-34.88586053446649,0.0 -58.41254711151123,-34.88522687517202,0.0 -58.411028059199445,-34.88452720402492,0.0 -58.40981570072472,-34.883897934949246,0.0 -58.40846923179924,-34.8832070535618,0.0 -58.40669943485409,-34.88232914176352,0.0 -58.40577675495297,-34.88184947671909,0.0 -58.40490771923214,-34.881420416165135,0.0 -58.40399576816707,-34.880975951075484,0.0 -58.403094545938075,-34.88053588426229,0.0 -58.40097069740295,-34.883625103502915,0.0 ",
				"Polygon Outer Boundary",
				"2093",
				"0030078",
				"Almirante Brown",
				"Glew",
				"0078",
				"2015/08/11",
				"Nuevo Sol",
				"Asentamiento Precario",
				"2010",
				"870",
				"43.9699999999999990000000000000000",
				"Boedo, Gaito, Blanes y San Roque",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.54781895875931,-34.47376251154378,0.0 -58.5438268011165,-34.4718727285737,0.0 -58.5404319586641,-34.4702470619602,0.0 -58.5392953785267,-34.4711772483774,0.0 -58.5391088314401,-34.4713239719761,0.0 -58.5374344605595,-34.4723879441658,0.0 -58.5396736397752,-34.4734828035746,0.0 -58.5400028714546,-34.4730135375,0.0 -58.5402564556346,-34.4731382469966,0.0 -58.5408702059278,-34.4722667767069,0.0 -58.5423543391345,-34.4729740093018,0.0 -58.542320677492,-34.4730321944694,0.0 -58.5441335794711,-34.4739235938726,0.0 -58.546788990497596,-34.475177651005325,0.0 -58.54781895875931,-34.47376251154378,0.0 ",
				"Polygon Outer Boundary",
				"873",
				"0970011",
				"San Isidro",
				"San Isidro",
				"0011",
				"2014/10/01",
				"Cava",
				"Villa",
				"1950",
				"2300",
				"18.2500000000000000000000000000000",
				"Int. Neyer, Andrés Rolón,",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-61.91876179073005,-35.81830904683981,0.0 -61.917836428619914,-35.81756303850187,0.0 -61.915004015900195,-35.81987716396037,0.0 -61.915958882309496,-35.820675347602716,0.0 -61.91876179073005,-35.81830904683981,0.0 ",
				"Polygon Outer Boundary",
				"1628",
				"0800005",
				"Pehuajo",
				"Pehuajó",
				"0005",
				"2015/04/27",
				"Villa Radici",
				"Otros",
				"decada_1970",
				"84",
				"4.4000000000000004000000000000000",
				"Sastre - Azcona - Acc. Güemes y Maciel",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.04654884338379,-33.514075964552475,0.0 -60.047943592071526,-33.51026971132651,0.0 -60.04631280899047,-33.51154444462692,0.0 -60.046731233596795,-33.51196487886023,0.0 -60.04657566547393,-33.512166149844596,0.0 -60.045894384384155,-33.5132082787866,0.0 -60.04616796970367,-33.513968622455174,0.0 -60.04654884338379,-33.514075964552475,0.0 ",
				"Polygon Outer Boundary",
				"1627",
				"0870001",
				"Ramallo",
				"Villa Ramallo",
				"0001",
				"2015/04/27",
				"El Triangulo",
				"Asentamiento Precario",
				"1980",
				"30",
				"2.7400000000000002000000000000000",
				"Frondizi entre Ruta 51 y Ruta 1001",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.72000336647034,-34.51354752258508,0.0 -58.71989339590072,-34.51349668982307,0.0 -58.7197941070362,-34.5134219784471,0.0 -58.71955007314682,-34.51374864320893,0.0 -58.71964931488037,-34.51379947581723,0.0 -58.71975928544999,-34.51386356906174,0.0 -58.72000336647034,-34.51354752258508,0.0 ",
				"Polygon Outer Boundary",
				"175",
				"1330018",
				"Malvinas Argentinas",
				"Los Polvorines",
				"0018",
				"2014/07/25",
				"San Roque",
				"Asentamiento Precario",
				"1996",
				"11",
				"0.1000000000000000100000000000000",
				"Dante Alighieri y Horacio Quiroga",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.34229469299317,-34.66067094669319,0.0 -58.34301352500915,-34.66062682248636,0.0 -58.34371626377106,-34.66062682248636,0.0 -58.34373772144317,-34.66011056752093,0.0 -58.342332243919365,-34.6601414546606,0.0 -58.34095895290374,-34.66015027955553,0.0 -58.3410099975617,-34.6612402377423,0.0 -58.3423190232314,-34.6612091065416,0.0 -58.34229469299317,-34.66067094669319,0.0 ",
				"Polygon Outer Boundary",
				"518",
				"0040002",
				"Avellaneda",
				"Avellaneda",
				"0002",
				"2014/10/31",
				"15 de Octubre",
				"Villa",
				"90_o_anterior",
				"278",
				"2.6499999999999999000000000000000",
				"Debenedetti, Campaña, Diaz de Solis, Ayolas",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.342333699152,-34.6613813641901,0.0 -58.341011573777,-34.6613964543493,0.0 -58.3410195949104,-34.6617382460404,0.0 -58.3413947559184,-34.6617310037663,0.0 -58.3416829710069,-34.6617296977332,0.0 -58.341867538494,-34.6617240068073,0.0 -58.3423403798614,-34.6617195324495,0.0 -58.342333699152,-34.6613813641901,0.0 ",
				"Polygon Outer Boundary",
				"518",
				"0040002",
				"Avellaneda",
				"Avellaneda",
				"0002",
				"2014/10/31",
				"15 de Octubre",
				"Villa",
				"90_o_anterior",
				"278",
				"2.6499999999999999000000000000000",
				"Debenedetti, Campaña, Diaz de Solis, Ayolas",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.91128015704453,-34.43408462024572,0.0 -58.91051304526627,-34.43371296561911,0.0 -58.9089144486934,-34.435801289214965,0.0 -58.90754115767776,-34.43512878392322,0.0 -58.90674185939133,-34.436221602274024,0.0 -58.90882325358689,-34.43728786065549,0.0 -58.91128015704453,-34.43408462024572,0.0 ",
				"Polygon Outer Boundary",
				"2067",
				"0840037",
				"Pilar",
				"Pilar",
				"0037",
				"2015/08/06",
				"Leguizamon & Haití",
				"Otros",
				"90_o_anterior",
				"280",
				"7.4100000000000001000000000000000",
				"Dr. Penna, Estados Unidos, Cuba",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.90610575675965,-34.43698700904603,0.0 -58.906647562980645,-34.43625699696143,0.0 -58.90482449904084,-34.43529248636759,0.0 -58.90427649021149,-34.436013658182716,0.0 -58.90610575675965,-34.43698700904603,0.0 ",
				"Polygon Outer Boundary",
				"2067",
				"0840037",
				"Pilar",
				"Pilar",
				"0037",
				"2015/08/06",
				"Leguizamon & Haití",
				"Otros",
				"90_o_anterior",
				"280",
				"7.4100000000000001000000000000000",
				"Dr. Penna, Estados Unidos, Cuba",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.40039670467377,-34.721416501178226,0.0 -58.40135157108306,-34.72126217964622,0.0 -58.4023654460907,-34.72111667622366,0.0 -58.402976989746094,-34.721050538219664,0.0 -58.40313255786896,-34.721050538219664,0.0 -58.403261303901665,-34.721050538219664,0.0 -58.40336859226226,-34.72102408300326,0.0 -58.40377628803253,-34.720688982862704,0.0 -58.4040766954422,-34.72026128728939,0.0 -58.4039828779333,-34.7199687305455,0.0 -58.4028206738236,-34.7201278076386,0.0 -58.40237081050873,-34.720384746032536,0.0 -58.40006411075591,-34.720420019925285,0.0 -58.40021967887878,-34.72080803175239,0.0 -58.40039670467377,-34.721416501178226,0.0 ",
				"Polygon Outer Boundary",
				"582",
				"0250016",
				"Lanus",
				"Remedios De Escalada",
				"0016",
				"2014/10/01",
				"Talleres",
				"Villa",
				"90_o_anterior",
				"120",
				"3.2900000000000000000000000000000",
				"Av. Cnel Rosales, 20 de Septiembre, Uriarte",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-57.62170314788818,-38.022410385249124,0.0 -57.62376731727272,-38.020772820245725,0.0 -57.62319600675255,-38.02030161734228,0.0 -57.623131633736186,-38.02032063455849,0.0 -57.622388661839075,-38.02088058371273,0.0 -57.622069478966296,-38.02088058371273,0.0 -57.62144875712693,-38.02037768617751,0.0 -57.62138438411057,-38.02036500804379,0.0 -57.62000799179077,-38.02138770378284,0.0 -57.619002582505345,-38.022144151365545,0.0 -57.61899185366928,-38.02220754047318,0.0 -57.619750499725335,-38.022925946527316,0.0 -57.618986489251256,-38.023487988705966,0.0 -57.618981124833226,-38.02352602147962,0.0 -57.61955511756241,-38.02397396155045,0.0 -57.61960339732469,-38.02397396155045,0.0 -57.62170314788818,-38.022410385249124,0.0 ",
				"Polygon Outer Boundary",
				"1316",
				"0450036",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Las Heras",
				"0036",
				"2015/02/02",
				"Bravo & Tetamanti",
				"Villa",
				"90_o_anterior",
				"600",
				"7.1600000000000001000000000000000",
				"Mario Bravo, Av Visctorio Tetamanti, Federico G Lorca ,E.Peralta Ramos",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.0510356444388,-34.8932334943027,0.0 -58.0520878155844,-34.8962513303139,0.0 -58.0524776830959,-34.896162230832,0.0 -58.0523841679401,-34.8959534519177,0.0 -58.0522977489272,-34.8957406410776,0.0 -58.0523399710633,-34.8955645890823,0.0 -58.0524966451089,-34.8953097979354,0.0 -58.052577305794,-34.8950771261605,0.0 -58.0525893897273,-34.8949190496888,0.0 -58.052550082029,-34.8948152000501,0.0 -58.0524258255074,-34.8947719206566,0.0 -58.0523023812261,-34.894694247606,0.0 -58.0520946378838,-34.8946496296328,0.0 -58.0520374576793,-34.894562800382,0.0 -58.0520136699791,-34.8945196322909,0.0 -58.0520856864772,-34.8943926411261,0.0 -58.0520484507691,-34.8939904454475,0.0 -58.0525658563804,-34.8938684226928,0.0 -58.0522701674726,-34.8930140156499,0.0 -58.0521708641072,-34.8928409217013,0.0 -58.0528580401178,-34.8926808837273,0.0 -58.0529131073521,-34.8926370656893,0.0 -58.0526229433435,-34.891802303909,0.0 -58.0525687954698,-34.8917747600833,0.0 -58.0518904091445,-34.8919298417891,0.0 -58.0518463331443,-34.8917850792699,0.0 -58.0517440229646,-34.8915136143068,0.0 -58.0516446399395,-34.8912432776528,0.0 -58.0506374208625,-34.8914965882523,0.0 -58.0506011653621,-34.8915404366764,0.0 -58.0507670855023,-34.8920128130294,0.0 -58.0507956843478,-34.8921772934177,0.0 -58.0511040323601,-34.893074985504,0.0 -58.0510356444388,-34.8932334943027,0.0 ",
				"Polygon Outer Boundary",
				"316",
				"0550044",
				"La Plata",
				"City Bell/gorina",
				"0044",
				"2014/09/25",
				"Medalla Milagrosa",
				"Villa",
				"decada_1990",
				"135",
				"3.9100000000000001000000000000000",
				"30bis, 132bis, 476, Arroyo Rodriguez",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.374086916446686,-34.66345293049303,0.0 -58.37441146373749,-34.66373090312313,0.0 -58.37474673986436,-34.663971370757174,0.0 -58.37465822696685,-34.664070646182374,0.0 -58.37486743927003,-34.66425375387683,0.0 -58.375221490859985,-34.66400225645775,0.0 -58.37465822696685,-34.6635742678669,0.0 -58.37429344654083,-34.66329629471133,0.0 -58.374086916446686,-34.66345293049303,0.0 ",
				"Polygon Outer Boundary",
				"547",
				"0040038",
				"Avellaneda",
				"Avellaneda",
				"0038",
				"2012/01/01",
				"Díaz Vélez & Mariano Acosta",
				"Villa",
				"90_o_anterior",
				"20",
				"0.3599999999999999900000000000000",
				"Díaz Vélez, Mariano Acosta, Cnel. Bosch,",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.31367862410843,-34.81428337895674,0.0 -58.31638002768159,-34.811204768681776,0.0 -58.31083548255264,-34.80795867018692,0.0 -58.310685278847814,-34.807747250924564,0.0 -58.31037414260208,-34.80748297608393,0.0 -58.31032586283982,-34.80760630444835,0.0 -58.3103956002742,-34.80791462455198,0.0 -58.31043315120041,-34.80861935188606,0.0 -58.31057262606918,-34.80905539890604,0.0 -58.31104469485581,-34.80958393765525,0.0 -58.31127000041306,-34.809896654819006,0.0 -58.31119489856064,-34.81017413525236,0.0 -58.311168076470494,-34.810592556361335,0.0 -58.31149530597031,-34.81112989403779,0.0 -58.3120156545192,-34.81162318455758,0.0 -58.31216585822403,-34.811887446121325,0.0 -58.312139036133885,-34.81247322289955,0.0 -58.31198883242906,-34.81334967812184,0.0 -58.31144702620804,-34.814644524555135,0.0 -58.31195664592087,-34.81493960575921,0.0 -58.31276893615723,-34.815283131799795,0.0 -58.31350696273148,-34.81445954773908,0.0 -58.31367862410843,-34.81428337895674,0.0 ",
				"Polygon Outer Boundary",
				"1542",
				"0320001",
				"Florencio Varela",
				"Gobernador Julio A. Costa",
				"0001",
				"2015/04/17",
				"Lujan",
				"Asentamiento Precario",
				"2013",
				"400",
				"20.0200000000000000000000000000000",
				"Los Olivos, Tynkunako",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.723120093345635,-34.70529936861193,0.0 -58.72431669384241,-34.705775651759915,0.0 -58.725357055664055,-34.70507445617223,0.0 -58.72491180896758,-34.70471283096765,0.0 -58.7258505821228,-34.703945474688,0.0 -58.72542679309845,-34.7035573837446,0.0 -58.72351203113794,-34.705034765678214,0.0 -58.722878694534295,-34.70455847826484,0.0 -58.7224280834198,-34.704986255048574,0.0 -58.723120093345635,-34.70529936861193,0.0 ",
				"Polygon Outer Boundary",
				"2324",
				"0720075",
				"Merlo",
				"Parque San Martín",
				"0075",
				"2015/10/09",
				"Gral. Belgrano II",
				"Asentamiento Precario",
				"90_o_anterior",
				"60",
				"2.7599999999999998000000000000000",
				"Caaguazu, Gabriela Mistral",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.23462026193738,-34.76977989537269,0.0 -58.234765101224184,-34.76959041127809,0.0 -58.233542013913386,-34.76891619690199,0.0 -58.23383169248701,-34.76937448701204,0.0 -58.23462026193738,-34.76977989537269,0.0 ",
				"Polygon Outer Boundary",
				"2295",
				"1200025",
				"Berazategui",
				"Berazategui",
				"0025",
				"2015/10/01",
				"Av. de los Autonomistas & 6",
				"Asentamiento Precario",
				"90_o_anterior",
				"18",
				"0.2899999999999999800000000000000",
				"Av. de los Autonomistas, calle 10, calle 128",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.41387748718261,-34.885772526523326,0.0 -58.4158828575164,-34.883057435171395,0.0 -58.41158151626586,-34.88094954713314,0.0 -58.40959668159485,-34.8836603076114,0.0 -58.41387748718261,-34.885772526523326,0.0 ",
				"Polygon Outer Boundary",
				"2094",
				"0030079",
				"Almirante Brown",
				"Glew",
				"0079",
				"2015/08/11",
				"Caceres & Ugarte",
				"Asentamiento Precario",
				"2010",
				"580",
				"22.9400000000000010000000000000000",
				"San Roque, Blanes, Roger (Cáceres) y Amat",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.41050896793603,-34.880377459632726,0.0 -58.40878162533044,-34.879497317241224,0.0 -58.406732082366936,-34.88226973385945,0.0 -58.408545255661004,-34.88317184925915,0.0 -58.41050896793603,-34.880377459632726,0.0 ",
				"Polygon Outer Boundary",
				"2094",
				"0030079",
				"Almirante Brown",
				"Glew",
				"0079",
				"2015/08/11",
				"Caceres & Ugarte",
				"Asentamiento Precario",
				"2010",
				"580",
				"22.9400000000000010000000000000000",
				"San Roque, Blanes, Roger (Cáceres) y Amat",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.3407661839439,-35.4024983730883,0.0 -57.3407415245213,-35.4024350300106,0.0 -57.3385114543908,-35.4014311792252,0.0 -57.3383109086884,-35.4012719652851,0.0 -57.3382984725185,-35.4012352005103,0.0 -57.3372086100191,-35.4007298490226,0.0 -57.3369600757883,-35.4006145342715,0.0 -57.3358702305546,-35.4001091713772,0.0 -57.3358253282306,-35.4001193527798,0.0 -57.3355997876162,-35.4004454925689,0.0 -57.3363482488795,-35.4014867189502,0.0 -57.3372321366847,-35.4027169851621,0.0 -57.337381371963,-35.403027608562,0.0 -57.3380133735885,-35.4039205643949,0.0 -57.3382222424997,-35.4042250236042,0.0 -57.3388756681795,-35.4051229526405,0.0 -57.338936679304,-35.4051149272974,0.0 -57.3399793198991,-35.4036108917215,0.0 -57.3399793198991,-35.4036108917215,0.0 -57.3407661839439,-35.4024983730883,0.0 ",
				"Polygon Outer Boundary",
				"496",
				"1340001",
				"Punta Indio",
				"Veronica",
				"0001",
				"2014/10/01",
				"La Loma",
				"Otros",
				"1980",
				"90",
				"10.1199999999999990000000000000000",
				"Diagonal 49 e/Circunvalacion 12va y 38",
				"Cobertura Parcial",
				"Sin dato",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.58697652816773,-34.920545922672645,0.0 -58.58582854270935,-34.91993012523559,0.0 -58.585495948791504,-34.92036118392669,0.0 -58.58799576759338,-34.92154878289454,0.0 -58.594454526901245,-34.924909155004535,0.0 -58.59494805335998,-34.92427579696325,0.0 -58.59613895416259,-34.92280673935386,0.0 -58.59758734703063,-34.92387994570496,0.0 -58.5981023311615,-34.92320259578925,0.0 -58.59929323196411,-34.9237567915907,0.0 -58.59979748725891,-34.923167408627876,0.0 -58.59561324119567,-34.92095058704402,0.0 -58.59491586685181,-34.92198863000283,0.0 -58.592480421066284,-34.920194038988676,0.0 -58.59299540519714,-34.91957823891132,0.0 -58.589068651199334,-34.91766043192634,0.0 -58.58817815780639,-34.9188656644837,0.0 -58.5873838871141,-34.9200788817902,0.0 -58.58738505325256,-34.92007740957792,0.0 -58.58738563632179,-34.92007667347176,0.0 -58.58738592785643,-34.92007630541866,0.0 -58.58738607362375,-34.920076121392114,0.0 -58.587386146507406,-34.92007602937885,0.0 -58.587386182949224,-34.92007598337221,0.0 -58.587386201170126,-34.92007596036889,0.0 -58.58738621028059,-34.92007594886726,0.0 -58.58738621483583,-34.92007594311642,0.0 -58.587386217113455,-34.920075940240984,0.0 -58.587386218252256,-34.920075938803286,0.0 -58.58738621882164,-34.92007593808444,0.0 -58.58738621910634,-34.920075937725024,0.0 -58.5873862192487,-34.92007593754531,0.0 -58.58738621931988,-34.920075937455444,0.0 -58.58738621935545,-34.920075937410516,0.0 -58.587386219373236,-34.92007593738806,0.0 -58.58738621938216,-34.920075937376815,0.0 -58.587386219386595,-34.920075937371216,0.0 -58.58738621938884,-34.92007593736841,0.0 -58.587386219389955,-34.920075937366995,0.0 -58.587378859519966,-34.920079676466536,0.0 -58.58738154172897,-34.920079676466536,0.0 -58.58738288283348,-34.920079676466536,0.0 -58.58738355338573,-34.920079676466536,0.0 -58.58738388866187,-34.920079676466536,0.0 -58.58738405629992,-34.920079676466536,0.0 -58.587384140118964,-34.920079676466536,0.0 -58.587384182028465,-34.920079676466536,0.0 -58.58738420298322,-34.920079676466536,0.0 -58.58738422393799,-34.920079676466536,0.0 -58.58738472280126,-34.92007874169131,0.0 -58.58738497223289,-34.920078274303705,0.0 -58.58738509694871,-34.92007804060989,0.0 -58.58738512812768,-34.92007798218643,0.0 -58.58738514371714,-34.92007795297473,0.0 -58.58738515151189,-34.920077938368834,0.0 -58.58738515930661,-34.920077923762996,0.0 -58.58741104602813,-34.92009727071108,0.0 -58.58740568161011,-34.920092872150306,0.0 -58.587403794669164,-34.92009153881629,0.0 -58.58740285119868,-34.92009087214929,0.0 -58.587401907728214,-34.92009020548226,0.0 -58.58739813384633,-34.92008753881415,0.0 -58.587391677755434,-34.920082672865284,0.0 -58.58738522166453,-34.92007780691609,0.0 -58.587385720527806,-34.92007687214084,0.0 -58.587385969959435,-34.92007640475323,0.0 -58.58738609467523,-34.92007617105941,0.0 -58.587386157033144,-34.920076054212494,0.0 -58.587386188212086,-34.920075995789055,0.0 -58.58738620380157,-34.92007596657732,0.0 -58.5873862115963,-34.92007595197147,0.0 -58.58738621549366,-34.920075944668525,0.0 -58.58738621744235,-34.92007594101706,0.0 -58.5873862184167,-34.920075939191314,0.0 -58.58738621890385,-34.92007593827848,0.0 -58.58738621914746,-34.920075937822034,0.0 -58.58738621926925,-34.9200759375938,0.0 -58.58738621933016,-34.920075937479695,0.0 -58.58738621936062,-34.92007593742263,0.0 -58.587386219375844,-34.920075937394095,0.0 -58.58738621938343,-34.92007593737985,0.0 -58.587386219387234,-34.92007593737273,0.0 -58.58738621938915,-34.920075937369155,0.0 -58.58738621939011,-34.92007593736736,0.0 -58.587386219390595,-34.920075937366484,0.0 -58.58738621939084,-34.92007593736605,0.0 -58.58738621939095,-34.920075937365844,0.0 -58.587386219390986,-34.920075937365716,0.0 -58.58738621939103,-34.920075937365645,0.0 -58.58738621939103,-34.92007593736562,0.0 -58.58738621939103,-34.92007593736559,0.0 -58.58738621939103,-34.92007593736559,0.0 -58.58738621939103,-34.92007593736559,0.0 -58.58738621939103,-34.92007593736559,0.0 -58.58738621939103,-34.92007593736559,0.0 -58.58738621939103,-34.92007593736559,0.0 -58.58738621939103,-34.92007593736559,0.0 -58.58738621939103,-34.92007593736559,0.0 -58.58738621939103,-34.92007593736559,0.0 -58.58738621939103,-34.92007593736559,0.0 -58.58738621939105,-34.92007593736559,0.0 -58.587388551668,-34.9200729929408,0.0 -58.58697652816773,-34.920545922672645,0.0 ",
				"Polygon Outer Boundary",
				"1137",
				"1300006",
				"Ezeiza",
				"Carlos Spegazzini",
				"0006",
				"2014/10/01",
				"La Flecha",
				"Otros",
				"90_o_anterior",
				"300",
				"37.4600000000000010000000000000000",
				"25 de Mayo - Bermudez- Riachuelo",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.57545423693955,-38.05469780210667,0.0 -57.574043394997716,-38.05351505455858,0.0 -57.57397365756332,-38.05352350282312,0.0 -57.57366788573563,-38.053781174423264,0.0 -57.57330691907555,-38.05402828485981,0.0 -57.57332837674767,-38.05405996562467,0.0 -57.57364755962044,-38.05431129920668,0.0 -57.57398820016533,-38.05404940537124,0.0 -57.57432079408317,-38.05431552329313,0.0 -57.57436370942741,-38.05452883934137,0.0 -57.57468825671821,-38.0548034036369,0.0 -57.574465633369975,-38.054982925888616,0.0 -57.57431274745613,-38.05510753519268,0.0 -57.57389432284981,-38.05541377749619,0.0 -57.574224234558635,-38.055698898488956,0.0 -57.57546341512352,-38.0547463788295,0.0 -57.57545423693955,-38.05469780210667,0.0 ",
				"Polygon Outer Boundary",
				"1322",
				"0450042",
				"General Pueyrredon",
				"Mar Del Plata",
				"0042",
				"2015/02/02",
				"Lanzilota &  García Lorca",
				"Villa",
				"90_o_anterior",
				"100",
				"1.5400000000000000000000000000000",
				"Jose Lanzilota, Federico García Lorca, W. Morris",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.49375355243682,-35.11051808427389,0.0 -60.494789220392704,-35.110219677235115,0.0 -60.49440264701844,-35.10933322635221,0.0 -60.493737459182746,-35.10950876194615,0.0 -60.49354434013367,-35.10904359179562,0.0 -60.49309372901917,-35.1091840208001,0.0 -60.493319034576416,-35.10964041339348,0.0 -60.49375355243682,-35.11051808427389,0.0 ",
				"Polygon Outer Boundary",
				"2144",
				"0120001",
				"Bragado",
				"Bragado",
				"0001",
				"2015/09/02",
				"Fátima",
				"Otros",
				"90_o_anterior",
				"70",
				"1.3100000000000001000000000000000",
				"Lamadrid, Catamarca, Chacabuco",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.40713977813721,-34.88663500030195,0.0 -58.40450081974268,-34.88537648961274,0.0 -58.40323481708765,-34.8870310311472,0.0 -58.40589556843042,-34.88836872122348,0.0 -58.40713977813721,-34.88663500030195,0.0 ",
				"Polygon Outer Boundary",
				"2130",
				"0030094",
				"Almirante Brown",
				"Almirante Brown",
				"0094",
				"2015/08/27",
				"Nuevo Sol II",
				"Asentamiento Precario",
				"2013",
				"85",
				"6.2199999999999998000000000000000",
				"Amat, Gaito, Pcia de Santa Fé y Miller",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.3335667848587,-34.76596368999535,0.0 -58.332826495170586,-34.76561995844727,0.0 -58.332306146621704,-34.76615318241622,0.0 -58.332011103630066,-34.766091487257185,0.0 -58.331217169761665,-34.765686060779224,0.0 -58.33040714263915,-34.76530266651702,0.0 -58.329967260360725,-34.76586233340562,0.0 -58.32936644554138,-34.765558262889684,0.0 -58.32870662212372,-34.765205715961734,0.0 -58.327676653862,-34.7665409795028,0.0 -58.32668960094452,-34.7678541879235,0.0 -58.32908213138581,-34.769193815253296,0.0 -58.32973122596741,-34.76852400430634,0.0 -58.33026766777038,-34.768052489392744,0.0 -58.33145320415496,-34.76860332430749,0.0 -58.33300888538361,-34.76660708109717,0.0 -58.3335667848587,-34.76596368999535,0.0 ",
				"Polygon Outer Boundary",
				"1275",
				"0030004",
				"Almirante Brown",
				"San José",
				"0004",
				"2014/10/01",
				"La Victoria",
				"Asentamiento Precario",
				"1989",
				"463",
				"15.1999999999999990000000000000000",
				"Jorge Bynon, Donato Alvarez, Sargento Jorge Bynon, El Zorzal",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.88697886466979,-36.77762447360346,0.0 -59.885568860918276,-36.77636122974898,0.0 -59.884581808000796,-36.776997151026194,0.0 -59.885337352752686,-36.77763306702778,0.0 -59.884441494941704,-36.77828186778143,0.0 -59.88516116514801,-36.778879103355855,0.0 -59.88697886466979,-36.77762447360346,0.0 ",
				"Polygon Outer Boundary",
				"1631",
				"0060001",
				"Azul",
				"Azul",
				"0001",
				"2015/04/29",
				"San Francisco de Asis",
				"Asentamiento Precario",
				"decada_2000",
				"24",
				"3.1000000000000001000000000000000",
				"Mendoza, Quiroga, Sargento Cabral y  Miñana",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.84518242068589,-36.75230406381349,0.0 -59.845000030472875,-36.7523255544671,0.0 -59.843267323449254,-36.75355051177215,0.0 -59.84398615546525,-36.754190920261856,0.0 -59.84535408206283,-36.75326683918908,0.0 -59.84518242068589,-36.75230406381349,0.0 ",
				"Polygon Outer Boundary",
				"1632",
				"0060002",
				"Azul",
				"Azul",
				"0002",
				"2015/04/29",
				"Hipódromo",
				"Asentamiento Precario",
				"decada_2000",
				"15",
				"1.8799999999999999000000000000000",
				"Las Flores Norte  y S/N",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.928714994341135,-34.947258284923635,0.0 -57.93075347319245,-34.945780844508604,0.0 -57.92970657348633,-34.94483984179487,0.0 -57.92961001396179,-34.94487501966072,0.0 -57.92873561382294,-34.94552580745677,0.0 -57.92738914489746,-34.944349548718485,0.0 -57.92689025402069,-34.94473870534646,0.0 -57.927051186561584,-34.944866225195675,0.0 -57.9265477694571,-34.94528835845401,0.0 -57.928714994341135,-34.947258284923635,0.0 ",
				"Polygon Outer Boundary",
				"1629",
				"0550135",
				"La Plata",
				"La Plata",
				"0135",
				"2015/04/28",
				"16 & 80",
				"Asentamiento Precario",
				"90_o_anterior",
				"225",
				"5.7000000000000002000000000000000",
				"15,17,79 y 81",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-60.28853547759354,-36.8802299229153,0.0 -60.28857839293778,-36.8801269399516,0.0 -60.28828871436417,-36.88004970263769,0.0 -60.28752696700394,-36.87997675621393,0.0 -60.28685105033218,-36.88002824781441,0.0 -60.28575134463608,-36.88063327151928,0.0 -60.28629851527512,-36.88115247243711,0.0 -60.28762889094651,-36.88010548515002,0.0 -60.288143875077374,-36.88052170722493,0.0 -60.28853547759354,-36.8802299229153,0.0 ",
				"Polygon Outer Boundary",
				"1635",
				"0780002",
				"Olavarria",
				"Olavarria",
				"0002",
				"2015/04/29",
				"Francisco Moreno",
				"Asentamiento Precario",
				"decada_1990",
				"20",
				"1.2300000000000000000000000000000",
				"Francisco Moreno,  Urquiza y vías del FFRR",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.296350009739406,-36.88246976801633,0.0 -60.29482651501894,-36.881388471687345,0.0 -60.29356051236391,-36.8809765452488,0.0 -60.29295969754457,-36.881045199809535,0.0 -60.291929729282856,-36.88217799115023,0.0 -60.29190827161074,-36.88272721726642,0.0 -60.29259491711854,-36.883413744356425,0.0 -60.29364634305238,-36.884392034794665,0.0 -60.29386091977358,-36.884426360547344,0.0 -60.296350009739406,-36.88246976801633,0.0 ",
				"Polygon Outer Boundary",
				"1634",
				"0780001",
				"Olavarria",
				"Olavarria",
				"0001",
				"2015/04/29",
				"Eucaliptus",
				"Otros",
				"90_o_anterior",
				"50",
				"8.9100000000000001000000000000000",
				"Amparo Castro, Saavedra y Ruta 226",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.28436422348022,-36.90861359679421,0.0 -60.281548742204905,-36.91090407986513,0.0 -60.28213882818818,-36.911547461613615,0.0 -60.28234720230102,-36.91162466705876,0.0 -60.28273964300752,-36.911127119485805,0.0 -60.28438568115234,-36.909986179177075,0.0 -60.2847888506949,-36.91032074238934,0.0 -60.28566241264343,-36.909668771696246,0.0 -60.28436422348022,-36.90861359679421,0.0 ",
				"Polygon Outer Boundary",
				"1636",
				"0780003",
				"Olavarria",
				"Olavarria",
				"0003",
				"2015/04/29",
				"Cirunvalación & Moreno",
				"Otros",
				"decada_1990",
				"10",
				"4.3200000000000003000000000000000",
				"Sarmiento y Av. Cirunvalación",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.5613315086979,-34.4275224509584,0.0 -58.5610416389947,-34.4269641439149,0.0 -58.5614610654676,-34.426594665547,0.0 -58.5607769513796,-34.4257314349557,0.0 -58.5603778897245,-34.4256071551784,0.0 -58.5594629648225,-34.4255839422098,0.0 -58.5591519521585,-34.4256528352116,0.0 -58.5593184517091,-34.4265478124414,0.0 -58.5594197204878,-34.4273192305806,0.0 -58.5596796100866,-34.427874847339,0.0 -58.560279827679,-34.4290093461983,0.0 -58.5604041430328,-34.429222900318,0.0 -58.5606566980683,-34.4294212212125,0.0 -58.5609170440356,-34.4295582393068,0.0 -58.5613938434727,-34.4296419868605,0.0 -58.5617499040752,-34.4296964085569,0.0 -58.56203198432922,-34.429770670158526,0.0 -58.5623634949796,-34.4296589733259,0.0 -58.5613315086979,-34.4275224509584,0.0 -58.5613315086979,-34.4275224509584,0.0 ",
				"Polygon Outer Boundary",
				"715",
				"0570001",
				"Tigre",
				"Tigre",
				"0001",
				"2014/10/01",
				"El Garrote",
				"Villa",
				"90_o_anterior",
				"700",
				"7.4000000000000004000000000000000",
				"Ate. Brow, Canal San Fernando, Tren de la Costa, Italia",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.73216986656189,-38.54792208777901,0.0 -58.73257529921829,-38.54760323342333,0.0 -58.73277068138122,-38.5474354147735,0.0 -58.73195839114487,-38.54677672278747,0.0 -58.73165261931718,-38.54655436043634,0.0 -58.731311559677124,-38.54711655825982,0.0 -58.73216986656189,-38.54792208777901,0.0 ",
				"Polygon Outer Boundary",
				"1463",
				"0760001",
				"Necochea",
				"Necochea",
				"0001",
				"2015/03/18",
				"La Terminal",
				"Asentamiento Precario",
				"decada_1980",
				"30",
				"1.7800000000000000000000000000000",
				"avenida 43 - ruta 86 - calle 62 - avenida 58",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.73328876681626,-38.54704523489878,0.0 -58.73358380980789,-38.546810286856214,0.0 -58.73292088508606,-38.54573622888602,0.0 -58.73265266418458,-38.54572364217408,0.0 -58.732604384422295,-38.545811749111365,0.0 -58.732733130455024,-38.546151589144,0.0 -58.73289406299592,-38.546428494649824,0.0 -58.73328876681626,-38.54704523489878,0.0 ",
				"Polygon Outer Boundary",
				"1463",
				"0760001",
				"Necochea",
				"Necochea",
				"0001",
				"2015/03/18",
				"La Terminal",
				"Asentamiento Precario",
				"decada_1980",
				"30",
				"1.7800000000000000000000000000000",
				"avenida 43 - ruta 86 - calle 62 - avenida 58",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.73223423957825,-38.54513625983352,0.0 -58.73189401812851,-38.544527894494465,0.0 -58.73144030570983,-38.54498102227055,0.0 -58.73203349299728,-38.54556001471845,0.0 -58.73223423957825,-38.54513625983352,0.0 ",
				"Polygon Outer Boundary",
				"1463",
				"0760001",
				"Necochea",
				"Necochea",
				"0001",
				"2015/03/18",
				"La Terminal",
				"Asentamiento Precario",
				"decada_1980",
				"30",
				"1.7800000000000000000000000000000",
				"avenida 43 - ruta 86 - calle 62 - avenida 58",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.57313525769859,-38.05393113042872,0.0 -57.573870182968676,-38.05339466668288,0.0 -57.57386750075966,-38.053356649417836,0.0 -57.573245228268206,-38.052832853978174,0.0 -57.57319963071496,-38.052822293547706,0.0 -57.573145986534655,-38.05265543854396,0.0 -57.57245934102684,-38.05209150805801,0.0 -57.57267659995705,-38.0517092156322,0.0 -57.57185161113738,-38.05104389532355,0.0 -57.57227695081383,-38.050718625416245,0.0 -57.572293044067926,-38.05067004602033,0.0 -57.57222598884254,-38.05061090584263,0.0 -57.57168954703957,-38.050517971181186,0.0 -57.571649313904345,-38.05054542916162,0.0 -57.57174319121986,-38.05109036233518,0.0 -57.571775377728045,-38.05109669874357,0.0 -57.571796835400164,-38.05128467860968,0.0 -57.57176733110099,-38.051333257597705,0.0 -57.57196962833404,-38.05172400045926,0.0 -57.572142840363085,-38.052076723305184,0.0 -57.57194167468697,-38.052480134775884,0.0 -57.571528614498675,-38.052811733115696,0.0 -57.572200298309326,-38.05335876148863,0.0 -57.57234668824821,-38.053267942389276,0.0 -57.572735608555384,-38.0532130284606,0.0 -57.57313525769859,-38.05393113042872,0.0 ",
				"Polygon Outer Boundary",
				"1323",
				"0450043",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Juramento",
				"0043",
				"2015/02/02",
				"Diagonal Canata",
				"Villa",
				"90_o_anterior",
				"150",
				"2.5200000000000000000000000000000",
				"Diag. Canata, W. Morris, Genova",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.2548446841,-34.7594669591083,0.0 -58.2537740400144,-34.7589423871762,0.0 -58.25240850448608,-34.75755066952942,0.0 -58.2489408939499,-34.7621579912755,0.0 -58.2496345791442,-34.7625793185097,0.0 -58.2503669474418,-34.7629725268061,0.0 -58.2513375310936,-34.7634943395969,0.0 -58.2538143969047,-34.7607159381562,0.0 -58.2548691741033,-34.7595797889016,0.0 -58.2548446841,-34.7594669591083,0.0 ",
				"Polygon Outer Boundary",
				"917",
				"0860031",
				"Quilmes",
				"Quilmes",
				"0031",
				"2014/10/01",
				"La Resistencia",
				"Asentamiento Precario",
				"90_o_anterior",
				"568",
				"16.2399999999999980000000000000000",
				"de Rca. De Francia a Fcio. Varela y de Calle 476 Concordia a Calle 477 Paso de los Libres, Calle 478 Posadas a Av. La Plata",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.276546556151,-37.8479245772417,0.0 -58.2761694319713,-37.8476249278772,0.0 -58.2759810605275,-37.8477572070687,0.0 -58.2750415572112,-37.8485024119862,0.0 -58.2742385029679,-37.8491393453138,0.0 -58.274640181564,-37.8494578281042,0.0 -58.2763827416782,-37.848075593929,0.0 -58.276546556151,-37.8479245772417,0.0 ",
				"Polygon Outer Boundary",
				"494",
				"0080006",
				"Balcarce",
				"Balcarce",
				"0006",
				"2014/10/10",
				"39 & 2",
				"Asentamiento Precario",
				"2000",
				"16",
				"2.1899999999999999000000000000000",
				"39 e/2 y Chacabuco",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.27445936389267,-37.849590731902275,0.0 -58.27405703254043,-37.849247625272085,0.0 -58.27325236983598,-37.8498787708035,0.0 -58.273686887696385,-37.85021763865844,0.0 -58.27445936389267,-37.849590731902275,0.0 ",
				"Polygon Outer Boundary",
				"494",
				"0080006",
				"Balcarce",
				"Balcarce",
				"0006",
				"2014/10/10",
				"39 & 2",
				"Asentamiento Precario",
				"2000",
				"16",
				"2.1899999999999999000000000000000",
				"39 e/2 y Chacabuco",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.27351522631944,-37.850306591212295,0.0 -58.27314508147537,-37.84999737472988,0.0 -58.27233505435288,-37.85063274965828,0.0 -58.272721292451024,-37.85094619927277,0.0 -58.27351522631944,-37.850306591212295,0.0 ",
				"Polygon Outer Boundary",
				"494",
				"0080006",
				"Balcarce",
				"Balcarce",
				"0006",
				"2014/10/10",
				"39 & 2",
				"Asentamiento Precario",
				"2000",
				"16",
				"2.1899999999999999000000000000000",
				"39 e/2 y Chacabuco",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.2496274728328,-34.76259241491198,0.0 -58.248704792931676,-34.76372940934684,0.0 -58.24941826052963,-34.76414365924097,0.0 -58.25035166926682,-34.76298022872705,0.0 -58.2496274728328,-34.76259241491198,0.0 ",
				"Polygon Outer Boundary",
				"1461",
				"0860076",
				"Quilmes",
				"Quilmes",
				"0076",
				"2015/03/17",
				"3 de Marzo",
				"Asentamiento Precario",
				"2002",
				"30",
				"1.2200000000000000000000000000000",
				"Fcio. Varela, Cuba y Avda La Plata",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.44066825946357,-35.02998199306841,0.0 -58.4406038864472,-35.030039097671335,0.0 -58.43994942744757,-35.030557429934824,0.0 -58.439407621226565,-35.03094398066953,0.0 -58.43827572902228,-35.031791750311136,0.0 -58.43734232028509,-35.032494557855,0.0 -58.437460337481745,-35.03261315603205,0.0 -58.438248906932124,-35.03202894853284,0.0 -58.43881217082525,-35.03159408460052,0.0 -58.440373216471926,-35.03037733180914,0.0 -58.440743361315974,-35.030056668310365,0.0 -58.44066825946357,-35.02998199306841,0.0 ",
				"Polygon Outer Boundary",
				"1993",
				"1000020",
				"San Vicente",
				"San Vicente",
				"0020",
				"2015/07/28",
				"Hospital",
				"Otros",
				"90_o_anterior",
				"30",
				"1.8000000000000000000000000000000",
				"S/n, Laprida,Blandengues y Laferrere",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.440217648349055,-35.02820294507208,0.0 -58.44018009742285,-35.02821612334774,0.0 -58.439960156283625,-35.02881792900544,0.0 -58.43996552070166,-35.02884428535633,0.0 -58.44154802402044,-35.02927037851642,0.0 -58.44182160933997,-35.02861147062946,0.0 -58.440217648349055,-35.02820294507208,0.0 ",
				"Polygon Outer Boundary",
				"1993",
				"1000020",
				"San Vicente",
				"San Vicente",
				"0020",
				"2015/07/28",
				"Hospital",
				"Otros",
				"90_o_anterior",
				"30",
				"1.8000000000000000000000000000000",
				"S/n, Laprida,Blandengues y Laferrere",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.55048823542892,-37.94478552868251,0.0 -57.549157859757536,-37.94364754231789,0.0 -57.549061300233014,-37.943579854841296,0.0 -57.547333957627416,-37.944865906235215,0.0 -57.54672241397201,-37.94533547860175,0.0 -57.546658040955656,-37.94538201263682,0.0 -57.54729640670121,-37.9458938850775,0.0 -57.54813170526177,-37.946585541760555,0.0 -57.548163891769946,-37.94659400235245,0.0 -57.54940998740494,-37.94564429482874,0.0 -57.54954409785568,-37.945741592823154,0.0 -57.54953336901963,-37.94579235694301,0.0 -57.55003762431443,-37.94620692927575,0.0 -57.5501234550029,-37.946219620228625,0.0 -57.5504667777568,-37.94613078351244,0.0 -57.55069744773209,-37.94600387373156,0.0 -57.55071354098619,-37.94596580075457,0.0 -57.55005371756852,-37.945411625189244,0.0 -57.549871327355504,-37.945314326757895,0.0 -57.54986596293747,-37.94525933193536,0.0 -57.55000007338822,-37.945178954812995,0.0 -57.55004298873245,-37.945178954812995,0.0 -57.55050969310104,-37.94484475425619,0.0 -57.55048823542892,-37.94478552868251,0.0 ",
				"Polygon Outer Boundary",
				"1330",
				"0450049",
				"General Pueyrredon",
				"Mar Del Plata",
				"0049",
				"2015/02/03",
				"Anchorena & Urquia Serapio",
				"Asentamiento Precario",
				"90_o_anterior",
				"110",
				"6.0599999999999996000000000000000",
				"Tomas Manuel Anchorena, Urquia Serapio,E. S. Zeballos, Daglio Cayetano",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7838117759771,-34.6809254434012,0.0 -58.7881612795565,-34.6779934719464,0.0 -58.7897930226419,-34.6768521588474,0.0 -58.7900580347124,-34.676710301938,0.0 -58.7926763993974,-34.6748452124033,0.0 -58.7928270664595,-34.6746967408199,0.0 -58.7942865315923,-34.6736883901452,0.0 -58.7942752313935,-34.6736324841218,0.0 -58.7934549420905,-34.6732824808062,0.0 -58.7930576294869,-34.6729413481496,0.0 -58.7917036882069,-34.6721363588633,0.0 -58.7907115372619,-34.6713782179368,0.0 -58.7895888344059,-34.6711490271888,0.0 -58.7885457264892,-34.6708945759605,0.0 -58.787525616699,-34.6704998225161,0.0 -58.7870916482074,-34.6704380883569,0.0 -58.7859136322371,-34.6697927944023,0.0 -58.7855799886414,-34.6695401544782,0.0 -58.7853932795944,-34.6693039404437,0.0 -58.7849405920201,-34.6689482587946,0.0 -58.7846243484385,-34.6686998458549,0.0 -58.7842353377384,-34.6685635566914,0.0 -58.7831841083075,-34.6680770589606,0.0 -58.7823255173477,-34.6676153713018,0.0 -58.7821532786617,-34.6674423921543,0.0 -58.7810905711792,-34.6668401173608,0.0 -58.7805878413573,-34.6664248802486,0.0 -58.780285932142,-34.6662188355505,0.0 -58.7801489521333,-34.6661052833404,0.0 -58.7797564777585,-34.6660279844728,0.0 -58.7790460887028,-34.6659891433469,0.0 -58.7780290752624,-34.6664456768495,0.0 -58.7778341359134,-34.6662889590137,0.0 -58.7770734097481,-34.6659636001672,0.0 -58.7768466659425,-34.6658778592708,0.0 -58.7755846770579,-34.6654851764899,0.0 -58.7749456140551,-34.6653518443387,0.0 -58.7744335600169,-34.6652242926471,0.0 -58.7741897373615,-34.6651355809246,0.0 -58.7730740631574,-34.6650241256098,0.0 -58.7724648020496,-34.6649417368793,0.0 -58.7723107627519,-34.6649714627903,0.0 -58.7713063835431,-34.6656790056632,0.0 -58.7713336566475,-34.6659376101381,0.0 -58.7733553916232,-34.6666239856898,0.0 -58.7735371295309,-34.6668838735647,0.0 -58.7728239094671,-34.6673992134668,0.0 -58.77262751474,-34.6675044077513,0.0 -58.7718433051095,-34.6680538193854,0.0 -58.7716915609885,-34.6681789313421,0.0 -58.7709202862055,-34.6687233294338,0.0 -58.7707337889753,-34.6688818906854,0.0 -58.7700329422834,-34.6693770579183,0.0 -58.7700309765238,-34.6694214750639,0.0 -58.771491050720215,-34.67108801428448,0.0 -58.7732357235846,-34.6725134329226,0.0 -58.7758282047711,-34.6706514209268,0.0 -58.7759753032114,-34.6706565937348,0.0 -58.7766956451314,-34.6713270453122,0.0 -58.7748994050194,-34.6726323799701,0.0 -58.7756449131702,-34.673320667086,0.0 -58.7758571210143,-34.6735280379112,0.0 -58.7773809161373,-34.6749489111931,0.0 -58.7775068242168,-34.6749488220635,0.0 -58.7791491371278,-34.6737694501796,0.0 -58.779443553973,-34.6738176470065,0.0 -58.78103247516,-34.6754856804022,0.0 -58.7795485096875,-34.6766065110975,0.0 -58.7811181508694,-34.6780489792656,0.0 -58.7838117759771,-34.6809254434012,0.0 ",
				"Polygon Outer Boundary",
				"628",
				"0720034",
				"Merlo",
				"Merlo",
				"0034",
				"2014/10/01",
				"20 de Junio",
				"Otros",
				"90_o_anterior",
				"900",
				"175.2200000000000000000000000000000",
				"Ricardo Rojas, Camino de la Ribera, Burela, Aconcagua",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.2988429069519,-34.79674829678142,0.0 -58.30093201249838,-34.79409634698998,0.0 -58.300897479057305,-34.79366462616037,0.0 -58.30068826675415,-34.793118363912,0.0 -58.30057561397552,-34.79262055725996,0.0 -58.30044150352478,-34.79211834219408,0.0 -58.30045223236083,-34.79191128772382,0.0 -58.300677537918084,-34.79154563707046,0.0 -58.30083847045898,-34.791144741117364,0.0 -58.300849199295044,-34.79074824869737,0.0 -58.30081701278686,-34.79045748637781,0.0 -58.30069363117217,-34.79037378188366,0.0 -58.30048978328705,-34.79021518366173,0.0 -58.30023229122161,-34.79008742376114,0.0 -58.300167918205254,-34.79018434508317,0.0 -58.300302028656006,-34.79027245527706,0.0 -58.30052196979523,-34.79064251706343,0.0 -58.298091888427734,-34.79384964964982,0.0 -58.2982474565506,-34.79390691874101,0.0 -58.29689562320709,-34.79571307736111,0.0 -58.2988429069519,-34.79674829678142,0.0 ",
				"Polygon Outer Boundary",
				"1590",
				"0320028",
				"Florencio Varela",
				"San Juan Bautista",
				"0028",
				"2015/04/22",
				"El Molino II",
				"Asentamiento Precario",
				"decada_2000",
				"350",
				"11.4100000000000000000000000000000",
				"Cosme Argerich, Calle 54D, Pedro Agrelo",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.91342282295227,-34.43830101472717,0.0 -58.912717821076505,-34.43793822734477,0.0 -58.912084819749,-34.438747860435775,0.0 -58.912816643714905,-34.4391194926703,0.0 -58.91342282295227,-34.43830101472717,0.0 ",
				"Polygon Outer Boundary",
				"2075",
				"0840039",
				"Pilar",
				"Pilar",
				"0039",
				"2015/08/06",
				"Nicaragua & La Garza",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"0.8299999999999999600000000000000",
				"Nicaragua, Cuba y Perú",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.763756428561464,-34.41064381578732,0.0 -58.76053864638379,-34.412094222764345,0.0 -58.75892932097486,-34.412775764526906,0.0 -58.758015632629395,-34.41318533057457,0.0 -58.75756675879529,-34.413333385474566,0.0 -58.75716979186108,-34.41351925829762,0.0 -58.75543172041944,-34.41421849045584,0.0 -58.75486309210828,-34.41446631817202,0.0 -58.754809447927975,-34.41462563560177,0.0 -58.754551955862546,-34.41443091425753,0.0 -58.75369364897779,-34.41479380367059,0.0 -58.75220234076551,-34.415262902285825,0.0 -58.75120455901196,-34.41574084911215,0.0 -58.751998492880375,-34.41613913604754,0.0 -58.75419790427259,-34.41744904414549,0.0 -58.75726635138562,-34.41911295187289,0.0 -58.757352182074094,-34.41898019449306,0.0 -58.75878361304785,-34.41699886609669,0.0 -58.75942734321143,-34.4162067239146,0.0 -58.76106885512854,-34.41410905977128,0.0 -58.76267281611944,-34.41203347110272,0.0 -58.763756428561464,-34.41064381578732,0.0 ",
				"Polygon Outer Boundary",
				"2076",
				"1180010",
				"Escobar",
				"Maquinista Savio-garín",
				"0010",
				"2015/08/06",
				"Ovejero Chico",
				"Asentamiento Precario",
				"90_o_anterior",
				"570",
				"35.7299999999999970000000000000000",
				"Juan Beleira, Uruguay,Cesar Oliveira, Estados Unidos",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.43435883522034,-34.69262393752047,0.0 -58.434380292892456,-34.69267686611263,0.0 -58.43475580215454,-34.692174043120616,0.0 -58.43282461166382,-34.69120367432511,0.0 -58.4307861328125,-34.6902862242744,0.0 -58.43056082725524,-34.69081552362159,0.0 -58.430238962173455,-34.691265425405575,0.0 -58.42998147010803,-34.69157418011686,0.0 -58.430625200271606,-34.69187411216217,0.0 -58.430185317993164,-34.69268568754136,0.0 -58.42952013015747,-34.69358546833345,0.0 -58.42886567115783,-34.69327672112481,0.0 -58.428168296813965,-34.694255886877876,0.0 -58.42748165130616,-34.693955963463516,0.0 -58.427181243896484,-34.69440584817747,0.0 -58.42752456665039,-34.695208577572764,0.0 -58.42840433120727,-34.69556142319526,0.0 -58.42960596084595,-34.69620536257832,0.0 -58.43057155609131,-34.69667287707318,0.0 -58.431086540222175,-34.69687575990013,0.0 -58.4312726429403,-34.6968504373265,0.0 -58.4313175887259,-34.6968396595292,0.0 -58.4320306777954,-34.6960906888083,0.0 -58.43327522277831,-34.6942647081383,0.0 -58.43435883522034,-34.69262393752047,0.0 ",
				"Polygon Outer Boundary",
				"592",
				"0250026",
				"Lanus",
				"Lanús Oeste",
				"0026",
				"2014/10/01",
				"San Jose Obrero",
				"Villa",
				"90_o_anterior",
				"2000",
				"24.4200000000000020000000000000000",
				"Humauaca, Gral Olazabal, Grecia y Boquerón",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.632842302322395,-34.7319934533714,0.0 -58.62801432609558,-34.72782279515356,0.0 -58.62643718719483,-34.72902199116519,0.0 -58.63128662109374,-34.73321904019497,0.0 -58.632842302322395,-34.7319934533714,0.0 ",
				"Polygon Outer Boundary",
				"1465",
				"0700128",
				"La Matanza",
				"Rafael Castillo",
				"0128",
				"2015/03/18",
				"17 de Octubre",
				"Asentamiento Precario",
				"90_o_anterior",
				"550",
				"12.6500000000000000000000000000000",
				"Gamboa, Larsen, Río Cuarto y Da Vinci",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.303853273391724,-34.77018970832192,0.0 -58.30215275287628,-34.77082865993561,0.0 -58.301766514778144,-34.77096085620357,0.0 -58.2995456457138,-34.77252956908385,0.0 -58.29941153526306,-34.772833613916866,0.0 -58.29928815364837,-34.773706084174705,0.0 -58.2993471622467,-34.77434941492074,0.0 -58.29921305179596,-34.774582951553455,0.0 -58.29979240894318,-34.77505883547631,0.0 -58.30047369003295,-34.775724187100614,0.0 -58.30070972442627,-34.77597975119902,0.0 -58.301063776016235,-34.77751752535535,0.0 -58.30117106437683,-34.779094925799846,0.0 -58.301085233688354,-34.77986599046178,0.0 -58.301047682762146,-34.77999376619541,0.0 -58.2998138666153,-34.781333196457894,0.0 -58.29952418804168,-34.781584337211044,0.0 -58.298606872558594,-34.78229369555957,0.0 -58.29825282096863,-34.7828576531239,0.0 -58.29808115959168,-34.783170471672925,0.0 -58.29888582229615,-34.78352294185609,0.0 -58.29944372177123,-34.78275191137428,0.0 -58.301020860672004,-34.7810820549402,0.0 -58.30200254917144,-34.779976141968056,0.0 -58.30208301544189,-34.779628062706294,0.0 -58.302297592163086,-34.77932404290906,0.0 -58.302050828933716,-34.7792447332125,0.0 -58.30208301544189,-34.778182857153325,0.0 -58.302142024040215,-34.77703724939864,0.0 -58.30226004123688,-34.776825750842995,0.0 -58.30126225948333,-34.77554793553708,0.0 -58.301358819007866,-34.77539371511014,0.0 -58.30085456371307,-34.775085273391554,0.0 -58.300607800483704,-34.77482530019045,0.0 -58.30016255378723,-34.77427891316587,0.0 -58.30036640167236,-34.77394402900772,0.0 -58.29999625682831,-34.773706084174705,0.0 -58.30018401145935,-34.77286005254506,0.0 -58.300918936729424,-34.7724458463969,0.0 -58.301643133163445,-34.77202282520609,0.0 -58.3021205663681,-34.77156014329575,0.0 -58.302029371261604,-34.77147201311396,0.0 -58.3026248216629,-34.77134422418318,0.0 -58.303129076957696,-34.771167963264304,0.0 -58.304663300514214,-34.77057307988377,0.0 -58.30487251281738,-34.77022496095368,0.0 -58.30494761466979,-34.769907686725745,0.0 -58.30482959747315,-34.76924669483337,0.0 -58.3049245121437,-34.7689639331119,0.0 -58.3067474176224,-34.7667703097181,0.0 -58.307071005512,-34.7664435917429,0.0 -58.3059244983249,-34.7658335078007,0.0 -58.3058527107955,-34.7650499921131,0.0 -58.305684563788,-34.7646853755514,0.0 -58.3053844751453,-34.7643892605801,0.0 -58.3043910294369,-34.7636950681204,0.0 -58.3042509986117,-34.7633756169918,0.0 -58.3034183809421,-34.7630163231754,0.0 -58.3034133408946,-34.7632626007166,0.0 -58.3037870915794,-34.7638764332415,0.0 -58.3050815364409,-34.7648688530906,0.0 -58.3052653957307,-34.7657331999762,0.0 -58.3046838463688,-34.767020475413,0.0 -58.3041862321882,-34.7678164136621,0.0 -58.304051756858826,-34.76799079565336,0.0 -58.304046392440796,-34.768237570334186,0.0 -58.304046392440796,-34.76848875094803,0.0 -58.30401420593262,-34.76889416365952,0.0 -58.30394983291626,-34.7700090383478,0.0 -58.303853273391724,-34.77018970832192,0.0 ",
				"Polygon Outer Boundary",
				"927",
				"0860021",
				"Quilmes",
				"San Francisco Solano",
				"0021",
				"2014/10/01",
				"Arroyo Las Piedras I",
				"Villa",
				"90_o_anterior",
				"380",
				"22.9400000000000010000000000000000",
				"Arroyo Las Piedras entre Av. Monteverde y Av. San Martín (2,5 km.)",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.74705386348069,-38.54375589244839,0.0 -58.747091414406896,-38.54375589244839,0.0 -58.7478853482753,-38.54315171115345,0.0 -58.747874619439244,-38.54311814537713,0.0 -58.74712360091508,-38.54251815448269,0.0 -58.747075321152806,-38.54252235024059,0.0 -58.74631357379257,-38.5431097539306,0.0 -58.74631357379257,-38.54315171115345,0.0 -58.74705386348069,-38.54375589244839,0.0 ",
				"Polygon Outer Boundary",
				"1464",
				"0760002",
				"Necochea",
				"Necochea",
				"0002",
				"2015/03/18",
				"Plan Federal Nº 9",
				"Otros",
				"2013",
				"31",
				"0.9899999999999999900000000000000",
				"calles 80 - 82 - 51 - 53",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7478968880381,-34.4688355171785,0.0 -58.7473568020342,-34.4685618210109,0.0 -58.7467929699767,-34.4682678682674,0.0 -58.746326565742486,-34.46890663182069,0.0 -58.746684867457,-34.4691143311948,0.0 -58.7468547383125,-34.4691958455838,0.0 -58.74684423208237,-34.46919852328248,0.0 -58.747402131557465,-34.46947493471055,0.0 -58.7478968880381,-34.4688355171785,0.0 ",
				"Polygon Outer Boundary",
				"192",
				"1330057",
				"Malvinas Argentinas",
				"Tortuguitas",
				"0057",
				"2014/07/25",
				"Rosalia",
				"Asentamiento Precario",
				"1978",
				"50",
				"1.0000000000000000000000000000000",
				"Panama- Batalla de Maipu- Batalla de Chacabuco- Vedia",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.74977052211761,-34.40692736007153,0.0 -58.745518275900395,-34.40466771299115,0.0 -58.74505519866943,-34.405192394273485,0.0 -58.74544680118561,-34.405564175687736,0.0 -58.74643921852112,-34.405887270098816,0.0 -58.74747455120086,-34.40622364103664,0.0 -58.747614026069634,-34.406325437238095,0.0 -58.74786789099744,-34.406774465705865,0.0 -58.74824166297912,-34.40762222148623,0.0 -58.74891221523285,-34.40802497291242,0.0 -58.74977052211761,-34.40692736007153,0.0 ",
				"Polygon Outer Boundary",
				"2079",
				"1180012",
				"Escobar",
				"Maquinista Savio",
				"0012",
				"2015/08/06",
				"Gral. Pringles & Los Pinos",
				"Asentamiento Precario",
				"90_o_anterior",
				"90",
				"4.0999999999999996000000000000000",
				"Gral. Pringles, Los Pinos, Esteban Echeberria",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.791736364364624,-34.51772675357968,0.0 -58.79110646434128,-34.518407433433865,0.0 -58.791878940537565,-34.51894666937024,0.0 -58.79235637374222,-34.51842953333592,0.0 -58.79256784915924,-34.51821737403422,0.0 -58.79232108592987,-34.518069304201454,0.0 -58.791977763175964,-34.51786156399246,0.0 -58.791736364364624,-34.51772675357968,0.0 ",
				"Polygon Outer Boundary",
				"1749",
				"1320046",
				"Jose C. Paz",
				"Jose C. Paz",
				"0046",
				"2015/06/03",
				"Comunidad Pueblo Guaraní",
				"Asentamiento Precario",
				"2005",
				"15",
				"0.9200000000000000400000000000000",
				"Varela, Charcas, Croacia, Argentina",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.79594827070832,-34.522707963935076,0.0 -58.798104766756296,-34.520489218471546,0.0 -58.7958731688559,-34.51899528883231,0.0 -58.79370594397187,-34.521196394756714,0.0 -58.79594827070832,-34.522707963935076,0.0 ",
				"Polygon Outer Boundary",
				"1750",
				"1320047",
				"Jose C. Paz",
				"Jose C. Paz",
				"0047",
				"2015/06/03",
				"Muñiz",
				"Asentamiento Precario",
				"2013",
				"180",
				"8.3599999999999994000000000000000",
				"Salvatori, Varela, Charcas, Uruguay",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.826647996902466,-34.37172530246238,0.0 -58.82519061247876,-34.373591376598775,0.0 -58.82651025931409,-34.37428208717706,0.0 -58.82792472839355,-34.372327474135716,0.0 -58.826647996902466,-34.37172530246238,0.0 ",
				"Polygon Outer Boundary",
				"2081",
				"1180014",
				"Escobar",
				"Matheu",
				"0014",
				"2015/08/06",
				"9 de Julio",
				"Asentamiento Precario",
				"2010",
				"85",
				"3.4900000000000002000000000000000",
				"Los Tilos, Japón, Los Mandarinos",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.523032665252686,-34.55202344288328,0.0 -58.52299511432647,-34.55212506134577,0.0 -58.52325260639191,-34.552235516055546,0.0 -58.5233035683632,-34.55214273410919,0.0 -58.5234389269828,-34.5519452501416,0.0 -58.5234300738432,-34.5519099005734,0.0 -58.52307558059692,-34.55175835065783,0.0 -58.52293878793716,-34.5519858882027,0.0 -58.523032665252686,-34.55202344288328,0.0 ",
				"Polygon Outer Boundary",
				"678",
				"1100001",
				"Vicente Lopez",
				"Villa Martelli",
				"0001",
				"2014/10/01",
				"La Fabriquita",
				"Villa",
				"90_o_anterior",
				"45",
				"0.1400000000000000100000000000000",
				"Av. de los Contribuyentes, Gral. Las Heras",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-57.12437868118286,-37.00253553587404,0.0 -57.12417483329772,-37.00167871667439,0.0 -57.12212562561035,-37.00193576344818,0.0 -57.122265100479126,-37.00278401163576,0.0 -57.12437868118286,-37.00253553587404,0.0 ",
				"Polygon Outer Boundary",
				"2078",
				"0390001",
				"General Madariaga",
				"General Madariaga",
				"0001",
				"2015/08/06",
				"Calle 29 & calle 8",
				"Asentamiento Precario",
				"90_o_anterior",
				"31",
				"1.8000000000000000000000000000000",
				"-",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.99245953559875,-35.566701925657625,0.0 -57.99137592315673,-35.56621756165584,0.0 -57.99058198928833,-35.57033674405752,0.0 -57.991783618927,-35.57044146627338,0.0 -57.99212694168091,-35.568783348447816,0.0 -57.992282509803765,-35.567840824071546,0.0 -57.992298603057854,-35.56729101306523,0.0 -57.99240052700042,-35.566963742817904,0.0 -57.99245953559875,-35.566701925657625,0.0 ",
				"Polygon Outer Boundary",
				"1931",
				"0270009",
				"Chascomus",
				"Chascomus",
				"0009",
				"2015/07/17",
				"Iporá",
				"Otros",
				"90_o_anterior",
				"25",
				"15.8800000000000010000000000000000",
				"Castelar, Garay, 12 de Octubre y Carlos Pellegrini",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.99852132797241,-35.566287380070925,0.0 -57.99634505063295,-35.56600810604555,0.0 -57.994986176490784,-35.56589465069471,0.0 -57.99477864056826,-35.56705537862189,0.0 -57.99469280987977,-35.56756155546045,0.0 -57.99595881253481,-35.56768373559757,0.0 -57.995830066502094,-35.568538991340816,0.0 -57.99701929092408,-35.568687351101794,0.0 -57.99658477306366,-35.571082886858775,0.0 -57.997673749923706,-35.5712006982448,0.0 -57.9978346824646,-35.57057236885074,0.0 -57.99799561500549,-35.56968222710704,0.0 -57.998188734054565,-35.5690189778095,0.0 -57.998242378234856,-35.56860008068744,0.0 -57.998435497283936,-35.56709901468219,0.0 -57.998456954956055,-35.56673247103708,0.0 -57.99852132797241,-35.566287380070925,0.0 ",
				"Polygon Outer Boundary",
				"1931",
				"0270009",
				"Chascomus",
				"Chascomus",
				"0009",
				"2015/07/17",
				"Iporá",
				"Otros",
				"90_o_anterior",
				"25",
				"15.8800000000000010000000000000000",
				"Castelar, Garay, 12 de Octubre y Carlos Pellegrini",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.62849175930024,-34.79284082606075,0.0 -58.62760663032532,-34.792091909737465,0.0 -58.6291923187673,-34.790818736378036,0.0 -58.62899601459503,-34.79066013901183,0.0 -58.626946806907654,-34.792343017733224,0.0 -58.62801432609558,-34.79321528167176,0.0 -58.62849175930024,-34.79284082606075,0.0 ",
				"Polygon Outer Boundary",
				"1467",
				"0700130",
				"La Matanza",
				"Gonzalez Catan",
				"0130",
				"2015/03/18",
				"Argenpan",
				"Asentamiento Precario",
				"90_o_anterior",
				"54",
				"1.3400000000000001000000000000000",
				"Sunchales, Verbena",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.4415344423922,-34.7192619392043,0.0 -58.4422802800861,-34.718311799407,0.0 -58.44288825988769,-34.7175363295234,0.0 -58.4439879655838,-34.71693665038685,0.0 -58.4446907043457,-34.715935705670354,0.0 -58.445001840591424,-34.71549475701713,0.0 -58.444583415985115,-34.715283100828444,0.0 -58.4441864490509,-34.71505380601273,0.0 -58.44347834587097,-34.714630490836534,0.0 -58.44300627708434,-34.714383555983105,0.0 -58.4419635057055,-34.7136911281781,0.0 -58.442390211614,-34.7130972663249,0.0 -58.4417233344084,-34.7135703869338,0.0 -58.4415776119575,-34.7138288403876,0.0 -58.4414407392163,-34.7142303036269,0.0 -58.4411075041334,-34.7155793572856,0.0 -58.4410863334688,-34.7159207083274,0.0 -58.44030261039734,-34.71685287133773,0.0 -58.438628911972046,-34.716209092654594,0.0 -58.43780815601348,-34.717174758799864,0.0 -58.4394455324454,-34.7179371310085,0.0 -58.440426887502,-34.7180392899937,0.0 -58.4400494796355,-34.7184723120668,0.0 -58.4415344423922,-34.7192619392043,0.0 ",
				"Polygon Outer Boundary",
				"974",
				"0630037",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0037",
				"2014/10/01",
				"El Porvenir",
				"Asentamiento Precario",
				"2004",
				"270",
				"17.0799999999999980000000000000000",
				"Pio Baroja, Canadá, Pérez Galdós",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.64550232887268,-34.75337248641133,0.0 -58.64808797836303,-34.751362652141324,0.0 -58.64676833152771,-34.75032245554816,0.0 -58.64569544792175,-34.74933513818844,0.0 -58.6445152759552,-34.748330178041094,0.0 -58.64320635795593,-34.74724586522108,0.0 -58.64203155040741,-34.74624969536947,0.0 -58.640733361244195,-34.74727671984767,0.0 -58.6394727230072,-34.74828169281251,0.0 -58.64076018333435,-34.74925579967401,0.0 -58.6419939994812,-34.75029600970129,0.0 -58.64550232887268,-34.75337248641133,0.0 ",
				"Polygon Outer Boundary",
				"1058",
				"0700072",
				"La Matanza",
				"González Catán",
				"0072",
				"2014/10/01",
				"Primavera",
				"Asentamiento Precario",
				"2008",
				"316",
				"25.3099999999999990000000000000000",
				"Apipé. Armonia, Luján y Lavalleja",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.646429367363446,-34.74988169032809,0.0 -58.653156347572796,-34.74448653344032,0.0 -58.6513002589345,-34.74289965552782,0.0 -58.64954072982073,-34.744283767405705,0.0 -58.64539939910173,-34.74756322654424,0.0 -58.64456254988909,-34.74828610056175,0.0 -58.646429367363446,-34.74988169032809,0.0 ",
				"Polygon Outer Boundary",
				"1468",
				"0700131",
				"La Matanza",
				"González Catán",
				"0131",
				"2015/03/18",
				"Cielo Argentino",
				"Asentamiento Precario",
				"2009",
				"520",
				"21.3299999999999980000000000000000",
				"Lavalleja, Armonía, Arias y s/n",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.67106914520263,-34.7099033241789,0.0 -58.668955564498894,-34.711534932756315,0.0 -58.67038249969482,-34.71283137716435,0.0 -58.67291450500488,-34.710899932162576,0.0 -58.67149829864502,-34.7095417200832,0.0 -58.672834038734436,-34.70851422664726,0.0 -58.6720822401277,-34.7078003232302,0.0 -58.67377817630768,-34.70652976113633,0.0 -58.672614097595215,-34.70605789233147,0.0 -58.67205619812011,-34.7058021118544,0.0 -58.67031812667847,-34.707116285898756,0.0 -58.66917014122009,-34.70615491230555,0.0 -58.6680006980896,-34.70703690685092,0.0 -58.66882681846619,-34.70776895518198,0.0 -58.66947054862976,-34.70836870079401,0.0 -58.67106914520263,-34.7099033241789,0.0 ",
				"Polygon Outer Boundary",
				"647",
				"0720015",
				"Merlo",
				"Libertad",
				"0015",
				"2014/10/01",
				"Nuevo",
				"Otros",
				"decada_1990",
				"420",
				"17.4200000000000020000000000000000",
				"Honduras, Obarrio, Salcedo",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.5986588404124,-34.4298069111936,0.0 -58.5964348464838,-34.4297768957247,0.0 -58.5962691443748,-34.4335065730341,0.0 -58.59533965587616,-34.434425302201525,0.0 -58.594105839729316,-34.43560661718708,0.0 -58.5956842669606,-34.4388808960028,0.0 -58.5985164889521,-34.4380075424095,0.0 -58.5985846628588,-34.4329472601096,0.0 -58.5986588404124,-34.4298069111936,0.0 -58.5986588404124,-34.4298069111936,0.0 ",
				"Polygon Outer Boundary",
				"706",
				"0570010",
				"Tigre",
				"Tigre",
				"0010",
				"2014/10/01",
				"Liniers",
				"Otros",
				"90_o_anterior",
				"800",
				"26.7199999999999990000000000000000",
				"Lamarca, Liniers, Williams, Juana de Arco, Ituzaingó",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.7525292261361,-34.489595054063,0.0 -58.7527153514074,-34.4896920500329,0.0 -58.7532255390704,-34.489059078723,0.0 -58.75294089317322,-34.488903258267165,0.0 -58.75274509191513,-34.48917076135729,0.0 -58.75262975692748,-34.48911328142683,0.0 -58.7525225575642,-34.4892533622402,0.0 -58.7523449382514,-34.489498977957,0.0 -58.7524370814691,-34.489547061106,0.0 -58.7525292261361,-34.489595054063,0.0 ",
				"Polygon Outer Boundary",
				"194",
				"1330061",
				"Malvinas Argentinas",
				"Tortuguitas",
				"0061",
				"2014/07/25",
				"Asamblea & Buenos Aires",
				"Asentamiento Precario",
				"decada_1990",
				"17",
				"0.3100000000000000000000000000000",
				"Buenos Aires- Asamblea- Naciones Unidas- Trunvirato",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.36401605978608,-34.700598130439865,0.0 -58.36248409934341,-34.70189915647998,0.0 -58.360598087310784,-34.70352651279594,0.0 -58.36069464683533,-34.703724968693486,0.0 -58.36086094379424,-34.70374701931938,0.0 -58.36114525794982,-34.70372937881913,0.0 -58.36213004775345,-34.70363235600054,0.0 -58.36278224363923,-34.703208982369695,0.0 -58.36488509550691,-34.70146254324212,0.0 -58.36401605978608,-34.700598130439865,0.0 ",
				"Polygon Outer Boundary",
				"1436",
				"0250033",
				"Lanus",
				"Lanús Oeste",
				"0033",
				"2015/03/09",
				"Gral. Belgrano",
				"Villa",
				"90_o_anterior",
				"330",
				"4.9699999999999998000000000000000",
				"Camino Gral. Belgrano, Gral Madariaga",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.515624403953545,-34.673607150754385,0.0 -58.51609647274017,-34.673977735294265,0.0 -58.51684749126434,-34.674432140264614,0.0 -58.51729273796081,-34.67405273434465,0.0 -58.51750731468201,-34.674132145029844,0.0 -58.51802229881286,-34.67366009150446,0.0 -58.517807722091675,-34.67340862264026,0.0 -58.517861366271966,-34.67334244649647,0.0 -58.51778090000152,-34.673254211555836,0.0 -58.51684212684631,-34.67252185792092,0.0 -58.515624403953545,-34.673607150754385,0.0 ",
				"Polygon Outer Boundary",
				"1123",
				"0700007",
				"La Matanza",
				"La Tablada",
				"0007",
				"2014/10/01",
				"Monte Tartaglia",
				"Villa",
				"90_o_anterior",
				"220",
				"2.4800000000000000000000000000000",
				"O´Gorman, Carlos Tejedor, Angaco y Vertiz",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9842796677276,-34.8802172375712,0.0 -57.9845750734317,-34.8798587097551,0.0 -57.9844387644663,-34.8797149258424,0.0 -57.9843606981802,-34.8795008428072,0.0 -57.9805351061611,-34.8762928576758,0.0 -57.9803094124449,-34.8763965119334,0.0 -57.979810237884514,-34.87714729088019,0.0 -57.977514266967766,-34.878907616566245,0.0 -57.97935962677002,-34.88056228833752,0.0 -57.97835111618042,-34.88140721426642,0.0 -57.97938108444214,-34.88218172207079,0.0 -57.98313617706298,-34.87999899955939,0.0 -57.9838153633824,-34.8794389466561,0.0 -57.9840008740618,-34.8796495982233,0.0 -57.9842000220493,-34.8797934852633,0.0 -57.9842796677276,-34.8802172375712,0.0 ",
				"Polygon Outer Boundary",
				"310",
				"0550038",
				"La Plata",
				"Ringuelet",
				"0038",
				"2014/09/19",
				"Ciudad Oculta",
				"Otros",
				"2001",
				"48",
				"19.5300000000000010000000000000000",
				"514 e/1 y 118",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.65559279918671,-34.48844341623927,0.0 -58.65603268146515,-34.48791724773171,0.0 -58.6553115863353,-34.48752372457737,0.0 -58.65522801876068,-34.487559097521135,0.0 -58.654643297195435,-34.4882930827187,0.0 -58.65513456054032,-34.48855395541977,0.0 -58.6553491372615,-34.48829750429669,0.0 -58.65559279918671,-34.48844341623927,0.0 ",
				"Polygon Outer Boundary",
				"1751",
				"0570039",
				"Tigre",
				"Don Torcuato",
				"0039",
				"2015/06/04",
				"Colón & Barca",
				"Asentamiento Precario",
				"90_o_anterior",
				"50",
				"0.7700000000000000200000000000000",
				"Colón, Barca, Alemania, Urquiza",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-60.97806176170706,-34.581827675486146,0.0 -60.97707470878958,-34.58265357810559,0.0 -60.97792983055115,-34.583395558486686,0.0 -60.978949069976814,-34.58254758036752,0.0 -60.97806176170706,-34.581827675486146,0.0 ",
				"Polygon Outer Boundary",
				"1753",
				"0540007",
				"Junin",
				"Junín",
				"0007",
				"2015/06/04",
				"Progreso II",
				"Otros",
				"2010",
				"66",
				"1.4900000000000000000000000000000",
				"Camino del Resero - Rusahill - Iberlucea - Dr. Noir - Apolidoro",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.9232803247869,-34.57325458659451,0.0 -60.922658052295446,-34.57377579910563,0.0 -60.923462714999914,-34.5744030166089,0.0 -60.92405816540121,-34.57390831024002,0.0 -60.9232803247869,-34.57325458659451,0.0 ",
				"Polygon Outer Boundary",
				"1752",
				"0540006",
				"Junin",
				"Junin",
				"0006",
				"2015/06/04",
				"San Juan",
				"Asentamiento Precario",
				"2011",
				"25",
				"1.0000000000000000000000000000000",
				"Ricardo Rojas - Manuel Etchepare - calle s/ nombre",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.922507848590605,-34.573943646506855,0.0 -60.92306038364768,-34.57446927170263,0.0 -60.923291053622954,-34.57428817432136,0.0 -60.9226687811315,-34.573815552468126,0.0 -60.922507848590605,-34.573943646506855,0.0 ",
				"Polygon Outer Boundary",
				"1752",
				"0540006",
				"Junin",
				"Junin",
				"0006",
				"2015/06/04",
				"San Juan",
				"Asentamiento Precario",
				"2011",
				"25",
				"1.0000000000000000000000000000000",
				"Ricardo Rojas - Manuel Etchepare - calle s/ nombre",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.425169587135315,-34.68954519950226,0.0 -58.424906730651855,-34.68988924754288,0.0 -58.426490361700864,-34.69066876371777,0.0 -58.42711687088012,-34.689748099801776,0.0 -58.426006436347954,-34.689187917331175,0.0 -58.425588011741645,-34.68974368893098,0.0 -58.425169587135315,-34.68954519950226,0.0 ",
				"Polygon Outer Boundary",
				"2116",
				"0250036",
				"Lanus",
				"Lanus",
				"0036",
				"2015/08/13",
				"25 de Mayo & Ucrania",
				"Villa",
				"90_o_anterior",
				"150",
				"1.6399999999999999000000000000000",
				"25 de Mayo, Ucrania, Aristóbulo del Valle, Ricardo Balbín",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-60.93058347702026,-34.56924379118053,0.0 -60.92997193336487,-34.56872255025838,0.0 -60.92919945716858,-34.56942048227701,0.0 -60.92984318733215,-34.56988871186685,0.0 -60.93058347702026,-34.56924379118053,0.0 ",
				"Polygon Outer Boundary",
				"1754",
				"0540008",
				"Junin",
				"Junín",
				"0008",
				"2015/06/04",
				"Bicentenario",
				"Otros",
				"2000",
				"24",
				"1.0200000000000000000000000000000",
				"Av. Alvear - Av. Caseros - Suiza - Riobamba",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.93069076538086,-34.56930563310701,0.0 -60.93046009540557,-34.5695044104163,0.0 -60.93109309673309,-34.56995055331366,0.0 -60.93125402927399,-34.569778280597404,0.0 -60.93069076538086,-34.56930563310701,0.0 ",
				"Polygon Outer Boundary",
				"1754",
				"0540008",
				"Junin",
				"Junín",
				"0008",
				"2015/06/04",
				"Bicentenario",
				"Otros",
				"2000",
				"24",
				"1.0200000000000000000000000000000",
				"Av. Alvear - Av. Caseros - Suiza - Riobamba",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.79324013869336,-34.33462785382271,0.0 -58.79337961356214,-34.33431777363558,0.0 -58.79107654094696,-34.333150734231126,0.0 -58.79013776779174,-34.33433790868601,0.0 -58.78955841064453,-34.33496692714741,0.0 -58.791931220694096,-34.33620481532215,0.0 -58.79233891646435,-34.33569097719096,0.0 -58.79248912016919,-34.33560238409157,0.0 -58.79324013869336,-34.33462785382271,0.0 ",
				"Polygon Outer Boundary",
				"2086",
				"1180018",
				"Escobar",
				"Escobar",
				"0018",
				"2015/08/06",
				"Gral. Paz & Córdoba",
				"Asentamiento Precario",
				"90_o_anterior",
				"200",
				"6.3300000000000001000000000000000",
				"Gral Paz, Gral Lamadrid, Patricias Mendocinas",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.781028985977166,-34.32179199208042,0.0 -58.781463503837585,-34.3220090807379,0.0 -58.78212869167328,-34.321180596517095,0.0 -58.78182828426361,-34.31950145100572,0.0 -58.781028985977166,-34.31907612121663,0.0 -58.78033161163331,-34.32000652733078,0.0 -58.781313300132744,-34.32058248785183,0.0 -58.78114700317383,-34.32078628832022,0.0 -58.78161907196044,-34.32104325342282,0.0 -58.781028985977166,-34.32179199208042,0.0 ",
				"Polygon Outer Boundary",
				"2087",
				"1180019",
				"Escobar",
				"Escobar",
				"0019",
				"2015/08/06",
				"San Isidro & Hornero",
				"Otros",
				"90_o_anterior",
				"60",
				"2.5000000000000000000000000000000",
				"San Isidro, Hornero, Paladini",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6198659427464,-34.62499327154792,0.0 -58.61943678930402,-34.62504182903588,0.0 -58.61968874931336,-34.625933516035616,0.0 -58.61954927444458,-34.625933516035616,0.0 -58.61962437629699,-34.62618954320545,0.0 -58.619656562805176,-34.62643674110257,0.0 -58.620026875287294,-34.625690730920674,0.0 -58.6198659427464,-34.62499327154792,0.0 ",
				"Polygon Outer Boundary",
				"2142",
				"1350040",
				"Hurlingham",
				"Hurlingham",
				"0040",
				"2015/09/02",
				"Bradley & Arroyo Morón",
				"Asentamiento Precario",
				"2000",
				"12",
				"0.4500000000000000100000000000000",
				"Roentgen y Arroyo Morón",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.50169825553894,-35.107411086861624,0.0 -60.502374172210686,-35.10940344063516,0.0 -60.504498817026615,-35.10878028676002,0.0 -60.50393018871546,-35.10771828114801,0.0 -60.50169825553894,-35.107411086861624,0.0 ",
				"Polygon Outer Boundary",
				"2149",
				"0120006",
				"Bragado",
				"Bragado",
				"0006",
				"2015/09/02",
				"12 de Octubre & G. Vega",
				"Otros",
				"90_o_anterior",
				"90",
				"3.4700000000000002000000000000000",
				"12 de Octubre,  G. Vega, San Luis, Alberti",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.66009354591369,-34.82428916884756,0.0 -58.66082310676575,-34.82480439889089,0.0 -58.661423921585076,-34.824280361468375,0.0 -58.66207301616669,-34.82376953186413,0.0 -58.66128981113434,-34.82317502790457,0.0 -58.660629987716675,-34.823681457474216,0.0 -58.65976095199585,-34.822937225119254,0.0 -58.65906357765197,-34.82343925241635,0.0 -58.66009354591369,-34.82428916884756,0.0 ",
				"Polygon Outer Boundary",
				"1646",
				"0700145",
				"La Matanza",
				"Virrey Del Pino",
				"0145",
				"2015/04/30",
				"Luz y Fuerza II",
				"Asentamiento Precario",
				"2012",
				"15",
				"2.6000000000000001000000000000000",
				"Areco, Urien",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.893080949783325,-34.483628187353006,0.0 -58.898940570652485,-34.47590732291256,0.0 -58.89599919319153,-34.474386060326616,0.0 -58.894261121749885,-34.476579499871534,0.0 -58.89199733734131,-34.47561545491536,0.0 -58.890409469604485,-34.47772926369567,0.0 -58.889926671981804,-34.47856946570142,0.0 -58.89164328575135,-34.47996683556222,0.0 -58.89029312878847,-34.48183290691645,0.0 -58.8921046257019,-34.482743817582204,0.0 -58.891879320144646,-34.48303566064306,0.0 -58.893080949783325,-34.483628187353006,0.0 ",
				"Polygon Outer Boundary",
				"2056",
				"0840031",
				"Pilar",
				"Villa Astolfi",
				"0031",
				"2015/08/06",
				"Padre Urquiza",
				"Asentamiento Precario",
				"2008",
				"360",
				"41.6800000000000000000000000000000",
				"Francisco Lauría, Chaco, Pampa",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.8947057976371,-34.9989623086447,0.0 -57.8921695788456,-34.9965433264484,0.0 -57.8912798873433,-34.9972093296789,0.0 -57.8909374957399,-34.9974140491989,0.0 -57.8904643176366,-34.9977550590008,0.0 -57.8900578839917,-34.9980513280875,0.0 -57.8909190878936,-34.9988670821083,0.0 -57.8910879503647,-34.9987523238034,0.0 -57.8928678752734,-35.0004229908066,0.0 -57.8947057976371,-34.9989623086447,0.0 ",
				"Polygon Outer Boundary",
				"285",
				"0550004",
				"La Plata",
				"Arana",
				"0004",
				"2014/06/30",
				"La Aceitera",
				"Asentamiento Precario",
				"decada_1990",
				"90",
				"8.8699999999999992000000000000000",
				"30 a 132 - 637 a 638",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.244694471359246,-34.824038158171675,0.0 -58.24273109436035,-34.822320696182196,0.0 -58.241931796073914,-34.82374751327548,0.0 -58.24357867240906,-34.824839628177834,0.0 -58.244694471359246,-34.824038158171675,0.0 ",
				"Polygon Outer Boundary",
				"1650",
				"0320038",
				"Florencio Varela",
				"Bosques",
				"0038",
				"2015/05/04",
				"Santa Ana I",
				"Asentamiento Precario",
				"90_o_anterior",
				"150",
				"4.0000000000000000000000000000000",
				"Av. Bosques, Combate de los Pozos, calle 811",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.24082169681787,-34.82579081322931,0.0 -58.24002776294947,-34.827358483137296,0.0 -58.241293765604496,-34.82643373764384,0.0 -58.240810967981815,-34.8260902581016,0.0 -58.24096117168665,-34.82590530698551,0.0 -58.24082169681787,-34.82579081322931,0.0 ",
				"Polygon Outer Boundary",
				"1650",
				"0320038",
				"Florencio Varela",
				"Bosques",
				"0038",
				"2015/05/04",
				"Santa Ana I",
				"Asentamiento Precario",
				"90_o_anterior",
				"150",
				"4.0000000000000000000000000000000",
				"Av. Bosques, Combate de los Pozos, calle 811",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.25198471546173,-34.76873552414001,0.0 -58.25366914272308,-34.766620301409695,0.0 -58.25232267379761,-34.765959283189694,0.0 -58.250702619552605,-34.76802164252881,0.0 -58.25198471546173,-34.76873552414001,0.0 ",
				"Polygon Outer Boundary",
				"1193",
				"1200001",
				"Berazategui",
				"Berazategui",
				"0001",
				"2014/10/01",
				"San Agustin - 9 de Julio",
				"Asentamiento Precario",
				"1996",
				"360",
				"5.7999999999999998000000000000000",
				"Av. Florencio Varela, calle 114, calle 3, calle 116",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.25377106666565,-34.766673182638606,0.0 -58.252096446231,-34.76880603063076,0.0 -58.25268745422363,-34.7691233090938,0.0 -58.254377245903015,-34.766994876051236,0.0 -58.25377106666565,-34.766673182638606,0.0 ",
				"Polygon Outer Boundary",
				"1193",
				"1200001",
				"Berazategui",
				"Berazategui",
				"0001",
				"2014/10/01",
				"San Agustin - 9 de Julio",
				"Asentamiento Precario",
				"1996",
				"360",
				"5.7999999999999998000000000000000",
				"Av. Florencio Varela, calle 114, calle 3, calle 116",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.445570468902595,-34.69058616098669,0.0 -58.446922302246094,-34.69136246272465,0.0 -58.4479467408448,-34.6905974682599,0.0 -58.4466184930247,-34.6891590857838,0.0 -58.4465148537299,-34.6893067144619,0.0 -58.445570468902595,-34.69058616098669,0.0 ",
				"Polygon Outer Boundary",
				"962",
				"0630049",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0049",
				"2014/10/01",
				"Libre Amanecer",
				"Villa",
				"2002",
				"400",
				"2.6600000000000001000000000000000",
				"Av. General Hornos, Darwin, Av. Carlos Pellegrini, 17 de Octubre",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9798163305383,-34.942565791801,0.0 -57.9788446421234,-34.9432857209936,0.0 -57.9797233471184,-34.944120703325,0.0 -57.9807125621847,-34.9433913257299,0.0 -57.9798163305383,-34.942565791801,0.0 ",
				"Polygon Outer Boundary",
				"374",
				"0550100",
				"La Plata",
				"Los Hornos",
				"0100",
				"2014/10/24",
				"136 & 52",
				"Otros",
				"1980",
				"55",
				"1.4399999999999999000000000000000",
				"136, 137, 50, 52",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.52470099925995,-34.562222224843424,0.0 -58.5247636972243,-34.5621285823576,0.0 -58.52494776248931,-34.561919614919546,0.0 -58.524633944034576,-34.56177162280407,0.0 -58.524371087551124,-34.562065397940025,0.0 -58.52470099925995,-34.562222224843424,0.0 ",
				"Polygon Outer Boundary",
				"734",
				"0470133",
				"General San Martin",
				"General San Martin",
				"0133",
				"2014/10/01",
				"Martinez",
				"Villa",
				"90_o_anterior",
				"18",
				"0.1400000000000000100000000000000",
				"Martinez & Rivadavia",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.621974159032106,-34.6018590195333,0.0 -58.621684312820435,-34.601580839496876,0.0 -58.62152891233564,-34.60173096852117,0.0 -58.6215771920979,-34.60192083719264,0.0 -58.62159864977002,-34.60227408007753,0.0 -58.62170593813061,-34.602424207848635,0.0 -58.62194733694195,-34.60220784715106,0.0 -58.62179713323712,-34.60202239467593,0.0 -58.62184004858136,-34.6019649926354,0.0 -58.621974159032106,-34.6018590195333,0.0 ",
				"Polygon Outer Boundary",
				"2143",
				"1350041",
				"Hurlingham",
				"Hurlingham",
				"0041",
				"2015/09/02",
				"Arroyo Morón & Díaz de Solís",
				"Asentamiento Precario",
				"90_o_anterior",
				"12",
				"0.2200000000000000000000000000000",
				"Días de Solís y Rosas Castillo",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"-",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.0134589690715,-35.55592304342284,0.0 -58.013362409546964,-35.55591431499559,0.0 -58.011533142998815,-35.55582703067084,0.0 -58.01137221045792,-35.55595795712233,0.0 -58.01135611720383,-35.55616307479972,0.0 -58.01140976138414,-35.55620235259296,0.0 -58.01212322898209,-35.556232901974404,0.0 -58.01341068930924,-35.55628963650904,0.0 -58.01341605372727,-35.556272179733426,0.0 -58.0134589690715,-35.55592304342284,0.0 ",
				"Polygon Outer Boundary",
				"1934",
				"0270010",
				"Chascomus",
				"Chascomús",
				"0010",
				"2015/07/20",
				"Los Pinos & Hipólito Yrigoyen",
				"Otros",
				"2007",
				"12",
				"0.7700000000000000200000000000000",
				"Los Pinos & Hipólito Yrigoyen",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.479602336883545,-34.740572179450965,0.0 -58.477209806442254,-34.74094246412188,0.0 -58.47216725349426,-34.74774835341964,0.0 -58.47553610801696,-34.749432107380365,0.0 -58.47643733024597,-34.749872874999696,0.0 -58.476877212524414,-34.74919409188787,0.0 -58.47771406173705,-34.7495995993528,0.0 -58.478310350328684,-34.74892081399508,0.0 -58.47905516624451,-34.74930869202543,0.0 -58.47850799560547,-34.7500139201411,0.0 -58.478988530114286,-34.750247525626705,0.0 -58.47844982519746,-34.750965968545295,0.0 -58.47940469160675,-34.75141554314351,0.0 -58.47950125113129,-34.75138028247915,0.0 -58.48097110167146,-34.74938803048905,0.0 -58.47982311621308,-34.748832659643234,0.0 -58.48063850775361,-34.74782769338208,0.0 -58.48097110167146,-34.74799518860807,0.0 -58.481775764375925,-34.74809215937315,0.0 -58.481818679720156,-34.74777480008225,0.0 -58.479602336883545,-34.740572179450965,0.0 ",
				"Polygon Outer Boundary",
				"1458",
				"0630068",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0068",
				"2015/03/17",
				"Santa Catalina II",
				"Otros",
				"90_o_anterior",
				"2150",
				"56.7400000000000020000000000000000",
				"Av. P.E.Giachino, Av. Facundo Quiroga, Av. Gilberto Elizalde y Arroyo Santa Catalina",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.57918739318848,-34.56893458085824,0.0 -58.578484654426575,-34.569495575879316,0.0 -58.57947929296642,-34.5703216010287,0.0 -58.57953830156475,-34.57032380964111,0.0 -58.580195903778076,-34.56980478411545,0.0 -58.57918739318848,-34.56893458085824,0.0 ",
				"Polygon Outer Boundary",
				"2277",
				"0470139",
				"General San Martin",
				"General San Martin",
				"0139",
				"2015/09/28",
				"Billinghurst I",
				"Otros",
				"1994",
				"150",
				"1.1799999999999999000000000000000",
				"Maipu, Naon",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-60.166591526940465,-35.4390254356678,0.0 -60.16454458236694,-35.43925707547236,0.0 -60.16456604003906,-35.43965042455704,0.0 -60.16421198844909,-35.43969412989225,0.0 -60.164265632629395,-35.44007873581903,0.0 -60.164244174957275,-35.4401049588835,0.0 -60.16423344612121,-35.44020985105592,0.0 -60.1636004447937,-35.440271038093385,0.0 -60.1636004447937,-35.44033222508435,0.0 -60.16359818167985,-35.44029726109521,0.0 -60.16368401236832,-35.44067749366173,0.0 -60.16364646144211,-35.44068623461914,0.0 -60.16372692771256,-35.44107957672086,0.0 -60.16470861621201,-35.44098342660681,0.0 -60.164907099679105,-35.44112328128019,0.0 -60.16504657454788,-35.441883736814205,0.0 -60.165969254449,-35.441796328497546,0.0 -60.16616773791611,-35.44180943975109,0.0 -60.167106511071324,-35.441700179239604,0.0 -60.166940214112394,-35.44075616224436,0.0 -60.1667792815715,-35.4398208752302,0.0 -60.16665053553879,-35.43906477077593,0.0 -60.166591526940465,-35.4390254356678,0.0 ",
				"Polygon Outer Boundary",
				"1344",
				"1090003",
				"Veinticinco de Mayo",
				"25 De Mayo",
				"0003",
				"2015/02/05",
				"Sandalio",
				"Otros",
				"decada_1930",
				"120",
				"6.8600000000000003000000000000000",
				"5 a 1; 19 a 22",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.71289635077119,-38.53648440137431,0.0 -58.71348643675446,-38.536056396881264,0.0 -58.71274614706635,-38.53549411259866,0.0 -58.71217751875519,-38.53588015899691,0.0 -58.71289635077119,-38.53648440137431,0.0 ",
				"Polygon Outer Boundary",
				"1756",
				"0760011",
				"Necochea",
				"Quequén",
				"0011",
				"2015/06/08",
				"Barrio Estación Quequén",
				"Asentamiento Precario",
				"decada_1990",
				"10",
				"0.6200000000000000000000000000000",
				"calle 580 esquina calle 557",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.52072596549988,-34.6731350942369,0.0 -58.51885914802551,-34.674670371000516,0.0 -58.52132141590118,-34.67639090596974,0.0 -58.523070216178894,-34.67493065935455,0.0 -58.52072596549988,-34.6731350942369,0.0 ",
				"Polygon Outer Boundary",
				"1122",
				"0700008",
				"La Matanza",
				"La Tablada",
				"0008",
				"2014/10/01",
				"Las Antenas",
				"Villa",
				"90_o_anterior",
				"1700",
				"6.9100000000000001000000000000000",
				"Colón, Las Heras, Salcedo",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.887448310852044,-34.478905544134605,0.0 -58.88682637363672,-34.47855177732533,0.0 -58.885624408721924,-34.48009065201604,0.0 -58.88623628765344,-34.480373660363306,0.0 -58.88693366199732,-34.480833546880035,0.0 -58.88739466667175,-34.480276376352215,0.0 -58.88816714286804,-34.48063897981696,0.0 -58.88889703899621,-34.47962191732908,0.0 -58.887448310852044,-34.478905544134605,0.0 ",
				"Polygon Outer Boundary",
				"2278",
				"0840041",
				"Pilar",
				"Villa Astolfi",
				"0041",
				"2015/09/28",
				"Gauchito Gil",
				"Asentamiento Precario",
				"2009",
				"75",
				"4.0300000000000002000000000000000",
				"Lago Aluminé, Uruguay, 25 de Mayo",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.2418717816472,-34.82385320244731,0.0 -58.241368532180786,-34.82357136435439,0.0 -58.23867559432983,-34.82844174322315,0.0 -58.23400855064392,-34.83199086140093,0.0 -58.234169483184814,-34.832202218451314,0.0 -58.23685169219971,-34.83025595177546,0.0 -58.238697052001946,-34.828864475001055,0.0 -58.239963054656975,-34.827340869034416,0.0 -58.24076771736144,-34.825773198791154,0.0 -58.2418717816472,-34.82385320244731,0.0 ",
				"Polygon Outer Boundary",
				"1651",
				"0320039",
				"Florencio Varela",
				"Florencio Varela",
				"0039",
				"2015/05/04",
				"Santa Ana II",
				"Asentamiento Precario",
				"decada_2000",
				"225",
				"4.9199999999999999000000000000000",
				"Tandil, Combate de los Pozos, Vías del Ferrocarril, Estanislao del Campo",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.36869835853576,-34.88446119700543,0.0 -58.36568355560303,-34.88297382477576,0.0 -58.361756801605225,-34.881072765458185,0.0 -58.36086630821227,-34.882265333272244,0.0 -58.3677864074707,-34.88564931524457,0.0 -58.36869835853576,-34.88446119700543,0.0 ",
				"Polygon Outer Boundary",
				"1231",
				"0030048",
				"Almirante Brown",
				"Almirante Brown",
				"0048",
				"2014/10/01",
				"Int. Arreghini & Min. French",
				"Asentamiento Precario",
				"decada_2000",
				"1100",
				"19.1200000000000010000000000000000",
				"Int. Arreghini, Min. French, Gdor. Arias",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.36168186739087,-34.88099795435429,0.0 -58.36260454729199,-34.87978776527233,0.0 -58.361134696751826,-34.87904844099256,0.0 -58.36120443418622,-34.87892081886646,0.0 -58.35888164117933,-34.877829421557244,0.0 -58.359353709965944,-34.877204502057666,0.0 -58.35784630849957,-34.876465154542565,0.0 -58.35700409486889,-34.87769739670669,0.0 -58.35924105718731,-34.87880199808818,0.0 -58.358693886548274,-34.879558927515404,0.0 -58.36016910150648,-34.8802190346978,0.0 -58.360689450055354,-34.879550126050496,0.0 -58.36155312135815,-34.87999459885061,0.0 -58.36104886606335,-34.880707510599706,0.0 -58.36168186739087,-34.88099795435429,0.0 ",
				"Polygon Outer Boundary",
				"1231",
				"0030048",
				"Almirante Brown",
				"Almirante Brown",
				"0048",
				"2014/10/01",
				"Int. Arreghini & Min. French",
				"Asentamiento Precario",
				"decada_2000",
				"1100",
				"19.1200000000000010000000000000000",
				"Int. Arreghini, Min. French, Gdor. Arias",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.5468828678131,-34.852463555943444,0.0 -58.5455846786499,-34.85422441007461,0.0 -58.5464859008789,-34.85464700945835,0.0 -58.54728830046952,-34.8536257238984,0.0 -58.547835471108556,-34.85294339242971,0.0 -58.5468828678131,-34.852463555943444,0.0 ",
				"Polygon Outer Boundary",
				"1422",
				"1300015",
				"Ezeiza",
				"Ezeiza",
				"0015",
				"2015/03/02",
				"Progreso & Viamonte",
				"Asentamiento Precario",
				"decada_1990",
				"60",
				"2.2300000000000000000000000000000",
				"Progreso, Viamonte, San Rafael y San Luis",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.22316706180573,-34.81680255672411,0.0 -58.223698139190674,-34.81639297537279,0.0 -58.22325825691223,-34.8160186250449,0.0 -58.222984671592705,-34.81623442720627,0.0 -58.22283446788788,-34.81609349524655,0.0 -58.22260086424648,-34.816274064276506,0.0 -58.22316706180573,-34.81680255672411,0.0 ",
				"Polygon Outer Boundary",
				"1658",
				"0320044",
				"Florencio Varela",
				"Florencio Varela",
				"0044",
				"2015/05/04",
				"Marcos Paz & San Antonio",
				"Otros",
				"90_o_anterior",
				"40",
				"0.4400000000000000000000000000000",
				"Marco Paz, Cramer, San Antonio",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.30020546913147,-34.802298613265776,0.0 -58.302423404529684,-34.80010496141022,0.0 -58.30232684500515,-34.799897926995584,0.0 -58.3020103443414,-34.799536716771954,0.0 -58.301795767620206,-34.79948385660648,0.0 -58.30160264857113,-34.799276820632,0.0 -58.30127835273742,-34.79975256209589,0.0 -58.29930424690246,-34.80186693538557,0.0 -58.30020546913147,-34.802298613265776,0.0 ",
				"Polygon Outer Boundary",
				"1661",
				"0320047",
				"Florencio Varela",
				"Florencio Varela",
				"0047",
				"2015/05/04",
				"San Nicolás II",
				"Villa",
				"90_o_anterior",
				"150",
				"3.4800000000000000000000000000000",
				"Padre Novak, Sudamérica, Pablo Fels",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.20363521575928,-34.875756606933926,0.0 -58.204213567078114,-34.8753077102577,0.0 -58.20469737052918,-34.87504365224429,0.0 -58.20501923561097,-34.87475318744988,0.0 -58.205480575561516,-34.874348295418045,0.0 -58.20629596710205,-34.87370574527416,0.0 -58.20846319198609,-34.87191009906747,0.0 -58.20806622505188,-34.87164603014106,0.0 -58.206199407577515,-34.87157561161744,0.0 -58.204439878463745,-34.871544803494395,0.0 -58.203237242996686,-34.87242062992025,0.0 -58.20085644721985,-34.87426907717857,0.0 -58.20231020450592,-34.875545361744585,0.0 -58.20285737514495,-34.87508326100037,0.0 -58.20363521575928,-34.875756606933926,0.0 ",
				"Polygon Outer Boundary",
				"1654",
				"0320042",
				"Florencio Varela",
				"Florencio Varela",
				"0042",
				"2015/05/04",
				"Calle 1139 & calle 1336",
				"Asentamiento Precario",
				"2011",
				"145",
				"16.4699999999999990000000000000000",
				"Calle 1138, calle 1139, calle 1135, calle 1134",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.29005649313331,-34.82179223913466,0.0 -58.29198768362403,-34.822761074465284,0.0 -58.29558184370398,-34.81804890465452,0.0 -58.29222371801734,-34.81625204368429,0.0 -58.29032446257769,-34.81873592937433,0.0 -58.29175919294357,-34.81951983519712,0.0 -58.29005649313331,-34.82179223913466,0.0 ",
				"Polygon Outer Boundary",
				"1575",
				"0320022",
				"Florencio Varela",
				"Gobernador Julio A. Costa",
				"0022",
				"2015/04/20",
				"Libertad",
				"Asentamiento Precario",
				"90_o_anterior",
				"850",
				"18.1200000000000010000000000000000",
				"Calle 560, calle 515, calle 576, calle 505",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.594655752182,-38.06281600332075,0.0 -57.595170736312866,-38.06255413991938,0.0 -57.5957715511322,-38.06205575214698,0.0 -57.58450174704195,-38.05263642972194,0.0 -57.583997491747134,-38.052982811926505,0.0 -57.58371854200959,-38.052898328613125,0.0 -57.58280659094452,-38.052180216512305,0.0 -57.582656387239695,-38.0522562522447,0.0 -57.581873182207346,-38.05285608691987,0.0 -57.581894639879465,-38.052923673617386,0.0 -57.58250618353485,-38.0534305718595,0.0 -57.58281731978059,-38.05326160616885,0.0 -57.58306408300996,-38.05341367530799,0.0 -57.583246473222964,-38.05355729587153,0.0 -57.58230233564972,-38.053836087925696,0.0 -57.582001928240054,-38.05450349489294,0.0 -57.58153438568115,-38.05463866518318,0.0 -57.581276893615716,-38.054558407853456,0.0 -57.58082628250122,-38.05489633285747,0.0 -57.580445408821106,-38.05519623999173,0.0 -57.58117496967315,-38.05574113854156,0.0 -57.581122163683176,-38.05593966646228,0.0 -57.58014583960175,-38.05605793815907,0.0 -57.57985616102815,-38.05615931374706,0.0 -57.57924461737276,-38.05652257511757,0.0 -57.57867598906159,-38.056970313395794,0.0 -57.57786059752107,-38.05759545282467,0.0 -57.57759237661957,-38.05757010943817,0.0 -57.57759237661957,-38.0574518401851,0.0 -57.57671261206269,-38.05673377275991,0.0 -57.576637510210276,-38.05672532486592,0.0 -57.57611179724336,-38.05719840542777,0.0 -57.57612252607942,-38.05726598811554,0.0 -57.57694864645601,-38.057958707066845,0.0 -57.57729196920992,-38.058034736796316,0.0 -57.578697446733706,-38.05808542323875,0.0 -57.58417988196016,-38.05786578173466,0.0 -57.58449101820588,-38.057781304057556,0.0 -57.5845661200583,-38.05783199067552,0.0 -57.584866527467966,-38.05837264574944,0.0 -57.586207631975405,-38.05950462937395,0.0 -57.586400751024485,-38.05968202820562,0.0 -57.58652949705719,-38.060129747154214,0.0 -57.586905006319284,-38.061270150969015,0.0 -57.587934974581,-38.061084308596534,0.0 -57.58875036612152,-38.06092380798593,0.0 -57.58882546797395,-38.06078864930392,0.0 -57.588181737810366,-38.05884571566258,0.0 -57.58866453543305,-38.05849091351442,0.0 -57.58991980925202,-38.05914983042044,0.0 -57.59009147062898,-38.05919206848128,0.0 -57.59104633703827,-38.05986787413946,0.0 -57.5927047803998,-38.06098293983079,0.0 -57.59330928325653,-38.06147711123744,0.0 -57.593863494694226,-38.06192904285005,0.0 -57.594056613743305,-38.06214867215861,0.0 -57.594314105808735,-38.06241898424877,0.0 -57.594457268714905,-38.06284979207847,0.0 -57.594655752182,-38.06281600332075,0.0 ",
				"Polygon Outer Boundary",
				"1339",
				"0450058",
				"General Pueyrredon",
				"Mar Del Plata",
				"0058",
				"2015/02/04",
				"Nuevo Golf",
				"Asentamiento Precario",
				"90_o_anterior",
				"700",
				"55.2999999999999970000000000000000",
				"Gianelli, Mario Bravo, Don Orione, Calle 79, Cerrito,",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.668016958981745,-34.39622045373068,0.0 -58.66731422021986,-34.39584863079894,0.0 -58.66741077974438,-34.39568485112637,0.0 -58.66603748872876,-34.39495005189393,0.0 -58.66565661504864,-34.39545467374747,0.0 -58.6671425588429,-34.39621602727692,0.0 -58.66776483133435,-34.396543584222606,0.0 -58.668016958981745,-34.39622045373068,0.0 ",
				"Polygon Outer Boundary",
				"2265",
				"0570052",
				"Tigre",
				"Benavidez",
				"0052",
				"2015/09/24",
				"Bosch & Benavidez",
				"Asentamiento Precario",
				"90_o_anterior",
				"30",
				"1.3100000000000001000000000000000",
				"Bosch, Benavidez",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.62587928771973,-34.801593831885704,0.0 -58.62197399139404,-34.79829889900117,0.0 -58.617875576019294,-34.80152335341628,0.0 -58.616931438446045,-34.80363768128676,0.0 -58.61806869506836,-34.803954825789745,0.0 -58.618669509887695,-34.804818157421174,0.0 -58.61999988555908,-34.804976727554156,0.0 -58.62100839614868,-34.805434817335794,0.0 -58.621931076049805,-34.804747681708584,0.0 -58.62587928771973,-34.801593831885704,0.0 ",
				"Polygon Outer Boundary",
				"1637",
				"0700143",
				"La Matanza",
				"Gonzalez Catan",
				"0143",
				"2015/04/29",
				"Los Ceibos I",
				"Otros",
				"90_o_anterior",
				"400",
				"34.6700000000000020000000000000000",
				"Albaterio, Sunchales, Scarlatti, Dúngenes",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.30605804920197,-34.808015929477136,0.0 -58.30583274364471,-34.80731560157987,0.0 -58.304778384044766,-34.80753583111986,0.0 -58.3050012588501,-34.808249370787074,0.0 -58.30605804920197,-34.808015929477136,0.0 ",
				"Polygon Outer Boundary",
				"1659",
				"0320045",
				"Florencio Varela",
				"Florencio Varela",
				"0045",
				"2015/05/04",
				"Km 26 Cuadro Estación",
				"Villa",
				"90_o_anterior",
				"50",
				"0.8100000000000000500000000000000",
				"El ombú, La Cautiva, Santo Vega",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.903004313628,-34.9651298956451,0.0 -57.9029472406233,-34.9651271073884,0.0 -57.9029472406233,-34.9651271073884,0.0 -57.902147428114,-34.9657294714032,0.0 -57.9021320394985,-34.9658149530193,0.0 -57.9028954676085,-34.9665096139747,0.0 -57.9033803620944,-34.9669505559378,0.0 -57.9034205427569,-34.9669461131826,0.0 -57.9037953524624,-34.9658946909982,0.0 -57.9037856999966,-34.9658438780091,0.0 -57.9037856999966,-34.9658438780091,0.0 -57.903004313628,-34.9651298956451,0.0 ",
				"Polygon Outer Boundary",
				"410",
				"0550134",
				"La Plata",
				"Altos De San Lorenzo",
				"0134",
				"2014/10/31",
				"Los Robles",
				"Asentamiento Precario",
				"2006",
				"102",
				"5.2999999999999998000000000000000",
				"14, 18, 605, 610",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Sin dato"
			],
			[
				"",
				"",
				"-57.9042727108605,-34.9605119822368,0.0 -57.9042191292752,-34.9605054699468,0.0 -57.9037764862556,-34.9608349594071,0.0 -57.9037762102911,-34.9608758682373,0.0 -57.9043503911686,-34.9613989133653,0.0 -57.904225040633,-34.9615368830498,0.0 -57.9034755808543,-34.9620973636807,0.0 -57.9035807759238,-34.9622048887547,0.0 -57.903585366316,-34.9622481345609,0.0 -57.9041504516826,-34.9627632734657,0.0 -57.9041701282116,-34.9630007137064,0.0 -57.9034195018499,-34.9635677520991,0.0 -57.90341598125,-34.9636113985314,0.0 -57.9039349477988,-34.9640765375539,0.0 -57.9043319671581,-34.9644257502632,0.0 -57.9043523732164,-34.9644197041517,0.0 -57.9044882604893,-34.9640014690628,0.0 -57.904546217837,-34.9637513573197,0.0 -57.9046635548126,-34.9634371116678,0.0 -57.9050619976572,-34.9623676181565,0.0 -57.9051048536907,-34.9620602440472,0.0 -57.9053113537583,-34.9614909266859,0.0 -57.9052998560106,-34.9614437767839,0.0 -57.9042727108605,-34.9605119822368,0.0 ",
				"Polygon Outer Boundary",
				"410",
				"0550134",
				"La Plata",
				"Altos De San Lorenzo",
				"0134",
				"2014/10/31",
				"Los Robles",
				"Asentamiento Precario",
				"2006",
				"102",
				"5.2999999999999998000000000000000",
				"14, 18, 605, 610",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Sin dato"
			],
			[
				"",
				"",
				"-57.9294205095508,-34.9610259478018,0.0 -57.9308303439235,-34.9622851540275,0.0 -57.9322052392094,-34.9635435164329,0.0 -57.9326504682038,-34.9636047001505,0.0 -57.9339089139193,-34.9647203647614,0.0 -57.936670578042,-34.9626346396923,0.0 -57.9365976509995,-34.9625702213694,0.0 -57.9379000258681,-34.9616170856087,0.0 -57.9367560028226,-34.9605708802953,0.0 -57.9355861007154,-34.9595053908497,0.0 -57.9348289396151,-34.9600634153668,0.0 -57.934534189234,-34.9600400169185,0.0 -57.9337071137086,-34.9592710190405,0.0 -57.9336864645024,-34.9590296902874,0.0 -57.9340671970765,-34.9587456270735,0.0 -57.9336755519281,-34.9583605144372,0.0 -57.9337330668688,-34.9582810565682,0.0 -57.9317947908866,-34.9565133591831,0.0 -57.9313140034557,-34.9568923363912,0.0 -57.9289321487062,-34.9589162419209,0.0 -57.9280267956208,-34.9597230308612,0.0 -57.9288738061495,-34.9604971248558,0.0 -57.9294205095508,-34.9610259478018,0.0 ",
				"Polygon Outer Boundary",
				"404",
				"0550129",
				"La Plata",
				"Altos De San Lorenzo",
				"0129",
				"2014/10/31",
				"Puente de Fierro",
				"Asentamiento Precario",
				"1994",
				"921",
				"38.2999999999999970000000000000000",
				"23bis, 29, 84, 90",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.3217765779683,-34.7521599069117,0.0 -58.3207243680954,-34.751521325046234,0.0 -58.32130372524261,-34.7507323650918,0.0 -58.320305943489075,-34.750203449170556,0.0 -58.3192331587491,-34.7514198920262,0.0 -58.3199960178995,-34.7524643092291,0.0 -58.3203336943071,-34.7529746416207,0.0 -58.3204315247112,-34.7532400606075,0.0 -58.3202191336555,-34.7535352726607,0.0 -58.3201714777036,-34.7538497940661,0.0 -58.3203828072359,-34.7541167791175,0.0 -58.3211547267892,-34.754732229689,0.0 -58.3222415214207,-34.7555990480538,0.0 -58.3224319947472,-34.7560355357857,0.0 -58.3228876246979,-34.7564893744546,0.0 -58.3249313183138,-34.7538598831081,0.0 -58.3217765779683,-34.7521599069117,0.0 ",
				"Polygon Outer Boundary",
				"908",
				"0860040",
				"Quilmes",
				"Quilmes",
				"0040",
				"2014/10/01",
				"La Paz",
				"Otros",
				"decada_1960",
				"530",
				"14.3599999999999990000000000000000",
				"sin dato",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.885238338261836,-34.47082159809348,0.0 -58.88457851484417,-34.47152035082634,0.0 -58.88360755518078,-34.471095792901295,0.0 -58.88306038454175,-34.47177243107244,0.0 -58.88509886339306,-34.47282496843418,0.0 -58.88622002676129,-34.4713169170901,0.0 -58.885238338261836,-34.47082159809348,0.0 ",
				"Polygon Outer Boundary",
				"2280",
				"0840042",
				"Pilar",
				"Pilar",
				"0042",
				"2015/09/29",
				"Mundo Aparte",
				"Asentamiento Precario",
				"2010",
				"108",
				"3.2000000000000002000000000000000",
				"Brown y Loretto",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.56833539158106,-33.91123185724552,0.0 -60.567487478256226,-33.91157910834604,0.0 -60.56777715682983,-33.91197087711987,0.0 -60.56814193725585,-33.91242497049068,0.0 -60.56871056556701,-33.91327972791924,0.0 -60.56971907615662,-33.9129413874622,0.0 -60.56833539158106,-33.91123185724552,0.0 ",
				"Polygon Outer Boundary",
				"2219",
				"0820022",
				"Pergamino",
				"Pergamino",
				"0022",
				"2015/09/21",
				"La Bloquera",
				"Asentamiento Precario",
				"2014",
				"60",
				"2.0499999999999998000000000000000",
				"Álvarez Condarco y Ruta 8",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.76600218564272,-35.284022982419984,0.0 -59.766032695770264,-35.283672664267236,0.0 -59.76789951324463,-35.282288892746614,0.0 -59.769959449768066,-35.280799998245016,0.0 -59.769058227539055,-35.28002926563216,0.0 -59.768071174621575,-35.280782481676184,0.0 -59.76729869842529,-35.279959198667235,0.0 -59.76616144180297,-35.28072993194696,0.0 -59.7645092010498,-35.279118390359734,0.0 -59.76238489151001,-35.280624832386216,0.0 -59.76023007184266,-35.278733016967976,0.0 -59.75679684430361,-35.28113281233285,0.0 -59.75928593426942,-35.283322344598865,0.0 -59.755959995090954,-35.28572200395911,0.0 -59.75782681256533,-35.287543595695034,0.0 -59.75707579404116,-35.28815662215793,0.0 -59.75844908505678,-35.289400175866206,0.0 -59.76259041577577,-35.28651019772125,0.0 -59.76269770413637,-35.28659777433227,0.0 -59.76600218564272,-35.284022982419984,0.0 ",
				"Polygon Outer Boundary",
				"1340",
				"1090001",
				"Veinticinco de Mayo",
				"Norberto De La Riestra",
				"0001",
				"2015/02/04",
				"Avellaneda",
				"Otros",
				"decada_1990",
				"450",
				"69.7699999999999960000000000000000",
				"Burucuyá,  Martínez, 2 de Abril, Camino a la Merced.",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.62560033798218,-34.819599106157156,0.0 -58.62311124801635,-34.82173058559158,0.0 -58.6203821180672,-34.8237277503548,0.0 -58.61725330352783,-34.82620475144151,0.0 -58.6184549331665,-34.82662749470235,0.0 -58.619164503258,-34.8272021194641,0.0 -58.6202962917128,-34.8287899007256,0.0 -58.6206956001841,-34.8296260991128,0.0 -58.6210920122334,-34.8305947557191,0.0 -58.6201188817976,-34.8313892734454,0.0 -58.6204947253785,-34.8328501873942,0.0 -58.6210829087727,-34.8346277191327,0.0 -58.6212758748019,-34.8354061748719,0.0 -58.6218851124173,-34.8359225054571,0.0 -58.6257813441908,-34.832732901653,0.0 -58.6222831207407,-34.8296926073759,0.0 -58.6221956882791,-34.8296431002278,0.0 -58.6259831847454,-34.8265566063962,0.0 -58.6313538727741,-34.8223228325924,0.0 -58.6319886788613,-34.8217592614914,0.0 -58.6318179927029,-34.8216121729538,0.0 -58.631854089441,-34.8215353878115,0.0 -58.6290581237235,-34.819184577232,0.0 -58.6270295434118,-34.8207244306703,0.0 -58.62560033798218,-34.819599106157156,0.0 ",
				"Polygon Outer Boundary",
				"1053",
				"0700077",
				"La Matanza",
				"Virrey Del Pino",
				"0077",
				"2014/10/01",
				"El Fortín",
				"Asentamiento Precario",
				"2012",
				"1200",
				"90.8299999999999980000000000000000",
				"Av. Río de La Plata, Uriarte, Manzanares, Arroyo Manzanares",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.26397645287216,-34.797642539689356,0.0 -58.26512443833053,-34.7961624082379,0.0 -58.264083741232746,-34.79561175731526,0.0 -58.26293039135635,-34.79709630379499,0.0 -58.26397645287216,-34.797642539689356,0.0 ",
				"Polygon Outer Boundary",
				"1666",
				"0320051",
				"Florencio Varela",
				"Florencio Varela",
				"0051",
				"2015/05/05",
				"Villa Angelica",
				"Asentamiento Precario",
				"90_o_anterior",
				"130",
				"2.2200000000000002000000000000000",
				"Islas Orcadas del Sur, calle 158, Bolívar, El Salto",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.2905681245029,-34.792329801541996,0.0 -58.29095436260104,-34.79191128772382,0.0 -58.29554630443454,-34.79036937638162,0.0 -58.29896343871951,-34.78925037124025,0.0 -58.29931212589145,-34.789911202883836,0.0 -58.299564253538854,-34.78960281544246,0.0 -58.29933894798159,-34.78932086020118,0.0 -58.299231659621,-34.789127015413634,0.0 -58.29915940761566,-34.78870848534121,0.0 -58.297893404960625,-34.78915785438758,0.0 -58.297609090805054,-34.7889948482518,0.0 -58.29745888710022,-34.789153448820585,0.0 -58.297496438026435,-34.78919750448,0.0 -58.29506350681186,-34.790021340976296,0.0 -58.295117150992155,-34.79015791200664,0.0 -58.29030526801944,-34.79177031417,0.0 -58.2905681245029,-34.792329801541996,0.0 ",
				"Polygon Outer Boundary",
				"1663",
				"0320049",
				"Florencio Varela",
				"Florencio Varela",
				"0049",
				"2015/05/05",
				"Terraplén & Aº Las Piedras",
				"Villa",
				"decada_2000",
				"170",
				"4.1299999999999999000000000000000",
				"Terraplén, Aº Las Piedras, Diagonal Hernán Cortez",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.34049311717535,-34.76899431474487,0.0 -58.34136215289619,-34.76945701104028,0.0 -58.34180739959265,-34.76883567541787,0.0 -58.34269252856757,-34.76768112446427,0.0 -58.34318069060828,-34.76711265641994,0.0 -58.34147480567481,-34.76621808249938,0.0 -58.34125486453558,-34.76639435398963,0.0 -58.341313873133906,-34.766460455701434,0.0 -58.34217218001868,-34.76684825134437,0.0 -58.34248244762421,-34.767038943544364,0.0 -58.34217131137847,-34.76743114319672,0.0 -58.34196746349334,-34.76763385239886,0.0 -58.34220349788666,-34.7677836806196,0.0 -58.34240734577179,-34.767889441552846,0.0 -58.34208634933021,-34.76821433511783,0.0 -58.34194600582122,-34.768387397458994,0.0 -58.341726064682,-34.76856366431645,0.0 -58.34114221175696,-34.76820992843233,0.0 -58.341012597084045,-34.76821994359574,0.0 -58.34085702896118,-34.76839180413502,0.0 -58.34049311717535,-34.76899431474487,0.0 ",
				"Polygon Outer Boundary",
				"1702",
				"0030054",
				"Almirante Brown",
				"Almirante Brown",
				"0054",
				"2015/05/14",
				"Plaza CGT",
				"Asentamiento Precario",
				"2009",
				"80",
				"2.1400000000000001000000000000000",
				"Amenedo & Santa Ana",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.64247227087617,-34.80066879717982,0.0 -58.643341306596994,-34.80002567169583,0.0 -58.639811519533396,-34.79710070893763,0.0 -58.63895321264863,-34.79776147767042,0.0 -58.64247227087617,-34.80066879717982,0.0 ",
				"Polygon Outer Boundary",
				"1670",
				"0700148",
				"La Matanza",
				"Virrey Del Pino",
				"0148",
				"2015/05/05",
				"Chivilcoy & Caballito",
				"Asentamiento Precario",
				"2010",
				"70",
				"4.9000000000000004000000000000000",
				"Chivilcoy, Caballito, Saujil",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.4332352015353,-34.716301662083,0.0 -58.4320888957426,-34.7157353098716,0.0 -58.430936336517334,-34.71505380601273,0.0 -58.4291666780238,-34.7156356904731,0.0 -58.4284522184526,-34.7152400478855,0.0 -58.4278322470803,-34.7160628838452,0.0 -58.4274641710114,-34.7165013536176,0.0 -58.4262843886622,-34.7158645566381,0.0 -58.4255752123916,-34.7168283091022,0.0 -58.4233894905477,-34.7196526662058,0.0 -58.42571943998337,-34.71878417731592,0.0 -58.42614591121673,-34.71862764620526,0.0 -58.426993489265435,-34.71828151297895,0.0 -58.427320718765266,-34.71821096335379,0.0 -58.42806100845336,-34.718537254865566,0.0 -58.42879056930543,-34.719013461788144,0.0 -58.429927825927734,-34.71747018865553,0.0 -58.4332352015353,-34.716301662083,0.0 ",
				"Polygon Outer Boundary",
				"967",
				"0630044",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0044",
				"2014/10/01",
				"Centenario",
				"Villa",
				"90_o_anterior",
				"2100",
				"18.0500000000000010000000000000000",
				"Bolonia, Australia, Trinidad, Gral. Hornos",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.26512217521667,-34.798199784674964,0.0 -58.26544630341232,-34.798369380227335,0.0 -58.26558041386307,-34.797827554252436,0.0 -58.265444040298455,-34.79776368022401,0.0 -58.26512217521667,-34.798199784674964,0.0 ",
				"Polygon Outer Boundary",
				"1667",
				"0320052",
				"Florencio Varela",
				"Florencio Varela",
				"0052",
				"2015/05/05",
				"Diagonal Vía Pública",
				"Asentamiento Precario",
				"90_o_anterior",
				"12",
				"0.1400000000000000100000000000000",
				"Calle 210, Calle 158, Roque Pérez,",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.01960611343383,-34.38490124644695,0.0 -59.01932930959447,-34.38516686915984,0.0 -59.01861906051635,-34.38546790721571,0.0 -59.0177607536316,-34.38585748426948,0.0 -59.01719212532043,-34.38627362139272,0.0 -59.018887281417854,-34.387960283656895,0.0 -59.02121543884277,-34.386238205547855,0.0 -59.0214729309082,-34.386078834060605,0.0 -59.02015328407287,-34.385104890602214,0.0 -59.019960165023804,-34.384927808756174,0.0 -59.01960611343383,-34.38490124644695,0.0 ",
				"Polygon Outer Boundary",
				"1906",
				"0310002",
				"Exaltacion de la Cruz",
				"Pavon",
				"0002",
				"2015/07/15",
				"La Sidrera",
				"Asentamiento Precario",
				"decada_1950",
				"50",
				"6.7599999999999998000000000000000",
				"Calles La Felicidad, La Alameda, La Madrugada y Los Cachorros",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.316667744447,-34.7400346736956,0.0 -58.3172007882882,-34.7403476168019,0.0 -58.3161948593146,-34.7387582211561,0.0 -58.316035866737366,-34.73851795101765,0.0 -58.315660357475274,-34.738808896346626,0.0 -58.31517755985259,-34.73877803855727,0.0 -58.31479668617248,-34.73852676755783,0.0 -58.31318736076356,-34.73754812585542,0.0 -58.31287622451782,-34.737314484455794,0.0 -58.31375598907471,-34.73632701162141,0.0 -58.31424951553344,-34.73658710605736,0.0 -58.31448018550873,-34.73637550386647,0.0 -58.3133209677368,-34.7357203067668,0.0 -58.3111158268293,-34.7345485024472,0.0 -58.3107814782283,-34.7353235659495,0.0 -58.3102798716579,-34.7362839877226,0.0 -58.316667744447,-34.7400346736956,0.0 ",
				"Polygon Outer Boundary",
				"894",
				"0860054",
				"Quilmes",
				"Quilmes",
				"0054",
				"2014/10/01",
				"Sarita",
				"Asentamiento Precario",
				"2012",
				"350",
				"8.4700000000000006000000000000000",
				"La Rijo y Arroyo Las Piedras",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.307088855654,-34.741850536170475,0.0 -58.30534005537629,-34.743869417874265,0.0 -58.30628419294953,-34.74411626465389,0.0 -58.30660605803132,-34.744239687767106,0.0 -58.30664897337556,-34.744257319625355,0.0 -58.30757165327668,-34.745279960965576,0.0 -58.30921316519379,-34.742811494750036,0.0 -58.307088855654,-34.741850536170475,0.0 ",
				"Polygon Outer Boundary",
				"1476",
				"0860077",
				"Quilmes",
				"Quilmes",
				"0077",
				"2015/03/26",
				"Arroyito II",
				"Asentamiento Precario",
				"decada_1990",
				"180",
				"6.5000000000000000000000000000000",
				"Rodolfo López y 395",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.3188680657594,-34.7311075893669,0.0 -58.3190810342243,-34.7288266061097,0.0 -58.319351077079766,-34.72859874750063,0.0 -58.319517374038696,-34.7285105714644,0.0 -58.31967830657959,-34.72826367806253,0.0 -58.319817781448364,-34.72808732518114,0.0 -58.31997871398926,-34.72751417571809,0.0 -58.31997871398926,-34.72717028413271,0.0 -58.319807052612305,-34.726623581744214,0.0 -58.31947445869446,-34.727073288811496,0.0 -58.31913113594056,-34.7273025502964,0.0 -58.31851959228515,-34.72789333657702,0.0 -58.3175003528595,-34.727007155572686,0.0 -58.315156102180474,-34.72506722369565,0.0 -58.31483960151673,-34.725693297594894,0.0 -58.31459820270539,-34.72635463811334,0.0 -58.31443190574645,-34.726971884490354,0.0 -58.314394354820244,-34.727395136485065,0.0 -58.314394354820244,-34.727589126258366,0.0 -58.31409394741059,-34.727955060273175,0.0 -58.3155557513237,-34.72901096922224,0.0 -58.31556648015976,-34.72909473595179,0.0 -58.31626653671264,-34.72959953891932,0.0 -58.318884372711175,-34.73132334066027,0.0 -58.3188680657594,-34.7311075893669,0.0 ",
				"Polygon Outer Boundary",
				"893",
				"0860055",
				"Quilmes",
				"Quilmes",
				"0055",
				"2014/10/01",
				"Finexcor",
				"Villa",
				"2011",
				"810",
				"17.0000000000000000000000000000000",
				"Montevideo y Arroyo Las Piedras",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.17527621984482,-34.77755277485673,0.0 -58.174780011177056,-34.77793170604541,0.0 -58.17548274993896,-34.779042052530436,0.0 -58.17575097084046,-34.77891868143669,0.0 -58.1752735376358,-34.7781123586739,0.0 -58.1755793094635,-34.77799779851635,0.0 -58.17607283592225,-34.77882615299533,0.0 -58.1767362277071,-34.7786481083886,0.0 -58.17593336105347,-34.77735890241278,0.0 -58.17621231079101,-34.77711656121723,0.0 -58.1764966249466,-34.77731484043016,0.0 -58.176721930503845,-34.77711656121723,0.0 -58.176287412643426,-34.77673762628481,0.0 -58.17602187395096,-34.7769579375038,0.0 -58.17576974630355,-34.77715181088992,0.0 -58.17527621984482,-34.77755277485673,0.0 ",
				"Polygon Outer Boundary",
				"1189",
				"1200005",
				"Berazategui",
				"Berazategui",
				"0005",
				"2014/10/01",
				"Compal",
				"Asentamiento Precario",
				"1990",
				"85",
				"1.9500000000000000000000000000000",
				"Avenida Mitre, calle 157, calle 39, calle 40",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.3583933049649,-34.7549581559698,0.0 -58.3576645209877,-34.7559930109468,0.0 -58.3576732911325,-34.7560299018506,0.0 -58.3581817402388,-34.7562783954969,0.0 -58.3584666357797,-34.7563565936486,0.0 -58.3592841010697,-34.756761566941,0.0 -58.3595369349354,-34.7569425281284,0.0 -58.3601320747224,-34.7575017747401,0.0 -58.3601764625108,-34.7574937202723,0.0 -58.3606315710404,-34.7568782304518,0.0 -58.3606161402554,-34.7568467479164,0.0 -58.359782594514,-34.7566912239539,0.0 -58.3596659654028,-34.7565089440543,0.0 -58.359258544471,-34.7555971173128,0.0 -58.3591006853293,-34.7554069807681,0.0 -58.3584404943668,-34.7549519424708,0.0 -58.3583933049649,-34.7549581559698,0.0 ",
				"Polygon Outer Boundary",
				"952",
				"0630059",
				"Lomas de Zamora",
				"Temperley",
				"0059",
				"2014/10/01",
				"Cabaña Espindola",
				"Otros",
				"decada_1980",
				"90",
				"2.5299999999999998000000000000000",
				"El Tala (antigua traza del arroyo Las Perdices, hoy entubado), Suecia, El Trébol, y Nueva York",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.510260034352534,-35.11135186285493,0.0 -60.51005082204938,-35.111422075398636,0.0 -60.51059799268841,-35.112681502626096,0.0 -60.51095204427838,-35.11258496185501,0.0 -60.51042096689343,-35.11131236827252,0.0 -60.510260034352534,-35.11135186285493,0.0 ",
				"Polygon Outer Boundary",
				"2145",
				"0120002",
				"Bragado",
				"Bragado",
				"0002",
				"2015/09/02",
				"El Complejo",
				"Asentamiento Precario",
				"2004",
				"25",
				"0.9899999999999999900000000000000",
				"Humberto Illia y Neuquen",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.51257193088532,-35.11342310746263,0.0 -60.51220715045928,-35.11302378262012,0.0 -60.51162796095013,-35.113330955749596,0.0 -60.510946679860346,-35.11354158808341,0.0 -60.51102697849274,-35.11372589092885,0.0 -60.51257193088532,-35.11342310746263,0.0 ",
				"Polygon Outer Boundary",
				"2145",
				"0120002",
				"Bragado",
				"Bragado",
				"0002",
				"2015/09/02",
				"El Complejo",
				"Asentamiento Precario",
				"2004",
				"25",
				"0.9899999999999999900000000000000",
				"Humberto Illia y Neuquen",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.985191587358706,-35.57209082311751,0.0 -57.98521304503084,-35.57213445643542,0.0 -57.98543835058808,-35.571052343137815,0.0 -57.985642198473215,-35.57004875725805,0.0 -57.98425817862153,-35.569856765483294,0.0 -57.98411870375275,-35.56992658072735,0.0 -57.98396850004792,-35.57065091029448,0.0 -57.984065059572465,-35.57071199803084,0.0 -57.984397653490305,-35.570869080567576,0.0 -57.984612230211496,-35.57120942500725,0.0 -57.984912637621164,-35.57139268679896,0.0 -57.98492336645722,-35.57157594817147,0.0 -57.98479462042451,-35.572073369783695,0.0 -57.985191587358706,-35.57209082311751,0.0 ",
				"Polygon Outer Boundary",
				"1935",
				"0270011",
				"Chascomus",
				"Chascomus",
				"0011",
				"2015/07/20",
				"Anahí",
				"Otros",
				"90_o_anterior",
				"10",
				"2.1200000000000001000000000000000",
				"Balcarce, Lastra y Garay",
				"Cobertura Parcial",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.98019647598266,-35.5739670343276,0.0 -57.97783613204955,-35.573583069098014,0.0 -57.97736406326294,-35.576323144302904,0.0 -57.97961711883545,-35.57665473940297,0.0 -57.98019647598266,-35.5739670343276,0.0 ",
				"Polygon Outer Boundary",
				"1936",
				"0270012",
				"Chascomus",
				"Chascomús",
				"0012",
				"2015/07/20",
				"El Porteño",
				"Otros",
				"90_o_anterior",
				"8",
				"6.5000000000000000000000000000000",
				"Ruta 2 y General Villegas",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.6374327510449,-34.7963927114948,0.0 -58.63794922828674,-34.79590250146067,0.0 -58.63868951797485,-34.795506031917284,0.0 -58.63960146903992,-34.79495978186806,0.0 -58.640116453170776,-34.794669034398396,0.0 -58.64032030105591,-34.794413528199925,0.0 -58.64039540290833,-34.79421969538327,0.0 -58.640620708465576,-34.793585330252064,0.0 -58.64104986190796,-34.79296858169561,0.0 -58.641124963760376,-34.79232539614444,0.0 -58.64035248756408,-34.793585330252064,0.0 -58.639901876449585,-34.79438709647902,0.0 -58.63935470581055,-34.7947571398005,0.0 -58.63852858543396,-34.79518885490994,0.0 -58.6379599571228,-34.795506031917284,0.0 -58.637208938598626,-34.796298969097606,0.0 -58.6374327510449,-34.7963927114948,0.0 ",
				"Polygon Outer Boundary",
				"1040",
				"0700090",
				"La Matanza",
				"Gonzalez Catan",
				"0090",
				"2014/10/01",
				"Arroyo Morales & Chivilcoy",
				"Asentamiento Precario",
				"2009",
				"44",
				"1.6699999999999999000000000000000",
				"Arroyo Morales y Chivilcoy",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.28403258696198,-34.83785141521576,0.0 -58.28471923246979,-34.836539321455724,0.0 -58.284284714609385,-34.83656573965717,0.0 -58.284198883920915,-34.83670223356299,0.0 -58.28355515375734,-34.83649969413763,0.0 -58.28355515375734,-34.83631476640105,0.0 -58.28317428007722,-34.836195884065326,0.0 -58.282605651766055,-34.83716895295039,0.0 -58.28403258696198,-34.83785141521576,0.0 ",
				"Polygon Outer Boundary",
				"1568",
				"0320015",
				"Florencio Varela",
				"Santa Rosa",
				"0015",
				"2015/04/20",
				"Villa Mónica",
				"Asentamiento Precario",
				"decada_2000",
				"70",
				"1.8400000000000001000000000000000",
				"La Haya, Dinamarca, Austria",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.352980613708496,-34.80653598427934,0.0 -58.3514853993391,-34.8056928314848,0.0 -58.35096895694733,-34.80635979855704,0.0 -58.35196673870087,-34.80698085155204,0.0 -58.351773619651794,-34.80720108198653,0.0 -58.35219740867615,-34.8074301210141,0.0 -58.352406620979316,-34.80770760975249,0.0 -58.35255146026611,-34.80792343368086,0.0 -58.35241734981537,-34.808055570500905,0.0 -58.35317373275757,-34.80849602503763,0.0 -58.35324883460998,-34.808289011698555,0.0 -58.35358142852783,-34.807839746918575,0.0 -58.35248708724976,-34.807187868177046,0.0 -58.352980613708496,-34.80653598427934,0.0 ",
				"Polygon Outer Boundary",
				"1257",
				"0030022",
				"Almirante Brown",
				"Claypole",
				"0022",
				"2014/10/01",
				"Medalla Milagrosa (Acumar)",
				"Otros",
				"1980",
				"114",
				"2.5600000000000001000000000000000",
				"Alsina, Rojas, Roldan, Trípodi y San Francisco de Asis",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.63091421313583,-34.75641358999937,0.0 -58.63027048297226,-34.756426811944344,0.0 -58.62840902991593,-34.75490186699751,0.0 -58.62847876735032,-34.75512664388933,0.0 -58.62880599685013,-34.75642240462959,0.0 -58.629320980980985,-34.75646207045394,0.0 -58.63007736392319,-34.757096721052235,0.0 -58.63091421313583,-34.75641358999937,0.0 ",
				"Polygon Outer Boundary",
				"1674",
				"0700150",
				"La Matanza",
				"González Catán",
				"0150",
				"2015/05/05",
				"Matías y Huemul",
				"Asentamiento Precario",
				"90_o_anterior",
				"72",
				"1.6899999999999999000000000000000",
				"Matías, Antequera, Huemul, Quevedo y Villegas",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.25158774852752,-34.807187868177046,0.0 -58.25097620487213,-34.806897163832616,0.0 -58.24709236621856,-34.81351704037054,0.0 -58.24689388275146,-34.813420146478514,0.0 -58.24680805206299,-34.813605125628044,0.0 -58.24730157852173,-34.813754870349705,0.0 -58.24780583381653,-34.81365797673735,0.0 -58.25158774852752,-34.807187868177046,0.0 ",
				"Polygon Outer Boundary",
				"1675",
				"0320056",
				"Florencio Varela",
				"Florencio Varela",
				"0056",
				"2015/05/05",
				"Villa Esther",
				"Villa",
				"decada_2000",
				"280",
				"5.3899999999999997000000000000000",
				"Terraplén, La Meca, Perón",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.46077847480773,-35.128122165336336,0.0 -60.45868668705225,-35.12963141096038,0.0 -60.4594162479043,-35.13035092519086,0.0 -60.46140611171722,-35.12884169290167,0.0 -60.46077847480773,-35.128122165336336,0.0 ",
				"Polygon Outer Boundary",
				"2146",
				"0120003",
				"Bragado",
				"Bragado",
				"0003",
				"2015/09/02",
				"Las Violetas",
				"Asentamiento Precario",
				"2007",
				"30",
				"2.5299999999999998000000000000000",
				"Los Paraísos, Los claveles, Ibarguren",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.62809789367021,-34.75343419107553,0.0 -58.627738477662206,-34.75352674798538,0.0 -58.62602186389268,-34.75413056908945,0.0 -58.624546648934476,-34.75417905088442,0.0 -58.62262082286179,-34.75419227318721,0.0 -58.621912719681866,-34.7543333109518,0.0 -58.621537210419774,-34.75444349653778,0.0 -58.62169814296067,-34.754659459859816,0.0 -58.62222385592759,-34.75451401523566,0.0 -58.622518898919225,-34.75450520040172,0.0 -58.62372589297593,-34.75446553363734,0.0 -58.62462711520492,-34.7544611262179,0.0 -58.62606477923691,-34.75441264458852,0.0 -58.62649929709732,-34.7543156812444,0.0 -58.62743807025254,-34.754007160755606,0.0 -58.628264190629125,-34.75362371225587,0.0 -58.62809789367021,-34.75343419107553,0.0 ",
				"Polygon Outer Boundary",
				"1672",
				"0700149",
				"La Matanza",
				"González Catán",
				"0149",
				"2015/05/05",
				"Cascada",
				"Asentamiento Precario",
				"90_o_anterior",
				"106",
				"2.0099999999999998000000000000000",
				"Tunuyán, Matías y Tinogasta",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.24782729148865,-34.81408518862637,0.0 -58.2463252544403,-34.81456965303676,0.0 -58.24619650840759,-34.81471939600548,0.0 -58.24597120285034,-34.81568831451949,0.0 -58.246486186981194,-34.81591732995789,0.0 -58.2438406907022,-34.82053273616869,0.0 -58.24338555335998,-34.820400619356974,0.0 -58.24249505996704,-34.82199481473694,0.0 -58.24301004409791,-34.82242638718486,0.0 -58.24782729148865,-34.81408518862637,0.0 ",
				"Polygon Outer Boundary",
				"1676",
				"0320057",
				"Florencio Varela",
				"Florencio Varela",
				"0057",
				"2015/05/05",
				"Santa Marta",
				"Villa",
				"decada_2000",
				"200",
				"4.3600000000000003000000000000000",
				"Terraplén, Diag. Tomás Espora, Av. Bosques",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.300913572311394,-34.79421529008669,0.0 -58.29874098300933,-34.79699939059701,0.0 -58.30000698566436,-34.7976733754787,0.0 -58.300216197967536,-34.797664565254344,0.0 -58.30093502998351,-34.79900370855121,0.0 -58.3012568950653,-34.79959398191297,0.0 -58.30151438713074,-34.799179909997214,0.0 -58.30121397972107,-34.79861606404435,0.0 -58.30099940299987,-34.79809626514036,0.0 -58.30076336860657,-34.797655755029055,0.0 -58.30092966556549,-34.79728572471664,0.0 -58.301138877868645,-34.796898072131874,0.0 -58.30112278461457,-34.79642671937449,0.0 -58.30083310604095,-34.79615359785208,0.0 -58.300913572311394,-34.79553246327949,0.0 -58.30101549625396,-34.79506110271507,0.0 -58.30095112323761,-34.794686655486345,0.0 -58.300913572311394,-34.79421529008669,0.0 ",
				"Polygon Outer Boundary",
				"1591",
				"0320029",
				"Florencio Varela",
				"San Juan Bautista",
				"0029",
				"2015/04/22",
				"El Molino III",
				"Asentamiento Precario",
				"2012",
				"150",
				"5.2000000000000002000000000000000",
				"Dr Argerich, Calle 54 D",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.49903767183422,-35.10803425120603,0.0 -60.499692130833864,-35.10784993548772,0.0 -60.49947755411267,-35.107310151343356,0.0 -60.4987265355885,-35.107200438681744,0.0 -60.49903767183422,-35.10803425120603,0.0 ",
				"Polygon Outer Boundary",
				"2150",
				"0120007",
				"Bragado",
				"Bragado",
				"0007",
				"2015/09/02",
				"Hermanos Islas & Catamarca",
				"Asentamiento Precario",
				"90_o_anterior",
				"10",
				"0.5000000000000000000000000000000",
				"Hermanos Islas, Catamarca, Salta",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.97999513149261,-34.61742237018354,0.0 -60.979571342468255,-34.617771132418135,0.0 -60.98052620887756,-34.61855694575301,0.0 -60.98093390464783,-34.61820818682038,0.0 -60.97999513149261,-34.61742237018354,0.0 ",
				"Polygon Outer Boundary",
				"1757",
				"0540009",
				"Junin",
				"Junin",
				"0009",
				"2015/06/08",
				"Las Marias",
				"Asentamiento Precario",
				"2010",
				"13",
				"0.6700000000000000400000000000000",
				"Los Ciruelos, Mayor López, Avellaneda",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.552926782518625,-37.946058867996854,0.0 -57.55292904563249,-37.94607578930097,0.0 -57.55459737963974,-37.945563918127476,0.0 -57.55491614341736,-37.9454835413383,0.0 -57.55508780479431,-37.94539047336729,0.0 -57.555356025695794,-37.945314326757895,0.0 -57.556343078613274,-37.94495897487063,0.0 -57.55610704421997,-37.94449363051482,0.0 -57.55610704421997,-37.94440902213352,0.0 -57.55602121353149,-37.94429057023603,0.0 -57.55595684051513,-37.944155196405084,0.0 -57.55564880557359,-37.943964826533374,0.0 -57.55575072951615,-37.94388444799501,0.0 -57.555874111130834,-37.94392252205046,0.0 -57.5566787738353,-37.943677155569304,0.0 -57.55674851126969,-37.94367292510554,0.0 -57.55740297026932,-37.943537550136746,0.0 -57.557435156777494,-37.94349947588184,0.0 -57.55616378970444,-37.94239108337061,0.0 -57.556115509942174,-37.94239108337061,0.0 -57.554996609687805,-37.943228725055796,0.0 -57.555229961872094,-37.94342332731284,0.0 -57.55386739969254,-37.9444957457231,0.0 -57.553593814373016,-37.94428422459327,0.0 -57.55294895265251,-37.94476226147979,0.0 -57.55249029491096,-37.94511338393754,0.0 -57.55249029491096,-37.945178954812995,0.0 -57.55258417222649,-37.94524241044322,0.0 -57.55242860410362,-37.94542643146097,0.0 -57.55180633161218,-37.94572890178772,0.0 -57.551235021092,-37.9460482921798,0.0 -57.551082135178156,-37.94649036003454,0.0 -57.55111432168632,-37.946585541760555,0.0 -57.552926782518625,-37.946058867996854,0.0 ",
				"Polygon Outer Boundary",
				"1341",
				"0450059",
				"General Pueyrredon",
				"Mar Del Plata",
				"0059",
				"2015/02/04",
				"Meyrelles & Puja",
				"Asentamiento Precario",
				"90_o_anterior",
				"100",
				"7.9199999999999999000000000000000",
				"Meyrelles, Puja, Ghandi, Vuelta de Obligado",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.98046502098441,-34.61857018973423,0.0 -60.9795262478292,-34.61777996182277,0.0 -60.979032721370466,-34.618190528101266,0.0 -60.979976858943694,-34.618958678909706,0.0 -60.98046502098441,-34.61857018973423,0.0 ",
				"Polygon Outer Boundary",
				"1758",
				"0540010",
				"Junin",
				"Junín",
				"0010",
				"2015/06/08",
				"Los Almendros",
				"Asentamiento Precario",
				"2013",
				"40",
				"0.7700000000000000200000000000000",
				"Los Muerdagos - Pasaje sin nombre - Los Olmos",
				"Inexistente",
				"Sin dato",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.40767353773116,-34.89437265728126,0.0 -58.4083092212677,-34.89334086512136,0.0 -58.40913534164429,-34.892293659827885,0.0 -58.408448696136475,-34.8919680554616,0.0 -58.407791554927826,-34.891642449804834,0.0 -58.406332433223724,-34.893699463865836,0.0 -58.40767353773116,-34.89437265728126,0.0 ",
				"Polygon Outer Boundary",
				"1242",
				"0030037",
				"Almirante Brown",
				"Glew",
				"0037",
				"2014/10/01",
				"Santa Teresita",
				"Asentamiento Precario",
				"2003",
				"80",
				"4.2599999999999998000000000000000",
				"San Roque, Patagones, M. Iglesias y El Ceibo",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.407510791621455,-34.890338814261646,0.0 -58.40687242587592,-34.891223240652245,0.0 -58.40734449466253,-34.891430045449795,0.0 -58.407988224826106,-34.890523620562945,0.0 -58.407510791621455,-34.890338814261646,0.0 ",
				"Polygon Outer Boundary",
				"1242",
				"0030037",
				"Almirante Brown",
				"Glew",
				"0037",
				"2014/10/01",
				"Santa Teresita",
				"Asentamiento Precario",
				"2003",
				"80",
				"4.2599999999999998000000000000000",
				"San Roque, Patagones, M. Iglesias y El Ceibo",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.62952172756195,-34.45148859383024,0.0 -58.630264114512,-34.4504784510288,0.0 -58.6298087443528,-34.4502254705747,0.0 -58.6294054462143,-34.4507547413089,0.0 -58.6292154172781,-34.4509973330137,0.0 -58.6290458919902,-34.4512169889131,0.0 -58.62952172756195,-34.45148859383024,0.0 ",
				"Polygon Outer Boundary",
				"693",
				"0570023",
				"Tigre",
				"General Pacheco",
				"0023",
				"2014/10/01",
				"Bajo Pacheco II",
				"Villa",
				"90_o_anterior",
				"60",
				"0.6800000000000000500000000000000",
				"Córdoba, San Luis, Isla Soledad",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-59.67756581492722,-33.67551495358868,0.0 -59.67691672034562,-33.67590333995958,0.0 -59.67732441611588,-33.67638100814822,0.0 -59.67786848545074,-33.67703723955723,0.0 -59.678560495376594,-33.67661314500142,0.0 -59.67927932739257,-33.67618904835393,0.0 -59.678801894187934,-33.675644415907236,0.0 -59.678000332787626,-33.67598369554145,0.0 -59.67756581492722,-33.67551495358868,0.0 ",
				"Polygon Outer Boundary",
				"1937",
				"0990017",
				"San Pedro",
				"San Pedro",
				"0017",
				"2015/07/20",
				"Riobamba & Rivero",
				"Asentamiento Precario",
				"90_o_anterior",
				"45",
				"1.8500000000000001000000000000000",
				"Riobamba & Rivero",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.2039648552156,-33.3671471206305,0.0 -60.204485111217,-33.3667674936281,0.0 -60.2051231788793,-33.3662715409811,0.0 -60.2054014346437,-33.3661160020236,0.0 -60.2059040211692,-33.3657214313513,0.0 -60.2060837324532,-33.3655163748971,0.0 -60.2062620000645,-33.3653829093388,0.0 -60.2050841363648,-33.3642860541074,0.0 -60.2034330829397,-33.365535262554,0.0 -60.2027455387871,-33.3660582458775,0.0 -60.2026339625191,-33.3661791551761,0.0 -60.2023770495339,-33.3663660295847,0.0 -60.2021584943321,-33.3660876943997,0.0 -60.2021066766071,-33.3659833709728,0.0 -60.201659941311,-33.3654442964671,0.0 -60.2015423114865,-33.3653633415137,0.0 -60.2011092585508,-33.3648371359398,0.0 -60.2008291284487,-33.364458998527,0.0 -60.2006038428169,-33.3642401784366,0.0 -60.2002150065336,-33.363874026251,0.0 -60.1999903867852,-33.3636631382208,0.0 -60.1997877931056,-33.3634984675476,0.0 -60.199637466323,-33.3633541793294,0.0 -60.1984340049708,-33.3642330262338,0.0 -60.1983274923615,-33.3643141620813,0.0 -60.1971438500511,-33.3651784486255,0.0 -60.1969575592798,-33.365286037304,0.0 -60.1957739516336,-33.3661777199562,0.0 -60.1959959668819,-33.3663787917883,0.0 -60.1961919210386,-33.3665057914604,0.0 -60.1966430980587,-33.3669301922982,0.0 -60.1968163405043,-33.3671342252454,0.0 -60.1972663399948,-33.3675578141695,0.0 -60.1974475794551,-33.3676856464822,0.0 -60.1978987686679,-33.3681100426311,0.0 -60.1980452277917,-33.3682522652734,0.0 -60.1985054391325,-33.3686723169911,0.0 -60.1985958909053,-33.3688506031992,0.0 -60.1988115798378,-33.3690517703472,0.0 -60.199806141737,-33.3700687351486,0.0 -60.2020826652343,-33.3684251816338,0.0 -60.2023608368443,-33.3682279945656,0.0 -60.2026465002532,-33.3681111294736,0.0 -60.2031333147709,-33.3677626686904,0.0 -60.2032932286163,-33.3676341961871,0.0 -60.203780995296,-33.3672815840142,0.0 -60.2039648552156,-33.3671471206305,0.0 ",
				"Polygon Outer Boundary",
				"423",
				"0980008",
				"San Nicolas",
				"San Nicolás",
				"0008",
				"2014/07/25",
				"9 de julio",
				"Asentamiento Precario",
				"decada_1970",
				"500",
				"32.2000000000000030000000000000000",
				"Av. De La Paz paralela Ruta 188, Catamarca, Pombo, Cangallos, Vías del Ferrocarril",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.56731129065155,-33.8688298847421,0.0 -60.56559467688203,-33.87007704040575,0.0 -60.566152576357126,-33.8712083729961,0.0 -60.568105224519975,-33.870486816146794,0.0 -60.56731129065155,-33.8688298847421,0.0 ",
				"Polygon Outer Boundary",
				"1941",
				"0820002",
				"Pergamino",
				"Pergamino",
				"0002",
				"2015/07/20",
				"San José I",
				"Otros",
				"90_o_anterior",
				"40",
				"3.3199999999999998000000000000000",
				"Champagnat y Chiclana",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.565858371555805,-33.863110551846404,0.0 -60.56856203824281,-33.865801002273294,0.0 -60.569119937717915,-33.86742235860782,0.0 -60.57411957532167,-33.86341345447394,0.0 -60.57199526578188,-33.861471295454386,0.0 -60.570106990635395,-33.85992110013248,0.0 -60.565858371555805,-33.863110551846404,0.0 ",
				"Polygon Outer Boundary",
				"1940",
				"0820001",
				"Pergamino",
				"Pergamino",
				"0001",
				"2015/07/20",
				"Santa Teresita",
				"Otros",
				"90_o_anterior",
				"70",
				"30.7500000000000000000000000000000",
				"Champagnat y Juan Manuel de Rosas",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.56709051132202,-33.874691357926615,0.0 -60.56761622428893,-33.8757157382096,0.0 -60.566173195838935,-33.876210108642994,0.0 -60.56518077850341,-33.8764773347119,0.0 -60.565341711044304,-33.87690934842013,0.0 -60.566795468330376,-33.879937836722,0.0 -60.569761991500854,-33.87890905348543,0.0 -60.56906009092927,-33.87742598049866,0.0 -60.56762242689729,-33.87445084946922,0.0 -60.56709051132202,-33.874691357926615,0.0 ",
				"Polygon Outer Boundary",
				"1942",
				"0820003",
				"Pergamino",
				"Pergamino",
				"0003",
				"2015/07/20",
				"San José II",
				"Asentamiento Precario",
				"90_o_anterior",
				"400",
				"16.2100000000000010000000000000000",
				"Sarratea y Carnevale",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.56689286604523,-33.8729276135002,0.0 -60.56497240439057,-33.873604610620404,0.0 -60.56563759222627,-33.875118926844046,0.0 -60.56759024038911,-33.87436177209078,0.0 -60.56689286604523,-33.8729276135002,0.0 ",
				"Polygon Outer Boundary",
				"1942",
				"0820003",
				"Pergamino",
				"Pergamino",
				"0003",
				"2015/07/20",
				"San José II",
				"Asentamiento Precario",
				"90_o_anterior",
				"400",
				"16.2100000000000010000000000000000",
				"Sarratea y Carnevale",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.56200051680208,-33.87741707307553,0.0 -60.56030536070465,-33.87872645429885,0.0 -60.560702327638865,-33.87932324043589,0.0 -60.56097054854035,-33.87981313638423,0.0 -60.561775211244814,-33.879082745031994,0.0 -60.56200051680208,-33.87869082514373,0.0 -60.56200051680208,-33.87812966398812,0.0 -60.561946872621775,-33.87780899881381,0.0 -60.561979059129946,-33.87756849914233,0.0 -60.56200051680208,-33.87741707307553,0.0 ",
				"Polygon Outer Boundary",
				"1943",
				"0820004",
				"Pergamino",
				"Pergamino",
				"0004",
				"2015/07/20",
				"La Latita",
				"Villa",
				"2010",
				"70",
				"2.1099999999999999000000000000000",
				"Córdoba & Barbazán",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.614155627787106,-33.74238974031699,0.0 -59.61397323757409,-33.74254140556041,0.0 -59.613361693918705,-33.742050722920844,0.0 -59.61269650608301,-33.74284473524272,0.0 -59.613093473017216,-33.743130221022625,0.0 -59.61265359073877,-33.74372795379676,0.0 -59.61249265819788,-33.74428999723214,0.0 -59.61270723491908,-33.74452195059214,0.0 -59.61468134075404,-33.742782285101704,0.0 -59.614155627787106,-33.74238974031699,0.0 ",
				"Polygon Outer Boundary",
				"2164",
				"0990032",
				"San Pedro",
				"San Pedro",
				"0032",
				"2015/09/08",
				"Bajo Campodónico",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"3.9100000000000001000000000000000",
				"s/n",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.61315784603357,-33.73795564379581,0.0 -59.61269650608301,-33.73836605269654,0.0 -59.61355481296778,-33.73938314455341,0.0 -59.613383151590824,-33.73987384245266,0.0 -59.613511897623546,-33.74022179017126,0.0 -59.61411271244287,-33.73978462486157,0.0 -59.614016152918346,-33.739151177296684,0.0 -59.61382303386927,-33.738410662241364,0.0 -59.61315784603357,-33.73795564379581,0.0 ",
				"Polygon Outer Boundary",
				"2164",
				"0990032",
				"San Pedro",
				"San Pedro",
				"0032",
				"2015/09/08",
				"Bajo Campodónico",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"3.9100000000000001000000000000000",
				"s/n",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-61.5234443945575,-34.8776734734513,0.0 -61.5227006335178,-34.8770296272912,0.0 -61.5221514432513,-34.8774830047495,0.0 -61.5206106133465,-34.8761611684881,0.0 -61.5201996857019,-34.875891594856,0.0 -61.5200925566068,-34.8759773853239,0.0 -61.5219914680075,-34.8776150641267,0.0 -61.5219285442717,-34.8776664145867,0.0 -61.5226665687566,-34.8783194400995,0.0 -61.5234443945575,-34.8776734734513,0.0 ",
				"Polygon Outer Boundary",
				"435",
				"0600002",
				"Lincoln",
				"Lincoln",
				"0002",
				"2014/08/01",
				"Chacra 599",
				"Asentamiento Precario",
				"2007",
				"158",
				"5.6799999999999997000000000000000",
				"Fortín Ancalú y 9 de julio",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-61.5221514432513,-34.8774830047495,0.0 -61.5227006335208,-34.8770296270821,0.0 -61.5219941161108,-34.8764180269065,0.0 -61.5214339152999,-34.8768673930826,0.0 -61.5221514432513,-34.8774830047495,0.0 ",
				"Polygon Outer Boundary",
				"435",
				"0600002",
				"Lincoln",
				"Lincoln",
				"0002",
				"2014/08/01",
				"Chacra 599",
				"Asentamiento Precario",
				"2007",
				"158",
				"5.6799999999999997000000000000000",
				"Fortín Ancalú y 9 de julio",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-61.5209025879895,-34.8785043870891,0.0 -61.5217980646284,-34.8777729581961,0.0 -61.5216652900196,-34.877666015045,0.0 -61.5215407461076,-34.8774834401333,0.0 -61.521275520831,-34.8772523380184,0.0 -61.5210756883767,-34.8771375769453,0.0 -61.5208209596754,-34.876917153879,0.0 -61.5206918849838,-34.8767496862807,0.0 -61.5204278228897,-34.8765211775679,0.0 -61.5202490379446,-34.8763564044038,0.0 -61.5199849766836,-34.8761278043329,0.0 -61.5199335487102,-34.8761263744132,0.0 -61.5193482528999,-34.8765794700088,0.0 -61.5192671662754,-34.8766423118474,0.0 -61.5191898650975,-34.8767088018269,0.0 -61.5190112208628,-34.8768606486752,0.0 -61.5192800234058,-34.8770913546822,0.0 -61.519482929964,-34.8772772784652,0.0 -61.5209025879895,-34.8785043870891,0.0 ",
				"Polygon Outer Boundary",
				"435",
				"0600002",
				"Lincoln",
				"Lincoln",
				"0002",
				"2014/08/01",
				"Chacra 599",
				"Asentamiento Precario",
				"2007",
				"158",
				"5.6799999999999997000000000000000",
				"Fortín Ancalú y 9 de julio",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7104537713276,-34.3965392127475,0.0 -58.7104432364855,-34.3964958349947,0.0 -58.7095979038437,-34.3960483951113,0.0 -58.7095489158527,-34.3960590555969,0.0 -58.709300616051,-34.3960337211124,0.0 -58.7070936850716,-34.3973024677188,0.0 -58.7067912828374,-34.3974856787505,0.0 -58.7066197522545,-34.397573373044,0.0 -58.7063763441746,-34.3976539075656,0.0 -58.7054345158868,-34.3981630541156,0.0 -58.7054408464369,-34.3981968330476,0.0 -58.704403638839715,-34.398668246795395,0.0 -58.70498299598694,-34.39897808891369,0.0 -58.7059325681166,-34.3984618449535,0.0 -58.7061151388641,-34.3985444212361,0.0 -58.7069968414765,-34.3990243591798,0.0 -58.7071750071424,-34.3991346793191,0.0 -58.708033661669,-34.3995938144356,0.0 -58.7080825099333,-34.3995853164477,0.0 -58.7086385684952,-34.3988744933732,0.0 -58.7087764095693,-34.3987288415078,0.0 -58.7092755095035,-34.3980795200007,0.0 -58.7093929402749,-34.397924458071,0.0 -58.7098487718665,-34.3973304733412,0.0 -58.7099545714716,-34.3971891693586,0.0 -58.7104537713276,-34.3965392127475,0.0 ",
				"Polygon Outer Boundary",
				"684",
				"0570032",
				"Tigre",
				"Tigre",
				"0032",
				"2014/10/01",
				"La Mascota",
				"Otros",
				"90_o_anterior",
				"130",
				"8.7500000000000000000000000000000",
				"Mar Argentino, Arequipa, Ángel Gallardo,",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.68416905403137,-34.68503274476193,0.0 -58.6851738516509,-34.6846131899624,0.0 -58.6853934213958,-34.6845423694176,0.0 -58.6866765586007,-34.6840214354609,0.0 -58.6868840580483,-34.6839543652795,0.0 -58.6871612064806,-34.6838462348001,0.0 -58.6873269851842,-34.6837815556296,0.0 -58.6875956201436,-34.6836767467129,0.0 -58.6876067752252,-34.683647482949,0.0 -58.6872015045265,-34.6829160017929,0.0 -58.6871119578033,-34.6827547777479,0.0 -58.68704974651337,-34.68263747091268,0.0 -58.68628799915314,-34.683272688408856,0.0 -58.686175346374505,-34.68336091267568,0.0 -58.685654997825615,-34.68380203259966,0.0 -58.685123920440674,-34.68425197250095,0.0 -58.68497908115387,-34.68437989614411,0.0 -58.68416905403137,-34.68503274476193,0.0 ",
				"Polygon Outer Boundary",
				"656",
				"0720006",
				"Merlo",
				"Libertad",
				"0006",
				"2014/10/01",
				"La Merced",
				"Otros",
				"1989",
				"200",
				"2.1499999999999999000000000000000",
				"Sarmiento, España, Isla Trinidad, Aconquija",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.65702551789582,-34.76812740315713,0.0 -58.65701881237327,-34.76812740315713,0.0 -58.65701545961201,-34.76812740315713,0.0 -58.65701210685074,-34.76812740315713,0.0 -58.65616452880204,-34.76853722431183,0.0 -58.658387660980225,-34.77048935521191,0.0 -58.659878969192505,-34.769352453891905,0.0 -58.660933496430516,-34.768501970959164,0.0 -58.66136491298676,-34.7680877429374,0.0 -58.661048412323,-34.76780130745122,0.0 -58.660651445388794,-34.767510464248154,0.0 -58.66087985225022,-34.76729012780596,0.0 -58.66119098849594,-34.76684504639861,0.0 -58.661684514954686,-34.76636911510969,0.0 -58.661920549348,-34.766188436772104,0.0 -58.662279965356,-34.765747756241275,0.0 -58.66238951683044,-34.765694874419474,0.0 -58.66243243217469,-34.76550538094648,0.0 -58.66247534751892,-34.765108765292574,0.0 -58.662620186805725,-34.764972152792765,0.0 -58.66277349181473,-34.76489723616462,0.0 -58.663371205329895,-34.76538639645042,0.0 -58.664095401763916,-34.765959283189694,0.0 -58.66476595401763,-34.76541724429919,0.0 -58.66349768824875,-34.76421416965422,0.0 -58.66370916366577,-34.7637822924278,0.0 -58.66377890110015,-34.763676526232004,0.0 -58.66380572319031,-34.76356194603363,0.0 -58.66401803679764,-34.76336804072025,0.0 -58.66450083442032,-34.762795135997116,0.0 -58.66469395346939,-34.76244257726822,0.0 -58.66500198841095,-34.76194017847802,0.0 -58.665136098861694,-34.76158761609788,0.0 -58.66532695479691,-34.761323193324685,0.0 -58.66556835360825,-34.761076397972246,0.0 -58.66561126895249,-34.760882486820634,0.0 -58.66571855731308,-34.76077230982703,0.0 -58.665884854272015,-34.76070179647395,0.0 -58.666700245812535,-34.76065331850878,0.0 -58.666391372680664,-34.760331600382266,0.0 -58.6655039805919,-34.75965290323622,0.0 -58.66502654738724,-34.7602566795427,0.0 -58.66473686881364,-34.76067094686305,0.0 -58.66452455520629,-34.760710610646385,0.0 -58.663975121453404,-34.76164931462311,0.0 -58.66361570544541,-34.762204599275044,0.0 -58.663234831765294,-34.76281276389405,0.0 -58.66265547461807,-34.763645677732704,0.0 -58.66277349181473,-34.76376025781485,0.0 -58.66237652488052,-34.763976196768134,0.0 -58.66187226958572,-34.76419213515654,0.0 -58.66168987937271,-34.7644212936448,0.0 -58.66162550635636,-34.76473418209186,0.0 -58.661614777520306,-34.76502944193311,0.0 -58.66133046336471,-34.76539961695844,0.0 -58.66111588664353,-34.76557589019655,0.0 -58.659946443513036,-34.76516605433812,0.0 -58.65979850292206,-34.76544368530327,0.0 -58.660236122086644,-34.76558911067424,0.0 -58.66065680980682,-34.76578301077033,0.0 -58.66125762462615,-34.76602979205204,0.0 -58.66115880198777,-34.766214877529144,0.0 -58.660692097619176,-34.766959622039785,0.0 -58.65988207049667,-34.76758978522336,0.0 -58.65961384959518,-34.76771317325549,0.0 -58.65954101085663,-34.767669106122334,0.0 -58.65919232368469,-34.76792469516714,0.0 -58.6591762304306,-34.768052489392744,0.0 -58.658937932923436,-34.76814502991535,0.0 -58.65863752551377,-34.76839180413502,0.0 -58.65855395793915,-34.768532817643575,0.0 -58.65796387195587,-34.76883247054928,0.0 -58.657915592193596,-34.76887653706129,0.0 -58.65763127803802,-34.76886331711016,0.0 -58.65711092948913,-34.768092149629425,0.0 -58.657038928940885,-34.76812740315713,0.0 -58.65702551789582,-34.76812740315713,0.0 ",
				"Polygon Outer Boundary",
				"1681",
				"0700153",
				"La Matanza",
				"González Catán",
				"0153",
				"2015/05/05",
				"Arroyo Las Víboras",
				"Villa",
				"90_o_anterior",
				"448",
				"17.4200000000000020000000000000000",
				"Arroyo Las Viboras entre Coronel Monasterio y Avenida Otero",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.816782999783754,-34.620680370413524,0.0 -58.81530795246362,-34.62108650781819,0.0 -58.81495909765362,-34.62130281932035,0.0 -58.81464259698988,-34.62136462250312,0.0 -58.814288545399904,-34.620653883122436,0.0 -58.81222324445843,-34.62122335801773,0.0 -58.8121266849339,-34.621029118957686,0.0 -58.811177182942636,-34.621298404805536,0.0 -58.811461329460144,-34.622097428161965,0.0 -58.81012558937073,-34.62246382856479,0.0 -58.81060302257537,-34.62379256826156,0.0 -58.811944294720895,-34.62335112886189,0.0 -58.81494836881757,-34.62252563088293,0.0 -58.81582276895642,-34.622238691159495,0.0 -58.815672397613525,-34.621925263558595,0.0 -58.81539361551404,-34.62121452897941,0.0 -58.81682591512799,-34.62083929398249,0.0 -58.816782999783754,-34.620680370413524,0.0 ",
				"Polygon Outer Boundary",
				"51",
				"0740009",
				"Moreno",
				"La Reja",
				"0009",
				"2014/09/11",
				"Lomas Verdes",
				"Asentamiento Precario",
				"2012",
				"220",
				"9.8599999999999994000000000000000",
				"Laferrere, Ricardo Rojas, Estanislao del Campo",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.640068532899015,-33.76767398347024,0.0 -59.64049232192337,-33.767192363565236,0.0 -59.63954508304596,-33.76619343957751,0.0 -59.63882088661194,-33.76571181135152,0.0 -59.63820397853851,-33.76626925118133,0.0 -59.63896036148071,-33.766840065809454,0.0 -59.640068532899015,-33.76767398347024,0.0 ",
				"Polygon Outer Boundary",
				"1952",
				"0990021",
				"San Pedro",
				"Río Tala",
				"0021",
				"2015/07/21",
				"Sargento Cabral",
				"Asentamiento Precario",
				"decada_2010",
				"80",
				"2.3500000000000001000000000000000",
				"Sargento Cabral entre vías y Carmelino",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.6384240873158,-33.76580992102449,0.0 -59.639545250684016,-33.7646102995864,0.0 -59.63940577581524,-33.76447205217058,0.0 -59.63912146165966,-33.7646325975358,0.0 -59.63819341734051,-33.765600322950434,0.0 -59.6384240873158,-33.76580992102449,0.0 ",
				"Polygon Outer Boundary",
				"1952",
				"0990021",
				"San Pedro",
				"Río Tala",
				"0021",
				"2015/07/21",
				"Sargento Cabral",
				"Asentamiento Precario",
				"decada_2010",
				"80",
				"2.3500000000000001000000000000000",
				"Sargento Cabral entre vías y Carmelino",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.66479897871613,-34.770083950336286,0.0 -58.66468096151947,-34.77018970832192,0.0 -58.66416597738862,-34.770692056902924,0.0 -58.66346860304475,-34.77124728072439,0.0 -58.66262102499604,-34.77191706956958,0.0 -58.662781957536936,-34.77202282520609,0.0 -58.66361880674959,-34.77274548509506,0.0 -58.6650993861258,-34.773996905544095,0.0 -58.66638684645295,-34.77510730498111,0.0 -58.666569236665964,-34.77527474486956,0.0 -58.66671323776245,-34.77539812141206,0.0 -58.66611242294311,-34.77586518808038,0.0 -58.66714239120483,-34.7768521881921,0.0 -58.667614459991455,-34.77656137688606,0.0 -58.668118715286255,-34.7754950599946,0.0 -58.66927742958068,-34.77577706249626,0.0 -58.67043614387512,-34.77574181223626,0.0 -58.671187162399285,-34.775027991231156,0.0 -58.66942763328552,-34.77317731542266,0.0 -58.668833021074526,-34.773485764273126,0.0 -58.66787815466523,-34.772630917486,0.0 -58.66479897871613,-34.770083950336286,0.0 ",
				"Polygon Outer Boundary",
				"1682",
				"0700154",
				"La Matanza",
				"González Catán",
				"0154",
				"2015/05/05",
				"Santa Cecilia",
				"Asentamiento Precario",
				"2011",
				"180",
				"23.3500000000000010000000000000000",
				"Vega, Castro, Scarlatti y Mar Chiquita",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-60.2360120326468,-33.3575641487631,0.0 -60.2348805316704,-33.3564243934641,0.0 -60.2347927535825,-33.3564894847865,0.0 -60.2359621819235,-33.3575860802716,0.0 -60.2360120326468,-33.3575641487631,0.0 ",
				"Polygon Outer Boundary",
				"426",
				"0980011",
				"San Nicolas",
				"San Nicolás",
				"0011",
				"2014/07/25",
				"12 de Marzo",
				"Asentamiento Precario",
				"1988",
				"73",
				"0.0800000000000000020000000000000",
				"España entre Ferreyra y Guido Lavalle; España, Del Forno, Ameghino, Campo",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.2407396455068,-33.3604677765518,0.0 -60.2404075787098,-33.3607178084746,0.0 -60.2402147662479,-33.3608142945108,0.0 -60.2398550022363,-33.3610739357194,0.0 -60.2398493103135,-33.3611140688713,0.0 -60.2407698077343,-33.3620176956767,0.0 -60.2415337062356,-33.3627412957972,0.0 -60.2417113176566,-33.3628973814275,0.0 -60.2420079217176,-33.3631872156333,0.0 -60.2421656482012,-33.3633400937035,0.0 -60.2426877227973,-33.3638384820311,0.0 -60.2428504776492,-33.3639826938187,0.0 -60.2433315212602,-33.3644449144578,0.0 -60.2435059076518,-33.3646366179898,0.0 -60.2438026023555,-33.3649161693245,0.0 -60.2438669735775,-33.3649193788988,0.0 -60.2447061179454,-33.3642921830644,0.0 -60.2447098349008,-33.3642381688297,0.0 -60.2444131396257,-33.3639586194519,0.0 -60.244241969855,-33.3638031561942,0.0 -60.2437739854266,-33.3633621916551,0.0 -60.2436039930131,-33.3631657012424,0.0 -60.2430722132632,-33.3626551636482,0.0 -60.2429399689305,-33.3625086385496,0.0 -60.2427875222248,-33.3623610708666,0.0 -60.2426289356186,-33.3622077447974,0.0 -60.242490106112,-33.3620882807122,0.0 -60.2417387675165,-33.3613614159321,0.0 -60.2408013250278,-33.3604701814861,0.0 -60.2407396455068,-33.3604677765518,0.0 ",
				"Polygon Outer Boundary",
				"426",
				"0980011",
				"San Nicolas",
				"San Nicolás",
				"0011",
				"2014/07/25",
				"12 de Marzo",
				"Asentamiento Precario",
				"1988",
				"73",
				"0.0800000000000000020000000000000",
				"España entre Ferreyra y Guido Lavalle; España, Del Forno, Ameghino, Campo",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.559650182724,-34.51409784050157,0.0 -58.56074452400207,-34.51338176346423,0.0 -58.56169939041138,-34.51250212954504,0.0 -58.56158673763275,-34.51244908599678,0.0 -58.560787439346306,-34.5130502442333,0.0 -58.560647964477546,-34.512904375353834,0.0 -58.559510707855225,-34.51391219149021,0.0 -58.559650182724,-34.51409784050157,0.0 ",
				"Polygon Outer Boundary",
				"872",
				"0970012",
				"San Isidro",
				"San Isidro",
				"0012",
				"2014/10/01",
				"Nueva Esperanza",
				"Villa",
				"90_o_anterior",
				"90",
				"0.7099999999999999600000000000000",
				"Terraplén Ferrovias Belgrano",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.40810424182564,-34.82831404257179,0.0 -58.40813106391578,-34.82828541998484,0.0 -58.408200801350176,-34.827695352129595,0.0 -58.40873724315315,-34.826964366684756,0.0 -58.40805864427239,-34.82663850361245,0.0 -58.40711718890816,-34.82782965899068,0.0 -58.40810424182564,-34.82831404257179,0.0 ",
				"Polygon Outer Boundary",
				"2090",
				"0030075",
				"Almirante Brown",
				"Burzaco",
				"0075",
				"2015/08/07",
				"San Pablo (Acumar)",
				"Villa",
				"1989",
				"30",
				"1.2700000000000000000000000000000",
				"Juan XXIII, San Pablo, Eva Perón y P. Vieira",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.85198722034693,-34.88438198851206,0.0 -57.85102128982545,-34.88397714390917,0.0 -57.85022769123315,-34.883616302473435,0.0 -57.84947097301483,-34.88328186265485,0.0 -57.84891843795776,-34.88410915867273,0.0 -57.84801721572875,-34.884615213301764,0.0 -57.84860763698816,-34.88541169297096,0.0 -57.84981966018677,-34.886824215277244,0.0 -57.85315666347742,-34.88491884458339,0.0 -57.85198722034693,-34.88438198851206,0.0 ",
				"Polygon Outer Boundary",
				"1309",
				"1140007",
				"Berisso",
				"Berisso",
				"0007",
				"2015/01/30",
				"Santa Teresita II",
				"Asentamiento Precario",
				"2013",
				"140",
				"9.0399999999999991000000000000000",
				"170 y 42",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.3159999832437,-34.7150649193109,0.0 -58.3155550168971,-34.7153563431322,0.0 -58.3154703609986,-34.7153694753901,0.0 -58.3150000443802,-34.7149415234965,0.0 -58.3147152929441,-34.7147126366726,0.0 -58.3145471997152,-34.7148242535447,0.0 -58.3144397754059,-34.7149338980174,0.0 -58.3148181770211,-34.71531058804,0.0 -58.3152755914685,-34.7157378164051,0.0 -58.3154414009794,-34.7159151067014,0.0 -58.3157214615514,-34.7161959453626,0.0 -58.3158342973098,-34.7157638852112,0.0 -58.3159522681615,-34.7153861103413,0.0 -58.3159999832437,-34.7150649193109,0.0 ",
				"Polygon Outer Boundary",
				"887",
				"0860061",
				"Quilmes",
				"Quilmes",
				"0061",
				"2014/10/01",
				"El Triángulo",
				"Asentamiento Precario",
				"2011",
				"72",
				"0.8299999999999999600000000000000",
				"Pilcomayo, Cabezas y Arroyo",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.696204544976354,-38.56702140130849,0.0 -58.6953837890178,-38.56637127750302,0.0 -58.694986822083585,-38.566673271228055,0.0 -58.694970728829496,-38.56672360339218,0.0 -58.695775391533964,-38.56734016954149,0.0 -58.695818306878216,-38.567327586611725,0.0 -58.696204544976354,-38.56702140130849,0.0 ",
				"Polygon Outer Boundary",
				"1484",
				"0760004",
				"Necochea",
				"Quequén",
				"0004",
				"2015/04/01",
				"Plan Federal 6 bis",
				"Otros",
				"decada_2010",
				"18",
				"0.5300000000000000300000000000000",
				"Calles 522 – 522 bis – 525 - 527",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.37369573302567,-34.877899834724175,0.0 -58.37442219257354,-34.878221094032895,0.0 -58.37551653385162,-34.87674681152291,0.0 -58.37487280368805,-34.87642554645231,0.0 -58.37428045459092,-34.8771560926024,0.0 -58.374003767967224,-34.87701086406551,0.0 -58.37348115630447,-34.87676001417018,0.0 -58.37293398566544,-34.87752136324276,0.0 -58.37369573302567,-34.877899834724175,0.0 ",
				"Polygon Outer Boundary",
				"2091",
				"0030076",
				"Almirante Brown",
				"Glew",
				"0076",
				"2015/08/09",
				"El Ombú II",
				"Asentamiento Precario",
				"1998",
				"90",
				"2.2300000000000000000000000000000",
				"Lagos, San Martín, El Plata y Montevideo",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.318017013371,-34.7158475161278,0.0 -58.32007694989443,-34.71445410887361,0.0 -58.31692267209291,-34.71119097470654,0.0 -58.31458378583193,-34.71314887065628,0.0 -58.31649351865053,-34.71478923428153,0.0 -58.31683684140444,-34.714701043516385,0.0 -58.318017013371,-34.7158475161278,0.0 ",
				"Polygon Outer Boundary",
				"1480",
				"0860078",
				"Quilmes",
				"Quilmes",
				"0078",
				"2015/03/31",
				"San Ignacio/ El Progreso",
				"Asentamiento Precario",
				"decada_1960",
				"360",
				"12.2899999999999990000000000000000",
				"Lynch, Bermejo, 162 y Victoria",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.37602078914642,-34.87602066265725,0.0 -58.375479150563486,-34.87572139944007,0.0 -58.37496953085064,-34.876377136538295,0.0 -58.37555425241589,-34.8766763973683,0.0 -58.37602078914642,-34.87602066265725,0.0 ",
				"Polygon Outer Boundary",
				"2092",
				"0030077",
				"Almirante Brown",
				"Glew",
				"0077",
				"2015/08/10",
				"Alsina & San Juan (Barrio Villa París)",
				"Asentamiento Precario",
				"2004",
				"30",
				"0.5200000000000000200000000000000",
				"San Juan, San Martín, El Plata y Alsina",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0063020327311,-34.9687487035103,0.0 -58.0077588558197,-34.970001350757435,0.0 -58.00824165344238,-34.97047610489514,0.0 -58.00853133201599,-34.97031345795411,0.0 -58.00656259059905,-34.96859465567708,0.0 -58.0076118865385,-34.9677338031818,0.0 -58.0084967231918,-34.9685448644281,0.0 -58.0095229936859,-34.9677029260339,0.0 -58.0087114028666,-34.966958020736,0.0 -58.0092887420631,-34.9665828803898,0.0 -58.0082243290983,-34.9656976744025,0.0 -58.0077299313881,-34.9660296145939,0.0 -58.0055318154883,-34.9639911364445,0.0 -58.0047324348856,-34.9632124996743,0.0 -58.00363898277282,-34.96229500299613,0.0 -58.00342440605164,-34.96212794350633,0.0 -58.00183653831482,-34.963235805341824,0.0 -58.001192808151245,-34.96365784400583,0.0 -58.000935316085815,-34.963846881452525,0.0 -58.00120890140534,-34.96409306910134,0.0 -58.00094604492187,-34.96433485982213,0.0 -58.00190091133118,-34.965187715940225,0.0 -58.00376772880555,-34.96693736204362,0.0 -58.00414323806762,-34.96670876718727,0.0 -58.0063020327311,-34.9687487035103,0.0 ",
				"Polygon Outer Boundary",
				"385",
				"0550111",
				"La Plata",
				"Lisandro Olmos",
				"0111",
				"2014/10/24",
				"Retiro",
				"Asentamiento Precario",
				"1996",
				"300",
				"26.3000000000000010000000000000000",
				"159, 164, 49, 52",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.662582945518,-34.5942170999644,0.0 -58.6628203534994,-34.5940259105976,0.0 -58.6621375203453,-34.5934460642849,0.0 -58.6614125893622,-34.5940505843666,0.0 -58.6614132392609,-34.5940916031748,0.0 -58.6619023678905,-34.5945160988117,0.0 -58.66205155849457,-34.5946701950877,0.0 -58.662582945518,-34.5942170999644,0.0 ",
				"Polygon Outer Boundary",
				"100",
				"1350007",
				"Hurlingham",
				"Hurlingham",
				"0007",
				"2014/07/23",
				"Latinoamerica",
				"Otros",
				"1986",
				"13",
				"0.8800000000000000000000000000000",
				"Pedro Díaz - Bolivia - EL Jaguel",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.707521203905344,-34.88855353195603,0.0 -58.707274440675974,-34.888659137902295,0.0 -58.706802371889346,-34.88865033741197,0.0 -58.70611572638153,-34.88872074130826,0.0 -58.705278877168894,-34.88903755809512,0.0 -58.704742435365915,-34.88935437366038,0.0 -58.704324010759585,-34.889662387622096,0.0 -58.70370173826813,-34.889864796168226,0.0 -58.70282197371125,-34.89006720421572,0.0 -58.70223188772797,-34.89023441048755,0.0 -58.70172763243317,-34.89032241365184,0.0 -58.70095515623689,-34.890181608543735,0.0 -58.700504545122385,-34.890551221437846,0.0 -58.7006332911551,-34.89058642257914,0.0 -58.700815681368105,-34.89068322563993,0.0 -58.70126629248262,-34.89068322563993,0.0 -58.701995853334665,-34.89062162370536,0.0 -58.70296144858003,-34.8904368176245,0.0 -58.70345497503876,-34.89032241365184,0.0 -58.703969959169626,-34.89022561016594,0.0 -58.70406651869417,-34.890181608543735,0.0 -58.70413089171052,-34.89022561016594,0.0 -58.704828266054385,-34.89107043674251,0.0 -58.704248908907175,-34.89144004563806,0.0 -58.70481753721833,-34.89209125726547,0.0 -58.705374598503106,-34.89172165129958,0.0 -58.70599150657654,-34.89241686114349,0.0 -58.70660925284028,-34.892073657019075,0.0 -58.70661998167633,-34.89200325599584,0.0 -58.705965522676706,-34.89124644118587,0.0 -58.70554709807038,-34.89078882884889,0.0 -58.705278877168894,-34.89057762229523,0.0 -58.705117944628,-34.8903928161154,0.0 -58.70496774092316,-34.890032002851974,0.0 -58.704806808382266,-34.889811993986875,0.0 -58.70498919859528,-34.889644786855385,0.0 -58.70545053854584,-34.88935437366038,0.0 -58.70585823431612,-34.889160764293436,0.0 -58.706223014742136,-34.88908156033001,0.0 -58.706716541200876,-34.889011156742875,0.0 -58.70717788115144,-34.889011156742875,0.0 -58.70762849226593,-34.88893195263524,0.0 -58.70780015364289,-34.8888791498544,0.0 -58.707521203905344,-34.88855353195603,0.0 ",
				"Polygon Outer Boundary",
				"1049",
				"0700081",
				"La Matanza",
				"Virrey Del Pino",
				"0081",
				"2014/10/01",
				"Roberto Arlt",
				"Asentamiento Precario",
				"2002",
				"73",
				"5.5599999999999996000000000000000",
				"Lord Byron, Renquecura y Arroyo Chacón",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.753177262842655,-34.617740229494494,0.0 -58.75155720859765,-34.617369393513364,0.0 -58.74938998371363,-34.617298757900535,0.0 -58.74685797840357,-34.61720163383475,0.0 -58.746718503534794,-34.617881499908634,0.0 -58.74754462391138,-34.61849955514331,0.0 -58.74788794666528,-34.61827882165925,0.0 -58.749958612024784,-34.62016828128776,0.0 -58.753252364695065,-34.61778437652474,0.0 -58.753177262842655,-34.617740229494494,0.0 ",
				"Polygon Outer Boundary",
				"2224",
				"0740060",
				"Moreno",
				"Paso Del Rey",
				"0060",
				"2015/09/22",
				"Bongiovani II",
				"Otros",
				"decada_2000",
				"250",
				"10.3900000000000010000000000000000",
				"Roma, Bouchard, Uruguay,Leonardo Da Vinci",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.5550911463797,-33.88847046978218,0.0 -60.55288100615144,-33.889263124102186,0.0 -60.55319214239716,-33.890118113762874,0.0 -60.55243039503693,-33.89034967198781,0.0 -60.55301427841186,-33.89169893144899,0.0 -60.5536687374115,-33.891516359635254,0.0 -60.55420517921447,-33.89303035798084,0.0 -60.55549800395966,-33.89264740799733,0.0 -60.555026773363345,-33.89103543688947,0.0 -60.555005315691226,-33.890545605379465,0.0 -60.5550911463797,-33.88847046978218,0.0 ",
				"Polygon Outer Boundary",
				"1945",
				"0820006",
				"Pergamino",
				"Pergamino",
				"0006",
				"2015/07/20",
				"Virgen de Itatí",
				"Asentamiento Precario",
				"90_o_anterior",
				"105",
				"8.0700000000000003000000000000000",
				"Drago y Nuestra Sra de Itatí",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.756645442917936,-38.53490664671338,0.0 -58.75588905997574,-38.53429399860867,0.0 -58.7558085937053,-38.53429399860867,0.0 -58.755020024254925,-38.53488146949682,0.0 -58.75501465983688,-38.534936020121584,0.0 -58.75578713603318,-38.535548662758885,0.0 -58.75584078021347,-38.53555285892334,0.0 -58.75663471408188,-38.5349570011201,0.0 -58.756645442917936,-38.53490664671338,0.0 ",
				"Polygon Outer Boundary",
				"1485",
				"0760005",
				"Necochea",
				"Necochea",
				"0005",
				"2015/04/01",
				"Tiro Federal",
				"Otros",
				"decada_2000",
				"20",
				"1.0700000000000001000000000000000",
				"calle 49 - 51 - 100 - 102",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9973303103713,-34.903395428528,0.0 -57.9971812517414,-34.9035053080706,0.0 -57.997402553678,-34.9036953691877,0.0 -57.9990015470273,-34.9051734682026,0.0 -57.9990482133372,-34.9051753182402,0.0 -57.9996311305481,-34.9047667575321,0.0 -58.0002213943023,-34.9043437152745,0.0 -58.0022454241319,-34.9028022443619,0.0 -58.0022481429158,-34.9027667815015,0.0 -58.0017570866891,-34.9023199083688,0.0 -58.0024174416734,-34.9018333950019,0.0 -58.0016875144732,-34.9012365043098,0.0 -58.0010394793637,-34.9016794218204,0.0 -58.0002748012655,-34.9009505591173,0.0 -58.0003468132297,-34.9010980102342,0.0 -57.9987119384194,-34.9023221473284,0.0 -57.997731176607,-34.903064263418,0.0 -57.9973303103713,-34.903395428528,0.0 ",
				"Polygon Outer Boundary",
				"337",
				"0550065",
				"La Plata",
				"Hernandez",
				"0065",
				"2014/10/07",
				"Nini",
				"Otros",
				"decada_1990",
				"348",
				"11.0000000000000000000000000000000",
				"21, 23, 516, 520",
				"Cobertura Parcial",
				"Sin dato",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.59009933844208,-33.88225366701877,0.0 -60.58941269293427,-33.88244071210706,0.0 -60.58910608291626,-33.882378363789854,0.0 -60.58846771717071,-33.88260103614209,0.0 -60.58853292837739,-33.88274354614254,0.0 -60.588683132082224,-33.88318888835976,0.0 -60.58904791250824,-33.883171074715705,0.0 -60.589423421770334,-33.88318888835976,0.0 -60.59033537283539,-33.88280589419289,0.0 -60.59009933844208,-33.88225366701877,0.0 ",
				"Polygon Outer Boundary",
				"1946",
				"0820007",
				"Pergamino",
				"Pergamino",
				"0007",
				"2015/07/20",
				"Desamparados",
				"Asentamiento Precario",
				"decada_1990",
				"15",
				"1.2000000000000000000000000000000",
				"Parborel entre vías FFCC",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.59685850515962,-33.89838257196617,0.0 -60.59340381994843,-33.899442288304996,0.0 -60.59403682127595,-33.900795856406276,0.0 -60.59445524588227,-33.90097395587256,0.0 -60.596676114946604,-33.90081366636965,0.0 -60.59714818373322,-33.90064447156745,0.0 -60.59770608320832,-33.900377321196174,0.0 -60.59781337156891,-33.90019922048363,0.0 -60.59685850515962,-33.89838257196617,0.0 ",
				"Polygon Outer Boundary",
				"1947",
				"0820008",
				"Pergamino",
				"Pergamino",
				"0008",
				"2015/07/20",
				"Güemes Sur",
				"Asentamiento Precario",
				"2000",
				"60",
				"7.7400000000000002000000000000000",
				"Dean Funes y Monroe",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.59823799878359,-33.90119657968225,0.0 -60.59815669432282,-33.90094724097634,0.0 -60.59798503294587,-33.90092052607174,0.0 -60.597416404634714,-33.90113424507412,0.0 -60.59659028425813,-33.90127672411144,0.0 -60.595925096422434,-33.90153496675969,0.0 -60.59531355276703,-33.901499347130574,0.0 -60.5932536162436,-33.90140139307377,0.0 -60.59399390593171,-33.9028885016393,0.0 -60.59577489271759,-33.902380928577614,0.0 -60.59659028425813,-33.904250919652526,0.0 -60.599310882389545,-33.90338716696765,0.0 -60.59823799878359,-33.90119657968225,0.0 ",
				"Polygon Outer Boundary",
				"1948",
				"0820009",
				"Pergamino",
				"Pergamino",
				"0009",
				"2015/07/20",
				"Belgrano",
				"Asentamiento Precario",
				"2005",
				"80",
				"10.5299999999999990000000000000000",
				"Niñas de Ayohuma y Arroyo Pergamino",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.640108682215214,-33.771468875245255,0.0 -59.644056893885136,-33.76823141053634,0.0 -59.643177129328244,-33.767633848581546,0.0 -59.64207205921411,-33.76882004958172,0.0 -59.6397864818573,-33.77129942420331,0.0 -59.63927686214446,-33.77100957295995,0.0 -59.638622403144836,-33.77174088805918,0.0 -59.639233946800225,-33.772128839266834,0.0 -59.640108682215214,-33.771468875245255,0.0 ",
				"Polygon Outer Boundary",
				"1951",
				"0990020",
				"San Pedro",
				"Río Tala",
				"0020",
				"2015/07/21",
				"9 de Julio & Rivadavia",
				"Asentamiento Precario",
				"90_o_anterior",
				"60",
				"4.4500000000000002000000000000000",
				"9 de Julio & Rivadavia",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.3295586652364,-34.7470443442146,0.0 -58.3292763029404,-34.7468758951872,0.0 -58.32914113998414,-34.74677863660964,0.0 -58.32833647727967,-34.746258511084555,0.0 -58.327848145353,-34.7468183454936,0.0 -58.3275943987148,-34.7470848350823,0.0 -58.3284305988285,-34.7476057446179,0.0 -58.3288667289208,-34.7478176266603,0.0 -58.3291047955896,-34.7476115143115,0.0 -58.3293566240504,-34.7473334985281,0.0 -58.3293192967829,-34.7473109949688,0.0 -58.3295586652364,-34.7470443442146,0.0 ",
				"Polygon Outer Boundary",
				"906",
				"0860042",
				"Quilmes",
				"Quilmes",
				"0042",
				"2014/10/01",
				"La Unión",
				"Asentamiento Precario",
				"90_o_anterior",
				"90",
				"1.6100000000000001000000000000000",
				"Tomás Flores- 802- 891-890",
				"Cobertura Parcial",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.30916241052,-34.7380771398444,0.0 -58.3073933821352,-34.7372203176669,0.0 -58.3049635079322,-34.7405767833556,0.0 -58.3076026663829,-34.7418993539859,0.0 -58.30916241052,-34.7380771398444,0.0 ",
				"Polygon Outer Boundary",
				"905",
				"0860043",
				"Quilmes",
				"Quilmes",
				"0043",
				"2014/10/01",
				"Arroyito",
				"Asentamiento Precario",
				"2005",
				"420",
				"10.2700000000000000000000000000000",
				"Rodolfo López, Rep. del Líbano, Arroyo Las Piedras, 392",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.420937061309814,-34.81238073210614,0.0 -58.421519519761205,-34.81160997145716,0.0 -58.42057764530182,-34.81112548964484,0.0 -58.42027723789215,-34.81150867095011,0.0 -58.41999292373657,-34.81190065917726,0.0 -58.420937061309814,-34.81238073210614,0.0 ",
				"Polygon Outer Boundary",
				"1487",
				"0630073",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0073",
				"2015/04/06",
				"Las Maderitas",
				"Asentamiento Precario",
				"2000",
				"45",
				"1.0300000000000000000000000000000",
				"Calles Juan F. Seguí, Manuel Sarratea, Necochea y Silva",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.32205608487129,-34.801690739682776,0.0 -58.31984594464302,-34.800536648517316,0.0 -58.31886962056161,-34.80170835927,0.0 -58.3206184208393,-34.80359363334262,0.0 -58.32205608487129,-34.801690739682776,0.0 ",
				"Polygon Outer Boundary",
				"1649",
				"0320037",
				"Florencio Varela",
				"Florencio Varela",
				"0037",
				"2015/05/04",
				"Triangulo de Don José",
				"Asentamiento Precario",
				"2012",
				"220",
				"5.1500000000000004000000000000000",
				"Calle 441, calle 445, calle 402 a",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.3226890861988,-34.80084499506694,0.0 -58.32238867878913,-34.8006776070831,0.0 -58.32207754254341,-34.80109167147622,0.0 -58.32238867878913,-34.8012854881371,0.0 -58.3226890861988,-34.80084499506694,0.0 ",
				"Polygon Outer Boundary",
				"1649",
				"0320037",
				"Florencio Varela",
				"Florencio Varela",
				"0037",
				"2015/05/04",
				"Triangulo de Don José",
				"Asentamiento Precario",
				"2012",
				"220",
				"5.1500000000000004000000000000000",
				"Calle 441, calle 445, calle 402 a",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.325874209403985,-34.80353196618126,0.0 -58.32307172007859,-34.804117802351335,0.0 -58.323087813332684,-34.8041926833662,0.0 -58.32708966918289,-34.80335136922905,0.0 -58.32705748267472,-34.80327208263724,0.0 -58.325874209403985,-34.80353196618126,0.0 ",
				"Polygon Outer Boundary",
				"1684",
				"0320060",
				"Florencio Varela",
				"Florencio Varela",
				"0060",
				"2015/05/06",
				"Don José IV",
				"Villa",
				"2012",
				"110",
				"0.6800000000000000500000000000000",
				"Diag. Los Tilos, calle 402 A, calle 449",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.32438826560975,-34.803424048537885,0.0 -58.324101688340306,-34.803765420191674,0.0 -58.32507801242172,-34.803562799767704,0.0 -58.325126292183995,-34.803501132583285,0.0 -58.32454157061875,-34.80319720078606,0.0 -58.324270248413086,-34.80302541275277,0.0 -58.32405298948288,-34.80326327301122,0.0 -58.32438826560975,-34.803424048537885,0.0 ",
				"Polygon Outer Boundary",
				"1684",
				"0320060",
				"Florencio Varela",
				"Florencio Varela",
				"0060",
				"2015/05/06",
				"Don José IV",
				"Villa",
				"2012",
				"110",
				"0.6800000000000000500000000000000",
				"Diag. Los Tilos, calle 402 A, calle 449",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.753745555877686,-38.53875446106445,0.0 -58.752366900444024,-38.53983701513393,0.0 -58.75330030918121,-38.54055870879537,0.0 -58.75463604927063,-38.539480361523104,0.0 -58.753745555877686,-38.53875446106445,0.0 ",
				"Polygon Outer Boundary",
				"1486",
				"0760006",
				"Necochea",
				"Necochea",
				"0006",
				"2015/04/01",
				"53 viviendas",
				"Otros",
				"decada_1990",
				"53",
				"1.9099999999999999000000000000000",
				"calle 55 - 53 - 90 bis - 94",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.332649664665,-34.7476540292963,0.0 -58.3322681655374,-34.7474998646722,0.0 -58.3320014133613,-34.747290886524,0.0 -58.3316064896969,-34.747061819099,0.0 -58.3308756975854,-34.7465630375591,0.0 -58.32963466644287,-34.74828610056175,0.0 -58.331576585769646,-34.74919409188787,0.0 -58.332649664665,-34.7476540292963,0.0 ",
				"Polygon Outer Boundary",
				"923",
				"0860025",
				"Quilmes",
				"Quilmes",
				"0025",
				"2014/10/01",
				"La Paz II",
				"Asentamiento Precario",
				"90_o_anterior",
				"240",
				"4.2000000000000002000000000000000",
				"Eva Perón, 802, Tomás Flores y 194",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.5529744643718,-33.91205101141994,0.0 -60.55303883738816,-33.9133465054823,0.0 -60.55312466807663,-33.913293083436045,0.0 -60.55323732085526,-33.913163980019306,0.0 -60.55346799083053,-33.91301706899685,0.0 -60.55372548289597,-33.91288796516198,0.0 -60.553843500092626,-33.912790024191274,0.0 -60.55396688170731,-33.91262530503218,0.0 -60.55423510260879,-33.91232257709874,0.0 -60.55431020446121,-33.912117789945775,0.0 -60.55433166213333,-33.91204210761254,0.0 -60.5529744643718,-33.91205101141994,0.0 ",
				"Polygon Outer Boundary",
				"1955",
				"0820014",
				"Pergamino",
				"Pergamino",
				"0014",
				"2015/07/21",
				"La 513",
				"Asentamiento Precario",
				"2003",
				"35",
				"1.0900000000000001000000000000000",
				"Roldán y José Hernández",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-60.562536120414734,-33.912456133672514,0.0 -60.56181192398071,-33.91153904098356,0.0 -60.56069159880281,-33.912166760831475,0.0 -60.56056285277009,-33.91238935541179,0.0 -60.560026410967104,-33.9129413874622,0.0 -60.559972766786814,-33.91318178739876,0.0 -60.56111991405487,-33.91465978692231,0.0 -60.5619192123413,-33.914152283951566,0.0 -60.56122183799744,-33.91320849846097,0.0 -60.562536120414734,-33.912456133672514,0.0 ",
				"Polygon Outer Boundary",
				"1957",
				"0820016",
				"Pergamino",
				"Pergamino",
				"0016",
				"2015/07/21",
				"Cristo Rey",
				"Asentamiento Precario",
				"2013",
				"80",
				"3.8700000000000001000000000000000",
				"Beltran y Guiraldes",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.3330344852447,-34.756775828034,0.0 -58.3319921532753,-34.7562477554557,0.0 -58.3314861077456,-34.7569348685419,0.0 -58.3313861784338,-34.7571079994596,0.0 -58.3301308433953,-34.7564930403695,0.0 -58.3296526410126,-34.7571578220102,0.0 -58.331901239405,-34.7582834382112,0.0 -58.3330344852447,-34.756775828034,0.0 ",
				"Polygon Outer Boundary",
				"924",
				"0860024",
				"Quilmes",
				"Quilmes",
				"0024",
				"2014/10/01",
				"Santa Teresa",
				"Otros",
				"decada_1980",
				"110",
				"3.3300000000000001000000000000000",
				"811-809- Madre Teresa de Calcuta- 896",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.3262780343967,-34.7594605383,0.0 -58.3270920511953,-34.7583844187315,0.0 -58.3270572062613,-34.7583296227613,0.0 -58.3231909085998,-34.7563908136687,0.0 -58.3230858676107,-34.7565452996845,0.0 -58.3231862533347,-34.7569327922165,0.0 -58.3229571832377,-34.7571673428232,0.0 -58.3221311466394,-34.7582967672442,0.0 -58.3214919756643,-34.7590728832462,0.0 -58.321105651225,-34.7595719137238,0.0 -58.320580559617,-34.7602575768354,0.0 -58.3203096714226,-34.7603947999691,0.0 -58.3199393449848,-34.7608445310463,0.0 -58.320015698885,-34.7609274569764,0.0 -58.3237520208555,-34.762786482705,0.0 -58.3262780343967,-34.7594605383,0.0 ",
				"Polygon Outer Boundary",
				"922",
				"0860026",
				"Quilmes",
				"Quilmes",
				"0026",
				"2014/10/01",
				"El Tala",
				"Otros",
				"1980",
				"1100",
				"23.0599999999999990000000000000000",
				"Eva Perón, Emilio Torre, 819, 813",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.32795023918151,-34.78607389991073,0.0 -58.32846966572106,-34.78636467768514,0.0 -58.329842956736684,-34.78440851654557,0.0 -58.330347212031484,-34.78368595880646,0.0 -58.32720902748405,-34.782108646143676,0.0 -58.32634091377259,-34.78347888316556,0.0 -58.328781723976135,-34.784769793041605,0.0 -58.32795023918151,-34.78607389991073,0.0 ",
				"Polygon Outer Boundary",
				"2117",
				"0030087",
				"Almirante Brown",
				"Solano",
				"0087",
				"2015/08/14",
				"Zabala",
				"Otros",
				"1980",
				"190",
				"6.8300000000000001000000000000000",
				"El Picaflor, Pte. Perón, Santa Ana, El Crespin y Falucho",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.566085102036595,-33.906276697030016,0.0 -60.564840557053685,-33.90673527291898,0.0 -60.56351554580032,-33.90738083673707,0.0 -60.56327414698898,-33.90775036417061,0.0 -60.563327791169286,-33.90778152906164,0.0 -60.56367647834122,-33.90765241729606,0.0 -60.56597244925797,-33.906490402605606,0.0 -60.56610119529069,-33.90635683668365,0.0 -60.566085102036595,-33.906276697030016,0.0 ",
				"Polygon Outer Boundary",
				"1956",
				"0820015",
				"Pergamino",
				"Pergamino",
				"0015",
				"2015/07/21",
				"Kennedy II",
				"Asentamiento Precario",
				"2005",
				"22",
				"0.8199999999999999500000000000000",
				"Markintach y Ruta  188",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.19926929846406,-33.3362919749043,0.0 -60.19896889105439,-33.336274047887834,0.0 -60.19860411062837,-33.33648917184189,0.0 -60.19813204184174,-33.33682082023014,0.0 -60.19756341353058,-33.33696423535829,0.0 -60.197220090776675,-33.337152467355615,0.0 -60.19697332754731,-33.337367589140186,0.0 -60.1980891264975,-33.33846111666338,0.0 -60.198453906923525,-33.33844319009336,0.0 -60.200224164873354,-33.337224174676166,0.0 -60.19926929846406,-33.3362919749043,0.0 ",
				"Polygon Outer Boundary",
				"1474",
				"0980016",
				"San Nicolas",
				"San Nicolas",
				"0016",
				"2015/03/20",
				"Cavalli",
				"Villa",
				"90_o_anterior",
				"100",
				"3.9700000000000002000000000000000",
				"Cochabamba frente al río",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.5353547334671,-34.84584240717456,0.0 -58.53446424007416,-34.845397749769944,0.0 -58.53398680686951,-34.84606693623829,0.0 -58.53485584259033,-34.84648957751997,0.0 -58.5353547334671,-34.84584240717456,0.0 ",
				"Polygon Outer Boundary",
				"1130",
				"1300013",
				"Ezeiza",
				"Ezeiza",
				"0013",
				"2014/10/01",
				"Moreno & Derqui",
				"Otros",
				"decada_1990",
				"35",
				"0.8000000000000000400000000000000",
				"Moreno y Derqui",
				"Sin dato",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.3135232620988,-34.7314903946697,0.0 -58.315105928646,-34.7292422448349,0.0 -58.3152514171122,-34.7290602784878,0.0 -58.315362396336,-34.7289218297815,0.0 -58.3140926343326,-34.7279408293218,0.0 -58.3142271563191,-34.7278059765024,0.0 -58.3143175494289,-34.7273690196843,0.0 -58.3143343484118,-34.7272872033682,0.0 -58.3144340093615,-34.7268018196266,0.0 -58.3144932224208,-34.7264549118878,0.0 -58.3145834326431,-34.7262277513486,0.0 -58.3151022220397,-34.7251473447473,0.0 -58.3149065447331,-34.7249739340427,0.0 -58.3144293435568,-34.7245650215748,0.0 -58.3139468952223,-34.7250896350809,0.0 -58.313785150585,-34.7253583707715,0.0 -58.3137650720318,-34.7255774534814,0.0 -58.3139774301338,-34.7266642934406,0.0 -58.3140638418827,-34.7270267896388,0.0 -58.3141006658943,-34.7272891838463,0.0 -58.3138824398247,-34.7278128923418,0.0 -58.3137724252483,-34.7280537767857,0.0 -58.3126182139519,-34.731002945492,0.0 -58.3135232620988,-34.7314903946697,0.0 ",
				"Polygon Outer Boundary",
				"933",
				"0860015",
				"Quilmes",
				"Quilmes",
				"0015",
				"2014/10/01",
				"San Sebastián II",
				"Villa",
				"90_o_anterior",
				"230",
				"6.9100000000000001000000000000000",
				"Zapiola, Franco, 170, Arroyo",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.3141309068784,-34.7210224040182,0.0 -58.3143101717521,-34.7206469608331,0.0 -58.3143200789034,-34.7201589455571,0.0 -58.3136994208683,-34.7206700000256,0.0 -58.3141309068784,-34.7210224040182,0.0 ",
				"Polygon Outer Boundary",
				"939",
				"0860009",
				"Quilmes",
				"Quilmes",
				"0009",
				"2014/10/01",
				"La Cañada",
				"Otros",
				"90_o_anterior",
				"25",
				"0.2700000000000000200000000000000",
				"Enriquez Y Formosa",
				"Sin dato",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.388192653656006,-34.905725915026466,0.0 -58.38933971710503,-34.904850443538024,0.0 -58.38784840889276,-34.90408494825637,0.0 -58.387071490287774,-34.90513640258833,0.0 -58.388192653656006,-34.905725915026466,0.0 ",
				"Polygon Outer Boundary",
				"2095",
				"0030080",
				"Almirante Brown",
				"Glew",
				"0080",
				"2015/08/11",
				"Quinta 68",
				"Villa",
				"2010",
				"25",
				"1.9399999999999999000000000000000",
				"Capitan Olivera, Islas Orcadas, Plumerillos y Lago Argentino",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-61.31070613861083,-38.97930739595916,0.0 -61.311081647872925,-38.979278204869765,0.0 -61.311011910438545,-38.97804799801903,0.0 -61.30902707576752,-38.97799378502204,0.0 -61.307922005653374,-38.978214806980155,0.0 -61.30723536014557,-38.97812723232455,0.0 -61.30670428276062,-38.978193955881494,0.0 -61.30676865577698,-38.97954092424113,0.0 -61.30895197391509,-38.97947003180838,0.0 -61.310051679611206,-38.979474201953444,0.0 -61.31009995937347,-38.97960764646595,0.0 -61.310572028160095,-38.979590965915634,0.0 -61.31070613861083,-38.97930739595916,0.0 ",
				"Polygon Outer Boundary",
				"1664",
				"1260001",
				"Monte Hermoso",
				"Monte Hermoso",
				"0001",
				"2015/05/05",
				"Esperanza",
				"Otros",
				"2003",
				"190",
				"5.8399999999999999000000000000000",
				"Piedra Buena, Río Gallegos, Río Asunción, Río Iguazú",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.54442059993744,-34.89158964876594,0.0 -58.54378223419189,-34.892135257864936,0.0 -58.543497920036316,-34.89207805708104,0.0 -58.54317605495453,-34.89195045518881,0.0 -58.54247331619262,-34.892852464313606,0.0 -58.54215145111083,-34.89313846513892,0.0 -58.54169547557831,-34.89336286508941,0.0 -58.54117512702942,-34.89356526451898,0.0 -58.54081571102142,-34.89378526333336,0.0 -58.54015588760375,-34.893499264759775,0.0 -58.539791107177734,-34.893970061882165,0.0 -58.53939414024352,-34.894251658871426,0.0 -58.53909909725189,-34.89446285597991,0.0 -58.5388845205307,-34.89443645637104,0.0 -58.538691401481636,-34.894379257189385,0.0 -58.538492918014526,-34.89433965773261,0.0 -58.53826224803924,-34.89421205935313,0.0 -58.538010120391846,-34.894550854614856,0.0 -58.53762388229371,-34.89436605737258,0.0 -58.53714644908905,-34.89492484776174,0.0 -58.53690505027771,-34.89490284821201,0.0 -58.5366529226303,-34.89481045003875,0.0 -58.53641688823701,-34.89513604313951,0.0 -58.53607892990112,-34.89499524628133,0.0 -58.53576779365539,-34.895408836365505,0.0 -58.535499572753906,-34.895496833987096,0.0 -58.535124063491814,-34.89559363126196,0.0 -58.534115552902215,-34.895184442003774,0.0 -58.53365421295165,-34.89575642642156,0.0 -58.533257246017456,-34.89626680915494,0.0 -58.533434271812446,-34.896337206524464,0.0 -58.5336434841156,-34.89653519880281,0.0 -58.53608429431915,-34.897674745082504,0.0 -58.53694796562195,-34.896521999332435,0.0 -58.53745222091675,-34.895884022402214,0.0 -58.53788673877717,-34.895316438761384,0.0 -58.538589477539055,-34.89562443037096,0.0 -58.539286851882935,-34.894704851999194,0.0 -58.54063868522643,-34.89527683975637,0.0 -58.54152917861938,-34.89415046006453,0.0 -58.54199051856994,-34.893556464554145,0.0 -58.54259133338928,-34.893301265164034,0.0 -58.54302048683166,-34.89343326494756,0.0 -58.54339063167572,-34.89294046467359,0.0 -58.54405045509339,-34.892504861970075,0.0 -58.54420602321624,-34.89231126002716,0.0 -58.544517159461975,-34.8919812556637,0.0 -58.544849753379815,-34.89178325240936,0.0 -58.54464054107666,-34.89170405097401,0.0 -58.54442059993744,-34.89158964876594,0.0 ",
				"Polygon Outer Boundary",
				"1135",
				"1300008",
				"Ezeiza",
				"La Unión",
				"0008",
				"2014/10/01",
				"Sol de Oro",
				"Asentamiento Precario",
				"90_o_anterior",
				"210",
				"13.4200000000000000000000000000000",
				"El Grillo, El Malambo, Los Padres; El Alba",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.37093029171228,-34.88562291280365,0.0 -58.36870942264795,-34.88449640075576,0.0 -58.36781892925501,-34.885675717676996,0.0 -58.37014708667993,-34.886802213558305,0.0 -58.37093029171228,-34.88562291280365,0.0 ",
				"Polygon Outer Boundary",
				"2131",
				"0030095",
				"Almirante Brown",
				"Glew",
				"0095",
				"2015/08/27",
				"Arreghini & Della Valle",
				"Asentamiento Precario",
				"2014",
				"130",
				"3.6800000000000002000000000000000",
				"Gobernador Arias e Intendente Arreghini",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.16138935834169,-37.333825343307026,0.0 -59.16304159909486,-37.333722975259676,0.0 -59.162848480045795,-37.333449993118066,0.0 -59.16224766522646,-37.332784594991956,0.0 -59.161432273685925,-37.33230686962567,0.0 -59.16104603558779,-37.331863264779614,0.0 -59.160380847752094,-37.33128316218232,0.0 -59.159329421818256,-37.331027233141825,0.0 -59.1582565382123,-37.330668931020426,0.0 -59.156647212803364,-37.329491640590014,0.0 -59.15602494031191,-37.329235705446585,0.0 -59.15566015988588,-37.32935514195535,0.0 -59.15593910962343,-37.329815823853444,0.0 -59.155574329197414,-37.330310627190194,0.0 -59.15531683713198,-37.33087367529904,0.0 -59.155166633427136,-37.331078419019676,0.0 -59.15493059903384,-37.33104429510499,0.0 -59.1545658186078,-37.33162439954675,0.0 -59.15368605405092,-37.332750471852265,0.0 -59.153643138706684,-37.33304051804566,0.0 -59.15385771542787,-37.33356942292708,0.0 -59.154201038181775,-37.333825343307026,0.0 -59.1546731069684,-37.333927711214876,0.0 -59.15488768368959,-37.33397889511649,0.0 -59.15523100644349,-37.33472958833337,0.0 -59.155359752476215,-37.33496844369274,0.0 -59.15587473660707,-37.33500256582493,0.0 -59.156389720737934,-37.33549733499992,0.0 -59.15686178952455,-37.33573618791801,0.0 -59.15767718106508,-37.33546321309249,0.0 -59.15857840329409,-37.33486607720315,0.0 -59.15920067578555,-37.33447367103407,0.0 -59.16010189801454,-37.33420069162048,0.0 -59.16138935834169,-37.333825343307026,0.0 ",
				"Polygon Outer Boundary",
				"1688",
				"1030001",
				"Tandil",
				"Tandil",
				"0001",
				"2015/05/11",
				"Villa Cordobita",
				"Asentamiento Precario",
				"2004",
				"66",
				"30.3700000000000010000000000000000",
				"subida al Monte Calvario por calle Paraguay",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.36652887053787,-34.84736567076371,0.0 -58.364903451874845,-34.84663485995923,0.0 -58.3617223519832,-34.85078190506799,0.0 -58.36324048228562,-34.851600723661896,0.0 -58.365842225030065,-34.84821974263611,0.0 -58.36607289500535,-34.84797760975814,0.0 -58.36652887053787,-34.84736567076371,0.0 ",
				"Polygon Outer Boundary",
				"2021",
				"0030071",
				"Almirante Brown",
				"Ministro Rivadavia",
				"0071",
				"2015/08/04",
				"Los Ciruelos",
				"Asentamiento Precario",
				"2002",
				"176",
				"9.2100000000000009000000000000000",
				"Maizani, Cnel. Cárdenas, Pedro Irigoyen e Irigoni",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.04409647732973,-37.334678404943254,0.0 -57.04268027096986,-37.33530966431718,0.0 -57.04752970486879,-37.34204845403293,0.0 -57.049074657261365,-37.34124665504951,0.0 -57.04409647732973,-37.334678404943254,0.0 ",
				"Polygon Outer Boundary",
				"1760",
				"1250004",
				"Villa Gesell",
				"Villa Gesell",
				"0004",
				"2015/06/10",
				"MAR AZUL",
				"Otros",
				"decada_2000",
				"63",
				"14.6000000000000000000000000000000",
				"MONTE HERMOSO Y SAN CLEMENTE E/35 A LA 43 Y NECOCHEA Y MIRAMAR E/40 Y 41",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.043324001133435,-37.34167314493618,0.0 -57.04467583447695,-37.341076058416654,0.0 -57.04411793500185,-37.34025718918459,0.0 -57.042723186314106,-37.34090546139627,0.0 -57.043324001133435,-37.34167314493618,0.0 ",
				"Polygon Outer Boundary",
				"1760",
				"1250004",
				"Villa Gesell",
				"Villa Gesell",
				"0004",
				"2015/06/10",
				"MAR AZUL",
				"Otros",
				"decada_2000",
				"63",
				"14.6000000000000000000000000000000",
				"MONTE HERMOSO Y SAN CLEMENTE E/35 A LA 43 Y NECOCHEA Y MIRAMAR E/40 Y 41",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.620404958724976,-37.98905178051852,0.0 -57.619574312120676,-37.98837532138411,0.0 -57.619267702102654,-37.98808782436327,0.0 -57.61765837669372,-37.989347729428495,0.0 -57.61737490072846,-37.98903486911619,0.0 -57.615169286727905,-37.99069216801716,0.0 -57.61629045009614,-37.99163495144979,0.0 -57.61708974838256,-37.99227755922221,0.0 -57.616688255220645,-37.99256926747171,0.0 -57.615914940834045,-37.9931907290046,0.0 -57.61654794216155,-37.99373608886945,0.0 -57.61660695075988,-37.99374031644947,0.0 -57.61672496795654,-37.99390941945023,0.0 -57.61698782444,-37.994112342536546,0.0 -57.62118363752962,-37.990945832912445,0.0 -57.6203897036612,-37.990235568995274,0.0 -57.61974597349762,-37.989592943335225,0.0 -57.620404958724976,-37.98905178051852,0.0 ",
				"Polygon Outer Boundary",
				"1353",
				"0450067",
				"General Pueyrredon",
				"Mar Del Plata",
				"0067",
				"2015/02/05",
				"12 de Octubre & Ciudad de Bragado",
				"Otros",
				"90_o_anterior",
				"270",
				"17.1299999999999990000000000000000",
				"Ciudad de Bragado, 12 de Octubre, Yapeyú, Irala",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.266645669937134,-34.706904608268594,0.0 -58.265926837921135,-34.70625193216584,0.0 -58.2650691916601,-34.7060662433822,0.0 -58.2644306810451,-34.7063558483792,0.0 -58.2628965755552,-34.7068626591398,0.0 -58.2611630272363,-34.7075586594799,0.0 -58.25837910175324,-34.7087744085953,0.0 -58.25865805149078,-34.709091917660466,0.0 -58.25932323932647,-34.70946234336282,0.0 -58.25953245162964,-34.70957258878724,0.0 -58.2604444026947,-34.71007971584704,0.0 -58.266645669937134,-34.706904608268594,0.0 ",
				"Polygon Outer Boundary",
				"943",
				"0860005",
				"Quilmes",
				"Quilmes",
				"0005",
				"2014/10/01",
				"El Matadero",
				"Villa",
				"90_o_anterior",
				"1100",
				"13.1700000000000000000000000000000",
				"Ceballos, Autopista, Suipacha, Carlos Gardel",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.36603308096528,-34.85977965783671,0.0 -58.36976474616677,-34.855054199519394,0.0 -58.36568129248917,-34.852908175168075,0.0 -58.3619541535154,-34.85773279957569,0.0 -58.36265039630234,-34.85807614709729,0.0 -58.3628059644252,-34.85812456778631,0.0 -58.36603308096528,-34.85977965783671,0.0 ",
				"Polygon Outer Boundary",
				"2023",
				"0030072",
				"Almirante Brown",
				"Ministro Rivadavia",
				"0072",
				"2015/08/04",
				"Los Pinos",
				"Otros",
				"1985",
				"960",
				"27.6999999999999990000000000000000",
				"Av. Espora, Mosconi, Irigoni, Pedro de Irigoyen, Michelis y Ezeiza",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.14672756567597,-37.34480350656964,0.0 -59.14726400747895,-37.344146738515455,0.0 -59.14829397574067,-37.344470858532844,0.0 -59.14872312918305,-37.344641447453746,0.0 -59.148959163576365,-37.34484615364727,0.0 -59.149130824953325,-37.3448205654036,0.0 -59.149270299822085,-37.34467556519142,0.0 -59.14974236860871,-37.3438482056828,0.0 -59.15012860670686,-37.34326819564357,0.0 -59.14959216490387,-37.34306348514836,0.0 -59.149270299822085,-37.342927011174865,0.0 -59.145257715135806,-37.34137460226982,0.0 -59.14453888311983,-37.34255170646886,0.0 -59.14379859343171,-37.34225316729513,0.0 -59.14304757490755,-37.343464376011156,0.0 -59.14383077993988,-37.34371173313543,0.0 -59.14672756567597,-37.34480350656964,0.0 ",
				"Polygon Outer Boundary",
				"1689",
				"1030002",
				"Tandil",
				"Tandil",
				"0002",
				"2015/05/11",
				"Las Tunitas",
				"Asentamiento Precario",
				"decada_1990",
				"240",
				"13.1099999999999990000000000000000",
				"Juidain, De los Granaderos, Uspallata y Baigorria",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.25538301467895,-34.621232187055114,0.0 -59.25310917198658,-34.62003584393062,0.0 -59.25153672695159,-34.62207094132315,0.0 -59.25266861915588,-34.62262274871844,0.0 -59.253886342048645,-34.62322311099673,0.0 -59.25538301467895,-34.621232187055114,0.0 ",
				"Polygon Outer Boundary",
				"1766",
				"0640006",
				"Lujan",
				"Olivera",
				"0006",
				"2015/06/11",
				"Olivera",
				"Otros",
				"decada_2000",
				"35",
				"6.5800000000000001000000000000000",
				"Reconquista, hernandez, Boulogne Sur Mer",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.129297733306885,-34.583519221239506,0.0 -59.13087487220764,-34.5823002517863,0.0 -59.129576683044434,-34.58114309757544,0.0 -59.13065130393079,-34.58011601943885,0.0 -59.12817120552063,-34.57810438691761,0.0 -59.12714123725891,-34.57722101995536,0.0 -59.12547826766967,-34.57848423182514,0.0 -59.123514890670776,-34.580083094846984,0.0 -59.12475044409803,-34.58097285568549,0.0 -59.1261112689972,-34.58193809075012,0.0 -59.1264545917511,-34.581699593596184,0.0 -59.126894474029534,-34.58153176185536,0.0 -59.127323627471924,-34.581770259490916,0.0 -59.129297733306885,-34.583519221239506,0.0 ",
				"Polygon Outer Boundary",
				"1765",
				"0640005",
				"Lujan",
				"Lujan",
				"0005",
				"2015/06/11",
				"Padre Varela",
				"Otros",
				"decada_1990",
				"500",
				"22.9800000000000000000000000000000",
				"Av. Simone, Rivadavia, La Pampa, Roma",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.16544318199157,-37.323451338706796,0.0 -59.16487002745271,-37.32379261164173,0.0 -59.164687637239695,-37.32396324752799,0.0 -59.164955858141184,-37.32425332764543,0.0 -59.164666179567575,-37.324594596938184,0.0 -59.16425848379732,-37.324620192072665,0.0 -59.163754228502505,-37.324364240335576,0.0 -59.16333580389619,-37.32470550912463,0.0 -59.162692073732615,-37.324210668874855,0.0 -59.1621127165854,-37.32508943465973,0.0 -59.16197324171662,-37.32555867431657,0.0 -59.16298175230622,-37.32624973102114,0.0 -59.16360402479768,-37.32676162077888,0.0 -59.16473055258393,-37.32770007627744,0.0 -59.16577124968171,-37.326710431960024,0.0 -59.165588859468706,-37.32652273932591,0.0 -59.1675522364676,-37.32502971303866,0.0 -59.16544318199157,-37.323451338706796,0.0 ",
				"Polygon Outer Boundary",
				"1690",
				"1030003",
				"Tandil",
				"Tandil",
				"0003",
				"2015/05/11",
				"Villa Laza",
				"Asentamiento Precario",
				"2001",
				"116",
				"11.3599999999999990000000000000000",
				"Cabildo, Giácomo, Artigas y s/n",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.08022403717042,-34.5610537468655,0.0 -59.08025085926056,-34.56115093658597,0.0 -59.082101583480835,-34.562025638959774,0.0 -59.08373773097992,-34.562785473959636,0.0 -59.08677210172755,-34.55846894068433,0.0 -59.08846725782496,-34.55617162465898,0.0 -59.08881783485412,-34.55555792518243,0.0 -59.08524513244629,-34.55375535797158,0.0 -59.082761406898506,-34.55743555782954,0.0 -59.08122718334197,-34.55955170947321,0.0 -59.08022403717042,-34.5610537468655,0.0 ",
				"Polygon Outer Boundary",
				"1762",
				"0640002",
				"Lujan",
				"Lujan",
				"0002",
				"2015/06/11",
				"Ameghino",
				"Otros",
				"90_o_anterior",
				"600",
				"35.5700000000000000000000000000000",
				"Del Pilar, Suipacha, Cerrito, Florida",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.63458037376404,-34.85675116990978,0.0 -58.63508462905884,-34.85709452152856,0.0 -58.636243343353264,-34.85787806216358,0.0 -58.63813698291778,-34.85637260107927,0.0 -58.63938689231872,-34.857341029499274,0.0 -58.6430025100708,-34.85436527677705,0.0 -58.639934062957764,-34.8531150763643,0.0 -58.640910387039185,-34.85128376259219,0.0 -58.638979196548455,-34.85037689500955,0.0 -58.63729476928711,-34.848915320395136,0.0 -58.638120889663696,-34.84814930405419,0.0 -58.637005090713494,-34.8472071822247,0.0 -58.63557815551757,-34.84804364606824,0.0 -58.63450527191162,-34.847189572368194,0.0 -58.632166385650635,-34.84522604973312,0.0 -58.628969192504876,-34.847656232292465,0.0 -58.62969875335694,-34.84889771090416,0.0 -58.63022446632385,-34.84894173462454,0.0 -58.63085746765137,-34.850227216874764,0.0 -58.63102912902833,-34.8509403867221,0.0 -58.63108277320861,-34.85134539400693,0.0 -58.630932569503784,-34.85188246580997,0.0 -58.631078246980906,-34.85195290119623,0.0 -58.630938772112124,-34.85248116467129,0.0 -58.63101387396455,-34.852886164371895,0.0 -58.631335739046335,-34.85316790211825,0.0 -58.6317970789969,-34.85328235780214,0.0 -58.631861452013254,-34.8533175749036,0.0 -58.63210821524262,-34.85356409419178,0.0 -58.632322791963816,-34.853828221180876,0.0 -58.63458037376404,-34.85675116990978,0.0 ",
				"Polygon Outer Boundary",
				"1065",
				"0700065",
				"La Matanza",
				"Virrey Del Pino",
				"0065",
				"2014/10/01",
				"Esperanza",
				"Asentamiento Precario",
				"2006",
				"1700",
				"88.3599999999999990000000000000000",
				"A. Williams, Urien, Corrales",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.12889003753663,-34.53740676456715,0.0 -59.12600398063659,-34.535815919183584,0.0 -59.12450194358826,-34.537654226672416,0.0 -59.12747383117675,-34.53927155017431,0.0 -59.12889003753663,-34.53740676456715,0.0 ",
				"Polygon Outer Boundary",
				"1768",
				"0640008",
				"Lujan",
				"Luján",
				"0008",
				"2015/06/11",
				"San Pedro",
				"Asentamiento Precario",
				"90_o_anterior",
				"85",
				"7.9299999999999997000000000000000",
				"Las Camelias y Las violetas",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.11935383956006,-34.54807107128487,0.0 -59.116296121283085,-34.54893707446898,0.0 -59.11735117435455,-34.55075982902653,0.0 -59.11935383956006,-34.54807107128487,0.0 ",
				"Polygon Outer Boundary",
				"1764",
				"0640004",
				"Lujan",
				"Luján",
				"0004",
				"2015/06/11",
				"La Loma",
				"Asentamiento Precario",
				"90_o_anterior",
				"60",
				"3.3100000000000001000000000000000",
				"Los Helechos, Los Tulipanes, Los Juncos",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.120054841041565,-34.53249272186665,0.0 -59.12069320678711,-34.53166190181246,0.0 -59.120017290115356,-34.53130393955301,0.0 -59.11934673786163,-34.5321391824313,0.0 -59.120054841041565,-34.53249272186665,0.0 ",
				"Polygon Outer Boundary",
				"1767",
				"0640007",
				"Lujan",
				"Luján",
				"0007",
				"2015/06/11",
				"Villa María",
				"Asentamiento Precario",
				"decada_2000",
				"10",
				"0.8299999999999999600000000000000",
				"Las Hortensias y 351",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.568496108055115,-34.44663141841961,0.0 -58.5678453383264,-34.4460548046931,0.0 -58.567766547203064,-34.44597669557844,0.0 -58.567105660413,-34.4454135602026,0.0 -58.5668885518943,-34.4455875675587,0.0 -58.5671923236721,-34.4458689586307,0.0 -58.5667484122838,-34.4462152355088,0.0 -58.567069172859185,-34.4465562140298,0.0 -58.56711208820342,-34.44660929948846,0.0 -58.5670769142435,-34.4466826128816,0.0 -58.5664069366108,-34.4472154854766,0.0 -58.5664056399133,-34.4472213293312,0.0 -58.5667220476315,-34.4474885077019,0.0 -58.566793726601,-34.4475599250158,0.0 -58.5670076183794,-34.4477329703926,0.0 -58.5671010742451,-34.447707926354,0.0 -58.5671338245393,-34.4476824411172,0.0 -58.5671429591801,-34.4476636193619,0.0 -58.5676858740657,-34.4472314688432,0.0 -58.5678094625473,-34.44716669476752,0.0 -58.568496108055115,-34.44663141841961,0.0 ",
				"Polygon Outer Boundary",
				"560",
				"0960004",
				"San Fernando",
				"San Fernando",
				"0004",
				"2014/10/01",
				"San Rafael I",
				"Villa",
				"decada_1960",
				"212",
				"2.1899999999999999000000000000000",
				"Quirno Costa, Entre Rios, Beruti, Sarmiento",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Sin dato",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.726574778556824,-34.58044526396626,0.0 -58.73202502727508,-34.57643481546355,0.0 -58.731075525283806,-34.57549842737815,0.0 -58.731552958488464,-34.575149487611014,0.0 -58.732035756111145,-34.574796129392226,0.0 -58.73623073101043,-34.57175276956183,0.0 -58.735313415527344,-34.570913507051344,0.0 -58.736616969108574,-34.56998147401983,0.0 -58.738537430763245,-34.568572361589716,0.0 -58.740516901016235,-34.567145555707796,0.0 -58.73867154121398,-34.565674550638974,0.0 -58.735034465789795,-34.56833382608778,0.0 -58.73597860336304,-34.56921728748368,0.0 -58.73372554779053,-34.57082516313638,0.0 -58.73464286327361,-34.571682095150756,0.0 -58.73001337051392,-34.575047897276946,0.0 -58.72608661651611,-34.57782171051106,0.0 -58.72514247894287,-34.576920673049706,0.0 -58.72432708740234,-34.577592035222914,0.0 -58.72233152389526,-34.57578994555431,0.0 -58.7212378436294,-34.576453885479,0.0 -58.72051298618317,-34.57693834054478,0.0 -58.7217110677363,-34.5780320629313,0.0 -58.7234534657495,-34.5796692955781,0.0 -58.7243161901631,-34.5804363610521,0.0 -58.725281953811646,-34.581443429224066,0.0 -58.72541606426238,-34.5813374299426,0.0 -58.72441828250885,-34.58042759721655,0.0 -58.72560918331146,-34.579544254944054,0.0 -58.726574778556824,-34.58044526396626,0.0 ",
				"Polygon Outer Boundary",
				"727",
				"1310007",
				"San Miguel",
				"Santa María",
				"0007",
				"2014/10/01",
				"Mitre",
				"Otros",
				"90_o_anterior",
				"3000",
				"48.3999999999999990000000000000000",
				"Ricardo Balbín a Pardo, Defensa a El Zonda",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.0363242028478,-34.1230828945438,0.0 -59.0384279826616,-34.1233929248829,0.0 -59.0385838544505,-34.1231378163573,0.0 -59.0368815628217,-34.1222417825761,0.0 -59.0344814436117,-34.1209908119656,0.0 -59.0336639643534,-34.1205615044102,0.0 -59.0324598786821,-34.1199312744013,0.0 -59.0312551795894,-34.1193278915222,0.0 -59.0305770063753,-34.1202192275763,0.0 -59.0302301560937,-34.1206911610646,0.0 -59.0314266346526,-34.1213320802504,0.0 -59.0325902425271,-34.1219484795152,0.0 -59.0347223097159,-34.1222288852645,0.0 -59.0343916640544,-34.1227479638093,0.0 -59.0363242028478,-34.1230828945438,0.0 ",
				"Polygon Outer Boundary",
				"455",
				"0380007",
				"Zarate",
				"Zárate",
				"0007",
				"2014/09/18",
				"La Esperanza",
				"Asentamiento Precario",
				"2001",
				"160",
				"13.3800000000000010000000000000000",
				"Laprida, calle 4, Almafuerte, Pacheco",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.18063068762421,-37.31053301865764,0.0 -59.18113494291901,-37.31093408312046,0.0 -59.18254042044282,-37.3100039516255,0.0 -59.18087745085359,-37.30882633744628,0.0 -59.18073797598481,-37.30888607194291,0.0 -59.17966509237885,-37.309654082672076,0.0 -59.1785922087729,-37.30871540182661,0.0 -59.176221136003726,-37.306855072433684,0.0 -59.173914436250925,-37.30866420071617,0.0 -59.17608166113495,-37.310447685517175,0.0 -59.17496586218476,-37.31129247934085,0.0 -59.173935893923044,-37.312171396172545,0.0 -59.17440796270966,-37.312760179370656,0.0 -59.17495513334871,-37.312307926020445,0.0 -59.17569542303681,-37.312760179370656,0.0 -59.17621040716767,-37.31236765775095,0.0 -59.17714381590485,-37.31323802901105,0.0 -59.18063068762421,-37.31053301865764,0.0 ",
				"Polygon Outer Boundary",
				"1691",
				"1030004",
				"Tandil",
				"Tandil",
				"0004",
				"2015/05/11",
				"La Movediza II",
				"Otros",
				"2004",
				"560",
				"25.0900000000000000000000000000000",
				"Azucena, Los Tulipanes, La Pastora y Misiones",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7015100920877,-34.7406486966397,0.0 -58.7002092922139,-34.7395904368969,0.0 -58.6989220885084,-34.74064081335,0.0 -58.6986782678253,-34.7407313165353,0.0 -58.6973414691702,-34.7418085463866,0.0 -58.6986752341757,-34.7429160412721,0.0 -58.7000149922629,-34.7418444908092,0.0 -58.7001992555186,-34.7419111900961,0.0 -58.7008512396255,-34.7424550755581,0.0 -58.70152831077575,-34.74305834469078,0.0 -58.7028694152832,-34.741991595010546,0.0 -58.7021666341792,-34.7413832129543,0.0 -58.7015298533988,-34.740830256986,0.0 -58.7013909917913,-34.7407399906541,0.0 -58.7015100920877,-34.7406486966397,0.0 ",
				"Polygon Outer Boundary",
				"622",
				"0720040",
				"Merlo",
				"Pontevedra",
				"0040",
				"2014/10/01",
				"El Alto",
				"Asentamiento Precario",
				"decada_1990",
				"280",
				"9.4499999999999993000000000000000",
				"Muñiz, Espejo, Necochea",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.079338908195496,-34.56895666734797,0.0 -59.07894194126129,-34.569539748554874,0.0 -59.08365726470947,-34.571774855302955,0.0 -59.084451198577874,-34.570613137357505,0.0 -59.08218204975128,-34.569491158610475,0.0 -59.07982170581818,-34.56838241670848,0.0 -59.08062636852265,-34.567123468737016,0.0 -59.07857179641724,-34.56615163621505,0.0 -59.07768666744233,-34.56735759032878,0.0 -59.078614711761475,-34.567874422452384,0.0 -59.07821774482727,-34.56842217264976,0.0 -59.079338908195496,-34.56895666734797,0.0 ",
				"Polygon Outer Boundary",
				"1761",
				"0640001",
				"Lujan",
				"Luján",
				"0001",
				"2015/06/11",
				"Villa del Parque",
				"Asentamiento Precario",
				"decada_1990",
				"95",
				"12.0000000000000000000000000000000",
				"Misiones, Corrientes, Alfonsina Storni, Pasteur",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.49923610687256,-34.748224392051135,0.0 -58.49820613861084,-34.747686644507276,0.0 -58.49714398384094,-34.74712244659945,0.0 -58.49668264389038,-34.74770427562979,0.0 -58.495337013155215,-34.74705192158999,0.0 -58.49442506209016,-34.748347809026264,0.0 -58.49715018644928,-34.749652491484056,0.0 -58.498045206069946,-34.74848004129496,0.0 -58.49875951185822,-34.74885029052112,0.0 -58.49923610687256,-34.748224392051135,0.0 ",
				"Polygon Outer Boundary",
				"1696",
				"0300039",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0039",
				"2015/05/12",
				"Maipu & Pinamar",
				"Villa",
				"2008",
				"150",
				"6.5899999999999999000000000000000",
				"Maipú, Don Segundo Sombra, La Rábida, Pinamar",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.64909911155701,-33.68920563003934,0.0 -59.65010225772858,-33.68865215297227,0.0 -59.64993596076966,-33.68850485605553,0.0 -59.64897346682846,-33.68906726110672,0.0 -59.64909911155701,-33.68920563003934,0.0 ",
				"Polygon Outer Boundary",
				"1962",
				"0990026",
				"San Pedro",
				"San Pedro",
				"0026",
				"2015/07/21",
				"Defensores Unidos",
				"Asentamiento Precario",
				"decada_2010",
				"14",
				"0.2300000000000000100000000000000",
				"Obligado y 24 de Febrero",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.177309274673455,-37.30412423032323,0.0 -59.17504549026489,-37.30592489047699,0.0 -59.178467988967896,-37.308587398985146,0.0 -59.179481863975525,-37.30772124069834,0.0 -59.1806298494339,-37.3068124037884,0.0 -59.179514050483704,-37.30589928897602,0.0 -59.177309274673455,-37.30412423032323,0.0 ",
				"Polygon Outer Boundary",
				"1692",
				"1030005",
				"Tandil",
				"Tandil",
				"0005",
				"2015/05/11",
				"La Movediza I",
				"Asentamiento Precario",
				"2002",
				"75",
				"11.7600000000000000000000000000000",
				"Azucena, Chubut, Formosa y Piccirilli",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.485910892486565,-34.74488765608611,0.0 -58.48678529262543,-34.74369750628846,0.0 -58.48605036735534,-34.74331841793759,0.0 -58.4851598739624,-34.7445350208966,0.0 -58.485910892486565,-34.74488765608611,0.0 ",
				"Polygon Outer Boundary",
				"1697",
				"0300040",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0040",
				"2015/05/12",
				"Santa Rita & Av. Dr. Gilberto Elizalde",
				"Villa",
				"decada_1990",
				"120",
				"1.2400000000000000000000000000000",
				"Santa Rita, Santos Vega, Av. Dr. Gilberto Elizalde",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.44176709651947,-34.82775479945578,0.0 -58.44121992588043,-34.8274861852704,0.0 -58.44251275062561,-34.825702741000846,0.0 -58.441236019134514,-34.82507742547058,0.0 -58.440114855766296,-34.824496141987325,0.0 -58.438441157341,-34.8267199695014,0.0 -58.43703031539917,-34.82605502934961,0.0 -58.43647241592407,-34.826830058412504,0.0 -58.439154624938965,-34.8281158859966,0.0 -58.440919518470764,-34.82893493008639,0.0 -58.44176709651947,-34.82775479945578,0.0 ",
				"Polygon Outer Boundary",
				"1238",
				"0030041",
				"Almirante Brown",
				"Adrogué",
				"0041",
				"2014/10/01",
				"Lindo",
				"Asentamiento Precario",
				"90_o_anterior",
				"270",
				"12.4900000000000000000000000000000",
				"Quebracho, Rodríguez. Matienzo, Portugal",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.108397960662835,-37.31087861688606,0.0 -59.10610735416413,-37.3126748487581,0.0 -59.10719096660613,-37.313579348323124,0.0 -59.109508395195,-37.311783138062424,0.0 -59.108397960662835,-37.31087861688606,0.0 ",
				"Polygon Outer Boundary",
				"1694",
				"1030007",
				"Tandil",
				"Tandil",
				"0007",
				"2015/05/11",
				"Villa Gaucho",
				"Asentamiento Precario",
				"90_o_anterior",
				"120",
				"4.0000000000000000000000000000000",
				"Rosales, Palacios, Darregueira y Lester",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.66806507110595,-34.7121434704173,0.0 -58.66733618080615,-34.71149083565038,0.0 -58.664857149124146,-34.70935650761714,0.0 -58.66325855255128,-34.710450137125754,0.0 -58.66375274956227,-34.71106750223721,0.0 -58.66255111992359,-34.71182597306584,0.0 -58.66017937660217,-34.7137485772601,0.0 -58.662228584289544,-34.715635860841964,0.0 -58.66374135017396,-34.71431300303243,0.0 -58.6649751663208,-34.71549475701713,0.0 -58.665490821003914,-34.715159634468215,0.0 -58.666306212544434,-34.71607680874282,0.0 -58.67038317024708,-34.712901931378994,0.0 -58.6688382178545,-34.711526113337015,0.0 -58.66806507110595,-34.7121434704173,0.0 ",
				"Polygon Outer Boundary",
				"609",
				"0720053",
				"Merlo",
				"Libertad",
				"0053",
				"2014/10/01",
				"Las Flores",
				"Asentamiento Precario",
				"90_o_anterior",
				"950",
				"34.4200000000000020000000000000000",
				"Zorrilla, Honduras, Salcedo, Obarrio",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.013418316841125,-34.903693399060785,0.0 -58.013155460357666,-34.9034382311645,0.0 -58.01268875598907,-34.903803384978424,0.0 -58.0110980673234,-34.9023593557705,0.0 -58.0102820683753,-34.902969817049,0.0 -58.0111702436115,-34.9038171919739,0.0 -58.0102679774992,-34.9044773819256,0.0 -58.0136463683556,-34.9075921757352,0.0 -58.0137561725185,-34.9074664550907,0.0 -58.0126596586007,-34.9064471083612,0.0 -58.0142724600091,-34.905253422724,0.0 -58.0137103428866,-34.9047377544686,0.0 -58.01295161247253,-34.90404975289943,0.0 -58.013418316841125,-34.903693399060785,0.0 ",
				"Polygon Outer Boundary",
				"342",
				"0550071",
				"La Plata",
				"Hernandez",
				"0071",
				"2014/10/07",
				"Mercosur",
				"Asentamiento Precario",
				"2002",
				"325",
				"8.3900000000000006000000000000000",
				"26, 29bis, 514, 512bis",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.25726020149886,-34.80386232543575,0.0 -58.25756907463073,-34.80344387015645,0.0 -58.258100152015686,-34.803170771881156,0.0 -58.25781047344207,-34.80295053067749,0.0 -58.25696515850723,-34.803219224867,0.0 -58.256299970671535,-34.803426250940184,0.0 -58.25552749447524,-34.803703753158835,0.0 -58.255106806755066,-34.80385351587282,0.0 -58.25483012013137,-34.80378303933543,0.0 -58.254551170393825,-34.803937206682704,0.0 -58.25532364659011,-34.80435125470249,0.0 -58.2557528000325,-34.80402970695265,0.0 -58.25684487819671,-34.803628871699814,0.0 -58.25726020149886,-34.80386232543575,0.0 ",
				"Polygon Outer Boundary",
				"1673",
				"0320055",
				"Florencio Varela",
				"Florencio Varela",
				"0055",
				"2015/05/05",
				"Terraplén & San Juan",
				"Asentamiento Precario",
				"90_o_anterior",
				"80",
				"1.4700000000000000000000000000000",
				"San Martín, Sallares,  Aristobulo del Valle",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9869676003324,-34.907654671622,0.0 -57.9859266310748,-34.9084317392481,0.0 -57.9868422411249,-34.909285034486,0.0 -57.9878930243972,-34.9085093833665,0.0 -57.9869676003324,-34.907654671622,0.0 ",
				"Polygon Outer Boundary",
				"340",
				"0550068",
				"La Plata",
				"Tolosa",
				"0068",
				"2014/10/07",
				"Boliviana",
				"Villa",
				"decada_1980",
				"60",
				"1.6000000000000001000000000000000",
				"528, 527, 19, 20",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.12348580546677,-37.29536779908726,0.0 -59.12235391326249,-37.29622556472878,0.0 -59.123475076630704,-37.297121727339224,0.0 -59.124633790925145,-37.29622129726224,0.0 -59.12348580546677,-37.29536779908726,0.0 ",
				"Polygon Outer Boundary",
				"1693",
				"1030006",
				"Tandil",
				"Tandil",
				"0006",
				"2015/05/11",
				"La Esperanza",
				"Asentamiento Precario",
				"90_o_anterior",
				"62",
				"1.9700000000000000000000000000000",
				"Basilico, Casacuberta, Vigil y Labardén",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.68425488471985,-34.712028818736535,0.0 -58.68456602096557,-34.710635347143025,0.0 -58.683825731277466,-34.710300204903255,0.0 -58.68303179740905,-34.71168486274064,0.0 -58.683804273605354,-34.712187567175285,0.0 -58.684185147285454,-34.71272995537534,0.0 -58.68479669094086,-34.712963666267434,0.0 -58.68549942970276,-34.7133869899754,0.0 -58.68578910827637,-34.71287547355555,0.0 -58.68501126766204,-34.7125535693591,0.0 -58.68425488471985,-34.712028818736535,0.0 ",
				"Polygon Outer Boundary",
				"608",
				"0720054",
				"Merlo",
				"Libertad",
				"0054",
				"2014/10/01",
				"Blandengues & Montañeses",
				"Asentamiento Precario",
				"90_o_anterior",
				"12",
				"2.7999999999999998000000000000000",
				"Blandengues, Montañeses",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.5509322009185,-34.4604279587945,0.0 -58.551032636078,-34.4604787244489,0.0 -58.5512357559187,-34.4605760453871,0.0 -58.5513847591892,-34.4606467313707,0.0 -58.5514900470894,-34.4606908276657,0.0 -58.551590771787,-34.4607500690736,0.0 -58.5516099365732,-34.4607553552846,0.0 -58.551723548671,-34.4608185233228,0.0 -58.5518882208246,-34.4608989828658,0.0 -58.5520073191583,-34.4609592524472,0.0 -58.5524887768923,-34.4611781270511,0.0 -58.5525696447557,-34.4610418802691,0.0 -58.5527850760849,-34.4607822434345,0.0 -58.5528547649913,-34.4606536334147,0.0 -58.5529351034713,-34.4605321800381,0.0 -58.5530295665679,-34.4604498325402,0.0 -58.553186585257,-34.460198139192,0.0 -58.5533039517981,-34.4600307937928,0.0 -58.5533993590484,-34.4599252022969,0.0 -58.5533828901546,-34.4599147318791,0.0 -58.5535454750061,-34.45970268207445,0.0 -58.5532870314192,-34.4595797335728,0.0 -58.5531451207427,-34.4595172122068,0.0 -58.5530773570094,-34.4595027994966,0.0 -58.5530753380579,-34.4594999813818,0.0 -58.5529145314844,-34.4593973957705,0.0 -58.5529074424771,-34.4594046126481,0.0 -58.5528736532425,-34.4593888896857,0.0 -58.5526811759888,-34.4593054882883,0.0 -58.5526253164456,-34.4592949116634,0.0 -58.5524306893287,-34.4591819928837,0.0 -58.5519685853196,-34.4589612016561,0.0 -58.5515149139661,-34.4596124684317,0.0 -58.5514814675251,-34.4596566871108,0.0 -58.5514137114016,-34.4597678326885,0.0 -58.5513675104586,-34.4598469654546,0.0 -58.5513415143265,-34.459833677768,0.0 -58.5512849566632,-34.4599327878515,0.0 -58.5512713795103,-34.4599565129354,0.0 -58.5512278241081,-34.4600210745807,0.0 -58.5511746005817,-34.4601035489864,0.0 -58.5511596105503,-34.4601271673746,0.0 -58.5511640385847,-34.4601291127185,0.0 -58.551141876796,-34.4601647238962,0.0 -58.5511373352938,-34.4601630478163,0.0 -58.5510366895774,-34.4602882250226,0.0 -58.5509322009185,-34.4604279587945,0.0 ",
				"Polygon Outer Boundary",
				"567",
				"0960014",
				"San Fernando",
				"San Fernando",
				"0014",
				"2014/10/01",
				"Santa Rosa",
				"Villa",
				"1986",
				"500",
				"3.1400000000000001000000000000000",
				"Entre Rios, Malvinas Argentinas, Urcola, Simon de Iriondo",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.488335609436035,-34.68876005887501,0.0 -58.49032580852508,-34.68732208538398,0.0 -58.4883838891983,-34.68554884441772,0.0 -58.48811030387878,-34.6858752647613,0.0 -58.487911690188,-34.6863416041329,0.0 -58.487859550733,-34.686623514233,0.0 -58.4877991765516,-34.6867864507125,0.0 -58.4877568067171,-34.687238206282,0.0 -58.4877952169188,-34.6876880804897,0.0 -58.4879731380105,-34.6881347284028,0.0 -58.488335609436035,-34.68876005887501,0.0 ",
				"Polygon Outer Boundary",
				"1127",
				"0700003",
				"La Matanza",
				"Ciudad Madero",
				"0003",
				"2014/10/01",
				"Madero",
				"Villa",
				"90_o_anterior",
				"450",
				"4.5300000000000002000000000000000",
				"Av. Gral. Paz Pcia., Riccheri, Rivera",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6259877588812,-34.4741827093379,0.0 -58.6256142750252,-34.4749425984172,0.0 -58.6256442107532,-34.475002064999,0.0 -58.6284939769784,-34.4764733858411,0.0 -58.6287252052818,-34.4765836942384,0.0 -58.6319450917339,-34.4782655016545,0.0 -58.6321577203937,-34.4783889354491,0.0 -58.6322256319628,-34.4784361160597,0.0 -58.6322876522977,-34.4784841320621,0.0 -58.6323570228525,-34.478541965071,0.0 -58.6325245149432,-34.4787300621477,0.0 -58.6325755500968,-34.4787976050934,0.0 -58.6326317634301,-34.478888010162,0.0 -58.6326787413299,-34.4789774109018,0.0 -58.6327520699576,-34.4790061738,0.0 -58.6343217209782,-34.4787071661072,0.0 -58.6343448368319,-34.4786646094678,0.0 -58.6342767911027,-34.4785988601359,0.0 -58.6335078099488,-34.478186415831,0.0 -58.633183769311,-34.4781594390886,0.0 -58.6312081744279,-34.4771280556626,0.0 -58.628824388148,-34.4758795136141,0.0 -58.6272044914277,-34.4749674984545,0.0 -58.62709380355,-34.4745939955208,0.0 -58.6266819520792,-34.4743813321685,0.0 -58.6265744959684,-34.4743433485274,0.0 -58.6260390747272,-34.474166250256,0.0 -58.6259877588812,-34.4741827093379,0.0 ",
				"Polygon Outer Boundary",
				"712",
				"0570004",
				"Tigre",
				"Tigre",
				"0004",
				"2014/10/01",
				"Basualdo",
				"Villa",
				"90_o_anterior",
				"350",
				"6.9699999999999998000000000000000",
				"Juan de Alarcón, Félix Frías, Madrid, Boulogne Sur Mer",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.81135404109955,-34.49974860475643,0.0 -58.811024548485875,-34.499792814451865,0.0 -58.810536386445165,-34.50005365117777,0.0 -58.8105708360672,-34.50014649117142,0.0 -58.810767056420445,-34.500062493086396,0.0 -58.811029912903905,-34.49998291587513,0.0 -58.811171650886536,-34.49995639012116,0.0 -58.81135404109955,-34.49974860475643,0.0 ",
				"Polygon Outer Boundary",
				"1887",
				"1320049",
				"Jose C. Paz",
				"Jose C. Paz",
				"0049",
				"2015/07/13",
				"FFCC San Martín & Crucero La Argentina",
				"Asentamiento Precario",
				"decada_2000",
				"10",
				"0.2800000000000000300000000000000",
				"Fray Butler, Buenos Aires",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.808714747428894,-34.50059300588689,0.0 -58.80816757678985,-34.50079194731668,0.0 -58.80799055099487,-34.500990888271716,0.0 -58.80821359343826,-34.50117214517298,0.0 -58.808720111846924,-34.50063279421082,0.0 -58.808714747428894,-34.50059300588689,0.0 ",
				"Polygon Outer Boundary",
				"1887",
				"1320049",
				"Jose C. Paz",
				"Jose C. Paz",
				"0049",
				"2015/07/13",
				"FFCC San Martín & Crucero La Argentina",
				"Asentamiento Precario",
				"decada_2000",
				"10",
				"0.2800000000000000300000000000000",
				"Fray Butler, Buenos Aires",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9680176866946,-34.8798487179112,0.0 -57.9683615149126,-34.8802886979266,0.0 -57.9682961304062,-34.8805495290531,0.0 -57.9685987925734,-34.8805354551944,0.0 -57.9690863334651,-34.8801750112711,0.0 -57.9689449826209,-34.8799729422867,0.0 -57.9678245598465,-34.8789047872492,0.0 -57.9676114790297,-34.8786930086476,0.0 -57.9674195389719,-34.8785247088688,0.0 -57.9671741955121,-34.878575482847,0.0 -57.966514011568,-34.8788692007351,0.0 -57.9663523670016,-34.8787345016691,0.0 -57.9660059602718,-34.8790003257899,0.0 -57.9658059434663,-34.8791625988763,0.0 -57.9658810284846,-34.8796560895116,0.0 -57.9663914195587,-34.8802914322987,0.0 -57.9668739595891,-34.8803240502731,0.0 -57.9676840204545,-34.8811288623524,0.0 -57.9679435529954,-34.8810066809445,0.0 -57.9672923284255,-34.8803932567539,0.0 -57.9674193897631,-34.8803020502967,0.0 -57.9680176866946,-34.8798487179112,0.0 ",
				"Polygon Outer Boundary",
				"343",
				"0550072",
				"La Plata",
				"Tolosa",
				"0072",
				"2014/10/07",
				"La Union",
				"Asentamiento Precario",
				"decada_1990",
				"131",
				"4.0999999999999996000000000000000",
				"521, 522, 120, autopista",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.97219308838248,-34.58554638084755,0.0 -60.97277780994773,-34.58504732435596,0.0 -60.9714957140386,-34.58403595289428,0.0 -60.97092708572745,-34.584482017807204,0.0 -60.97219308838248,-34.58554638084755,0.0 ",
				"Polygon Outer Boundary",
				"1778",
				"0540011",
				"Junin",
				"Junín",
				"0011",
				"2015/06/19",
				"La Celeste",
				"Asentamiento Precario",
				"2000",
				"15",
				"1.2200000000000000000000000000000",
				"Pastor Bauman, Chávez, Payán y Angel María de Rosa",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.28798599541187,-35.0658150716164,0.0 -58.285582736134536,-35.06802797291109,0.0 -58.28429460525513,-35.06909927658786,0.0 -58.28521728515625,-35.06969639056691,0.0 -58.286869525909424,-35.07101353830911,0.0 -58.28850030899048,-35.07224285702288,0.0 -58.28938074409962,-35.071241841756105,0.0 -58.29056091606617,-35.07024081421101,0.0 -58.290925696492195,-35.0704866817631,0.0 -58.29225607216358,-35.069380271945704,0.0 -58.28798599541187,-35.0658150716164,0.0 ",
				"Polygon Outer Boundary",
				"2299",
				"1000033",
				"San Vicente",
				"Domselaar",
				"0033",
				"2015/10/05",
				"Domselaar Chico",
				"Otros",
				"90_o_anterior",
				"600",
				"132.5900000000000000000000000000000",
				"Noreste vías FFCC",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.278458788990974,-35.07993445938123,0.0 -58.28264303505421,-35.076246795303426,0.0 -58.2765919715166,-35.07176869342706,0.0 -58.275454714894295,-35.07250628005233,0.0 -58.274381831288345,-35.07348971851597,0.0 -58.277171328663826,-35.07540387725505,0.0 -58.276184275746346,-35.0764048414681,0.0 -58.275025561451905,-35.07735311202742,0.0 -58.278458788990974,-35.07993445938123,0.0 ",
				"Polygon Outer Boundary",
				"2299",
				"1000033",
				"San Vicente",
				"Domselaar",
				"0033",
				"2015/10/05",
				"Domselaar Chico",
				"Otros",
				"90_o_anterior",
				"600",
				"132.5900000000000000000000000000000",
				"Noreste vías FFCC",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.274575620889664,-35.07180381675087,0.0 -58.28410282731056,-35.06449783998158,0.0 -58.27624931931496,-35.057472245619145,0.0 -58.27539101243019,-35.058069444650265,0.0 -58.279081732034676,-35.06140665294649,0.0 -58.27011242508888,-35.068045535379824,0.0 -58.27358856797218,-35.071452582832634,0.0 -58.274575620889664,-35.07180381675087,0.0 ",
				"Polygon Outer Boundary",
				"2299",
				"1000033",
				"San Vicente",
				"Domselaar",
				"0033",
				"2015/10/05",
				"Domselaar Chico",
				"Otros",
				"90_o_anterior",
				"600",
				"132.5900000000000000000000000000000",
				"Noreste vías FFCC",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.6003308903991,-34.5563593344137,0.0 -58.6054013403675,-34.5524888237437,0.0 -58.6006205784132,-34.5483449349701,0.0 -58.5998849564671,-34.5489088822387,0.0 -58.5944652557373,-34.55311914845491,0.0 -58.59438478946685,-34.55308822147943,0.0 -58.5931670665741,-34.55401160765254,0.0 -58.5932010506342,-34.5540323769627,0.0 -58.5996937816127,-34.5560726080519,0.0 -58.6003308903991,-34.5563593344137,0.0 ",
				"Polygon Outer Boundary",
				"762",
				"0470105",
				"General San Martin",
				"Loma Hermosa",
				"0105",
				"2014/10/01",
				"Costa Esperanza",
				"Asentamiento Precario",
				"90_o_anterior",
				"1800",
				"49.2800000000000010000000000000000",
				"Av. Eva Perón, Diagonal Buenos Aires, Güemes, CEAMSE",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.5574808785193,-34.7113613578362,0.0 -58.5626667035646,-34.714151392676,0.0 -58.5674709906612,-34.7103675144522,0.0 -58.5648798207396,-34.7080656323953,0.0 -58.5574808785193,-34.7113613578362,0.0 ",
				"Polygon Outer Boundary",
				"1112",
				"0700018",
				"La Matanza",
				"San Justo",
				"0018",
				"2014/10/01",
				"17 de Marzo",
				"Otros",
				"90_o_anterior",
				"850",
				"29.8500000000000010000000000000000",
				"Crovara, Gaboto, Colonia y Rucci",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.014030729136714,-34.93422303206044,0.0 -58.01392880519415,-34.934231827666885,0.0 -58.01301148971106,-34.93493107536169,0.0 -58.012963209948786,-34.9349618597144,0.0 -58.01381078799749,-34.935788635151106,0.0 -58.01388052543189,-34.93577104427112,0.0 -58.01486221393134,-34.93508939476686,0.0 -58.01489440043951,-34.935027826145614,0.0 -58.014030729136714,-34.93422303206044,0.0 ",
				"Polygon Outer Boundary",
				"1771",
				"0550137",
				"La Plata",
				"Melchor Romero",
				"0137",
				"2015/06/16",
				"La Usina",
				"Asentamiento Precario",
				"2005",
				"70",
				"1.6100000000000001000000000000000",
				"528-529-146-147",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.67326319217681,-34.86654053086051,0.0 -58.6722332239151,-34.86567784622761,0.0 -58.672125935554504,-34.86580548891211,0.0 -58.67101550102234,-34.86666817220598,0.0 -58.67198646068573,-34.86750443818892,0.0 -58.6730808019638,-34.866641763668014,0.0 -58.67326319217681,-34.86654053086051,0.0 ",
				"Polygon Outer Boundary",
				"1024",
				"0700106",
				"La Matanza",
				"Virrey Del Pino",
				"0106",
				"2014/10/01",
				"Concordia & Rufino Zado",
				"Asentamiento Precario",
				"2003",
				"37",
				"2.0200000000000000000000000000000",
				"Concordia, Rufino Zado, Mirave, Zepita",
				"Inexistente",
				"Sin dato",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.77120304852724,-38.53616549630758,0.0 -58.76654673367738,-38.53970694166897,0.0 -58.76839209347963,-38.54116710771012,0.0 -58.77304840832948,-38.53760895006388,0.0 -58.77120304852724,-38.53616549630758,0.0 ",
				"Polygon Outer Boundary",
				"1775",
				"0760012",
				"Necochea",
				"Necochea",
				"0012",
				"2015/06/17",
				"Barrio Los Malvones",
				"Otros",
				"decada_1970",
				"70",
				"12.9000000000000000000000000000000",
				"Calles 106 - 114 - 67 - 71",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.59014689922333,-34.53600151937807,0.0 -58.590441942214966,-34.53582475729746,0.0 -58.59233021736144,-34.53438855148037,0.0 -58.593714237213135,-34.53324398818259,0.0 -58.59339237213135,-34.53288603272454,0.0 -58.59303832054139,-34.53255901034366,0.0 -58.59389662742615,-34.53189170393341,0.0 -58.5924196692944,-34.5305313947845,0.0 -58.5882665600093,-34.5338954373089,0.0 -58.58790457248688,-34.53417201368486,0.0 -58.59014689922333,-34.53600151937807,0.0 ",
				"Polygon Outer Boundary",
				"768",
				"0470099",
				"General San Martin",
				"General San Martin",
				"0099",
				"2014/10/01",
				"Eucaliptus",
				"Villa",
				"2006",
				"600",
				"15.9200000000000000000000000000000",
				"Artigas, Calle 3, calle 8",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.528788685798645,-34.52218201168936,0.0 -58.52891206741333,-34.52225272815094,0.0 -58.52915346622467,-34.52205383794974,0.0 -58.52929830551147,-34.52189914524272,0.0 -58.52940022945403,-34.52197870152792,0.0 -58.52943778038025,-34.521863786869346,0.0 -58.52928221225738,-34.52174887205222,0.0 -58.529287576675415,-34.52166489573947,0.0 -58.52916419506074,-34.521616277835484,0.0 -58.52889060974121,-34.52200080048255,0.0 -58.528788685798645,-34.52218201168936,0.0 ",
				"Polygon Outer Boundary",
				"676",
				"1100003",
				"Vicente Lopez",
				"Munro",
				"0003",
				"2014/10/01",
				"Gral Belgrano",
				"Otros",
				"90_o_anterior",
				"10",
				"0.1700000000000000100000000000000",
				"Gral Acha y Ramón Castro",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-59.0458523674739,-34.1167367982377,0.0 -59.0365509457511,-34.111949109472,0.0 -59.0368263167848,-34.1127914077024,0.0 -59.0456687867976,-34.1174903912399,0.0 -59.0642563318366,-34.1273498084792,0.0 -59.0647608003901,-34.1275606798647,0.0 -59.0657708725447,-34.1281349663353,0.0 -59.0669157151127,-34.1286338530511,0.0 -59.0692130105178,-34.1298825495774,0.0 -59.070513373752,-34.1301738099386,0.0 -59.0706969544439,-34.1300725021008,0.0 -59.0567907170327,-34.1225500559544,0.0 -59.0566429071651,-34.1224139295063,0.0 -59.0541517445882,-34.121068283054,0.0 -59.0458523674739,-34.1167367982377,0.0 ",
				"Polygon Outer Boundary",
				"463",
				"0380013",
				"Zarate",
				"Zárate",
				"0013",
				"2014/09/18",
				"El Progreso",
				"Villa",
				"2000",
				"150",
				"9.1400000000000006000000000000000",
				"Pellegrini, Ruta 9, calle 14",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.0730223098991,-34.1311932133272,0.0 -59.0722573904265,-34.1316047701852,0.0 -59.0726245517414,-34.1317693923691,0.0 -59.0732211889575,-34.1321049673809,0.0 -59.0749499071395,-34.1330103801039,0.0 -59.0768163108405,-34.1339727662106,0.0 -59.0815817596343,-34.1365053088644,0.0 -59.0837923771295,-34.1376512594822,0.0 -59.087395148211,-34.1395569219386,0.0 -59.088335999257,-34.1400317480902,0.0 -59.0884813339714,-34.1400190860941,0.0 -59.0886266686858,-34.1398481489613,0.0 -59.0887337574228,-34.1396962045529,0.0 -59.0730223098991,-34.1311932133272,0.0 ",
				"Polygon Outer Boundary",
				"463",
				"0380013",
				"Zarate",
				"Zárate",
				"0013",
				"2014/09/18",
				"El Progreso",
				"Villa",
				"2000",
				"150",
				"9.1400000000000006000000000000000",
				"Pellegrini, Ruta 9, calle 14",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6960074272679,-34.4809867113373,0.0 -58.6977209387741,-34.4788789988734,0.0 -58.6978236884086,-34.478746059167,0.0 -58.6979833962392,-34.4785550466562,0.0 -58.6982195378286,-34.4782503733672,0.0 -58.6976283788681,-34.477919415416686,0.0 -58.69784295558929,-34.477565644426086,0.0 -58.69814872741699,-34.4776850423031,0.0 -58.6979341506958,-34.47795921455924,0.0 -58.69822919368744,-34.47810514458626,0.0 -58.6984384059906,-34.477844239206675,0.0 -58.69832038879394,-34.47776021865653,0.0 -58.698508143424995,-34.47749046789734,0.0 -58.69851350784302,-34.47749046789734,0.0 -58.69851350784302,-34.47750815649843,0.0 -58.69851887226105,-34.477499312198354,0.0 -58.69851350784302,-34.47749489004796,0.0 -58.6981860823753,-34.4773069967158,0.0 -58.6982191970342,-34.477165202375,0.0 -58.69826138019561,-34.476827142649334,0.0 -58.69825065135956,-34.47677849859027,0.0 -58.69785904884338,-34.47658392207044,0.0 -58.697655200958245,-34.47683598702066,0.0 -58.69702756404877,-34.476667943805126,0.0 -58.6970168352127,-34.47668563258059,0.0 -58.696871995925896,-34.47688905322894,0.0 -58.69686663150787,-34.477185338938206,0.0 -58.696603775024414,-34.477198605437906,0.0 -58.69639456272126,-34.47724724925204,0.0 -58.69625508785248,-34.4771499615954,0.0 -58.696056604385376,-34.47740644699093,0.0 -58.6961090148408,-34.4775640081469,0.0 -58.6961865615764,-34.4777251009448,0.0 -58.695949571589,-34.4780316534298,0.0 -58.6957665423304,-34.4782312478323,0.0 -58.6950271442903,-34.4791541149476,0.0 -58.6943098413858,-34.4800410681805,0.0 -58.6943217987269,-34.4800840112984,0.0 -58.695049009682,-34.4804829766072,0.0 -58.6953758449792,-34.4806533111952,0.0 -58.6960074272679,-34.4809867113373,0.0 ",
				"Polygon Outer Boundary",
				"177",
				"1330024",
				"Malvinas Argentinas",
				"Pablo Nogues",
				"0024",
				"2014/07/25",
				"Los Olivos",
				"Asentamiento Precario",
				"1980",
				"800",
				"8.6799999999999997000000000000000",
				"Copernico- Lavoisier- Pasco- Padre Stoppler",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.34210777655243,-34.88667900382345,0.0 -58.34334159269929,-34.884927645473375,0.0 -58.33950066938996,-34.88300022806778,0.0 -58.33824539557099,-34.88472522476529,0.0 -58.34210777655243,-34.88667900382345,0.0 ",
				"Polygon Outer Boundary",
				"2025",
				"0030073",
				"Almirante Brown",
				"Ministro Rivadavia",
				"0073",
				"2015/08/04",
				"El Triunfo",
				"Asentamiento Precario",
				"2010",
				"50",
				"9.2599999999999998000000000000000",
				"Adolfo Romero, Nuñez, Cnel. Conde y Gral. Morillas",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.47216892987489,-34.7478541400193,0.0 -58.47113896161317,-34.749158830275086,0.0 -58.46541428938508,-34.75681906201571,0.0 -58.467270378023386,-34.75776221748178,0.0 -58.46793556585908,-34.757057055532755,0.0 -58.46951270475983,-34.75724216112731,0.0 -58.471733573824174,-34.75688957868487,0.0 -58.47258115187287,-34.760494663151015,0.0 -58.47923303022981,-34.751512509892855,0.0 -58.47216892987489,-34.7478541400193,0.0 ",
				"Polygon Outer Boundary",
				"1462",
				"0630070",
				"Lomas de Zamora",
				"Ingeniero Budge",
				"0070",
				"2015/03/17",
				"Santa Catalina III",
				"Asentamiento Precario",
				"90_o_anterior",
				"2800",
				"80.8400000000000030000000000000000",
				"Gral. Juan Facundo Quiroga, Av. Giachino, Padre Carlos Mujica.",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.35116744041443,-34.80596778397362,0.0 -58.351526856422424,-34.805531720617196,0.0 -58.350566625595086,-34.80506482194067,0.0 -58.35072755813598,-34.804800538498675,0.0 -58.34950447082519,-34.80411339758364,0.0 -58.34934890270233,-34.80394821862504,0.0 -58.34940254688262,-34.8038469087,0.0 -58.349448563531034,-34.803778634549836,0.0 -58.348949672654264,-34.80288005336804,0.0 -58.34907305426896,-34.802615762920894,0.0 -58.34880709648132,-34.8023955202343,0.0 -58.34843695163726,-34.802836005019024,0.0 -58.3488017320633,-34.8030562465287,0.0 -58.34842085838318,-34.80347910857767,0.0 -58.3493059873581,-34.804038516496746,0.0 -58.34917187690735,-34.80429839762429,0.0 -58.349601030349724,-34.80453625420928,0.0 -58.3504593372345,-34.805157320945156,0.0 -58.350239396095276,-34.80542600794092,0.0 -58.35116744041443,-34.80596778397362,0.0 ",
				"Polygon Outer Boundary",
				"1983",
				"0030062",
				"Almirante Brown",
				"Claypole",
				"0062",
				"2015/07/25",
				"Sáenz (Acumar)",
				"Otros",
				"1943",
				"82",
				"1.9299999999999999000000000000000",
				"J.V. Gonzalez, R. Rojas, Tuyuti, Uruguay, San Francisco de Asis, Cavour, Marconi y Garibaldi",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.97016763687134,-34.622812569614204,0.0 -58.97074732929468,-34.62210184263428,0.0 -58.97051632404327,-34.62197382284186,0.0 -58.97153556346893,-34.620680370413524,0.0 -58.97094547748565,-34.6203669369272,0.0 -58.96950798109174,-34.6221945464986,0.0 -58.97016763687134,-34.622812569614204,0.0 ",
				"Polygon Outer Boundary",
				"2300",
				"0460010",
				"General Rodriguez",
				"General Rodríguez",
				"0010",
				"2015/10/05",
				"Thompson y Camino Navarro",
				"Asentamiento Precario",
				"2013",
				"80",
				"1.8400000000000001000000000000000",
				"Thompson, Bolivar, Islas Malvinas",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-62.08873467519879,-38.85041595489878,0.0 -62.089271117001765,-38.84869052930863,0.0 -62.0865030772984,-38.848210076477244,0.0 -62.08629922941327,-38.84888688735781,0.0 -62.085977364331484,-38.84997311358221,0.0 -62.08873467519879,-38.85041595489878,0.0 ",
				"Polygon Outer Boundary",
				"2301",
				"1130001",
				"Coronel Rosales",
				"Punta Alta",
				"0001",
				"2015/10/05",
				"Gaudí",
				"Otros",
				"2015",
				"150",
				"8.4499999999999993000000000000000",
				"Roca y Pilcomayo",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.087983656674616,-38.853223337595736,0.0 -62.08857910707593,-38.85140607126575,0.0 -62.087297011166804,-38.85123060861055,0.0 -62.08709316328167,-38.85212880573473,0.0 -62.08554821088911,-38.85190739075282,0.0 -62.08529071882367,-38.852763803369484,0.0 -62.087983656674616,-38.853223337595736,0.0 ",
				"Polygon Outer Boundary",
				"2301",
				"1130001",
				"Coronel Rosales",
				"Punta Alta",
				"0001",
				"2015/10/05",
				"Gaudí",
				"Otros",
				"2015",
				"150",
				"8.4499999999999993000000000000000",
				"Roca y Pilcomayo",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.73921334743499,-34.577455113114574,0.0 -58.738848567008965,-34.577123849016395,0.0 -58.73825579881668,-34.57756332576727,0.0 -58.73861789703369,-34.5778967965253,0.0 -58.738926351070404,-34.57766932986188,0.0 -58.73921334743499,-34.577455113114574,0.0 ",
				"Polygon Outer Boundary",
				"724",
				"1310010",
				"San Miguel",
				"San Miguel",
				"0010",
				"2014/10/01",
				"Santa Brigida",
				"Otros",
				"90_o_anterior",
				"184",
				"0.3700000000000000000000000000000",
				"Avellaneda a Conesa, Pedro de Uriarte a Pinzón a Las Tres Marías",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-62.331696040928364,-38.70388172537618,0.0 -62.33130980283022,-38.70398219717051,0.0 -62.33083773404359,-38.70414964984734,0.0 -62.329679019749165,-38.70476922134195,0.0 -62.327425964176655,-38.70570694096028,0.0 -62.3235635831952,-38.70738140969152,0.0 -62.320001609623425,-38.70890514215732,0.0 -62.31530237942933,-38.71074697321397,0.0 -62.315152175724506,-38.71079720430535,0.0 -62.31045294553041,-38.712689216378635,0.0 -62.31105376034974,-38.71396169190873,0.0 -62.312169559299946,-38.713794262212076,0.0 -62.313950546085835,-38.71327522766025,0.0 -62.31635380536317,-38.71230412063499,0.0 -62.32010889798403,-38.71047907346384,0.0 -62.321439273655415,-38.70984280753374,0.0 -62.32708264142275,-38.707465132098704,0.0 -62.33161021023989,-38.70565670629248,0.0 -62.332726009190075,-38.70497016229542,0.0 -62.331696040928364,-38.70388172537618,0.0 ",
				"Polygon Outer Boundary",
				"1490",
				"0070001",
				"Bahia Blanca",
				"Bahia Blanca",
				"0001",
				"2015/04/09",
				"Ferrocarril Roca",
				"Asentamiento Precario",
				"2010",
				"560",
				"35.6599999999999970000000000000000",
				"FFRR Roca entre Sesquicentenario Y Pablo Acosta",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.39903572719777,-35.013503852017124,0.0 -58.397762775421135,-35.011000289531125,0.0 -58.399976390210206,-35.01011675513701,0.0 -58.39958667755127,-35.009436123364836,0.0 -58.398857116699226,-35.007924653485155,0.0 -58.39778770765406,-35.008306518084325,0.0 -58.39669336637598,-35.00602169568315,0.0 -58.39551319440943,-35.006338059514185,0.0 -58.39353908857447,-35.002084621220725,0.0 -58.39332451185327,-35.002084621220725,0.0 -58.3888613160525,-35.00352589367683,0.0 -58.38802446683985,-35.001768240941864,0.0 -58.38761677106959,-35.00245372999985,0.0 -58.386865752545425,-35.00331497734229,0.0 -58.385749953595216,-35.00461561941011,0.0 -58.38547100385767,-35.00486168450239,0.0 -58.38433374723536,-35.00626775654635,0.0 -58.38487018903833,-35.007304719195275,0.0 -58.388196128216805,-35.00626775654635,0.0 -58.38914026579004,-35.00851742155028,0.0 -58.39075306575978,-35.007985368702265,0.0 -58.392383848840836,-35.011535518519686,0.0 -58.398735319788095,-35.01410137245598,0.0 -58.39925030391896,-35.01399592798988,0.0 -58.39903572719777,-35.013503852017124,0.0 ",
				"Polygon Outer Boundary",
				"1996",
				"1000023",
				"San Vicente",
				"San Vicente",
				"0023",
				"2015/07/28",
				"Parque Ibañez",
				"Otros",
				"90_o_anterior",
				"280",
				"84.5900000000000030000000000000000",
				"French, Avellaneda, Potrerillos y San Pedro",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.59975457191467,-34.47750815649843,0.0 -58.60078454017639,-34.47836604914997,0.0 -58.6012737404451,-34.4780532944488,0.0 -58.6013191571264,-34.4780450710788,0.0 -58.60180377960205,-34.4774462463782,0.0 -58.601964712142944,-34.47734011463665,0.0 -58.601975440979,-34.47715438376407,0.0 -58.601943254470825,-34.4766502550259,0.0 -58.6017212623481,-34.4763340173728,0.0 -58.6017052590072,-34.4762755158041,0.0 -58.60126733779907,-34.47573043333916,0.0 -58.6007803975316,-34.4755861124306,0.0 -58.6007262228959,-34.4755648506711,0.0 -58.6005022832955,-34.4755810345738,0.0 -58.600233196439,-34.4755502806883,0.0 -58.5992077831595,-34.4755513299372,0.0 -58.5990044245127,-34.4755473761919,0.0 -58.5980311734165,-34.4755598301424,0.0 -58.5980089449604,-34.475587336912,0.0 -58.59795212745666,-34.475686210887226,0.0 -58.59807014465331,-34.4758896339721,0.0 -58.59830617904663,-34.47611958990565,0.0 -58.598531484603875,-34.47638492288765,0.0 -58.59869241714477,-34.476473367027474,0.0 -58.59881043434143,-34.47665909941598,0.0 -58.59902501106262,-34.47684483139105,0.0 -58.599432706832886,-34.47718976110501,0.0 -58.59975457191467,-34.47750815649843,0.0 ",
				"Polygon Outer Boundary",
				"572",
				"0960019",
				"San Fernando",
				"Virreyes",
				"0019",
				"2014/10/01",
				"Presidente Perón",
				"Villa",
				"decada_1960",
				"364",
				"6.8499999999999996000000000000000",
				"Av. Hipolito Yrigoyen, Serranio, J. Antonio",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.7103059962565,-34.4779100857911,0.0 -58.7102347612381,-34.47790393796722,0.0 -58.710063099861145,-34.47811619988094,0.0 -58.71026158332825,-34.47821790852323,0.0 -58.71047616004944,-34.478003435806514,0.0 -58.71057003736495,-34.47789951583826,0.0 -58.71066391468048,-34.47801006899157,0.0 -58.71088922023773,-34.47782655067683,0.0 -58.71049761772156,-34.477592177302405,0.0 -58.71038764715194,-34.47773147476469,0.0 -58.71044933795928,-34.47778232933583,0.0 -58.7103059962565,-34.4779100857911,0.0 ",
				"Polygon Outer Boundary",
				"202",
				"1330103",
				"Malvinas Argentinas",
				"Pablo Nogues",
				"0103",
				"2014/07/25",
				"Bella Flor 2",
				"Villa",
				"90_o_anterior",
				"11",
				"0.2000000000000000100000000000000",
				"Cristophersen- Japón",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.57884407043457,-34.532554591113495,0.0 -58.57812523841857,-34.53319095784147,0.0 -58.5782157522341,-34.5333085529685,0.0 -58.5798402866553,-34.5318833124835,0.0 -58.5843510672463,-34.5283185833253,0.0 -58.5838361593755,-34.5280681910612,0.0 -58.5832620719236,-34.5286490391642,0.0 -58.5827892191852,-34.528469613413,0.0 -58.5829866378406,-34.5282588600602,0.0 -58.5824077011631,-34.5279858503763,0.0 -58.5822029313447,-34.5283232675313,0.0 -58.58108639717101,-34.53000907556601,0.0 -58.57976675033569,-34.53166190181246,0.0 -58.57884407043457,-34.532554591113495,0.0 ",
				"Polygon Outer Boundary",
				"769",
				"0470098",
				"General San Martin",
				"José León Suárez",
				"0098",
				"2014/10/01",
				"Ciudad de Dios",
				"Villa",
				"2005",
				"190",
				"4.5700000000000003000000000000000",
				"Vías de FFCC, San Martín",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.67047905921936,-34.882208125617275,0.0 -58.66894483566284,-34.88100235500935,0.0 -58.66782903671264,-34.88185607763319,0.0 -58.66572618484497,-34.880060609457516,0.0 -58.665339946746826,-34.879699750825836,0.0 -58.664149045944214,-34.88065030186039,0.0 -58.663891553878784,-34.880597493757975,0.0 -58.66282939910888,-34.879699750825836,0.0 -58.6573438805639,-34.8839734800277,0.0 -58.654847145080566,-34.88600134697948,0.0 -58.65102767944335,-34.889011156742875,0.0 -58.652851581573486,-34.88918716559761,0.0 -58.653967380523675,-34.8893455732445,0.0 -58.65609169006348,-34.890929632916354,0.0 -58.66031885147095,-34.89045441822153,0.0 -58.6627948610183,-34.8885352335833,0.0 -58.6644564461118,-34.8871092018015,0.0 -58.6670607238326,-34.8851126271982,0.0 -58.6690302236401,-34.8834858203679,0.0 -58.67047905921936,-34.882208125617275,0.0 ",
				"Polygon Outer Boundary",
				"1048",
				"0700082",
				"La Matanza",
				"Virrey Del Pino",
				"0082",
				"2014/10/01",
				"Fondo Recoleta",
				"Asentamiento Precario",
				"2010",
				"400",
				"102.5999999999999900000000000000000",
				"Hilarón Plaza, Arroyo Chacon, Felipe Pereyra Arroyo Rodriguez",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.654932975769036,-34.82008353814432,0.0 -58.65647792816162,-34.81886804885587,0.0 -58.65401029586791,-34.81679815263439,0.0 -58.653688430786126,-34.81651629040248,0.0 -58.652368783950806,-34.81751161209915,0.0 -58.65099549293518,-34.81647224934164,0.0 -58.65066289901733,-34.81674530353936,0.0 -58.652390241622925,-34.81810175291329,0.0 -58.654932975769036,-34.82008353814432,0.0 ",
				"Polygon Outer Boundary",
				"1039",
				"0700091",
				"La Matanza",
				"Virrey Del Pino",
				"0091",
				"2014/10/01",
				"Oro Verde",
				"Asentamiento Precario",
				"decada_2000",
				"140",
				"8.1899999999999995000000000000000",
				"Areco y Camargo; Villanueva y Morel;  Hidalgo y Costilla y Morel",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.123316407203674,-34.57443835266546,0.0 -59.122796058654785,-34.574782878429794,0.0 -59.12291944026947,-34.574941889839465,0.0 -59.12277996540069,-34.57505673122397,0.0 -59.122989177703865,-34.57527316263275,0.0 -59.123606085777276,-34.57482704829633,0.0 -59.123316407203674,-34.57443835266546,0.0 ",
				"Polygon Outer Boundary",
				"1880",
				"0640009",
				"Lujan",
				"Luján",
				"0009",
				"2015/07/08",
				"San Cayetano",
				"Otros",
				"decada_1990",
				"15",
				"0.3599999999999999900000000000000",
				"RICARDO GUTIERREZ ENTRE VELEZ SARSFIELD Y PEDRO ALBERTI",
				"Sin dato",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.22746127843857,-34.75756829854615,0.0 -58.227359354496,-34.75768949793429,0.0 -58.229266405105584,-34.758687733400514,0.0 -58.22956681251525,-34.75829549220642,0.0 -58.228762149810784,-34.75784154782419,0.0 -58.2287836074829,-34.75763440732538,0.0 -58.22864413261413,-34.757563891292314,0.0 -58.22864413261413,-34.757563891292314,0.0 -58.228628039360046,-34.75755948403826,0.0 -58.22861194610596,-34.757555076783945,0.0 -58.22859048843384,-34.757537447764385,0.0 -58.22857439517975,-34.75755066952942,0.0 -58.22851538658142,-34.75749337519903,0.0 -58.228434920310974,-34.75757270579975,0.0 -58.22838127613067,-34.757652036324224,0.0 -58.22818547487259,-34.75757050217297,0.0 -58.22805941104888,-34.75748015342485,0.0 -58.2276999950409,-34.75729504836384,0.0 -58.22757124900818,-34.75743828445926,0.0 -58.22746127843857,-34.75756829854615,0.0 ",
				"Polygon Outer Boundary",
				"2294",
				"1200024",
				"Berazategui",
				"Berazategui",
				"0024",
				"2015/10/01",
				"Calle137 &  calle4",
				"Villa",
				"90_o_anterior",
				"85",
				"1.1699999999999999000000000000000",
				"Calle 137, Calle 4",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.99627089500427,-34.32387424790055,0.0 -58.99977922439575,-34.3268070397381,0.0 -59.000755548477166,-34.32651465119442,0.0 -58.998427391052246,-34.324521065786776,0.0 -59.00001525878906,-34.32327172812418,0.0 -58.99838447570801,-34.32200465036276,0.0 -58.99780511856079,-34.32257173648117,0.0 -58.99709701538086,-34.32311223687103,0.0 -58.99627089500427,-34.32387424790055,0.0 ",
				"Polygon Outer Boundary",
				"1968",
				"0310005",
				"Exaltacion de la Cruz",
				"Los Cardales",
				"0005",
				"2015/07/23",
				"Los Floristas",
				"Asentamiento Precario",
				"decada_1950",
				"80",
				"8.2400000000000002000000000000000",
				"Calles Baradero Sur, Parada Robles Norte, Matheu Sur, Parada Robles Sur, Garin, Rodriguez",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.47404479980468,-34.79074384321534,0.0 -58.47452759742737,-34.790096234795136,0.0 -58.47448468208313,-34.79005217961581,0.0 -58.47394287586212,-34.790699788381986,0.0 -58.47243010997772,-34.78991560841036,0.0 -58.47259640693664,-34.78969973733401,0.0 -58.47218334674835,-34.78948827124196,0.0 -58.47200095653534,-34.78972176502075,0.0 -58.47158789634704,-34.78951911008082,0.0 -58.47149670124054,-34.78961603207074,0.0 -58.473948240280144,-34.79086719662355,0.0 -58.47404479980468,-34.79074384321534,0.0 ",
				"Polygon Outer Boundary",
				"1196",
				"0300030",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0030",
				"2014/10/01",
				"Don Tito",
				"Asentamiento Precario",
				"90_o_anterior",
				"30",
				"0.6200000000000000000000000000000",
				"Estrecho San Carlos, Sarro y M. Castex",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.498882055282586,-34.82995652204999,0.0 -58.501811027526855,-34.831383206859,0.0 -58.502304553985596,-34.83070069097578,0.0 -58.50255131721496,-34.83039685950484,0.0 -58.50411772727966,-34.83111020118457,0.0 -58.50476682186126,-34.830123850560206,0.0 -58.50182712078094,-34.828639899014235,0.0 -58.501070737838745,-34.82967030144162,0.0 -58.499584794044495,-34.82897015760646,0.0 -58.498882055282586,-34.82995652204999,0.0 ",
				"Polygon Outer Boundary",
				"1222",
				"0300004",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0004",
				"2014/10/01",
				"Vialidad",
				"Otros",
				"90_o_anterior",
				"400",
				"8.1699999999999999000000000000000",
				"Francisco Narciso de Laprida, El Ceibo, 20 de Junio",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-62.32720518484712,-38.71587036273196,0.0 -62.32564950361848,-38.71659028673451,0.0 -62.324576620012515,-38.717226492608134,0.0 -62.32236647978425,-38.71823938764253,0.0 -62.32077240943908,-38.71903462575059,0.0 -62.321877479553216,-38.71987170893643,0.0 -62.32311749830842,-38.7194280560691,0.0 -62.323825601488345,-38.71924389746622,0.0 -62.32434058561921,-38.71910159276626,0.0 -62.325713876634836,-38.71839006501615,0.0 -62.32645416632295,-38.7179380319423,0.0 -62.32598662376403,-38.71761993288021,0.0 -62.32811713591217,-38.71648146147841,0.0 -62.32720518484712,-38.71587036273196,0.0 ",
				"Polygon Outer Boundary",
				"1492",
				"0070003",
				"Bahia Blanca",
				"Bahia Blanca",
				"0003",
				"2015/04/09",
				"Paloni",
				"Asentamiento Precario",
				"2010",
				"120",
				"9.2699999999999996000000000000000",
				"Colorados del Monte, Fortín Carhué, Coulin y Biglo",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.31248522177338,-38.714070521001254,0.0 -62.3122706450522,-38.714137492668144,0.0 -62.3109402693808,-38.7144221215524,0.0 -62.31040382757783,-38.71473186346219,0.0 -62.309298757463694,-38.71560248218228,0.0 -62.31033945456147,-38.71642286319496,0.0 -62.31092954054475,-38.71587036273196,0.0 -62.31191659346223,-38.71517554548113,0.0 -62.31286073103547,-38.71434677872274,0.0 -62.31248522177338,-38.714070521001254,0.0 ",
				"Polygon Outer Boundary",
				"1493",
				"0070004",
				"Bahia Blanca",
				"Bahia Blanca",
				"0004",
				"2015/04/09",
				"Británico",
				"Asentamiento Precario",
				"decada_1990",
				"80",
				"3.3900000000000001000000000000000",
				"Pampa Central, Acosta. Jujuy y Veres",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.684335350990295,-34.58707444668818,0.0 -58.68401348590851,-34.586531235749995,0.0 -58.68405640125275,-34.585391806148415,0.0 -58.68406713008881,-34.58425236092333,0.0 -58.6840419843793,-34.58409336732426,0.0 -58.683852553367615,-34.58384604334331,0.0 -58.68297278881072,-34.58309081734609,0.0 -58.681878447532654,-34.582119171465486,0.0 -58.68170142173767,-34.581584761389074,0.0 -58.68147075176239,-34.581324180022904,0.0 -58.68110597133637,-34.581032681255316,0.0 -58.67977190762758,-34.581973423603614,0.0 -58.681295402348034,-34.583581052546904,0.0 -58.68172455579043,-34.584358356487066,0.0 -58.682303912937634,-34.58543597037752,0.0 -58.68270456790924,-34.586491488468745,0.0 -58.683396577835076,-34.58701261798,0.0 -58.68389010429382,-34.58739242217501,0.0 -58.683938384056084,-34.58741008744415,0.0 -58.684356808662415,-34.58713185901886,0.0 -58.684335350990295,-34.58707444668818,0.0 ",
				"Polygon Outer Boundary",
				"1387",
				"1310019",
				"San Miguel",
				"San Miguel",
				"0019",
				"2015/02/11",
				"San Blas",
				"Villa",
				"2004",
				"750",
				"11.1199999999999990000000000000000",
				"Río Primero. Río Segundo, Gaspar Campos, Río Reconquista",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.307749278843396,-38.718415177880864,0.0 -62.305925376713276,-38.71973777628556,0.0 -62.306912429630756,-38.72069204094606,0.0 -62.30641890317201,-38.721177539128355,0.0 -62.30747032910585,-38.72203133827584,0.0 -62.309744842350476,-38.72375564662566,0.0 -62.306762225925915,-38.72591515858876,0.0 -62.30747032910585,-38.726467581398055,0.0 -62.309680469334126,-38.724793559746196,0.0 -62.31124687939882,-38.723705424640656,0.0 -62.31208372861146,-38.72310275806742,0.0 -62.313907630741596,-38.722098302483445,0.0 -62.3098735883832,-38.71856585488386,0.0 -62.308757789432995,-38.71925226832211,0.0 -62.307749278843396,-38.718415177880864,0.0 ",
				"Polygon Outer Boundary",
				"1495",
				"0070006",
				"Bahia Blanca",
				"Bahia Blanca",
				"0006",
				"2015/04/09",
				"Nocito",
				"Villa",
				"decada_1980",
				"800",
				"26.5000000000000000000000000000000",
				"17 de Mayo, Pampa Central, Molina, Pacífico, Av. Buenos Aires",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.30471980758011,-38.72424949426474,0.0 -62.30501485057175,-38.72448804656275,0.0 -62.304955841973424,-38.72480611505456,0.0 -62.305470826104276,-38.724626155423906,0.0 -62.30516505427658,-38.72391886783314,0.0 -62.30471980758011,-38.72424949426474,0.0 ",
				"Polygon Outer Boundary",
				"1496",
				"0070007",
				"Bahia Blanca",
				"Bahia Blanca",
				"0007",
				"2015/04/09",
				"La Plata & Santa Cruz",
				"Asentamiento Precario",
				"2010",
				"10",
				"0.3100000000000000000000000000000",
				"La Plata y Santa Cruz",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.29923510923981,-38.731807448351375,0.0 -62.297604326158755,-38.73296241409282,0.0 -62.297024969011545,-38.73253558110288,0.0 -62.29596281424165,-38.73331392169891,0.0 -62.2965314425528,-38.73376585750793,0.0 -62.29539418593049,-38.734627875289355,0.0 -62.29610228911042,-38.735238813631334,0.0 -62.296542171388865,-38.734862208421845,0.0 -62.29991102591157,-38.73221754702086,0.0 -62.29923510923981,-38.731807448351375,0.0 ",
				"Polygon Outer Boundary",
				"1500",
				"0070011",
				"Bahia Blanca",
				"Bahia Blanca",
				"0011",
				"2015/04/10",
				"Caracol I",
				"Villa",
				"90_o_anterior",
				"78",
				"4.7699999999999996000000000000000",
				"Ricchieri, Carhue, Roldán y Roca",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.30671310797334,-38.726074189835295,0.0 -62.30644488707184,-38.72593189873664,0.0 -62.305093053728335,-38.72693630043226,0.0 -62.30383777990937,-38.72790720864999,0.0 -62.30184221640229,-38.72948072153499,0.0 -62.30265760794281,-38.73016703013029,0.0 -62.305318359285586,-38.72814993364287,0.0 -62.30730319395661,-38.72660150143588,0.0 -62.30671310797334,-38.726074189835295,0.0 ",
				"Polygon Outer Boundary",
				"1497",
				"0070008",
				"Bahia Blanca",
				"Bahia Blanca",
				"0008",
				"2015/04/09",
				"Don Onésimo",
				"Asentamiento Precario",
				"decada_1990",
				"70",
				"6.0999999999999996000000000000000",
				"Ricchieri, Pacífico, La Plata y Charlone",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.309445859864354,-38.71476116330309,0.0 -62.305615665391095,-38.71512113179679,0.0 -62.305958988144994,-38.71541412806966,0.0 -62.30698895640671,-38.71530530102279,0.0 -62.307986738160245,-38.71522995912405,0.0 -62.30926346965134,-38.715108574786825,0.0 -62.30959069915116,-38.71485743412433,0.0 -62.309445859864354,-38.71476116330309,0.0 ",
				"Polygon Outer Boundary",
				"1494",
				"0070005",
				"Bahia Blanca",
				"Bahia Blanca",
				"0005",
				"2015/04/09",
				"Carlos Gardel",
				"Villa",
				"90_o_anterior",
				"43",
				"1.1499999999999999000000000000000",
				"Carlos Gardel entre Veres y 17 de Mayo",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.30186987668275,-38.724626155423906,0.0 -62.30154407210647,-38.72485633626595,0.0 -62.30089497752487,-38.72538365685438,0.0 -62.301957132294774,-38.72622066567027,0.0 -62.30197858996689,-38.726216480650585,0.0 -62.30249893851578,-38.72576868212749,0.0 -62.30250430293381,-38.72566405589986,0.0 -62.30285835452378,-38.72541713739528,0.0 -62.30186987668275,-38.724626155423906,0.0 ",
				"Polygon Outer Boundary",
				"1498",
				"0070009",
				"Bahia Blanca",
				"Bahia Blanca",
				"0009",
				"2015/04/09",
				"Mariano Moreno",
				"Asentamiento Precario",
				"90_o_anterior",
				"50",
				"1.5200000000000000000000000000000",
				"Santa Cruz, Calvento, Entre Ríos y Chaco",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.78989100456238,-34.514968617248826,0.0 -58.7881851196289,-34.5138414679485,0.0 -58.787691593170166,-34.51369560045416,0.0 -58.78661334514617,-34.5151012220464,0.0 -58.785717487335205,-34.51629465572756,0.0 -58.785207867622375,-34.51677644448112,0.0 -58.78454804420471,-34.51714330927818,0.0 -58.783614635467536,-34.518009634194435,0.0 -58.783308863639824,-34.51853561278414,0.0 -58.78291726112366,-34.51908368778153,0.0 -58.782868981361396,-34.51937540364852,0.0 -58.78270268440246,-34.519636179089076,0.0 -58.782981634140015,-34.51983507506281,0.0 -58.783716559410095,-34.51907042794513,0.0 -58.78459632396697,-34.518173174111695,0.0 -58.78565311431885,-34.517085848633535,0.0 -58.7868708372116,-34.517890294052215,0.0 -58.78839433193207,-34.51620625381891,0.0 -58.78866255283355,-34.516343276737345,0.0 -58.78989100456238,-34.514968617248826,0.0 ",
				"Polygon Outer Boundary",
				"1719",
				"1320039",
				"Jose C. Paz",
				"Jose C. Paz",
				"0039",
				"2015/05/18",
				"11 de Septiembre & Fernandez Moreno",
				"Otros",
				"2000",
				"275",
				"11.8200000000000000000000000000000",
				"Ballestero, Agrelo, Varela",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.5859443062869,-34.4761874411913,0.0 -58.5855384987538,-34.4761642668877,0.0 -58.585289151289,-34.4761314550014,0.0 -58.5845072007411,-34.4760558794688,0.0 -58.5842331235541,-34.4760437809008,0.0 -58.5835309041848,-34.4759455067854,0.0 -58.583252401839,-34.4758797237265,0.0 -58.5825243969504,-34.4757105600868,0.0 -58.5823196020096,-34.4757011621615,0.0 -58.5815838571295,-34.4755197434134,0.0 -58.5813795736695,-34.4754582116739,0.0 -58.5812843002589,-34.4754312674156,0.0 -58.5809065517465,-34.4753197096047,0.0 -58.5808457540675,-34.475342799486,0.0 -58.5805174104948,-34.4757137715803,0.0 -58.5803888614028,-34.4758619945311,0.0 -58.5799400004137,-34.4763564934614,0.0 -58.5799226687268,-34.4764087221353,0.0 -58.5796960375735,-34.4767060904044,0.0 -58.5791226313175,-34.4773173070662,0.0 -58.5791298687237,-34.4773462345578,0.0 -58.5798313287502,-34.4776695048423,0.0 -58.5798659018371,-34.4776653998446,0.0 -58.5799560371938,-34.477587578083,0.0 -58.5801912566456,-34.4773988947469,0.0 -58.5802588382565,-34.4775748720743,0.0 -58.5803347465347,-34.4779233383311,0.0 -58.5804365056463,-34.4779725417569,0.0 -58.5805520867198,-34.4780168811791,0.0 -58.5807788170447,-34.478125694808,0.0 -58.5812897159167,-34.4783753145198,0.0 -58.5815090104804,-34.4784691192418,0.0 -58.5820361319558,-34.4787208577921,0.0 -58.5822664230777,-34.4788060046327,0.0 -58.5826019462429,-34.4789963487699,0.0 -58.5827801401578,-34.4790847156578,0.0 -58.5828229258462,-34.4790777305893,0.0 -58.5834723395989,-34.4785667076408,0.0 -58.5848983483152,-34.4774370591191,0.0 -58.5857541130808,-34.4767512954874,0.0 -58.58607530593872,-34.47650874465717,0.0 -58.5863654823268,-34.4762545083892,0.0 -58.5863563918966,-34.4762320492533,0.0 -58.5859443062869,-34.4761874411913,0.0 ",
				"Polygon Outer Boundary",
				"573",
				"0960020",
				"San Fernando",
				"Victoria",
				"0020",
				"2014/10/01",
				"Jardin",
				"Asentamiento Precario",
				"90_o_anterior",
				"684",
				"14.4200000000000000000000000000000",
				"A. Gilardoni, Guatemala, España, Uruguay",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.76485681626946,-38.556807486461125,0.0 -58.76451885793358,-38.55705708402215,0.0 -58.76436328981072,-38.55693123662071,0.0 -58.76419431064278,-38.557059181476966,0.0 -58.764352560974665,-38.557185028654416,0.0 -58.76401996705681,-38.55743881979208,0.0 -58.76423186156899,-38.557615004848316,0.0 -58.76428818795829,-38.55761919972534,0.0 -58.765068710781634,-38.55702771964818,0.0 -58.76507139299064,-38.55697738069349,0.0 -58.76485681626946,-38.556807486461125,0.0 ",
				"Polygon Outer Boundary",
				"1781",
				"0760014",
				"Necochea",
				"Necochea",
				"0014",
				"2015/06/23",
				"calle 89 entre 80 y 82",
				"Asentamiento Precario",
				"decada_2000",
				"10",
				"0.5799999999999999600000000000000",
				"calle 89 entre 80 y 82",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.76548981759697,-38.557310875611535,0.0 -58.76527524087577,-38.55714098216737,0.0 -58.76522159669548,-38.55713888471493,0.0 -58.76474529504776,-38.557514327726196,0.0 -58.764764070510864,-38.55752691237417,0.0 -58.76482307910919,-38.55756886118484,0.0 -58.7648981809616,-38.55762758947866,0.0 -58.765152990818024,-38.55783104069691,0.0 -58.7653112411499,-38.55770729208638,0.0 -58.765318156220026,-38.55769470746998,0.0 -58.76515990588814,-38.55756886118484,0.0 -58.76548981759697,-38.557310875611535,0.0 ",
				"Polygon Outer Boundary",
				"1781",
				"0760014",
				"Necochea",
				"Necochea",
				"0014",
				"2015/06/23",
				"calle 89 entre 80 y 82",
				"Asentamiento Precario",
				"decada_2000",
				"10",
				"0.5799999999999999600000000000000",
				"calle 89 entre 80 y 82",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9935394643678,-34.9542205509856,0.0 -57.9926537492926,-34.9533710968893,0.0 -57.9932532598316,-34.9529300812188,0.0 -57.9922505809796,-34.9519256786937,0.0 -57.9917376281475,-34.9522933354594,0.0 -57.9913901565484,-34.9520295770432,0.0 -57.991041264008,-34.9516591658028,0.0 -57.9907779779444,-34.9515082222762,0.0 -57.9912716117064,-34.951018110083,0.0 -57.9917781860341,-34.9505287947115,0.0 -57.9914263317601,-34.9502281172791,0.0 -57.9908463887458,-34.9496593230207,0.0 -57.991219251565,-34.9492977946365,0.0 -57.9903395905977,-34.9484330209381,0.0 -57.9902524960972,-34.9485028505582,0.0 -57.9895153804241,-34.9490569614412,0.0 -57.989335374024,-34.9492039823345,0.0 -57.9901469652458,-34.9499249118642,0.0 -57.9904310056746,-34.9504308289601,0.0 -57.9902515451614,-34.9505591903472,0.0 -57.9903970590614,-34.9506961477357,0.0 -57.9901723120577,-34.9508590594755,0.0 -57.9903073277199,-34.9510550363033,0.0 -57.9900174221374,-34.9512674421341,0.0 -57.9903009665522,-34.9516115992762,0.0 -57.9901481632495,-34.951722548727,0.0 -57.9921848510292,-34.9536281064589,0.0 -57.9910249153027,-34.9544698633923,0.0 -57.9919629775349,-34.9553613377204,0.0 -57.9925992097881,-34.9549902538609,0.0 -57.9935394643678,-34.9542205509856,0.0 ",
				"Polygon Outer Boundary",
				"351",
				"0550078",
				"La Plata",
				"San Carlos",
				"0078",
				"2014/10/10",
				"48 & 144",
				"Asentamiento Precario",
				"1998",
				"203",
				"8.6999999999999993000000000000000",
				"144, 149, 47, arroyo, 52",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6067726348864,-34.7948872070072,0.0 -58.608450965721,-34.79350898274,0.0 -58.6099788795196,-34.7922560207554,0.0 -58.611502647399895,-34.79105663185545,0.0 -58.61132025718689,-34.79095971155861,0.0 -58.609796762466424,-34.792096315147475,0.0 -58.60910475254059,-34.792655800307635,0.0 -58.60890626907348,-34.792431125620695,0.0 -58.607935309410095,-34.793175633511076,0.0 -58.6066250668081,-34.7921220718205,0.0 -58.6049883329966,-34.7933896600267,0.0 -58.6067726348864,-34.7948872070072,0.0 ",
				"Polygon Outer Boundary",
				"1066",
				"0700064",
				"La Matanza",
				"Gonzalez Catan",
				"0064",
				"2014/10/01",
				"Cnel. Conde & Vicente Blasco Ibañez",
				"Asentamiento Precario",
				"2009",
				"120",
				"6.0999999999999996000000000000000",
				"Cnel. Conde, Vicente Blasco Ibañez",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.3137115649879,-34.80175681311547,0.0 -58.30994037911296,-34.79980982708696,0.0 -58.30771951004862,-34.802941721017106,0.0 -58.30793023109437,-34.8030562465287,0.0 -58.30713629722595,-34.803990063992536,0.0 -58.307576179504395,-34.80416625478048,0.0 -58.30785512924194,-34.80381387282795,0.0 -58.30834865570068,-34.80391958757189,0.0 -58.308649063110344,-34.80353196618126,0.0 -58.30955414101482,-34.80396363534185,0.0 -58.30935565754771,-34.80416625478048,0.0 -58.30938247963786,-34.804465778255654,0.0 -58.310063760727644,-34.804430540256256,0.0 -58.31104008480906,-34.80498994171813,0.0 -58.311276119202375,-34.8052674386723,0.0 -58.31135658547282,-34.805285057495,0.0 -58.312332909554236,-34.80460232536107,0.0 -58.31263868138194,-34.80414863571863,0.0 -58.31321267411113,-34.802836005019024,0.0 -58.3137115649879,-34.80175681311547,0.0 ",
				"Polygon Outer Boundary",
				"1587",
				"0320027",
				"Florencio Varela",
				"Gobernador Julio A. Costa",
				"0027",
				"2015/04/22",
				"Don José III",
				"Asentamiento Precario",
				"2005",
				"400",
				"19.3700000000000010000000000000000",
				"El Malambo, La Aguada, La Cautiva, Los Pinos",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.6937359550462,-34.5996878473442,0.0 -58.6935532183931,-34.5995236460592,0.0 -58.6933646802614,-34.5993819163463,0.0 -58.6932840699826,-34.599308944278,0.0 -58.6931439411183,-34.599208293861,0.0 -58.6930143581873,-34.5991302902353,0.0 -58.6926646031529,-34.5988426148509,0.0 -58.6925299250877,-34.5987420221471,0.0 -58.6924162674701,-34.5986912293282,0.0 -58.6921954715081,-34.5988691345221,0.0 -58.6920407724771,-34.5990026799781,0.0 -58.6914722167823,-34.5994607831209,0.0 -58.6914773833684,-34.5994788657087,0.0 -58.6921173736824,-34.6000265434004,0.0 -58.6922471690294,-34.6000910298711,0.0 -58.692510161518,-34.6003507358769,0.0 -58.6927090341122,-34.6005286319859,0.0 -58.6937359550462,-34.5996878473442,0.0 ",
				"Polygon Outer Boundary",
				"8",
				"1360008",
				"Ituzaingo",
				"Villa Udaondo",
				"0008",
				"2014/09/01",
				"Buen Ayre",
				"Asentamiento Precario",
				"1989",
				"113",
				"2.6400000000000001000000000000000",
				"del Cabestro, Tabare, N.Alsina, D. Nicolas Repeto",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6305912598585,-34.6829404686575,0.0 -58.6306469646799,-34.6829436181351,0.0 -58.6310840780853,-34.6825786193488,0.0 -58.6310828969964,-34.6825376854898,0.0 -58.6303772541992,-34.6819488438618,0.0 -58.6302097608987,-34.6820883814877,0.0 -58.6300590835354,-34.682213866747,0.0 -58.6298900396095,-34.6823547384921,0.0 -58.6305912598585,-34.6829404686575,0.0 ",
				"Polygon Outer Boundary",
				"135",
				"1010002",
				"Moron",
				"Moron",
				"0002",
				"2014/10/31",
				"Patagones",
				"Villa",
				"1965",
				"70",
				"0.5999999999999999800000000000000",
				"Carmen de Patagones a Cartagena, Mons. T. Solari, J. Mazza",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.51920333941961,-34.557681755532975,0.0 -58.519273076854006,-34.5576022333627,0.0 -58.51944923400878,-34.557333945853316,0.0 -58.51914346218109,-34.557201408306476,0.0 -58.51889669895172,-34.55753275177763,0.0 -58.51920333941961,-34.557681755532975,0.0 ",
				"Polygon Outer Boundary",
				"1788",
				"1100024",
				"Vicente Lopez",
				"Villa Martelli",
				"0024",
				"2015/06/23",
				"La Habanita",
				"Villa",
				"90_o_anterior",
				"17",
				"0.1400000000000000100000000000000",
				"Mejico Esq. Constituyentes",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.51987925609137,-34.55359510113918,0.0 -58.5196852684021,-34.55351236185542,0.0 -58.519583344459534,-34.55366699582963,0.0 -58.51973441680457,-34.55374531685446,0.0 -58.5197764635086,-34.553733267444905,0.0 -58.519771967730776,-34.553723226325104,0.0 -58.51987925609137,-34.55359510113918,0.0 ",
				"Polygon Outer Boundary",
				"1787",
				"1100023",
				"Vicente Lopez",
				"Villa Martelli",
				"0023",
				"2015/06/23",
				"Alsina",
				"Asentamiento Precario",
				"90_o_anterior",
				"11",
				"0.0400000000000000010000000000000",
				"Adolfo Alsina 5131",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.55063796043397,-34.529129617212554,0.0 -58.55082035064697,-34.52929755470102,0.0 -58.55103492736816,-34.52910310073604,0.0 -58.55085340579535,-34.528947215855304,0.0 -58.55063796043397,-34.529129617212554,0.0 ",
				"Polygon Outer Boundary",
				"1783",
				"1100019",
				"Vicente Lopez",
				"Villa Adelina",
				"0019",
				"2015/06/23",
				"Santa Fé",
				"Asentamiento Precario",
				"90_o_anterior",
				"13",
				"0.2500000000000000000000000000000",
				"Santa Fe 6872",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.55044034560706,-34.529137250772756,0.0 -58.55022040446783,-34.52893395758906,0.0 -58.55015603145148,-34.528956054698284,0.0 -58.54978052218939,-34.52930076884298,0.0 -58.549995098910586,-34.52949522234638,0.0 -58.55044034560706,-34.529137250772756,0.0 ",
				"Polygon Outer Boundary",
				"1783",
				"1100019",
				"Vicente Lopez",
				"Villa Adelina",
				"0019",
				"2015/06/23",
				"Santa Fé",
				"Asentamiento Precario",
				"90_o_anterior",
				"13",
				"0.2500000000000000000000000000000",
				"Santa Fe 6872",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.540601134300225,-34.530539397722194,0.0 -58.5401451587677,-34.530906201904315,0.0 -58.54043483734131,-34.531113909580085,0.0 -58.54055821895599,-34.53099016889947,0.0 -58.5406655073166,-34.531056458572664,0.0 -58.540875588259944,-34.53085196483569,0.0 -58.54071915149688,-34.53075594496485,0.0 -58.540778160095215,-34.530667558403216,0.0 -58.540601134300225,-34.530539397722194,0.0 ",
				"Polygon Outer Boundary",
				"1784",
				"1100020",
				"Vicente Lopez",
				"Carapachay",
				"0020",
				"2015/06/23",
				"Silveyra",
				"Villa",
				"90_o_anterior",
				"17",
				"0.2200000000000000000000000000000",
				"Ingeniero Luis SIlveyra 3350",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.33626818843186,-34.760133280364606,0.0 -58.33784377668053,-34.758061909486486,0.0 -58.33640456199646,-34.757392008209436,0.0 -58.33482897374778,-34.75940830646851,0.0 -58.33626818843186,-34.760133280364606,0.0 ",
				"Polygon Outer Boundary",
				"1970",
				"0030056",
				"Almirante Brown",
				"San José",
				"0056",
				"2015/07/23",
				"8 de Noviembre",
				"Asentamiento Precario",
				"1985",
				"247",
				"4.1100000000000003000000000000000",
				"Virrey Vertíz, Belgrano, 30 de Septiembre y El Chajá",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.77439890056848,-34.573731628680555,0.0 -58.776651956140995,-34.57207080366817,0.0 -58.77715621143579,-34.57257435518188,0.0 -58.77923760563136,-34.571037188374596,0.0 -58.78053545951843,-34.57016258078215,0.0 -58.781576156616204,-34.57090467266407,0.0 -58.78206968307495,-34.570657309439355,0.0 -58.78141522407531,-34.56827198343854,0.0 -58.780235052108765,-34.567485694316964,0.0 -58.77900123596192,-34.56844867660005,0.0 -58.77754244953393,-34.56956183488386,0.0 -58.77717766910791,-34.56987987737068,0.0 -58.77332601696253,-34.572715702427,0.0 -58.77439890056848,-34.573731628680555,0.0 ",
				"Polygon Outer Boundary",
				"2326",
				"0740078",
				"Moreno",
				"Trujui",
				"0078",
				"2015/10/09",
				"Haras Trujui III",
				"Asentamiento Precario",
				"2013",
				"280",
				"18.9400000000000010000000000000000",
				"Baigorria, Los Olmos",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.34599614143371,-34.7700486976443,0.0 -58.34336757659912,-34.77296580697312,0.0 -58.34357142448425,-34.77307596769156,0.0 -58.34628355689347,-34.770242587263915,0.0 -58.34716868586838,-34.769189408620086,0.0 -58.34643065929413,-34.768841283853554,0.0 -58.346055150032036,-34.76927754123945,0.0 -58.34647893905639,-34.76950668560932,0.0 -58.34599614143371,-34.7700486976443,0.0 ",
				"Polygon Outer Boundary",
				"1969",
				"0030055",
				"Almirante Brown",
				"San José",
				"0055",
				"2015/07/23",
				"La Unión",
				"Asentamiento Precario",
				"1985",
				"110",
				"1.8700000000000001000000000000000",
				"Av. Amenedo, Pcia de Misiones, Canale y Tierra del Fuego",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.52920711040497,-34.53680578210621,0.0 -58.529309034347534,-34.536682049884526,0.0 -58.52918028831481,-34.53661134567526,0.0 -58.52909445762634,-34.536730658993534,0.0 -58.52920711040497,-34.53680578210621,0.0 ",
				"Polygon Outer Boundary",
				"1786",
				"1100022",
				"Vicente Lopez",
				"Munro",
				"0022",
				"2015/06/23",
				"Villa Colombo",
				"Asentamiento Precario",
				"90_o_anterior",
				"10",
				"0.0400000000000000010000000000000",
				"Luis María Drago 5347",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.52916955947876,-34.536929514144006,0.0 -58.529008626937866,-34.53713720679403,0.0 -58.52905690670013,-34.53716813969758,0.0 -58.52921783924102,-34.53695602812818,0.0 -58.52916955947876,-34.536929514144006,0.0 ",
				"Polygon Outer Boundary",
				"1786",
				"1100022",
				"Vicente Lopez",
				"Munro",
				"0022",
				"2015/06/23",
				"Villa Colombo",
				"Asentamiento Precario",
				"90_o_anterior",
				"10",
				"0.0400000000000000010000000000000",
				"Luis María Drago 5347",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.72104406356811,-34.70660032072628,0.0 -58.722283244132996,-34.705537510528686,0.0 -58.72159140184522,-34.705264088269665,0.0 -58.72050762176514,-34.70615050230919,0.0 -58.72104406356811,-34.70660032072628,0.0 ",
				"Polygon Outer Boundary",
				"2325",
				"0720076",
				"Merlo",
				"Pontevedra",
				"0076",
				"2015/10/09",
				"Lafayette & Bebedero",
				"Asentamiento Precario",
				"90_o_anterior",
				"35",
				"1.0400000000000000000000000000000",
				"Lafayette, Bebedero, José María Terrero",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.70693044736981,-34.7558935251507,0.0 -58.70561616495252,-34.756986539006625,0.0 -58.70625453069806,-34.757511004228,0.0 -58.70760636404157,-34.75643562657315,0.0 -58.70693044736981,-34.7558935251507,0.0 ",
				"Polygon Outer Boundary",
				"2328",
				"0720078",
				"Merlo",
				"Pontevedra",
				"0078",
				"2015/10/09",
				"Peña & Valparaiso",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"2.0600000000000001000000000000000",
				"Peña y Valparaiso",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.704194594174616,-34.7558935251507,0.0 -58.703572321683176,-34.756360702198265,0.0 -58.704183865338564,-34.756902800553625,0.0 -58.70476858690381,-34.75640477536821,0.0 -58.704194594174616,-34.7558935251507,0.0 ",
				"Polygon Outer Boundary",
				"2328",
				"0720078",
				"Merlo",
				"Pontevedra",
				"0078",
				"2015/10/09",
				"Peña & Valparaiso",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"2.0600000000000001000000000000000",
				"Peña y Valparaiso",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.51484388113022,-34.51625266483266,0.0 -58.51466460744632,-34.516539367809926,0.0 -58.514645831983216,-34.5165349477297,0.0 -58.51431055585635,-34.51638024477419,0.0 -58.51418985645068,-34.516565888286344,0.0 -58.51481212894213,-34.51683772268282,0.0 -58.515101807515755,-34.51639129499482,0.0 -58.51507766763461,-34.516336043876976,0.0 -58.51484388113022,-34.51625266483266,0.0 ",
				"Polygon Outer Boundary",
				"1790",
				"1100026",
				"Vicente Lopez",
				"Olivos",
				"0026",
				"2015/06/23",
				"La Vecindad",
				"Villa",
				"90_o_anterior",
				"23",
				"0.2500000000000000000000000000000",
				"Castro y Bellocq",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.36743858893897,-35.00126210975435,0.0 -58.365277597113156,-35.003326162252115,0.0 -58.36449439208081,-35.00401163825768,0.0 -58.363742504916445,-35.004707094902066,0.0 -58.36307731708076,-35.005374983398205,0.0 -58.362722396850586,-35.0051828461473,0.0 -58.3599328994751,-35.00801253040563,0.0 -58.35763692855834,-35.01020942273605,0.0 -58.357079029083245,-35.01080696724292,0.0 -58.358302116394036,-35.01179114867933,0.0 -58.35906386375427,-35.012344745533134,0.0 -58.36015820503234,-35.01277531827334,0.0 -58.360823392868035,-35.01281046696838,0.0 -58.36151003837585,-35.01220414986175,0.0 -58.360823392868035,-35.01183508507445,0.0 -58.361960649490356,-35.01030608464341,0.0 -58.36258292198181,-35.00949763608245,0.0 -58.36315691471099,-35.008706754758514,0.0 -58.36413860321045,-35.009141740432966,0.0 -58.36469113826751,-35.00838161244067,0.0 -58.365297317504876,-35.00863645382632,0.0 -58.36588203907012,-35.008096013392624,0.0 -58.365973234176636,-35.007933441181464,0.0 -58.365554809570305,-35.0076917791894,0.0 -58.365265130996704,-35.007586326460036,0.0 -58.36641311645508,-35.00605724660833,0.0 -58.36554408073425,-35.00558709274816,0.0 -58.366076026759394,-35.00480376331135,0.0 -58.36699870666052,-35.005273921673236,0.0 -58.36796966632391,-35.005752865263716,0.0 -58.36961117824103,-35.00341524247011,0.0 -58.368699227175966,-35.00294507342691,0.0 -58.369224940142885,-35.002198070325235,0.0 -58.36743858893897,-35.00126210975435,0.0 ",
				"Polygon Outer Boundary",
				"2003",
				"1000030",
				"San Vicente",
				"Alejandro Korn",
				"0030",
				"2015/07/28",
				"San Jose I",
				"Otros",
				"90_o_anterior",
				"450",
				"46.0600000000000020000000000000000",
				"San Juan, 812, Ruta Provincial 210 y vías FFCC",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.62631916999817,-34.7291366192847,0.0 -58.62300395965576,-34.73182592570299,0.0 -58.62773537635803,-34.735952297859136,0.0 -58.63108277320861,-34.73325430861151,0.0 -58.62631916999817,-34.7291366192847,0.0 ",
				"Polygon Outer Boundary",
				"1101",
				"0700029",
				"La Matanza",
				"Rafael Castillo",
				"0029",
				"2014/10/01",
				"18 de Febrero",
				"Asentamiento Precario",
				"90_o_anterior",
				"1100",
				"27.0100000000000020000000000000000",
				"Da Vinci, Alagón, Gamboa y Río Cuarto",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.0077499608994,-34.9474221782772,0.0 -58.007658584684,-34.9474306449831,0.0 -58.0073190618575,-34.9476977248797,0.0 -58.0073184724551,-34.9477401618371,0.0 -58.0081416344792,-34.9485098664738,0.0 -58.0079140897701,-34.9487041278061,0.0 -58.0073434633814,-34.9486746681014,0.0 -58.0067661442235,-34.9481396115767,0.0 -58.0065265768785,-34.9482693528685,0.0 -58.0055818959432,-34.9473843507451,0.0 -58.0049541517742,-34.9478191473319,0.0 -58.0045390193294,-34.948131060053,0.0 -58.0054751458922,-34.9490006601159,0.0 -58.0065331371592,-34.9498881738338,0.0 -58.007588990142,-34.94911677146,0.0 -58.0086453172639,-34.9483385181017,0.0 -58.0085681188587,-34.9482268547451,0.0 -58.0085700340512,-34.9481884048078,0.0 -58.0077499608994,-34.9474221782772,0.0 ",
				"Polygon Outer Boundary",
				"352",
				"0550079",
				"La Plata",
				"San Carlos",
				"0079",
				"2014/10/10",
				"40 & 150",
				"Asentamiento Precario",
				"decada_1990",
				"118",
				"4.5000000000000000000000000000000",
				"150, 152, 38, 40",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.081713082268834,-34.57097976492598,0.0 -59.080667020753026,-34.57046736932089,0.0 -59.07984090037644,-34.571629089303045,0.0 -59.081182004883885,-34.57218564901871,0.0 -59.08156824298203,-34.571624672147536,0.0 -59.08133757300674,-34.571527494667116,0.0 -59.081713082268834,-34.57097976492598,0.0 ",
				"Polygon Outer Boundary",
				"2027",
				"0640010",
				"Lujan",
				"Lujan",
				"0010",
				"2015/08/04",
				"Lanusse",
				"Otros",
				"decada_2000",
				"16",
				"1.8100000000000001000000000000000",
				"Dr. Luppi, San Vicente, Pasteur",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.32695669028907,-34.82130781719604,0.0 -58.32914113998414,-34.818656657583674,0.0 -58.32796096801758,-34.81801367246316,0.0 -58.3288300037384,-34.816965507878315,0.0 -58.32733869552612,-34.81616396125654,0.0 -58.32433885429054,-34.819869948028376,0.0 -58.32695669028907,-34.82130781719604,0.0 ",
				"Polygon Outer Boundary",
				"2005",
				"0030066",
				"Almirante Brown",
				"Don Orione",
				"0066",
				"2015/07/29",
				"Parque Gauchito Gil",
				"Asentamiento Precario",
				"2010",
				"141",
				"12.5700000000000000000000000000000",
				"Humahuaca, 25 de Mayo, Beata Maria B. Arias y Campo",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.3440879592672,-34.76752809113812,0.0 -58.346180082298815,-34.7649302876266,0.0 -58.34525740239769,-34.764454345297345,0.0 -58.34317600820214,-34.767071994148765,0.0 -58.3440879592672,-34.76752809113812,0.0 ",
				"Polygon Outer Boundary",
				"1971",
				"0030057",
				"Almirante Brown",
				"San José",
				"0057",
				"2015/07/23",
				"Cooperativa Frías",
				"Asentamiento Precario",
				"1985",
				"80",
				"3.4300000000000002000000000000000",
				"30 de Septiembre, La Torcaza, Av.Amenedo y Benteveo",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.744901008182,-35.0614915381985,0.0 -58.7441708396915,-35.0620650480025,0.0 -58.7439960209868,-35.0621853638491,0.0 -58.7432758389973,-35.0627644694144,0.0 -58.7429763507714,-35.0630012015943,0.0 -58.7421372746888,-35.0636408969643,0.0 -58.7447673664078,-35.0659105801272,0.0 -58.7450007699457,-35.0660168253684,0.0 -58.7455342408979,-35.0664793035492,0.0 -58.7456633857817,-35.0666005121782,0.0 -58.746770978863,-35.0675567951299,0.0 -58.7485171346283,-35.0690106874492,0.0 -58.749425473871,-35.0682793696864,0.0 -58.7503342866694,-35.0675662559973,0.0 -58.751297349445,-35.0668170109209,0.0 -58.7504901601895,-35.0661429968345,0.0 -58.7503244343386,-35.066033583886,0.0 -58.7495575813881,-35.0653896320773,0.0 -58.7494011550608,-35.065180990489,0.0 -58.7484428794354,-35.0643960771696,0.0 -58.7482522695091,-35.0642583741937,0.0 -58.7477811363307,-35.0638483762172,0.0 -58.7475483685446,-35.0636791420056,0.0 -58.7466919868919,-35.0629643969572,0.0 -58.746501881506,-35.0628156104872,0.0 -58.7461099728926,-35.0624731211076,0.0 -58.745946024812,-35.0623200075743,0.0 -58.7455442720844,-35.0619764231717,0.0 -58.7453660980545,-35.061843350845,0.0 -58.7449611318365,-35.0614880143907,0.0 -58.744901008182,-35.0614915381985,0.0 ",
				"Polygon Outer Boundary",
				"484",
				"0150002",
				"Cañuelas",
				"Cañuelas",
				"0002",
				"2014/09/09",
				"La Union II",
				"Asentamiento Precario",
				"1987",
				"80",
				"29.3999999999999990000000000000000",
				"Santa Cruz, Tte. Beltran, 1 de Mayo, Mosconi",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.5674755223433,-34.6932375303648,0.0 -58.5668363120555,-34.6926774469774,0.0 -58.5657350260703,-34.6934989715356,0.0 -58.5663776579168,-34.6940704569988,0.0 -58.5674755223433,-34.6932375303648,0.0 ",
				"Polygon Outer Boundary",
				"1109",
				"0700021",
				"La Matanza",
				"San Justo",
				"0021",
				"2014/10/01",
				"Constructora",
				"Villa",
				"90_o_anterior",
				"200",
				"1.1699999999999999000000000000000",
				"Gral. Madariaga, Bermejo, Condarco, Balbastro",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.58705699443818,-34.505038128397096,0.0 -58.58757466077804,-34.50458500642075,0.0 -58.58765244483948,-34.50444796416712,0.0 -58.588194251060486,-34.50399041823683,0.0 -58.58784019947051,-34.503692017363946,0.0 -58.587239384651184,-34.50423134853252,0.0 -58.586810231208794,-34.50387326839188,0.0 -58.586477637290955,-34.50415619603796,0.0 -58.58679950237274,-34.504417019110946,0.0 -58.586531281471245,-34.50462037212703,0.0 -58.58705699443818,-34.505038128397096,0.0 ",
				"Polygon Outer Boundary",
				"822",
				"0470045",
				"General San Martin",
				"General San Martin",
				"0045",
				"2014/10/01",
				"Magnolia",
				"Asentamiento Precario",
				"90_o_anterior",
				"60",
				"1.0400000000000000000000000000000",
				"Calle 238, M. Estrada,  Andrés Lamas",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-62.30001831427216,-38.73245188806068,0.0 -62.29948187246919,-38.732878721550705,0.0 -62.30047965422272,-38.733698904235176,0.0 -62.300050500780344,-38.73411736116036,0.0 -62.299331668764346,-38.73446049400976,0.0 -62.29934239760041,-38.734661351498204,0.0 -62.29976082220673,-38.734728303868856,0.0 -62.300554756075144,-38.73473667291076,0.0 -62.30141306295992,-38.73468645864456,0.0 -62.30144524946809,-38.734728303868856,0.0 -62.30130577459931,-38.73484547036646,0.0 -62.300511840730906,-38.73544803788968,0.0 -62.29949260130524,-38.736058969216565,0.0 -62.29891324415802,-38.73652762532268,0.0 -62.29890251532197,-38.73667826413229,0.0 -62.29929948225618,-38.737079966071306,0.0 -62.30270052328705,-38.73456092282459,0.0 -62.30001831427216,-38.73245188806068,0.0 ",
				"Polygon Outer Boundary",
				"1502",
				"0070013",
				"Bahia Blanca",
				"Bahia Blanca",
				"0013",
				"2015/04/10",
				"Caracol II",
				"Villa",
				"decada_1990",
				"120",
				"5.6500000000000004000000000000000",
				"Carhué y Belisario Roldán",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.79449434578418,-34.68388143393638,0.0 -58.785782530903816,-34.68972163457352,0.0 -58.78859348595142,-34.6925974732117,0.0 -58.789902403950684,-34.6939912486275,0.0 -58.790996745228775,-34.69594955164244,0.0 -58.791640475392335,-34.69716685178306,0.0 -58.79442997276783,-34.700007149142934,0.0 -58.797047808766365,-34.69905451368914,0.0 -58.79779882729053,-34.69958375696191,0.0 -58.798850253224366,-34.69887809851267,0.0 -58.79470892250538,-34.694908657610874,0.0 -58.79329271614552,-34.693514897644455,0.0 -58.792906478047364,-34.692932687164195,0.0 -58.792820647358894,-34.69136246272465,0.0 -58.79309959709644,-34.689580486546596,0.0 -58.795781806111336,-34.69203289927557,0.0 -58.79794903099537,-34.690621447587276,0.0 -58.79554577171802,-34.68802784236584,0.0 -58.79749841988086,-34.686828051916706,0.0 -58.79919357597827,-34.685628244079204,0.0 -58.796318247914314,-34.68268158339627,0.0 -58.79449434578418,-34.68388143393638,0.0 ",
				"Polygon Outer Boundary",
				"2329",
				"0720079",
				"Merlo",
				"Mariano Acosta",
				"0079",
				"2015/10/09",
				"Ferrari",
				"Otros",
				"90_o_anterior",
				"300",
				"101.0800000000000000000000000000000",
				"Perelli y Martín Coronado",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7733256816864,-34.57281287851863,0.0 -58.77150177955627,-34.57417333187516,0.0 -58.77617418766021,-34.579248333183536,0.0 -58.778486251831055,-34.57754786682552,0.0 -58.778577446937554,-34.57746836365106,0.0 -58.77439320087433,-34.573780216146844,0.0 -58.7733256816864,-34.57281287851863,0.0 ",
				"Polygon Outer Boundary",
				"1711",
				"0740055",
				"Moreno",
				"Trujui",
				"0055",
				"2015/05/15",
				"Haras Trujui II",
				"Asentamiento Precario",
				"2012",
				"229",
				"18.3999999999999990000000000000000",
				"Barker, Prirovano Y Jacobo Watt",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.48125457763672,-34.500292382381105,0.0 -58.481200933456414,-34.500119965469494,0.0 -58.480390906333916,-34.50008901880659,0.0 -58.48047137260436,-34.500341012727596,0.0 -58.480825424194336,-34.500367538359185,0.0 -58.48082005977631,-34.500265856725605,0.0 -58.48125457763672,-34.500292382381105,0.0 ",
				"Polygon Outer Boundary",
				"1791",
				"1100027",
				"Vicente Lopez",
				"La Lucila",
				"0027",
				"2015/06/23",
				"Enamour",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"0.1700000000000000100000000000000",
				"Brown, Espora y Roma",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.519761238894716,-34.55683351513087,0.0 -58.51945010264899,-34.55670097678674,0.0 -58.51918188174749,-34.557103009112744,0.0 -58.51948228915716,-34.557257636413084,0.0 -58.519535933337465,-34.55722671097601,0.0 -58.519761238894716,-34.55683351513087,0.0 ",
				"Polygon Outer Boundary",
				"1789",
				"1100025",
				"Vicente Lopez",
				"Villa Martelli",
				"0025",
				"2015/06/23",
				"Méjico",
				"Villa",
				"90_o_anterior",
				"19",
				"0.1900000000000000000000000000000",
				"Mejico 5241; y esq. Constituyentes",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.518885970115655,-34.556936332579326,0.0 -58.51895034313201,-34.55696725812436,0.0 -58.519036173820496,-34.55679495851281,0.0 -58.518971800804145,-34.556772868793225,0.0 -58.518885970115655,-34.556936332579326,0.0 ",
				"Polygon Outer Boundary",
				"1789",
				"1100025",
				"Vicente Lopez",
				"Villa Martelli",
				"0025",
				"2015/06/23",
				"Méjico",
				"Villa",
				"90_o_anterior",
				"19",
				"0.1900000000000000000000000000000",
				"Mejico 5241; y esq. Constituyentes",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.50657349918037,-34.514144252689775,0.0 -58.50616043899208,-34.513954183564685,0.0 -58.506050468422465,-34.51412436175512,0.0 -58.50646734237671,-34.514307800194544,0.0 -58.50657349918037,-34.514144252689775,0.0 ",
				"Polygon Outer Boundary",
				"667",
				"1100012",
				"Vicente Lopez",
				"Olivos",
				"0012",
				"2014/10/01",
				"La Colonia",
				"Villa",
				"90_o_anterior",
				"11",
				"0.0899999999999999970000000000000",
				"Goyena, Borges, Pelliza",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.3630544485605,-34.8305318717905,0.0 -58.3604112659818,-34.8292090937535,0.0 -58.3594277849055,-34.828730863007,0.0 -58.358741998672485,-34.828371287715854,0.0 -58.35798025131225,-34.829401693504266,0.0 -58.357926607131965,-34.82948976177698,0.0 -58.35845232009888,-34.82978038640873,0.0 -58.3621329987211,-34.8315986851697,0.0 -58.3627548707878,-34.8319461825209,0.0 -58.3630544485605,-34.8305318717905,0.0 ",
				"Polygon Outer Boundary",
				"1233",
				"0030046",
				"Almirante Brown",
				"Almirante Brown",
				"0046",
				"2014/10/01",
				"Gutierrez & República Argentina",
				"Otros",
				"90_o_anterior",
				"104",
				"7.1699999999999999000000000000000",
				"Gutierrez, República Argentina, Araujo y Leguizamón",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.0566982286109,-34.944121460285,0.0 -58.0560157895283,-34.9434601327938,0.0 -58.0534057065251,-34.9452698558639,0.0 -58.0525377035001,-34.944454946956,0.0 -58.051697313356,-34.9436616486354,0.0 -58.0506981639265,-34.9443695570586,0.0 -58.0506054931831,-34.9444720308641,0.0 -58.0496205246785,-34.943538820917,0.0 -58.0489721462825,-34.943974696055,0.0 -58.050641813487,-34.9456753807263,0.0 -58.05083513259887,-34.94587758249315,0.0 -58.05056691169739,-34.946106235457464,0.0 -58.05150032043456,-34.94694169279022,0.0 -58.0524924310917,-34.9462589881514,0.0 -58.0526965000159,-34.9463295793827,0.0 -58.0529320580117,-34.9465509838344,0.0 -58.0534645293286,-34.9470515410113,0.0 -58.0535223331922,-34.9471058752288,0.0 -58.0544667387467,-34.9464362695957,0.0 -58.0544703771233,-34.9463656729197,0.0 -58.0540638081068,-34.9459826568249,0.0 -58.0566982286109,-34.944121460285,0.0 ",
				"Polygon Outer Boundary",
				"371",
				"0550097",
				"La Plata",
				"Melchor Romero",
				"0097",
				"2014/10/15",
				"Altos del Sol",
				"Asentamiento Precario",
				"1990",
				"268",
				"12.0299999999999990000000000000000",
				"167, 170, 516bis, vias",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6826678349217,-34.4611883248993,0.0 -58.6826586692429,-34.4611136820366,0.0 -58.6815036772223,-34.4605003704106,0.0 -58.6814243419805,-34.4605213278971,0.0 -58.6792954973316,-34.4632671015197,0.0 -58.6805205263758,-34.4639331995643,0.0 -58.6820179924164,-34.4620156334601,0.0 -58.6826678349217,-34.4611883248993,0.0 ",
				"Polygon Outer Boundary",
				"695",
				"0570021",
				"Tigre",
				"Ricardo Rojas",
				"0021",
				"2014/10/01",
				"Km 38",
				"Villa",
				"90_o_anterior",
				"240",
				"5.0000000000000000000000000000000",
				"C. Pellegrini, Australia, R. Elizalde, J.Bibiloni",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.465205976172,-34.793168825300256,0.0 -58.46556002776197,-34.79264018129266,0.0 -58.46308166663221,-34.79134498915091,0.0 -58.461858579321415,-34.792939746646404,0.0 -58.46436912695935,-34.794323019605834,0.0 -58.465205976172,-34.793168825300256,0.0 ",
				"Polygon Outer Boundary",
				"1973",
				"0300046",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0046",
				"2015/07/24",
				"Costa Esperanza",
				"Otros",
				"90_o_anterior",
				"60",
				"5.8200000000000003000000000000000",
				"Colonia Montegrande, Tarulli, Gatemala y Lagos Garcia",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-62.26800346747041,-38.74783302187324,0.0 -62.26909780874848,-38.74704647190685,0.0 -62.268582824617624,-38.74668666424642,0.0 -62.2681644000113,-38.746787075868944,0.0 -62.26799273863434,-38.74679544349778,0.0 -62.267606500536196,-38.74702973670704,0.0 -62.267209533602006,-38.747121780257466,0.0 -62.26704860106111,-38.74717198578041,0.0 -62.26650143042206,-38.74718872094688,0.0 -62.265825513750315,-38.7473477048327,0.0 -62.26518178358674,-38.746787075868944,0.0 -62.26457023993134,-38.74628501634415,0.0 -62.26296091452242,-38.747498320819005,0.0 -62.263551000505686,-38.74795853436405,0.0 -62.26419473066926,-38.747515055909,0.0 -62.265256885439165,-38.74832670306416,0.0 -62.266286853700876,-38.749129973637835,0.0 -62.267338279634714,-38.7483016007131,0.0 -62.2667589224875,-38.747916696891636,0.0 -62.26719880476594,-38.74784975688477,0.0 -62.26738119497895,-38.74784975688477,0.0 -62.267606500536196,-38.74790832939421,0.0 -62.26783180609345,-38.747950166871526,0.0 -62.26800346747041,-38.74783302187324,0.0 ",
				"Polygon Outer Boundary",
				"1504",
				"0070015",
				"Bahia Blanca",
				"Bahia Blanca",
				"0015",
				"2015/04/10",
				"Villa Parodi",
				"Otros",
				"decada_2000",
				"140",
				"6.5099999999999998000000000000000",
				"Estados Unidos, Coronel Granada, Méjico y Chubut",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.86525297164917,-33.66546093969605,0.0 -59.864609241485596,-33.665925271728035,0.0 -59.86588597297668,-33.667005726947096,0.0 -59.86648678779602,-33.666550330120884,0.0 -59.86525297164917,-33.66546093969605,0.0 ",
				"Polygon Outer Boundary",
				"2165",
				"0990033",
				"San Pedro",
				"Gobernador Castro",
				"0033",
				"2015/09/08",
				"El Progreso",
				"Asentamiento Precario",
				"90_o_anterior",
				"50",
				"1.2900000000000000000000000000000",
				"s/n entre Bolivar y Sarmiento",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.49170982837677,-34.69109781522284,0.0 -58.49036335945129,-34.689933356162626,0.0 -58.49032044410705,-34.68978338675961,0.0 -58.491082191467285,-34.689209971830834,0.0 -58.48962843418121,-34.68782052687655,0.0 -58.48834633827209,-34.68881298993791,0.0 -58.48946750164032,-34.69038326274142,0.0 -58.4894420056719,-34.6905828100799,0.0 -58.4898759508643,-34.6912811222697,0.0 -58.490384817123406,-34.69205495301722,0.0 -58.49046528339385,-34.69205936376485,0.0 -58.49170982837677,-34.69109781522284,0.0 ",
				"Polygon Outer Boundary",
				"1128",
				"0700002",
				"La Matanza",
				"Ciudad Madero",
				"0002",
				"2014/10/01",
				"2 de Abril",
				"Villa",
				"90_o_anterior",
				"300",
				"6.2800000000000002000000000000000",
				"Blanco Encalada, Riccheri, Av. Gral. Paz",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.71342884542627,-34.590441632955475,0.0 -58.710628619214724,-34.59250836811196,0.0 -58.71029376983643,-34.59263442599069,0.0 -58.711044788360596,-34.593402813246435,0.0 -58.71144175529481,-34.593385149251404,0.0 -58.71172296049281,-34.593603540260155,0.0 -58.71299743652344,-34.594754097732775,0.0 -58.7141990661621,-34.59598171621715,0.0 -58.71467113494873,-34.594771761436725,0.0 -58.71474623680115,-34.593455805209004,0.0 -58.7154757976532,-34.59089448835252,0.0 -58.714284896850586,-34.589825777627496,0.0 -58.71370779516382,-34.5902119925423,0.0 -58.71342884542627,-34.590441632955475,0.0 ",
				"Polygon Outer Boundary",
				"2112",
				"1310022",
				"San Miguel",
				"San Miguel",
				"0022",
				"2015/08/13",
				"Mayor Irusta & Gaboto",
				"Otros",
				"90_o_anterior",
				"250",
				"15.5900000000000000000000000000000",
				"Mayor Irusta y Gaboto",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.649657011032104,-33.77227153352202,0.0 -59.6489703655243,-33.77286906313434,0.0 -59.64919030666352,-33.77310539832342,0.0 -59.649925231933594,-33.77245881937129,0.0 -59.649657011032104,-33.77227153352202,0.0 ",
				"Polygon Outer Boundary",
				"2163",
				"0990031",
				"San Pedro",
				"Río Tala",
				"0031",
				"2015/09/08",
				"Piojillo",
				"Asentamiento Precario",
				"90_o_anterior",
				"30",
				"0.3100000000000000000000000000000",
				"Acceso a la Campiña de San Pedro",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.683943916112185,-34.45714609501223,0.0 -58.68320362642407,-34.45690724031948,0.0 -58.6831017024815,-34.45740706509913,0.0 -58.6835147626698,-34.45770341997151,0.0 -58.683943916112185,-34.45714609501223,0.0 ",
				"Polygon Outer Boundary",
				"689",
				"0570027",
				"Tigre",
				"Ricardo Rojas",
				"0027",
				"2014/10/01",
				"Dorrego & Elizalde",
				"Villa",
				"90_o_anterior",
				"40",
				"0.3800000000000000000000000000000",
				"J. E. Uriburu, Dorrego, J. A. Bibiloni, R. de Elizalde",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-60.57611346244812,-33.877581860252974,0.0 -60.575834512710564,-33.87697170073349,0.0 -60.57541608810424,-33.877118673863315,0.0 -60.57571649551391,-33.877746647112225,0.0 -60.57611346244812,-33.877581860252974,0.0 ",
				"Polygon Outer Boundary",
				"2334",
				"0820024",
				"Pergamino",
				"Pergamino",
				"0024",
				"2015/10/09",
				"Ricardo John & Conscripto Silva",
				"Asentamiento Precario",
				"2012",
				"11",
				"0.3100000000000000000000000000000",
				"Ricardo John, Conscripto Silva y de la Fuente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.241530902683735,-38.74655278186337,0.0 -62.239513881504536,-38.74822629360697,0.0 -62.24423456937075,-38.75192461541847,0.0 -62.244341857731335,-38.75190788136214,0.0 -62.246530540287495,-38.75038506581548,0.0 -62.241530902683735,-38.74655278186337,0.0 ",
				"Polygon Outer Boundary",
				"1509",
				"0070020",
				"Bahia Blanca",
				"Bahia Blanca",
				"0020",
				"2015/04/10",
				"Evita",
				"Asentamiento Precario",
				"2010",
				"210",
				"15.4499999999999990000000000000000",
				"Juncal, Chile Thompson, Santa María",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.24720251746476,-38.74061149837196,0.0 -62.246778728440404,-38.740816522727236,0.0 -62.24644613452255,-38.74101736234127,0.0 -62.2459311503917,-38.74118891239764,0.0 -62.24544298835098,-38.74143577638969,0.0 -62.245603920891874,-38.74153619539651,0.0 -62.246022345498204,-38.7417077442065,0.0 -62.2463817615062,-38.74182908335985,0.0 -62.246966483071446,-38.74152782715134,0.0 -62.24734199233353,-38.74122656967193,0.0 -62.2474439162761,-38.74095878417886,0.0 -62.24742782302201,-38.74071191853789,0.0 -62.24720251746476,-38.74061149837196,0.0 ",
				"Polygon Outer Boundary",
				"1507",
				"0070018",
				"Bahia Blanca",
				"Bahia Blanca",
				"0018",
				"2015/04/10",
				"Rosario Sur",
				"Villa",
				"decada_1990",
				"45",
				"1.1399999999999999000000000000000",
				"Darregeira y 1010",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.246138099580996,-38.74191694951461,0.0 -62.24421763792634,-38.74186674029656,0.0 -62.243563178926706,-38.742159626904176,0.0 -62.2428765334189,-38.742896022210395,0.0 -62.242189887911074,-38.74349852181244,0.0 -62.2413101233542,-38.74431021462733,0.0 -62.24105263128877,-38.74462819486419,0.0 -62.24117064848542,-38.74483739161617,0.0 -62.24047327414154,-38.745515184882635,0.0 -62.24162125959992,-38.746444002242306,0.0 -62.24404145032167,-38.7484438472524,0.0 -62.24833130836486,-38.745230679850636,0.0 -62.25047707557678,-38.7435236258522,0.0 -62.24926471710206,-38.742511089247614,0.0 -62.2503912448883,-38.74157385248766,0.0 -62.24997282028198,-38.74123075381229,0.0 -62.2464232519269,-38.74379140172718,0.0 -62.24515724927187,-38.74282070940269,0.0 -62.246138099580996,-38.74191694951461,0.0 ",
				"Polygon Outer Boundary",
				"1508",
				"0070019",
				"Bahia Blanca",
				"Bahia Blanca",
				"0019",
				"2015/04/10",
				"Progreso",
				"Otros",
				"90_o_anterior",
				"380",
				"33.2100000000000010000000000000000",
				"Esmeralda, Santa Fe, Piccioli y Arroyo",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.25189495831727,-38.742636611093914,0.0 -62.24833298474551,-38.745297622313096,0.0 -62.24502850323915,-38.74782465436601,0.0 -62.246702201664455,-38.7491801777486,0.0 -62.24891234189271,-38.74747321817669,0.0 -62.24846173077822,-38.74687075211318,0.0 -62.252839095890515,-38.743506889826676,0.0 -62.25193787366151,-38.7434232096402,0.0 -62.25189495831727,-38.742636611093914,0.0 ",
				"Polygon Outer Boundary",
				"1510",
				"0070021",
				"Bahia Blanca",
				"Bahia Blanca",
				"0021",
				"2015/04/10",
				"El Porvenir",
				"Asentamiento Precario",
				"2004",
				"58",
				"12.6099999999999990000000000000000",
				"Santa Fe, Brunel, Esmeralda y Ecuador",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.245582463219755,-38.73725152558593,0.0 -62.24467587657272,-38.73793357519016,0.0 -62.24382293410599,-38.73861980257431,0.0 -62.24379611201584,-38.738795542673145,0.0 -62.24406433291733,-38.738816464084664,0.0 -62.24497628398239,-38.73819718770914,0.0 -62.24572730250656,-38.73763648689941,0.0 -62.24589896388352,-38.737402162868754,0.0 -62.245582463219755,-38.73725152558593,0.0 ",
				"Polygon Outer Boundary",
				"1505",
				"0070016",
				"Bahia Blanca",
				"Bahia Blanca",
				"0016",
				"2015/04/10",
				"Ferroviario",
				"Otros",
				"90_o_anterior",
				"20",
				"0.8299999999999999600000000000000",
				"Brown y Venezuela",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.7964798121671,-34.5614308413965,0.0 -58.7947571014838,-34.5632132625925,0.0 -58.7939242710882,-34.564032409975,0.0 -58.794032551349,-34.56410497133,0.0 -58.7924525795026,-34.5657414710513,0.0 -58.792457696195,-34.5657794695993,0.0 -58.7930891312162,-34.5661942183648,0.0 -58.7931350669168,-34.5661898952702,0.0 -58.7946704161091,-34.5646373026118,0.0 -58.7947667778002,-34.5645969893411,0.0 -58.7961419043016,-34.565523545495,0.0 -58.7985882660179,-34.5630151050864,0.0 -58.7985882660183,-34.5630151050866,0.0 -58.8000053508137,-34.5615648822331,0.0 -58.7999966176949,-34.5615281103182,0.0 -58.7978089316283,-34.5600706902358,0.0 -58.7964798121671,-34.5614308413965,0.0 ",
				"Polygon Outer Boundary",
				"77",
				"0740033",
				"Moreno",
				"Cuartel V",
				"0033",
				"2014/09/11",
				"Prozorovich",
				"Asentamiento Precario",
				"2011",
				"330",
				"16.7600000000000020000000000000000",
				"Oyuela Calixto, Recine Juan, Ayende Faustino, Lynch Benito, Portugal, S/N",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-61.911207558587186,-35.80620240116607,0.0 -61.91020977683365,-35.80536709200746,0.0 -61.909732343628995,-35.805754293699295,0.0 -61.908852579072125,-35.805023394542324,0.0 -61.90846097655594,-35.80536274141593,0.0 -61.910322429612286,-35.80687238237145,0.0 -61.911207558587186,-35.80620240116607,0.0 ",
				"Polygon Outer Boundary",
				"1511",
				"0800001",
				"Pehuajo",
				"Pehuajó",
				"0001",
				"2015/04/10",
				"Albergue",
				"Asentamiento Precario",
				"decada_1970",
				"32",
				"1.9800000000000000000000000000000",
				"Pellegrini entre Del Campo y Rivarola",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.4809210072907,-34.4943647807953,0.0 -58.48104000091552,-34.49265706614314,0.0 -58.48042845726013,-34.4929311891911,0.0 -58.48012804985046,-34.4931434128674,0.0 -58.4802414390266,-34.493662309238,0.0 -58.4804025127194,-34.4938484438087,0.0 -58.480422581849,-34.4943585820603,0.0 -58.4802709201798,-34.4946359201849,0.0 -58.4802612285624,-34.4951699685691,0.0 -58.4802857021744,-34.4954373574815,0.0 -58.48029971122742,-34.495716581965006,0.0 -58.48085761070251,-34.496043748978025,0.0 -58.4809210072907,-34.4943647807953,0.0 ",
				"Polygon Outer Boundary",
				"668",
				"1100011",
				"Vicente Lopez",
				"La Lucila",
				"0011",
				"2014/10/01",
				"El Ceibo",
				"Villa",
				"90_o_anterior",
				"82",
				"2.0000000000000000000000000000000",
				"Ramseyer, Bermúdez",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.8238318344042,-34.5271547560167,0.0 -58.8238249148179,-34.5271124144115,0.0 -58.8218577938228,-34.5257943771189,0.0 -58.819985389709466,-34.524449328341944,0.0 -58.82176637649537,-34.52261956883183,0.0 -58.82056474685669,-34.5217444522484,0.0 -58.81890177726745,-34.523954324904466,0.0 -58.8168273666886,-34.5266239640208,0.0 -58.81694912910461,-34.526782876350374,0.0 -58.8177930116336,-34.5274150863638,0.0 -58.82117629051208,-34.52960249295901,0.0 -58.8214065234411,-34.5296477694287,0.0 -58.8225678945506,-34.5284634659301,0.0 -58.8235493452131,-34.5274624720656,0.0 -58.8238318344042,-34.5271547560167,0.0 ",
				"Polygon Outer Boundary",
				"74",
				"0740030",
				"Moreno",
				"Cuartel V",
				"0030",
				"2014/09/11",
				"Club Boca",
				"Asentamiento Precario",
				"2011",
				"900",
				"24.3299999999999980000000000000000",
				"Yersin Alejandro, Pinazo Manuel de, Samai Huasi, Gral. Mosconi",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.62942779064178,-33.71057426030774,0.0 -59.62956726551055,-33.71037345205937,0.0 -59.62982475757599,-33.71020388028398,0.0 -59.63024318218231,-33.71009678214804,0.0 -59.63035583496093,-33.70985581085386,0.0 -59.63005006313323,-33.709681775609795,0.0 -59.628896713256836,-33.710168180920164,0.0 -59.62821006774902,-33.71040022651962,0.0 -59.62780237197876,-33.710775068086555,0.0 -59.627931118011475,-33.71172108952766,0.0 -59.62786674499512,-33.712809893757914,0.0 -59.627437591552734,-33.71391653309097,0.0 -59.62703324854374,-33.714701881384755,0.0 -59.62664365768432,-33.71593343583549,0.0 -59.625957012176514,-33.717040034911946,0.0 -59.62634660303593,-33.718271555824636,0.0 -59.627848640084274,-33.716843703858494,0.0 -59.62832070887089,-33.71534443373689,0.0 -59.628835693001754,-33.7132382719658,0.0 -59.62905026972293,-33.71170324016297,0.0 -59.62942779064178,-33.71057426030774,0.0 ",
				"Polygon Outer Boundary",
				"1961",
				"0990025",
				"San Pedro",
				"San Pedro",
				"0025",
				"2015/07/21",
				"La Tosquera",
				"Villa",
				"90_o_anterior",
				"400",
				"10.9300000000000000000000000000000",
				"Barranca sur s/n",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.50336134433747,-34.82938848325524,0.0 -58.504793643951416,-34.83007541339484,0.0 -58.50640296936036,-34.82787809747699,0.0 -58.5049501391319,-34.8271644584626,0.0 -58.50336134433747,-34.82938848325524,0.0 ",
				"Polygon Outer Boundary",
				"1221",
				"0300005",
				"Esteban Echeverria",
				"El Jaguel",
				"0005",
				"2014/10/01",
				"Siglo XX",
				"Otros",
				"1998",
				"160",
				"4.3799999999999999000000000000000",
				"Tomás Alba Edison, Francisco Narciso de Laprida, Yapeyú, Pedro B. Palacios",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6221195146321,-34.6095782275924,0.0 -58.6220586160768,-34.6095888966811,0.0 -58.6217318802728,-34.6098271272438,0.0 -58.6214962968079,-34.6100248348782,0.0 -58.6216075548258,-34.6101596718989,0.0 -58.6217314062292,-34.6102977156942,0.0 -58.6217989523596,-34.6103531906921,0.0 -58.6218673598619,-34.610402726488,0.0 -58.6219466437381,-34.6104274177783,0.0 -58.6220466244929,-34.6105388722262,0.0 -58.621991600385,-34.6105436587335,0.0 -58.6220923452702,-34.6108133984827,0.0 -58.6221260423424,-34.6110238833291,0.0 -58.6223034957954,-34.6109926279226,0.0 -58.6221842827213,-34.6105143782178,0.0 -58.6225646953337,-34.6104453948457,0.0 -58.6228579081805,-34.610210479146,0.0 -58.6221195146321,-34.6095782275924,0.0 ",
				"Polygon Outer Boundary",
				"106",
				"1350013",
				"Hurlingham",
				"Hurlingham",
				"0013",
				"2014/07/23",
				"San Jorge",
				"Asentamiento Precario",
				"decada_1980",
				"40",
				"0.8399999999999999700000000000000",
				"Maestra Rodriguez - Roma",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.465139865875244,-34.77846925660655,0.0 -58.464721441268914,-34.77883937135045,0.0 -58.464421033859246,-34.77899799144671,0.0 -58.46399724483489,-34.779156611237994,0.0 -58.46424400806427,-34.77965890523183,0.0 -58.464544415473945,-34.779773463082854,0.0 -58.46532225608826,-34.780346249951876,0.0 -58.46599280834197,-34.779773463082854,0.0 -58.46599280834197,-34.77947825598971,0.0 -58.46616446971893,-34.779443007310974,0.0 -58.4663200378418,-34.77951791073527,0.0 -58.46661508083343,-34.77968974774583,0.0 -58.466641902923584,-34.77955315938201,0.0 -58.46666872501373,-34.779288794164444,0.0 -58.46655070781708,-34.779156611237994,0.0 -58.465139865875244,-34.77846925660655,0.0 ",
				"Polygon Outer Boundary",
				"1209",
				"0300017",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0017",
				"2014/10/01",
				"La Paz III",
				"Villa",
				"90_o_anterior",
				"110",
				"2.6299999999999999000000000000000",
				"Maxer y Maggio",
				"Cobertura Parcial",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.242393136024475,-34.821889123180505,0.0 -58.242462873458855,-34.821928757530074,0.0 -58.245686888694756,-34.81642380414752,0.0 -58.24593901634216,-34.81560023148907,0.0 -58.2461804151535,-34.81467535398411,0.0 -58.24584782123565,-34.81458286566259,0.0 -58.24102520942688,-34.816155153008594,0.0 -58.23928713798523,-34.81913669114828,0.0 -58.242393136024475,-34.821889123180505,0.0 ",
				"Polygon Outer Boundary",
				"1677",
				"0320058",
				"Florencio Varela",
				"Florencio Varela",
				"0058",
				"2015/05/05",
				"Santa Marta II",
				"Otros",
				"90_o_anterior",
				"387",
				"25.5399999999999990000000000000000",
				"Benito Quinquela Martín, calle 819, Av. Bosque,  calle 813",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.5643734072281,-34.451423337068,0.0 -58.5643243679382,-34.4514277188095,0.0 -58.564234101852,-34.4515331094692,0.0 -58.5641997852094,-34.4515546092884,0.0 -58.564162283734,-34.4515968935551,0.0 -58.5641297024237,-34.4516505024277,0.0 -58.5640684952983,-34.4517364041279,0.0 -58.5640436400689,-34.451770904925,0.0 -58.5639440012775,-34.4518834860808,0.0 -58.5638782686671,-34.4519731206362,0.0 -58.563816490157,-34.4521050752824,0.0 -58.5637684334021,-34.4521155973975,0.0 -58.5636763287862,-34.4522456633282,0.0 -58.5636122721925,-34.4523199938659,0.0 -58.563543825375,-34.452383817181,0.0 -58.563543311434,-34.4524265358945,0.0 -58.5640209855762,-34.45286331173,0.0 -58.564158903198,-34.4529830583733,0.0 -58.5641918132209,-34.4529801998418,0.0 -58.5645383425896,-34.4524418301528,0.0 -58.5645217544205,-34.4524200075747,0.0 -58.5642610083726,-34.4522941748323,0.0 -58.56425285339355,-34.452160967440136,0.0 -58.5646601105584,-34.4515510918927,0.0 -58.5643734072281,-34.451423337068,0.0 ",
				"Polygon Outer Boundary",
				"577",
				"0960025",
				"San Fernando",
				"San Fernando",
				"0025",
				"2014/10/01",
				"Don Mariano",
				"Otros",
				"decada_1960",
				"62",
				"0.8199999999999999500000000000000",
				"Chacabuco, Maipu, Fray Justo M de Oro, Arroyo Cordero",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.79504084587097,-34.5122943754548,0.0 -58.790969252586365,-34.50979686553222,0.0 -58.7885279294298,-34.5104429752221,0.0 -58.791564702987664,-34.5125374918918,0.0 -58.792294263839715,-34.511724154119676,0.0 -58.794327378273,-34.51301930237111,0.0 -58.79504084587097,-34.5122943754548,0.0 ",
				"Polygon Outer Boundary",
				"1154",
				"1320024",
				"Jose C. Paz",
				"Jose C. Paz",
				"0024",
				"2014/10/01",
				"Comunidad guarani",
				"Asentamiento Precario",
				"2001",
				"230",
				"8.4199999999999999000000000000000",
				"Budapest, Lacroze, Chavez, Ballesteros",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.407309595495455,-34.81914109511298,0.0 -58.40902620926499,-34.81674530353936,0.0 -58.40747052803635,-34.8159966043844,0.0 -58.40738469734788,-34.81611111175471,0.0 -58.40576464310289,-34.81526551511462,0.0 -58.40412313118577,-34.81752922830407,0.0 -58.407309595495455,-34.81914109511298,0.0 ",
				"Polygon Outer Boundary",
				"2103",
				"0030081",
				"Almirante Brown",
				"Burzaco",
				"0081",
				"2015/08/12",
				"Bétharram II",
				"Asentamiento Precario",
				"1998",
				"319",
				"10.2200000000000010000000000000000",
				"Diomede, Pino, Bradley e Ituzaingó",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-56.74086604267359,-36.34692359676823,0.0 -56.74223933368921,-36.34546317502669,0.0 -56.74133811146021,-36.344944675512224,0.0 -56.74106989055872,-36.34592982163784,0.0 -56.7405978217721,-36.34675076722185,0.0 -56.74086604267359,-36.34692359676823,0.0 ",
				"Polygon Outer Boundary",
				"2211",
				"1230003",
				"La Costa",
				"San Clemente Del Tuyo",
				"0003",
				"2015/09/18",
				"Calle 54 & 41",
				"Asentamiento Precario",
				"90_o_anterior",
				"35",
				"1.2000000000000000000000000000000",
				"Calle 54 y 41",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"-"
			],
			[
				"",
				"",
				"-58.74232626054436,-38.53258610956743,0.0 -58.741557598114014,-38.531973441701616,0.0 -58.741498589515686,-38.5319650489549,0.0 -58.74145567417145,-38.531990227192104,0.0 -58.74070352409036,-38.53257561872322,0.0 -58.74070352409036,-38.532617582090886,0.0 -58.74147600028664,-38.53324493151935,0.0 -58.74151891563088,-38.533238637070646,0.0 -58.742323578335345,-38.532623876593924,0.0 -58.74232626054436,-38.53258610956743,0.0 ",
				"Polygon Outer Boundary",
				"1472",
				"0760003",
				"Necochea",
				"Necochea",
				"0003",
				"2015/03/20",
				"Los Alamos",
				"Otros",
				"decada_1990",
				"10",
				"4.2999999999999998000000000000000",
				"calle 86 - 90 - 33 - 29",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.741351487115026,-38.533320464860836,0.0 -58.740600468590856,-38.53269101792541,0.0 -58.74054145999253,-38.53269101792541,0.0 -58.73973679728806,-38.53327850190313,0.0 -58.73974752612411,-38.53332466115526,0.0 -58.74049854464829,-38.5339457100313,0.0 -58.74055218882858,-38.5339457100313,0.0 -58.741346122696996,-38.53336242779406,0.0 -58.741351487115026,-38.533320464860836,0.0 ",
				"Polygon Outer Boundary",
				"1472",
				"0760003",
				"Necochea",
				"Necochea",
				"0003",
				"2015/03/20",
				"Los Alamos",
				"Otros",
				"decada_1990",
				"10",
				"4.2999999999999998000000000000000",
				"calle 86 - 90 - 33 - 29",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.74041807837784,-38.53254834252112,0.0 -58.73962414450943,-38.53191469245405,0.0 -58.73955977149308,-38.53191888883047,0.0 -58.738749325275414,-38.532533655331086,0.0 -58.738746643066406,-38.53256932421596,0.0 -58.738757371902466,-38.532596600410116,0.0 -58.739549042657025,-38.53322814632159,0.0 -58.73960268683731,-38.53322814632159,0.0 -58.74042344279587,-38.53260709125127,0.0 -58.74041807837784,-38.53254834252112,0.0 ",
				"Polygon Outer Boundary",
				"1472",
				"0760003",
				"Necochea",
				"Necochea",
				"0003",
				"2015/03/20",
				"Los Alamos",
				"Otros",
				"decada_1990",
				"10",
				"4.2999999999999998000000000000000",
				"calle 86 - 90 - 33 - 29",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.74136221595109,-38.53183076487433,0.0 -58.74061656184495,-38.53122228699344,0.0 -58.74054145999253,-38.53122228699344,0.0 -58.7397636193782,-38.531809782964096,0.0 -58.7397636193782,-38.531864335917966,0.0 -58.74051463790237,-38.532456022991106,0.0 -58.740600468590856,-38.5324686120249,0.0 -58.74136221595109,-38.531864335917966,0.0 -58.74136221595109,-38.53183076487433,0.0 ",
				"Polygon Outer Boundary",
				"1472",
				"0760003",
				"Necochea",
				"Necochea",
				"0003",
				"2015/03/20",
				"Los Alamos",
				"Otros",
				"decada_1990",
				"10",
				"4.2999999999999998000000000000000",
				"calle 86 - 90 - 33 - 29",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.25436259061098,-38.7556060124452,0.0 -62.25264597684145,-38.75525461456228,0.0 -62.25144434720278,-38.75488648159131,0.0 -62.25071478635073,-38.7555056132266,0.0 -62.25037146359682,-38.75515421484942,0.0 -62.25234556943178,-38.75361473490083,0.0 -62.24992085248231,-38.75170707238024,0.0 -62.245607860386365,-38.75513748155021,0.0 -62.25011397153139,-38.75880198043169,0.0 -62.25436259061098,-38.7556060124452,0.0 ",
				"Polygon Outer Boundary",
				"1512",
				"0070022",
				"Bahia Blanca",
				"Bahia Blanca",
				"0022",
				"2015/04/13",
				"Spurr",
				"Otros",
				"90_o_anterior",
				"710",
				"27.4699999999999990000000000000000",
				"Capitán Brickman, Esmeralda, Tierra del Fuego y James Harris",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.23888540640473,-38.75601597445535,0.0 -62.23850989714265,-38.755949042043106,0.0 -62.23803782835602,-38.75569804493816,0.0 -62.236911300569766,-38.75528808110186,0.0 -62.23676109686494,-38.75552234643951,0.0 -62.2366645373404,-38.75563111222777,0.0 -62.236600164324045,-38.75577334416232,0.0 -62.237125877290964,-38.75600760790726,0.0 -62.23803782835602,-38.756250237403925,0.0 -62.23855281248689,-38.75671876099435,0.0 -62.23830604925752,-38.75712035019535,0.0 -62.23855281248689,-38.757480105269074,0.0 -62.238348964601755,-38.758023917635754,0.0 -62.23848843947053,-38.758358569340274,0.0 -62.23869228735566,-38.75861792333196,0.0 -62.238703016191714,-38.75893583984243,0.0 -62.23889613524079,-38.75924538876814,0.0 -62.23906779661774,-38.759672062113545,0.0 -62.239099983125925,-38.76009036683848,0.0 -62.23847771063447,-38.760642525321,0.0 -62.23770523443818,-38.761194679531265,0.0 -62.237104419618845,-38.76188068335629,0.0 -62.237190250307314,-38.76197270775796,0.0 -62.237887624651194,-38.762533217459975,0.0 -62.23816657438874,-38.762558314806334,0.0 -62.23846698179841,-38.7620898295521,0.0 -62.23833823576569,-38.76183048817806,0.0 -62.238574270159006,-38.76154604816793,0.0 -62.23949695006013,-38.76050030309006,0.0 -62.23976517096162,-38.76011546504401,0.0 -62.2402479685843,-38.759111529938004,0.0 -62.240677122026675,-38.75840876696061,0.0 -62.24016213789582,-38.75821634255759,0.0 -62.239614967256784,-38.757923521818405,0.0 -62.239636424928904,-38.75773946245312,0.0 -62.239775899797685,-38.7569279223185,0.0 -62.24007630720734,-38.756517965546486,0.0 -62.23971152678131,-38.7563757350958,0.0 -62.23888540640473,-38.75601597445535,0.0 ",
				"Polygon Outer Boundary",
				"1513",
				"0070023",
				"Bahia Blanca",
				"Bahia Blanca",
				"0023",
				"2015/04/13",
				"Empleados de Comercio",
				"Villa",
				"decada_2000",
				"30",
				"8.5600000000000005000000000000000",
				"Arroyo e  Islas Orcadas",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.523027300834656,-34.52370240238259,0.0 -58.52305948734283,-34.523653785667854,0.0 -58.52271080017089,-34.52349025651004,0.0 -58.52267861366273,-34.523525614192984,0.0 -58.523027300834656,-34.52370240238259,0.0 ",
				"Polygon Outer Boundary",
				"1794",
				"1100028",
				"Vicente Lopez",
				"Carapachay",
				"0028",
				"2015/06/24",
				"Carregal",
				"Otros",
				"90_o_anterior",
				"11",
				"0.0200000000000000000000000000000",
				"Carregal 3140",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.235073890537016,-34.81778466285208,0.0 -58.237015809863806,-34.817088822051055,0.0 -58.232831563800566,-34.81347740197394,0.0 -58.232091274112456,-34.81401472083847,0.0 -58.2320805452764,-34.815380023501,0.0 -58.23367914184927,-34.81489556385554,0.0 -58.235073890537016,-34.81778466285208,0.0 ",
				"Polygon Outer Boundary",
				"1678",
				"0320059",
				"Florencio Varela",
				"Florencio Varela",
				"0059",
				"2015/05/05",
				"Av. Bosques & Quinquela Martín",
				"Asentamiento Precario",
				"90_o_anterior",
				"240",
				"6.6799999999999997000000000000000",
				"Av. Bosques, Naciones Unidas, Luis Agote, Moliere & Calle 1003",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.418646454811096,-34.82494531594826,0.0 -58.41910779476166,-34.82496293056348,0.0 -58.41916143894196,-34.82475595859674,0.0 -58.418870838359,-34.82460183019852,0.0 -58.416472943499684,-34.82344805988547,0.0 -58.41624319553375,-34.823765128146874,0.0 -58.418646454811096,-34.82494531594826,0.0 ",
				"Polygon Outer Boundary",
				"1261",
				"0030018",
				"Almirante Brown",
				"Burzaco",
				"0018",
				"2014/10/01",
				"La Cumbre (Acumar)",
				"Villa",
				"90_o_anterior",
				"36",
				"1.1899999999999999000000000000000",
				"Diomede(Petiribí), Florida, Buenos Aires",
				"Cobertura Parcial",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-62.24872374907136,-38.7600318043246,0.0 -62.24780106917024,-38.76052540115141,0.0 -62.24727535620332,-38.760266054091794,0.0 -62.24682474508882,-38.76086840710522,0.0 -62.24627757444977,-38.76061742730084,0.0 -62.24569821730257,-38.76147912094196,0.0 -62.24516177549958,-38.761253241090856,0.0 -62.244861368089914,-38.76162134122213,0.0 -62.244185451418154,-38.76147912094196,0.0 -62.2439601458609,-38.761788658835926,0.0 -62.24489355459809,-38.762173487858796,0.0 -62.24471116438509,-38.76249138852975,0.0 -62.244668249040835,-38.76275909325943,0.0 -62.24482918158173,-38.762976602612795,0.0 -62.2446789778769,-38.76306025987985,0.0 -62.24476480856537,-38.76319411130313,0.0 -62.24434638395905,-38.76354547009464,0.0 -62.24477553740144,-38.76378807396475,0.0 -62.24499011412262,-38.76388009590661,0.0 -62.24531197920441,-38.763570567084976,0.0 -62.245869878679514,-38.76392192402276,0.0 -62.24535489454866,-38.764950887959344,0.0 -62.245891336351626,-38.76527714171891,0.0 -62.24682474508882,-38.76427327923043,0.0 -62.24727535620332,-38.76443222506552,0.0 -62.2475435771048,-38.7640223114015,0.0 -62.247489932924516,-38.76380480523574,0.0 -62.247908357530825,-38.763160648470844,0.0 -62.24850917235017,-38.76263360679245,0.0 -62.24863791838289,-38.76240773059576,0.0 -62.248605731874704,-38.762181853684076,0.0 -62.248434070497744,-38.76194761020564,0.0 -62.24888468161225,-38.76147912094196,0.0 -62.24915290251374,-38.761303436675114,0.0 -62.249399665743105,-38.76112775197575,0.0 -62.249560598284,-38.76137036406587,0.0 -62.24998975172639,-38.76106919031317,0.0 -62.24922800436616,-38.760533767169896,0.0 -62.24872374907136,-38.7600318043246,0.0 ",
				"Polygon Outer Boundary",
				"1514",
				"0070024",
				"Bahia Blanca",
				"Bahia Blanca",
				"0024",
				"2015/04/13",
				"Serra",
				"Villa",
				"2006",
				"95",
				"13.3900000000000010000000000000000",
				"Tierra del Fuego e Islas Orcadas",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.80582332611084,-34.55601739685241,0.0 -58.8045573234558,-34.55743113992012,0.0 -58.8086476618548,-34.5601186350836,0.0 -58.8116302637223,-34.562101355153,0.0 -58.813643988181,-34.5599396054418,0.0 -58.8145799205544,-34.5589405048867,0.0 -58.8117173647337,-34.5563604177491,0.0 -58.8107167321306,-34.5554673215965,0.0 -58.8098656198081,-34.5563243513095,0.0 -58.8096247882837,-34.5564121411085,0.0 -58.8046137716409,-34.5531428186172,0.0 -58.803420066833496,-34.554462251728694,0.0 -58.80582332611084,-34.55601739685241,0.0 ",
				"Polygon Outer Boundary",
				"78",
				"0740034",
				"Moreno",
				"Moreno",
				"0034",
				"2014/09/11",
				"18 de Julio - Los Hornos",
				"Asentamiento Precario",
				"2007",
				"675",
				"61.7899999999999990000000000000000",
				"S/N",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.80691766738891,-34.55914527116322,0.0 -58.80432128906251,-34.55741346828006,0.0 -58.8056094199419,-34.55605274072191,0.0 -58.803248405456536,-34.55463897422951,0.0 -58.800308704376214,-34.55769621407058,0.0 -58.8052225112915,-34.560947721586366,0.0 -58.80691766738891,-34.55914527116322,0.0 ",
				"Polygon Outer Boundary",
				"78",
				"0740034",
				"Moreno",
				"Moreno",
				"0034",
				"2014/09/11",
				"18 de Julio - Los Hornos",
				"Asentamiento Precario",
				"2007",
				"675",
				"61.7899999999999990000000000000000",
				"S/N",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7829343755858,-34.5362826388249,0.0 -58.78136157989502,-34.53787959330683,0.0 -58.7823486328125,-34.538546851725506,0.0 -58.78340005874634,-34.53927596904793,0.0 -58.783968687057495,-34.53868383789147,0.0 -58.78283143043518,-34.537910525934535,0.0 -58.784515857696526,-34.536213633379404,0.0 -58.78440856933594,-34.536116414529204,0.0 -58.783571720123284,-34.53559496603162,0.0 -58.7829343755858,-34.5362826388249,0.0 ",
				"Polygon Outer Boundary",
				"1173",
				"1320005",
				"Jose C. Paz",
				"Jose C. Paz",
				"0005",
				"2014/10/01",
				"Papelitos",
				"Asentamiento Precario",
				"90_o_anterior",
				"200",
				"4.6500000000000004000000000000000",
				"Rodrigo de Traina, J.C Paz, Colón,",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.416199358180165,-34.82378274301449,0.0 -58.41573173180222,-34.824416875739935,0.0 -58.4172230400145,-34.825147883795836,0.0 -58.41646129265428,-34.826151908381334,0.0 -58.414991442114115,-34.825394487459555,0.0 -58.41483050957322,-34.825614668678206,0.0 -58.41777021065355,-34.827103078277,0.0 -58.418666990473874,-34.8259185177933,0.0 -58.41892448253929,-34.82567191569865,0.0 -58.41889766044915,-34.825456138260115,0.0 -58.418715270236135,-34.825015774386536,0.0 -58.416199358180165,-34.82378274301449,0.0 ",
				"Polygon Outer Boundary",
				"2105",
				"0030083",
				"Almirante Brown",
				"Burzaco",
				"0083",
				"2015/08/12",
				"Morel & Florida (La Cumbre)",
				"Asentamiento Precario",
				"1994",
				"186",
				"5.4800000000000004000000000000000",
				"Av. Monteverde, Diomede, Prieto, Buenos Aires y Pinto",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-56.887443233281374,-37.12207835815506,0.0 -56.886906791478395,-37.12153941311213,0.0 -56.88597338274121,-37.12171050719227,0.0 -56.8857373483479,-37.12188587822307,0.0 -56.88588218763471,-37.12218956855936,0.0 -56.887443233281374,-37.12207835815506,0.0 ",
				"Polygon Outer Boundary",
				"2167",
				"1240001",
				"Pinamar",
				"Ostende",
				"0001",
				"2015/09/08",
				"La Palangana",
				"Asentamiento Precario",
				"2010",
				"13",
				"0.7099999999999999600000000000000",
				"Praga y Misiones",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.24853849597275,-34.8194493720575,0.0 -58.245743634179235,-34.81799165233591,0.0 -58.24537348933517,-34.81859940568743,0.0 -58.24812543578446,-34.820017479404726,0.0 -58.24853849597275,-34.8194493720575,0.0 ",
				"Polygon Outer Boundary",
				"1698",
				"0320061",
				"Florencio Varela",
				"Florencio Varela",
				"0061",
				"2015/05/13",
				"Martín Gras & Calle 828",
				"Asentamiento Precario",
				"2014",
				"65",
				"2.2300000000000000000000000000000",
				"Martín Gras, Calle 828, Cale 811",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.67355287075043,-34.45224943724897,0.0 -58.67260336875915,-34.45151955852329,0.0 -58.67235660552978,-34.45133819372929,0.0 -58.67182016372681,-34.45065696635102,0.0 -58.670774102211,-34.45116125208731,0.0 -58.67123544216157,-34.4516566877402,0.0 -58.670929670333855,-34.4518070872676,0.0 -58.67025911808014,-34.45213884997329,0.0 -58.66955101490021,-34.45249272874005,0.0 -58.6700858100872,-34.4531045491666,0.0 -58.6700482555944,-34.4531946389761,0.0 -58.6703174315342,-34.4535558129937,0.0 -58.6706212080888,-34.4539742520879,0.0 -58.6711069718066,-34.4542101451144,0.0 -58.6715236425201,-34.4544117663862,0.0 -58.67355287075043,-34.45224943724897,0.0 ",
				"Polygon Outer Boundary",
				"696",
				"0570020",
				"Tigre",
				"Ricardo Rojas",
				"0020",
				"2014/10/01",
				"San Lorenzo",
				"Villa",
				"90_o_anterior",
				"130",
				"7.6699999999999999000000000000000",
				"Groussac, Quintana, Roca, Arroyo Las Tunas",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.7606192763657,-34.5476153083646,0.0 -58.7581749890433,-34.545323513732,0.0 -58.75446438789367,-34.54810882850764,0.0 -58.75680327415467,-34.55032683804587,0.0 -58.7606192763657,-34.5476153083646,0.0 ",
				"Polygon Outer Boundary",
				"1177",
				"1320001",
				"Jose C. Paz",
				"Jose C. Paz",
				"0001",
				"2014/10/01",
				"Ferrari",
				"Asentamiento Precario",
				"90_o_anterior",
				"430",
				"15.3699999999999990000000000000000",
				"Tres Sargentos, Chile, Pichincha, Defensa",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.538965035229914,-33.87458446536255,0.0 -60.537935066968195,-33.87365805753277,0.0 -60.53709285333752,-33.872945429282694,0.0 -60.53648667410015,-33.87340863832206,0.0 -60.536046791821725,-33.87377385906141,0.0 -60.53787605836987,-33.875421786864564,0.0 -60.538965035229914,-33.87458446536255,0.0 ",
				"Polygon Outer Boundary",
				"2214",
				"0820017",
				"Pergamino",
				"Pergamino",
				"0017",
				"2015/09/21",
				"La Guarida",
				"Otros",
				"2000",
				"25",
				"3.4199999999999999000000000000000",
				"Remedios de Escalada & s/n",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.22961569204926,-38.756484499583586,0.0 -62.22626829519868,-38.753773704476274,0.0 -62.22552800551056,-38.753087622722674,0.0 -62.22503447905183,-38.75306252204567,0.0 -62.22501302137971,-38.75350596603994,0.0 -62.22502375021576,-38.75429244483887,0.0 -62.22552800551056,-38.754710781094914,0.0 -62.22642922773957,-38.75536338075853,0.0 -62.227148059755564,-38.755647845411254,0.0 -62.22784543409943,-38.75591557581345,0.0 -62.22876811400056,-38.756484499583586,0.0 -62.229122165590525,-38.75674386038561,0.0 -62.22961569204926,-38.756517965546486,0.0 -62.22961569204926,-38.756484499583586,0.0 ",
				"Polygon Outer Boundary",
				"1515",
				"0070025",
				"Bahia Blanca",
				"Bahia Blanca",
				"0025",
				"2015/04/13",
				"5 de Abril",
				"Villa",
				"decada_2000",
				"20",
				"4.7100000000000000000000000000000",
				"Monseñor de Andrea, Vías FFRR Roca e Independencia",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.24673891440033,-38.77668671931083,0.0 -62.24713588133454,-38.77634378940224,0.0 -62.247092965990305,-38.77600085784477,0.0 -62.24666381254793,-38.775649560393276,0.0 -62.24628830328584,-38.77489677431359,0.0 -62.24585294723511,-38.77442837007637,0.0 -62.24619626998901,-38.77375921583008,0.0 -62.246878389269106,-38.774127251442394,0.0 -62.24750066176057,-38.77393486942739,0.0 -62.248798850923784,-38.773031503461674,0.0 -62.24950695410371,-38.77253799314815,0.0 -62.24899196997285,-38.77218667864114,0.0 -62.24821949377656,-38.771693162482634,0.0 -62.246502880007036,-38.77081486256892,0.0 -62.24585914984346,-38.771191278141806,0.0 -62.24488282576203,-38.77184372709632,0.0 -62.24527979269624,-38.772412523879986,0.0 -62.2441210784018,-38.77345809437118,0.0 -62.2434558905661,-38.7740101494081,0.0 -62.24428201094269,-38.774687665659215,0.0 -62.24673891440033,-38.77668671931083,0.0 ",
				"Polygon Outer Boundary",
				"1516",
				"0070026",
				"Bahia Blanca",
				"Ingeniero White",
				"0026",
				"2015/04/13",
				"Saladero",
				"Asentamiento Precario",
				"90_o_anterior",
				"110",
				"28.0500000000000010000000000000000",
				"Juan B. Justo, Alcorta, Perito Moreno",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.24552655592561,-38.77059737711036,0.0 -62.24590206518769,-38.770254417924676,0.0 -62.24377775564789,-38.76849777185512,0.0 -62.2431662119925,-38.768037690736655,0.0 -62.24291944876313,-38.76828027933253,0.0 -62.24304819479585,-38.76866507334439,0.0 -62.24546218290925,-38.77060574194796,0.0 -62.24552655592561,-38.77059737711036,0.0 ",
				"Polygon Outer Boundary",
				"1516",
				"0070026",
				"Bahia Blanca",
				"Ingeniero White",
				"0026",
				"2015/04/13",
				"Saladero",
				"Asentamiento Precario",
				"90_o_anterior",
				"110",
				"28.0500000000000010000000000000000",
				"Juan B. Justo, Alcorta, Perito Moreno",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.2400333918631,-38.76999510622624,0.0 -62.24213624373078,-38.768464311510186,0.0 -62.24155688658357,-38.76818826306568,0.0 -62.240762952715166,-38.767920578705485,0.0 -62.2387352026999,-38.76718444153618,0.0 -62.238348964601755,-38.767335015666,0.0 -62.23790908232331,-38.7682384537714,0.0 -62.2366645373404,-38.76871526371466,0.0 -62.23605299368501,-38.76962704929392,0.0 -62.235849145799875,-38.76994491675637,0.0 -62.23595643416047,-38.770321336919636,0.0 -62.23606372252106,-38.77049699898278,0.0 -62.23825240507722,-38.77059737711036,0.0 -62.2389497794211,-38.770739579215984,0.0 -62.23956132307649,-38.77065593095289,0.0 -62.2400333918631,-38.76999510622624,0.0 ",
				"Polygon Outer Boundary",
				"1516",
				"0070026",
				"Bahia Blanca",
				"Ingeniero White",
				"0026",
				"2015/04/13",
				"Saladero",
				"Asentamiento Precario",
				"90_o_anterior",
				"110",
				"28.0500000000000010000000000000000",
				"Juan B. Justo, Alcorta, Perito Moreno",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.26356172934174,-38.78403004209972,0.0 -62.263357881456606,-38.784138764432605,0.0 -62.264559511095285,-38.78587829921228,0.0 -62.26472044363618,-38.78581139481321,0.0 -62.26468825712799,-38.785602318161494,0.0 -62.264752630144365,-38.78529288359177,0.0 -62.264098171144724,-38.78446493043654,0.0 -62.26356172934174,-38.78403004209972,0.0 ",
				"Polygon Outer Boundary",
				"1518",
				"0070028",
				"Bahia Blanca",
				"Ingeniero White",
				"0028",
				"2015/04/13",
				"Estación White",
				"Asentamiento Precario",
				"90_o_anterior",
				"24",
				"1.9900000000000000000000000000000",
				"Guillero Torres y Gral. Belgrano",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.26246738806367,-38.78033338414316,0.0 -62.26253176108002,-38.780308293049764,0.0 -62.261930946260684,-38.779463554420396,0.0 -62.26093316450715,-38.779881743111346,0.0 -62.261598352342844,-38.78093556773609,0.0 -62.26246738806367,-38.78033338414316,0.0 ",
				"Polygon Outer Boundary",
				"1518",
				"0070028",
				"Bahia Blanca",
				"Ingeniero White",
				"0028",
				"2015/04/13",
				"Estación White",
				"Asentamiento Precario",
				"90_o_anterior",
				"24",
				"1.9900000000000000000000000000000",
				"Guillero Torres y Gral. Belgrano",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.47790718078613,-34.790783492545245,0.0 -58.475128412246704,-34.78935610465906,0.0 -58.47450077533722,-34.79017112854596,0.0 -58.47727417945861,-34.7916469621127,0.0 -58.47790718078613,-34.790783492545245,0.0 ",
				"Polygon Outer Boundary",
				"1206",
				"0300020",
				"Esteban Echeverria",
				"Luis Guillon",
				"0020",
				"2014/10/01",
				"La Nango",
				"Asentamiento Precario",
				"2013",
				"50",
				"3.2999999999999998000000000000000",
				"Puerto Deseado, Ing. Huergo, Gifford, Castex",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.40981125831603,-34.83243118797701,0.0 -58.410437973216176,-34.83160777536428,0.0 -58.41069010086358,-34.83124670413493,0.0 -58.40919342823326,-34.830511346857406,0.0 -58.408286841586225,-34.83170905115648,0.0 -58.40981125831603,-34.83243118797701,0.0 ",
				"Polygon Outer Boundary",
				"2106",
				"0030084",
				"Almirante Brown",
				"Burzaco",
				"0084",
				"2015/08/12",
				"San Pablo II (Acumar)",
				"Asentamiento Precario",
				"1990",
				"39",
				"2.5000000000000000000000000000000",
				"Echenagucia, Maure, Cafferata, Echague y Av. Monteverde",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-62.25367594510317,-38.77588375888653,0.0 -62.25311804562807,-38.77621832682859,0.0 -62.252774722874165,-38.77678708872825,0.0 -62.25288201123475,-38.777238749358666,0.0 -62.25341845303774,-38.778058422456255,0.0 -62.253032214939594,-38.77849334721311,0.0 -62.251980789005756,-38.779513737192794,0.0 -62.2518091276288,-38.780082472811955,0.0 -62.251980789005756,-38.78021629229846,0.0 -62.25507069379091,-38.77774059114889,0.0 -62.25367594510317,-38.77588375888653,0.0 ",
				"Polygon Outer Boundary",
				"1517",
				"0070027",
				"Bahia Blanca",
				"Ingeniero White",
				"0027",
				"2015/04/13",
				"White Norte",
				"Asentamiento Precario",
				"90_o_anterior",
				"70",
				"4.7199999999999998000000000000000",
				"Guayaquil, Alcorta, Juan B. Justo y Rodó",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.47346007823944,-34.760274307981646,0.0 -58.472698330879204,-34.76130556510969,0.0 -58.474602699279785,-34.762275111344536,0.0 -58.475418090820305,-34.761239459269945,0.0 -58.47346007823944,-34.760274307981646,0.0 ",
				"Polygon Outer Boundary",
				"1194",
				"0300032",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0032",
				"2014/10/01",
				"El Parque",
				"Villa",
				"2007",
				"210",
				"2.8100000000000001000000000000000",
				"Gral. José María Paz y Arroyo Santa Catalina (limite con Lomas de Zamora)",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.244571689516306,-38.70788374266402,0.0 -62.24436784163118,-38.70786699828847,0.0 -62.24407816305756,-38.708093047027596,0.0 -62.24344516173005,-38.70861211920514,0.0 -62.24220061674714,-38.70955816041589,0.0 -62.24136376753449,-38.70896374660364,0.0 -62.23905706778169,-38.70702140222354,0.0 -62.23653579130769,-38.7089972348371,0.0 -62.237694505602114,-38.709893039260415,0.0 -62.239078525453806,-38.710914410048,0.0 -62.239625696092844,-38.71055442037003,0.0 -62.240591291338205,-38.71123253895225,0.0 -62.24004412069917,-38.71170135791494,0.0 -62.24088096991181,-38.71244643886888,0.0 -62.24117064848542,-38.71225389060244,0.0 -62.24140668287874,-38.71200273991027,0.0 -62.24172854796053,-38.712094828599845,0.0 -62.24198604002594,-38.71196088137578,0.0 -62.24277997389436,-38.711299513278014,0.0 -62.24401379004121,-38.71038698269287,0.0 -62.24458241835236,-38.70996838678426,0.0 -62.245344165712595,-38.70929862823247,0.0 -62.2457411326468,-38.70877118895677,0.0 -62.244571689516306,-38.70788374266402,0.0 ",
				"Polygon Outer Boundary",
				"1520",
				"0070029",
				"Bahia Blanca",
				"Bahia Blanca",
				"0029",
				"2015/04/13",
				"Miramar",
				"Asentamiento Precario",
				"90_o_anterior",
				"640",
				"20.9600000000000010000000000000000",
				"Charcas, Lizarraga, Azara y Rojas",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Inexistente"
			],
			[
				"",
				"",
				"-59.0412614730461,-34.0924222719176,0.0 -59.040899048422,-34.0922377967187,0.0 -59.0408535425211,-34.0922375315932,0.0 -59.0404893305436,-34.0927109342893,0.0 -59.0404883575476,-34.0927491490298,0.0 -59.0408710421683,-34.0929531652263,0.0 -59.0412614730461,-34.0924222719176,0.0 ",
				"Polygon Outer Boundary",
				"459",
				"0380009",
				"Zarate",
				"Zárate",
				"0009",
				"2014/09/18",
				"Anta",
				"Villa",
				"1993",
				"14",
				"0.3100000000000000000000000000000",
				"Av. Anta, Urquiza, J. B. Justo",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.305320860818036,-34.811442605334946,0.0 -58.30673170275987,-34.809826183449054,0.0 -58.30638301558792,-34.80871625142322,0.0 -58.303657891228795,-34.809324073193835,0.0 -58.30383491702378,-34.80987903698217,0.0 -58.30459129996597,-34.80969404946798,0.0 -58.30463421531021,-34.80976452095093,0.0 -58.30391001887619,-34.81073349773021,0.0 -58.305320860818036,-34.811442605334946,0.0 ",
				"Polygon Outer Boundary",
				"1701",
				"0320062",
				"Florencio Varela",
				"Ing. Dante Ardigó",
				"0062",
				"2015/05/14",
				"Irineo Portela & calle 519.",
				"Otros",
				"90_o_anterior",
				"70",
				"5.0199999999999996000000000000000",
				"calle 513, calle 521, calle 527, Ireneo Portela, calle519.",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.91392695903779,-34.57730935707402,0.0 -60.91540217399597,-34.578506315778,0.0 -60.91637397184968,-34.57768920561458,0.0 -60.91613173484802,-34.577490447873814,0.0 -60.91607809066772,-34.57744627942244,0.0 -60.916882753372185,-34.57678374983553,0.0 -60.91677010059357,-34.5767793329539,0.0 -60.915096402168274,-34.57705317917126,0.0 -60.91392695903779,-34.57730935707402,0.0 ",
				"Polygon Outer Boundary",
				"1699",
				"0540003",
				"Junin",
				"Junin",
				"0003",
				"2015/05/13",
				"Ricardo Rojas",
				"Asentamiento Precario",
				"2012",
				"42",
				"2.3300000000000001000000000000000",
				"Arias - Lebensohn - 12 de Octubre - 2 de Enero",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.47997248172759,-34.75391460438421,0.0 -58.480605483055115,-34.75310803732824,0.0 -58.48021388053893,-34.75289647745205,0.0 -58.47928047180176,-34.75240724316256,0.0 -58.478642106056206,-34.753227039520425,0.0 -58.47969353199006,-34.75375593607759,0.0 -58.47997248172759,-34.75391460438421,0.0 ",
				"Polygon Outer Boundary",
				"1212",
				"0300014",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0014",
				"2014/10/01",
				"Elizalde & Restelli",
				"Villa",
				"90_o_anterior",
				"110",
				"1.5400000000000000000000000000000",
				"San Antonio, Dr. Gilberto Elizalde, Rastelli",
				"Cobertura Parcial",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.507543578743935,-34.82831844604582,0.0 -58.505140319466584,-34.81725617670454,0.0 -58.49981881678104,-34.814472760382564,0.0 -58.49951505661011,-34.81486033031566,0.0 -58.499343395233154,-34.81511577313844,0.0 -58.4993326663971,-34.81587328857687,0.0 -58.49928975105285,-34.81658675605087,0.0 -58.498831763863556,-34.818595001693765,0.0 -58.498291969299316,-34.81945817995324,0.0 -58.49788427352905,-34.820330156970755,0.0 -58.4976301342249,-34.821202124758116,0.0 -58.4972083568573,-34.82205646808222,0.0 -58.496857658028595,-34.822928417595506,0.0 -58.507543578743935,-34.82831844604582,0.0 ",
				"Polygon Outer Boundary",
				"1700",
				"0300041",
				"Esteban Echeverria",
				"El Jagüel",
				"0041",
				"2015/05/14",
				"La Morita",
				"Asentamiento Precario",
				"90_o_anterior",
				"3200",
				"79.3599999999999990000000000000000",
				"Tomas Edison, Estancia Los Remedios, Arroyo Ortega",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.40911388397217,-34.83052896028213,0.0 -58.40848624706269,-34.83020311131481,0.0 -58.40934455394744,-34.828983367922596,0.0 -58.408668637275696,-34.82861788172766,0.0 -58.40774595737457,-34.82974956263276,0.0 -58.406855463981636,-34.83095608467834,0.0 -58.40828776359558,-34.83165621162826,0.0 -58.40911388397217,-34.83052896028213,0.0 ",
				"Polygon Outer Boundary",
				"2107",
				"0030085",
				"Almirante Brown",
				"Burzaco",
				"0085",
				"2015/08/12",
				"San Pablo & Echagüe (San Pablo)",
				"Asentamiento Precario",
				"1990",
				"53",
				"3.5000000000000000000000000000000",
				"Juan XXIII, Eva Perón, Cafferata, Echenagucía y Echague",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6673125008633,-34.6842297114617,0.0 -58.6673576984023,-34.6842282227597,0.0 -58.6684188264508,-34.6833434353035,0.0 -58.6684190293275,-34.6833035079819,0.0 -58.6678499122411,-34.6828458050766,0.0 -58.6675882071432,-34.6826378883482,0.0 -58.667540770035,-34.6826361979563,0.0 -58.6668328270353,-34.6832226214519,0.0 -58.6668167439784,-34.6832661606852,0.0 -58.6670295444188,-34.6839995683577,0.0 -58.6673125008633,-34.6842297114617,0.0 ",
				"Polygon Outer Boundary",
				"5",
				"1360005",
				"Ituzaingo",
				"Ituzaingó Sur",
				"0005",
				"2014/09/01",
				"Atalaya",
				"Otros",
				"1980",
				"25",
				"1.4600000000000000000000000000000",
				"Italo Botti, Spilimbergo, Cuyo, Caaguazu",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.62555775791406,-34.721420910360614,0.0 -58.624077178537846,-34.720265696533396,0.0 -58.624914027750485,-34.71951612167556,0.0 -58.62473163753747,-34.719480847397186,0.0 -58.62337980419397,-34.720397973744085,0.0 -58.62267170101404,-34.72152673066758,0.0 -58.62226400524378,-34.7225672898054,0.0 -58.622081615030766,-34.72309638264952,0.0 -58.62267170101404,-34.72336092780184,0.0 -58.623143769800656,-34.722964109755935,0.0 -58.62351927906275,-34.72294647335413,0.0 -58.62393770366907,-34.722664290413626,0.0 -58.62512860447168,-34.72358138144879,0.0 -58.625310994684696,-34.723228655331496,0.0 -58.62497840076684,-34.72244383432122,0.0 -58.625107146799564,-34.72215283137914,0.0 -58.625364638865,-34.72180891749067,0.0 -58.62555775791406,-34.721420910360614,0.0 ",
				"Polygon Outer Boundary",
				"2357",
				"0700159",
				"La Matanza",
				"Rafael Castillo",
				"0159",
				"2015/10/21",
				"9 de Mayo II",
				"Asentamiento Precario",
				"2014",
				"150",
				"7.1299999999999999000000000000000",
				"Garcia Merou &  Arroyo Dupuy",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.60405230894684,-34.408795063647524,0.0 -58.60426688566804,-34.4113442789505,0.0 -58.60656285658479,-34.41029981818628,0.0 -58.60884189605713,-34.40933500809591,0.0 -58.60887408256531,-34.4095031868024,0.0 -58.60974311828613,-34.40953859280279,0.0 -58.60980749130249,-34.40751157515049,0.0 -58.60889554023743,-34.40750272343731,0.0 -58.60889554023743,-34.406635251002065,0.0 -58.60405230894684,-34.408795063647524,0.0 ",
				"Polygon Outer Boundary",
				"682",
				"0570034",
				"Tigre",
				"Rincon De Milberg",
				"0034",
				"2014/10/01",
				"Juan Pablo II",
				"Asentamiento Precario",
				"90_o_anterior",
				"200",
				"14.6199999999999990000000000000000",
				"5 de Abril, Jose Ingenieros, Carriego, Ameghino",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-62.223592288792126,-38.715719680046305,0.0 -62.223527915775776,-38.71590384773008,0.0 -62.21889305859804,-38.71975451788064,0.0 -62.219729907810695,-38.72040743702988,0.0 -62.220523841679096,-38.71985496736879,0.0 -62.22327042371034,-38.72191415076153,0.0 -62.227325923740864,-38.71885046613392,0.0 -62.223592288792126,-38.715719680046305,0.0 ",
				"Polygon Outer Boundary",
				"1522",
				"0070031",
				"Bahia Blanca",
				"Bahia Blanca",
				"0031",
				"2015/04/13",
				"9 de Noviembre",
				"Otros",
				"90_o_anterior",
				"530",
				"23.8000000000000010000000000000000",
				"Fragata Sarmiento, Punta Alta, Los Naranjos, Parera",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.22795272246003,-38.7192941225868,0.0 -62.22603226080536,-38.7207087823176,0.0 -62.22725534811616,-38.72171325743277,0.0 -62.22907925024629,-38.720156314986106,0.0 -62.22795272246003,-38.7192941225868,0.0 ",
				"Polygon Outer Boundary",
				"1521",
				"0070030",
				"Bahia Blanca",
				"Bahia Blanca",
				"0030",
				"2015/04/13",
				"Altos Sánchez",
				"Asentamiento Precario",
				"2013",
				"45",
				"3.3799999999999999000000000000000",
				"Rawson y Parera",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.20071841031313,-38.72368868397116,0.0 -62.20151687040924,-38.72289349765176,0.0 -62.19934964552522,-38.72105197956983,0.0 -62.19806218519807,-38.71999727056865,0.0 -62.197139505296946,-38.72079248911646,0.0 -62.195980791002505,-38.7215542164803,0.0 -62.19722080975771,-38.722667495714546,0.0 -62.19825077801942,-38.72184718638137,0.0 -62.19951678067446,-38.722767941108216,0.0 -62.1983366087079,-38.723588239871724,0.0 -62.20078278332949,-38.725479913367174,0.0 -62.20170546323061,-38.724659636319736,0.0 -62.20071841031313,-38.72368868397116,0.0 ",
				"Polygon Outer Boundary",
				"1524",
				"0070033",
				"Bahia Blanca",
				"Bahia Blanca",
				"0033",
				"2015/04/13",
				"17 de Agosto",
				"Asentamiento Precario",
				"decada_2000",
				"116",
				"11.3300000000000000000000000000000",
				"Patagones, Pilcanyén, Laferrere y Leuman",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.46429765224456,-34.794338638302044,0.0 -58.463101387023926,-34.79368665278802,0.0 -58.46260786056518,-34.79344876489792,0.0 -58.461851477622986,-34.793034662118735,0.0 -58.46135795116424,-34.79363378887176,0.0 -58.46214652061462,-34.79403467272414,0.0 -58.463863134384155,-34.79489370298771,0.0 -58.46429765224456,-34.794338638302044,0.0 ",
				"Polygon Outer Boundary",
				"1207",
				"0300019",
				"Esteban Echeverria",
				"9 De Abril",
				"0019",
				"2014/10/01",
				"Los Niños",
				"Asentamiento Precario",
				"90_o_anterior",
				"44",
				"2.0699999999999998000000000000000",
				"Monte Grande, Tarulli, Rafal de Sanzio y Joaquín V González",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.475836515426636,-34.78693301310244,0.0 -58.476319313049316,-34.78637789483235,0.0 -58.47591698169708,-34.78616642022288,0.0 -58.47547709941863,-34.78593732211742,0.0 -58.47506940364838,-34.78572144062803,0.0 -58.47468852996826,-34.78550115281149,0.0 -58.474602699279785,-34.785602485280165,0.0 -58.475396633148186,-34.786007813909954,0.0 -58.47501575946807,-34.7865012547708,0.0 -58.475836515426636,-34.78693301310244,0.0 ",
				"Polygon Outer Boundary",
				"1527",
				"0300035",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0035",
				"2015/04/13",
				"Parish Roberston",
				"Asentamiento Precario",
				"2009",
				"21",
				"0.7900000000000000400000000000000",
				"Prayones, Petraca, Insua y Sastre",
				"Inexistente",
				"Sin dato",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.4706437587738,-34.79070859935054,0.0 -58.47586333751678,-34.79348400759161,0.0 -58.47723662853241,-34.791721854455204,0.0 -58.47444713115692,-34.7902372112108,0.0 -58.473926782608025,-34.79092446778606,0.0 -58.47143769264221,-34.78968652071915,0.0 -58.4706437587738,-34.79070859935054,0.0 ",
				"Polygon Outer Boundary",
				"1528",
				"0300036",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0036",
				"2015/04/13",
				"Puerto Argentino",
				"Otros",
				"90_o_anterior",
				"450",
				"10.7500000000000000000000000000000",
				"Puerto Deseado, Zuviria, Ing. Huergo y Luis de Sarro",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.492369651794434,-34.77123846767704,0.0 -58.48699450492859,-34.768550444315196,0.0 -58.48468780517579,-34.771617427863454,0.0 -58.490073680877686,-34.77434060220466,0.0 -58.492369651794434,-34.77123846767704,0.0 ",
				"Polygon Outer Boundary",
				"1219",
				"0300007",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0007",
				"2014/10/01",
				"San Agustin",
				"Asentamiento Precario",
				"90_o_anterior",
				"600",
				"23.2300000000000000000000000000000",
				"Huergo, Paz, Moreno y Fiambala",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.47814857959747,-34.84117558599726,0.0 -58.480015397071845,-34.8386483478616,0.0 -58.47939848899841,-34.83832253102712,0.0 -58.47754776477814,-34.840876195983924,0.0 -58.47814857959747,-34.84117558599726,0.0 ",
				"Polygon Outer Boundary",
				"1529",
				"0300037",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0037",
				"2015/04/14",
				"Santa Evita",
				"Asentamiento Precario",
				"2007",
				"25",
				"2.1600000000000001000000000000000",
				"Arentales entre Mendel y Dreyer y Arroyo Ortega",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.490143418312066,-34.78242587345964,0.0 -58.49545955657958,-34.7850209233322,0.0 -58.49585384130478,-34.784492227094034,0.0 -58.49314246326686,-34.78313522457177,0.0 -58.48899543285369,-34.78105561894649,0.0 -58.488603830337524,-34.781562307350995,0.0 -58.490143418312066,-34.78242587345964,0.0 ",
				"Polygon Outer Boundary",
				"1530",
				"0300038",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0038",
				"2015/04/14",
				"Zaizar",
				"Otros",
				"90_o_anterior",
				"170",
				"5.2900000000000000000000000000000",
				"Los Andes, El Garreador, Duclout, Ing. Huergo",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.499370217323296,-34.75178137164785,0.0 -58.4954810142517,-34.75703942640686,0.0 -58.4976633710003,-34.7581110835773,0.0 -58.50086688995361,-34.75980274594319,0.0 -58.50480437278747,-34.75451842265226,0.0 -58.499370217323296,-34.75178137164785,0.0 ",
				"Polygon Outer Boundary",
				"1214",
				"0300012",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0012",
				"2014/10/01",
				"San Pantaleón",
				"Asentamiento Precario",
				"90_o_anterior",
				"380",
				"39.8599999999999990000000000000000",
				"Amicis, Av. del Sur, Defoe y E Salgari",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.753289580345154,-34.54876716818564,0.0 -58.75372426584362,-34.54845788173726,0.0 -58.75252263620496,-34.547344441004974,0.0 -58.752082753926516,-34.54767140530474,0.0 -58.753289580345154,-34.54876716818564,0.0 ",
				"Polygon Outer Boundary",
				"2108",
				"1320052",
				"Jose C. Paz",
				"Jose C. Paz",
				"0052",
				"2015/08/13",
				"Parque Jardín II",
				"Asentamiento Precario",
				"90_o_anterior",
				"80",
				"0.8800000000000000000000000000000",
				"Pichincha, Int. Arricau,",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-62.22133923321962,-38.72057485123549,0.0 -62.21588898450136,-38.724776819331616,0.0 -62.218657024204724,-38.7269865201464,0.0 -62.22286272794008,-38.723705424640656,0.0 -62.223635204136365,-38.724257864534295,0.0 -62.22485829144716,-38.72335386975731,0.0 -62.22339916974306,-38.72206482038748,0.0 -62.22224045544862,-38.72131146908096,0.0 -62.22133923321962,-38.72057485123549,0.0 ",
				"Polygon Outer Boundary",
				"1523",
				"0070032",
				"Bahia Blanca",
				"Bahia Blanca",
				"0032",
				"2015/04/13",
				"Stella Maris",
				"Asentamiento Precario",
				"90_o_anterior",
				"210",
				"24.3200000000000000000000000000000",
				"El Caldén, Misioneros, Punta Alta y Rawson",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.30095112323761,-34.7880520496864,0.0 -58.299974799156196,-34.788232680152724,0.0 -58.29923987388611,-34.788699674158956,0.0 -58.299400806427,-34.789206315609064,0.0 -58.299760222435,-34.78959840989922,0.0 -58.30005526542664,-34.789911202883836,0.0 -58.300302028656006,-34.79005217961581,0.0 -58.300559520721436,-34.79017112854596,0.0 -58.30092430114746,-34.79047951386217,0.0 -58.300897479057305,-34.79116676841814,0.0 -58.30074727535248,-34.79159409688881,0.0 -58.30053269863128,-34.79192009856293,0.0 -58.30048978328705,-34.79220204491745,0.0 -58.3007526397705,-34.79309633713254,0.0 -58.30092966556549,-34.79366462616037,0.0 -58.3009704746064,-34.7940960758552,0.0 -58.3009835293483,-34.7946665963167,0.0 -58.3010552532938,-34.7950763403305,0.0 -58.3009299294203,-34.7957172705269,0.0 -58.3008897088201,-34.7961300055409,0.0 -58.3011674749177,-34.7964221522524,0.0 -58.3012061720841,-34.7968906794651,0.0 -58.3009566219705,-34.7973384270023,0.0 -58.3008208565637,-34.7976546262829,0.0 -58.3011911211513,-34.798244889534,0.0 -58.301338605289,-34.7987209615051,0.0 -58.3017055568201,-34.7991992707702,0.0 -58.302007913589485,-34.7995014766654,0.0 -58.302163481712334,-34.79961160194836,0.0 -58.302404880523675,-34.7998406620657,0.0 -58.30265700817108,-34.79976577709736,0.0 -58.302163481712334,-34.79912264456857,0.0 -58.301294445991516,-34.79801256840033,0.0 -58.3012702683452,-34.7976667182339,0.0 -58.3013468590948,-34.7971428723491,0.0 -58.3014516948758,-34.7965375955481,0.0 -58.3013546971993,-34.7959476445594,0.0 -58.3013745234478,-34.7951875563328,0.0 -58.3011971628114,-34.7938554597444,0.0 -58.3009552514439,-34.792008975059,0.0 -58.3010502086177,-34.7915554273969,0.0 -58.3011663657133,-34.790979061404,0.0 -58.301117420196526,-34.79073503225055,0.0 -58.30126225948333,-34.79055440726492,0.0 -58.301401734352105,-34.79036497087933,0.0 -58.30157876014709,-34.790179939571,0.0 -58.3000837417633,-34.789274141448,0.0 -58.3008363563943,-34.7886558329984,0.0 -58.30095112323761,-34.7880520496864,0.0 ",
				"Polygon Outer Boundary",
				"884",
				"0860064",
				"Quilmes",
				"San Francisco Solano",
				"0064",
				"2014/10/01",
				"Los Eucaliptos de Solano",
				"Villa",
				"90_o_anterior",
				"180",
				"5.7000000000000002000000000000000",
				"Arroyo Las Piedras de Donato Alvarez a Monteverde",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.546931147575386,-34.46212650201316,0.0 -58.53906691074371,-34.458358050887014,0.0 -58.538852334022515,-34.45868978756717,0.0 -58.5395336151123,-34.459017099799794,0.0 -58.53924930095672,-34.459370949418705,0.0 -58.5395470282865,-34.4595106078595,0.0 -58.54238748550415,-34.46087921659967,0.0 -58.54529500007629,-34.46225919085411,0.0 -58.54551494121551,-34.46186996965598,0.0 -58.54667901992798,-34.46242284013418,0.0 -58.546931147575386,-34.46212650201316,0.0 ",
				"Polygon Outer Boundary",
				"882",
				"0970002",
				"San Isidro",
				"San Isidro",
				"0002",
				"2014/10/01",
				"Uruguay",
				"Villa",
				"decada_1960",
				"680",
				"6.4699999999999998000000000000000",
				"Uruguay, Av. Rolón, 12 de Octubre, Pje Granados",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.773990869522095,-34.57101068524938,0.0 -58.77085804939269,-34.56815271534228,0.0 -58.7681221961975,-34.57020675310337,0.0 -58.77191483974457,-34.57371396050397,0.0 -58.77330422401428,-34.572653863036834,0.0 -58.773990869522095,-34.57101068524938,0.0 ",
				"Polygon Outer Boundary",
				"1705",
				"0740054",
				"Moreno",
				"Tujui",
				"0054",
				"2015/05/15",
				"Cabaña Santa Brígida",
				"Asentamiento Precario",
				"90_o_anterior",
				"400",
				"17.0100000000000020000000000000000",
				"Discepolo - Watt - Pirovano - Arroyo",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-62.2869045753032,-38.70137407111294,0.0 -62.28688311763108,-38.701369884638304,0.0 -62.28678655810654,-38.70135732521294,0.0 -62.28635204024612,-38.701729920560894,0.0 -62.28645932860673,-38.70176759863406,0.0 -62.28681338019668,-38.701859700507136,0.0 -62.28718352504075,-38.70202297171788,0.0 -62.287408830598,-38.70210251396755,0.0 -62.28766632266343,-38.70186807339881,0.0 -62.287231804803014,-38.701545716361835,0.0 -62.2869045753032,-38.70137407111294,0.0 ",
				"Polygon Outer Boundary",
				"1525",
				"0070034",
				"Bahia Blanca",
				"Bahia Blanca",
				"0034",
				"2015/04/13",
				"San Roque",
				"Otros",
				"90_o_anterior",
				"16",
				"0.4600000000000000200000000000000",
				"Cuyo y Zelarrayán",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.325305581092834,-34.789272399047015,0.0 -58.32408693619072,-34.7886600238272,0.0 -58.323571952059865,-34.78935169910266,0.0 -58.32453218288719,-34.789549948908146,0.0 -58.324918420985334,-34.789757009307294,0.0 -58.325305581092834,-34.789272399047015,0.0 ",
				"Polygon Outer Boundary",
				"2109",
				"0030086",
				"Almirante Brown",
				"Solano",
				"0086",
				"2015/08/13",
				"8 de Agosto",
				"Villa",
				"1980",
				"75",
				"0.9399999999999999500000000000000",
				"Caléndula, Cala, Tulipán y Nardo",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-61.10245490446687,-36.23404485179289,0.0 -61.09888220205903,-36.23101590073952,0.0 -61.09565282240509,-36.233447725013804,0.0 -61.099322084337466,-36.23658042630339,0.0 -61.10245490446687,-36.23404485179289,0.0 ",
				"Polygon Outer Boundary",
				"1706",
				"0110001",
				"Bolivar",
				"Bolivar",
				"0001",
				"2015/05/15",
				"Villa Diamante",
				"Otros",
				"decada_1950",
				"300",
				"18.7899999999999990000000000000000",
				"Miguens y Castells",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.555016935802996,-38.02536424867009,0.0 -57.554724575020366,-38.024988155365264,0.0 -57.55468970630318,-38.02497547802923,0.0 -57.55459851119667,-38.024827575613315,0.0 -57.55459851119667,-38.024776866144855,0.0 -57.554341019131236,-38.02447260859702,0.0 -57.55392795894295,-38.02469023738836,0.0 -57.55385285709053,-38.02459515692797,0.0 -57.5534344324842,-38.02480222088347,0.0 -57.553775073029094,-38.025220572803995,0.0 -57.55360609386116,-38.02527762060808,0.0 -57.553254724480205,-38.02545298950546,0.0 -57.552994550205774,-38.02514028322669,0.0 -57.552771926857524,-38.02524592738907,0.0 -57.553026736713946,-38.02557976194096,0.0 -57.55323058459907,-38.02565371242705,0.0 -57.55286043975502,-38.025843870477104,0.0 -57.55282557103783,-38.025890353480946,0.0 -57.553201080299914,-38.026350956197746,0.0 -57.55323058459907,-38.026338279097494,0.0 -57.55353367421775,-38.02619671799578,0.0 -57.55368656013161,-38.02637419754249,0.0 -57.55469507072121,-38.025877676301,0.0 -57.55451536271721,-38.02562835798309,0.0 -57.555016935802996,-38.02536424867009,0.0 ",
				"Polygon Outer Boundary",
				"1357",
				"0450070",
				"General Pueyrredon",
				"Mar Del Plata",
				"0070",
				"2015/02/06",
				"Paso",
				"Villa",
				"decada_1970",
				"75",
				"2.2500000000000000000000000000000",
				"Sarmiento, Vieytes, Las Heras, Alsina",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.10357809066773,-34.99342366885038,0.0 -58.1022423505783,-34.99221513746754,0.0 -58.101174831390374,-34.99126587848714,0.0 -58.10067594051362,-34.99081321870804,0.0 -58.100316524505615,-34.99048800528266,0.0 -58.10142695903778,-34.98963101777054,0.0 -58.10032725334167,-34.98866854417599,0.0 -58.10000002384186,-34.98891465722224,0.0 -58.099334836006165,-34.98942006562227,0.0 -58.09868574142456,-34.988897077743474,0.0 -58.09825658798217,-34.98857185670536,0.0 -58.0981707572937,-34.98891465722224,0.0 -58.09866428375244,-34.98940688109494,0.0 -58.09625029563904,-34.991199957315814,0.0 -58.098176121711724,-34.992839181355215,0.0 -58.1004559993744,-34.99112964134123,0.0 -58.103266954422,-34.993700529891264,0.0 -58.10357809066773,-34.99342366885038,0.0 ",
				"Polygon Outer Boundary",
				"362",
				"0550088",
				"La Plata",
				"Abasto",
				"0088",
				"2014/10/15",
				"516bis & 220",
				"Asentamiento Precario",
				"2007",
				"165",
				"12.1199999999999990000000000000000",
				"216, 220, 516, 516bis",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.52482861373574,-34.519072637918015,0.0 -58.524489104747765,-34.518922359628554,0.0 -58.52440327405929,-34.5190483282131,0.0 -58.524729372002184,-34.51919197636653,0.0 -58.52482861373574,-34.519072637918015,0.0 ",
				"Polygon Outer Boundary",
				"1797",
				"1100030",
				"Vicente Lopez",
				"Carapachay",
				"0030",
				"2015/06/24",
				"El Conventillo",
				"Villa",
				"90_o_anterior",
				"20",
				"0.0599999999999999980000000000000",
				"Av. Mitre 3531",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.83432984352111,-34.61106492834361,0.0 -58.83496284484863,-34.61045123284339,0.0 -58.83419036865234,-34.609952325964265,0.0 -58.833879232406616,-34.61024372326668,0.0 -58.83380413055419,-34.61020398733112,0.0 -58.83351445198059,-34.610508629017716,0.0 -58.83432984352111,-34.61106492834361,0.0 ",
				"Polygon Outer Boundary",
				"2233",
				"0740068",
				"Moreno",
				"La Reja",
				"0068",
				"2015/09/23",
				"13 de Diciembre y Los Aromos",
				"Asentamiento Precario",
				"2010",
				"20",
				"0.8299999999999999600000000000000",
				"13 de Diciembre, Los Aromos, Comodoro Rivadavia",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.55966365337371,-38.04134009227539,0.0 -57.55017936229705,-38.04299620888777,0.0 -57.55037248134613,-38.04313140042698,0.0 -57.55356967449188,-38.042594857535306,0.0 -57.55418121814728,-38.04240896774243,0.0 -57.5544548034668,-38.04244276592169,0.0 -57.55567252635955,-38.04226110052475,0.0 -57.55611777305602,-38.04219772876862,0.0 -57.557233572006226,-38.041978039589395,0.0 -57.55856394767761,-38.041745675317216,0.0 -57.55969047546387,-38.041572457834604,0.0 -57.55988895893096,-38.04151753513261,0.0 -57.560216188430786,-38.0414710620449,0.0 -57.560591697692864,-38.041403464773765,0.0 -57.561010122299194,-38.04132741776913,0.0 -57.56121397018432,-38.04129361907507,0.0 -57.56203472614288,-38.04109082658304,0.0 -57.56276965141296,-38.0408626843582,0.0 -57.56359577178956,-38.04050357015692,0.0 -57.56442725658417,-38.040055731156045,0.0 -57.56462037563323,-38.04003460660723,0.0 -57.565516233444214,-38.03943889182173,0.0 -57.56512773223221,-38.03925299401716,0.0 -57.56436288356782,-38.039814910938325,0.0 -57.563021779060364,-38.04027120120588,0.0 -57.562807202339165,-38.040368373766015,0.0 -57.56264090538025,-38.04024162692285,0.0 -57.56165921688079,-38.04096408099033,0.0 -57.561036944389336,-38.041111950827165,0.0 -57.5605434179306,-38.04123024648164,0.0 -57.55966365337371,-38.04134009227539,0.0 ",
				"Polygon Outer Boundary",
				"1332",
				"0450051",
				"General Pueyrredon",
				"Mar Del Plata",
				"0051",
				"2015/02/03",
				"Vertiz",
				"Villa",
				"90_o_anterior",
				"450",
				"3.7400000000000002000000000000000",
				"Av. Vertiz, Cerrito,Tomas Alva Edison",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.56043386645615,-37.93843119342631,0.0 -57.559859873726964,-37.93796580773405,0.0 -57.559806229546666,-37.9379742693184,0.0 -57.55856704898178,-37.93893465281145,0.0 -57.55826127715408,-37.938909268387185,0.0 -57.55752098746597,-37.93827465493144,0.0 -57.55744588561356,-37.93827888570596,0.0 -57.55356431007386,-37.94112614172003,0.0 -57.55359804723411,-37.9410944121345,0.0 -57.55383026786148,-37.941274212938076,0.0 -57.55453300662338,-37.94084269027045,0.0 -57.555074812844396,-37.94129959654549,0.0 -57.55526793189347,-37.94143920622961,0.0 -57.555106999352574,-37.941540740378734,0.0 -57.554624201729894,-37.94188764766317,0.0 -57.55462956614792,-37.94192572275319,0.0 -57.554865600541234,-37.94211609790741,0.0 -57.55503189750016,-37.942230322763216,0.0 -57.55437743850052,-37.94273375612313,0.0 -57.554849507287145,-37.94310181026268,0.0 -57.55490851588547,-37.94310604075931,0.0 -57.559282779693596,-37.939793487332444,0.0 -57.55913794040679,-37.939662335912004,0.0 -57.5589770078659,-37.93953118425753,0.0 -57.55976557731628,-37.93894311428424,0.0 -57.56037712097168,-37.9384523472514,0.0 -57.56043386645615,-37.93843119342631,0.0 ",
				"Polygon Outer Boundary",
				"1336",
				"0450055",
				"General Pueyrredon",
				"Mar Del Plata",
				"0055",
				"2015/02/04",
				"Zeballos & Los Granados",
				"Asentamiento Precario",
				"90_o_anterior",
				"180",
				"12.0100000000000000000000000000000",
				"Zeballos, Los Granados, Vuelta de Obligado, Bautista Laureano",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.633388193639,-34.7472765236074,0.0 -58.6345781078915,-34.7482856624755,0.0 -58.637086304125,-34.7462779265166,0.0 -58.63718748092651,-34.746240879653435,0.0 -58.638432025909424,-34.745200618555984,0.0 -58.63967120647431,-34.74422205590508,0.0 -58.641387820243835,-34.74286439122802,0.0 -58.64056706428528,-34.74217673437264,0.0 -58.63882899284363,-34.7434726982903,0.0 -58.637273311615,-34.74217232629742,0.0 -58.63631308078766,-34.74141413385886,0.0 -58.63515436649322,-34.74241036202318,0.0 -58.63603413105011,-34.74316854531905,0.0 -58.6347335305317,-34.7442360138574,0.0 -58.6359231964584,-34.7452454071257,0.0 -58.6358963864829,-34.7452688120069,0.0 -58.633388193639,-34.7472765236074,0.0 ",
				"Polygon Outer Boundary",
				"1026",
				"0700104",
				"La Matanza",
				"González Catán",
				"0104",
				"2014/10/01",
				"Primavera II",
				"Asentamiento Precario",
				"90_o_anterior",
				"315",
				"19.6499999999999990000000000000000",
				"Doblas, Lujan, Riglos, de Achega y Lavalleja",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7017854608459,-34.6503788016572,0.0 -58.7023890800288,-34.6508815123788,0.0 -58.702535370125,-34.651005923664,0.0 -58.7032175873442,-34.6515610241348,0.0 -58.7032571573969,-34.6515625266325,0.0 -58.7036617351493,-34.6512455868541,0.0 -58.7039118465838,-34.651048866651,0.0 -58.7040894093008,-34.6509091515438,0.0 -58.7042332678413,-34.6507764690638,0.0 -58.704521360999,-34.6505429253343,0.0 -58.7047628334581,-34.6503473734156,0.0 -58.7049870654397,-34.6501662398022,0.0 -58.7051381233043,-34.6500613943585,0.0 -58.7052534252331,-34.6499622982225,0.0 -58.7053639986308,-34.6498662645731,0.0 -58.7053815493478,-34.6498522514768,0.0 -58.7054511940958,-34.6497924200186,0.0 -58.7055448407888,-34.6497111207313,0.0 -58.7055963751484,-34.6496656086979,0.0 -58.7058671781784,-34.6494492742174,0.0 -58.70588957889,-34.6494395970945,0.0 -58.706068932544,-34.6493105339702,0.0 -58.7063654798294,-34.649065718372,0.0 -58.7063564258979,-34.6490587720201,0.0 -58.7063783567961,-34.6490442225103,0.0 -58.7063831560021,-34.6490020900787,0.0 -58.7060388764975,-34.6487109049706,0.0 -58.705391371787,-34.648147175148,0.0 -58.705295426006,-34.6480537676054,0.0 -58.7052501349394,-34.6480204773868,0.0 -58.7052205706067,-34.6480349456344,0.0 -58.7049082566817,-34.6477717683901,0.0 -58.7046431397561,-34.6479943805808,0.0 -58.7044219131805,-34.6481789707612,0.0 -58.7042806967354,-34.6483033891996,0.0 -58.7041995144529,-34.6483547148016,0.0 -58.7037499776649,-34.6487021852762,0.0 -58.7037479392583,-34.6487280324465,0.0 -58.7036887084885,-34.6487799037424,0.0 -58.7035417133292,-34.6489086342168,0.0 -58.7033236031031,-34.649081898406,0.0 -58.7032227289863,-34.6491509508379,0.0 -58.7031659666532,-34.649188925021,0.0 -58.7028253317254,-34.6494556172193,0.0 -58.7027217903575,-34.6495487971085,0.0 -58.7025997945491,-34.6496713449122,0.0 -58.7023806637831,-34.6498468498695,0.0 -58.7021476499429,-34.6500452812703,0.0 -58.7019965171601,-34.6501686900365,0.0 -58.7017912810282,-34.6503273062445,0.0 -58.7017854608459,-34.6503788016572,0.0 ",
				"Polygon Outer Boundary",
				"17",
				"1360016",
				"Ituzaingo",
				"Ituzaingó Norte",
				"0016",
				"2014/09/01",
				"La Esperanza",
				"Otros",
				"1985",
				"242",
				"7.9400000000000004000000000000000",
				"Cnel. Pringles,Camerucci, Portugal, Republica de El Salvador",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.30775320529938,-34.805368746851336,0.0 -58.30776393413543,-34.804659586983114,0.0 -58.30677151679993,-34.80465077750539,0.0 -58.30617556348444,-34.80430720713967,0.0 -58.30593466758727,-34.80372577710443,0.0 -58.30487251281738,-34.80300338862005,0.0 -58.30421805381774,-34.80227218407278,0.0 -58.30373525619506,-34.8017524082216,0.0 -58.30359578132629,-34.80141763559916,0.0 -58.304121494293206,-34.801179770014926,0.0 -58.303327560424805,-34.800457359218136,0.0 -58.30270528793335,-34.79993757192374,0.0 -58.30076336860657,-34.8020343209544,0.0 -58.302630186080926,-34.801717169062215,0.0 -58.30333828926087,-34.80325886819786,0.0 -58.30297350883483,-34.8033733932688,0.0 -58.30546259880066,-34.80487101416606,0.0 -58.30629944801331,-34.80531589042564,0.0 -58.30775320529938,-34.805368746851336,0.0 ",
				"Polygon Outer Boundary",
				"1660",
				"0320046",
				"Florencio Varela",
				"Florencio Varela",
				"0046",
				"2015/05/04",
				"Arroyo Las Piedras Sur (Km 26)",
				"Asentamiento Precario",
				"90_o_anterior",
				"170",
				"9.8100000000000005000000000000000",
				"La Yerra, El molino, El cacique, El Bayo",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.458058834075935,-34.84857193464135,0.0 -58.45532298088074,-34.84714554771043,0.0 -58.45445394515992,-34.84823735227217,0.0 -58.45574140548707,-34.848888906157256,0.0 -58.456352949142456,-34.848184523352685,0.0 -58.46054792404175,-34.85031526286938,0.0 -58.46079468727111,-34.84996307832563,0.0 -58.458058834075935,-34.84857193464135,0.0 ",
				"Polygon Outer Boundary",
				"1977",
				"0300049",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0049",
				"2015/07/24",
				"San Nicolas",
				"Asentamiento Precario",
				"90_o_anterior",
				"80",
				"4.0800000000000001000000000000000",
				"Colon, Villegas y Daireaux",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.344692587852485,-34.77143235450145,0.0 -58.34592640399933,-34.77007954375061,0.0 -58.34645211696625,-34.769511092225585,0.0 -58.346012234687805,-34.76929516775203,0.0 -58.34637701511382,-34.76884569050535,0.0 -58.34598004817962,-34.7685945109778,0.0 -58.345284224487834,-34.7682089268823,0.0 -58.34451443050057,-34.769132122367026,0.0 -58.34268093109131,-34.77130015898875,0.0 -58.34190845489501,-34.77214620661074,0.0 -58.342210412956774,-34.77230704280769,0.0 -58.34283804986626,-34.77264854328236,0.0 -58.343340754508965,-34.772926149078486,0.0 -58.344692587852485,-34.77143235450145,0.0 ",
				"Polygon Outer Boundary",
				"1978",
				"0030058",
				"Almirante Brown",
				"San José",
				"0058",
				"2015/07/24",
				"Agustín Ramírez",
				"Asentamiento Precario",
				"1989",
				"370",
				"8.3900000000000006000000000000000",
				"Tierra del Fuego, Bartolomé Mitre, El Picaflor, El Benteveo y Tomás Nother",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.507563420935185,-34.750646216199726,0.0 -58.50217754523327,-34.7479222601676,0.0 -58.501297780676396,-34.74912116450596,0.0 -58.50670511405041,-34.751827450759464,0.0 -58.507563420935185,-34.750646216199726,0.0 ",
				"Polygon Outer Boundary",
				"1976",
				"0300048",
				"Esteban Echeverria",
				"9 De Abril",
				"0048",
				"2015/07/24",
				"El Gauchito Gil",
				"Asentamiento Precario",
				"2006",
				"140",
				"8.9399999999999995000000000000000",
				"San Clemente, Maipú, Moreno y Huergo",
				"Sin dato",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.80577504634857,-34.53366381052439,0.0 -58.80585551261902,-34.533327952820294,0.0 -58.804686069488525,-34.532563429573585,0.0 -58.80393505096435,-34.53203753956583,0.0 -58.80381703376769,-34.53217011719182,0.0 -58.80315721035004,-34.53174586804556,0.0 -58.80181074142456,-34.530822234824505,0.0 -58.79999756813049,-34.53266949102141,0.0 -58.80577504634857,-34.53366381052439,0.0 ",
				"Polygon Outer Boundary",
				"2226",
				"0740061",
				"Moreno",
				"Cuartel V",
				"0061",
				"2015/09/23",
				"Anderson",
				"Otros",
				"1998",
				"170",
				"7.1100000000000003000000000000000",
				"San Fernando, Rio de la Plata, Av. Derqui",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.32774639129638,-34.72171632504551,0.0 -58.324865698814385,-34.71911046656578,0.0 -58.32413613796234,-34.71966162791477,0.0 -58.32476913928985,-34.72023483182044,0.0 -58.3239483833313,-34.72082125939622,0.0 -58.32310080528259,-34.72174278004043,0.0 -58.325220588594675,-34.72332565516377,0.0 -58.32774639129638,-34.72171632504551,0.0 ",
				"Polygon Outer Boundary",
				"1427",
				"0860073",
				"Quilmes",
				"Quilmes",
				"0073",
				"2015/03/03",
				"Barracas de Cambaceres",
				"Asentamiento Precario",
				"2003",
				"415",
				"9.6199999999999992000000000000000",
				"Lynch, 173, Pilcomayo, 171, Neuquén y Heredia",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.37941193953156,-34.92426700028937,0.0 -58.3792939223349,-34.924161440129225,0.0 -58.379208091646426,-34.924205423545786,0.0 -58.36727762594819,-34.94051284920359,0.0 -58.37224507704378,-34.942984187975625,0.0 -58.377373460680246,-34.94528835845401,0.0 -58.380060195922844,-34.92457488331415,0.0 -58.37941193953156,-34.92426700028937,0.0 ",
				"Polygon Outer Boundary",
				"1801",
				"1290002",
				"Pte. Peron",
				"Guernica",
				"0002",
				"2015/06/26",
				"Parque Americano",
				"Otros",
				"90_o_anterior",
				"2400",
				"122.6800000000000100000000000000000",
				"Av. Antartida, Gral. San Martín, Sto. Domingo",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-60.96772670745849,-34.589622632711695,0.0 -60.97343444824219,-34.591300771468035,0.0 -60.96963644027709,-34.58805045091512,0.0 -60.96772670745849,-34.589622632711695,0.0 ",
				"Polygon Outer Boundary",
				"1707",
				"0540004",
				"Junin",
				"Junin",
				"0004",
				"2015/05/15",
				"El Triangulo",
				"Asentamiento Precario",
				"decada_1970",
				"45",
				"6.2100000000000000000000000000000",
				"Intendente de la Sota - P. Bauman y Vías del Ferrocarril",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.63994252867997,-34.39545467374747,0.0 -58.63986742682755,-34.395392702806525,0.0 -58.63965821452438,-34.39540598229774,0.0 -58.6394436378032,-34.395366143817796,0.0 -58.63919687457383,-34.395366143817796,0.0 -58.63904667086899,-34.39543696776903,0.0 -58.638960840180516,-34.39558746846639,0.0 -58.63895011134445,-34.39568485112637,0.0 -58.63873017020523,-34.39576452776386,0.0 -58.6386336106807,-34.39584863079894,0.0 -58.63879990763962,-34.39586633669029,0.0 -58.63895011134445,-34.395897321991136,0.0 -58.63910567946732,-34.39586633669029,0.0 -58.639819147065275,-34.39564943926312,0.0 -58.64001763053238,-34.39557418900398,0.0 -58.63994252867997,-34.39545467374747,0.0 ",
				"Polygon Outer Boundary",
				"1870",
				"0570041",
				"Tigre",
				"Tigre",
				"0041",
				"2015/07/06",
				"Alge II",
				"Asentamiento Precario",
				"2009",
				"25",
				"0.4099999999999999800000000000000",
				"Juan Rocha & Martín Rodríguez",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.60444736573845,-37.95762155558429,0.0 -57.60418987367302,-37.95729587098581,0.0 -57.60406380984932,-37.957352971636695,0.0 -57.60411208961158,-37.95740161289689,0.0 -57.60376072023064,-37.95757925896479,0.0 -57.603961885906756,-37.95784572726101,0.0 -57.60400748346001,-37.95784995690872,0.0 -57.60444736573845,-37.95762155558429,0.0 ",
				"Polygon Outer Boundary",
				"1289",
				"0450013",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Libertad",
				"0013",
				"2015/01/29",
				"Leguizamon & Ituzaingo",
				"Asentamiento Precario",
				"90_o_anterior",
				"20",
				"0.1900000000000000000000000000000",
				"Leguizamon y Ituzaingo",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.61113947723061,-37.95368998071306,0.0 -57.611482799984515,-37.953512325238634,0.0 -57.6112816343084,-37.95327756555985,0.0 -57.61123067233712,-37.95327122069325,0.0 -57.61092490050941,-37.953427727242655,0.0 -57.61113947723061,-37.95368998071306,0.0 ",
				"Polygon Outer Boundary",
				"1291",
				"0450015",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Libertad",
				"0015",
				"2015/01/29",
				"Necochea & Avenida Fermin Errea Doctor",
				"Asentamiento Precario",
				"90_o_anterior",
				"20",
				"0.1200000000000000000000000000000",
				"Necochea y Avenida Fermin Errea Doctor",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.75001192092895,-34.54578029671794,0.0 -58.750483989715576,-34.54546216207882,0.0 -58.74989390373231,-34.544918679257016,0.0 -58.74943256378174,-34.54523239741647,0.0 -58.75001192092895,-34.54578029671794,0.0 ",
				"Polygon Outer Boundary",
				"2111",
				"1320053",
				"Jose C. Paz",
				"Jose C. Paz",
				"0053",
				"2015/08/13",
				"Parque Jardín",
				"Asentamiento Precario",
				"decada_2000",
				"40",
				"0.4500000000000000100000000000000",
				"Int. Arricau, Muñiz",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.606762112118304,-37.954241978909934,0.0 -57.60905540082604,-37.95307664451823,0.0 -57.60882204864174,-37.952786894258914,0.0 -57.608288289047785,-37.95306818467284,0.0 -57.60745143983513,-37.95346156645274,0.0 -57.60731732938438,-37.95349540564723,0.0 -57.60705179069191,-37.953178162586894,0.0 -57.607008875347674,-37.953171817711706,0.0 -57.60690158698708,-37.95322469165481,0.0 -57.60717249009758,-37.95356519893664,0.0 -57.60688012931496,-37.95370690025965,0.0 -57.606952548958354,-37.953755543934356,0.0 -57.60679161641746,-37.95383168179535,0.0 -57.60687208268791,-37.9539564631191,0.0 -57.60659581515939,-37.95409604875549,0.0 -57.606703103519976,-37.95423563412664,0.0 -57.606762112118304,-37.954241978909934,0.0 ",
				"Polygon Outer Boundary",
				"1292",
				"0450016",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Libertad",
				"0016",
				"2015/01/29",
				"Brandsen & Portugal",
				"Asentamiento Precario",
				"90_o_anterior",
				"30",
				"0.9699999999999999700000000000000",
				"Brandsen e/ Portugal y Colombia",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.596778930164874,-37.955944475957324,0.0 -57.59860396385192,-37.955068910975726,0.0 -57.59804606437683,-37.95437944908009,0.0 -57.59625208564102,-37.95526771166998,0.0 -57.596778930164874,-37.955944475957324,0.0 ",
				"Polygon Outer Boundary",
				"1294",
				"0450018",
				"General Pueyrredon",
				"Mar Del Plata",
				"0018",
				"2015/01/29",
				"Río Negro & Bolivia",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"1.6799999999999999000000000000000",
				"Rio Negro, Bolivia, Santa Cruz , Paraguay",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.595174969173975,-37.955375571395976,0.0 -57.59531176183372,-37.955548992584134,0.0 -57.59607350919396,-37.95517254119199,0.0 -57.59489601943642,-37.953740739341114,0.0 -57.59424692485481,-37.95408124423086,0.0 -57.59440517518669,-37.95426735803764,0.0 -57.59451782796532,-37.95421871470184,0.0 -57.59466111660004,-37.954396368467876,0.0 -57.59479141328483,-37.95433080581852,0.0 -57.595124007202685,-37.9547411001452,0.0 -57.59504890535026,-37.95478551331115,0.0 -57.59525543544442,-37.95507525568704,0.0 -57.59515619371087,-37.955130243162195,0.0 -57.59528762195259,-37.955316354311115,0.0 -57.595174969173975,-37.955375571395976,0.0 ",
				"Polygon Outer Boundary",
				"1295",
				"0450019",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Libertad",
				"0019",
				"2015/01/29",
				"Bolivia & Río Negro",
				"Asentamiento Precario",
				"90_o_anterior",
				"30",
				"1.0900000000000001000000000000000",
				"Bolivia, Matias Strobel, Río Negro",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.62583148665726,-37.96894982807309,0.0 -57.62607824988663,-37.96926700300892,0.0 -57.626239182427526,-37.969190881149295,0.0 -57.62633574195206,-37.9691316752039,0.0 -57.626303555443876,-37.96906401120785,0.0 -57.62642693705856,-37.96899634714943,0.0 -57.626303555443876,-37.968835644760745,0.0 -57.6261640805751,-37.96891176698871,0.0 -57.62609970755875,-37.96882295771508,0.0 -57.62583148665726,-37.96894982807309,0.0 ",
				"Polygon Outer Boundary",
				"1297",
				"0450021",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Santa Rosa Lima",
				"0021",
				"2015/01/29",
				"Guayanas & Alberti Manuel",
				"Asentamiento Precario",
				"90_o_anterior",
				"12",
				"0.1400000000000000100000000000000",
				"Guayanas, Alberti Manuel, Esteban Gascón",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.634196877479546,-37.95760040727759,0.0 -57.634705365635455,-37.95826869082542,0.0 -57.635040641762316,-37.95811219459048,0.0 -57.63505137059837,-37.95806355380088,0.0 -57.63455092906952,-37.95743333544053,0.0 -57.634196877479546,-37.95760040727759,0.0 ",
				"Polygon Outer Boundary",
				"1298",
				"0450022",
				"General Pueyrredon",
				"Mar Del Plata - Barrio San Jorge",
				"0022",
				"2015/01/29",
				"Englender & Moreno",
				"Asentamiento Precario",
				"90_o_anterior",
				"5",
				"0.3200000000000000100000000000000",
				"Englender, Moreno, Belgrano",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.68744182772934,-37.99584562102204,0.0 -57.68744182772934,-37.99589635050711,0.0 -57.68806946463882,-37.99639518857482,0.0 -57.6881177444011,-37.996390961147824,0.0 -57.68965733237564,-37.995224181982366,0.0 -57.688992144539945,-37.9946915157577,0.0 -57.68744182772934,-37.99584562102204,0.0 ",
				"Polygon Outer Boundary",
				"1352",
				"0450066",
				"General Pueyrredon",
				"Batan",
				"0066",
				"2015/02/05",
				"El Colmenar",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"2.2500000000000000000000000000000",
				"Monte Malabrigo, Eva Duarte de Perón, Lucio Varela",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.68905115313827,-37.99809882181947,0.0 -57.68873465247453,-37.99832709721295,0.0 -57.68873465247453,-37.998369370355995,0.0 -57.688836576417096,-37.998661054378886,0.0 -57.6885437965393,-37.99888087345566,0.0 -57.689163805916905,-37.99936700945873,0.0 -57.68926572985947,-37.99945578177221,0.0 -57.68953931517898,-37.999248646206944,0.0 -57.68924427218735,-37.99899923730102,0.0 -57.68907261081039,-37.998885100739145,0.0 -57.68908333964646,-37.99883860060745,0.0 -57.68922281451523,-37.99877096399963,0.0 -57.689276458695524,-37.99876673670958,0.0 -57.68957150168717,-37.998546917290696,0.0 -57.68905115313827,-37.99809882181947,0.0 ",
				"Polygon Outer Boundary",
				"1352",
				"0450066",
				"General Pueyrredon",
				"Batan",
				"0066",
				"2015/02/05",
				"El Colmenar",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"2.2500000000000000000000000000000",
				"Monte Malabrigo, Eva Duarte de Perón, Lucio Varela",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.61044633574784,-38.01892391255,0.0 -57.60942173190415,-38.01910140971291,0.0 -57.60918033309281,-38.019456402749036,0.0 -57.60918033309281,-38.01948175932867,0.0 -57.609673859551556,-38.019879011264194,0.0 -57.609743596985936,-38.019891689482,0.0 -57.6098991651088,-38.019752228965544,0.0 -57.61006009764969,-38.01987055911778,0.0 -57.61027467437088,-38.02006073217644,0.0 -57.61042487807572,-38.01992127198167,0.0 -57.609609486535184,-38.01924087146791,0.0 -57.610499979928136,-38.01910140971291,0.0 -57.61044633574784,-38.01892391255,0.0 ",
				"Polygon Outer Boundary",
				"1315",
				"0450035",
				"General Pueyrredon",
				"Mar Del Plata- Barrio La Heras",
				"0035",
				"2015/02/02",
				"Martinez de Hoz & Colectora Norte Via",
				"Villa",
				"90_o_anterior",
				"12",
				"0.5999999999999999800000000000000",
				"Florencio Martinez de Hoz, Colectora Norte Via, Napoles",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.622495950199664,-37.95294128687509,0.0 -57.62371635530143,-37.95230679459826,0.0 -57.62302166316658,-37.9517272868637,0.0 -57.62196063995361,-37.95226660990286,0.0 -57.622495950199664,-37.95294128687509,0.0 ",
				"Polygon Outer Boundary",
				"1296",
				"0450020",
				"General Pueyrredon",
				"Mar Del Plata",
				"0020",
				"2015/01/29",
				"Libertad & Ramon Carrillo Doctor",
				"Asentamiento Precario",
				"90_o_anterior",
				"30",
				"1.0500000000000000000000000000000",
				"Libertad, Ramon Carrillo Doctor, Maipu, Rep. de Nicaragua",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.6359579572454,-37.95540095013202,0.0 -57.63698411174118,-37.954844730823964,0.0 -57.636424661613994,-37.95420602513068,0.0 -57.63623958919197,-37.95408124423086,0.0 -57.63610971160233,-37.95403683063911,0.0 -57.63516020961106,-37.95440905800615,0.0 -57.635154845193036,-37.954442896764164,0.0 -57.63589626643807,-37.95538614587039,0.0 -57.6359579572454,-37.95540095013202,0.0 ",
				"Polygon Outer Boundary",
				"1299",
				"0450023",
				"General Pueyrredon",
				"Mar Del Plata - Barrio San Jorge",
				"0023",
				"2015/01/29",
				"Botana & Rivadavia",
				"Asentamiento Precario",
				"90_o_anterior",
				"15",
				"1.3400000000000001000000000000000",
				"Botana, Rivadavia, Hector Tarantino Doctor, Pedro Luro",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.606516480445855,-37.998248891834095,0.0 -57.606204212643206,-37.9979910248589,0.0 -57.60614520404488,-37.99798891119142,0.0 -57.60548269841819,-37.998491962333034,0.0 -57.60548269841819,-37.99852789442539,0.0 -57.60611838195473,-37.99905207824173,0.0 -57.60617470834405,-37.99904151005663,0.0 -57.60645634029061,-37.99882591874823,0.0 -57.60653948877007,-37.99876462306445,0.0 -57.60619193315505,-37.99848773502689,0.0 -57.606516480445855,-37.998248891834095,0.0 ",
				"Polygon Outer Boundary",
				"1310",
				"0450032",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Las Americas",
				"0032",
				"2015/01/30",
				"San Cayetano & Magallanes",
				"Asentamiento Precario",
				"90_o_anterior",
				"50",
				"0.5799999999999999600000000000000",
				"San Cayetano, Magallanes, 12 de Octubre, Juan N. Fernandez",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.783867241814725,-37.93706464342523,0.0 -57.78347563929856,-37.93670925164589,0.0 -57.78338980861008,-37.93670925164589,0.0 -57.78168928809463,-37.937860037847585,0.0 -57.78167855925858,-37.93794042297518,0.0 -57.7821506280452,-37.93831273189331,0.0 -57.783867241814725,-37.93706464342523,0.0 ",
				"Polygon Outer Boundary",
				"1308",
				"0450031",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Sierra De Los Pad",
				"0031",
				"2015/01/30",
				"Los Almendros & Los Perales",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"1.2600000000000000000000000000000",
				"Los Almendros, Los Perales, Las Azaleas",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.47047209739685,-34.72566684386411,0.0 -58.46957087516785,-34.72523917404168,0.0 -58.46649169921874,-34.72933060497099,0.0 -58.4642521879347,-34.7322418321009,0.0 -58.4652191744672,-34.7327187372432,0.0 -58.47047209739685,-34.72566684386411,0.0 ",
				"Polygon Outer Boundary",
				"990",
				"0630021",
				"Lomas de Zamora",
				"Banfield",
				"0021",
				"2014/10/01",
				"Nuevo Horizonte",
				"Otros",
				"90_o_anterior",
				"160",
				"9.0199999999999996000000000000000",
				"Limay, Escobar, Tabaré, Virgilio, Euskadi",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.35024023428559,-34.91428216751565,0.0 -58.340970519930124,-34.9096544234163,0.0 -58.33609962835908,-34.916393599065934,0.0 -58.34528351202607,-34.92090660188292,0.0 -58.35024023428559,-34.91428216751565,0.0 ",
				"Polygon Outer Boundary",
				"1803",
				"1290003",
				"Pte. Peron",
				"Guernica",
				"0003",
				"2015/06/26",
				"Las Lomas",
				"Otros",
				"90_o_anterior",
				"2000",
				"85.4699999999999990000000000000000",
				"Av. 21, gral. Paz, Lomas de Zamora y Av. 41",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.60266369674354,-37.98801594993201,0.0 -57.60217017028481,-37.987396558533085,0.0 -57.602135301567614,-37.98738598866861,0.0 -57.60131299495697,-37.98779821225468,0.0 -57.601816118694835,-37.98843451180738,0.0 -57.60185366962105,-37.9884471954633,0.0 -57.6026556501165,-37.98805400111027,0.0 -57.60266369674354,-37.98801594993201,0.0 ",
				"Polygon Outer Boundary",
				"1303",
				"0450027",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Regional",
				"0027",
				"2015/01/30",
				"San Lorenzo & Remedios de Escalada",
				"Villa",
				"90_o_anterior",
				"80",
				"0.7600000000000000100000000000000",
				"San Lorenzo, Remedios de Escalada, Paula Albarracin, Avellaneda Nicolas",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.62829685583711,-37.99136015035509,0.0 -57.631365302950144,-37.98904332481785,0.0 -57.62927317991853,-37.98735216509207,0.0 -57.62612963095307,-37.98964367714462,0.0 -57.62829685583711,-37.99136015035509,0.0 ",
				"Polygon Outer Boundary",
				"1305",
				"0450029",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Autodromo",
				"0029",
				"2015/01/30",
				"258 & Vertiz",
				"Asentamiento Precario",
				"90_o_anterior",
				"80",
				"9.9600000000000009000000000000000",
				"Calle 258,  Av. Vertiz, Onesimo Leguizamón,",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.63666534796357,-37.988493702182886,0.0 -57.63603234663606,-37.98819774982779,0.0 -57.6338973082602,-37.98616833008945,0.0 -57.63344669714569,-37.98646429063084,0.0 -57.634133342653506,-37.9870731199906,0.0 -57.633596900850534,-37.9874959151847,0.0 -57.63571048155427,-37.98921243864636,0.0 -57.63666534796357,-37.988493702182886,0.0 ",
				"Polygon Outer Boundary",
				"1307",
				"0450030",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Autodromo",
				"0030",
				"2015/01/30",
				"Vertiz & Paraná",
				"Asentamiento Precario",
				"90_o_anterior",
				"80",
				"3.3100000000000001000000000000000",
				"Paraná, Hipolito Bouchard, Av. Vertiz",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.62138283345849,-38.0187907893957,0.0 -57.62076860759407,-38.018270972858495,0.0 -57.62071496341377,-38.018268859775624,0.0 -57.619953216053545,-38.01885840753604,0.0 -57.61995053384452,-38.01889221658282,0.0 -57.620583535172045,-38.01939089821103,0.0 -57.62063449714332,-38.019399350412776,0.0 -57.621398926712565,-38.01883093767406,0.0 -57.62138283345849,-38.0187907893957,0.0 ",
				"Polygon Outer Boundary",
				"1317",
				"0450037",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Las Heras",
				"0037",
				"2015/02/02",
				"Tetamanti & Guiraldes",
				"Villa",
				"90_o_anterior",
				"60",
				"0.8399999999999999700000000000000",
				"Av Victorio Tetamanti, Ricardo Guiraldes, O. Olazar, W. Morris",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.39715659618378,-34.921742315912624,0.0 -58.39783335104585,-34.92083622557612,0.0 -58.39515566825867,-34.91950346287304,0.0 -58.39367508888244,-34.92147400865167,0.0 -58.39715659618378,-34.921742315912624,0.0 ",
				"Polygon Outer Boundary",
				"1805",
				"1290005",
				"Pte. Peron",
				"Numancia",
				"0005",
				"2015/06/26",
				"Hospital Guernica",
				"Otros",
				"90_o_anterior",
				"140",
				"5.3799999999999999000000000000000",
				"La Pampa, Mansilla, Rivadavia y Circunvalación",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.887280229479074,-34.922516443420925,0.0 -57.88718593306839,-34.922547232432194,0.0 -57.8745259065181,-34.93071031125615,0.0 -57.87551295943558,-34.93175262868718,0.0 -57.87720811553299,-34.93067072932056,0.0 -57.87728095427155,-34.93067072932056,0.0 -57.8776135481894,-34.93104015997679,0.0 -57.879308704286814,-34.929931863017266,0.0 -57.879748586565256,-34.92957122347638,0.0 -57.8796842135489,-34.929509650713406,0.0 -57.8801884688437,-34.92915780546703,0.0 -57.87997389212251,-34.928937901421804,0.0 -57.88181925192475,-34.927688835262934,0.0 -57.882817033678286,-34.92873558917962,0.0 -57.88470530882478,-34.92752170524998,0.0 -57.885735277086496,-34.928568461298916,0.0 -57.887505535036325,-34.927389760262415,0.0 -57.886866331100464,-34.92665966082922,0.0 -57.887660264968865,-34.92614946700775,0.0 -57.88672685623169,-34.924988324415956,0.0 -57.88754224777222,-34.92440774695833,0.0 -57.88831019774079,-34.9251114766819,0.0 -57.88920069113374,-34.92462766314527,0.0 -57.887280229479074,-34.922516443420925,0.0 ",
				"Polygon Outer Boundary",
				"1311",
				"1140008",
				"Berisso",
				"Berisso",
				"0008",
				"2015/01/30",
				"El Carmen",
				"Otros",
				"90_o_anterior",
				"870",
				"36.7700000000000030000000000000000",
				"130 - 31 a 45",
				"Cobertura Parcial",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.884276155382395,-34.862984099230516,0.0 -57.88562178611755,-34.86451584854031,0.0 -57.885873913764954,-34.864542257760995,0.0 -57.88598120212555,-34.86460387924294,0.0 -57.886115312576294,-34.864683106794736,0.0 -57.886244058609,-34.86477553884203,0.0 -57.888094782829285,-34.86411530765361,0.0 -57.88795614615082,-34.86382040267695,0.0 -57.88688326254487,-34.86417252789972,0.0 -57.88541341200471,-34.86236787019677,0.0 -57.884276155382395,-34.862984099230516,0.0 ",
				"Polygon Outer Boundary",
				"1306",
				"1140006",
				"Berisso",
				"Berisso",
				"0006",
				"2015/01/30",
				"Club Náutico",
				"Otros",
				"90_o_anterior",
				"140",
				"3.5099999999999998000000000000000",
				"7 Oeste- 168 Norte- 170",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Sin dato",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.4568073765207,-34.7367670118198,0.0 -58.4602197060653,-34.7321947894324,0.0 -58.4602045459365,-34.7321527770569,0.0 -58.451642990112305,-34.72778752441924,0.0 -58.45052719116211,-34.727135013119984,0.0 -58.448445796966546,-34.72993460294219,0.0 -58.44838678836822,-34.73009772572485,0.0 -58.447126150131226,-34.731786248047584,0.0 -58.4568073765207,-34.7367670118198,0.0 ",
				"Polygon Outer Boundary",
				"991",
				"0630020",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0020",
				"2014/10/01",
				"Facundo Quiroga",
				"Otros",
				"90_o_anterior",
				"1350",
				"62.7400000000000020000000000000000",
				"Ginebra, Amberes, Cosquín, Arroyo del Rey",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.582698464393616,-37.96701291673185,0.0 -57.58234441280364,-37.96719476866011,0.0 -57.581931352615356,-37.96740199472695,0.0 -57.582194209098816,-37.9677191763496,0.0 -57.58220493793487,-37.967896797459765,0.0 -57.581334770657115,-37.96836622261095,0.0 -57.58190071675927,-37.96901114866754,0.0 -57.58220648858696,-37.96885890433878,0.0 -57.582698464393616,-37.96701291673185,0.0 ",
				"Polygon Outer Boundary",
				"1302",
				"0450026",
				"General Pueyrredon",
				"Mar Del Plata- Barrio Lopez De",
				"0026",
				"2015/01/30",
				"Necochea & Nasser",
				"Asentamiento Precario",
				"90_o_anterior",
				"30",
				"1.0000000000000000000000000000000",
				"Necochea, Gamal Abdel Nasser, Ituzaingo, Vias FFCC",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.5783762941137,-38.07065880014257,0.0 -57.57770037744194,-38.07009078521193,0.0 -57.577295363880694,-38.07040118796967,0.0 -57.57720953319222,-38.07045608900062,0.0 -57.57699763868004,-38.07028293945537,0.0 -57.57606959436089,-38.0709628658022,0.0 -57.57642209529876,-38.0712542608733,0.0 -57.576981545425944,-38.07173780520525,0.0 -57.577037871815264,-38.07173147058401,0.0 -57.57839238736778,-38.07069891998948,0.0 -57.5783762941137,-38.07065880014257,0.0 ",
				"Polygon Outer Boundary",
				"1324",
				"0450044",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Parque Independen",
				"0044",
				"2015/02/02",
				"Thetis & R. H. Gral San Martin",
				"Asentamiento Precario",
				"90_o_anterior",
				"60",
				"1.8700000000000001000000000000000",
				"Bahia Thetis, Rompe Hielos Gral San Martin, Fragata Maldonado",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.31974938511848,-34.804800538498675,0.0 -58.313805609941475,-34.80177883758126,0.0 -58.31268981099129,-34.80418387383856,0.0 -58.31243231892586,-34.80461553958507,0.0 -58.312098383903496,-34.8048225621512,0.0 -58.31165850162506,-34.80515291623302,0.0 -58.311347365379326,-34.805307081018064,0.0 -58.311127424240105,-34.80516613036875,0.0 -58.31063389778137,-34.80478291957241,0.0 -58.31028521060943,-34.80463756328704,0.0 -58.30995798110961,-34.80450982573373,0.0 -58.30964684486389,-34.80476089590928,0.0 -58.30946445465088,-34.8047124438297,0.0 -58.309287428855896,-34.80469922962123,0.0 -58.30883145332336,-34.80472565803604,0.0 -58.308783173561096,-34.80535112804654,0.0 -58.30916404724121,-34.80534672334476,0.0 -58.31026375293731,-34.80602944931256,0.0 -58.3094322681427,-34.807029302298105,0.0 -58.30951273441315,-34.80724953260314,0.0 -58.309984803199775,-34.80717465436545,0.0 -58.31015646457672,-34.80696763770725,0.0 -58.31037104129791,-34.80671657425384,0.0 -58.310628533363335,-34.806597649193165,0.0 -58.311262875795364,-34.806597649193165,0.0 -58.31150963902473,-34.806712169625015,0.0 -58.312228471040726,-34.80654479355557,0.0 -58.313430100679405,-34.80622765901815,0.0 -58.31974938511848,-34.804800538498675,0.0 ",
				"Polygon Outer Boundary",
				"1648",
				"0320036",
				"Florencio Varela",
				"Florencio Varela",
				"0036",
				"2015/05/04",
				"3 de Mayo",
				"Asentamiento Precario",
				"90_o_anterior",
				"550",
				"23.0599999999999990000000000000000",
				"Diag Los Tilos, El Malambo, La Aguada",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.62075787875802,-38.00353707852255,0.0 -57.6205218443647,-38.00332995448518,0.0 -57.62040650937706,-38.00339970039983,0.0 -57.62026435229927,-38.00327711662689,0.0 -57.61991679668427,-38.00353073799947,0.0 -57.62030303478241,-38.00384564998292,0.0 -57.6203566789627,-38.003849876980205,0.0 -57.62075787875802,-38.00353707852255,0.0 ",
				"Polygon Outer Boundary",
				"1313",
				"0450033",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Don Emilo",
				"0033",
				"2015/02/02",
				"Soler & Echegaray",
				"Asentamiento Precario",
				"90_o_anterior",
				"15",
				"0.2500000000000000000000000000000",
				"Miguel Estanislao Soler, Marcelino Echegaray",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.62721932027488,-38.016996772824214,0.0 -57.62595176696777,-38.01590216870432,0.0 -57.61953592300415,-38.01706016638441,0.0 -57.621660232543945,-38.018784450191845,0.0 -57.622400522232056,-38.01820969343027,0.0 -57.622679471969604,-38.018463263145435,0.0 -57.62317299842834,-38.018843616073184,0.0 -57.625928046181805,-38.01695028417857,0.0 -57.62662542052567,-38.01751237218978,0.0 -57.62721932027488,-38.016996772824214,0.0 ",
				"Polygon Outer Boundary",
				"1319",
				"0450039",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Parque Palermo",
				"0039",
				"2015/02/02",
				"Colectora Norte  &  Tetamanti",
				"Villa",
				"90_o_anterior",
				"100",
				"10.8000000000000010000000000000000",
				"Colectora Norte Via, Av. Victorio Tetamanti, Ciudad de San Cayetano,F.Garcia Lorca",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.59012592025101,-37.99345706804981,0.0 -57.58938252925873,-37.993831209360835,0.0 -57.58935570716857,-37.99386714373659,0.0 -57.58936643600464,-37.99389885052411,0.0 -57.58988028857857,-37.994526642094684,0.0 -57.59028530213982,-37.99430892374108,0.0 -57.59028106927871,-37.99431103751461,0.0 -57.5900262594223,-37.99397917432447,0.0 -57.59043127298355,-37.993774137080806,0.0 -57.59018606040627,-37.993471864635076,0.0 -57.59012592025101,-37.99345706804981,0.0 ",
				"Polygon Outer Boundary",
				"1374",
				"0450078",
				"General Pueyrredon",
				"Mar Del Plata",
				"0078",
				"2015/02/09",
				"Bernardino Rivadavia",
				"Villa",
				"90_o_anterior",
				"165",
				"2.0499999999999998000000000000000",
				"Malvinas, Avellaneda, Roca, Rodriguez Peña",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-57.59194982238114,-37.99568497742116,0.0 -57.59263646788895,-37.99532564177705,0.0 -57.592293145135045,-37.99487752662492,0.0 -57.59264183230698,-37.99472110842722,0.0 -57.59249699302018,-37.99453509716334,0.0 -57.5924487132579,-37.99453509716334,0.0 -57.59142947383225,-37.9949832144075,0.0 -57.59059798903764,-37.99540596401498,0.0 -57.59118271060288,-37.99607813087383,0.0 -57.59194982238114,-37.99568497742116,0.0 ",
				"Polygon Outer Boundary",
				"1374",
				"0450078",
				"General Pueyrredon",
				"Mar Del Plata",
				"0078",
				"2015/02/09",
				"Bernardino Rivadavia",
				"Villa",
				"90_o_anterior",
				"165",
				"2.0499999999999998000000000000000",
				"Malvinas, Avellaneda, Roca, Rodriguez Peña",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.77892630174755,-34.598277932302516,0.0 -58.779848981648676,-34.59757582681365,0.0 -58.77858281135559,-34.59643213283829,0.0 -58.77726316452026,-34.5974875112376,0.0 -58.778486251831055,-34.59861352779832,0.0 -58.77892630174755,-34.598277932302516,0.0 ",
				"Polygon Outer Boundary",
				"2229",
				"0740064",
				"Moreno",
				"Trujui",
				"0064",
				"2015/09/23",
				"Malaver II",
				"Asentamiento Precario",
				"2014",
				"23",
				"2.8799999999999999000000000000000",
				"Aguirre y Lafinur",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.6430029887706,-38.03913047020615,0.0 -57.64242363162338,-38.03956141511673,0.0 -57.64535570517183,-38.041973814791035,0.0 -57.64592433348298,-38.04155133372332,0.0 -57.6430029887706,-38.03913047020615,0.0 ",
				"Polygon Outer Boundary",
				"1320",
				"0450040",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Parque Hermoso",
				"0040",
				"2015/02/02",
				"206 & 3",
				"Asentamiento Precario",
				"90_o_anterior",
				"25",
				"2.5699999999999998000000000000000",
				"Calle 206, Calle 3, Calle 204",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.69449941441417,-34.477919415416686,0.0 -58.694279473274946,-34.47821127535468,0.0 -58.69446722790598,-34.4783085617738,0.0 -58.694317024201155,-34.478481023783466,0.0 -58.69443504139781,-34.47851197846542,0.0 -58.694783728569746,-34.47808303399252,0.0 -58.69449941441417,-34.477919415416686,0.0 ",
				"Polygon Outer Boundary",
				"1537",
				"1330164",
				"Malvinas Argentinas",
				"Malvinas Argentinas",
				"0164",
				"2015/04/17",
				"Olivos II",
				"Asentamiento Precario",
				"decada_1990",
				"12",
				"0.1400000000000000100000000000000",
				"O´Brien - Franklin Benjamin",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Cobertura Total",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7050885542201,-34.6474275635467,0.0 -58.7050947073951,-34.6473825612095,0.0 -58.7044492441578,-34.6468078516255,0.0 -58.7038847341182,-34.6462880804694,0.0 -58.7038520197386,-34.6462877327068,0.0 -58.7037635188889,-34.6463679137088,0.0 -58.7032275489574,-34.6468173981294,0.0 -58.7032269174305,-34.6468579523233,0.0 -58.7036468058713,-34.647209438504,0.0 -58.7038091170659,-34.647292285946,0.0 -58.7036376355374,-34.647448199694,0.0 -58.7032234372953,-34.6477818026481,0.0 -58.7027152091873,-34.6482000322636,0.0 -58.7021827839302,-34.6477211556272,0.0 -58.7021282590631,-34.6477205752361,0.0 -58.7004211484135,-34.6491310360168,0.0 -58.7003824177501,-34.6491666772979,0.0 -58.7003706686308,-34.6492206332328,0.0 -58.7015797517317,-34.6502179730021,0.0 -58.7016314358179,-34.6502189740821,0.0 -58.7026750056258,-34.6493803772156,0.0 -58.7050885542201,-34.6474275635467,0.0 ",
				"Polygon Outer Boundary",
				"25",
				"1360024",
				"Ituzaingo",
				"Ituzaingó Norte",
				"0024",
				"2014/09/01",
				"Nuevo San Alberto",
				"Otros",
				"1988",
				"148",
				"6.5400000000000000000000000000000",
				"Almagro, Portugal, Cnel. Pringles, Camerucci",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.5655714282766,-38.05186340011048,0.0 -57.565260292030864,-38.05159727327324,0.0 -57.564941109158106,-38.05182960628001,0.0 -57.565303207375116,-38.052114741235,0.0 -57.5655714282766,-38.051897193925335,0.0 -57.5655714282766,-38.05186340011048,0.0 ",
				"Polygon Outer Boundary",
				"1321",
				"0450041",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Juramento",
				"0041",
				"2015/02/02",
				"Puan & Padre Dutto",
				"Villa",
				"90_o_anterior",
				"40",
				"0.1600000000000000000000000000000",
				"Puan, Dutto Padre",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.8230162858963,-34.61598757342324,0.0 -58.823735285550356,-34.61524588414319,0.0 -58.82249074056744,-34.61442472042425,0.0 -58.82318811491132,-34.61366094257697,0.0 -58.82241563871502,-34.6131576400388,0.0 -58.820994067937136,-34.614627804680715,0.0 -58.8230162858963,-34.61598757342324,0.0 ",
				"Polygon Outer Boundary",
				"2231",
				"0740066",
				"Moreno",
				"La Reja",
				"0066",
				"2015/09/23",
				"Lomas Verdes II",
				"Asentamiento Precario",
				"2014",
				"50",
				"3.4700000000000002000000000000000",
				"Atahualpa y Guiraldes",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.39626694098115,-34.935147764945,0.0 -58.39800501242279,-34.93280812651388,0.0 -58.39337015524506,-34.93045082933059,0.0 -58.39162135496735,-34.93282571802927,0.0 -58.39626694098115,-34.935147764945,0.0 ",
				"Polygon Outer Boundary",
				"1808",
				"1290008",
				"Pte. Peron",
				"Pte. Peron",
				"0008",
				"2015/06/26",
				"San Martín",
				"Otros",
				"90_o_anterior",
				"400",
				"15.2600000000000000000000000000000",
				"Malvinas Argentinas, De las Americas, Beltran, Godoy Cruz",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.9406164151949,-34.8914282654723,0.0 -57.9431817524577,-34.8894017276131,0.0 -57.9422540974543,-34.8884706758637,0.0 -57.9417391045655,-34.8879538171345,0.0 -57.941358089447014,-34.88757667051862,0.0 -57.94188380241393,-34.887180642303136,0.0 -57.94277429580689,-34.886502989596046,0.0 -57.94379353523254,-34.885702120100945,0.0 -57.94468402862548,-34.88505965871003,0.0 -57.94509172439575,-34.88544689631412,0.0 -57.9459254709169,-34.88481012091,0.0 -57.945556811256,-34.8844670208688,0.0 -57.9453585309384,-34.8843097481692,0.0 -57.9449482288982,-34.8845806983338,0.0 -57.9426978137711,-34.885251828598,0.0 -57.9426533082697,-34.8859785585157,0.0 -57.9413763265559,-34.8871473046271,0.0 -57.9413299216756,-34.8875018259275,0.0 -57.941198305179,-34.8879266552573,0.0 -57.9414124246298,-34.8886917113324,0.0 -57.9407112041177,-34.8896855229787,0.0 -57.9392149669961,-34.8908635792354,0.0 -57.9402221579526,-34.8917321071967,0.0 -57.9406164151949,-34.8914282654723,0.0 ",
				"Polygon Outer Boundary",
				"502",
				"1150003",
				"Ensenada",
				"El Dique",
				"0003",
				"2014/11/20",
				"Eucaliptus",
				"Villa",
				"decada_1990",
				"230",
				"9.2400000000000002000000000000000",
				"35, 41 bis, 126, 131",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.768599797040224,-34.59552688126844,0.0 -58.769415188580744,-34.594943982353456,0.0 -58.76870172098279,-34.59428159225798,0.0 -58.76789705827832,-34.59489982317807,0.0 -58.768599797040224,-34.59552688126844,0.0 ",
				"Polygon Outer Boundary",
				"2228",
				"0740063",
				"Moreno",
				"Trujui",
				"0063",
				"2015/09/23",
				"Malaver",
				"Villa",
				"decada_2000",
				"30",
				"0.9699999999999999700000000000000",
				"Cañada y Pitágoras",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.60032594203949,-37.95420602513068,0.0 -57.60055124759674,-37.95409181889162,0.0 -57.60069763753563,-37.95402625597045,0.0 -57.60011023376138,-37.95329871511122,0.0 -57.59817481040954,-37.95430754163856,0.0 -57.59872198104858,-37.954997004209126,0.0 -57.60032594203949,-37.95420602513068,0.0 ",
				"Polygon Outer Boundary",
				"1327",
				"0450046",
				"General Pueyrredon",
				"Mar Del Plata- Barrio Libertad",
				"0046",
				"2015/02/03",
				"Río Negro & Bayley",
				"Otros",
				"90_o_anterior",
				"50",
				"1.8999999999999999000000000000000",
				"Rio Negro, Onésimo Leguizamón, Paraguay, Santa Cruz",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.825939893722534,-34.60946224637649,0.0 -58.82808029651642,-34.61086625044084,0.0 -58.828906416893005,-34.61002738294298,0.0 -58.82676601409912,-34.608627779881566,0.0 -58.825939893722534,-34.60946224637649,0.0 ",
				"Polygon Outer Boundary",
				"2232",
				"0740067",
				"Moreno",
				"La Reja",
				"0067",
				"2015/09/23",
				"Reja Grande II",
				"Asentamiento Precario",
				"2013",
				"40",
				"3.0099999999999998000000000000000",
				"Moctezuma, Atahualpa",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.438822031021125,-34.70381758128278,0.0 -58.4395569562912,-34.702895860894884,0.0 -58.439412117004395,-34.70281206762317,0.0 -58.43913853168487,-34.70314283004417,0.0 -58.438671827316284,-34.70287822021316,0.0 -58.43848180957138,-34.70316488082521,0.0 -58.43873083591461,-34.7033236462753,0.0 -58.43851089477539,-34.70363235600054,0.0 -58.438822031021125,-34.70381758128278,0.0 ",
				"Polygon Outer Boundary",
				"1980",
				"0630075",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0075",
				"2015/07/24",
				"Gral. Conesa & Campana",
				"Villa",
				"90_o_anterior",
				"87",
				"0.4699999999999999700000000000000",
				"Gral. Conesa y Campana",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-62.47625470161437,-34.85273649080175,0.0 -62.47507452964783,-34.85248116467129,0.0 -62.47499942779541,-34.852754099471184,0.0 -62.47325062751769,-34.85241072973726,0.0 -62.47247815132141,-34.85469983422868,0.0 -62.47401237487793,-34.854735050723384,0.0 -62.47556805610656,-34.85474385484471,0.0 -62.47625470161437,-34.85273649080175,0.0 ",
				"Polygon Outer Boundary",
				"1539",
				"1280001",
				"Ameghino",
				"Florentino Ameghino",
				"0001",
				"2015/04/17",
				"San Miguel",
				"Asentamiento Precario",
				"decada_1940",
				"50",
				"6.7500000000000000000000000000000",
				"Calle 1 y Ruta 66 (CIRC 5 - SECCION B - QTA 39 - FRACC II - MANZANA VARIAS)",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.39337468147277,-34.92190066076977,0.0 -58.389651775360115,-34.92687957098075,0.0 -58.392441272735596,-34.9282693895048,0.0 -58.39353024959564,-34.92674322675624,0.0 -58.396271467208855,-34.92808466814617,0.0 -58.39733898639678,-34.92663327157143,0.0 -58.40018749237061,-34.9280055017223,0.0 -58.40131402015685,-34.92654530731748,0.0 -58.40229034423828,-34.927002720408176,0.0 -58.40279459953308,-34.9262462281487,0.0 -58.4036099910736,-34.926650864410895,0.0 -58.404661417007446,-34.92517305274557,0.0 -58.40378165245056,-34.92473322270566,0.0 -58.405135162174695,-34.922762755187605,0.0 -58.396925926208496,-34.92212938057959,0.0 -58.39337468147277,-34.92190066076977,0.0 ",
				"Polygon Outer Boundary",
				"1804",
				"1290004",
				"Pte. Peron",
				"Numancia",
				"0004",
				"2015/06/26",
				"Estacion Numancia",
				"Otros",
				"90_o_anterior",
				"950",
				"66.1299999999999950000000000000000",
				"Primera Junta, Blanco Encalada, Mansilla, Brasil",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.58852506056427,-38.018733736541265,0.0 -57.58849513716995,-38.018733736541265,0.0 -57.58588803000748,-38.017203858251165,0.0 -57.586365463212125,-38.0166755779432,0.0 -57.58478832431137,-38.0153273893388,0.0 -57.58453083224594,-38.01558096902629,0.0 -57.58492017164826,-38.01678123430943,0.0 -57.58441591635346,-38.01737290714551,0.0 -57.58724832907319,-38.01979871583384,0.0 -57.58852506056427,-38.018733736541265,0.0 ",
				"Polygon Outer Boundary",
				"1331",
				"0450050",
				"General Pueyrredon",
				"Mar Del Plata",
				"0050",
				"2015/02/03",
				"Villa Evita",
				"Villa",
				"90_o_anterior",
				"90",
				"6.2400000000000002000000000000000",
				"Horacio Gaudini, Ortiz de Zarate,",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.33840012550353,-34.78681405950196,0.0 -58.33762245252728,-34.78642635768731,0.0 -58.33747744560241,-34.78662020882244,0.0 -58.33788530901074,-34.78680084242464,0.0 -58.337579537183046,-34.787316306870345,0.0 -58.3379065990448,-34.78748812763636,0.0 -58.33840012550353,-34.78681405950196,0.0 ",
				"Polygon Outer Boundary",
				"2135",
				"0030098",
				"Almirante Brown",
				"Rafael Calzada",
				"0098",
				"2015/08/31",
				"La Pampa y Perón (Barrio San Jerónimo)",
				"Villa",
				"90_o_anterior",
				"30",
				"0.4400000000000000000000000000000",
				"La Pampa, Cervantes Saavedra, Pres. J. D. Perón y Jujuy",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.337837029248476,-34.75802665166004,0.0 -58.33841638639569,-34.75731708470237,0.0 -58.33701090887189,-34.75654140204549,0.0 -58.33645300939679,-34.75729064109541,0.0 -58.337837029248476,-34.75802665166004,0.0 ",
				"Polygon Outer Boundary",
				"1269",
				"0030010",
				"Almirante Brown",
				"San José",
				"0010",
				"2014/10/01",
				"Santa María",
				"Otros",
				"90_o_anterior",
				"45",
				"1.4700000000000000000000000000000",
				"El Chajá, Vertíz, Alvear y Belgrano",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.33419458940625,-34.785699411872855,0.0 -58.33331482484936,-34.78529408172752,0.0 -58.33298223093152,-34.78582277282607,0.0 -58.33384053781628,-34.78631180907513,0.0 -58.33419458940625,-34.785699411872855,0.0 ",
				"Polygon Outer Boundary",
				"2134",
				"0030097",
				"Almirante Brown",
				"Rafael Calzada",
				"0097",
				"2015/08/31",
				"Tierra del Fuego & Perón (Barrio Asunción)",
				"Villa",
				"2003",
				"24",
				"0.6600000000000000300000000000000",
				"Pres. Juan Domingo Perón, Santa Cruz, Tierra del Fuego y Dardo Rocha",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.54290831275284,-37.92821318428277,0.0 -57.542865397408605,-37.92821318428277,0.0 -57.54218411631882,-37.92870825100346,0.0 -57.54219484515488,-37.928763258211106,0.0 -57.543106796219945,-37.92955027990599,0.0 -57.54424518439919,-37.93044942072523,0.0 -57.54428541753441,-37.93044518950008,0.0 -57.544972063042216,-37.92993955633991,0.0 -57.54496938083321,-37.92989724378389,0.0 -57.54290831275284,-37.92821318428277,0.0 ",
				"Polygon Outer Boundary",
				"1328",
				"0450047",
				"General Pueyrredon",
				"Mar Del Plata- Parque Peña",
				"0047",
				"2015/02/03",
				"Los Manzanos & Tabelli",
				"Otros",
				"90_o_anterior",
				"30",
				"2.3900000000000001000000000000000",
				"Kraglievich Lucas, Los Durazneros, V.M. Teresa Michel, Los Manzanos",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.594282865524285,-34.544030541153454,0.0 -58.592131733894355,-34.545660996370785,0.0 -58.5915673907474,-34.5461426611015,0.0 -58.5914164418972,-34.5462506142238,0.0 -58.5912551192756,-34.5463729592282,0.0 -58.5917715727762,-34.5468385172888,0.0 -58.591718673706055,-34.546924687655824,0.0 -58.59087646007537,-34.5476051288613,0.0 -58.58948707580566,-34.548692055868145,0.0 -58.59066724777222,-34.54969943895379,0.0 -58.5933655500412,-34.54766698687683,0.0 -58.59283447265624,-34.54714561073508,0.0 -58.5949319601059,-34.54560797393938,0.0 -58.595511317253106,-34.545117514847426,0.0 -58.594282865524285,-34.544030541153454,0.0 ",
				"Polygon Outer Boundary",
				"844",
				"0470023",
				"General San Martin",
				"Loma Hermosa",
				"0023",
				"2014/10/01",
				"Libertador",
				"Otros",
				"90_o_anterior",
				"800",
				"11.3400000000000000000000000000000",
				"Libertador, Los Eucaliptos, Las Carmelias",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-57.580371857620776,-38.029640589569794,0.0 -57.58054733276367,-38.02961523650556,0.0 -57.58134126663207,-38.02901943697018,0.0 -57.581339003518224,-38.02886731716335,0.0 -57.58012890815734,-38.02796726850968,0.0 -57.57972657680511,-38.02823770682592,0.0 -57.57997334003449,-38.02841095584765,0.0 -57.57986915297806,-38.02847856511084,0.0 -57.579373363405466,-38.02884196383151,0.0 -57.5778414029628,-38.03001665899222,0.0 -57.578315734863274,-38.03039272648406,0.0 -57.578519582748406,-38.03021525667229,0.0 -57.578707337379456,-38.03038005008319,0.0 -57.57896482944488,-38.030591323144606,0.0 -57.57907748222351,-38.03052794129016,0.0 -57.579147219657905,-38.03061245041723,0.0 -57.580371857620776,-38.029640589569794,0.0 ",
				"Polygon Outer Boundary",
				"1329",
				"0450048",
				"General Pueyrredon",
				"Mar Del Plata",
				"0048",
				"2015/02/03",
				"Cariño",
				"Villa",
				"90_o_anterior",
				"200",
				"3.8599999999999999000000000000000",
				"Florencio Sanchez, Azopardo, Valentini, Vertiz",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.513891696929925,-34.702124077551844,0.0 -58.513580560684204,-34.702379869400296,0.0 -58.51418137550354,-34.70297965408174,0.0 -58.51315140724183,-34.703685277552054,0.0 -58.513323068618774,-34.703799940797566,0.0 -58.51466417312622,-34.70276796586712,0.0 -58.513891696929925,-34.702124077551844,0.0 ",
				"Polygon Outer Boundary",
				"1545",
				"0700135",
				"La Matanza",
				"Tapiales",
				"0135",
				"2015/04/17",
				"Club Atlético Lugano",
				"Villa",
				"2005",
				"15",
				"1.7000000000000000000000000000000",
				"L. Guanella, Junca y Vias del FFCC",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.51270079612731,-34.70435561427464,0.0 -58.51176738739014,-34.70352651279594,0.0 -58.51112365722656,-34.70402926681183,0.0 -58.51203560829162,-34.704893643767534,0.0 -58.51270079612731,-34.70435561427464,0.0 ",
				"Polygon Outer Boundary",
				"1545",
				"0700135",
				"La Matanza",
				"Tapiales",
				"0135",
				"2015/04/17",
				"Club Atlético Lugano",
				"Villa",
				"2005",
				"15",
				"1.7000000000000000000000000000000",
				"L. Guanella, Junca y Vias del FFCC",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.49039018154144,-34.74494055123471,0.0 -58.489810824394226,-34.74570311919634,0.0 -58.4900065258831,-34.7457939645585,0.0 -58.49002003669738,-34.74588384236347,0.0 -58.489848375320435,-34.7461615381668,0.0 -58.4907442331314,-34.74661113891671,0.0 -58.49098563194274,-34.746306997500746,0.0 -58.49069595336914,-34.745888250240654,0.0 -58.4909291377428,-34.7456177495384,0.0 -58.4911824730144,-34.7457494159009,0.0 -58.49164545536041,-34.74513009190569,0.0 -58.49086761474609,-34.744711338679515,0.0 -58.490615487098694,-34.74505074935215,0.0 -58.49039018154144,-34.74494055123471,0.0 ",
				"Polygon Outer Boundary",
				"1195",
				"0300031",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0031",
				"2014/10/01",
				"Santa Adela & Santa Teresita",
				"Asentamiento Precario",
				"2000",
				"35",
				"1.7500000000000000000000000000000",
				"Santa Aldea, Santa Teresita",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.61998808477073,-38.00413308524358,0.0 -57.619821787811816,-38.003991481248626,0.0 -57.61974668595939,-38.00404220509915,0.0 -57.61965549085289,-38.003976686785606,0.0 -57.619561613537364,-38.00405065907083,0.0 -57.619403363205485,-38.00392596288977,0.0 -57.619314850308,-38.00398514076484,0.0 -57.61923706624657,-38.00392173589685,0.0 -57.618966163136065,-38.004114063827316,0.0 -57.619454325176775,-38.004500831654674,0.0 -57.61948382947593,-38.00450717209387,0.0 -57.61998808477073,-38.00413308524358,0.0 ",
				"Polygon Outer Boundary",
				"1314",
				"0450034",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Don Emilio",
				"0034",
				"2015/02/02",
				"Soler & Scarpatti",
				"Asentamiento Precario",
				"90_o_anterior",
				"20",
				"0.3100000000000000000000000000000",
				"Miguel Estanislao Soler, Francisco Scarpatti",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.80928354337812,-34.52327369037445,0.0 -58.81020069122314,-34.523879190196986,0.0 -58.8110214471817,-34.523052703941374,0.0 -58.81033496931195,-34.52256653172486,0.0 -58.81013648584485,-34.52240300043243,0.0 -58.809245992451906,-34.523242752309116,0.0 -58.80928354337812,-34.52327369037445,0.0 ",
				"Polygon Outer Boundary",
				"2245",
				"0740072",
				"Moreno",
				"Cuartel V",
				"0072",
				"2015/09/24",
				"Don Máximo",
				"Asentamiento Precario",
				"90_o_anterior",
				"190",
				"1.9299999999999999000000000000000",
				"Av. Derqui, Francisco Bilbao, Somellera, Acevedo",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.809562493115656,-34.525023882214256,0.0 -58.808961678296335,-34.52465263247294,0.0 -58.80817847326398,-34.52543048717507,0.0 -58.80849497392773,-34.52560727132149,0.0 -58.80888657644391,-34.5252316045618,0.0 -58.809186816215515,-34.5254216479579,0.0 -58.809562493115656,-34.525023882214256,0.0 ",
				"Polygon Outer Boundary",
				"2245",
				"0740072",
				"Moreno",
				"Cuartel V",
				"0072",
				"2015/09/24",
				"Don Máximo",
				"Asentamiento Precario",
				"90_o_anterior",
				"190",
				"1.9299999999999999000000000000000",
				"Av. Derqui, Francisco Bilbao, Somellera, Acevedo",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.33565128035843,-34.7710798326637,0.0 -58.336869003251195,-34.76944499295694,0.0 -58.335576178506024,-34.76879281066833,0.0 -58.33430481143295,-34.76812299646699,0.0 -58.333037258125835,-34.769702779805286,0.0 -58.33438372705132,-34.77043206986117,0.0 -58.33565128035843,-34.7710798326637,0.0 ",
				"Polygon Outer Boundary",
				"1981",
				"0030060",
				"Almirante Brown",
				"San Jose",
				"0060",
				"2015/07/24",
				"La Taperita",
				"Asentamiento Precario",
				"1998",
				"60",
				"5.9500000000000002000000000000000",
				"El hornero, El tordo, Piedrabuena y Nother",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.591465474106364,-38.04425305810198,0.0 -57.59143328759819,-38.04424038409994,0.0 -57.59074240922927,-38.04474523015117,0.0 -57.590745091438286,-38.04479170116085,0.0 -57.59137809276581,-38.045317666441484,0.0 -57.59142792318017,-38.045328227954606,0.0 -57.5921011576429,-38.044846621406975,0.0 -57.592106522060924,-38.04477691493369,0.0 -57.591465474106364,-38.04425305810198,0.0 ",
				"Polygon Outer Boundary",
				"1335",
				"0450054",
				"General Pueyrredon",
				"Mar Del Plata",
				"0054",
				"2015/02/04",
				"Talcahuano & Benito Linch",
				"Villa",
				"90_o_anterior",
				"70",
				"0.7700000000000000200000000000000",
				"Talcahuano, Benito Linch, Mattioli, Mario Bravo",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.7239408493042,-34.590647184613836,0.0 -58.723602890968316,-34.59092981739797,0.0 -58.72443974018097,-34.59172913303599,0.0 -58.72678399085998,-34.59000242497664,0.0 -58.73171925544738,-34.58641199384924,0.0 -58.730801939964294,-34.58558612858086,0.0 -58.728790283203125,-34.587061197683155,0.0 -58.7283718585968,-34.58733501002435,0.0 -58.727803230285645,-34.58691104214525,0.0 -58.72698247432709,-34.5875469931527,0.0 -58.72745990753174,-34.58800187179031,0.0 -58.72589349746704,-34.58922959005144,0.0 -58.7252926826477,-34.58868639320219,0.0 -58.723382949829094,-34.59012607789757,0.0 -58.7239408493042,-34.590647184613836,0.0 ",
				"Polygon Outer Boundary",
				"728",
				"1310006",
				"San Miguel",
				"San Miguel",
				"0006",
				"2014/10/01",
				"San Ambrosio 2",
				"Asentamiento Precario",
				"90_o_anterior",
				"110",
				"13.5200000000000000000000000000000",
				"Puerto de Palos, Quirno, Santa Fe y J M Rosas",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.6111266695541,-37.9770853859083,0.0 -57.6119523741267,-37.9766741291263,0.0 -57.6119655694354,-37.9766321523901,0.0 -57.6114663385114,-37.9760186939293,0.0 -57.6114183706339,-37.9760100630519,0.0 -57.6110332942062,-37.9762031940492,0.0 -57.6109041178168,-37.9761161695548,0.0 -57.611344047293,-37.9758983022311,0.0 -57.6107564300925,-37.9751719835444,0.0 -57.6098744716837,-37.9756128938261,0.0 -57.6088646315473,-37.9761124467581,0.0 -57.6094527642829,-37.9768400461937,0.0 -57.6103380173354,-37.9764033497615,0.0 -57.6104606109129,-37.9763354937354,0.0 -57.6105441073649,-37.9763643932117,0.0 -57.6111266695541,-37.9770853859083,0.0 ",
				"Polygon Outer Boundary",
				"447",
				"0450010",
				"General Pueyrredon",
				"Mar Del Plata",
				"0010",
				"2014/09/03",
				"Bolivia & Pigue",
				"Asentamiento Precario",
				"decada_1990",
				"20",
				"0.5000000000000000000000000000000",
				"Tandil, Gascón, Alberti",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7525411391048,-34.5482669677482,0.0 -58.751792907714844,-34.54882018860423,0.0 -58.7524151802063,-34.549385737633784,0.0 -58.7531297995688,-34.548840319491,0.0 -58.7531251276603,-34.5488287755351,0.0 -58.7525411391048,-34.5482669677482,0.0 ",
				"Polygon Outer Boundary",
				"716",
				"1310018",
				"San Miguel",
				"San Miguel",
				"0018",
				"2014/10/01",
				"Callao & Defensa",
				"Asentamiento Precario",
				"90_o_anterior",
				"40",
				"0.7700000000000000200000000000000",
				"Callao, Defensa, Letonia, Pichincha",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.541043758392334,-38.03233641532869,0.0 -57.54072189331055,-38.031994160816815,0.0 -57.54032647702843,-38.03224345747131,0.0 -57.540829181671135,-38.032915286604165,0.0 -57.541279792785645,-38.032682893576045,0.0 -57.541043758392334,-38.03233641532869,0.0 ",
				"Polygon Outer Boundary",
				"1333",
				"0450052",
				"General Pueyrredon",
				"Mar Del Plata-  San Carlos",
				"0052",
				"2015/02/04",
				"Larrea & Irigoyen",
				"Villa",
				"90_o_anterior",
				"25",
				"0.4199999999999999800000000000000",
				"Bernardo de Irigoyen, Vieytes, Larrea",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-57.622248055413365,-38.02509802551909,0.0 -57.62040269561111,-38.02357673181377,0.0 -57.61939954943954,-38.024350060061124,0.0 -57.621352197602384,-38.025829080424245,0.0 -57.622248055413365,-38.02509802551909,0.0 ",
				"Polygon Outer Boundary",
				"1318",
				"0450038",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Parque Hermoso",
				"0038",
				"2015/02/02",
				"Reforma Universitaria & Yahati",
				"Asentamiento Precario",
				"90_o_anterior",
				"60",
				"4.2000000000000002000000000000000",
				"Reforma Universitaria,Jose Yahati,  Mario Bravo, Domingo Heguilor",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.61910450644791,-38.02523325009763,0.0 -57.618503691628575,-38.02569385694538,0.0 -57.6190669555217,-38.026124880914175,0.0 -57.61964094825088,-38.025651599557065,0.0 -57.61910450644791,-38.02523325009763,0.0 ",
				"Polygon Outer Boundary",
				"1318",
				"0450038",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Parque Hermoso",
				"0038",
				"2015/02/02",
				"Reforma Universitaria & Yahati",
				"Asentamiento Precario",
				"90_o_anterior",
				"60",
				"4.2000000000000002000000000000000",
				"Reforma Universitaria,Jose Yahati,  Mario Bravo, Domingo Heguilor",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.62181890197099,-38.02737145557173,0.0 -57.62094450183213,-38.02664041605644,0.0 -57.62086403556168,-38.02664041605644,0.0 -57.62024712748825,-38.02713059364701,0.0 -57.62121808715165,-38.02784895143239,0.0 -57.62181890197099,-38.02740948632956,0.0 -57.6217782497406,-38.027405260690784,0.0 -57.6217782497406,-38.02743061451983,0.0 -57.62184572406113,-38.0273503273644,0.0 -57.62181890197099,-38.02737145557173,0.0 ",
				"Polygon Outer Boundary",
				"1318",
				"0450038",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Parque Hermoso",
				"0038",
				"2015/02/02",
				"Reforma Universitaria & Yahati",
				"Asentamiento Precario",
				"90_o_anterior",
				"60",
				"4.2000000000000002000000000000000",
				"Reforma Universitaria,Jose Yahati,  Mario Bravo, Domingo Heguilor",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.60634207725525,-34.40626347434761,0.0 -58.60642790794372,-34.40579432525909,0.0 -58.60487222671509,-34.40584743660872,0.0 -58.605000972747796,-34.40829052224259,0.0 -58.60509753227233,-34.40822856080762,0.0 -58.60511898994445,-34.407732867675605,0.0 -58.60541939735412,-34.40731683724416,0.0 -58.606224060058594,-34.406661806414164,0.0 -58.60634207725525,-34.40626347434761,0.0 ",
				"Polygon Outer Boundary",
				"702",
				"0570014",
				"Tigre",
				"Tigre",
				"0014",
				"2014/10/01",
				"Paraná & J. Ingenieros",
				"Villa",
				"90_o_anterior",
				"120",
				"2.0299999999999998000000000000000",
				"Paraná, Ameghino, J. Ingenieros (Yatay)",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.577561974525445,-34.57298956203059,0.0 -58.57743322849274,-34.57288796905709,0.0 -58.576923608779914,-34.57329875727302,0.0 -58.5765266418457,-34.572940974102224,0.0 -58.576333522796624,-34.57308673780212,0.0 -58.5766366480798,-34.5733419315418,0.0 -58.57707381248474,-34.57369629232362,0.0 -58.57730984687805,-34.573493107979694,0.0 -58.57727229595184,-34.57343126916775,0.0 -58.57733130455017,-34.57337826443521,0.0 -58.57721865177154,-34.57326342073208,0.0 -58.577561974525445,-34.57298956203059,0.0 ",
				"Polygon Outer Boundary",
				"830",
				"0470037",
				"General San Martin",
				"Villa Billinghurst",
				"0037",
				"2014/10/01",
				"Rivadavia & Chacabuco",
				"Otros",
				"90_o_anterior",
				"60",
				"0.3599999999999999900000000000000",
				"Mitre, Chacabuco, Moreno y Rivadavia",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-57.5835824618116,-38.05054542916162,0.0 -57.58339202497155,-38.050380681124494,0.0 -57.58334219455719,-38.050380681124494,0.0 -57.58266359567642,-38.05088126055057,0.0 -57.58267051074654,-38.050925615524484,0.0 -57.58286476135254,-38.051079801653316,0.0 -57.583130300045006,-38.05088970911911,0.0 -57.58320540189743,-38.05095518549217,0.0 -57.58341080043464,-38.05079677481161,0.0 -57.58332765195518,-38.05073552258988,0.0 -57.5835824618116,-38.05054542916162,0.0 ",
				"Polygon Outer Boundary",
				"1334",
				"0450053",
				"General Pueyrredon",
				"Mar Del Plata",
				"0053",
				"2015/02/04",
				"Benito Linch & Gianelli",
				"Asentamiento Precario",
				"2013",
				"40",
				"0.2700000000000000200000000000000",
				"Benito Linch, Gianelli, Santa Cecilia",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.56118178367615,-37.93515227692999,0.0 -57.56187915802001,-37.93469533243847,0.0 -57.561492919921875,-37.93434839120522,0.0 -57.560999393463135,-37.933971831184316,0.0 -57.561145070940256,-37.933950676069735,0.0 -57.56124163046479,-37.933950676069735,0.0 -57.56181025877595,-37.93348526200861,0.0 -57.56148839369416,-37.93327370918855,0.0 -57.56198192015291,-37.93285060172196,0.0 -57.561692241579294,-37.93262212267745,0.0 -57.560548782348626,-37.93346833780541,0.0 -57.560849189758294,-37.93370950733318,0.0 -57.56015717983246,-37.934301850183516,0.0 -57.56118178367615,-37.93515227692999,0.0 ",
				"Polygon Outer Boundary",
				"1338",
				"0450057",
				"General Pueyrredon",
				"Mar Del Plata",
				"0057",
				"2015/02/04",
				"Los Quebrachos & Zeballos",
				"Asentamiento Precario",
				"90_o_anterior",
				"35",
				"1.9600000000000000000000000000000",
				"Los Quebrachos, Zeballos, Godoy Cruz, Av. B, Calle 6",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.47248998721624,-34.76137928310518,0.0 -58.47257045348669,-34.76133521259059,0.0 -58.47349313338782,-34.760149706919776,0.0 -58.47474304278875,-34.75839565615115,0.0 -58.475429688296565,-34.75750539502249,0.0 -58.476153884730586,-34.75650934891693,0.0 -58.47671178420569,-34.755826213004596,0.0 -58.477334056697146,-34.75493592417222,0.0 -58.47861615260626,-34.75319057761808,0.0 -58.47928670485999,-34.75233552064174,0.0 -58.47924378951575,-34.752304667904944,0.0 -58.4790560348847,-34.752220924704105,0.0 -58.47897556861425,-34.75240163361035,0.0 -58.47805825313117,-34.753631325178894,0.0 -58.47680834373023,-34.75524003381317,0.0 -58.47526339133765,-34.75739080625915,0.0 -58.473852549395815,-34.75929031484263,0.0 -58.473675523600825,-34.75959440844641,0.0 -58.47331610759283,-34.75998664346971,0.0 -58.47277430137182,-34.76063889533761,0.0 -58.472345147929445,-34.761277920886435,0.0 -58.47248998721624,-34.76137928310518,0.0 ",
				"Polygon Outer Boundary",
				"1974",
				"0300047",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0047",
				"2015/07/24",
				"La Paz II",
				"Asentamiento Precario",
				"2007",
				"120",
				"3.0200000000000000000000000000000",
				"Elizalde ( Arooyo Santa Catalina) entre Paz y San Juan",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.480187927088984,-34.75112344017083,0.0 -58.48087457259681,-34.75022428534696,0.0 -58.48155048926856,-34.74928545148151,0.0 -58.4821352108338,-34.748470023736836,0.0 -58.48221567710425,-34.74831134496973,0.0 -58.48226932128455,-34.748192335694355,0.0 -58.48225859244848,-34.74815707365391,0.0 -58.482113753161684,-34.748126219356166,0.0 -58.482092295489565,-34.74815707365391,0.0 -58.4820815666535,-34.74823200547186,0.0 -58.48157194694067,-34.74905625098289,0.0 -58.4810730560639,-34.74968655082365,0.0 -58.48070291121985,-34.75017139358189,0.0 -58.48004308780218,-34.75106614138095,0.0 -58.480187927088984,-34.75112344017083,0.0 ",
				"Polygon Outer Boundary",
				"1974",
				"0300047",
				"Esteban Echeverria",
				"Esteban Echeverria",
				"0047",
				"2015/07/24",
				"La Paz II",
				"Asentamiento Precario",
				"2007",
				"120",
				"3.0200000000000000000000000000000",
				"Elizalde ( Arooyo Santa Catalina) entre Paz y San Juan",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.54774475470185,-38.04411153162131,0.0 -57.54751944914461,-38.04395099378971,0.0 -57.54512918181717,-38.0458098313343,0.0 -57.54525256343185,-38.04588164911072,0.0 -57.54774475470185,-38.04411153162131,0.0 ",
				"Polygon Outer Boundary",
				"1337",
				"0450056",
				"General Pueyrredon",
				"Mar Del Plata",
				"0056",
				"2015/02/04",
				"Puerto",
				"Villa",
				"90_o_anterior",
				"70",
				"0.5899999999999999700000000000000",
				"Bermejo, Figuroa Alcorta,",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.72261047363281,-34.57149657453589,0.0 -58.7225023006353,-34.5713277186203,0.0 -58.7221266032017,-34.5715357386563,0.0 -58.7218024669903,-34.5717974564974,0.0 -58.721369456493,-34.5720735800759,0.0 -58.7208518544426,-34.5724798461367,0.0 -58.7203561446766,-34.5728453486397,0.0 -58.719312051669,-34.5735476623095,0.0 -58.7187617986044,-34.573919609544,0.0 -58.718994855880744,-34.574115910592575,0.0 -58.719338178634644,-34.57387297395816,0.0 -58.71962249279022,-34.57367420709289,0.0 -58.72261047363281,-34.57149657453589,0.0 ",
				"Polygon Outer Boundary",
				"721",
				"1310013",
				"San Miguel",
				"San Miguel",
				"0013",
				"2014/10/01",
				"Pichincha & Azcuenaga",
				"Otros",
				"90_o_anterior",
				"509",
				"1.1699999999999999000000000000000",
				"Pichincha, Azcuenaga, Bramante y Pardo",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.9326063171029,-34.61835828578114,0.0 -58.93201623111963,-34.618888044649424,0.0 -58.93343243747949,-34.61962087217641,0.0 -58.93386159092188,-34.61906463018743,0.0 -58.9326063171029,-34.61835828578114,0.0 ",
				"Polygon Outer Boundary",
				"2175",
				"0460006",
				"General Rodriguez",
				"General Rodriguez",
				"0006",
				"2015/09/09",
				"Tuyuti & Comandante Patino",
				"Asentamiento Precario",
				"2015",
				"12",
				"1.1100000000000001000000000000000",
				"Tuyuti & Cmte Patino",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.58440508207422,-34.514066497313635,0.0 -58.58410467466455,-34.514367071139525,0.0 -58.58301033338648,-34.51528646669959,0.0 -58.58127226194483,-34.51666554101742,0.0 -58.57721676191431,-34.51972417567077,0.0 -58.57723821958643,-34.51988329231966,0.0 -58.57781757673364,-34.519777214587506,0.0 -58.57983459791284,-34.51931754285393,0.0 -58.58131517728907,-34.51887554841046,0.0 -58.58217348417383,-34.51878714924035,0.0 -58.58328928312403,-34.518857868583936,0.0 -58.586765426007325,-34.51608208928416,0.0 -58.58440508207422,-34.514066497313635,0.0 ",
				"Polygon Outer Boundary",
				"1810",
				"0470096",
				"General San Martin",
				"General San Martin",
				"0096",
				"2015/06/26",
				"El Basural",
				"Otros",
				"90_o_anterior",
				"420",
				"20.2899999999999990000000000000000",
				"Andrade, Italia, Libertad",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.662139630527,-34.5854961248488,0.0 -58.6621839394267,-34.5854515427948,0.0 -58.6621903988953,-34.5853885186319,0.0 -58.662110263054,-34.5852884907843,0.0 -58.6619760777033,-34.585160829528,0.0 -58.6618958700939,-34.5850653075393,0.0 -58.6618450713951,-34.5848349044715,0.0 -58.661788702011116,-34.58464984359024,0.0 -58.6617005389489,-34.58433306632,0.0 -58.661665320396416,-34.58428327631006,0.0 -58.661654591560364,-34.58419936309078,0.0 -58.66170823574066,-34.58402270340479,0.0 -58.661702871322625,-34.583960872426,0.0 -58.6614907017457,-34.5838260048867,0.0 -58.66127371788025,-34.584013870410644,0.0 -58.66135954856872,-34.58411103329473,0.0 -58.6612468957901,-34.58432302464752,0.0 -58.66129517555237,-34.584402521265375,0.0 -58.661348819732666,-34.58449526722345,0.0 -58.661407828330994,-34.58457918014395,0.0 -58.66145074367523,-34.58468517529083,0.0 -58.66131663322448,-34.58480441966949,0.0 -58.662139630527,-34.5854961248488,0.0 ",
				"Polygon Outer Boundary",
				"124",
				"1350029",
				"Hurlingham",
				"Hurlingham",
				"0029",
				"2014/07/23",
				"Villegas",
				"Villa",
				"90_o_anterior",
				"47",
				"0.5500000000000000400000000000000",
				"General Villegas, Bustamante y Arroyo Moron",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-57.547409059479826,-37.93197053039094,0.0 -57.54654538817704,-37.93125123349795,0.0 -57.54612159915269,-37.93153049077453,0.0 -57.546368362382054,-37.9317462797617,0.0 -57.54648637957871,-37.93172512400665,0.0 -57.546566845849156,-37.93173781746041,0.0 -57.546625854447484,-37.93177166665973,0.0 -57.54682433791458,-37.93192398786378,0.0 -57.54710865207017,-37.93218631808648,0.0 -57.547162296250455,-37.93219054921143,0.0 -57.54743051715196,-37.93200014834744,0.0 -57.547409059479826,-37.93197053039094,0.0 ",
				"Polygon Outer Boundary",
				"1343",
				"0450060",
				"General Pueyrredon",
				"Mar Del Plata",
				"0060",
				"2015/02/05",
				"Los Ceibos & Los Manzanos",
				"Asentamiento Precario",
				"90_o_anterior",
				"20",
				"0.4500000000000000100000000000000",
				"Los Ceibos, Los Manzanos, Las Lambercianas",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-60.158856036141515,-35.42819880929448,0.0 -60.156704904511564,-35.42843485138973,0.0 -60.15689265914261,-35.42927847766805,0.0 -60.159006239846356,-35.429090520246795,0.0 -60.159006239846356,-35.429016211377856,0.0 -60.158856036141515,-35.42819880929448,0.0 ",
				"Polygon Outer Boundary",
				"1342",
				"1090002",
				"Veinticinco de Mayo",
				"25 De Mayo",
				"0002",
				"2015/02/05",
				"La Cañonera",
				"Otros",
				"decada_1940",
				"82",
				"1.9099999999999999000000000000000",
				"33,102, 34, 104",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.63801360130309,-34.7133869899754,0.0 -58.63878607749939,-34.71281373860129,0.0 -58.63945126533508,-34.712302218636,0.0 -58.637123107910156,-34.71072354224359,0.0 -58.63358259201049,-34.708395160059105,0.0 -58.633389472961426,-34.70858037467772,0.0 -58.63683342933655,-34.710961668545366,0.0 -58.63649010658264,-34.711261530320535,0.0 -58.637627363204956,-34.7120640961937,0.0 -58.63690853118896,-34.71256679832337,0.0 -58.63801360130309,-34.7133869899754,0.0 ",
				"Polygon Outer Boundary",
				"1445",
				"0700121",
				"La Matanza",
				"Rafael Castillo",
				"0121",
				"2015/03/13",
				"El Torero",
				"Asentamiento Precario",
				"2008",
				"210",
				"4.8600000000000003000000000000000",
				"Merou, Dávila, Andrade y Aguirre",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.357969522476196,-34.67468801769445,0.0 -58.35617244243621,-34.67536300091449,0.0 -58.356242179870605,-34.67546005687285,0.0 -58.35637629032136,-34.67555711271748,0.0 -58.35690200328827,-34.67511594887088,0.0 -58.35734188556672,-34.67544682197614,0.0 -58.35809826850891,-34.674802721113274,0.0 -58.35809290409088,-34.674767427770554,0.0 -58.357969522476196,-34.67468801769445,0.0 ",
				"Polygon Outer Boundary",
				"1425",
				"0040048",
				"Avellaneda",
				"Sarandi",
				"0048",
				"2015/03/03",
				"Viaducto",
				"Villa",
				"90_o_anterior",
				"35",
				"0.4899999999999999900000000000000",
				"Belgrano, Spurr, Autopista",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.645834922790534,-34.61322386423131,0.0 -58.64533603191376,-34.612813273386045,0.0 -58.645180463790894,-34.6129457222677,0.0 -58.64555597305298,-34.61343136635911,0.0 -58.6456438383927,-34.6134093165268,0.0 -58.645834922790534,-34.61322386423131,0.0 ",
				"Polygon Outer Boundary",
				"114",
				"1350020",
				"Hurlingham",
				"Santo Tesei",
				"0020",
				"2014/07/23",
				"Cristo Obrero",
				"Villa",
				"decada_1980",
				"19",
				"0.1799999999999999900000000000000",
				"Granada -Floresta - Moises Levensohn",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-57.63996136374771,-37.99099656578625,0.0 -57.636804822832346,-37.98845142334811,0.0 -57.63567829504609,-37.98921243864636,0.0 -57.63348961248993,-37.987487459304695,0.0 -57.62833666987717,-37.991372833505196,0.0 -57.633581645786755,-37.995756844338736,0.0 -57.63996136374771,-37.99099656578625,0.0 ",
				"Polygon Outer Boundary",
				"1325",
				"0450045",
				"General Pueyrredon",
				"Mar Del Plata - Barrio Autódromo",
				"0045",
				"2015/02/02",
				"Calle 258 & Vértiz",
				"Otros",
				"90_o_anterior",
				"700",
				"47.8299999999999980000000000000000",
				"Calle 258, Av. Vertiz,",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.620203733444214,-34.62298914680185,0.0 -58.62010717391967,-34.622662478709294,0.0 -58.61962437629699,-34.62273752419569,0.0 -58.6197155714035,-34.623073020834354,0.0 -58.620203733444214,-34.62298914680185,0.0 ",
				"Polygon Outer Boundary",
				"121",
				"1350026",
				"Hurlingham",
				"Villa Tesei",
				"0026",
				"2014/07/23",
				"Del Río",
				"Otros",
				"decada_1980",
				"12",
				"0.1700000000000000100000000000000",
				"Alvarez Rodriguez, Martin de Alzaga, Husares y Arroyo Moron",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.6626551781464,-34.5772009946267,0.0 -58.6626077484736,-34.5771957877996,0.0 -58.6619828842945,-34.5776242943104,0.0 -58.6619786792428,-34.5776622855108,0.0 -58.6629834649627,-34.5786606454569,0.0 -58.6630296125349,-34.5786643057926,0.0 -58.663645711747,-34.5782457031121,0.0 -58.663650245837,-34.5782075351801,0.0 -58.6626551781464,-34.5772009946267,0.0 ",
				"Polygon Outer Boundary",
				"119",
				"1350025",
				"Hurlingham",
				"William Morris",
				"0025",
				"2014/07/23",
				"La Chimenea",
				"Asentamiento Precario",
				"decada_1980",
				"61",
				"1.2000000000000000000000000000000",
				"Olascoaga - Dol Huici, Adrogue - Cañuelas",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.35851132869721,-34.7838930339275,0.0 -58.35762083530425,-34.783417200959285,0.0 -58.357577919960015,-34.78329824228835,0.0 -58.356832265853875,-34.78287087083308,0.0 -58.35644066333771,-34.783276212886015,0.0 -58.35727751255035,-34.783765264233374,0.0 -58.35811972618103,-34.784324805912156,0.0 -58.35851132869721,-34.7838930339275,0.0 ",
				"Polygon Outer Boundary",
				"1982",
				"0030061",
				"Almirante Brown",
				"José Marmol",
				"0061",
				"2015/07/25",
				"Martín Arín",
				"Asentamiento Precario",
				"1987",
				"110",
				"1.0800000000000001000000000000000",
				"Martín Arín, Entre Ríos, Rosales, Piedrabuena, Bouchard y Lavalle",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.6612016818066,-34.3961543379384,0.0 -58.661627769470215,-34.39642849679319,0.0 -58.66264700889587,-34.39495005189393,0.0 -58.66230905055999,-34.394742005156246,0.0 -58.661665320396416,-34.39440116151091,0.0 -58.66106986999512,-34.394122288405015,0.0 -58.6607957845614,-34.3944598916776,0.0 -58.660096929014,-34.3953740838962,0.0 -58.6599832537227,-34.3955268853479,0.0 -58.6599937594395,-34.3955909084878,0.0 -58.6604629480819,-34.3958309472168,0.0 -58.6606671700524,-34.3959326961704,0.0 -58.6608160367587,-34.3960076083692,0.0 -58.6611579448754,-34.3961763039175,0.0 -58.6612016818066,-34.3961543379384,0.0 ",
				"Polygon Outer Boundary",
				"683",
				"0570033",
				"Tigre",
				"Benavidez",
				"0033",
				"2014/10/01",
				"San Luis",
				"Otros",
				"90_o_anterior",
				"100",
				"3.3799999999999999000000000000000",
				"Diego Palma, Riestra, Av. Cazón, Padre Rebagliatti",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.65128517150879,-34.74282031083205,0.0 -58.65482568740845,-34.74005642303666,0.0 -58.65426242351532,-34.73961560303671,0.0 -58.65365087985993,-34.7390777994518,0.0 -58.65324318408965,-34.73871191468414,0.0 -58.652717471122735,-34.738332803456714,0.0 -58.65154266357422,-34.73919241362406,0.0 -58.65105450153351,-34.7387868550697,0.0 -58.65074872970582,-34.73897640985919,0.0 -58.65036249160766,-34.73926294534336,0.0 -58.650636076927185,-34.739505397669234,0.0 -58.649890422821045,-34.74010050490732,0.0 -58.64975094795227,-34.74023275037812,0.0 -58.64956319332123,-34.74036058746536,0.0 -58.6489462852478,-34.74084107681745,0.0 -58.649885058403015,-34.74161249883172,0.0 -58.6501433943485,-34.7418028921478,0.0 -58.65128517150879,-34.74282031083205,0.0 ",
				"Polygon Outer Boundary",
				"1044",
				"0700086",
				"La Matanza",
				"González Catán",
				"0086",
				"2014/10/01",
				"Armonía",
				"Asentamiento Precario",
				"2011",
				"110",
				"13.4400000000000000000000000000000",
				"Armonía y San Matías",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.6235274993226,-34.611973412197,0.0 -58.6235280077162,-34.6119360119915,0.0 -58.6234316530589,-34.6115716814002,0.0 -58.6230499770201,-34.6116376787001,0.0 -58.6230260699568,-34.6115471838955,0.0 -58.6222654565536,-34.6116717244928,0.0 -58.6223885493977,-34.6121858013849,0.0 -58.6235274993226,-34.611973412197,0.0 ",
				"Polygon Outer Boundary",
				"105",
				"1350012",
				"Hurlingham",
				"Hurlingham",
				"0012",
				"2014/07/23",
				"Parque Quirno II",
				"Asentamiento Precario",
				"decada_1990",
				"16",
				"0.5699999999999999500000000000000",
				"Cafayate - Esquina Diego de Carabajal",
				"Cobertura Parcial",
				"Cobertura Total",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.54484486766159,-37.92034244510794,0.0 -57.54348230548204,-37.91921677592221,0.0 -57.54342866130173,-37.91921677592221,0.0 -57.54277420230209,-37.91969074399506,0.0 -57.54276883788407,-37.91975422163003,0.0 -57.54313898272813,-37.920033522573036,0.0 -57.54349839873611,-37.9197711489901,0.0 -57.54438352771103,-37.92052018077286,0.0 -57.54447472281754,-37.92043131299409,0.0 -57.544576646760106,-37.920507485382466,0.0 -57.54484486766159,-37.92034244510794,0.0 ",
				"Polygon Outer Boundary",
				"1348",
				"0450064",
				"General Pueyrredon",
				"Mar Del Plata",
				"0064",
				"2015/02/05",
				"Ringuelet & Los Helechos",
				"Asentamiento Precario",
				"decada_2000",
				"10",
				"0.9399999999999999500000000000000",
				"Ringuelet, Los Helechos, Las Maravillas, Cabrera",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.53817153163254,-37.91752400787114,0.0 -57.537801386788495,-37.91779062142397,0.0 -57.53815007396042,-37.918086857571446,0.0 -57.53849339671433,-37.91783717289759,0.0 -57.53849339671433,-37.91778215751651,0.0 -57.53817153163254,-37.91752400787114,0.0 ",
				"Polygon Outer Boundary",
				"1350",
				"0450065",
				"General Pueyrredon",
				"Mar Del Plata",
				"0065",
				"2015/02/05",
				"Los Quebrachos & Dieckmann",
				"Asentamiento Precario",
				"decada_2000",
				"12",
				"0.2000000000000000100000000000000",
				"Los Quebrachos, Dieckmann, Los cerezos,",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Sin dato",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.275502659380436,-34.86572186096878,0.0 -58.272498585283756,-34.864454226992414,0.0 -58.27165100723505,-34.865545801862744,0.0 -58.274311758577824,-34.867007081023964,0.0 -58.274515606462955,-34.866364473507176,0.0 -58.27489111572505,-34.86647010796442,0.0 -58.27497694641352,-34.86626764180217,0.0 -58.2751915231347,-34.86634686775111,0.0 -58.275502659380436,-34.86572186096878,0.0 ",
				"Polygon Outer Boundary",
				"1554",
				"0320002",
				"Florencio Varela",
				"Florencio Varela",
				"0002",
				"2015/04/20",
				"San Francisco Chico",
				"Asentamiento Precario",
				"90_o_anterior",
				"230",
				"4.8099999999999996000000000000000",
				"Calle 1323, Av. Eva Perón, calle 1332",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.693030834198,-38.8323031671726,0.0 -62.69277334213256,-38.83338128910824,0.0 -62.69150733947753,-38.83318906701361,0.0 -62.69179701805115,-38.83213601502274,0.0 -62.68905211240053,-38.83165127156842,0.0 -62.688451297581196,-38.83370722973443,0.0 -62.68978167325258,-38.83397466708216,0.0 -62.689586877822876,-38.835111264599306,0.0 -62.69020915031433,-38.835211551744095,0.0 -62.69088506698608,-38.83532855323442,0.0 -62.69117642194032,-38.83422538868302,0.0 -62.69389986991882,-38.83455132544376,0.0 -62.694545276463025,-38.832570609795916,0.0 -62.693030834198,-38.8323031671726,0.0 ",
				"Polygon Outer Boundary",
				"1351",
				"1110004",
				"Villarino",
				"Médanos",
				"0004",
				"2015/02/05",
				"Hospital",
				"Otros",
				"90_o_anterior",
				"97",
				"11.6099999999999990000000000000000",
				"Matheu, Uriarte, Bustamante y Medrano",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Sin dato",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-62.70558357238769,-38.82995464348197,0.0 -62.702751159667976,-38.82945316931001,0.0 -62.70219326019287,-38.83148411788771,0.0 -62.70510077476501,-38.8319187166411,0.0 -62.70558357238769,-38.82995464348197,0.0 ",
				"Polygon Outer Boundary",
				"1349",
				"1110003",
				"Villarino",
				"Médanos",
				"0003",
				"2015/02/05",
				"Africa",
				"Otros",
				"90_o_anterior",
				"180",
				"14.7100000000000010000000000000000",
				"Alberti,  Lavalle, Laprida",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-62.69978547468781,-38.831308606100514,0.0 -62.699045184999704,-38.83108294745252,0.0 -62.69643807783722,-38.83065670138782,0.0 -62.69589090719819,-38.832587324926514,0.0 -62.69592309370637,-38.83266254296561,0.0 -62.69862676039338,-38.833088777019036,0.0 -62.701523546129465,-38.833606940469956,0.0 -62.70181322470307,-38.83264582785267,0.0 -62.699527982622385,-38.83226137917194,0.0 -62.699527982622385,-38.83219451831984,0.0 -62.69978547468781,-38.831308606100514,0.0 ",
				"Polygon Outer Boundary",
				"1349",
				"1110003",
				"Villarino",
				"Médanos",
				"0003",
				"2015/02/05",
				"Africa",
				"Otros",
				"90_o_anterior",
				"180",
				"14.7100000000000010000000000000000",
				"Alberti,  Lavalle, Laprida",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.5751174101606,-38.044918440128214,0.0 -57.57483309600502,-38.045136008177316,0.0 -57.575083673000336,-38.045353575579895,0.0 -57.575416266918175,-38.04511699740269,0.0 -57.57517641875893,-38.04492266475668,0.0 -57.5751174101606,-38.044918440128214,0.0 ",
				"Polygon Outer Boundary",
				"1346",
				"0450062",
				"General Pueyrredon",
				"Mar Del Plata",
				"0062",
				"2015/02/05",
				"Puan & Santa Cecilia",
				"Villa",
				"90_o_anterior",
				"30",
				"0.1300000000000000000000000000000",
				"Puan, Santa Cecilia, Gianelli",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.56219452712684,-38.04771509084036,0.0 -57.561566890217364,-38.04719759177725,0.0 -57.561502517201006,-38.047199704025765,0.0 -57.561173737049096,-38.04744261219779,0.0 -57.56172627210617,-38.0479115283024,0.0 -57.561628581024706,-38.0479685584346,0.0 -57.56159103009849,-38.047934762806065,0.0 -57.561510563828044,-38.04798968069449,0.0 -57.5609446177259,-38.04782703913602,0.0 -57.56114846561103,-38.047998129596756,0.0 -57.56146764848381,-38.04809106745723,0.0 -57.56153470370918,-38.04814176078593,0.0 -57.561609805561595,-38.04807416967319,0.0 -57.56185388658195,-38.04801502739835,0.0 -57.56219720933586,-38.047750998802904,0.0 -57.56219452712684,-38.04771509084036,0.0 ",
				"Polygon Outer Boundary",
				"1345",
				"0450061",
				"General Pueyrredon",
				"Mar Del Plata",
				"0061",
				"2015/02/05",
				"Triunvirato & Fournier",
				"Villa",
				"90_o_anterior",
				"40",
				"0.4699999999999999700000000000000",
				"Triunvirato, Fournier, Soler, Padre Dutto",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6218865416302,-34.6030276589502,0.0 -58.621839366335,-34.603026134542,0.0 -58.6216726028085,-34.6031569290934,0.0 -58.621639719734,-34.604130915742,0.0 -58.6216930892166,-34.6041468416653,0.0 -58.6219096454904,-34.6039648721947,0.0 -58.6219296107017,-34.6039836655163,0.0 -58.62203977674,-34.6039004535383,0.0 -58.6220185888235,-34.6038830885816,0.0 -58.6224455200556,-34.6035565743535,0.0 -58.6224378468469,-34.6035129525491,0.0 -58.6218865416302,-34.6030276589502,0.0 ",
				"Polygon Outer Boundary",
				"54",
				"1350002",
				"Hurlingham",
				"Hurlingham",
				"0002",
				"2014/07/23",
				"El Progreso",
				"Asentamiento Precario",
				"decada_1980",
				"18",
				"0.5200000000000000200000000000000",
				"S. Gaboto - Fernandez - Arroyo Morón",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.56741947028786,-38.05479706754937,0.0 -57.5666711339727,-38.05534196907106,0.0 -57.567070783115916,-38.05566299442506,0.0 -57.56780839059502,-38.05510331115195,0.0 -57.56741947028786,-38.05479706754937,0.0 ",
				"Polygon Outer Boundary",
				"1347",
				"0450063",
				"General Pueyrredon",
				"Mar Del Plata",
				"0063",
				"2015/02/05",
				"Rondeau & Sicilia",
				"Villa",
				"90_o_anterior",
				"50",
				"0.4400000000000000000000000000000",
				"Rondeau, Sicilia, Posadas, Calabria",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-59.4975250289385,-33.8044196627419,0.0 -59.49606607294,-33.8056640661495,0.0 -59.4953596744721,-33.8070984233528,0.0 -59.4948454520401,-33.8074375976502,0.0 -59.4939973135082,-33.8074170707525,0.0 -59.4932989431143,-33.8070706991391,0.0 -59.4914189078856,-33.8081592541466,0.0 -59.4921065533226,-33.808909890827,0.0 -59.4923882972065,-33.8089695438437,0.0 -59.4928511942683,-33.8087644574105,0.0 -59.4937163936281,-33.8083600576811,0.0 -59.4940833869477,-33.8084029992036,0.0 -59.4944250873614,-33.8083059136039,0.0 -59.4945798372971,-33.8082163030265,0.0 -59.4946649201616,-33.8081279394951,0.0 -59.4950149309963,-33.8079281478251,0.0 -59.4956194129007,-33.8075395303244,0.0 -59.4957677753805,-33.8077282895423,0.0 -59.4962998800419,-33.8074157337491,0.0 -59.4960822981747,-33.8071150809926,0.0 -59.4968638560075,-33.8066945445637,0.0 -59.4969334276684,-33.8067093432068,0.0 -59.4971685044021,-33.8070473898214,0.0 -59.4974410399823,-33.8069122373188,0.0 -59.4980058690731,-33.8064826458707,0.0 -59.498387669108,-33.8062923499484,0.0 -59.4984162748426,-33.8060355255371,0.0 -59.4988673267105,-33.805784655282,0.0 -59.4984453152561,-33.805222899445,0.0 -59.4978357298891,-33.8046043926657,0.0 -59.4975250289385,-33.8044196627419,0.0 ",
				"Polygon Outer Boundary",
				"436",
				"0090001",
				"Baradero",
				"Baradero",
				"0001",
				"2014/08/11",
				"Tiro Federal",
				"Villa",
				"decada_1980",
				"127",
				"9.5999999999999996000000000000000",
				"Serrano 600 al 1500 (Mapa adjunto)",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-62.701828479766846,-39.49822919966319,0.0 -62.700583934783936,-39.497997391628786,0.0 -62.699317932128906,-39.50102739280199,0.0 -62.69974708557128,-39.50106050683923,0.0 -62.6997685432434,-39.50106050683923,0.0 -62.69974708557128,-39.50109362086071,0.0 -62.70075559616088,-39.50120951981158,0.0 -62.701828479766846,-39.49822919966319,0.0 ",
				"Polygon Outer Boundary",
				"598",
				"1110001",
				"Villarino",
				"Pedro Luro",
				"0001",
				"2012/01/01",
				"Matadero",
				"Otros",
				"2000",
				"31",
				"4.0899999999999999000000000000000",
				"sin dato",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.44547407701611,-34.69061262593854,0.0 -58.444470930844545,-34.692090238991646,0.0 -58.44617145135999,-34.69302531183275,0.0 -58.44660060480236,-34.6925974732117,0.0 -58.44630556181073,-34.69240340135552,0.0 -58.44662742689252,-34.6921784538619,0.0 -58.44681518152356,-34.69197997027161,0.0 -58.44657378271222,-34.69185646913076,0.0 -58.446734715253115,-34.691715324744166,0.0 -58.44658987596631,-34.69161828783875,0.0 -58.446906376630075,-34.691384516644945,0.0 -58.44547407701611,-34.69061262593854,0.0 ",
				"Polygon Outer Boundary",
				"2179",
				"0630078",
				"Lomas de Zamora",
				"Lomas de Zamora",
				"0078",
				"2015/09/10",
				"Soledad",
				"Villa",
				"2000",
				"180",
				"3.2799999999999998000000000000000",
				"Gral. Hornos y 17 de Octubre",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.723287518034795,-34.56333205290833,0.0 -58.72190886260113,-34.56433042364285,0.0 -58.72239053249359,-34.56480430415902,0.0 -58.72385614634595,-34.56384007491247,0.0 -58.723287518034795,-34.56333205290833,0.0 ",
				"Polygon Outer Boundary",
				"2114",
				"1310024",
				"San Miguel",
				"San Miguel",
				"0024",
				"2015/08/13",
				"Maestro Sarmiento & Las Heras",
				"Asentamiento Precario",
				"2004",
				"30",
				"1.2400000000000000000000000000000",
				"Maestro Sarmiento, Gral. Las Heras, Conesa",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.66219639778137,-34.62112182402032,0.0 -58.658913373947144,-34.61832296840303,0.0 -58.65702509880066,-34.61987691882311,0.0 -58.660383224487305,-34.62263157760694,0.0 -58.66219639778137,-34.62112182402032,0.0 ",
				"Polygon Outer Boundary",
				"116",
				"1350022",
				"Hurlingham",
				"Santo Tesei",
				"0022",
				"2014/07/23",
				"2 de Abril",
				"Asentamiento Precario",
				"decada_1990",
				"249",
				"10.4300000000000000000000000000000",
				"Padre Solanet - La Trilla - Fitz Roy - Juramento",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.5894850651252,-37.9607099232531,0.0 -57.5905534302315,-37.9601783167846,0.0 -57.5913196021291,-37.9597956721567,0.0 -57.5901459737026,-37.9582884988912,0.0 -57.5884746108298,-37.959130382848,0.0 -57.5885102086625,-37.9591967768835,0.0 -57.5883422959074,-37.9592800741887,0.0 -57.5883282520887,-37.9593198690557,0.0 -57.5888191791068,-37.9599275783812,0.0 -57.5894431611981,-37.9607041100819,0.0 -57.5894850651252,-37.9607099232531,0.0 ",
				"Polygon Outer Boundary",
				"474",
				"0450004",
				"General Pueyrredon",
				"Mar Del Plata",
				"0004",
				"2014/09/01",
				"Beruti",
				"Asentamiento Precario",
				"decada_1990",
				"100",
				"2.5000000000000000000000000000000",
				"Beruti, rauch, río Negro, Cnel. Suarez",
				"Inexistente",
				"Sin dato",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-57.6123708349108,-37.975440505989,0.0 -57.6114807527653,-37.9758864877206,0.0 -57.6120695283904,-37.9766195819671,0.0 -57.6129575081831,-37.9761719318643,0.0 -57.6123708349108,-37.975440505989,0.0 ",
				"Polygon Outer Boundary",
				"437",
				"0450009",
				"General Pueyrredon",
				"Mar Del Plata",
				"0009",
				"2014/09/03",
				"Bolivia & Gascón",
				"Asentamiento Precario",
				"decada_1990",
				"10",
				"0.5000000000000000000000000000000",
				"Bolivia, Gascón, Pigue",
				"Inexistente",
				"Sin dato",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.6675414048551,-34.5805751052904,0.0 -58.666085600852966,-34.57944708672096,0.0 -58.665913939476006,-34.57959725574515,0.0 -58.665817379951484,-34.579712090698244,0.0 -58.6655855628132,-34.5799183985082,0.0 -58.665372133255,-34.58011842848905,0.0 -58.66529703140259,-34.58025534621026,0.0 -58.66517901420593,-34.580343680104235,0.0 -58.665313124656684,-34.58042759721655,0.0 -58.66543650627136,-34.580551264385555,0.0 -58.66553306579589,-34.58071468143378,0.0 -58.66559207439422,-34.58090901480263,0.0 -58.66562962532043,-34.58099293134416,0.0 -58.66565108299255,-34.58108126445425,0.0 -58.6656585160037,-34.5811495499063,0.0 -58.66576373577118,-34.58125793039277,0.0 -58.66589784622193,-34.58137276305144,0.0 -58.666643500328064,-34.58175700964022,0.0 -58.667163848876946,-34.58133301330294,0.0 -58.666938543319695,-34.58111659767199,0.0 -58.6675414048551,-34.5805751052904,0.0 ",
				"Polygon Outer Boundary",
				"98",
				"1350005",
				"Hurlingham",
				"William Morris",
				"0005",
				"2014/07/23",
				"San Damián",
				"Otros",
				"decada_1980",
				"200",
				"2.9399999999999999000000000000000",
				"Ofelia C. Ojeda y Eva Perón",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.57361376285552,-34.550097086814645,0.0 -58.57313096523284,-34.54967734735024,0.0 -58.57290029525757,-34.54985408001437,0.0 -58.57272863388061,-34.54971711223239,0.0 -58.57242286205292,-34.54993802789834,0.0 -58.572766184806824,-34.549968956044765,0.0 -58.573227524757385,-34.55005290381283,0.0 -58.57361376285552,-34.550097086814645,0.0 ",
				"Polygon Outer Boundary",
				"831",
				"0470036",
				"General San Martin",
				"Villa Gral. Sucre",
				"0036",
				"2014/10/01",
				"Formosa & Reconquista",
				"Asentamiento Precario",
				"90_o_anterior",
				"45",
				"0.2200000000000000000000000000000",
				"Formosa y Roconquista",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.648431301116936,-34.619325093170204,0.0 -58.64820063114166,-34.619113191144514,0.0 -58.6478693448226,-34.619369400457,0.0 -58.6478686870145,-34.6194099539251,0.0 -58.6480987071991,-34.61958114072941,0.0 -58.648431301116936,-34.619325093170204,0.0 ",
				"Polygon Outer Boundary",
				"113",
				"1350019",
				"Hurlingham",
				"Santo Tesei",
				"0019",
				"2014/07/23",
				"Barrio Mitre",
				"Asentamiento Precario",
				"decada_1980",
				"20",
				"0.1400000000000000100000000000000",
				"Mar del Plata - Esquina Valdez",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-60.61386823654174,-33.882244760099574,0.0 -60.61365399509668,-33.882289294686245,0.0 -60.6130313873291,-33.88247633969643,0.0 -60.61186194419861,-33.879937836722,0.0 -60.6102529540658,-33.88046335757177,0.0 -60.610370971262455,-33.880730570321916,0.0 -60.61098251491784,-33.880614778232925,0.0 -60.61232328414917,-33.88344718578064,0.0 -60.611684918403625,-33.88366985534342,0.0 -60.610767602920525,-33.88396823164643,0.0 -60.611491799354546,-33.88540220469329,0.0 -60.61491999775171,-33.88423098006414,0.0 -60.61386823654174,-33.882244760099574,0.0 ",
				"Polygon Outer Boundary",
				"2215",
				"0820018",
				"Pergamino",
				"Pergamino",
				"0018",
				"2015/09/21",
				"Mastrangelo",
				"Asentamiento Precario",
				"2007",
				"65",
				"10.5200000000000000000000000000000",
				"Ruta 178 y s/n",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.6072927880015,-34.6684554618438,0.0 -58.60697507858276,-34.66819378044358,0.0 -58.60679537057876,-34.66834599495587,0.0 -58.6069107055664,-34.66844526513928,0.0 -58.606749773025506,-34.66857321320024,0.0 -58.60696166753769,-34.66875410494923,0.0 -58.6072988989259,-34.6684914487807,0.0 -58.6072927880015,-34.6684554618438,0.0 ",
				"Polygon Outer Boundary",
				"138",
				"1010005",
				"Moron",
				"Moron",
				"0005",
				"2014/10/31",
				"Los Olivos",
				"Otros",
				"1970",
				"15",
				"0.2099999999999999900000000000000",
				"Los Olivos, Santa Teresa, Ramella, Aguado,",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.607479333877556,-34.669287953905446,0.0 -58.60752493143082,-34.66924162830589,0.0 -58.60707432031631,-34.66885778662727,0.0 -58.60700994729996,-34.66890631843198,0.0 -58.607479333877556,-34.669287953905446,0.0 ",
				"Polygon Outer Boundary",
				"138",
				"1010005",
				"Moron",
				"Moron",
				"0005",
				"2014/10/31",
				"Los Olivos",
				"Otros",
				"1970",
				"15",
				"0.2099999999999999900000000000000",
				"Los Olivos, Santa Teresa, Ramella, Aguado,",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.2813265869248,-34.7483078304057,0.0 -58.28024983406066,-34.74770868340983,0.0 -58.27953100204468,-34.74911475323794,0.0 -58.27875852584838,-34.74862108881492,0.0 -58.278940916061394,-34.748391886472675,0.0 -58.278104066848755,-34.74805689728993,0.0 -58.27802896499634,-34.74783650892876,0.0 -58.27768564224243,-34.747616119979554,0.0 -58.27741742134094,-34.74750151749357,0.0 -58.27731013298034,-34.74778361563458,0.0 -58.27624261379241,-34.74727231204459,0.0 -58.2758617401123,-34.74797755754765,0.0 -58.27672541141509,-34.74837866324123,0.0 -58.27787339687347,-34.74886351367707,0.0 -58.27882289886475,-34.74926461506826,0.0 -58.28024446964264,-34.74989491331892,0.0 -58.2813265869248,-34.7483078304057,0.0 ",
				"Polygon Outer Boundary",
				"912",
				"0860036",
				"Quilmes",
				"Quilmes",
				"0036",
				"2014/10/01",
				"La Vera",
				"Villa",
				"1975",
				"160",
				"5.2400000000000002000000000000000",
				"Joaquín V. González, Gral. Acha, Triunvirato, Lavalleja",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6225411059508,-34.6409585734577,0.0 -58.6223292596856,-34.6411268044807,0.0 -58.6227393199767,-34.6414762008653,0.0 -58.6229499803453,-34.641307144537,0.0 -58.6225411059508,-34.6409585734577,0.0 ",
				"Polygon Outer Boundary",
				"137",
				"1010004",
				"Moron",
				"Moron",
				"0004",
				"2014/10/31",
				"Larrea",
				"Villa",
				"1970",
				"22",
				"0.1499999999999999900000000000000",
				"Larrea, R. Balbin y Jujuy",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.26944589614868,-34.87694485100937,0.0 -58.26879998669028,-34.877772210814705,0.0 -58.268220629543066,-34.878485141839676,0.0 -58.26943298801779,-34.87915405915396,0.0 -58.27001770958304,-34.87844553472274,0.0 -58.26970875263214,-34.87821229242473,0.0 -58.270352482795715,-34.87741574298343,0.0 -58.26944589614868,-34.87694485100937,0.0 ",
				"Polygon Outer Boundary",
				"1555",
				"0320003",
				"Florencio Varela",
				"Florencio Varela",
				"0003",
				"2015/04/20",
				"Cura Brochero",
				"Asentamiento Precario",
				"90_o_anterior",
				"90",
				"2.3599999999999999000000000000000",
				"calle 1360, calle 1317 A, calle 1313",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.6473928855114,-34.5831089176171,0.0 -58.647054082867,-34.5827981601278,0.0 -58.6467323675115,-34.5830200217248,0.0 -58.6469304121938,-34.5832202455773,0.0 -58.646238208604,-34.5836134008858,0.0 -58.6462923751071,-34.5836737616327,0.0 -58.6473928855114,-34.5831089176171,0.0 ",
				"Polygon Outer Boundary",
				"97",
				"1350004",
				"Hurlingham",
				"Hurlingham",
				"0004",
				"2014/07/23",
				"Libertad",
				"Villa",
				"decada_1980",
				"94",
				"1.0000000000000000000000000000000",
				"FFCC S. Martín - M de Aviles - Idel Maestro",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.6471582847873,-34.5827098108095,0.0 -58.6475259512853,-34.5830350392024,0.0 -58.6475284827639,-34.5830364824403,0.0 -58.6486837205405,-34.5824193504771,0.0 -58.6481241111711,-34.5819543622919,0.0 -58.6471582847873,-34.5827098108095,0.0 ",
				"Polygon Outer Boundary",
				"97",
				"1350004",
				"Hurlingham",
				"Hurlingham",
				"0004",
				"2014/07/23",
				"Libertad",
				"Villa",
				"decada_1980",
				"94",
				"1.0000000000000000000000000000000",
				"FFCC S. Martín - M de Aviles - Idel Maestro",
				"Cobertura Parcial",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-57.9504843393655,-34.8331202873995,0.0 -57.9504701773807,-34.8331051788056,0.0 -57.9503247451842,-34.8331695970511,0.0 -57.9500766720758,-34.8332785167528,0.0 -57.9495432323653,-34.8335148313227,0.0 -57.9494318247922,-34.83356468118,0.0 -57.9494318247858,-34.8335646811764,0.0 -57.9493994700571,-34.8335735982364,0.0 -57.9493425964542,-34.8335971527032,0.0 -57.9491140549027,-34.8336632319966,0.0 -57.9489810320709,-34.8337075807502,0.0 -57.9489002240691,-34.8337310910356,0.0 -57.9486888347226,-34.8337930429187,0.0 -57.9485649825267,-34.8338289844538,0.0 -57.9485585324484,-34.8338598771184,0.0 -57.9482718595676,-34.8339737293227,0.0 -57.9481569187916,-34.8340249602933,0.0 -57.948096565133,-34.8340653981081,0.0 -57.9478519005856,-34.8342305157747,0.0 -57.9476723880467,-34.8343468050189,0.0 -57.9475442818251,-34.8344395405103,0.0 -57.9472247593833,-34.8346789143451,0.0 -57.947114052376,-34.8347576131634,0.0 -57.9471086814182,-34.8347934798297,0.0 -57.9473811627263,-34.8350752904494,0.0 -57.9474260948374,-34.8350792932448,0.0 -57.9478068741546,-34.8348247317937,0.0 -57.9483378986501,-34.834492496107,0.0 -57.9484992821753,-34.8343932917819,0.0 -57.9486434574027,-34.8343047924007,0.0 -57.9488568217065,-34.8341456345872,0.0 -57.9492540860797,-34.8339091888423,0.0 -57.949487080647,-34.8337605438001,0.0 -57.9495381338228,-34.8337204005607,0.0 -57.9504843393655,-34.8331202873995,0.0 ",
				"Polygon Outer Boundary",
				"512",
				"1150013",
				"Ensenada",
				"Punta Lara",
				"0013",
				"2014/11/26",
				"Club de Pesca",
				"Asentamiento Precario",
				"decada_1970",
				"71",
				"1.2000000000000000000000000000000",
				"Camino Alte Brown, 3, 23, 26",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.6220359798118,-34.5875259444281,0.0 -58.6216389169059,-34.5871708341558,0.0 -58.6211563811498,-34.5875498086515,0.0 -58.6211572564227,-34.5875627979979,0.0 -58.6220359798118,-34.5875259444281,0.0 ",
				"Polygon Outer Boundary",
				"102",
				"1350009",
				"Hurlingham",
				"Hurlingham",
				"0009",
				"2014/07/23",
				"El Triangulo",
				"Otros",
				"decada_1980",
				"27",
				"0.1700000000000000100000000000000",
				"O´Higgins-Tambo Nuevo - Los Patos",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Sin dato",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.6243057530607,-34.6120087815769,0.0 -58.6242638985345,-34.611988587808,0.0 -58.6237975085549,-34.6120876851265,0.0 -58.6235674748377,-34.6121142031724,0.0 -58.6228555966901,-34.6122425502035,0.0 -58.62143754959106,-34.61246449032012,0.0 -58.621475100517266,-34.61238060556669,0.0 -58.62133562564849,-34.61232321068654,0.0 -58.62105131149291,-34.612751463835636,0.0 -58.620901107788086,-34.613056096174304,0.0 -58.6214065224082,-34.6130414425651,0.0 -58.6242829155128,-34.6130229010895,0.0 -58.6243153092478,-34.6129955950494,0.0 -58.6243057530607,-34.6120087815769,0.0 ",
				"Polygon Outer Boundary",
				"104",
				"1350011",
				"Hurlingham",
				"Villa Tesei",
				"0011",
				"2014/07/23",
				"Nuevo Parque Quirno",
				"Asentamiento Precario",
				"decada_1980",
				"90",
				"2.5899999999999999000000000000000",
				"Cafayate - J. Jufre - Arroyo Morón- Morales",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.66296350955963,-34.59936419702496,0.0 -58.66256654262542,-34.59967329414631,0.0 -58.662469983100884,-34.59955407110721,0.0 -58.662341237068176,-34.59997355881985,0.0 -58.66219103336335,-34.60016784714782,0.0 -58.66228759288787,-34.600260575507754,0.0 -58.66232514381408,-34.600313563095526,0.0 -58.662899136543274,-34.59985433621178,0.0 -58.663478493690484,-34.60035330376418,0.0 -58.6635425383008,-34.6002923035452,0.0 -58.6636644693983,-34.600396736899,0.0 -58.66393957661,-34.6001678163247,0.0 -58.6638243244506,-34.6000626510487,0.0 -58.6634485559566,-34.5997546837278,0.0 -58.66296350955963,-34.59936419702496,0.0 ",
				"Polygon Outer Boundary",
				"117",
				"1350023",
				"Hurlingham",
				"Hurlingham",
				"0023",
				"2014/07/23",
				"Los Patitos",
				"Asentamiento Precario",
				"decada_1980",
				"26",
				"0.7800000000000000300000000000000",
				"Tokio - Amberes - Granada",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.64096939563751,-34.62137345152548,0.0 -58.64076554775238,-34.621126238544534,0.0 -58.6405724287033,-34.62125425964445,0.0 -58.64084601402283,-34.62147939972045,0.0 -58.64096939563751,-34.62137345152548,0.0 ",
				"Polygon Outer Boundary",
				"111",
				"1350017",
				"Hurlingham",
				"Santo Tesei",
				"0017",
				"2014/07/23",
				"Malarredo 2",
				"Villa",
				"decada_1980",
				"10",
				"0.0700000000000000070000000000000",
				"Malarredo e/Chuquisaca y Mazzarello",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.642616271972656,-34.62646764078792,0.0 -58.642707467079155,-34.62640142716235,0.0 -58.64266455173492,-34.62632197074192,0.0 -58.642417788505554,-34.62640142716235,0.0 -58.642160296440125,-34.62644115534403,0.0 -58.642176389694214,-34.62656475400984,0.0 -58.64248216152191,-34.6265073689379,0.0 -58.642616271972656,-34.62646764078792,0.0 ",
				"Polygon Outer Boundary",
				"118",
				"1350024",
				"Hurlingham",
				"Santo Tesei",
				"0024",
				"2014/07/23",
				"El Mastil",
				"Asentamiento Precario",
				"decada_1980",
				"10",
				"0.0700000000000000070000000000000",
				"Ernesto Plass e/Bonorino y El Cóndor",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.655372858047485,-34.574398599600784,0.0 -58.654890060424805,-34.574796129392226,0.0 -58.65506172180176,-34.57495955775511,0.0 -58.6555552482605,-34.57456644574458,0.0 -58.655372858047485,-34.574398599600784,0.0 ",
				"Polygon Outer Boundary",
				"109",
				"1350015",
				"Hurlingham",
				"William Morris",
				"0015",
				"2014/07/23",
				"Barrio Roca 1",
				"Asentamiento Precario",
				"decada_1980",
				"20",
				"0.7099999999999999600000000000000",
				"Garibaldi - Villegas - Gral Levalle",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.652980327606194,-34.576028459665345,0.0 -58.65327000617981,-34.57624488854424,0.0 -58.654396533966064,-34.57549842737815,0.0 -58.65405857563019,-34.575184823350284,0.0 -58.652980327606194,-34.576028459665345,0.0 ",
				"Polygon Outer Boundary",
				"109",
				"1350015",
				"Hurlingham",
				"William Morris",
				"0015",
				"2014/07/23",
				"Barrio Roca 1",
				"Asentamiento Precario",
				"decada_1980",
				"20",
				"0.7099999999999999600000000000000",
				"Garibaldi - Villegas - Gral Levalle",
				"Cobertura Total",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.6196647281919,-34.6181029980063,0.0 -58.6194657972784,-34.6180937160496,0.0 -58.6193910270771,-34.618072589436,0.0 -58.6192839087307,-34.6180626338343,0.0 -58.6191920168288,-34.618265568303,0.0 -58.618912655425,-34.6186360134901,0.0 -58.6186182358498,-34.6193754789006,0.0 -58.6195930520591,-34.6193830002492,0.0 -58.6196175667268,-34.6193445197998,0.0 -58.6196048904323,-34.618220397217,0.0 -58.6196647281919,-34.6181029980063,0.0 ",
				"Polygon Outer Boundary",
				"103",
				"1350010",
				"Hurlingham",
				"Villa Tesei",
				"0010",
				"2014/07/23",
				"La Juanita",
				"Asentamiento Precario",
				"decada_1980",
				"45",
				"0.9300000000000000500000000000000",
				"Niza - Cetrangolo - Manuela Pedraza",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.64650011062622,-34.61452184773933,0.0 -58.6469292640686,-34.61418190163937,0.0 -58.646639585495,-34.61396115667311,0.0 -58.6462265253067,-34.614305518564066,0.0 -58.64650011062622,-34.61452184773933,0.0 ",
				"Polygon Outer Boundary",
				"115",
				"1350021",
				"Hurlingham",
				"Santo Tesei",
				"0021",
				"2014/07/23",
				"La Floresta",
				"Asentamiento Precario",
				"decada_1980",
				"17",
				"0.1900000000000000000000000000000",
				"Floresta entre Amberes y Cuzco",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Total",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Total"
			],
			[
				"",
				"",
				"-58.85058403015136,-34.553817211415115,0.0 -58.84927511215209,-34.552968931609115,0.0 -58.84624421596527,-34.55603948677261,0.0 -58.84755313396454,-34.556852391756316,0.0 -58.85058403015136,-34.553817211415115,0.0 ",
				"Polygon Outer Boundary",
				"2236",
				"0740071",
				"Moreno",
				"Cuartel V",
				"0071",
				"2015/09/23",
				"El Vergel",
				"Otros",
				"2009",
				"60",
				"6.6500000000000004000000000000000",
				"Araucanos, Curapaligue, Agote",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7752057401382,-34.6119223444813,0.0 -58.7752057401382,-34.61192234448129,0.0 -58.7752057401382,-34.61192234448129,0.0 -58.7752057401382,-34.61192234448129,0.0 -58.7752057401382,-34.61192234448129,0.0 -58.7752057401382,-34.61192234448129,0.0 -58.77528369426727,-34.6118287300756,0.0 -58.7752057401382,-34.6119223444813,0.0 -58.776227831840515,-34.6110870036368,0.0 -58.777214884757996,-34.61036293095924,0.0 -58.7759470169514,-34.6091715284326,0.0 -58.7750420580842,-34.6098278018655,0.0 -58.7749633726579,-34.6097774320504,0.0 -58.7738268053883,-34.6107632357342,0.0 -58.7752057401382,-34.6119223444813,0.0 ",
				"Polygon Outer Boundary",
				"93",
				"0740048",
				"Moreno",
				"Moreno",
				"0048",
				"2014/11/28",
				"Santa Elena",
				"Otros",
				"1985",
				"115",
				"4.6500000000000004000000000000000",
				"Plutarco- El Moro- Bolivia- Darwin",
				"Cobertura Parcial",
				"Cobertura Total",
				"Cobertura Parcial",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.52540013380348,-34.6956099393507,0.0 -58.525764914229505,-34.69551731757471,0.0 -58.527224035933614,-34.695018922429085,0.0 -58.52691650390625,-34.69471900177988,0.0 -58.5274851322174,-34.6944014375549,0.0 -58.52739569731056,-34.69418531676052,0.0 -58.52767288684844,-34.694013301847356,0.0 -58.52730810642242,-34.69374866282131,0.0 -58.52707383222877,-34.69391185698737,0.0 -58.525169463828206,-34.69538059000166,0.0 -58.52540013380348,-34.6956099393507,0.0 ",
				"Polygon Outer Boundary",
				"1449",
				"0700124",
				"La Matanza",
				"La Tablada",
				"0124",
				"2015/03/16",
				"Los Vagones de Tablada",
				"Villa",
				"90_o_anterior",
				"54",
				"1.8700000000000001000000000000000",
				"Uspallata, Luzuriaga y Vias del FFCC",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.52404964156448,-34.69599365703263,0.0 -58.523974539712064,-34.695923088397066,0.0 -58.52312696166336,-34.69660230901679,0.0 -58.523223521187894,-34.69666405606942,0.0 -58.52404964156448,-34.69599365703263,0.0 ",
				"Polygon Outer Boundary",
				"1449",
				"0700124",
				"La Matanza",
				"La Tablada",
				"0124",
				"2015/03/16",
				"Los Vagones de Tablada",
				"Villa",
				"90_o_anterior",
				"54",
				"1.8700000000000001000000000000000",
				"Uspallata, Luzuriaga y Vias del FFCC",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.52346198633313,-34.69666846657143,0.0 -58.523150850087404,-34.6969507382103,0.0 -58.52321522310376,-34.69696396966976,0.0 -58.52349417284131,-34.696911043819256,0.0 -58.52352635934948,-34.69683165498006,0.0 -58.52346198633313,-34.69666846657143,0.0 ",
				"Polygon Outer Boundary",
				"1449",
				"0700124",
				"La Matanza",
				"La Tablada",
				"0124",
				"2015/03/16",
				"Los Vagones de Tablada",
				"Villa",
				"90_o_anterior",
				"54",
				"1.8700000000000001000000000000000",
				"Uspallata, Luzuriaga y Vias del FFCC",
				"Inexistente",
				"Inexistente",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.8008267478232,-34.5655516336019,0.0 -58.8072755839809,-34.5698603068687,0.0 -58.810377719106,-34.5666592327524,0.0 -58.8135569666543,-34.563382027634,0.0 -58.8116302637223,-34.562101355153,0.0 -58.80693912506103,-34.559198284968446,0.0 -58.8039226311317,-34.5624046535127,0.0 -58.8008267478232,-34.5655516336019,0.0 ",
				"Polygon Outer Boundary",
				"79",
				"0740035",
				"Moreno",
				"Moreno",
				"0035",
				"2014/09/11",
				"Tejeda & Diaz",
				"Asentamiento Precario",
				"2012",
				"1000",
				"69.6099999999999990000000000000000",
				"Ricchieri Pablo, S/N, Tejeda Luis De, S/N",
				"Inexistente",
				"Sin dato",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.7681575145185,-34.6118640132391,0.0 -58.7687937966435,-34.6115102607688,0.0 -58.7685880187671,-34.6114852403021,0.0 -58.7681793835058,-34.6116224893291,0.0 -58.7677121794165,-34.611903657233,0.0 -58.7668932142573,-34.6119765576403,0.0 -58.7660022236033,-34.6122849004586,0.0 -58.7659886170319,-34.6123474219752,0.0 -58.7666715435684,-34.6129598236104,0.0 -58.7681575145185,-34.6118640132391,0.0 ",
				"Polygon Outer Boundary",
				"45",
				"0740003",
				"Moreno",
				"Paso Del Rey",
				"0003",
				"2014/09/11",
				"Las Catonas",
				"Asentamiento Precario",
				"2008",
				"46",
				"1.2100000000000000000000000000000",
				"Ingenieros Jose, Origone Manuel, Arroyo",
				"Cobertura Parcial",
				"Cobertura Parcial",
				"Inexistente",
				"Cobertura Total",
				"Cobertura Parcial",
				"Cobertura Parcial"
			],
			[
				"",
				"",
				"-58.8355200972549,-34.681106684713,0.0 -58.8353885772738,-34.6811459986231,0.0 -58.8349635827617,-34.6811103818268,0.0 -58.8348323782546,-34.6811271589233,0.0 -58.834541653047,-34.6812414920834,0.0 -58.8348120544155,-34.6813699374704,0.0 -58.8349845618207,-34.6814873688827,0.0 -58.834952348311,-34.6815203972995,0.0 -58.8349417206164,-34.6816172152555,0.0 -58.834324480743,-34.6822283469407,0.0 -58.83546710014343,-34.68311388449169,0.0 -58.83532762527466,-34.68326386597701,0.0 -58.8339645014634,-34.6844183296652,0.0 -58.8345667204622,-34.6848225833942,0.0 -58.8350991884349,-34.6851813595237,0.0 -58.8353051001434,-34.6853198250538,0.0 -58.8359158138903,-34.6847452302132,0.0 -58.8363603226783,-34.6843011251601,0.0 -58.8368542995122,-34.6838016834258,0.0 -58.8376840698127,-34.6829708702848,0.0 -58.8380572596927,-34.682598204059,0.0 -58.8368889266875,-34.6817763685915,0.0 -58.8367495561524,-34.6816690138933,0.0 -58.8357944417477,-34.6809921016814,0.0 -58.8355200972549,-34.681106684713,0.0 ",
				"Polygon Outer Boundary",
				"44",
				"0740002",
				"Moreno",
				"Moreno",
				"0002",
				"2014/09/11",
				"Atalaya",
				"Asentamiento Precario",
				"2009",
				"280",
				"48.4799999999999970000000000000000",
				"Sivori- Arenales- Gral Luis Maria Campos- San Nicolas- Ambrossetti- Santa Cruz",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.8338424096118,-34.6797150821147,0.0 -58.8325724572599,-34.6788600584065,0.0 -58.8312108204401,-34.6802532269671,0.0 -58.8317836582381,-34.680641798857,0.0 -58.8320175865746,-34.6806891090875,0.0 -58.8322734752647,-34.6811152022826,0.0 -58.83268296718598,-34.68129202887385,0.0 -58.8330612348487,-34.6813435816794,0.0 -58.8331712017696,-34.6812905526761,0.0 -58.8332311193297,-34.6812966337506,0.0 -58.8333673273346,-34.6813104574824,0.0 -58.8336803648826,-34.6812722611987,0.0 -58.833946075551,-34.6812709278051,0.0 -58.8342408970884,-34.6812556307242,0.0 -58.8342844550864,-34.6812696579552,0.0 -58.8344772057846,-34.6811642432963,0.0 -58.834882881257,-34.681023961296,0.0 -58.8350684369345,-34.681021227199,0.0 -58.8354057780064,-34.6810875609958,0.0 -58.8357296418181,-34.6809464042116,0.0 -58.8338424096118,-34.6797150821147,0.0 ",
				"Polygon Outer Boundary",
				"44",
				"0740002",
				"Moreno",
				"Moreno",
				"0002",
				"2014/09/11",
				"Atalaya",
				"Asentamiento Precario",
				"2009",
				"280",
				"48.4799999999999970000000000000000",
				"Sivori- Arenales- Gral Luis Maria Campos- San Nicolas- Ambrossetti- Santa Cruz",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.8297122704448,-34.676665913247,0.0 -58.8323544087073,-34.6784849258495,0.0 -58.8324786644228,-34.6785717652631,0.0 -58.8351540001124,-34.6803684966594,0.0 -58.8358619545706,-34.6808439867718,0.0 -58.8358702823324,-34.680641303401,0.0 -58.8358990666538,-34.6805333900291,0.0 -58.8359559168218,-34.6804975096211,0.0 -58.8360919135505,-34.6803954886113,0.0 -58.836174443533,-34.6803512884266,0.0 -58.8361922472982,-34.6802432701195,0.0 -58.8362100148772,-34.6801442671553,0.0 -58.8363036250295,-34.6800865589833,0.0 -58.8364132728624,-34.680047035241,0.0 -58.8365443853897,-34.6800302555397,0.0 -58.8367514942967,-34.6799408133106,0.0 -58.8368796631528,-34.6798577397957,0.0 -58.8368970246708,-34.6797812720774,0.0 -58.8370352592555,-34.6796992861777,0.0 -58.8371271728382,-34.6797113426487,0.0 -58.8372352805372,-34.6797754839538,0.0 -58.837435728426,-34.6798855844875,0.0 -58.8376103645737,-34.6798782344836,0.0 -58.8376872785409,-34.6798429052331,0.0 -58.8381081273214,-34.6797883159973,0.0 -58.838240372379,-34.6796904039927,0.0 -58.8383289300631,-34.6796011812985,0.0 -58.8384258855748,-34.6794939170229,0.0 -58.8384950044807,-34.6794269580217,0.0 -58.8386784991583,-34.6793459424934,0.0 -58.8389607221341,-34.6792512461222,0.0 -58.8388180387172,-34.6793443878797,0.0 -58.8386315697775,-34.6794192446041,0.0 -58.838365769287,-34.6796961070793,0.0 -58.8385260930748,-34.6797338790249,0.0 -58.8388335075939,-34.6799127044854,0.0 -58.839842400517,-34.678935634308,0.0 -58.8394339202663,-34.6786202529359,0.0 -58.8393040074919,-34.6789253692533,0.0 -58.8391320012935,-34.6791063930369,0.0 -58.8391769132292,-34.6790413620208,0.0 -58.8392497825393,-34.6789023127085,0.0 -58.8393904694735,-34.6785927010412,0.0 -58.8347967800993,-34.6754887630815,0.0 -58.8334412941739,-34.6768413145358,0.0 -58.8323596707502,-34.6761223237534,0.0 -58.8337325347687,-34.6747439853151,0.0 -58.8324572084852,-34.6738799725492,0.0 -58.83076355436,-34.6756168393053,0.0 -58.8297122704448,-34.676665913247,0.0 ",
				"Polygon Outer Boundary",
				"44",
				"0740002",
				"Moreno",
				"Moreno",
				"0002",
				"2014/09/11",
				"Atalaya",
				"Asentamiento Precario",
				"2009",
				"280",
				"48.4799999999999970000000000000000",
				"Sivori- Arenales- Gral Luis Maria Campos- San Nicolas- Ambrossetti- Santa Cruz",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			],
			[
				"",
				"",
				"-58.8390493153156,-34.6791934135284,0.0 -58.838962182793,-34.6792502926223,0.0 -58.838994336543,-34.6792243546036,0.0 -58.8390575542232,-34.6791847427368,0.0 -58.8390493153156,-34.6791934135284,0.0 ",
				"Polygon Inner Boundary",
				"",
				"",
				"",
				"",
				"",
				"",
				"",
				"",
				"",
				"",
				"",
				"",
				"",
				"",
				"",
				"",
				"",
				""
			],
			[
				"",
				"",
				"-58.83946929126978,-34.67842903191384,0.0 -58.840295411646366,-34.67783789232386,0.0 -58.84131465107202,-34.6772379254403,0.0 -58.83919034153223,-34.675843867957624,0.0 -58.837709762156,-34.67728204080037,0.0 -58.83946929126978,-34.67842903191384,0.0 ",
				"Polygon Outer Boundary",
				"44",
				"0740002",
				"Moreno",
				"Moreno",
				"0002",
				"2014/09/11",
				"Atalaya",
				"Asentamiento Precario",
				"2009",
				"280",
				"48.4799999999999970000000000000000",
				"Sivori- Arenales- Gral Luis Maria Campos- San Nicolas- Ambrossetti- Santa Cruz",
				"Cobertura Parcial",
				"Cobertura Total",
				"Inexistente",
				"Inexistente",
				"Inexistente",
				"Inexistente"
			]
		],
		"description": "Id, cod_folio, partido, localidad, matrícula, fecha de carga, nombre oficial, tipo, año de origen, cantidad de familias, superficie, dirección, energía eléctrica, alumbrado público, agua corriente, red cloacal, red de gas y pavimento.",
		"parameters": [],
		"tags": [],
		"timestamp": null,
		"created_at": "2016-07-27T16:33:28Z",
		"title": "Villas y asentamientos precarios",
		"modified_at": "2016-12-20T15:35:05Z",
		"link": null,
		"user": "mara_leguizamon",
		"guid": "VILLA-Y-ASENT-PRECA",
		"category_name": "Demografía y Territorio"
	};

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 120,
		"./af.js": 120,
		"./ar": 127,
		"./ar-dz": 121,
		"./ar-dz.js": 121,
		"./ar-kw": 122,
		"./ar-kw.js": 122,
		"./ar-ly": 123,
		"./ar-ly.js": 123,
		"./ar-ma": 124,
		"./ar-ma.js": 124,
		"./ar-sa": 125,
		"./ar-sa.js": 125,
		"./ar-tn": 126,
		"./ar-tn.js": 126,
		"./ar.js": 127,
		"./az": 128,
		"./az.js": 128,
		"./be": 129,
		"./be.js": 129,
		"./bg": 130,
		"./bg.js": 130,
		"./bn": 131,
		"./bn.js": 131,
		"./bo": 132,
		"./bo.js": 132,
		"./br": 133,
		"./br.js": 133,
		"./bs": 134,
		"./bs.js": 134,
		"./ca": 135,
		"./ca.js": 135,
		"./cs": 136,
		"./cs.js": 136,
		"./cv": 137,
		"./cv.js": 137,
		"./cy": 138,
		"./cy.js": 138,
		"./da": 139,
		"./da.js": 139,
		"./de": 142,
		"./de-at": 140,
		"./de-at.js": 140,
		"./de-ch": 141,
		"./de-ch.js": 141,
		"./de.js": 142,
		"./dv": 143,
		"./dv.js": 143,
		"./el": 144,
		"./el.js": 144,
		"./en-au": 145,
		"./en-au.js": 145,
		"./en-ca": 146,
		"./en-ca.js": 146,
		"./en-gb": 147,
		"./en-gb.js": 147,
		"./en-ie": 148,
		"./en-ie.js": 148,
		"./en-nz": 149,
		"./en-nz.js": 149,
		"./eo": 150,
		"./eo.js": 150,
		"./es": 152,
		"./es-do": 151,
		"./es-do.js": 151,
		"./es.js": 152,
		"./et": 153,
		"./et.js": 153,
		"./eu": 154,
		"./eu.js": 154,
		"./fa": 155,
		"./fa.js": 155,
		"./fi": 156,
		"./fi.js": 156,
		"./fo": 157,
		"./fo.js": 157,
		"./fr": 160,
		"./fr-ca": 158,
		"./fr-ca.js": 158,
		"./fr-ch": 159,
		"./fr-ch.js": 159,
		"./fr.js": 160,
		"./fy": 161,
		"./fy.js": 161,
		"./gd": 162,
		"./gd.js": 162,
		"./gl": 163,
		"./gl.js": 163,
		"./gom-latn": 164,
		"./gom-latn.js": 164,
		"./he": 165,
		"./he.js": 165,
		"./hi": 166,
		"./hi.js": 166,
		"./hr": 167,
		"./hr.js": 167,
		"./hu": 168,
		"./hu.js": 168,
		"./hy-am": 169,
		"./hy-am.js": 169,
		"./id": 170,
		"./id.js": 170,
		"./is": 171,
		"./is.js": 171,
		"./it": 172,
		"./it.js": 172,
		"./ja": 173,
		"./ja.js": 173,
		"./jv": 174,
		"./jv.js": 174,
		"./ka": 175,
		"./ka.js": 175,
		"./kk": 176,
		"./kk.js": 176,
		"./km": 177,
		"./km.js": 177,
		"./kn": 178,
		"./kn.js": 178,
		"./ko": 179,
		"./ko.js": 179,
		"./ky": 180,
		"./ky.js": 180,
		"./lb": 181,
		"./lb.js": 181,
		"./lo": 182,
		"./lo.js": 182,
		"./lt": 183,
		"./lt.js": 183,
		"./lv": 184,
		"./lv.js": 184,
		"./me": 185,
		"./me.js": 185,
		"./mi": 186,
		"./mi.js": 186,
		"./mk": 187,
		"./mk.js": 187,
		"./ml": 188,
		"./ml.js": 188,
		"./mr": 189,
		"./mr.js": 189,
		"./ms": 191,
		"./ms-my": 190,
		"./ms-my.js": 190,
		"./ms.js": 191,
		"./my": 192,
		"./my.js": 192,
		"./nb": 193,
		"./nb.js": 193,
		"./ne": 194,
		"./ne.js": 194,
		"./nl": 196,
		"./nl-be": 195,
		"./nl-be.js": 195,
		"./nl.js": 196,
		"./nn": 197,
		"./nn.js": 197,
		"./pa-in": 198,
		"./pa-in.js": 198,
		"./pl": 199,
		"./pl.js": 199,
		"./pt": 201,
		"./pt-br": 200,
		"./pt-br.js": 200,
		"./pt.js": 201,
		"./ro": 202,
		"./ro.js": 202,
		"./ru": 203,
		"./ru.js": 203,
		"./sd": 204,
		"./sd.js": 204,
		"./se": 205,
		"./se.js": 205,
		"./si": 206,
		"./si.js": 206,
		"./sk": 207,
		"./sk.js": 207,
		"./sl": 208,
		"./sl.js": 208,
		"./sq": 209,
		"./sq.js": 209,
		"./sr": 211,
		"./sr-cyrl": 210,
		"./sr-cyrl.js": 210,
		"./sr.js": 211,
		"./ss": 212,
		"./ss.js": 212,
		"./sv": 213,
		"./sv.js": 213,
		"./sw": 214,
		"./sw.js": 214,
		"./ta": 215,
		"./ta.js": 215,
		"./te": 216,
		"./te.js": 216,
		"./tet": 217,
		"./tet.js": 217,
		"./th": 218,
		"./th.js": 218,
		"./tl-ph": 219,
		"./tl-ph.js": 219,
		"./tlh": 220,
		"./tlh.js": 220,
		"./tr": 221,
		"./tr.js": 221,
		"./tzl": 222,
		"./tzl.js": 222,
		"./tzm": 224,
		"./tzm-latn": 223,
		"./tzm-latn.js": 223,
		"./tzm.js": 224,
		"./uk": 225,
		"./uk.js": 225,
		"./ur": 226,
		"./ur.js": 226,
		"./uz": 228,
		"./uz-latn": 227,
		"./uz-latn.js": 227,
		"./uz.js": 228,
		"./vi": 229,
		"./vi.js": 229,
		"./x-pseudo": 230,
		"./x-pseudo.js": 230,
		"./yo": 231,
		"./yo.js": 231,
		"./zh-cn": 232,
		"./zh-cn.js": 232,
		"./zh-hk": 233,
		"./zh-hk.js": 233,
		"./zh-tw": 234,
		"./zh-tw.js": 234
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 365;


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(237);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(237);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  F: __webpack_require__(369),
	  T: __webpack_require__(370),
	  __: __webpack_require__(371),
	  add: __webpack_require__(56),
	  addIndex: __webpack_require__(372),
	  adjust: __webpack_require__(238),
	  all: __webpack_require__(373),
	  allPass: __webpack_require__(374),
	  always: __webpack_require__(35),
	  and: __webpack_require__(239),
	  any: __webpack_require__(240),
	  anyPass: __webpack_require__(375),
	  ap: __webpack_require__(76),
	  aperture: __webpack_require__(376),
	  append: __webpack_require__(377),
	  apply: __webpack_require__(241),
	  applySpec: __webpack_require__(378),
	  ascend: __webpack_require__(379),
	  assoc: __webpack_require__(57),
	  assocPath: __webpack_require__(242),
	  binary: __webpack_require__(380),
	  bind: __webpack_require__(243),
	  both: __webpack_require__(381),
	  call: __webpack_require__(382),
	  chain: __webpack_require__(77),
	  clamp: __webpack_require__(383),
	  clone: __webpack_require__(384),
	  comparator: __webpack_require__(385),
	  complement: __webpack_require__(386),
	  compose: __webpack_require__(78),
	  composeK: __webpack_require__(244),
	  composeP: __webpack_require__(387),
	  concat: __webpack_require__(79),
	  cond: __webpack_require__(388),
	  construct: __webpack_require__(389),
	  constructN: __webpack_require__(245),
	  contains: __webpack_require__(390),
	  converge: __webpack_require__(246),
	  countBy: __webpack_require__(391),
	  curry: __webpack_require__(58),
	  curryN: __webpack_require__(13),
	  dec: __webpack_require__(392),
	  descend: __webpack_require__(393),
	  defaultTo: __webpack_require__(247),
	  difference: __webpack_require__(248),
	  differenceWith: __webpack_require__(249),
	  dissoc: __webpack_require__(250),
	  dissocPath: __webpack_require__(394),
	  divide: __webpack_require__(395),
	  drop: __webpack_require__(251),
	  dropLast: __webpack_require__(396),
	  dropLastWhile: __webpack_require__(397),
	  dropRepeats: __webpack_require__(398),
	  dropRepeatsWith: __webpack_require__(252),
	  dropWhile: __webpack_require__(399),
	  either: __webpack_require__(400),
	  empty: __webpack_require__(253),
	  eqBy: __webpack_require__(401),
	  eqProps: __webpack_require__(402),
	  equals: __webpack_require__(21),
	  evolve: __webpack_require__(403),
	  filter: __webpack_require__(80),
	  find: __webpack_require__(404),
	  findIndex: __webpack_require__(405),
	  findLast: __webpack_require__(406),
	  findLastIndex: __webpack_require__(407),
	  flatten: __webpack_require__(408),
	  flip: __webpack_require__(59),
	  forEach: __webpack_require__(409),
	  forEachObjIndexed: __webpack_require__(410),
	  fromPairs: __webpack_require__(411),
	  groupBy: __webpack_require__(412),
	  groupWith: __webpack_require__(413),
	  gt: __webpack_require__(414),
	  gte: __webpack_require__(415),
	  has: __webpack_require__(416),
	  hasIn: __webpack_require__(417),
	  head: __webpack_require__(418),
	  identical: __webpack_require__(254),
	  identity: __webpack_require__(81),
	  ifElse: __webpack_require__(419),
	  inc: __webpack_require__(420),
	  indexBy: __webpack_require__(421),
	  indexOf: __webpack_require__(422),
	  init: __webpack_require__(423),
	  insert: __webpack_require__(424),
	  insertAll: __webpack_require__(425),
	  intersection: __webpack_require__(460),
	  intersectionWith: __webpack_require__(461),
	  intersperse: __webpack_require__(462),
	  into: __webpack_require__(463),
	  invert: __webpack_require__(464),
	  invertObj: __webpack_require__(465),
	  invoker: __webpack_require__(46),
	  is: __webpack_require__(269),
	  isArrayLike: __webpack_require__(47),
	  isEmpty: __webpack_require__(466),
	  isNil: __webpack_require__(467),
	  join: __webpack_require__(468),
	  juxt: __webpack_require__(270),
	  keys: __webpack_require__(23),
	  keysIn: __webpack_require__(469),
	  last: __webpack_require__(271),
	  lastIndexOf: __webpack_require__(470),
	  length: __webpack_require__(272),
	  lens: __webpack_require__(65),
	  lensIndex: __webpack_require__(471),
	  lensPath: __webpack_require__(472),
	  lensProp: __webpack_require__(473),
	  lift: __webpack_require__(66),
	  liftN: __webpack_require__(273),
	  lt: __webpack_require__(474),
	  lte: __webpack_require__(475),
	  map: __webpack_require__(16),
	  mapAccum: __webpack_require__(476),
	  mapAccumRight: __webpack_require__(477),
	  mapObjIndexed: __webpack_require__(478),
	  match: __webpack_require__(479),
	  mathMod: __webpack_require__(480),
	  max: __webpack_require__(36),
	  maxBy: __webpack_require__(481),
	  mean: __webpack_require__(274),
	  median: __webpack_require__(482),
	  memoize: __webpack_require__(483),
	  merge: __webpack_require__(484),
	  mergeAll: __webpack_require__(485),
	  mergeWith: __webpack_require__(486),
	  mergeWithKey: __webpack_require__(275),
	  min: __webpack_require__(487),
	  minBy: __webpack_require__(488),
	  modulo: __webpack_require__(489),
	  multiply: __webpack_require__(276),
	  nAry: __webpack_require__(67),
	  negate: __webpack_require__(490),
	  none: __webpack_require__(491),
	  not: __webpack_require__(277),
	  nth: __webpack_require__(48),
	  nthArg: __webpack_require__(492),
	  objOf: __webpack_require__(278),
	  of: __webpack_require__(493),
	  omit: __webpack_require__(494),
	  once: __webpack_require__(495),
	  or: __webpack_require__(279),
	  over: __webpack_require__(280),
	  pair: __webpack_require__(496),
	  partial: __webpack_require__(497),
	  partialRight: __webpack_require__(498),
	  partition: __webpack_require__(499),
	  path: __webpack_require__(49),
	  pathEq: __webpack_require__(500),
	  pathOr: __webpack_require__(501),
	  pathSatisfies: __webpack_require__(502),
	  pick: __webpack_require__(503),
	  pickAll: __webpack_require__(281),
	  pickBy: __webpack_require__(504),
	  pipe: __webpack_require__(282),
	  pipeK: __webpack_require__(505),
	  pipeP: __webpack_require__(283),
	  pluck: __webpack_require__(50),
	  prepend: __webpack_require__(284),
	  product: __webpack_require__(506),
	  project: __webpack_require__(507),
	  prop: __webpack_require__(86),
	  propEq: __webpack_require__(508),
	  propIs: __webpack_require__(509),
	  propOr: __webpack_require__(510),
	  propSatisfies: __webpack_require__(511),
	  props: __webpack_require__(512),
	  range: __webpack_require__(513),
	  reduce: __webpack_require__(24),
	  reduceBy: __webpack_require__(68),
	  reduceRight: __webpack_require__(285),
	  reduceWhile: __webpack_require__(514),
	  reduced: __webpack_require__(515),
	  reject: __webpack_require__(69),
	  remove: __webpack_require__(516),
	  repeat: __webpack_require__(517),
	  replace: __webpack_require__(518),
	  reverse: __webpack_require__(70),
	  scan: __webpack_require__(519),
	  sequence: __webpack_require__(286),
	  set: __webpack_require__(520),
	  slice: __webpack_require__(31),
	  sort: __webpack_require__(521),
	  sortBy: __webpack_require__(522),
	  sortWith: __webpack_require__(523),
	  split: __webpack_require__(524),
	  splitAt: __webpack_require__(525),
	  splitEvery: __webpack_require__(526),
	  splitWhen: __webpack_require__(527),
	  subtract: __webpack_require__(528),
	  sum: __webpack_require__(287),
	  symmetricDifference: __webpack_require__(529),
	  symmetricDifferenceWith: __webpack_require__(530),
	  tail: __webpack_require__(87),
	  take: __webpack_require__(288),
	  takeLast: __webpack_require__(531),
	  takeLastWhile: __webpack_require__(532),
	  takeWhile: __webpack_require__(533),
	  tap: __webpack_require__(534),
	  test: __webpack_require__(535),
	  times: __webpack_require__(289),
	  toLower: __webpack_require__(536),
	  toPairs: __webpack_require__(537),
	  toPairsIn: __webpack_require__(538),
	  toString: __webpack_require__(51),
	  toUpper: __webpack_require__(539),
	  transduce: __webpack_require__(540),
	  transpose: __webpack_require__(541),
	  traverse: __webpack_require__(542),
	  trim: __webpack_require__(543),
	  tryCatch: __webpack_require__(544),
	  type: __webpack_require__(88),
	  unapply: __webpack_require__(545),
	  unary: __webpack_require__(546),
	  uncurryN: __webpack_require__(547),
	  unfold: __webpack_require__(548),
	  union: __webpack_require__(549),
	  unionWith: __webpack_require__(550),
	  uniq: __webpack_require__(89),
	  uniqBy: __webpack_require__(290),
	  uniqWith: __webpack_require__(90),
	  unless: __webpack_require__(551),
	  unnest: __webpack_require__(552),
	  until: __webpack_require__(553),
	  update: __webpack_require__(291),
	  useWith: __webpack_require__(292),
	  values: __webpack_require__(293),
	  valuesIn: __webpack_require__(554),
	  view: __webpack_require__(555),
	  when: __webpack_require__(556),
	  where: __webpack_require__(294),
	  whereEq: __webpack_require__(557),
	  without: __webpack_require__(558),
	  xprod: __webpack_require__(559),
	  zip: __webpack_require__(560),
	  zipObj: __webpack_require__(561),
	  zipWith: __webpack_require__(562)
	};


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	var always = __webpack_require__(35);
	
	
	/**
	 * A function that always returns `false`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.T
	 * @example
	 *
	 *      R.F(); //=> false
	 */
	module.exports = always(false);


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	var always = __webpack_require__(35);
	
	
	/**
	 * A function that always returns `true`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.F
	 * @example
	 *
	 *      R.T(); //=> true
	 */
	module.exports = always(true);


/***/ },
/* 371 */
/***/ function(module, exports) {

	/**
	 * A special placeholder value used to specify "gaps" within curried functions,
	 * allowing partial application of any combination of arguments, regardless of
	 * their positions.
	 *
	 * If `g` is a curried ternary function and `_` is `R.__`, the following are
	 * equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2, _)(1, 3)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @constant
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @example
	 *
	 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
	 *      greet('Alice'); //=> 'Hello, Alice!'
	 */
	module.exports = {'@@functional/placeholder': true};


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(19);
	var _curry1 = __webpack_require__(3);
	var curryN = __webpack_require__(13);
	
	
	/**
	 * Creates a new list iteration function from an existing one by adding two new
	 * parameters to its callback function: the current index, and the entire list.
	 *
	 * This would turn, for instance, Ramda's simple `map` function into one that
	 * more closely resembles `Array.prototype.map`. Note that this will only work
	 * for functions in which the iteration callback function is the first
	 * parameter, and where the list is the last parameter. (This latter might be
	 * unimportant if the list parameter is not used.)
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Function
	 * @category List
	 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
	 * @param {Function} fn A list iteration function that does not pass index or list to its callback
	 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
	 * @example
	 *
	 *      var mapIndexed = R.addIndex(R.map);
	 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
	 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
	 */
	module.exports = _curry1(function addIndex(fn) {
	  return curryN(fn.length, function() {
	    var idx = 0;
	    var origFn = arguments[0];
	    var list = arguments[arguments.length - 1];
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = function() {
	      var result = origFn.apply(this, _concat(arguments, [idx, list]));
	      idx += 1;
	      return result;
	    };
	    return fn.apply(this, args);
	  });
	});


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _xall = __webpack_require__(444);
	
	
	/**
	 * Returns `true` if all elements of the list match the predicate, `false` if
	 * there are any that don't.
	 *
	 * Dispatches to the `all` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
	 *         otherwise.
	 * @see R.any, R.none, R.transduce
	 * @example
	 *
	 *      var equals3 = R.equals(3);
	 *      R.all(equals3)([3, 3, 3, 3]); //=> true
	 *      R.all(equals3)([3, 3, 1, 3]); //=> false
	 */
	module.exports = _curry2(_dispatchable(['all'], _xall, function all(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (!fn(list[idx])) {
	      return false;
	    }
	    idx += 1;
	  }
	  return true;
	}));


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var curryN = __webpack_require__(13);
	var max = __webpack_require__(36);
	var pluck = __webpack_require__(50);
	var reduce = __webpack_require__(24);
	
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if every one of the provided predicates is satisfied
	 * by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.anyPass
	 * @example
	 *
	 *      var isQueen = R.propEq('rank', 'Q');
	 *      var isSpade = R.propEq('suit', '♠︎');
	 *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
	 *
	 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
	 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
	 */
	module.exports = _curry1(function allPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function() {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (!preds[idx].apply(this, arguments)) {
	        return false;
	      }
	      idx += 1;
	    }
	    return true;
	  });
	});


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var curryN = __webpack_require__(13);
	var max = __webpack_require__(36);
	var pluck = __webpack_require__(50);
	var reduce = __webpack_require__(24);
	
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if at least one of the provided predicates is
	 * satisfied by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.allPass
	 * @example
	 *
	 *      var isClub = R.propEq('suit', '♣');
	 *      var isSpade = R.propEq('suit', '♠');
	 *      var isBlackCard = R.anyPass([isClub, isSpade]);
	 *
	 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
	 */
	module.exports = _curry1(function anyPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function() {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (preds[idx].apply(this, arguments)) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  });
	});


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	var _aperture = __webpack_require__(427);
	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _xaperture = __webpack_require__(445);
	
	
	/**
	 * Returns a new list, composed of n-tuples of consecutive elements If `n` is
	 * greater than the length of the list, an empty list is returned.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @param {Number} n The size of the tuples to create
	 * @param {Array} list The list to split into `n`-length tuples
	 * @return {Array} The resulting list of `n`-length tuples
	 * @see R.transduce
	 * @example
	 *
	 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
	 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
	 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
	 */
	module.exports = _curry2(_dispatchable([], _xaperture, _aperture));


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(19);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a new list containing the contents of the given list, followed by
	 * the given element.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The element to add to the end of the new list.
	 * @param {Array} list The list of elements to add a new item to.
	 *        list.
	 * @return {Array} A new list containing the elements of the old list followed by `el`.
	 * @see R.prepend
	 * @example
	 *
	 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
	 *      R.append('tests', []); //=> ['tests']
	 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
	 */
	module.exports = _curry2(function append(el, list) {
	  return _concat(list, [el]);
	});


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var apply = __webpack_require__(241);
	var curryN = __webpack_require__(13);
	var map = __webpack_require__(16);
	var max = __webpack_require__(36);
	var pluck = __webpack_require__(50);
	var reduce = __webpack_require__(24);
	var values = __webpack_require__(293);
	
	
	/**
	 * Given a spec object recursively mapping properties to functions, creates a
	 * function producing an object of the same structure, by mapping each property
	 * to the result of calling its associated function with the supplied arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
	 * @param {Object} spec an object recursively mapping properties to functions for
	 *        producing the values for these properties.
	 * @return {Function} A function that returns an object of the same structure
	 * as `spec', with each property set to the value returned by calling its
	 * associated function with the supplied arguments.
	 * @see R.converge, R.juxt
	 * @example
	 *
	 *      var getMetrics = R.applySpec({
	 *                                      sum: R.add,
	 *                                      nested: { mul: R.multiply }
	 *                                   });
	 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
	 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
	 */
	module.exports = _curry1(function applySpec(spec) {
	  spec = map(function(v) { return typeof v == 'function' ? v : applySpec(v); },
	             spec);
	  return curryN(reduce(max, 0, pluck('length', values(spec))),
	                function() {
	                  var args = arguments;
	                  return map(function(f) { return apply(f, args); }, spec);
	                });
	});


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Makes an ascending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
	 * @example
	 *
	 *      var byAge = R.ascend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByYoungestFirst = R.sort(byAge, people);
	 */
	module.exports = _curry3(function ascend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa < bb ? -1 : aa > bb ? 1 : 0;
	});


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var nAry = __webpack_require__(67);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 2 parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> c) -> (a, b -> c)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 2.
	 * @example
	 *
	 *      var takesThreeArgs = function(a, b, c) {
	 *        return [a, b, c];
	 *      };
	 *      takesThreeArgs.length; //=> 3
	 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      var takesTwoArgs = R.binary(takesThreeArgs);
	 *      takesTwoArgs.length; //=> 2
	 *      // Only 2 arguments are passed to the wrapped function
	 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
	 * @symb R.binary(f)(a, b, c) = f(a, b)
	 */
	module.exports = _curry1(function binary(fn) {
	  return nAry(2, fn);
	});


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isFunction = __webpack_require__(61);
	var and = __webpack_require__(239);
	var lift = __webpack_require__(66);
	
	
	/**
	 * A function which calls the two provided functions and returns the `&&`
	 * of the results.
	 * It returns the result of the first function if it is false-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * false-y value.
	 *
	 * In addition to functions, `R.both` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f A predicate
	 * @param {Function} g Another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
	 * @see R.and
	 * @example
	 *
	 *      var gt10 = R.gt(R.__, 10)
	 *      var lt20 = R.lt(R.__, 20)
	 *      var f = R.both(gt10, lt20);
	 *      f(15); //=> true
	 *      f(30); //=> false
	 */
	module.exports = _curry2(function both(f, g) {
	  return _isFunction(f) ?
	    function _both() {
	      return f.apply(this, arguments) && g.apply(this, arguments);
	    } :
	    lift(and)(f, g);
	});


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	var curry = __webpack_require__(58);
	
	
	/**
	 * Returns the result of calling its first argument with the remaining
	 * arguments. This is occasionally useful as a converging function for
	 * `R.converge`: the left branch can produce a function while the right branch
	 * produces a value to be passed to that function as an argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig (*... -> a),*... -> a
	 * @param {Function} fn The function to apply to the remaining arguments.
	 * @param {...*} args Any number of positional arguments.
	 * @return {*}
	 * @see R.apply
	 * @example
	 *
	 *      R.call(R.add, 1, 2); //=> 3
	 *
	 *      var indentN = R.pipe(R.times(R.always(' ')),
	 *                           R.join(''),
	 *                           R.replace(/^(?!$)/gm));
	 *
	 *      var format = R.converge(R.call, [
	 *                                  R.pipe(R.prop('indent'), indentN),
	 *                                  R.prop('value')
	 *                              ]);
	 *
	 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
	 * @symb R.call(f, a, b) = f(a, b)
	 */
	module.exports = curry(function call(fn) {
	  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
	});


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	/**
	 * Restricts a number to be within a range.
	 *
	 * Also works for other ordered types such as Strings and Dates.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a -> a
	 * @param {Number} minimum The lower limit of the clamp (inclusive)
	 * @param {Number} maximum The upper limit of the clamp (inclusive)
	 * @param {Number} value Value to be clamped
	 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
	 * @example
	 *
	 *      R.clamp(1, 10, -5) // => 1
	 *      R.clamp(1, 10, 15) // => 10
	 *      R.clamp(1, 10, 4)  // => 4
	 */
	module.exports = _curry3(function clamp(min, max, value) {
	  if (min > max) {
	    throw new Error('min must not be greater than max in clamp(min, max, value)');
	  }
	  return value < min ? min :
	         value > max ? max :
	         value;
	});


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(255);
	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Creates a deep copy of the value which may contain (nested) `Array`s and
	 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
	 * assigned by reference rather than copied
	 *
	 * Dispatches to a `clone` method if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {*} -> {*}
	 * @param {*} value The object or array to clone
	 * @return {*} A deeply cloned copy of `val`
	 * @example
	 *
	 *      var objects = [{}, {}, {}];
	 *      var objectsClone = R.clone(objects);
	 *      objects === objectsClone; //=> false
	 *      objects[0] === objectsClone[0]; //=> false
	 */
	module.exports = _curry1(function clone(value) {
	  return value != null && typeof value.clone === 'function' ?
	    value.clone() :
	    _clone(value, [], [], true);
	});


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Makes a comparator function out of a function that reports whether the first
	 * element is less than the second.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a, b -> Boolean) -> (a, b -> Number)
	 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
	 * is less than the second, `false` otherwise
	 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
	 * @example
	 *
	 *      var byAge = R.comparator((a, b) => a.age < b.age);
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByIncreasingAge = R.sort(byAge, people);
	 */
	module.exports = _curry1(function comparator(pred) {
	  return function(a, b) {
	    return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
	  };
	});


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var lift = __webpack_require__(66);
	var not = __webpack_require__(277);
	
	
	/**
	 * Takes a function `f` and returns a function `g` such that if called with the same arguments
	 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
	 *
	 * `R.complement` may be applied to any functor
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> *) -> (*... -> Boolean)
	 * @param {Function} f
	 * @return {Function}
	 * @see R.not
	 * @example
	 *
	 *      var isNotNil = R.complement(R.isNil);
	 *      isNil(null); //=> true
	 *      isNotNil(null); //=> false
	 *      isNil(7); //=> false
	 *      isNotNil(7); //=> true
	 */
	module.exports = lift(not);


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	var pipeP = __webpack_require__(283);
	var reverse = __webpack_require__(70);
	
	
	/**
	 * Performs right-to-left composition of one or more Promise-returning
	 * functions. The rightmost function may have any arity; the remaining
	 * functions must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
	 * @param {...Function} functions The functions to compose
	 * @return {Function}
	 * @see R.pipeP
	 * @example
	 *
	 *      var db = {
	 *        users: {
	 *          JOE: {
	 *            name: 'Joe',
	 *            followers: ['STEVE', 'SUZY']
	 *          }
	 *        }
	 *      }
	 *
	 *      // We'll pretend to do a db lookup which returns a promise
	 *      var lookupUser = (userId) => Promise.resolve(db.users[userId])
	 *      var lookupFollowers = (user) => Promise.resolve(user.followers)
	 *      lookupUser('JOE').then(lookupFollowers)
	 *
	 *      //  followersForUser :: String -> Promise [UserId]
	 *      var followersForUser = R.composeP(lookupFollowers, lookupUser);
	 *      followersForUser('JOE').then(followers => console.log('Followers:', followers))
	 *      // Followers: ["STEVE","SUZY"]
	 */
	module.exports = function composeP() {
	  if (arguments.length === 0) {
	    throw new Error('composeP requires at least one argument');
	  }
	  return pipeP.apply(this, reverse(arguments));
	};


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(22);
	var _curry1 = __webpack_require__(3);
	var map = __webpack_require__(16);
	var max = __webpack_require__(36);
	var reduce = __webpack_require__(24);
	
	
	/**
	 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
	 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
	 * to `fn` are applied to each of the predicates in turn until one returns a
	 * "truthy" value, at which point `fn` returns the result of applying its
	 * arguments to the corresponding transformer. If none of the predicates
	 * matches, `fn` returns undefined.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Logic
	 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
	 * @param {Array} pairs A list of [predicate, transformer]
	 * @return {Function}
	 * @example
	 *
	 *      var fn = R.cond([
	 *        [R.equals(0),   R.always('water freezes at 0°C')],
	 *        [R.equals(100), R.always('water boils at 100°C')],
	 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
	 *      ]);
	 *      fn(0); //=> 'water freezes at 0°C'
	 *      fn(50); //=> 'nothing special happens at 50°C'
	 *      fn(100); //=> 'water boils at 100°C'
	 */
	module.exports = _curry1(function cond(pairs) {
	  var arity = reduce(max,
	                     0,
	                     map(function(pair) { return pair[0].length; }, pairs));
	  return _arity(arity, function() {
	    var idx = 0;
	    while (idx < pairs.length) {
	      if (pairs[idx][0].apply(this, arguments)) {
	        return pairs[idx][1].apply(this, arguments);
	      }
	      idx += 1;
	    }
	  });
	});


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var constructN = __webpack_require__(245);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> {*}) -> (* -> {*})
	 * @param {Function} fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Constructor function
	 *      function Animal(kind) {
	 *        this.kind = kind;
	 *      };
	 *      Animal.prototype.sighting = function() {
	 *        return "It's a " + this.kind + "!";
	 *      }
	 *
	 *      var AnimalConstructor = R.construct(Animal)
	 *
	 *      // Notice we no longer need the 'new' keyword:
	 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
	 *
	 *      var animalTypes = ["Lion", "Tiger", "Bear"];
	 *      var animalSighting = R.invoker(0, 'sighting');
	 *      var sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
	 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
	 */
	module.exports = _curry1(function construct(Fn) {
	  return constructN(Fn.length, Fn);
	});


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(30);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if the specified value is equal, in `R.equals` terms, to at
	 * least one element of the given list; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Boolean
	 * @param {Object} a The item to compare against.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
	 * @see R.any
	 * @example
	 *
	 *      R.contains(3, [1, 2, 3]); //=> true
	 *      R.contains(4, [1, 2, 3]); //=> false
	 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
	 *      R.contains([42], [[42]]); //=> true
	 */
	module.exports = _curry2(_contains);


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var reduceBy = __webpack_require__(68);
	
	
	/**
	 * Counts the elements of a list according to how many match each value of a
	 * key generated by the supplied function. Returns an object mapping the keys
	 * produced by `fn` to the number of occurrences in the list. Note that all
	 * keys are coerced to strings because of how JavaScript objects work.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> String) -> [a] -> {*}
	 * @param {Function} fn The function used to map values to keys.
	 * @param {Array} list The list to count elements from.
	 * @return {Object} An object mapping keys to number of occurrences in the list.
	 * @example
	 *
	 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
	 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
	 *
	 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
	 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
	 */
	module.exports = reduceBy(function(acc, elem) { return acc + 1; }, 0);


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	var add = __webpack_require__(56);
	
	
	/**
	 * Decrements its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n - 1
	 * @see R.inc
	 * @example
	 *
	 *      R.dec(42); //=> 41
	 */
	module.exports = add(-1);


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Makes a descending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
	 * @example
	 *
	 *      var byAge = R.descend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByOldestFirst = R.sort(byAge, people);
	 */
	module.exports = _curry3(function descend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa > bb ? -1 : aa < bb ? 1 : 0;
	});


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var assoc = __webpack_require__(57);
	var dissoc = __webpack_require__(250);
	
	
	/**
	 * Makes a shallow clone of an object, omitting the property at the given path.
	 * Note that this copies and flattens prototype properties onto the new object
	 * as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.11.0
	 * @category Object
	 * @sig [String] -> {k: v} -> {k: v}
	 * @param {Array} path The path to the value to omit
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object without the property at path
	 * @see R.assocPath
	 * @example
	 *
	 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
	 */
	module.exports = _curry2(function dissocPath(path, obj) {
	  switch (path.length) {
	    case 0:
	      return obj;
	    case 1:
	      return dissoc(path[0], obj);
	    default:
	      var head = path[0];
	      var tail = Array.prototype.slice.call(path, 1);
	      return obj[head] == null ? obj : assoc(head, dissocPath(tail, obj[head]), obj);
	  }
	});


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Divides two numbers. Equivalent to `a / b`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a / b`.
	 * @see R.multiply
	 * @example
	 *
	 *      R.divide(71, 100); //=> 0.71
	 *
	 *      var half = R.divide(R.__, 2);
	 *      half(42); //=> 21
	 *
	 *      var reciprocal = R.divide(1);
	 *      reciprocal(4);   //=> 0.25
	 */
	module.exports = _curry2(function divide(a, b) { return a / b; });


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _dropLast = __webpack_require__(429);
	var _xdropLast = __webpack_require__(448);
	
	
	/**
	 * Returns a list containing all but the last `n` elements of the given `list`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements of `list` to skip.
	 * @param {Array} list The list of elements to consider.
	 * @return {Array} A copy of the list with only the first `list.length - n` elements
	 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
	 * @example
	 *
	 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(3, 'ramda');               //=> 'ra'
	 */
	module.exports = _curry2(_dispatchable([], _xdropLast, _dropLast));


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _dropLastWhile = __webpack_require__(430);
	var _xdropLastWhile = __webpack_require__(449);
	
	
	/**
	 * Returns a new list excluding all the tailing elements of a given list which
	 * satisfy the supplied predicate function. It passes each value from the right
	 * to the supplied predicate function, skipping elements until the predicate
	 * function returns a `falsy` value. The predicate function is applied to one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} predicate The function to be called on each element
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
	 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
	 * @example
	 *
	 *      var lteThree = x => x <= 3;
	 *
	 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
	 */
	module.exports = _curry2(_dispatchable([], _xdropLastWhile, _dropLastWhile));


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(9);
	var _xdropRepeatsWith = __webpack_require__(267);
	var dropRepeatsWith = __webpack_require__(252);
	var equals = __webpack_require__(21);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements. `R.equals`
	 * is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
	 */
	module.exports = _curry1(_dispatchable([], _xdropRepeatsWith(equals), dropRepeatsWith(equals)));


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _xdropWhile = __webpack_require__(450);
	
	
	/**
	 * Returns a new list excluding the leading elements of a given list which
	 * satisfy the supplied predicate function. It passes each value to the supplied
	 * predicate function, skipping elements while the predicate function returns
	 * `true`. The predicate function is applied to one argument: *(value)*.
	 *
	 * Dispatches to the `dropWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.takeWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var lteTwo = x => x <= 2;
	 *
	 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
	 */
	module.exports = _curry2(_dispatchable(['dropWhile'], _xdropWhile, function dropWhile(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len && pred(list[idx])) {
	    idx += 1;
	  }
	  return Array.prototype.slice.call(list, idx);
	}));


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isFunction = __webpack_require__(61);
	var lift = __webpack_require__(66);
	var or = __webpack_require__(279);
	
	
	/**
	 * A function wrapping calls to the two functions in an `||` operation,
	 * returning the result of the first function if it is truth-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * truth-y value.
	 *
	 * In addition to functions, `R.either` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f a predicate
	 * @param {Function} g another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
	 * @see R.or
	 * @example
	 *
	 *      var gt10 = x => x > 10;
	 *      var even = x => x % 2 === 0;
	 *      var f = R.either(gt10, even);
	 *      f(101); //=> true
	 *      f(8); //=> true
	 */
	module.exports = _curry2(function either(f, g) {
	  return _isFunction(f) ?
	    function _either() {
	      return f.apply(this, arguments) || g.apply(this, arguments);
	    } :
	    lift(or)(f, g);
	});


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var equals = __webpack_require__(21);
	
	
	/**
	 * Takes a function and two values in its domain and returns `true` if the
	 * values map to the same value in the codomain; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Relation
	 * @sig (a -> b) -> a -> a -> Boolean
	 * @param {Function} f
	 * @param {*} x
	 * @param {*} y
	 * @return {Boolean}
	 * @example
	 *
	 *      R.eqBy(Math.abs, 5, -5); //=> true
	 */
	module.exports = _curry3(function eqBy(f, x, y) {
	  return equals(f(x), f(y));
	});


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var equals = __webpack_require__(21);
	
	
	/**
	 * Reports whether two objects have the same value, in `R.equals` terms, for
	 * the specified property. Useful as a curried predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig k -> {k: v} -> {k: v} -> Boolean
	 * @param {String} prop The name of the property to compare
	 * @param {Object} obj1
	 * @param {Object} obj2
	 * @return {Boolean}
	 *
	 * @example
	 *
	 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
	 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
	 *      R.eqProps('a', o1, o2); //=> false
	 *      R.eqProps('c', o1, o2); //=> true
	 */
	module.exports = _curry3(function eqProps(prop, obj1, obj2) {
	  return equals(obj1[prop], obj2[prop]);
	});


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates a new object by recursively evolving a shallow copy of `object`,
	 * according to the `transformation` functions. All non-primitive properties
	 * are copied by reference.
	 *
	 * A `transformation` function will not be invoked if its corresponding key
	 * does not exist in the evolved object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
	 * @param {Object} transformations The object specifying transformation functions to apply
	 *        to the object.
	 * @param {Object} object The object to be transformed.
	 * @return {Object} The transformed object.
	 * @example
	 *
	 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
	 *      var transformations = {
	 *        firstName: R.trim,
	 *        lastName: R.trim, // Will not get invoked.
	 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
	 *      };
	 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
	 */
	module.exports = _curry2(function evolve(transformations, object) {
	  var result = {};
	  var transformation, key, type;
	  for (key in object) {
	    transformation = transformations[key];
	    type = typeof transformation;
	    result[key] = type === 'function'                 ? transformation(object[key])
	                : transformation && type === 'object' ? evolve(transformation, object[key])
	                                                      : object[key];
	  }
	  return result;
	});


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _xfind = __webpack_require__(452);
	
	
	/**
	 * Returns the first element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Dispatches to the `find` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 *        desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
	 *      R.find(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable(['find'], _xfind, function find(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx += 1;
	  }
	}));


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _xfindIndex = __webpack_require__(453);
	
	
	/**
	 * Returns the index of the first element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
	 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	module.exports = _curry2(_dispatchable([], _xfindIndex, function findIndex(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	}));


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _xfindLast = __webpack_require__(454);
	
	
	/**
	 * Returns the last element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
	 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable([], _xfindLast, function findLast(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx -= 1;
	  }
	}));


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _xfindLastIndex = __webpack_require__(455);
	
	
	/**
	 * Returns the index of the last element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
	 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	module.exports = _curry2(_dispatchable([], _xfindLastIndex, function findLastIndex(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx -= 1;
	  }
	  return -1;
	}));


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _makeFlat = __webpack_require__(265);
	
	
	/**
	 * Returns a new list by pulling every item out of it (and all its sub-arrays)
	 * and putting them in a new array, depth-first.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b]
	 * @param {Array} list The array to consider.
	 * @return {Array} The flattened list.
	 * @see R.unnest
	 * @example
	 *
	 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
	 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
	 */
	module.exports = _curry1(_makeFlat(true));


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(45);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Iterate over an input `list`, calling a provided function `fn` for each
	 * element in the list.
	 *
	 * `fn` receives one argument: *(value)*.
	 *
	 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.forEach` method. For more
	 * details on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
	 *
	 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
	 * the original array. In some libraries this function is named `each`.
	 *
	 * Dispatches to the `forEach` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> *) -> [a] -> [a]
	 * @param {Function} fn The function to invoke. Receives one argument, `value`.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} The original list.
	 * @see R.addIndex
	 * @example
	 *
	 *      var printXPlusFive = x => console.log(x + 5);
	 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
	 *      // logs 6
	 *      // logs 7
	 *      // logs 8
	 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
	 */
	module.exports = _curry2(_checkForMethod('forEach', function forEach(fn, list) {
	  var len = list.length;
	  var idx = 0;
	  while (idx < len) {
	    fn(list[idx]);
	    idx += 1;
	  }
	  return list;
	}));


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var keys = __webpack_require__(23);
	
	
	/**
	 * Iterate over an input `object`, calling a provided function `fn` for each
	 * key and value in the object.
	 *
	 * `fn` receives three argument: *(value, key, obj)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Object
	 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
	 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
	 * @param {Object} obj The object to iterate over.
	 * @return {Object} The original object.
	 * @example
	 *
	 *      var printKeyConcatValue = (value, key) => console.log(key + ':' + value);
	 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
	 *      // logs x:1
	 *      // logs y:2
	 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
	 */
	module.exports = _curry2(function forEachObjIndexed(fn, obj) {
	  var keyList = keys(obj);
	  var idx = 0;
	  while (idx < keyList.length) {
	    var key = keyList[idx];
	    fn(obj[key], key, obj);
	    idx += 1;
	  }
	  return obj;
	});


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Creates a new object from a list key-value pairs. If a key appears in
	 * multiple pairs, the rightmost pair is included in the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [[k,v]] -> {k: v}
	 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
	 * @return {Object} The object made by pairing up `keys` and `values`.
	 * @see R.toPairs, R.pair
	 * @example
	 *
	 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry1(function fromPairs(pairs) {
	  var result = {};
	  var idx = 0;
	  while (idx < pairs.length) {
	    result[pairs[idx][0]] = pairs[idx][1];
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(45);
	var _curry2 = __webpack_require__(1);
	var reduceBy = __webpack_require__(68);
	
	/**
	 * Splits a list into sub-lists stored in an object, based on the result of
	 * calling a String-returning function on each element, and grouping the
	 * results according to values returned.
	 *
	 * Dispatches to the `groupBy` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> String) -> [a] -> {String: [a]}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} list The array to group
	 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
	 *         that produced that key when passed to `fn`.
	 * @see R.transduce
	 * @example
	 *
	 *      var byGrade = R.groupBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Abby', score: 84},
	 *                      {name: 'Eddy', score: 58},
	 *                      // ...
	 *                      {name: 'Jack', score: 69}];
	 *      byGrade(students);
	 *      // {
	 *      //   'A': [{name: 'Dianne', score: 99}],
	 *      //   'B': [{name: 'Abby', score: 84}]
	 *      //   // ...,
	 *      //   'F': [{name: 'Eddy', score: 58}]
	 *      // }
	 */
	module.exports = _curry2(_checkForMethod('groupBy', reduceBy(function(acc, item) {
	  if (acc == null) {
	    acc = [];
	  }
	  acc.push(item);
	  return acc;
	}, null)));


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	/**
	 * Takes a list and returns a list of lists where each sublist's elements are
	 * all "equal" according to the provided equality function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.21.0
	 * @category List
	 * @sig ((a, a) → Boolean) → [a] → [[a]]
	 * @param {Function} fn Function for determining whether two given (adjacent)
	 *        elements should be in the same group
	 * @param {Array} list The array to group. Also accepts a string, which will be
	 *        treated as a list of characters.
	 * @return {List} A list that contains sublists of equal elements,
	 *         whose concatenations are equal to the original list.
	 * @example
	 *
	 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
	 *
	 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
	 *
	 * R.groupWith(R.eqBy(isVowel), 'aestiou')
	 * //=> ['ae', 'st', 'iou']
	 */
	module.exports = _curry2(function(fn, list) {
	  var res = [];
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    var nextidx = idx + 1;
	    while (nextidx < len && fn(list[idx], list[nextidx])) {
	      nextidx += 1;
	    }
	    res.push(list.slice(idx, nextidx));
	    idx = nextidx;
	  }
	  return res;
	});


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if the first argument is greater than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.lt
	 * @example
	 *
	 *      R.gt(2, 1); //=> true
	 *      R.gt(2, 2); //=> false
	 *      R.gt(2, 3); //=> false
	 *      R.gt('a', 'z'); //=> false
	 *      R.gt('z', 'a'); //=> true
	 */
	module.exports = _curry2(function gt(a, b) { return a > b; });


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if the first argument is greater than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.lte
	 * @example
	 *
	 *      R.gte(2, 1); //=> true
	 *      R.gte(2, 2); //=> true
	 *      R.gte(2, 3); //=> false
	 *      R.gte('a', 'z'); //=> false
	 *      R.gte('z', 'a'); //=> true
	 */
	module.exports = _curry2(function gte(a, b) { return a >= b; });


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _has = __webpack_require__(15);
	
	
	/**
	 * Returns whether or not an object has an own property with the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      var hasName = R.has('name');
	 *      hasName({name: 'alice'});   //=> true
	 *      hasName({name: 'bob'});     //=> true
	 *      hasName({});                //=> false
	 *
	 *      var point = {x: 0, y: 0};
	 *      var pointHas = R.has(R.__, point);
	 *      pointHas('x');  //=> true
	 *      pointHas('y');  //=> true
	 *      pointHas('z');  //=> false
	 */
	module.exports = _curry2(_has);


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns whether or not an object or its prototype chain has a property with
	 * the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      function Rectangle(width, height) {
	 *        this.width = width;
	 *        this.height = height;
	 *      }
	 *      Rectangle.prototype.area = function() {
	 *        return this.width * this.height;
	 *      };
	 *
	 *      var square = new Rectangle(2, 2);
	 *      R.hasIn('width', square);  //=> true
	 *      R.hasIn('area', square);  //=> true
	 */
	module.exports = _curry2(function hasIn(prop, obj) {
	  return prop in obj;
	});


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(48);
	
	
	/**
	 * Returns the first element of the given list or string. In some libraries
	 * this function is named `first`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {*}
	 * @see R.tail, R.init, R.last
	 * @example
	 *
	 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
	 *      R.head([]); //=> undefined
	 *
	 *      R.head('abc'); //=> 'a'
	 *      R.head(''); //=> ''
	 */
	module.exports = nth(0);


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var curryN = __webpack_require__(13);
	
	
	/**
	 * Creates a function that will process either the `onTrue` or the `onFalse`
	 * function depending upon the result of the `condition` predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
	 * @param {Function} condition A predicate function
	 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
	 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
	 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
	 *                    function depending upon the result of the `condition` predicate.
	 * @see R.unless, R.when
	 * @example
	 *
	 *      var incCount = R.ifElse(
	 *        R.has('count'),
	 *        R.over(R.lensProp('count'), R.inc),
	 *        R.assoc('count', 1)
	 *      );
	 *      incCount({});           //=> { count: 1 }
	 *      incCount({ count: 1 }); //=> { count: 2 }
	 */
	module.exports = _curry3(function ifElse(condition, onTrue, onFalse) {
	  return curryN(Math.max(condition.length, onTrue.length, onFalse.length),
	    function _ifElse() {
	      return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
	    }
	  );
	});


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	var add = __webpack_require__(56);
	
	
	/**
	 * Increments its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n + 1
	 * @see R.dec
	 * @example
	 *
	 *      R.inc(42); //=> 43
	 */
	module.exports = add(1);


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var reduceBy = __webpack_require__(68);
	
	
	/**
	 * Given a function that generates a key, turns a list of objects into an
	 * object indexing the objects by the given key. Note that if multiple
	 * objects generate the same value for the indexing key only the last value
	 * will be included in the generated object.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} array The array of objects to index
	 * @return {Object} An object indexing each array element by the given property.
	 * @example
	 *
	 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
	 *      R.indexBy(R.prop('id'), list);
	 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
	 */
	module.exports = reduceBy(function(acc, elem) { return elem; }, null);


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _indexOf = __webpack_require__(260);
	var _isArray = __webpack_require__(28);
	
	
	/**
	 * Returns the position of the first occurrence of an item in an array, or -1
	 * if the item is not included in the array. `R.equals` is used to determine
	 * equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.lastIndexOf
	 * @example
	 *
	 *      R.indexOf(3, [1,2,3,4]); //=> 2
	 *      R.indexOf(10, [1,2,3,4]); //=> -1
	 */
	module.exports = _curry2(function indexOf(target, xs) {
	  return typeof xs.indexOf === 'function' && !_isArray(xs) ?
	    xs.indexOf(target) :
	    _indexOf(xs, target, 0);
	});


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	var slice = __webpack_require__(31);
	
	
	/**
	 * Returns all but the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.last, R.head, R.tail
	 * @example
	 *
	 *      R.init([1, 2, 3]);  //=> [1, 2]
	 *      R.init([1, 2]);     //=> [1]
	 *      R.init([1]);        //=> []
	 *      R.init([]);         //=> []
	 *
	 *      R.init('abc');  //=> 'ab'
	 *      R.init('ab');   //=> 'a'
	 *      R.init('a');    //=> ''
	 *      R.init('');     //=> ''
	 */
	module.exports = slice(0, -1);


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Inserts the supplied element into the list, at index `index`. _Note that
	 * this is not destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} index The position to insert the element
	 * @param {*} elt The element to insert into the Array
	 * @param {Array} list The list to insert into
	 * @return {Array} A new Array with `elt` inserted at `index`.
	 * @example
	 *
	 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
	 */
	module.exports = _curry3(function insert(idx, elt, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(idx, 0, elt);
	  return result;
	});


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Inserts the sub-list into the list, at index `index`. _Note that this is not
	 * destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig Number -> [a] -> [a] -> [a]
	 * @param {Number} index The position to insert the sub-list
	 * @param {Array} elts The sub-list to insert into the Array
	 * @param {Array} list The list to insert the sub-list into
	 * @return {Array} A new Array with `elts` inserted starting at `index`.
	 * @example
	 *
	 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
	 */
	module.exports = _curry3(function insertAll(idx, elts, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  return [].concat(Array.prototype.slice.call(list, 0, idx),
	                   elts,
	                   Array.prototype.slice.call(list, idx));
	});


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(30);
	
	
	// A simple Set type that honours R.equals semantics
	module.exports = (function() {
	  function _Set() {
	    /* globals Set */
	    this._nativeSet = typeof Set === 'function' ? new Set() : null;
	    this._items = {};
	  }
	
	  // until we figure out why jsdoc chokes on this
	  // @param item The item to add to the Set
	  // @returns {boolean} true if the item did not exist prior, otherwise false
	  //
	  _Set.prototype.add = function(item) {
	    return !hasOrAdd(item, true, this);
	  };
	
	  //
	  // @param item The item to check for existence in the Set
	  // @returns {boolean} true if the item exists in the Set, otherwise false
	  //
	  _Set.prototype.has = function(item) {
	    return hasOrAdd(item, false, this);
	  };
	
	  //
	  // Combines the logic for checking whether an item is a member of the set and
	  // for adding a new item to the set.
	  //
	  // @param item       The item to check or add to the Set instance.
	  // @param shouldAdd  If true, the item will be added to the set if it doesn't
	  //                   already exist.
	  // @param set        The set instance to check or add to.
	  // @return {boolean} true if the item already existed, otherwise false.
	  //
	  function hasOrAdd(item, shouldAdd, set) {
	    var type = typeof item;
	    var prevSize, newSize;
	    switch (type) {
	      case 'string':
	      case 'number':
	        // distinguish between +0 and -0
	        if (item === 0 && 1 / item === -Infinity) {
	          if (set._items['-0']) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items['-0'] = true;
	            }
	            return false;
	          }
	        }
	        // these types can all utilise the native Set
	        if (set._nativeSet !== null) {
	          if (shouldAdd) {
	            prevSize = set._nativeSet.size;
	            set._nativeSet.add(item);
	            newSize = set._nativeSet.size;
	            return newSize === prevSize;
	          } else {
	            return set._nativeSet.has(item);
	          }
	        } else {
	          if (!(type in set._items)) {
	            if (shouldAdd) {
	              set._items[type] = {};
	              set._items[type][item] = true;
	            }
	            return false;
	          } else if (item in set._items[type]) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items[type][item] = true;
	            }
	            return false;
	          }
	        }
	
	      case 'boolean':
	        // set._items['boolean'] holds a two element array
	        // representing [ falseExists, trueExists ]
	        if (type in set._items) {
	          var bIdx = item ? 1 : 0;
	          if (set._items[type][bIdx]) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items[type][bIdx] = true;
	            }
	            return false;
	          }
	        } else {
	          if (shouldAdd) {
	            set._items[type] = item ? [false, true] : [true, false];
	          }
	          return false;
	        }
	
	      case 'function':
	        // compare functions for reference equality
	        if (set._nativeSet !== null) {
	          if (shouldAdd) {
	            prevSize = set._nativeSet.size;
	            set._nativeSet.add(item);
	            newSize = set._nativeSet.size;
	            return newSize === prevSize;
	          } else {
	            return set._nativeSet.has(item);
	          }
	        } else {
	          if (!(type in set._items)) {
	            if (shouldAdd) {
	              set._items[type] = [item];
	            }
	            return false;
	          }
	          if (!_contains(item, set._items[type])) {
	            if (shouldAdd) {
	              set._items[type].push(item);
	            }
	            return false;
	          }
	          return true;
	        }
	
	      case 'undefined':
	        if (set._items[type]) {
	          return true;
	        } else {
	          if (shouldAdd) {
	            set._items[type] = true;
	          }
	          return false;
	        }
	
	      case 'object':
	        if (item === null) {
	          if (!set._items['null']) {
	            if (shouldAdd) {
	              set._items['null'] = true;
	            }
	            return false;
	          }
	          return true;
	        }
	      /* falls through */
	      default:
	        // reduce the search size of heterogeneous sets by creating buckets
	        // for each type.
	        type = Object.prototype.toString.call(item);
	        if (!(type in set._items)) {
	          if (shouldAdd) {
	            set._items[type] = [item];
	          }
	          return false;
	        }
	        // scan through all previously applied items
	        if (!_contains(item, set._items[type])) {
	          if (shouldAdd) {
	            set._items[type].push(item);
	          }
	          return false;
	        }
	        return true;
	    }
	  }
	  return _Set;
	}());


/***/ },
/* 427 */
/***/ function(module, exports) {

	module.exports = function _aperture(n, list) {
	  var idx = 0;
	  var limit = list.length - (n - 1);
	  var acc = new Array(limit >= 0 ? limit : 0);
	  while (idx < limit) {
	    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
	    idx += 1;
	  }
	  return acc;
	};


/***/ },
/* 428 */
/***/ function(module, exports) {

	module.exports = function _arrayFromIterator(iter) {
	  var list = [];
	  var next;
	  while (!(next = iter.next()).done) {
	    list.push(next.value);
	  }
	  return list;
	};


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	var take = __webpack_require__(288);
	
	module.exports = function dropLast(n, xs) {
	  return take(n < xs.length ? xs.length - n : 0, xs);
	};


/***/ },
/* 430 */
/***/ function(module, exports) {

	module.exports = function dropLastWhile(pred, list) {
	  var idx = list.length - 1;
	  while (idx >= 0 && pred(list[idx])) {
	    idx -= 1;
	  }
	  return Array.prototype.slice.call(list, 0, idx + 1);
	};


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	var _arrayFromIterator = __webpack_require__(428);
	var _functionName = __webpack_require__(434);
	var _has = __webpack_require__(15);
	var identical = __webpack_require__(254);
	var keys = __webpack_require__(23);
	var type = __webpack_require__(88);
	
	
	module.exports = function _equals(a, b, stackA, stackB) {
	  if (identical(a, b)) {
	    return true;
	  }
	
	  if (type(a) !== type(b)) {
	    return false;
	  }
	
	  if (a == null || b == null) {
	    return false;
	  }
	
	  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
	    return typeof a.equals === 'function' && a.equals(b) &&
	           typeof b.equals === 'function' && b.equals(a);
	  }
	
	  switch (type(a)) {
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	      if (typeof a.constructor === 'function' &&
	          _functionName(a.constructor) === 'Promise') {
	        return a === b;
	      }
	      break;
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	      if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
	        return false;
	      }
	      break;
	    case 'Date':
	      if (!identical(a.valueOf(), b.valueOf())) {
	        return false;
	      }
	      break;
	    case 'Error':
	      return a.name === b.name && a.message === b.message;
	    case 'RegExp':
	      if (!(a.source === b.source &&
	            a.global === b.global &&
	            a.ignoreCase === b.ignoreCase &&
	            a.multiline === b.multiline &&
	            a.sticky === b.sticky &&
	            a.unicode === b.unicode)) {
	        return false;
	      }
	      break;
	    case 'Map':
	    case 'Set':
	      if (!_equals(_arrayFromIterator(a.entries()), _arrayFromIterator(b.entries()), stackA, stackB)) {
	        return false;
	      }
	      break;
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float32Array':
	    case 'Float64Array':
	      break;
	    case 'ArrayBuffer':
	      break;
	    default:
	      // Values of other types are only equal if identical.
	      return false;
	  }
	
	  var keysA = keys(a);
	  if (keysA.length !== keys(b).length) {
	    return false;
	  }
	
	  var idx = stackA.length - 1;
	  while (idx >= 0) {
	    if (stackA[idx] === a) {
	      return stackB[idx] === b;
	    }
	    idx -= 1;
	  }
	
	  stackA.push(a);
	  stackB.push(b);
	  idx = keysA.length - 1;
	  while (idx >= 0) {
	    var key = keysA[idx];
	    if (!(_has(key, b) && _equals(b[key], a[key], stackA, stackB))) {
	      return false;
	    }
	    idx -= 1;
	  }
	  stackA.pop();
	  stackB.pop();
	  return true;
	};


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var _forceReduced = __webpack_require__(433);
	var _reduce = __webpack_require__(17);
	var _xfBase = __webpack_require__(11);
	var isArrayLike = __webpack_require__(47);
	
	module.exports = (function() {
	  var preservingReduced = function(xf) {
	    return {
	      '@@transducer/init': _xfBase.init,
	      '@@transducer/result': function(result) {
	        return xf['@@transducer/result'](result);
	      },
	      '@@transducer/step': function(result, input) {
	        var ret = xf['@@transducer/step'](result, input);
	        return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
	      }
	    };
	  };
	
	  return function _xcat(xf) {
	    var rxf = preservingReduced(xf);
	    return {
	      '@@transducer/init': _xfBase.init,
	      '@@transducer/result': function(result) {
	        return rxf['@@transducer/result'](result);
	      },
	      '@@transducer/step': function(result, input) {
	        return !isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
	      }
	    };
	  };
	}());


/***/ },
/* 433 */
/***/ function(module, exports) {

	module.exports = function _forceReduced(x) {
	  return {
	    '@@transducer/value': x,
	    '@@transducer/reduced': true
	  };
	};


/***/ },
/* 434 */
/***/ function(module, exports) {

	module.exports = function _functionName(f) {
	  // String(x => x) evaluates to "x => x", so the pattern may not match.
	  var match = String(f).match(/^function (\w*)/);
	  return match == null ? '' : match[1];
	};


/***/ },
/* 435 */
/***/ function(module, exports) {

	module.exports = function _isRegExp(x) {
	  return Object.prototype.toString.call(x) === '[object RegExp]';
	};


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(15);
	
	// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	module.exports = function _objectAssign(target) {
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  var output = Object(target);
	  var idx = 1;
	  var length = arguments.length;
	  while (idx < length) {
	    var source = arguments[idx];
	    if (source != null) {
	      for (var nextKey in source) {
	        if (_has(nextKey, source)) {
	          output[nextKey] = source[nextKey];
	        }
	      }
	    }
	    idx += 1;
	  }
	  return output;
	};


/***/ },
/* 437 */
/***/ function(module, exports) {

	module.exports = function _of(x) { return [x]; };


/***/ },
/* 438 */
/***/ function(module, exports) {

	module.exports = function _pipe(f, g) {
	  return function() {
	    return g.call(this, f.apply(this, arguments));
	  };
	};


/***/ },
/* 439 */
/***/ function(module, exports) {

	module.exports = function _pipeP(f, g) {
	  return function() {
	    var ctx = this;
	    return f.apply(ctx, arguments).then(function(x) {
	      return g.call(ctx, x);
	    });
	  };
	};


/***/ },
/* 440 */
/***/ function(module, exports) {

	module.exports = function _quote(s) {
	  var escaped = s
	    .replace(/\\/g, '\\\\')
	    .replace(/[\b]/g, '\\b')  // \b matches word boundary; [\b] matches backspace
	    .replace(/\f/g, '\\f')
	    .replace(/\n/g, '\\n')
	    .replace(/\r/g, '\\r')
	    .replace(/\t/g, '\\t')
	    .replace(/\v/g, '\\v')
	    .replace(/\0/g, '\\0');
	
	  return '"' + escaped.replace(/"/g, '\\"') + '"';
	};


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(82);
	var _identity = __webpack_require__(84);
	var _isTransformer = __webpack_require__(85);
	var isArrayLike = __webpack_require__(47);
	var objOf = __webpack_require__(278);
	
	
	module.exports = (function() {
	  var _stepCatArray = {
	    '@@transducer/init': Array,
	    '@@transducer/step': function(xs, x) {
	      xs.push(x);
	      return xs;
	    },
	    '@@transducer/result': _identity
	  };
	  var _stepCatString = {
	    '@@transducer/init': String,
	    '@@transducer/step': function(a, b) { return a + b; },
	    '@@transducer/result': _identity
	  };
	  var _stepCatObject = {
	    '@@transducer/init': Object,
	    '@@transducer/step': function(result, input) {
	      return _assign(
	        result,
	        isArrayLike(input) ? objOf(input[0], input[1]) : input
	      );
	    },
	    '@@transducer/result': _identity
	  };
	
	  return function _stepCat(obj) {
	    if (_isTransformer(obj)) {
	      return obj;
	    }
	    if (isArrayLike(obj)) {
	      return _stepCatArray;
	    }
	    if (typeof obj === 'string') {
	      return _stepCatString;
	    }
	    if (typeof obj === 'object') {
	      return _stepCatObject;
	    }
	    throw new Error('Cannot create transformer for ' + obj);
	  };
	}());


/***/ },
/* 442 */
/***/ function(module, exports) {

	/**
	 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
	 */
	module.exports = (function() {
	  var pad = function pad(n) { return (n < 10 ? '0' : '') + n; };
	
	  return typeof Date.prototype.toISOString === 'function' ?
	    function _toISOString(d) {
	      return d.toISOString();
	    } :
	    function _toISOString(d) {
	      return (
	        d.getUTCFullYear() + '-' +
	        pad(d.getUTCMonth() + 1) + '-' +
	        pad(d.getUTCDate()) + 'T' +
	        pad(d.getUTCHours()) + ':' +
	        pad(d.getUTCMinutes()) + ':' +
	        pad(d.getUTCSeconds()) + '.' +
	        (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z'
	      );
	    };
	}());


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(30);
	var _map = __webpack_require__(64);
	var _quote = __webpack_require__(440);
	var _toISOString = __webpack_require__(442);
	var keys = __webpack_require__(23);
	var reject = __webpack_require__(69);
	
	
	module.exports = function _toString(x, seen) {
	  var recur = function recur(y) {
	    var xs = seen.concat([x]);
	    return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
	  };
	
	  //  mapPairs :: (Object, [String]) -> [String]
	  var mapPairs = function(obj, keys) {
	    return _map(function(k) { return _quote(k) + ': ' + recur(obj[k]); }, keys.slice().sort());
	  };
	
	  switch (Object.prototype.toString.call(x)) {
	    case '[object Arguments]':
	      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
	    case '[object Array]':
	      return '[' + _map(recur, x).concat(mapPairs(x, reject(function(k) { return /^\d+$/.test(k); }, keys(x)))).join(', ') + ']';
	    case '[object Boolean]':
	      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
	    case '[object Date]':
	      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
	    case '[object Null]':
	      return 'null';
	    case '[object Number]':
	      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
	    case '[object String]':
	      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
	    case '[object Undefined]':
	      return 'undefined';
	    default:
	      if (typeof x.toString === 'function') {
	        var repr = x.toString();
	        if (repr !== '[object Object]') {
	          return repr;
	        }
	      }
	      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
	  }
	};


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduced = __webpack_require__(29);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XAll(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.all = true;
	  }
	  XAll.prototype['@@transducer/init'] = _xfBase.init;
	  XAll.prototype['@@transducer/result'] = function(result) {
	    if (this.all) {
	      result = this.xf['@@transducer/step'](result, true);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAll.prototype['@@transducer/step'] = function(result, input) {
	    if (!this.f(input)) {
	      this.all = false;
	      result = _reduced(this.xf['@@transducer/step'](result, false));
	    }
	    return result;
	  };
	
	  return _curry2(function _xall(f, xf) { return new XAll(f, xf); });
	}());


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(19);
	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XAperture(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XAperture.prototype['@@transducer/init'] = _xfBase.init;
	  XAperture.prototype['@@transducer/result'] = function(result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XAperture.prototype['@@transducer/step'] = function(result, input) {
	    this.store(input);
	    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
	  };
	  XAperture.prototype.store = function(input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	  XAperture.prototype.getCopy = function() {
	    return _concat(Array.prototype.slice.call(this.acc, this.pos),
	                   Array.prototype.slice.call(this.acc, 0, this.pos));
	  };
	
	  return _curry2(function _xaperture(n, xf) { return new XAperture(n, xf); });
	}());


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _flatCat = __webpack_require__(432);
	var map = __webpack_require__(16);
	
	
	module.exports = _curry2(function _xchain(f, xf) {
	  return map(f, _flatCat(xf));
	});


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XDrop(n, xf) {
	    this.xf = xf;
	    this.n = n;
	  }
	  XDrop.prototype['@@transducer/init'] = _xfBase.init;
	  XDrop.prototype['@@transducer/result'] = _xfBase.result;
	  XDrop.prototype['@@transducer/step'] = function(result, input) {
	    if (this.n > 0) {
	      this.n -= 1;
	      return result;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdrop(n, xf) { return new XDrop(n, xf); });
	}());


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XDropLast(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XDropLast.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLast.prototype['@@transducer/result'] =  function(result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLast.prototype['@@transducer/step'] = function(result, input) {
	    if (this.full) {
	      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
	    }
	    this.store(input);
	    return result;
	  };
	  XDropLast.prototype.store = function(input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	
	  return _curry2(function _xdropLast(n, xf) { return new XDropLast(n, xf); });
	}());


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduce = __webpack_require__(17);
	var _xfBase = __webpack_require__(11);
	
	module.exports = (function() {
	  function XDropLastWhile(fn, xf) {
	    this.f = fn;
	    this.retained = [];
	    this.xf = xf;
	  }
	  XDropLastWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLastWhile.prototype['@@transducer/result'] = function(result) {
	    this.retained = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLastWhile.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.retain(result, input)
	                         : this.flush(result, input);
	  };
	  XDropLastWhile.prototype.flush = function(result, input) {
	    result = _reduce(
	      this.xf['@@transducer/step'],
	      result,
	      this.retained
	    );
	    this.retained = [];
	    return this.xf['@@transducer/step'](result, input);
	  };
	  XDropLastWhile.prototype.retain = function(result, input) {
	    this.retained.push(input);
	    return result;
	  };
	
	  return _curry2(function _xdropLastWhile(fn, xf) { return new XDropLastWhile(fn, xf); });
	}());


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XDropWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XDropWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XDropWhile.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f) {
	      if (this.f(input)) {
	        return result;
	      }
	      this.f = null;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropWhile(f, xf) { return new XDropWhile(f, xf); });
	}());


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XFilter(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFilter.prototype['@@transducer/init'] = _xfBase.init;
	  XFilter.prototype['@@transducer/result'] = _xfBase.result;
	  XFilter.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
	  };
	
	  return _curry2(function _xfilter(f, xf) { return new XFilter(f, xf); });
	}());


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduced = __webpack_require__(29);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XFind(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.found = false;
	  }
	  XFind.prototype['@@transducer/init'] = _xfBase.init;
	  XFind.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, void 0);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFind.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, input));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfind(f, xf) { return new XFind(f, xf); });
	}());


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduced = __webpack_require__(29);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XFindIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.found = false;
	  }
	  XFindIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindIndex.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, -1);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFindIndex.prototype['@@transducer/step'] = function(result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, this.idx));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindIndex(f, xf) { return new XFindIndex(f, xf); });
	}());


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XFindLast(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFindLast.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLast.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
	  };
	  XFindLast.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.last = input;
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindLast(f, xf) { return new XFindLast(f, xf); });
	}());


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XFindLastIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.lastIdx = -1;
	  }
	  XFindLastIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLastIndex.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
	  };
	  XFindLastIndex.prototype['@@transducer/step'] = function(result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.lastIdx = this.idx;
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindLastIndex(f, xf) { return new XFindLastIndex(f, xf); });
	}());


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XMap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XMap.prototype['@@transducer/init'] = _xfBase.init;
	  XMap.prototype['@@transducer/result'] = _xfBase.result;
	  XMap.prototype['@@transducer/step'] = function(result, input) {
	    return this.xf['@@transducer/step'](result, this.f(input));
	  };
	
	  return _curry2(function _xmap(f, xf) { return new XMap(f, xf); });
	}());


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(60);
	var _has = __webpack_require__(15);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
	    this.valueFn = valueFn;
	    this.valueAcc = valueAcc;
	    this.keyFn = keyFn;
	    this.xf = xf;
	    this.inputs = {};
	  }
	  XReduceBy.prototype['@@transducer/init'] = _xfBase.init;
	  XReduceBy.prototype['@@transducer/result'] = function(result) {
	    var key;
	    for (key in this.inputs) {
	      if (_has(key, this.inputs)) {
	        result = this.xf['@@transducer/step'](result, this.inputs[key]);
	        if (result['@@transducer/reduced']) {
	          result = result['@@transducer/value'];
	          break;
	        }
	      }
	    }
	    this.inputs = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XReduceBy.prototype['@@transducer/step'] = function(result, input) {
	    var key = this.keyFn(input);
	    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
	    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
	    return result;
	  };
	
	  return _curryN(4, [],
	                 function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
	                   return new XReduceBy(valueFn, valueAcc, keyFn, xf);
	                 });
	}());


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduced = __webpack_require__(29);
	var _xfBase = __webpack_require__(11);
	
	module.exports = (function() {
	  function XTake(n, xf) {
	    this.xf = xf;
	    this.n = n;
	    this.i = 0;
	  }
	  XTake.prototype['@@transducer/init'] = _xfBase.init;
	  XTake.prototype['@@transducer/result'] = _xfBase.result;
	  XTake.prototype['@@transducer/step'] = function(result, input) {
	    this.i += 1;
	    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
	    return this.i >= this.n ? _reduced(ret) : ret;
	  };
	
	  return _curry2(function _xtake(n, xf) { return new XTake(n, xf); });
	}());


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduced = __webpack_require__(29);
	var _xfBase = __webpack_require__(11);
	
	
	module.exports = (function() {
	  function XTakeWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XTakeWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XTakeWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : _reduced(result);
	  };
	
	  return _curry2(function _xtakeWhile(f, xf) { return new XTakeWhile(f, xf); });
	}());


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(30);
	var _curry2 = __webpack_require__(1);
	var _filter = __webpack_require__(259);
	var flip = __webpack_require__(59);
	var uniq = __webpack_require__(89);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The list of elements found in both `list1` and `list2`.
	 * @see R.intersectionWith
	 * @example
	 *
	 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
	 */
	module.exports = _curry2(function intersection(list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  return uniq(_filter(flip(_contains)(lookupList), filteredList));
	});


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(83);
	var _curry3 = __webpack_require__(4);
	var uniqWith = __webpack_require__(90);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate function that determines whether
	 *        the two supplied elements are equal.
	 * @param {Array} list1 One list of items to compare
	 * @param {Array} list2 A second list of items to compare
	 * @return {Array} A new list containing those elements common to both lists.
	 * @see R.intersection
	 * @example
	 *
	 *      var buffaloSpringfield = [
	 *        {id: 824, name: 'Richie Furay'},
	 *        {id: 956, name: 'Dewey Martin'},
	 *        {id: 313, name: 'Bruce Palmer'},
	 *        {id: 456, name: 'Stephen Stills'},
	 *        {id: 177, name: 'Neil Young'}
	 *      ];
	 *      var csny = [
	 *        {id: 204, name: 'David Crosby'},
	 *        {id: 456, name: 'Stephen Stills'},
	 *        {id: 539, name: 'Graham Nash'},
	 *        {id: 177, name: 'Neil Young'}
	 *      ];
	 *
	 *      R.intersectionWith(R.eqBy(R.prop('id')), buffaloSpringfield, csny);
	 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
	 */
	module.exports = _curry3(function intersectionWith(pred, list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  var results = [];
	  var idx = 0;
	  while (idx < filteredList.length) {
	    if (_containsWith(pred, filteredList[idx], lookupList)) {
	      results[results.length] = filteredList[idx];
	    }
	    idx += 1;
	  }
	  return uniqWith(pred, results);
	});


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(45);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates a new list with the separator interposed between elements.
	 *
	 * Dispatches to the `intersperse` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} separator The element to add to the list.
	 * @param {Array} list The list to be interposed.
	 * @return {Array} The new list.
	 * @example
	 *
	 *      R.intersperse('n', ['ba', 'a', 'a']); //=> ['ba', 'n', 'a', 'n', 'a']
	 */
	module.exports = _curry2(_checkForMethod('intersperse', function intersperse(separator, list) {
	  var out = [];
	  var idx = 0;
	  var length = list.length;
	  while (idx < length) {
	    if (idx === length - 1) {
	      out.push(list[idx]);
	    } else {
	      out.push(list[idx], separator);
	    }
	    idx += 1;
	  }
	  return out;
	}));


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(255);
	var _curry3 = __webpack_require__(4);
	var _isTransformer = __webpack_require__(85);
	var _reduce = __webpack_require__(17);
	var _stepCat = __webpack_require__(441);
	
	
	/**
	 * Transforms the items of the list with the transducer and appends the
	 * transformed items to the accumulator using an appropriate iterator function
	 * based on the accumulator type.
	 *
	 * The accumulator can be an array, string, object or a transformer. Iterated
	 * items will be appended to arrays and concatenated to strings. Objects will
	 * be merged directly or 2-item arrays will be merged as key, value pairs.
	 *
	 * The accumulator can also be a transformer object that provides a 2-arity
	 * reducing iterator function, step, 0-arity initial value function, init, and
	 * 1-arity result extraction function result. The step function is used as the
	 * iterator function in reduce. The result function is used to convert the
	 * final accumulator into the return type and in most cases is R.identity. The
	 * init function is used to provide the initial accumulator.
	 *
	 * The iteration is performed with R.reduce after initializing the transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig a -> (b -> b) -> [c] -> a
	 * @param {*} acc The initial accumulator value.
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *
	 *      R.into([], transducer, numbers); //=> [2, 3]
	 *
	 *      var intoArray = R.into([]);
	 *      intoArray(transducer, numbers); //=> [2, 3]
	 */
	module.exports = _curry3(function into(acc, xf, list) {
	  return _isTransformer(acc) ?
	    _reduce(xf(acc), acc['@@transducer/init'](), list) :
	    _reduce(xf(_stepCat(acc)), _clone(acc, [], [], false), list);
	});


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _has = __webpack_require__(15);
	var keys = __webpack_require__(23);
	
	
	/**
	 * Same as R.invertObj, however this accounts for objects with duplicate values
	 * by putting the values into an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: [ s, ... ]}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object with keys
	 * in an array.
	 * @example
	 *
	 *      var raceResultsByFirstName = {
	 *        first: 'alice',
	 *        second: 'jake',
	 *        third: 'alice',
	 *      };
	 *      R.invert(raceResultsByFirstName);
	 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
	 */
	module.exports = _curry1(function invert(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    var val = obj[key];
	    var list = _has(val, out) ? out[val] : (out[val] = []);
	    list[list.length] = key;
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var keys = __webpack_require__(23);
	
	
	/**
	 * Returns a new object with the keys of the given object as values, and the
	 * values of the given object, which are coerced to strings, as keys. Note
	 * that the last key found is preferred when handling the same value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: s}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object
	 * @example
	 *
	 *      var raceResults = {
	 *        first: 'alice',
	 *        second: 'jake'
	 *      };
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': 'first', 'jake':'second' }
	 *
	 *      // Alternatively:
	 *      var raceResults = ['alice', 'jake'];
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': '0', 'jake':'1' }
	 */
	module.exports = _curry1(function invertObj(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    out[obj[key]] = key;
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var empty = __webpack_require__(253);
	var equals = __webpack_require__(21);
	
	
	/**
	 * Returns `true` if the given value is its type's empty value; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> Boolean
	 * @param {*} x
	 * @return {Boolean}
	 * @see R.empty
	 * @example
	 *
	 *      R.isEmpty([1, 2, 3]);   //=> false
	 *      R.isEmpty([]);          //=> true
	 *      R.isEmpty('');          //=> true
	 *      R.isEmpty(null);        //=> false
	 *      R.isEmpty({});          //=> true
	 *      R.isEmpty({length: 0}); //=> false
	 */
	module.exports = _curry1(function isEmpty(x) {
	  return x != null && equals(x, empty(x));
	});


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Checks if the input value is `null` or `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Type
	 * @sig * -> Boolean
	 * @param {*} x The value to test.
	 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
	 * @example
	 *
	 *      R.isNil(null); //=> true
	 *      R.isNil(undefined); //=> true
	 *      R.isNil(0); //=> false
	 *      R.isNil([]); //=> false
	 */
	module.exports = _curry1(function isNil(x) { return x == null; });


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(46);
	
	
	/**
	 * Returns a string made by inserting the `separator` between each element and
	 * concatenating all the elements into a single string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig String -> [a] -> String
	 * @param {Number|String} separator The string used to separate the elements.
	 * @param {Array} xs The elements to join into a string.
	 * @return {String} str The string made by concatenating `xs` with `separator`.
	 * @see R.split
	 * @example
	 *
	 *      var spacer = R.join(' ');
	 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
	 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
	 */
	module.exports = invoker(1, 'join');


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Returns a list containing the names of all the properties of the supplied
	 * object, including prototype properties.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.keysIn(f); //=> ['x', 'y']
	 */
	module.exports = _curry1(function keysIn(obj) {
	  var prop;
	  var ks = [];
	  for (prop in obj) {
	    ks[ks.length] = prop;
	  }
	  return ks;
	});


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isArray = __webpack_require__(28);
	var equals = __webpack_require__(21);
	
	
	/**
	 * Returns the position of the last occurrence of an item in an array, or -1 if
	 * the item is not included in the array. `R.equals` is used to determine
	 * equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.indexOf
	 * @example
	 *
	 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
	 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
	 */
	module.exports = _curry2(function lastIndexOf(target, xs) {
	  if (typeof xs.lastIndexOf === 'function' && !_isArray(xs)) {
	    return xs.lastIndexOf(target);
	  } else {
	    var idx = xs.length - 1;
	    while (idx >= 0) {
	      if (equals(xs[idx], target)) {
	        return idx;
	      }
	      idx -= 1;
	    }
	    return -1;
	  }
	});


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var lens = __webpack_require__(65);
	var nth = __webpack_require__(48);
	var update = __webpack_require__(291);
	
	
	/**
	 * Returns a lens whose focus is the specified index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Number -> Lens s a
	 * @param {Number} n
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
	 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
	 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
	 */
	module.exports = _curry1(function lensIndex(n) {
	  return lens(nth(n), update(n));
	});


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var assocPath = __webpack_require__(242);
	var lens = __webpack_require__(65);
	var path = __webpack_require__(49);
	
	
	/**
	 * Returns a lens whose focus is the specified path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig [Idx] -> Lens s a
	 * @param {Array} path The path to use.
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xHeadYLens = R.lensPath(['x', 0, 'y']);
	 *
	 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> 2
	 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
	 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
	 */
	module.exports = _curry1(function lensPath(p) {
	  return lens(path(p), assocPath(p));
	});


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var assoc = __webpack_require__(57);
	var lens = __webpack_require__(65);
	var prop = __webpack_require__(86);
	
	
	/**
	 * Returns a lens whose focus is the specified property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig String -> Lens s a
	 * @param {String} k
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	module.exports = _curry1(function lensProp(k) {
	  return lens(prop(k), assoc(k));
	});


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if the first argument is less than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.gt
	 * @example
	 *
	 *      R.lt(2, 1); //=> false
	 *      R.lt(2, 2); //=> false
	 *      R.lt(2, 3); //=> true
	 *      R.lt('a', 'z'); //=> true
	 *      R.lt('z', 'a'); //=> false
	 */
	module.exports = _curry2(function lt(a, b) { return a < b; });


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if the first argument is less than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.gte
	 * @example
	 *
	 *      R.lte(2, 1); //=> false
	 *      R.lte(2, 2); //=> true
	 *      R.lte(2, 3); //=> true
	 *      R.lte('a', 'z'); //=> true
	 *      R.lte('z', 'a'); //=> false
	 */
	module.exports = _curry2(function lte(a, b) { return a <= b; });


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * The mapAccum function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from left to right, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * The iterator function receives two arguments, *acc* and *value*, and should
	 * return a tuple *[acc, value]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (acc -> x -> (acc, y)) -> acc -> [x] -> (acc, [y])
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccumRight
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var appender = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
	 * @symb R.mapAccum(f, a, [b, c, d]) = [
	 *   f(f(f(a, b)[0], c)[0], d)[0],
	 *   [
	 *     f(a, b)[1],
	 *     f(f(a, b)[0], c)[1],
	 *     f(f(f(a, b)[0], c)[0], d)[1]
	 *   ]
	 * ]
	 */
	module.exports = _curry3(function mapAccum(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var tuple = [acc];
	  while (idx < len) {
	    tuple = fn(tuple[0], list[idx]);
	    result[idx] = tuple[1];
	    idx += 1;
	  }
	  return [tuple[0], result];
	});


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * The mapAccumRight function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from right to left, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * Similar to `mapAccum`, except moves through the input list from the right to
	 * the left.
	 *
	 * The iterator function receives two arguments, *value* and *acc*, and should
	 * return a tuple *[value, acc]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (x-> acc -> (y, acc)) -> acc -> [x] -> ([y], acc)
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccum
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var append = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccumRight(append, 5, digits); //=> [['12345', '2345', '345', '45'], '12345']
	 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
	 *   [
	 *     f(b, f(c, f(d, a)[0])[0])[1],
	 *     f(c, f(d, a)[0])[1],
	 *     f(d, a)[1],
	 *   ]
	 *   f(b, f(c, f(d, a)[0])[0])[0],
	 * ]
	 */
	module.exports = _curry3(function mapAccumRight(fn, acc, list) {
	  var idx = list.length - 1;
	  var result = [];
	  var tuple = [acc];
	  while (idx >= 0) {
	    tuple = fn(list[idx], tuple[0]);
	    result[idx] = tuple[1];
	    idx -= 1;
	  }
	  return [result, tuple[0]];
	});


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduce = __webpack_require__(17);
	var keys = __webpack_require__(23);
	
	
	/**
	 * An Object-specific version of `map`. The function is applied to three
	 * arguments: *(value, key, obj)*. If only the value is significant, use
	 * `map` instead.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig ((*, String, Object) -> *) -> Object -> Object
	 * @param {Function} fn
	 * @param {Object} obj
	 * @return {Object}
	 * @see R.map
	 * @example
	 *
	 *      var values = { x: 1, y: 2, z: 3 };
	 *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
	 *
	 *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
	 */
	module.exports = _curry2(function mapObjIndexed(fn, obj) {
	  return _reduce(function(acc, key) {
	    acc[key] = fn(obj[key], key, obj);
	    return acc;
	  }, {}, keys(obj));
	});


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Tests a regular expression against a String. Note that this function will
	 * return an empty array when there are no matches. This differs from
	 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
	 * which returns `null` when there are no matches.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig RegExp -> String -> [String | Undefined]
	 * @param {RegExp} rx A regular expression.
	 * @param {String} str The string to match against
	 * @return {Array} The list of matches or empty array.
	 * @see R.test
	 * @example
	 *
	 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
	 *      R.match(/a/, 'b'); //=> []
	 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
	 */
	module.exports = _curry2(function match(rx, str) {
	  return str.match(rx) || [];
	});


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isInteger = __webpack_require__(262);
	
	
	/**
	 * mathMod behaves like the modulo operator should mathematically, unlike the
	 * `%` operator (and by extension, R.modulo). So while "-17 % 5" is -2,
	 * mathMod(-17, 5) is 3. mathMod requires Integer arguments, and returns NaN
	 * when the modulus is zero or negative.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} m The dividend.
	 * @param {Number} p the modulus.
	 * @return {Number} The result of `b mod a`.
	 * @example
	 *
	 *      R.mathMod(-17, 5);  //=> 3
	 *      R.mathMod(17, 5);   //=> 2
	 *      R.mathMod(17, -5);  //=> NaN
	 *      R.mathMod(17, 0);   //=> NaN
	 *      R.mathMod(17.2, 5); //=> NaN
	 *      R.mathMod(17, 5.3); //=> NaN
	 *
	 *      var clock = R.mathMod(R.__, 12);
	 *      clock(15); //=> 3
	 *      clock(24); //=> 0
	 *
	 *      var seventeenMod = R.mathMod(17);
	 *      seventeenMod(3);  //=> 2
	 *      seventeenMod(4);  //=> 1
	 *      seventeenMod(10); //=> 7
	 */
	module.exports = _curry2(function mathMod(m, p) {
	  if (!_isInteger(m)) { return NaN; }
	  if (!_isInteger(p) || p < 1) { return NaN; }
	  return ((m % p) + p) % p;
	});


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * larger result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.max, R.minBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.maxBy(square, -3, 2); //=> -3
	 *
	 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
	 *      R.reduce(R.maxBy(square), 0, []); //=> 0
	 */
	module.exports = _curry3(function maxBy(f, a, b) {
	  return f(b) > f(a) ? b : a;
	});


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var mean = __webpack_require__(274);
	
	
	/**
	 * Returns the median of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @example
	 *
	 *      R.median([2, 9, 7]); //=> 7
	 *      R.median([7, 2, 10, 9]); //=> 8
	 *      R.median([]); //=> NaN
	 */
	module.exports = _curry1(function median(list) {
	  var len = list.length;
	  if (len === 0) {
	    return NaN;
	  }
	  var width = 2 - len % 2;
	  var idx = (len - width) / 2;
	  return mean(Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    return a < b ? -1 : a > b ? 1 : 0;
	  }).slice(idx, idx + width));
	});


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(22);
	var _curry1 = __webpack_require__(3);
	var _has = __webpack_require__(15);
	var toString = __webpack_require__(51);
	
	
	/**
	 * Creates a new function that, when invoked, caches the result of calling `fn`
	 * for a given argument set and returns the result. Subsequent calls to the
	 * memoized `fn` with the same argument set will not result in an additional
	 * call to `fn`; instead, the cached result for that set of arguments will be
	 * returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (*... -> a) -> (*... -> a)
	 * @param {Function} fn The function to memoize.
	 * @return {Function} Memoized version of `fn`.
	 * @example
	 *
	 *      var count = 0;
	 *      var factorial = R.memoize(n => {
	 *        count += 1;
	 *        return R.product(R.range(1, n + 1));
	 *      });
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      count; //=> 1
	 */
	module.exports = _curry1(function memoize(fn) {
	  var cache = {};
	  return _arity(fn.length, function() {
	    var key = toString(arguments);
	    if (!_has(key, cache)) {
	      cache[key] = fn.apply(this, arguments);
	    }
	    return cache[key];
	  });
	});


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(82);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Create a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects,
	 * the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> {k: v} -> {k: v}
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeWith, R.mergeWithKey
	 * @example
	 *
	 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
	 *      //=> { 'name': 'fred', 'age': 40 }
	 *
	 *      var resetToDefault = R.merge(R.__, {x: 0});
	 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
	 * @symb R.merge({ x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: 5, z: 3 }
	 */
	module.exports = _curry2(function merge(l, r) {
	  return _assign({}, l, r);
	});


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(82);
	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Merges a list of objects together into one object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig [{k: v}] -> {k: v}
	 * @param {Array} list An array of objects
	 * @return {Object} A merged object.
	 * @see R.reduce
	 * @example
	 *
	 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
	 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
	 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
	 */
	module.exports = _curry1(function mergeAll(list) {
	  return _assign.apply(null, [{}].concat(list));
	});


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var mergeWithKey = __webpack_require__(275);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the values
	 * associated with the key in each object, with the result being used as the
	 * value associated with the key in the returned object. The key will be
	 * excluded from the returned object if the resulting value is `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.merge, R.mergeWithKey
	 * @example
	 *
	 *      R.mergeWith(R.concat,
	 *                  { a: true, values: [10, 20] },
	 *                  { b: true, values: [15, 35] });
	 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
	 */
	module.exports = _curry3(function mergeWith(fn, l, r) {
	  return mergeWithKey(function(_, _l, _r) {
	    return fn(_l, _r);
	  }, l, r);
	});


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns the smaller of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.minBy, R.max
	 * @example
	 *
	 *      R.min(789, 123); //=> 123
	 *      R.min('a', 'b'); //=> 'a'
	 */
	module.exports = _curry2(function min(a, b) { return b < a ? b : a; });


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * smaller result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.min, R.maxBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.minBy(square, -3, 2); //=> 2
	 *
	 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
	 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
	 */
	module.exports = _curry3(function minBy(f, a, b) {
	  return f(b) < f(a) ? b : a;
	});


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Divides the first parameter by the second and returns the remainder. Note
	 * that this function preserves the JavaScript-style behavior for modulo. For
	 * mathematical modulo see `mathMod`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The value to the divide.
	 * @param {Number} b The pseudo-modulus
	 * @return {Number} The result of `b % a`.
	 * @see R.mathMod
	 * @example
	 *
	 *      R.modulo(17, 3); //=> 2
	 *      // JS behavior:
	 *      R.modulo(-17, 3); //=> -2
	 *      R.modulo(17, -3); //=> 2
	 *
	 *      var isOdd = R.modulo(R.__, 2);
	 *      isOdd(42); //=> 0
	 *      isOdd(21); //=> 1
	 */
	module.exports = _curry2(function modulo(a, b) { return a % b; });


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Negates its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number}
	 * @example
	 *
	 *      R.negate(42); //=> -42
	 */
	module.exports = _curry1(function negate(n) { return -n; });


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(257);
	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _xany = __webpack_require__(266);
	var any = __webpack_require__(240);
	
	
	/**
	 * Returns `true` if no elements of the list match the predicate, `false`
	 * otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
	 * @see R.all, R.any
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
	 *      R.none(isEven, [1, 3, 5, 7, 8, 11]); //=> false
	 */
	module.exports = _curry2(_complement(_dispatchable(['any'], _xany, any)));


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var curryN = __webpack_require__(13);
	var nth = __webpack_require__(48);
	
	
	/**
	 * Returns a function which returns its nth argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig Number -> *... -> *
	 * @param {Number} n
	 * @return {Function}
	 * @example
	 *
	 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
	 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
	 * @symb R.nthArg(-1)(a, b, c) = c
	 * @symb R.nthArg(0)(a, b, c) = a
	 * @symb R.nthArg(1)(a, b, c) = b
	 */
	module.exports = _curry1(function nthArg(n) {
	  var arity = n < 0 ? 1 : n + 1;
	  return curryN(arity, function() {
	    return nth(n, arguments);
	  });
	});


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _of = __webpack_require__(437);
	
	
	/**
	 * Returns a singleton array containing the value provided.
	 *
	 * Note this `of` is different from the ES6 `of`; See
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> [a]
	 * @param {*} x any value
	 * @return {Array} An array wrapping `x`.
	 * @example
	 *
	 *      R.of(null); //=> [null]
	 *      R.of([42]); //=> [[42]]
	 */
	module.exports = _curry1(_of);


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(30);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a partial copy of an object omitting the keys specified.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [String] -> {String: *} -> {String: *}
	 * @param {Array} names an array of String property names to omit from the new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with properties from `names` not on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
	 */
	module.exports = _curry2(function omit(names, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (!_contains(prop, names)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(22);
	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Accepts a function `fn` and returns a function that guards invocation of
	 * `fn` such that `fn` can only ever be called once, no matter how many times
	 * the returned function is invoked. The first value calculated is returned in
	 * subsequent invocations.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a... -> b) -> (a... -> b)
	 * @param {Function} fn The function to wrap in a call-only-once wrapper.
	 * @return {Function} The wrapped function.
	 * @example
	 *
	 *      var addOneOnce = R.once(x => x + 1);
	 *      addOneOnce(10); //=> 11
	 *      addOneOnce(addOneOnce(50)); //=> 11
	 */
	module.exports = _curry1(function once(fn) {
	  var called = false;
	  var result;
	  return _arity(fn.length, function() {
	    if (called) {
	      return result;
	    }
	    called = true;
	    result = fn.apply(this, arguments);
	    return result;
	  });
	});


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category List
	 * @sig a -> b -> (a,b)
	 * @param {*} fst
	 * @param {*} snd
	 * @return {Array}
	 * @see R.objOf, R.of
	 * @example
	 *
	 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
	 */
	module.exports = _curry2(function pair(fst, snd) { return [fst, snd]; });


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(19);
	var _createPartialApplicator = __webpack_require__(258);
	
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided initially followed by the arguments provided to `g`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partialRight
	 * @example
	 *
	 *      var multiply2 = (a, b) => a * b;
	 *      var double = R.partial(multiply2, [2]);
	 *      double(2); //=> 4
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var sayHello = R.partial(greet, ['Hello']);
	 *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
	 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
	 */
	module.exports = _createPartialApplicator(_concat);


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(19);
	var _createPartialApplicator = __webpack_require__(258);
	var flip = __webpack_require__(59);
	
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided to `g` followed by the arguments provided initially.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partial
	 * @example
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
	 *
	 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
	 */
	module.exports = _createPartialApplicator(flip(_concat));


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	var filter = __webpack_require__(80);
	var juxt = __webpack_require__(270);
	var reject = __webpack_require__(69);
	
	
	/**
	 * Takes a predicate and a list or other "filterable" object and returns the
	 * pair of filterable objects of the same type of elements which do and do not
	 * satisfy, the predicate, respectively.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
	 * @param {Function} pred A predicate to determine which side the element belongs to.
	 * @param {Array} filterable the list (or other filterable) to partition.
	 * @return {Array} An array, containing first the subset of elements that satisfy the
	 *         predicate, and second the subset of elements that do not satisfy.
	 * @see R.filter, R.reject
	 * @example
	 *
	 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
	 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
	 *
	 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
	 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
	 */
	module.exports = juxt([filter, reject]);


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var equals = __webpack_require__(21);
	var path = __webpack_require__(49);
	
	
	/**
	 * Determines whether a nested path on an object has a specific value, in
	 * `R.equals` terms. Most likely used to filter a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Relation
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> Boolean
	 * @param {Array} path The path of the nested property to use
	 * @param {*} val The value to compare the nested property with
	 * @param {Object} obj The object to check the nested property in
	 * @return {Boolean} `true` if the value equals the nested object property,
	 *         `false` otherwise.
	 * @example
	 *
	 *      var user1 = { address: { zipCode: 90210 } };
	 *      var user2 = { address: { zipCode: 55555 } };
	 *      var user3 = { name: 'Bob' };
	 *      var users = [ user1, user2, user3 ];
	 *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
	 *      R.filter(isFamous, users); //=> [ user1 ]
	 */
	module.exports = _curry3(function pathEq(_path, val, obj) {
	  return equals(path(_path, obj), val);
	});


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var defaultTo = __webpack_require__(247);
	var path = __webpack_require__(49);
	
	
	/**
	 * If the given, non-null object has a value at the given path, returns the
	 * value at that path. Otherwise returns the provided default value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig a -> [Idx] -> {a} -> a
	 * @param {*} d The default value.
	 * @param {Array} p The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path` of the supplied object or the default value.
	 * @example
	 *
	 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
	 */
	module.exports = _curry3(function pathOr(d, p, obj) {
	  return defaultTo(d, path(p, obj));
	});


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var path = __webpack_require__(49);
	
	
	/**
	 * Returns `true` if the specified object property at given path satisfies the
	 * given predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Logic
	 * @typedefn Idx = String | Int
	 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
	 * @param {Function} pred
	 * @param {Array} propPath
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propSatisfies, R.path
	 * @example
	 *
	 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
	 */
	module.exports = _curry3(function pathSatisfies(pred, propPath, obj) {
	  return propPath.length > 0 && pred(path(propPath, obj));
	});


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys specified. If
	 * the key does not exist, the property is ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.omit, R.props
	 * @example
	 *
	 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
	 */
	module.exports = _curry2(function pick(names, obj) {
	  var result = {};
	  var idx = 0;
	  while (idx < names.length) {
	    if (names[idx] in obj) {
	      result[names[idx]] = obj[names[idx]];
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys that satisfy
	 * the supplied predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
	 * @param {Function} pred A predicate to determine whether or not a key
	 *        should be included on the output object.
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties that satisfy `pred`
	 *         on it.
	 * @see R.pick, R.filter
	 * @example
	 *
	 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
	 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
	 */
	module.exports = _curry2(function pickBy(test, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (test(obj[prop], prop, obj)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	var composeK = __webpack_require__(244);
	var reverse = __webpack_require__(70);
	
	/**
	 * Returns the left-to-right Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.pipeK(f, g, h)` is equivalent to `R.pipe(R.chain(f), R.chain(g), R.chain(h))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (a -> m z)
	 * @param {...Function}
	 * @return {Function}
	 * @see R.composeK
	 * @example
	 *
	 *      //  parseJson :: String -> Maybe *
	 *      //  get :: String -> Object -> Maybe *
	 *
	 *      //  getStateCode :: Maybe String -> Maybe String
	 *      var getStateCode = R.pipeK(
	 *        parseJson,
	 *        get('user'),
	 *        get('address'),
	 *        get('state'),
	 *        R.compose(Maybe.of, R.toUpper)
	 *      );
	 *
	 *      getStateCode('{"user":{"address":{"state":"ny"}}}');
	 *      //=> Just('NY')
	 *      getStateCode('[Invalid JSON]');
	 *      //=> Nothing()
	 * @symb R.pipeK(f, g, h)(a) = R.chain(h, R.chain(g, f(a)))
	 */
	module.exports = function pipeK() {
	  if (arguments.length === 0) {
	    throw new Error('pipeK requires at least one argument');
	  }
	  return composeK.apply(this, reverse(arguments));
	};


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	var multiply = __webpack_require__(276);
	var reduce = __webpack_require__(24);
	
	
	/**
	 * Multiplies together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The product of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.product([2,4,6,8,100,1]); //=> 38400
	 */
	module.exports = reduce(multiply, 1);


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	var _map = __webpack_require__(64);
	var identity = __webpack_require__(81);
	var pickAll = __webpack_require__(281);
	var useWith = __webpack_require__(292);
	
	
	/**
	 * Reasonable analog to SQL `select` statement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @category Relation
	 * @sig [k] -> [{k: v}] -> [{k: v}]
	 * @param {Array} props The property names to project
	 * @param {Array} objs The objects to query
	 * @return {Array} An array of objects with just the `props` properties.
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
	 *      var kids = [abby, fred];
	 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
	 */
	module.exports = useWith(_map, [pickAll, identity]); // passing `identity` gives correct arity


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var equals = __webpack_require__(21);
	
	
	/**
	 * Returns `true` if the specified object property is equal, in `R.equals`
	 * terms, to the given value; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig String -> a -> Object -> Boolean
	 * @param {String} name
	 * @param {*} val
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.equals, R.propSatisfies
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
	 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
	 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
	 *      var kids = [abby, fred, rusty, alois];
	 *      var hasBrownHair = R.propEq('hair', 'brown');
	 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
	 */
	module.exports = _curry3(function propEq(name, val, obj) {
	  return equals(val, obj[name]);
	});


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var is = __webpack_require__(269);
	
	
	/**
	 * Returns `true` if the specified object property is of the given type;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Type
	 * @sig Type -> String -> Object -> Boolean
	 * @param {Function} type
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.is, R.propSatisfies
	 * @example
	 *
	 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
	 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
	 *      R.propIs(Number, 'x', {});            //=> false
	 */
	module.exports = _curry3(function propIs(type, name, obj) {
	  return is(type, obj[name]);
	});


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var _has = __webpack_require__(15);
	
	
	/**
	 * If the given, non-null object has an own property with the specified name,
	 * returns the value of that property. Otherwise returns the provided default
	 * value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Object
	 * @sig a -> String -> Object -> a
	 * @param {*} val The default value.
	 * @param {String} p The name of the property to return.
	 * @param {Object} obj The object to query.
	 * @return {*} The value of given property of the supplied object or the default value.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var favorite = R.prop('favoriteLibrary');
	 *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
	 *
	 *      favorite(alice);  //=> undefined
	 *      favoriteWithDefault(alice);  //=> 'Ramda'
	 */
	module.exports = _curry3(function propOr(val, p, obj) {
	  return (obj != null && _has(p, obj)) ? obj[p] : val;
	});


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Returns `true` if the specified object property satisfies the given
	 * predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Logic
	 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
	 * @param {Function} pred
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propEq, R.propIs
	 * @example
	 *
	 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
	 */
	module.exports = _curry3(function propSatisfies(pred, name, obj) {
	  return pred(obj[name]);
	});


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> [v]
	 * @param {Array} ps The property names to fetch
	 * @param {Object} obj The object to query
	 * @return {Array} The corresponding values or partially applied function.
	 * @example
	 *
	 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
	 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
	 *
	 *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
	 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
	 */
	module.exports = _curry2(function props(ps, obj) {
	  var len = ps.length;
	  var out = [];
	  var idx = 0;
	
	  while (idx < len) {
	    out[idx] = obj[ps[idx]];
	    idx += 1;
	  }
	
	  return out;
	});


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isNumber = __webpack_require__(263);
	
	
	/**
	 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> Number -> [Number]
	 * @param {Number} from The first number in the list.
	 * @param {Number} to One more than the last number in the list.
	 * @return {Array} The list of numbers in tthe set `[a, b)`.
	 * @example
	 *
	 *      R.range(1, 5);    //=> [1, 2, 3, 4]
	 *      R.range(50, 53);  //=> [50, 51, 52]
	 */
	module.exports = _curry2(function range(from, to) {
	  if (!(_isNumber(from) && _isNumber(to))) {
	    throw new TypeError('Both arguments to range must be numbers');
	  }
	  var result = [];
	  var n = from;
	  while (n < to) {
	    result.push(n);
	    n += 1;
	  }
	  return result;
	});


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(60);
	var _reduce = __webpack_require__(17);
	var _reduced = __webpack_require__(29);
	
	
	/**
	 * Like `reduce`, `reduceWhile` returns a single item by iterating through
	 * the list, successively calling the iterator function. `reduceWhile` also
	 * takes a predicate that is evaluated before each step. If the predicate returns
	 * `false`, it "short-circuits" the iteration and returns the current value
	 * of the accumulator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.22.0
	 * @category List
	 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} pred The predicate. It is passed the accumulator and the
	 *        current element.
	 * @param {Function} fn The iterator function. Receives two values, the
	 *        accumulator and the current element.
	 * @param {*} a The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced
	 * @example
	 *
	 *      var isOdd = (acc, x) => x % 2 === 1;
	 *      var xs = [1, 3, 5, 60, 777, 800];
	 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
	 *
	 *      var ys = [2, 4, 6]
	 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
	 */
	module.exports = _curryN(4, [], function _reduceWhile(pred, fn, a, list) {
	  return _reduce(function(acc, x) {
	    return pred(acc, x) ? fn(acc, x) : _reduced(acc);
	  }, a, list);
	});


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _reduced = __webpack_require__(29);
	
	/**
	 * Returns a value wrapped to indicate that it is the final value of the reduce
	 * and transduce functions. The returned value should be considered a black
	 * box: the internal structure is not guaranteed to be stable.
	 *
	 * Note: this optimization is unavailable to functions not explicitly listed
	 * above. For instance, it is not currently supported by reduceRight.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category List
	 * @sig a -> *
	 * @param {*} x The final value of the reduce.
	 * @return {*} The wrapped value.
	 * @see R.reduce, R.transduce
	 * @example
	 *
	 *      R.reduce(
	 *        R.pipe(R.add, R.when(R.gte(R.__, 10), R.reduced)),
	 *        0,
	 *        [1, 2, 3, 4, 5]) // 10
	 */
	
	module.exports = _curry1(_reduced);


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Removes the sub-list of `list` starting at index `start` and containing
	 * `count` elements. _Note that this is not destructive_: it returns a copy of
	 * the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @param {Number} start The position to start removing elements
	 * @param {Number} count The number of elements to remove
	 * @param {Array} list The list to remove from
	 * @return {Array} A new Array with `count` elements from `start` removed.
	 * @example
	 *
	 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
	 */
	module.exports = _curry3(function remove(start, count, list) {
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(start, count);
	  return result;
	});


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var always = __webpack_require__(35);
	var times = __webpack_require__(289);
	
	
	/**
	 * Returns a fixed list of size `n` containing a specified identical value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig a -> n -> [a]
	 * @param {*} value The value to repeat.
	 * @param {Number} n The desired size of the output list.
	 * @return {Array} A new array containing `n` `value`s.
	 * @example
	 *
	 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
	 *
	 *      var obj = {};
	 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
	 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
	 * @symb R.repeat(a, 0) = []
	 * @symb R.repeat(a, 1) = [a]
	 * @symb R.repeat(a, 2) = [a, a]
	 */
	module.exports = _curry2(function repeat(value, n) {
	  return times(always(value), n);
	});


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Replace a substring or regex match in a string with a replacement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category String
	 * @sig RegExp|String -> String -> String -> String
	 * @param {RegExp|String} pattern A regular expression or a substring to match.
	 * @param {String} replacement The string to replace the matches with.
	 * @param {String} str The String to do the search and replacement in.
	 * @return {String} The result.
	 * @example
	 *
	 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *
	 *      // Use the "g" (global) flag to replace all occurrences:
	 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
	 */
	module.exports = _curry3(function replace(regex, replacement, str) {
	  return str.replace(regex, replacement);
	});


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Scan is similar to reduce, but returns a list of successively reduced values
	 * from the left
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a,b -> a) -> a -> [b] -> [a]
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} A list of all intermediately reduced values.
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
	 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
	 */
	module.exports = _curry3(function scan(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [acc];
	  while (idx < len) {
	    acc = fn(acc, list[idx]);
	    result[idx + 1] = acc;
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var always = __webpack_require__(35);
	var over = __webpack_require__(280);
	
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> a -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
	 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
	 */
	module.exports = _curry3(function set(lens, v, x) {
	  return over(lens, always(v), x);
	});


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a copy of the list, sorted according to the comparator function,
	 * which should accept two values at a time and return a negative number if the
	 * first value is smaller, a positive number if it's larger, and zero if they
	 * are equal. Please note that this is a **copy** of the list. It does not
	 * modify the original.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a,a -> Number) -> [a] -> [a]
	 * @param {Function} comparator A sorting function :: a -> b -> Int
	 * @param {Array} list The list to sort
	 * @return {Array} a new array with its elements sorted by the comparator function.
	 * @example
	 *
	 *      var diff = function(a, b) { return a - b; };
	 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
	 */
	module.exports = _curry2(function sort(comparator, list) {
	  return Array.prototype.slice.call(list, 0).sort(comparator);
	});


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Sorts the list according to the supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> [a] -> [a]
	 * @param {Function} fn
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted by the keys generated by `fn`.
	 * @example
	 *
	 *      var sortByFirstItem = R.sortBy(R.prop(0));
	 *      var sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
	 *      var pairs = [[-1, 1], [-2, 2], [-3, 3]];
	 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var bob = {
	 *        name: 'Bob',
	 *        age: -10
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 314.159
	 *      };
	 *      var people = [clara, bob, alice];
	 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
	 */
	module.exports = _curry2(function sortBy(fn, list) {
	  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    var aa = fn(a);
	    var bb = fn(b);
	    return aa < bb ? -1 : aa > bb ? 1 : 0;
	  });
	});


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Sorts a list according to a list of comparators.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Relation
	 * @sig [a -> a -> Number] -> [a] -> [a]
	 * @param {Array} functions A list of comparator functions.
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted according to the comarator functions.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'alice',
	 *        age: 40
	 *      };
	 *      var bob = {
	 *        name: 'bob',
	 *        age: 30
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 40
	 *      };
	 *      var people = [clara, bob, alice];
	 *      var ageNameSort = R.sortWith([
	 *        R.descend(R.prop('age')),
	 *        R.ascend(R.prop('name'))
	 *      ]);
	 *      ageNameSort(people); //=> [alice, clara, bob]
	 */
	module.exports = _curry2(function sortWith(fns, list) {
	  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    var result = 0;
	    var i = 0;
	    while (result === 0 && i < fns.length) {
	      result = fns[i](a, b);
	      i += 1;
	    }
	    return result;
	  });
	});


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(46);
	
	
	/**
	 * Splits a string into an array of strings based on the given
	 * separator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig (String | RegExp) -> String -> [String]
	 * @param {String|RegExp} sep The pattern.
	 * @param {String} str The string to separate into an array.
	 * @return {Array} The array of strings from `str` separated by `str`.
	 * @see R.join
	 * @example
	 *
	 *      var pathComponents = R.split('/');
	 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
	 *
	 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
	 */
	module.exports = invoker(1, 'split');


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var length = __webpack_require__(272);
	var slice = __webpack_require__(31);
	
	
	/**
	 * Splits a given list or string at a given index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig Number -> [a] -> [[a], [a]]
	 * @sig Number -> String -> [String, String]
	 * @param {Number} index The index where the array/string is split.
	 * @param {Array|String} array The array/string to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
	 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
	 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
	 */
	module.exports = _curry2(function splitAt(index, array) {
	  return [slice(0, index, array), slice(index, length(array), array)];
	});


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var slice = __webpack_require__(31);
	
	
	/**
	 * Splits a collection into slices of the specified length.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @sig Number -> String -> [String]
	 * @param {Number} n
	 * @param {Array} list
	 * @return {Array}
	 * @example
	 *
	 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
	 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
	 */
	module.exports = _curry2(function splitEvery(n, list) {
	  if (n <= 0) {
	    throw new Error('First argument to splitEvery must be a positive integer');
	  }
	  var result = [];
	  var idx = 0;
	  while (idx < list.length) {
	    result.push(slice(idx, idx += n, list));
	  }
	  return result;
	});


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Takes a list and a predicate and returns a pair of lists with the following properties:
	 *
	 *  - the result of concatenating the two output lists is equivalent to the input list;
	 *  - none of the elements of the first output list satisfies the predicate; and
	 *  - if the second output list is non-empty, its first element satisfies the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
	 * @param {Function} pred The predicate that determines where the array is split.
	 * @param {Array} list The array to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
	 */
	module.exports = _curry2(function splitWhen(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var prefix = [];
	
	  while (idx < len && !pred(list[idx])) {
	    prefix.push(list[idx]);
	    idx += 1;
	  }
	
	  return [prefix, Array.prototype.slice.call(list, idx)];
	});


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Subtracts its second argument from its first argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a - b`.
	 * @see R.add
	 * @example
	 *
	 *      R.subtract(10, 8); //=> 2
	 *
	 *      var minus5 = R.subtract(R.__, 5);
	 *      minus5(17); //=> 12
	 *
	 *      var complementaryAngle = R.subtract(90);
	 *      complementaryAngle(30); //=> 60
	 *      complementaryAngle(72); //=> 18
	 */
	module.exports = _curry2(function subtract(a, b) {
	  return Number(a) - Number(b);
	});


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var concat = __webpack_require__(79);
	var difference = __webpack_require__(248);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
	 * @example
	 *
	 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
	 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
	 */
	module.exports = _curry2(function symmetricDifference(list1, list2) {
	  return concat(difference(list1, list2), difference(list2, list1));
	});


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var concat = __webpack_require__(79);
	var differenceWith = __webpack_require__(249);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both. Duplication is determined according to the value
	 * returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifference, R.difference, R.differenceWith
	 * @example
	 *
	 *      var eqA = R.eqBy(R.prop('a'));
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
	 *      var l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
	 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
	 */
	module.exports = _curry3(function symmetricDifferenceWith(pred, list1, list2) {
	  return concat(differenceWith(pred, list1, list2), differenceWith(pred, list2, list1));
	});


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var drop = __webpack_require__(251);
	
	
	/**
	 * Returns a new list containing the last `n` elements of the given list.
	 * If `n > list.length`, returns a list of `list.length` elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements to return.
	 * @param {Array} xs The collection to consider.
	 * @return {Array}
	 * @see R.dropLast
	 * @example
	 *
	 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(3, 'ramda');               //=> 'mda'
	 */
	module.exports = _curry2(function takeLast(n, xs) {
	  return drop(n >= 0 ? xs.length - n : 0, xs);
	});


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a new list containing the last `n` elements of a given list, passing
	 * each value to the supplied predicate function, and terminating when the
	 * predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropLastWhile, R.addIndex
	 * @example
	 *
	 *      var isNotOne = x => x !== 1;
	 *
	 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
	 */
	module.exports = _curry2(function takeLastWhile(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0 && fn(list[idx])) {
	    idx -= 1;
	  }
	  return Array.prototype.slice.call(list, idx + 1);
	});


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(9);
	var _xtakeWhile = __webpack_require__(459);
	
	
	/**
	 * Returns a new list containing the first `n` elements of a given list,
	 * passing each value to the supplied predicate function, and terminating when
	 * the predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * Dispatches to the `takeWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isNotFour = x => x !== 4;
	 *
	 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
	 */
	module.exports = _curry2(_dispatchable(['takeWhile'], _xtakeWhile, function takeWhile(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len && fn(list[idx])) {
	    idx += 1;
	  }
	  return Array.prototype.slice.call(list, 0, idx);
	}));


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Runs the given function with the supplied object, then returns the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> *) -> a -> a
	 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
	 * @param {*} x
	 * @return {*} `x`.
	 * @example
	 *
	 *      var sayX = x => console.log('x is ' + x);
	 *      R.tap(sayX, 100); //=> 100
	 *      // logs 'x is 100'
	 * @symb R.tap(f, a) = a
	 */
	module.exports = _curry2(function tap(fn, x) {
	  fn(x);
	  return x;
	});


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	var _cloneRegExp = __webpack_require__(256);
	var _curry2 = __webpack_require__(1);
	var _isRegExp = __webpack_require__(435);
	var toString = __webpack_require__(51);
	
	
	/**
	 * Determines whether a given string matches a given regular expression.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category String
	 * @sig RegExp -> String -> Boolean
	 * @param {RegExp} pattern
	 * @param {String} str
	 * @return {Boolean}
	 * @see R.match
	 * @example
	 *
	 *      R.test(/^x/, 'xyz'); //=> true
	 *      R.test(/^y/, 'xyz'); //=> false
	 */
	module.exports = _curry2(function test(pattern, str) {
	  if (!_isRegExp(pattern)) {
	    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + toString(pattern));
	  }
	  return _cloneRegExp(pattern).test(str);
	});


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(46);
	
	
	/**
	 * The lower case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to lower case.
	 * @return {String} The lower case version of `str`.
	 * @see R.toUpper
	 * @example
	 *
	 *      R.toLower('XYZ'); //=> 'xyz'
	 */
	module.exports = invoker(0, 'toLowerCase');


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var _has = __webpack_require__(15);
	
	
	/**
	 * Converts an object into an array of key, value arrays. Only the object's
	 * own properties are used.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own properties.
	 * @see R.fromPairs
	 * @example
	 *
	 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
	 */
	module.exports = _curry1(function toPairs(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    if (_has(prop, obj)) {
	      pairs[pairs.length] = [prop, obj[prop]];
	    }
	  }
	  return pairs;
	});


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Converts an object into an array of key, value arrays. The object's own
	 * properties and prototype properties are used. Note that the order of the
	 * output array is not guaranteed to be consistent across different JS
	 * platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own
	 *         and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
	 */
	module.exports = _curry1(function toPairsIn(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    pairs[pairs.length] = [prop, obj[prop]];
	  }
	  return pairs;
	});


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(46);
	
	
	/**
	 * The upper case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to upper case.
	 * @return {String} The upper case version of `str`.
	 * @see R.toLower
	 * @example
	 *
	 *      R.toUpper('abc'); //=> 'ABC'
	 */
	module.exports = invoker(0, 'toUpperCase');


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	var _reduce = __webpack_require__(17);
	var _xwrap = __webpack_require__(268);
	var curryN = __webpack_require__(13);
	
	
	/**
	 * Initializes a transducer using supplied iterator function. Returns a single
	 * item by iterating through the list, successively calling the transformed
	 * iterator function and passing it an accumulator value and the current value
	 * from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It will be
	 * wrapped as a transformer to initialize the transducer. A transformer can be
	 * passed directly in place of an iterator function. In both cases, iteration
	 * may be stopped early with the `R.reduced` function.
	 *
	 * A transducer is a function that accepts a transformer and returns a
	 * transformer and can be composed directly.
	 *
	 * A transformer is an an object that provides a 2-arity reducing iterator
	 * function, step, 0-arity initial value function, init, and 1-arity result
	 * extraction function, result. The step function is used as the iterator
	 * function in reduce. The result function is used to convert the final
	 * accumulator into the return type and in most cases is R.identity. The init
	 * function can be used to provide an initial accumulator, but is ignored by
	 * transduce.
	 *
	 * The iteration is performed with R.reduce after initializing the transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (c -> c) -> (a,b -> a) -> a -> [b] -> a
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array. Wrapped as transformer, if necessary, and used to
	 *        initialize the transducer
	 * @param {*} acc The initial accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced, R.into
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *
	 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
	 */
	module.exports = curryN(4, function transduce(xf, fn, acc, list) {
	  return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
	});


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Transposes the rows and columns of a 2D list.
	 * When passed a list of `n` lists of length `x`,
	 * returns a list of `x` lists of length `n`.
	 *
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [[a]] -> [[a]]
	 * @param {Array} list A 2D list
	 * @return {Array} A 2D list
	 * @example
	 *
	 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
	 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 *
	 * If some of the rows are shorter than the following rows, their elements are skipped:
	 *
	 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
	 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
	 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
	 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
	 */
	module.exports = _curry1(function transpose(outerlist) {
	  var i = 0;
	  var result = [];
	  while (i < outerlist.length) {
	    var innerlist = outerlist[i];
	    var j = 0;
	    while (j < innerlist.length) {
	      if (typeof result[j] === 'undefined') {
	        result[j] = [];
	      }
	      result[j].push(innerlist[j]);
	      j += 1;
	    }
	    i += 1;
	  }
	  return result;
	});


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	var map = __webpack_require__(16);
	var sequence = __webpack_require__(286);
	
	
	/**
	 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
	 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
	 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
	 * into an Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
	 * @param {Function} of
	 * @param {Function} f
	 * @param {*} traversable
	 * @return {*}
	 * @see R.sequence
	 * @example
	 *
	 *      // Returns `Nothing` if the given divisor is `0`
	 *      safeDiv = n => d => d === 0 ? Nothing() : Just(n / d)
	 *
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Just([5, 2.5, 2])
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Nothing
	 */
	module.exports = _curry3(function traverse(of, f, traversable) {
	  return sequence(of, map(f, traversable));
	});


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Removes (strips) whitespace from both ends of the string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to trim.
	 * @return {String} Trimmed version of `str`.
	 * @example
	 *
	 *      R.trim('   xyz  '); //=> 'xyz'
	 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
	 */
	module.exports = (function() {
	  var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	           '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' +
	           '\u2029\uFEFF';
	  var zeroWidth = '\u200b';
	  var hasProtoTrim = (typeof String.prototype.trim === 'function');
	  if (!hasProtoTrim || (ws.trim() || !zeroWidth.trim())) {
	    return _curry1(function trim(str) {
	      var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
	      var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
	      return str.replace(beginRx, '').replace(endRx, '');
	    });
	  } else {
	    return _curry1(function trim(str) {
	      return str.trim();
	    });
	  }
	}());


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(22);
	var _concat = __webpack_require__(19);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
	 * function evaluates the `tryer`; if it does not throw, it simply returns the
	 * result. If the `tryer` *does* throw, the returned function evaluates the
	 * `catcher` function and returns its result. Note that for effective
	 * composition with this function, both the `tryer` and `catcher` functions
	 * must return the same type of results.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
	 * @param {Function} tryer The function that may throw.
	 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
	 * @return {Function} A new function that will catch exceptions and send then to the catcher.
	 * @example
	 *
	 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
	 *      R.tryCatch(R.prop('x'), R.F)(null);      //=> false
	 */
	module.exports = _curry2(function _tryCatch(tryer, catcher) {
	  return _arity(tryer.length, function() {
	    try {
	      return tryer.apply(this, arguments);
	    } catch (e) {
	      return catcher.apply(this, _concat([e], arguments));
	    }
	  });
	});


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Takes a function `fn`, which takes a single array argument, and returns a
	 * function which:
	 *
	 *   - takes any number of positional arguments;
	 *   - passes these arguments to `fn` as an array; and
	 *   - returns the result.
	 *
	 * In other words, R.unapply derives a variadic function from a function which
	 * takes an array. R.unapply is the inverse of R.apply.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Function
	 * @sig ([*...] -> a) -> (*... -> a)
	 * @param {Function} fn
	 * @return {Function}
	 * @see R.apply
	 * @example
	 *
	 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
	 * @symb R.unapply(f)(a, b) = f([a, b])
	 */
	module.exports = _curry1(function unapply(fn) {
	  return function() {
	    return fn(Array.prototype.slice.call(arguments, 0));
	  };
	});


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	var nAry = __webpack_require__(67);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 1 parameter. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> b) -> (a -> b)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 1.
	 * @example
	 *
	 *      var takesTwoArgs = function(a, b) {
	 *        return [a, b];
	 *      };
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.unary(takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only 1 argument is passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.unary(f)(a, b, c) = f(a)
	 */
	module.exports = _curry1(function unary(fn) {
	  return nAry(1, fn);
	});


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var curryN = __webpack_require__(13);
	
	
	/**
	 * Returns a function of arity `n` from a (manually) curried function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Function
	 * @sig Number -> (a -> b) -> (a -> c)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to uncurry.
	 * @return {Function} A new function.
	 * @see R.curry
	 * @example
	 *
	 *      var addFour = a => b => c => d => a + b + c + d;
	 *
	 *      var uncurriedAddFour = R.uncurryN(4, addFour);
	 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
	 */
	module.exports = _curry2(function uncurryN(depth, fn) {
	  return curryN(depth, function() {
	    var currentDepth = 1;
	    var value = fn;
	    var idx = 0;
	    var endIdx;
	    while (currentDepth <= depth && typeof value === 'function') {
	      endIdx = currentDepth === depth ? arguments.length : idx + value.length;
	      value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
	      currentDepth += 1;
	      idx = endIdx;
	    }
	    return value;
	  });
	});


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Builds a list from a seed value. Accepts an iterator function, which returns
	 * either false to stop iteration or an array of length 2 containing the value
	 * to add to the resulting list and the seed to be used in the next call to the
	 * iterator function.
	 *
	 * The iterator function receives one argument: *(seed)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a -> [b]) -> * -> [b]
	 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
	 *        either false to quit iteration or an array of length two to proceed. The element
	 *        at index 0 of this array will be added to the resulting array, and the element
	 *        at index 1 will be passed to the next call to `fn`.
	 * @param {*} seed The seed value.
	 * @return {Array} The final list.
	 * @example
	 *
	 *      var f = n => n > 50 ? false : [-n, n + 10];
	 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
	 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
	 */
	module.exports = _curry2(function unfold(fn, seed) {
	  var pair = fn(seed);
	  var result = [];
	  while (pair && pair.length) {
	    result[result.length] = pair[0];
	    pair = fn(pair[1]);
	  }
	  return result;
	});


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(19);
	var _curry2 = __webpack_require__(1);
	var compose = __webpack_require__(78);
	var uniq = __webpack_require__(89);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @example
	 *
	 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
	 */
	module.exports = _curry2(compose(uniq, _concat));


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(19);
	var _curry3 = __webpack_require__(4);
	var uniqWith = __webpack_require__(90);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list. Duplication is determined according to the value returned by
	 * applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> a -> Boolean) -> [*] -> [*] -> [*]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @see R.union
	 * @example
	 *
	 *      var l1 = [{a: 1}, {a: 2}];
	 *      var l2 = [{a: 1}, {a: 4}];
	 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
	 */
	module.exports = _curry3(function unionWith(pred, list1, list2) {
	  return uniqWith(pred, _concat(list1, list2));
	});


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is not satisfied, the function will return the result of
	 * calling the `whenFalseFn` function with the same argument. If the predicate
	 * is satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred        A predicate function
	 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
	 *                               to a falsy value.
	 * @param {*}        x           An object to test with the `pred` function and
	 *                               pass to `whenFalseFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
	 * @see R.ifElse, R.when
	 * @example
	 *
	 *      // coerceArray :: (a|[a]) -> [a]
	 *      var coerceArray = R.unless(R.isArrayLike, R.of);
	 *      coerceArray([1, 2, 3]); //=> [1, 2, 3]
	 *      coerceArray(1);         //=> [1]
	 */
	module.exports = _curry3(function unless(pred, whenFalseFn, x) {
	  return pred(x) ? x : whenFalseFn(x);
	});


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	var _identity = __webpack_require__(84);
	var chain = __webpack_require__(77);
	
	
	/**
	 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
	 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain c => c (c a) -> c a
	 * @param {*} list
	 * @return {*}
	 * @see R.flatten, R.chain
	 * @example
	 *
	 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
	 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
	 */
	module.exports = chain(_identity);


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Takes a predicate, a transformation function, and an initial value,
	 * and returns a value of the same type as the initial value.
	 * It does so by applying the transformation until the predicate is satisfied,
	 * at which point it returns the satisfactory value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred A predicate function
	 * @param {Function} fn The iterator function
	 * @param {*} init Initial value
	 * @return {*} Final value that satisfies predicate
	 * @example
	 *
	 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
	 */
	module.exports = _curry3(function until(pred, fn, init) {
	  var val = init;
	  while (!pred(val)) {
	    val = fn(val);
	  }
	  return val;
	});


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(3);
	
	
	/**
	 * Returns a list of all the properties, including prototype properties, of the
	 * supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.valuesIn(f); //=> ['X', 'Y']
	 */
	module.exports = _curry1(function valuesIn(obj) {
	  var prop;
	  var vs = [];
	  for (prop in obj) {
	    vs[vs.length] = obj[prop];
	  }
	  return vs;
	});


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a "view" of the given data structure, determined by the given lens.
	 * The lens's focus determines which portion of the data structure is visible.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> s -> a
	 * @param {Lens} lens
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});  //=> 1
	 *      R.view(xLens, {x: 4, y: 2});  //=> 4
	 */
	module.exports = (function() {
	  // `Const` is a functor that effectively ignores the function given to `map`.
	  var Const = function(x) {
	    return {value: x, map: function() { return this; }};
	  };
	
	  return _curry2(function view(lens, x) {
	    // Using `Const` effectively ignores the setter function of the `lens`,
	    // leaving the value returned by the getter function unmodified.
	    return lens(Const)(x).value;
	  });
	}());


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is satisfied, the function will return the result of calling
	 * the `whenTrueFn` function with the same argument. If the predicate is not
	 * satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred       A predicate function
	 * @param {Function} whenTrueFn A function to invoke when the `condition`
	 *                              evaluates to a truthy value.
	 * @param {*}        x          An object to test with the `pred` function and
	 *                              pass to `whenTrueFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
	 * @see R.ifElse, R.unless
	 * @example
	 *
	 *      // truncate :: String -> String
	 *      var truncate = R.when(
	 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
	 *        R.pipe(R.take(10), R.append('…'), R.join(''))
	 *      );
	 *      truncate('12345');         //=> '12345'
	 *      truncate('0123456789ABC'); //=> '0123456789…'
	 */
	module.exports = _curry3(function when(pred, whenTrueFn, x) {
	  return pred(x) ? whenTrueFn(x) : x;
	});


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var equals = __webpack_require__(21);
	var map = __webpack_require__(16);
	var where = __webpack_require__(294);
	
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec, false otherwise. An object satisfies the spec if, for each of the
	 * spec's own properties, accessing that property of the object gives the same
	 * value (in `R.equals` terms) as accessing that property of the spec.
	 *
	 * `whereEq` is a specialization of [`where`](#where).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @sig {String: *} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @see R.where
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.whereEq({a: 1, b: 2});
	 *
	 *      pred({a: 1});              //=> false
	 *      pred({a: 1, b: 2});        //=> true
	 *      pred({a: 1, b: 2, c: 3});  //=> true
	 *      pred({a: 1, b: 1});        //=> false
	 */
	module.exports = _curry2(function whereEq(spec, testObj) {
	  return where(map(equals, spec), testObj);
	});


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(30);
	var _curry2 = __webpack_require__(1);
	var flip = __webpack_require__(59);
	var reject = __webpack_require__(69);
	
	
	/**
	 * Returns a new list without values in the first argument.
	 * `R.equals` is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @param {Array} list1 The values to be removed from `list2`.
	 * @param {Array} list2 The array to remove values from.
	 * @return {Array} The new array without values in `list1`.
	 * @see R.transduce
	 * @example
	 *
	 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
	 */
	module.exports = _curry2(function(xs, list) {
	  return reject(flip(_contains)(xs), list);
	});


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates a new list out of the two supplied by creating each possible pair
	 * from the lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The list made by combining each possible pair from
	 *         `as` and `bs` into pairs (`[a, b]`).
	 * @example
	 *
	 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
	 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
	 */
	module.exports = _curry2(function xprod(a, b) { // = xprodWith(prepend); (takes about 3 times as long...)
	  var idx = 0;
	  var ilen = a.length;
	  var j;
	  var jlen = b.length;
	  var result = [];
	  while (idx < ilen) {
	    j = 0;
	    while (j < jlen) {
	      result[result.length] = [a[idx], b[j]];
	      j += 1;
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates a new list out of the two supplied by pairing up equally-positioned
	 * items from both lists. The returned list is truncated to the length of the
	 * shorter of the two input lists.
	 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
	 * @example
	 *
	 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
	 */
	module.exports = _curry2(function zip(a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = [a[idx], b[idx]];
	    idx += 1;
	  }
	  return rv;
	});


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates a new object out of a list of keys and a list of values.
	 * Key/value pairing is truncated to the length of the shorter of the two lists.
	 * Note: `zipObj` is equivalent to `pipe(zipWith(pair), fromPairs)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [String] -> [*] -> {String: *}
	 * @param {Array} keys The array that will be properties on the output object.
	 * @param {Array} values The list of values on the output object.
	 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
	 * @example
	 *
	 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry2(function zipObj(keys, values) {
	  var idx = 0;
	  var len = Math.min(keys.length, values.length);
	  var out = {};
	  while (idx < len) {
	    out[keys[idx]] = values[idx];
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(4);
	
	
	/**
	 * Creates a new list out of the two supplied by applying the function to each
	 * equally-positioned pair in the lists. The returned list is truncated to the
	 * length of the shorter of the two input lists.
	 *
	 * @function
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a,b -> c) -> [a] -> [b] -> [c]
	 * @param {Function} fn The function used to combine the two elements into one value.
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
	 *         using `fn`.
	 * @example
	 *
	 *      var f = (x, y) => {
	 *        // ...
	 *      };
	 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
	 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
	 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
	 */
	module.exports = _curry3(function zipWith(fn, a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = fn(a[idx], b[idx]);
	    idx += 1;
	  }
	  return rv;
	});


/***/ },
/* 563 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(10);
	
	var focusNode = __webpack_require__(114);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(53);
	var ExecutionEnvironment = __webpack_require__(14);
	var FallbackCompositionState = __webpack_require__(571);
	var SyntheticCompositionEvent = __webpack_require__(608);
	var SyntheticInputEvent = __webpack_require__(611);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(296);
	var ExecutionEnvironment = __webpack_require__(14);
	var ReactInstrumentation = __webpack_require__(20);
	
	var camelizeStyleName = __webpack_require__(336);
	var dangerousStyleValue = __webpack_require__(617);
	var hyphenateStyleName = __webpack_require__(343);
	var memoizeStringOnly = __webpack_require__(346);
	var warning = __webpack_require__(6);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(52);
	var EventPropagators = __webpack_require__(53);
	var ExecutionEnvironment = __webpack_require__(14);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(25);
	var SyntheticEvent = __webpack_require__(26);
	
	var getEventTarget = __webpack_require__(103);
	var isEventSupported = __webpack_require__(104);
	var isTextInputElement = __webpack_require__(313);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var DOMLazyTree = __webpack_require__(37);
	var ExecutionEnvironment = __webpack_require__(14);
	
	var createNodesFromMarkup = __webpack_require__(339);
	var emptyFunction = __webpack_require__(18);
	var invariant = __webpack_require__(5);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 569 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(53);
	var ReactDOMComponentTree = __webpack_require__(10);
	var SyntheticMouseEvent = __webpack_require__(72);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var PooledClass = __webpack_require__(32);
	
	var getTextContentAccessor = __webpack_require__(311);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(38);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(39);
	
	var instantiateReactComponent = __webpack_require__(312);
	var KeyEscapeUtils = __webpack_require__(95);
	var shouldUpdateReactComponent = __webpack_require__(105);
	var traverseAllChildren = __webpack_require__(315);
	var warning = __webpack_require__(6);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/gba-villas-y-asentamientos"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(316);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)))

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(91);
	var ReactDOMIDOperations = __webpack_require__(581);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7),
	    _assign = __webpack_require__(8);
	
	var React = __webpack_require__(40);
	var ReactComponentEnvironment = __webpack_require__(97);
	var ReactCurrentOwner = __webpack_require__(27);
	var ReactErrorUtils = __webpack_require__(98);
	var ReactInstanceMap = __webpack_require__(54);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactNodeTypes = __webpack_require__(306);
	var ReactReconciler = __webpack_require__(39);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(44);
	var invariant = __webpack_require__(5);
	var shallowEqual = __webpack_require__(34);
	var shouldUpdateReactComponent = __webpack_require__(105);
	var warning = __webpack_require__(6);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDefaultInjection = __webpack_require__(589);
	var ReactMount = __webpack_require__(305);
	var ReactReconciler = __webpack_require__(39);
	var ReactUpdates = __webpack_require__(25);
	var ReactVersion = __webpack_require__(602);
	
	var findDOMNode = __webpack_require__(618);
	var getHostComponentFromComposite = __webpack_require__(310);
	var renderSubtreeIntoContainer = __webpack_require__(626);
	var warning = __webpack_require__(6);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7),
	    _assign = __webpack_require__(8);
	
	var AutoFocusUtils = __webpack_require__(564);
	var CSSPropertyOperations = __webpack_require__(566);
	var DOMLazyTree = __webpack_require__(37);
	var DOMNamespaces = __webpack_require__(92);
	var DOMProperty = __webpack_require__(38);
	var DOMPropertyOperations = __webpack_require__(298);
	var EventPluginHub = __webpack_require__(52);
	var EventPluginRegistry = __webpack_require__(93);
	var ReactBrowserEventEmitter = __webpack_require__(71);
	var ReactDOMComponentFlags = __webpack_require__(299);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDOMInput = __webpack_require__(582);
	var ReactDOMOption = __webpack_require__(583);
	var ReactDOMSelect = __webpack_require__(300);
	var ReactDOMTextarea = __webpack_require__(586);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactMultiChild = __webpack_require__(595);
	var ReactServerRenderingTransaction = __webpack_require__(600);
	
	var emptyFunction = __webpack_require__(18);
	var escapeTextContentForBrowser = __webpack_require__(74);
	var invariant = __webpack_require__(5);
	var isEventSupported = __webpack_require__(104);
	var shallowEqual = __webpack_require__(34);
	var validateDOMNesting = __webpack_require__(106);
	var warning = __webpack_require__(6);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(106);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var DOMLazyTree = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(10);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 580 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(91);
	var ReactDOMComponentTree = __webpack_require__(10);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7),
	    _assign = __webpack_require__(8);
	
	var DOMPropertyOperations = __webpack_require__(298);
	var LinkedValueUtils = __webpack_require__(96);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(25);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(6);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var React = __webpack_require__(40);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDOMSelect = __webpack_require__(300);
	
	var warning = __webpack_require__(6);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var getNodeForCharacterOffset = __webpack_require__(623);
	var getTextContentAccessor = __webpack_require__(311);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7),
	    _assign = __webpack_require__(8);
	
	var DOMChildrenOperations = __webpack_require__(91);
	var DOMLazyTree = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(10);
	
	var escapeTextContentForBrowser = __webpack_require__(74);
	var invariant = __webpack_require__(5);
	var validateDOMNesting = __webpack_require__(106);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7),
	    _assign = __webpack_require__(8);
	
	var LinkedValueUtils = __webpack_require__(96);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(25);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(6);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var ReactUpdates = __webpack_require__(25);
	var Transaction = __webpack_require__(73);
	
	var emptyFunction = __webpack_require__(18);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(563);
	var BeforeInputEventPlugin = __webpack_require__(565);
	var ChangeEventPlugin = __webpack_require__(567);
	var DefaultEventPluginOrder = __webpack_require__(569);
	var EnterLeaveEventPlugin = __webpack_require__(570);
	var HTMLDOMPropertyConfig = __webpack_require__(572);
	var ReactComponentBrowserEnvironment = __webpack_require__(574);
	var ReactDOMComponent = __webpack_require__(577);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDOMEmptyComponent = __webpack_require__(579);
	var ReactDOMTreeTraversal = __webpack_require__(587);
	var ReactDOMTextComponent = __webpack_require__(585);
	var ReactDefaultBatchingStrategy = __webpack_require__(588);
	var ReactEventListener = __webpack_require__(592);
	var ReactInjection = __webpack_require__(593);
	var ReactReconcileTransaction = __webpack_require__(598);
	var SVGDOMPropertyConfig = __webpack_require__(603);
	var SelectEventPlugin = __webpack_require__(604);
	var SimpleEventPlugin = __webpack_require__(605);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 590 */
317,
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(52);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var EventListener = __webpack_require__(113);
	var ExecutionEnvironment = __webpack_require__(14);
	var PooledClass = __webpack_require__(32);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(25);
	
	var getEventTarget = __webpack_require__(103);
	var getUnboundedScrollPosition = __webpack_require__(341);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(38);
	var EventPluginHub = __webpack_require__(52);
	var EventPluginUtils = __webpack_require__(94);
	var ReactComponentEnvironment = __webpack_require__(97);
	var ReactEmptyComponent = __webpack_require__(301);
	var ReactBrowserEventEmitter = __webpack_require__(71);
	var ReactHostComponent = __webpack_require__(303);
	var ReactUpdates = __webpack_require__(25);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(616);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var ReactComponentEnvironment = __webpack_require__(97);
	var ReactInstanceMap = __webpack_require__(54);
	var ReactInstrumentation = __webpack_require__(20);
	
	var ReactCurrentOwner = __webpack_require__(27);
	var ReactReconciler = __webpack_require__(39);
	var ReactChildReconciler = __webpack_require__(573);
	
	var emptyFunction = __webpack_require__(18);
	var flattenChildren = __webpack_require__(619);
	var invariant = __webpack_require__(5);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 597 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var CallbackQueue = __webpack_require__(297);
	var PooledClass = __webpack_require__(32);
	var ReactBrowserEventEmitter = __webpack_require__(71);
	var ReactInputSelection = __webpack_require__(304);
	var ReactInstrumentation = __webpack_require__(20);
	var Transaction = __webpack_require__(73);
	var ReactUpdateQueue = __webpack_require__(99);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(596);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var PooledClass = __webpack_require__(32);
	var Transaction = __webpack_require__(73);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactServerUpdateQueue = __webpack_require__(601);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(99);
	
	var warning = __webpack_require__(6);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 602 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.2';

/***/ },
/* 603 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(53);
	var ExecutionEnvironment = __webpack_require__(14);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactInputSelection = __webpack_require__(304);
	var SyntheticEvent = __webpack_require__(26);
	
	var getActiveElement = __webpack_require__(115);
	var isTextInputElement = __webpack_require__(313);
	var shallowEqual = __webpack_require__(34);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var EventListener = __webpack_require__(113);
	var EventPropagators = __webpack_require__(53);
	var ReactDOMComponentTree = __webpack_require__(10);
	var SyntheticAnimationEvent = __webpack_require__(606);
	var SyntheticClipboardEvent = __webpack_require__(607);
	var SyntheticEvent = __webpack_require__(26);
	var SyntheticFocusEvent = __webpack_require__(610);
	var SyntheticKeyboardEvent = __webpack_require__(612);
	var SyntheticMouseEvent = __webpack_require__(72);
	var SyntheticDragEvent = __webpack_require__(609);
	var SyntheticTouchEvent = __webpack_require__(613);
	var SyntheticTransitionEvent = __webpack_require__(614);
	var SyntheticUIEvent = __webpack_require__(55);
	var SyntheticWheelEvent = __webpack_require__(615);
	
	var emptyFunction = __webpack_require__(18);
	var getEventCharCode = __webpack_require__(101);
	var invariant = __webpack_require__(5);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(26);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(26);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(26);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(72);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(55);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(26);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(55);
	
	var getEventCharCode = __webpack_require__(101);
	var getEventKey = __webpack_require__(620);
	var getEventModifierState = __webpack_require__(102);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(55);
	
	var getEventModifierState = __webpack_require__(102);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(26);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(72);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 616 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(296);
	var warning = __webpack_require__(6);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(7);
	
	var ReactCurrentOwner = __webpack_require__(27);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactInstanceMap = __webpack_require__(54);
	
	var getHostComponentFromComposite = __webpack_require__(310);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(6);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(95);
	var traverseAllChildren = __webpack_require__(315);
	var warning = __webpack_require__(6);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/gba-villas-y-asentamientos"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(316);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)))

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(101);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 621 */
320,
/* 622 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 623 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(74);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(305);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(367).enable();
	  window.Promise = __webpack_require__(366);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(651);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(8);


/***/ },
/* 628 */
95,
/* 629 */
[652, 42],
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(629);
	var ReactElement = __webpack_require__(41);
	
	var emptyFunction = __webpack_require__(18);
	var traverseAllChildren = __webpack_require__(638);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(42),
	    _assign = __webpack_require__(8);
	
	var ReactComponent = __webpack_require__(107);
	var ReactElement = __webpack_require__(41);
	var ReactPropTypeLocationNames = __webpack_require__(318);
	var ReactNoopUpdateQueue = __webpack_require__(108);
	
	var emptyObject = __webpack_require__(44);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(6);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(41);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(41);
	var ReactPropTypeLocationNames = __webpack_require__(318);
	var ReactPropTypesSecret = __webpack_require__(634);
	
	var emptyFunction = __webpack_require__(18);
	var getIteratorFn = __webpack_require__(320);
	var warning = __webpack_require__(6);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        if (props[propName] === null) {
	          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	        }
	        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 634 */
597,
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var ReactComponent = __webpack_require__(107);
	var ReactNoopUpdateQueue = __webpack_require__(108);
	
	var emptyObject = __webpack_require__(44);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 636 */
602,
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(42);
	
	var ReactElement = __webpack_require__(41);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(42);
	
	var ReactCurrentOwner = __webpack_require__(27);
	var REACT_ELEMENT_TYPE = __webpack_require__(317);
	
	var getIteratorFn = __webpack_require__(320);
	var invariant = __webpack_require__(5);
	var KeyEscapeUtils = __webpack_require__(628);
	var warning = __webpack_require__(6);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHelper = __webpack_require__(33);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(43);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = function defaultProps(props) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var DefaultProps = function DefaultProps(ownerProps) {
	      return factory(ownerProps);
	    };
	    DefaultProps.defaultProps = props;
	    return DefaultProps;
	  };
	};
	
	exports.default = (0, _createHelper2.default)(defaultProps, 'defaultProps');

/***/ },
/* 640 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
	};
	
	exports.default = isClassComponent;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isClassComponent = __webpack_require__(640);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
	  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && (("production") === 'production' || !Component.propTypes));
	};
	
	exports.default = isReferentiallyTransparentFunctionComponent;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(12);
	
	var _createHelper = __webpack_require__(33);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(43);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lifecycle = function lifecycle(spec) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    if (false) {
	      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
	    }
	
	    /* eslint-disable react/prefer-es6-class */
	    return (0, _react.createClass)(_extends({}, spec, {
	      render: function render() {
	        return factory(_extends({}, this.props, this.state));
	      }
	    }));
	    /* eslint-enable react/prefer-es6-class */
	  };
	};
	
	exports.default = (0, _createHelper2.default)(lifecycle, 'lifecycle');

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(644);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(321);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(33);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = (0, _shouldUpdate2.default)(function (props, nextProps) {
	  return !(0, _shallowEqual2.default)(props, nextProps);
	});
	
	exports.default = (0, _createHelper2.default)(pure, 'pure', true, true);

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _createHelper = __webpack_require__(33);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(43);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      _class.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return _class;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(shouldUpdate, 'shouldUpdate');

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
	  if (!hasKey && isReferentiallyTransparent) {
	    if (children) {
	      return type(_extends({}, props, { children: children }));
	    }
	    return type(props);
	  }
	
	  var Component = type;
	
	  if (children) {
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  }
	
	  return _react2.default.createElement(Component, props);
	};
	
	exports.default = createEagerElementUtil;

/***/ },
/* 646 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var pick = function pick(obj, keys) {
	  var result = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (obj.hasOwnProperty(key)) {
	      result[key] = obj[key];
	    }
	  }
	  return result;
	};
	
	exports.default = pick;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(12);
	
	var _createEagerFactory = __webpack_require__(43);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _createHelper = __webpack_require__(33);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapValues = function mapValues(obj, func) {
	  var result = {};
	  /* eslint-disable no-restricted-syntax */
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      result[key] = func(obj[key], key);
	    }
	  }
	  /* eslint-enable no-restricted-syntax */
	  return result;
	};
	
	var withHandlers = function withHandlers(handlers) {
	  return function (BaseComponent) {
	    var _class, _temp2, _initialiseProps;
	
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return _temp2 = _class = function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _class.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	        this.cachedHandlers = {};
	      };
	
	      _class.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.handlers));
	      };
	
	      return _class;
	    }(_react.Component), _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.cachedHandlers = {};
	      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
	        return function () {
	          var cachedHandler = _this2.cachedHandlers[handlerName];
	          if (cachedHandler) {
	            return cachedHandler.apply(undefined, arguments);
	          }
	
	          var handler = createHandler(_this2.props);
	          _this2.cachedHandlers[handlerName] = handler;
	
	          if (false) {
	            console.error( // eslint-disable-line no-console
	            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
	          }
	
	          return handler.apply(undefined, arguments);
	        };
	      });
	    }, _temp2;
	  };
	};
	
	exports.default = (0, _createHelper2.default)(withHandlers, 'withHandlers');

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(12);
	
	var _pick = __webpack_require__(646);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _shallowEqual = __webpack_require__(321);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(33);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(43);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
	      return !(0, _shallowEqual2.default)((0, _pick2.default)(props, shouldMapOrKeys), (0, _pick2.default)(nextProps, shouldMapOrKeys));
	    };
	
	    return function (_Component) {
	      _inherits(_class2, _Component);
	
	      function _class2() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class2);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _class2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (shouldMap(this.props, nextProps)) {
	          this.computedProps = propsMapper(nextProps);
	        }
	      };
	
	      _class2.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.computedProps));
	      };
	
	      return _class2;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(withPropsOnChange, 'withPropsOnChange');

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * $script.js JS loader & dependency manager
	  * https://github.com/ded/script.js
	  * (c) Dustin Diaz 2014 | License MIT
	  */
	
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      return !fn(el)
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ },
/* 650 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 651 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.d9192f38.js